import * as React from 'react';
const BlueLink = ({ mainColor, secColor }) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={'300'}
    height={'290'}
    viewBox="0 0 332.48 305.89"
  >
    <defs>
      <style>
        {
          '\n            .cls-1 {\n                fill: none;\n            }\n\n            .cls-2 {\n                fill: #f0fdf7;\n                opacity: .12;\n            }\n\n            .cls-3 {\n                fill: #c3f7e0;\n                opacity: .5;\n            }\n\n            .cls-4 {\n                fill: #d2f9e8;\n                opacity: .38;\n            }\n\n            .cls-5 {\n                fill: #9df2cc;\n                opacity: .81;\n            }\n\n            .cls-6 {\n                fill: #8ef0c5;\n                opacity: .94;\n            }\n\n            .cls-7 {\n                fill: url(#linear-gradient-3);\n            }\n\n            .cls-8 {\n                fill: url(#linear-gradient-2);\n            }\n\n            .cls-9 {\n                fill: #caf8e4;\n                opacity: .44;\n            }\n\n            .cls-10 {\n                fill: url(#linear-gradient);\n            }\n\n            .cls-11 {\n                fill: #acf4d4;\n                opacity: .69;\n            }\n\n            .cls-12 {\n                fill: #b4f5d8;\n                opacity: .62;\n            }\n\n            .cls-13 {\n                isolation: isolate;\n            }\n\n            .cls-14 {\n                fill: #e8fcf3;\n                opacity: .19;\n            }\n\n            .cls-15 {\n                fill: #87eec1;\n            }\n\n            .cls-16 {\n                fill: {};\n                opacity: .56;\n            }\n\n            .cls-17 {\n                clip-path: url(#clippath-17);\n            }\n\n            .cls-18 {\n                clip-path: url(#clippath-19);\n            }\n\n            .cls-19 {\n                clip-path: url(#clippath-11);\n            }\n\n            .cls-20 {\n                clip-path: url(#clippath-16);\n            }\n\n            .cls-21 {\n                clip-path: url(#clippath-18);\n            }\n\n            .cls-22 {\n                clip-path: url(#clippath-10);\n            }\n\n            .cls-23 {\n                clip-path: url(#clippath-15);\n            }\n\n            .cls-24 {\n                clip-path: url(#clippath-13);\n            }\n\n            .cls-25 {\n                clip-path: url(#clippath-14);\n            }\n\n            .cls-26 {\n                clip-path: url(#clippath-12);\n            }\n\n            .cls-27 {\n                clip-path: url(#clippath-61);\n            }\n\n            .cls-28 {\n                clip-path: url(#clippath-67);\n            }\n\n            .cls-29 {\n                clip-path: url(#clippath-68);\n            }\n\n            .cls-30 {\n                clip-path: url(#clippath-60);\n            }\n\n            .cls-31 {\n                clip-path: url(#clippath-65);\n            }\n\n            .cls-32 {\n                clip-path: url(#clippath-62);\n            }\n\n            .cls-33 {\n                clip-path: url(#clippath-64);\n            }\n\n            .cls-34 {\n                clip-path: url(#clippath-66);\n            }\n\n            .cls-35 {\n                clip-path: url(#clippath-63);\n            }\n\n            .cls-36 {\n                clip-path: url(#clippath-76);\n            }\n\n            .cls-37 {\n                clip-path: url(#clippath-78);\n            }\n\n            .cls-38 {\n                clip-path: url(#clippath-75);\n            }\n\n            .cls-39 {\n                clip-path: url(#clippath-79);\n            }\n\n            .cls-40 {\n                clip-path: url(#clippath-50);\n            }\n\n            .cls-41 {\n                clip-path: url(#clippath-55);\n            }\n\n            .cls-42 {\n                clip-path: url(#clippath-52);\n            }\n\n            .cls-43 {\n                clip-path: url(#clippath-57);\n            }\n\n            .cls-44 {\n                clip-path: url(#clippath-54);\n            }\n\n            .cls-45 {\n                clip-path: url(#clippath-56);\n            }\n\n            .cls-46 {\n                clip-path: url(#clippath-53);\n            }\n\n            .cls-47 {\n                clip-path: url(#clippath-70);\n            }\n\n            .cls-48 {\n                clip-path: url(#clippath-77);\n            }\n\n            .cls-49 {\n                clip-path: url(#clippath-74);\n            }\n\n            .cls-50 {\n                clip-path: url(#clippath-71);\n            }\n\n            .cls-51 {\n                clip-path: url(#clippath-73);\n            }\n\n            .cls-52 {\n                clip-path: url(#clippath-72);\n            }\n\n            .cls-53 {\n                clip-path: url(#clippath-51);\n            }\n\n            .cls-54 {\n                clip-path: url(#clippath-58);\n            }\n\n            .cls-55 {\n                clip-path: url(#clippath-59);\n            }\n\n            .cls-56 {\n                clip-path: url(#clippath-31);\n            }\n\n            .cls-57 {\n                clip-path: url(#clippath-32);\n            }\n\n            .cls-58 {\n                clip-path: url(#clippath-33);\n            }\n\n            .cls-59 {\n                clip-path: url(#clippath-34);\n            }\n\n            .cls-60 {\n                clip-path: url(#clippath-35);\n            }\n\n            .cls-61 {\n                clip-path: url(#clippath-39);\n            }\n\n            .cls-62 {\n                clip-path: url(#clippath-30);\n            }\n\n            .cls-63 {\n                clip-path: url(#clippath-36);\n            }\n\n            .cls-64 {\n                clip-path: url(#clippath-37);\n            }\n\n            .cls-65 {\n                clip-path: url(#clippath-38);\n            }\n\n            .cls-66 {\n                clip-path: url(#clippath-27);\n            }\n\n            .cls-67 {\n                clip-path: url(#clippath-29);\n            }\n\n            .cls-68 {\n                clip-path: url(#clippath-26);\n            }\n\n            .cls-69 {\n                clip-path: url(#clippath-28);\n            }\n\n            .cls-70 {\n                clip-path: url(#clippath-20);\n            }\n\n            .cls-71 {\n                clip-path: url(#clippath-21);\n            }\n\n            .cls-72 {\n                clip-path: url(#clippath-22);\n            }\n\n            .cls-73 {\n                clip-path: url(#clippath-23);\n            }\n\n            .cls-74 {\n                clip-path: url(#clippath-24);\n            }\n\n            .cls-75 {\n                clip-path: url(#clippath-25);\n            }\n\n            .cls-76 {\n                clip-path: url(#clippath-69);\n            }\n\n            .cls-77 {\n                clip-path: url(#clippath-41);\n            }\n\n            .cls-78 {\n                clip-path: url(#clippath-42);\n            }\n\n            .cls-79 {\n                clip-path: url(#clippath-43);\n            }\n\n            .cls-80 {\n                clip-path: url(#clippath-44);\n            }\n\n            .cls-81 {\n                clip-path: url(#clippath-45);\n            }\n\n            .cls-82 {\n                clip-path: url(#clippath-49);\n            }\n\n            .cls-83 {\n                clip-path: url(#clippath-40);\n            }\n\n            .cls-84 {\n                clip-path: url(#clippath-46);\n            }\n\n            .cls-85 {\n                clip-path: url(#clippath-47);\n            }\n\n            .cls-86 {\n                clip-path: url(#clippath-48);\n            }\n\n            .cls-87 {\n                clip-path: url(#clippath-90);\n            }\n\n            .cls-88 {\n                clip-path: url(#clippath-95);\n            }\n\n            .cls-89 {\n                clip-path: url(#clippath-93);\n            }\n\n            .cls-90 {\n                clip-path: url(#clippath-99);\n            }\n\n            .cls-91 {\n                clip-path: url(#clippath-94);\n            }\n\n            .cls-92 {\n                clip-path: url(#clippath-96);\n            }\n\n            .cls-93 {\n                clip-path: url(#clippath-85);\n            }\n\n            .cls-94 {\n                clip-path: url(#clippath-86);\n            }\n\n            .cls-95 {\n                clip-path: url(#clippath-87);\n            }\n\n            .cls-96 {\n                clip-path: url(#clippath-80);\n            }\n\n            .cls-97 {\n                clip-path: url(#clippath-89);\n            }\n\n            .cls-98 {\n                clip-path: url(#clippath-81);\n            }\n\n            .cls-99 {\n                clip-path: url(#clippath-82);\n            }\n\n            .cls-100 {\n                clip-path: url(#clippath-83);\n            }\n\n            .cls-101 {\n                clip-path: url(#clippath-84);\n            }\n\n            .cls-102 {\n                clip-path: url(#clippath-88);\n            }\n\n            .cls-103 {\n                clip-path: url(#clippath-92);\n            }\n\n            .cls-104 {\n                clip-path: url(#clippath-97);\n            }\n\n            .cls-105 {\n                clip-path: url(#clippath-91);\n            }\n\n            .cls-106 {\n                clip-path: url(#clippath-98);\n            }\n\n            .cls-107 {\n                fill: #a6a6a6;\n            }\n\n            .cls-108 {\n                clip-path: url(#clippath-1);\n            }\n\n            .cls-109 {\n                clip-path: url(#clippath-3);\n            }\n\n            .cls-110 {\n                clip-path: url(#clippath-4);\n            }\n\n            .cls-111 {\n                clip-path: url(#clippath-2);\n            }\n\n            .cls-112 {\n                clip-path: url(#clippath-7);\n            }\n\n            .cls-113 {\n                clip-path: url(#clippath-6);\n            }\n\n            .cls-114 {\n                clip-path: url(#clippath-9);\n            }\n\n            .cls-115 {\n                clip-path: url(#clippath-8);\n            }\n\n            .cls-116 {\n                clip-path: url(#clippath-5);\n            }\n\n            .cls-117 {\n                mix-blend-mode: hard-light;\n            }\n\n            .cls-118 {\n                clip-path: url(#clippath-429);\n            }\n\n            .cls-119 {\n                clip-path: url(#clippath-420);\n            }\n\n            .cls-120 {\n                clip-path: url(#clippath-421);\n            }\n\n            .cls-121 {\n                clip-path: url(#clippath-423);\n            }\n\n            .cls-122 {\n                clip-path: url(#clippath-422);\n            }\n\n            .cls-123 {\n                clip-path: url(#clippath-427);\n            }\n\n            .cls-124 {\n                clip-path: url(#clippath-426);\n            }\n\n            .cls-125 {\n                clip-path: url(#clippath-424);\n            }\n\n            .cls-126 {\n                clip-path: url(#clippath-428);\n            }\n\n            .cls-127 {\n                clip-path: url(#clippath-425);\n            }\n\n            .cls-128 {\n                clip-path: url(#clippath-447);\n            }\n\n            .cls-129 {\n                clip-path: url(#clippath-449);\n            }\n\n            .cls-130 {\n                clip-path: url(#clippath-440);\n            }\n\n            .cls-131 {\n                clip-path: url(#clippath-443);\n            }\n\n            .cls-132 {\n                clip-path: url(#clippath-444);\n            }\n\n            .cls-133 {\n                clip-path: url(#clippath-441);\n            }\n\n            .cls-134 {\n                clip-path: url(#clippath-445);\n            }\n\n            .cls-135 {\n                clip-path: url(#clippath-442);\n            }\n\n            .cls-136 {\n                clip-path: url(#clippath-446);\n            }\n\n            .cls-137 {\n                clip-path: url(#clippath-448);\n            }\n\n            .cls-138 {\n                clip-path: url(#clippath-416);\n            }\n\n            .cls-139 {\n                clip-path: url(#clippath-415);\n            }\n\n            .cls-140 {\n                clip-path: url(#clippath-414);\n            }\n\n            .cls-141 {\n                clip-path: url(#clippath-413);\n            }\n\n            .cls-142 {\n                clip-path: url(#clippath-412);\n            }\n\n            .cls-143 {\n                clip-path: url(#clippath-411);\n            }\n\n            .cls-144 {\n                clip-path: url(#clippath-410);\n            }\n\n            .cls-145 {\n                clip-path: url(#clippath-417);\n            }\n\n            .cls-146 {\n                clip-path: url(#clippath-419);\n            }\n\n            .cls-147 {\n                clip-path: url(#clippath-418);\n            }\n\n            .cls-148 {\n                clip-path: url(#clippath-451);\n            }\n\n            .cls-149 {\n                clip-path: url(#clippath-454);\n            }\n\n            .cls-150 {\n                clip-path: url(#clippath-453);\n            }\n\n            .cls-151 {\n                clip-path: url(#clippath-452);\n            }\n\n            .cls-152 {\n                clip-path: url(#clippath-458);\n            }\n\n            .cls-153 {\n                clip-path: url(#clippath-457);\n            }\n\n            .cls-154 {\n                clip-path: url(#clippath-456);\n            }\n\n            .cls-155 {\n                clip-path: url(#clippath-450);\n            }\n\n            .cls-156 {\n                clip-path: url(#clippath-455);\n            }\n\n            .cls-157 {\n                clip-path: url(#clippath-459);\n            }\n\n            .cls-158 {\n                clip-path: url(#clippath-430);\n            }\n\n            .cls-159 {\n                clip-path: url(#clippath-433);\n            }\n\n            .cls-160 {\n                clip-path: url(#clippath-432);\n            }\n\n            .cls-161 {\n                clip-path: url(#clippath-431);\n            }\n\n            .cls-162 {\n                clip-path: url(#clippath-438);\n            }\n\n            .cls-163 {\n                clip-path: url(#clippath-437);\n            }\n\n            .cls-164 {\n                clip-path: url(#clippath-434);\n            }\n\n            .cls-165 {\n                clip-path: url(#clippath-439);\n            }\n\n            .cls-166 {\n                clip-path: url(#clippath-435);\n            }\n\n            .cls-167 {\n                clip-path: url(#clippath-436);\n            }\n\n            .cls-168 {\n                clip-path: url(#clippath-403);\n            }\n\n            .cls-169 {\n                clip-path: url(#clippath-406);\n            }\n\n            .cls-170 {\n                clip-path: url(#clippath-405);\n            }\n\n            .cls-171 {\n                clip-path: url(#clippath-400);\n            }\n\n            .cls-172 {\n                clip-path: url(#clippath-402);\n            }\n\n            .cls-173 {\n                clip-path: url(#clippath-401);\n            }\n\n            .cls-174 {\n                clip-path: url(#clippath-404);\n            }\n\n            .cls-175 {\n                clip-path: url(#clippath-408);\n            }\n\n            .cls-176 {\n                clip-path: url(#clippath-407);\n            }\n\n            .cls-177 {\n                clip-path: url(#clippath-409);\n            }\n\n            .cls-178 {\n                clip-path: url(#clippath-370);\n            }\n\n            .cls-179 {\n                clip-path: url(#clippath-371);\n            }\n\n            .cls-180 {\n                clip-path: url(#clippath-375);\n            }\n\n            .cls-181 {\n                clip-path: url(#clippath-376);\n            }\n\n            .cls-182 {\n                clip-path: url(#clippath-377);\n            }\n\n            .cls-183 {\n                clip-path: url(#clippath-378);\n            }\n\n            .cls-184 {\n                clip-path: url(#clippath-379);\n            }\n\n            .cls-185 {\n                clip-path: url(#clippath-372);\n            }\n\n            .cls-186 {\n                clip-path: url(#clippath-373);\n            }\n\n            .cls-187 {\n                clip-path: url(#clippath-374);\n            }\n\n            .cls-188 {\n                clip-path: url(#clippath-322);\n            }\n\n            .cls-189 {\n                clip-path: url(#clippath-321);\n            }\n\n            .cls-190 {\n                clip-path: url(#clippath-324);\n            }\n\n            .cls-191 {\n                clip-path: url(#clippath-325);\n            }\n\n            .cls-192 {\n                clip-path: url(#clippath-326);\n            }\n\n            .cls-193 {\n                clip-path: url(#clippath-323);\n            }\n\n            .cls-194 {\n                clip-path: url(#clippath-320);\n            }\n\n            .cls-195 {\n                clip-path: url(#clippath-327);\n            }\n\n            .cls-196 {\n                clip-path: url(#clippath-328);\n            }\n\n            .cls-197 {\n                clip-path: url(#clippath-307);\n            }\n\n            .cls-198 {\n                clip-path: url(#clippath-304);\n            }\n\n            .cls-199 {\n                clip-path: url(#clippath-305);\n            }\n\n            .cls-200 {\n                clip-path: url(#clippath-302);\n            }\n\n            .cls-201 {\n                clip-path: url(#clippath-303);\n            }\n\n            .cls-202 {\n                clip-path: url(#clippath-300);\n            }\n\n            .cls-203 {\n                clip-path: url(#clippath-301);\n            }\n\n            .cls-204 {\n                clip-path: url(#clippath-306);\n            }\n\n            .cls-205 {\n                clip-path: url(#clippath-308);\n            }\n\n            .cls-206 {\n                clip-path: url(#clippath-309);\n            }\n\n            .cls-207 {\n                clip-path: url(#clippath-317);\n            }\n\n            .cls-208 {\n                clip-path: url(#clippath-314);\n            }\n\n            .cls-209 {\n                clip-path: url(#clippath-316);\n            }\n\n            .cls-210 {\n                clip-path: url(#clippath-310);\n            }\n\n            .cls-211 {\n                clip-path: url(#clippath-318);\n            }\n\n            .cls-212 {\n                clip-path: url(#clippath-315);\n            }\n\n            .cls-213 {\n                clip-path: url(#clippath-311);\n            }\n\n            .cls-214 {\n                clip-path: url(#clippath-312);\n            }\n\n            .cls-215 {\n                clip-path: url(#clippath-313);\n            }\n\n            .cls-216 {\n                clip-path: url(#clippath-319);\n            }\n\n            .cls-217 {\n                clip-path: url(#clippath-329);\n            }\n\n            .cls-218 {\n                clip-path: url(#clippath-368);\n            }\n\n            .cls-219 {\n                clip-path: url(#clippath-365);\n            }\n\n            .cls-220 {\n                clip-path: url(#clippath-366);\n            }\n\n            .cls-221 {\n                clip-path: url(#clippath-369);\n            }\n\n            .cls-222 {\n                clip-path: url(#clippath-363);\n            }\n\n            .cls-223 {\n                clip-path: url(#clippath-362);\n            }\n\n            .cls-224 {\n                clip-path: url(#clippath-367);\n            }\n\n            .cls-225 {\n                clip-path: url(#clippath-364);\n            }\n\n            .cls-226 {\n                clip-path: url(#clippath-361);\n            }\n\n            .cls-227 {\n                clip-path: url(#clippath-360);\n            }\n\n            .cls-228 {\n                clip-path: url(#clippath-380);\n            }\n\n            .cls-229 {\n                clip-path: url(#clippath-381);\n            }\n\n            .cls-230 {\n                clip-path: url(#clippath-383);\n            }\n\n            .cls-231 {\n                clip-path: url(#clippath-388);\n            }\n\n            .cls-232 {\n                clip-path: url(#clippath-389);\n            }\n\n            .cls-233 {\n                clip-path: url(#clippath-386);\n            }\n\n            .cls-234 {\n                clip-path: url(#clippath-387);\n            }\n\n            .cls-235 {\n                clip-path: url(#clippath-384);\n            }\n\n            .cls-236 {\n                clip-path: url(#clippath-385);\n            }\n\n            .cls-237 {\n                clip-path: url(#clippath-382);\n            }\n\n            .cls-238 {\n                clip-path: url(#clippath-391);\n            }\n\n            .cls-239 {\n                clip-path: url(#clippath-395);\n            }\n\n            .cls-240 {\n                clip-path: url(#clippath-396);\n            }\n\n            .cls-241 {\n                clip-path: url(#clippath-397);\n            }\n\n            .cls-242 {\n                clip-path: url(#clippath-398);\n            }\n\n            .cls-243 {\n                clip-path: url(#clippath-392);\n            }\n\n            .cls-244 {\n                clip-path: url(#clippath-393);\n            }\n\n            .cls-245 {\n                clip-path: url(#clippath-394);\n            }\n\n            .cls-246 {\n                clip-path: url(#clippath-390);\n            }\n\n            .cls-247 {\n                clip-path: url(#clippath-399);\n            }\n\n            .cls-248 {\n                clip-path: url(#clippath-330);\n            }\n\n            .cls-249 {\n                clip-path: url(#clippath-339);\n            }\n\n            .cls-250 {\n                clip-path: url(#clippath-336);\n            }\n\n            .cls-251 {\n                clip-path: url(#clippath-334);\n            }\n\n            .cls-252 {\n                clip-path: url(#clippath-331);\n            }\n\n            .cls-253 {\n                clip-path: url(#clippath-332);\n            }\n\n            .cls-254 {\n                clip-path: url(#clippath-333);\n            }\n\n            .cls-255 {\n                clip-path: url(#clippath-337);\n            }\n\n            .cls-256 {\n                clip-path: url(#clippath-338);\n            }\n\n            .cls-257 {\n                clip-path: url(#clippath-335);\n            }\n\n            .cls-258 {\n                clip-path: url(#clippath-340);\n            }\n\n            .cls-259 {\n                clip-path: url(#clippath-344);\n            }\n\n            .cls-260 {\n                clip-path: url(#clippath-342);\n            }\n\n            .cls-261 {\n                clip-path: url(#clippath-343);\n            }\n\n            .cls-262 {\n                clip-path: url(#clippath-349);\n            }\n\n            .cls-263 {\n                clip-path: url(#clippath-346);\n            }\n\n            .cls-264 {\n                clip-path: url(#clippath-347);\n            }\n\n            .cls-265 {\n                clip-path: url(#clippath-341);\n            }\n\n            .cls-266 {\n                clip-path: url(#clippath-345);\n            }\n\n            .cls-267 {\n                clip-path: url(#clippath-348);\n            }\n\n            .cls-268 {\n                clip-path: url(#clippath-350);\n            }\n\n            .cls-269 {\n                clip-path: url(#clippath-352);\n            }\n\n            .cls-270 {\n                clip-path: url(#clippath-353);\n            }\n\n            .cls-271 {\n                clip-path: url(#clippath-354);\n            }\n\n            .cls-272 {\n                clip-path: url(#clippath-355);\n            }\n\n            .cls-273 {\n                clip-path: url(#clippath-356);\n            }\n\n            .cls-274 {\n                clip-path: url(#clippath-351);\n            }\n\n            .cls-275 {\n                clip-path: url(#clippath-357);\n            }\n\n            .cls-276 {\n                clip-path: url(#clippath-358);\n            }\n\n            .cls-277 {\n                clip-path: url(#clippath-359);\n            }\n\n            .cls-278 {\n                clip-path: url(#clippath-230);\n            }\n\n            .cls-279 {\n                clip-path: url(#clippath-235);\n            }\n\n            .cls-280 {\n                clip-path: url(#clippath-232);\n            }\n\n            .cls-281 {\n                clip-path: url(#clippath-234);\n            }\n\n            .cls-282 {\n                clip-path: url(#clippath-233);\n            }\n\n            .cls-283 {\n                clip-path: url(#clippath-239);\n            }\n\n            .cls-284 {\n                clip-path: url(#clippath-236);\n            }\n\n            .cls-285 {\n                clip-path: url(#clippath-231);\n            }\n\n            .cls-286 {\n                clip-path: url(#clippath-238);\n            }\n\n            .cls-287 {\n                clip-path: url(#clippath-237);\n            }\n\n            .cls-288 {\n                clip-path: url(#clippath-212);\n            }\n\n            .cls-289 {\n                clip-path: url(#clippath-217);\n            }\n\n            .cls-290 {\n                clip-path: url(#clippath-214);\n            }\n\n            .cls-291 {\n                clip-path: url(#clippath-211);\n            }\n\n            .cls-292 {\n                clip-path: url(#clippath-213);\n            }\n\n            .cls-293 {\n                clip-path: url(#clippath-210);\n            }\n\n            .cls-294 {\n                clip-path: url(#clippath-215);\n            }\n\n            .cls-295 {\n                clip-path: url(#clippath-219);\n            }\n\n            .cls-296 {\n                clip-path: url(#clippath-216);\n            }\n\n            .cls-297 {\n                clip-path: url(#clippath-218);\n            }\n\n            .cls-298 {\n                clip-path: url(#clippath-207);\n            }\n\n            .cls-299 {\n                clip-path: url(#clippath-201);\n            }\n\n            .cls-300 {\n                clip-path: url(#clippath-200);\n            }\n\n            .cls-301 {\n                clip-path: url(#clippath-202);\n            }\n\n            .cls-302 {\n                clip-path: url(#clippath-203);\n            }\n\n            .cls-303 {\n                clip-path: url(#clippath-204);\n            }\n\n            .cls-304 {\n                clip-path: url(#clippath-205);\n            }\n\n            .cls-305 {\n                clip-path: url(#clippath-209);\n            }\n\n            .cls-306 {\n                clip-path: url(#clippath-206);\n            }\n\n            .cls-307 {\n                clip-path: url(#clippath-208);\n            }\n\n            .cls-308 {\n                clip-path: url(#clippath-220);\n            }\n\n            .cls-309 {\n                clip-path: url(#clippath-221);\n            }\n\n            .cls-310 {\n                clip-path: url(#clippath-222);\n            }\n\n            .cls-311 {\n                clip-path: url(#clippath-224);\n            }\n\n            .cls-312 {\n                clip-path: url(#clippath-223);\n            }\n\n            .cls-313 {\n                clip-path: url(#clippath-225);\n            }\n\n            .cls-314 {\n                clip-path: url(#clippath-226);\n            }\n\n            .cls-315 {\n                clip-path: url(#clippath-227);\n            }\n\n            .cls-316 {\n                clip-path: url(#clippath-228);\n            }\n\n            .cls-317 {\n                clip-path: url(#clippath-229);\n            }\n\n            .cls-318 {\n                clip-path: url(#clippath-270);\n            }\n\n            .cls-319 {\n                clip-path: url(#clippath-275);\n            }\n\n            .cls-320 {\n                clip-path: url(#clippath-279);\n            }\n\n            .cls-321 {\n                clip-path: url(#clippath-272);\n            }\n\n            .cls-322 {\n                clip-path: url(#clippath-273);\n            }\n\n            .cls-323 {\n                clip-path: url(#clippath-274);\n            }\n\n            .cls-324 {\n                clip-path: url(#clippath-276);\n            }\n\n            .cls-325 {\n                clip-path: url(#clippath-277);\n            }\n\n            .cls-326 {\n                clip-path: url(#clippath-278);\n            }\n\n            .cls-327 {\n                clip-path: url(#clippath-271);\n            }\n\n            .cls-328 {\n                clip-path: url(#clippath-250);\n            }\n\n            .cls-329 {\n                clip-path: url(#clippath-259);\n            }\n\n            .cls-330 {\n                clip-path: url(#clippath-253);\n            }\n\n            .cls-331 {\n                clip-path: url(#clippath-252);\n            }\n\n            .cls-332 {\n                clip-path: url(#clippath-251);\n            }\n\n            .cls-333 {\n                clip-path: url(#clippath-255);\n            }\n\n            .cls-334 {\n                clip-path: url(#clippath-256);\n            }\n\n            .cls-335 {\n                clip-path: url(#clippath-254);\n            }\n\n            .cls-336 {\n                clip-path: url(#clippath-257);\n            }\n\n            .cls-337 {\n                clip-path: url(#clippath-258);\n            }\n\n            .cls-338 {\n                clip-path: url(#clippath-240);\n            }\n\n            .cls-339 {\n                clip-path: url(#clippath-249);\n            }\n\n            .cls-340 {\n                clip-path: url(#clippath-246);\n            }\n\n            .cls-341 {\n                clip-path: url(#clippath-241);\n            }\n\n            .cls-342 {\n                clip-path: url(#clippath-242);\n            }\n\n            .cls-343 {\n                clip-path: url(#clippath-243);\n            }\n\n            .cls-344 {\n                clip-path: url(#clippath-247);\n            }\n\n            .cls-345 {\n                clip-path: url(#clippath-244);\n            }\n\n            .cls-346 {\n                clip-path: url(#clippath-248);\n            }\n\n            .cls-347 {\n                clip-path: url(#clippath-245);\n            }\n\n            .cls-348 {\n                clip-path: url(#clippath-264);\n            }\n\n            .cls-349 {\n                clip-path: url(#clippath-269);\n            }\n\n            .cls-350 {\n                clip-path: url(#clippath-266);\n            }\n\n            .cls-351 {\n                clip-path: url(#clippath-263);\n            }\n\n            .cls-352 {\n                clip-path: url(#clippath-268);\n            }\n\n            .cls-353 {\n                clip-path: url(#clippath-265);\n            }\n\n            .cls-354 {\n                clip-path: url(#clippath-262);\n            }\n\n            .cls-355 {\n                clip-path: url(#clippath-260);\n            }\n\n            .cls-356 {\n                clip-path: url(#clippath-267);\n            }\n\n            .cls-357 {\n                clip-path: url(#clippath-291);\n            }\n\n            .cls-358 {\n                clip-path: url(#clippath-290);\n            }\n\n            .cls-359 {\n                clip-path: url(#clippath-281);\n            }\n\n            .cls-360 {\n                clip-path: url(#clippath-280);\n            }\n\n            .cls-361 {\n                clip-path: url(#clippath-292);\n            }\n\n            .cls-362 {\n                clip-path: url(#clippath-297);\n            }\n\n            .cls-363 {\n                clip-path: url(#clippath-294);\n            }\n\n            .cls-364 {\n                clip-path: url(#clippath-299);\n            }\n\n            .cls-365 {\n                clip-path: url(#clippath-296);\n            }\n\n            .cls-366 {\n                clip-path: url(#clippath-298);\n            }\n\n            .cls-367 {\n                clip-path: url(#clippath-293);\n            }\n\n            .cls-368 {\n                clip-path: url(#clippath-295);\n            }\n\n            .cls-369 {\n                clip-path: url(#clippath-282);\n            }\n\n            .cls-370 {\n                clip-path: url(#clippath-287);\n            }\n\n            .cls-371 {\n                clip-path: url(#clippath-284);\n            }\n\n            .cls-372 {\n                clip-path: url(#clippath-289);\n            }\n\n            .cls-373 {\n                clip-path: url(#clippath-288);\n            }\n\n            .cls-374 {\n                clip-path: url(#clippath-283);\n            }\n\n            .cls-375 {\n                clip-path: url(#clippath-285);\n            }\n\n            .cls-376 {\n                clip-path: url(#clippath-286);\n            }\n\n            .cls-377 {\n                clip-path: url(#clippath-261);\n            }\n\n            .cls-378 {\n                clip-path: url(#clippath-490);\n            }\n\n            .cls-379 {\n                clip-path: url(#clippath-492);\n            }\n\n            .cls-380 {\n                clip-path: url(#clippath-499);\n            }\n\n            .cls-381 {\n                clip-path: url(#clippath-498);\n            }\n\n            .cls-382 {\n                clip-path: url(#clippath-497);\n            }\n\n            .cls-383 {\n                clip-path: url(#clippath-496);\n            }\n\n            .cls-384 {\n                clip-path: url(#clippath-491);\n            }\n\n            .cls-385 {\n                clip-path: url(#clippath-495);\n            }\n\n            .cls-386 {\n                clip-path: url(#clippath-494);\n            }\n\n            .cls-387 {\n                clip-path: url(#clippath-493);\n            }\n\n            .cls-388 {\n                clip-path: url(#clippath-464);\n            }\n\n            .cls-389 {\n                clip-path: url(#clippath-467);\n            }\n\n            .cls-390 {\n                clip-path: url(#clippath-466);\n            }\n\n            .cls-391 {\n                clip-path: url(#clippath-469);\n            }\n\n            .cls-392 {\n                clip-path: url(#clippath-468);\n            }\n\n            .cls-393 {\n                clip-path: url(#clippath-463);\n            }\n\n            .cls-394 {\n                clip-path: url(#clippath-462);\n            }\n\n            .cls-395 {\n                clip-path: url(#clippath-465);\n            }\n\n            .cls-396 {\n                clip-path: url(#clippath-480);\n            }\n\n            .cls-397 {\n                clip-path: url(#clippath-487);\n            }\n\n            .cls-398 {\n                clip-path: url(#clippath-482);\n            }\n\n            .cls-399 {\n                clip-path: url(#clippath-489);\n            }\n\n            .cls-400 {\n                clip-path: url(#clippath-486);\n            }\n\n            .cls-401 {\n                clip-path: url(#clippath-481);\n            }\n\n            .cls-402 {\n                clip-path: url(#clippath-484);\n            }\n\n            .cls-403 {\n                clip-path: url(#clippath-485);\n            }\n\n            .cls-404 {\n                clip-path: url(#clippath-488);\n            }\n\n            .cls-405 {\n                clip-path: url(#clippath-483);\n            }\n\n            .cls-406 {\n                clip-path: url(#clippath-471);\n            }\n\n            .cls-407 {\n                clip-path: url(#clippath-470);\n            }\n\n            .cls-408 {\n                clip-path: url(#clippath-473);\n            }\n\n            .cls-409 {\n                clip-path: url(#clippath-472);\n            }\n\n            .cls-410 {\n                clip-path: url(#clippath-461);\n            }\n\n            .cls-411 {\n                clip-path: url(#clippath-460);\n            }\n\n            .cls-412 {\n                clip-path: url(#clippath-479);\n            }\n\n            .cls-413 {\n                clip-path: url(#clippath-478);\n            }\n\n            .cls-414 {\n                clip-path: url(#clippath-477);\n            }\n\n            .cls-415 {\n                clip-path: url(#clippath-475);\n            }\n\n            .cls-416 {\n                clip-path: url(#clippath-474);\n            }\n\n            .cls-417 {\n                clip-path: url(#clippath-476);\n            }\n\n            .cls-418 {\n                clip-path: url(#clippath-163);\n            }\n\n            .cls-419 {\n                clip-path: url(#clippath-165);\n            }\n\n            .cls-420 {\n                clip-path: url(#clippath-160);\n            }\n\n            .cls-421 {\n                clip-path: url(#clippath-161);\n            }\n\n            .cls-422 {\n                clip-path: url(#clippath-168);\n            }\n\n            .cls-423 {\n                clip-path: url(#clippath-167);\n            }\n\n            .cls-424 {\n                clip-path: url(#clippath-162);\n            }\n\n            .cls-425 {\n                clip-path: url(#clippath-169);\n            }\n\n            .cls-426 {\n                clip-path: url(#clippath-164);\n            }\n\n            .cls-427 {\n                clip-path: url(#clippath-166);\n            }\n\n            .cls-428 {\n                clip-path: url(#clippath-178);\n            }\n\n            .cls-429 {\n                clip-path: url(#clippath-174);\n            }\n\n            .cls-430 {\n                clip-path: url(#clippath-172);\n            }\n\n            .cls-431 {\n                clip-path: url(#clippath-171);\n            }\n\n            .cls-432 {\n                clip-path: url(#clippath-179);\n            }\n\n            .cls-433 {\n                clip-path: url(#clippath-173);\n            }\n\n            .cls-434 {\n                clip-path: url(#clippath-176);\n            }\n\n            .cls-435 {\n                clip-path: url(#clippath-175);\n            }\n\n            .cls-436 {\n                clip-path: url(#clippath-190);\n            }\n\n            .cls-437 {\n                clip-path: url(#clippath-198);\n            }\n\n            .cls-438 {\n                clip-path: url(#clippath-191);\n            }\n\n            .cls-439 {\n                clip-path: url(#clippath-182);\n            }\n\n            .cls-440 {\n                clip-path: url(#clippath-185);\n            }\n\n            .cls-441 {\n                clip-path: url(#clippath-181);\n            }\n\n            .cls-442 {\n                clip-path: url(#clippath-188);\n            }\n\n            .cls-443 {\n                clip-path: url(#clippath-184);\n            }\n\n            .cls-444 {\n                clip-path: url(#clippath-186);\n            }\n\n            .cls-445 {\n                clip-path: url(#clippath-187);\n            }\n\n            .cls-446 {\n                clip-path: url(#clippath-189);\n            }\n\n            .cls-447 {\n                clip-path: url(#clippath-183);\n            }\n\n            .cls-448 {\n                clip-path: url(#clippath-180);\n            }\n\n            .cls-449 {\n                clip-path: url(#clippath-192);\n            }\n\n            .cls-450 {\n                clip-path: url(#clippath-193);\n            }\n\n            .cls-451 {\n                clip-path: url(#clippath-199);\n            }\n\n            .cls-452 {\n                clip-path: url(#clippath-195);\n            }\n\n            .cls-453 {\n                clip-path: url(#clippath-194);\n            }\n\n            .cls-454 {\n                clip-path: url(#clippath-197);\n            }\n\n            .cls-455 {\n                clip-path: url(#clippath-196);\n            }\n\n            .cls-456 {\n                clip-path: url(#clippath-102);\n            }\n\n            .cls-457 {\n                clip-path: url(#clippath-101);\n            }\n\n            .cls-458 {\n                clip-path: url(#clippath-104);\n            }\n\n            .cls-459 {\n                clip-path: url(#clippath-109);\n            }\n\n            .cls-460 {\n                clip-path: url(#clippath-106);\n            }\n\n            .cls-461 {\n                clip-path: url(#clippath-103);\n            }\n\n            .cls-462 {\n                clip-path: url(#clippath-105);\n            }\n\n            .cls-463 {\n                clip-path: url(#clippath-100);\n            }\n\n            .cls-464 {\n                clip-path: url(#clippath-108);\n            }\n\n            .cls-465 {\n                clip-path: url(#clippath-107);\n            }\n\n            .cls-466 {\n                clip-path: url(#clippath-118);\n            }\n\n            .cls-467 {\n                clip-path: url(#clippath-114);\n            }\n\n            .cls-468 {\n                clip-path: url(#clippath-119);\n            }\n\n            .cls-469 {\n                clip-path: url(#clippath-111);\n            }\n\n            .cls-470 {\n                clip-path: url(#clippath-110);\n            }\n\n            .cls-471 {\n                clip-path: url(#clippath-113);\n            }\n\n            .cls-472 {\n                clip-path: url(#clippath-112);\n            }\n\n            .cls-473 {\n                clip-path: url(#clippath-117);\n            }\n\n            .cls-474 {\n                clip-path: url(#clippath-115);\n            }\n\n            .cls-475 {\n                clip-path: url(#clippath-116);\n            }\n\n            .cls-476 {\n                clip-path: url(#clippath-170);\n            }\n\n            .cls-477 {\n                clip-path: url(#clippath-177);\n            }\n\n            .cls-478 {\n                clip-path: url(#clippath-151);\n            }\n\n            .cls-479 {\n                clip-path: url(#clippath-156);\n            }\n\n            .cls-480 {\n                clip-path: url(#clippath-159);\n            }\n\n            .cls-481 {\n                clip-path: url(#clippath-150);\n            }\n\n            .cls-482 {\n                clip-path: url(#clippath-143);\n            }\n\n            .cls-483 {\n                clip-path: url(#clippath-144);\n            }\n\n            .cls-484 {\n                clip-path: url(#clippath-141);\n            }\n\n            .cls-485 {\n                clip-path: url(#clippath-148);\n            }\n\n            .cls-486 {\n                clip-path: url(#clippath-142);\n            }\n\n            .cls-487 {\n                clip-path: url(#clippath-149);\n            }\n\n            .cls-488 {\n                clip-path: url(#clippath-140);\n            }\n\n            .cls-489 {\n                clip-path: url(#clippath-145);\n            }\n\n            .cls-490 {\n                clip-path: url(#clippath-146);\n            }\n\n            .cls-491 {\n                clip-path: url(#clippath-147);\n            }\n\n            .cls-492 {\n                clip-path: url(#clippath-153);\n            }\n\n            .cls-493 {\n                clip-path: url(#clippath-152);\n            }\n\n            .cls-494 {\n                clip-path: url(#clippath-157);\n            }\n\n            .cls-495 {\n                clip-path: url(#clippath-154);\n            }\n\n            .cls-496 {\n                clip-path: url(#clippath-158);\n            }\n\n            .cls-497 {\n                clip-path: url(#clippath-155);\n            }\n\n            .cls-498 {\n                clip-path: url(#clippath-120);\n            }\n\n            .cls-499 {\n                clip-path: url(#clippath-125);\n            }\n\n            .cls-500 {\n                clip-path: url(#clippath-122);\n            }\n\n            .cls-501 {\n                clip-path: url(#clippath-121);\n            }\n\n            .cls-502 {\n                clip-path: url(#clippath-123);\n            }\n\n            .cls-503 {\n                clip-path: url(#clippath-124);\n            }\n\n            .cls-504 {\n                clip-path: url(#clippath-129);\n            }\n\n            .cls-505 {\n                clip-path: url(#clippath-126);\n            }\n\n            .cls-506 {\n                clip-path: url(#clippath-128);\n            }\n\n            .cls-507 {\n                clip-path: url(#clippath-127);\n            }\n\n            .cls-508 {\n                clip-path: url(#clippath-130);\n            }\n\n            .cls-509 {\n                clip-path: url(#clippath-132);\n            }\n\n            .cls-510 {\n                clip-path: url(#clippath-131);\n            }\n\n            .cls-511 {\n                clip-path: url(#clippath-134);\n            }\n\n            .cls-512 {\n                clip-path: url(#clippath-133);\n            }\n\n            .cls-513 {\n                clip-path: url(#clippath-136);\n            }\n\n            .cls-514 {\n                clip-path: url(#clippath-139);\n            }\n\n            .cls-515 {\n                clip-path: url(#clippath-137);\n            }\n\n            .cls-516 {\n                clip-path: url(#clippath-138);\n            }\n\n            .cls-517 {\n                clip-path: url(#clippath-135);\n            }\n\n            .cls-518 {\n                clip-path: url(#clippath-630);\n            }\n\n            .cls-519 {\n                clip-path: url(#clippath-631);\n            }\n\n            .cls-520 {\n                clip-path: url(#clippath-627);\n            }\n\n            .cls-521 {\n                clip-path: url(#clippath-629);\n            }\n\n            .cls-522 {\n                clip-path: url(#clippath-626);\n            }\n\n            .cls-523 {\n                clip-path: url(#clippath-625);\n            }\n\n            .cls-524 {\n                clip-path: url(#clippath-622);\n            }\n\n            .cls-525 {\n                clip-path: url(#clippath-621);\n            }\n\n            .cls-526 {\n                clip-path: url(#clippath-628);\n            }\n\n            .cls-527 {\n                clip-path: url(#clippath-624);\n            }\n\n            .cls-528 {\n                clip-path: url(#clippath-623);\n            }\n\n            .cls-529 {\n                clip-path: url(#clippath-620);\n            }\n\n            .cls-530 {\n                clip-path: url(#clippath-615);\n            }\n\n            .cls-531 {\n                clip-path: url(#clippath-616);\n            }\n\n            .cls-532 {\n                clip-path: url(#clippath-613);\n            }\n\n            .cls-533 {\n                clip-path: url(#clippath-614);\n            }\n\n            .cls-534 {\n                clip-path: url(#clippath-619);\n            }\n\n            .cls-535 {\n                clip-path: url(#clippath-618);\n            }\n\n            .cls-536 {\n                clip-path: url(#clippath-617);\n            }\n\n            .cls-537 {\n                clip-path: url(#clippath-612);\n            }\n\n            .cls-538 {\n                clip-path: url(#clippath-611);\n            }\n\n            .cls-539 {\n                clip-path: url(#clippath-610);\n            }\n\n            .cls-540 {\n                clip-path: url(#clippath-600);\n            }\n\n            .cls-541 {\n                clip-path: url(#clippath-601);\n            }\n\n            .cls-542 {\n                clip-path: url(#clippath-602);\n            }\n\n            .cls-543 {\n                clip-path: url(#clippath-604);\n            }\n\n            .cls-544 {\n                clip-path: url(#clippath-603);\n            }\n\n            .cls-545 {\n                clip-path: url(#clippath-606);\n            }\n\n            .cls-546 {\n                clip-path: url(#clippath-605);\n            }\n\n            .cls-547 {\n                clip-path: url(#clippath-608);\n            }\n\n            .cls-548 {\n                clip-path: url(#clippath-607);\n            }\n\n            .cls-549 {\n                clip-path: url(#clippath-539);\n            }\n\n            .cls-550 {\n                clip-path: url(#clippath-538);\n            }\n\n            .cls-551 {\n                clip-path: url(#clippath-537);\n            }\n\n            .cls-552 {\n                clip-path: url(#clippath-536);\n            }\n\n            .cls-553 {\n                clip-path: url(#clippath-531);\n            }\n\n            .cls-554 {\n                clip-path: url(#clippath-533);\n            }\n\n            .cls-555 {\n                clip-path: url(#clippath-530);\n            }\n\n            .cls-556 {\n                clip-path: url(#clippath-535);\n            }\n\n            .cls-557 {\n                clip-path: url(#clippath-532);\n            }\n\n            .cls-558 {\n                clip-path: url(#clippath-534);\n            }\n\n            .cls-559 {\n                clip-path: url(#clippath-544);\n            }\n\n            .cls-560 {\n                clip-path: url(#clippath-542);\n            }\n\n            .cls-561 {\n                clip-path: url(#clippath-543);\n            }\n\n            .cls-562 {\n                clip-path: url(#clippath-529);\n            }\n\n            .cls-563 {\n                clip-path: url(#clippath-528);\n            }\n\n            .cls-564 {\n                clip-path: url(#clippath-527);\n            }\n\n            .cls-565 {\n                clip-path: url(#clippath-526);\n            }\n\n            .cls-566 {\n                clip-path: url(#clippath-525);\n            }\n\n            .cls-567 {\n                clip-path: url(#clippath-523);\n            }\n\n            .cls-568 {\n                clip-path: url(#clippath-520);\n            }\n\n            .cls-569 {\n                clip-path: url(#clippath-521);\n            }\n\n            .cls-570 {\n                clip-path: url(#clippath-524);\n            }\n\n            .cls-571 {\n                clip-path: url(#clippath-522);\n            }\n\n            .cls-572 {\n                clip-path: url(#clippath-549);\n            }\n\n            .cls-573 {\n                clip-path: url(#clippath-546);\n            }\n\n            .cls-574 {\n                clip-path: url(#clippath-545);\n            }\n\n            .cls-575 {\n                clip-path: url(#clippath-540);\n            }\n\n            .cls-576 {\n                clip-path: url(#clippath-548);\n            }\n\n            .cls-577 {\n                clip-path: url(#clippath-541);\n            }\n\n            .cls-578 {\n                clip-path: url(#clippath-547);\n            }\n\n            .cls-579 {\n                clip-path: url(#clippath-519);\n            }\n\n            .cls-580 {\n                clip-path: url(#clippath-518);\n            }\n\n            .cls-581 {\n                clip-path: url(#clippath-517);\n            }\n\n            .cls-582 {\n                clip-path: url(#clippath-516);\n            }\n\n            .cls-583 {\n                clip-path: url(#clippath-515);\n            }\n\n            .cls-584 {\n                clip-path: url(#clippath-510);\n            }\n\n            .cls-585 {\n                clip-path: url(#clippath-511);\n            }\n\n            .cls-586 {\n                clip-path: url(#clippath-512);\n            }\n\n            .cls-587 {\n                clip-path: url(#clippath-513);\n            }\n\n            .cls-588 {\n                clip-path: url(#clippath-514);\n            }\n\n            .cls-589 {\n                clip-path: url(#clippath-569);\n            }\n\n            .cls-590 {\n                clip-path: url(#clippath-564);\n            }\n\n            .cls-591 {\n                clip-path: url(#clippath-567);\n            }\n\n            .cls-592 {\n                clip-path: url(#clippath-561);\n            }\n\n            .cls-593 {\n                clip-path: url(#clippath-563);\n            }\n\n            .cls-594 {\n                clip-path: url(#clippath-565);\n            }\n\n            .cls-595 {\n                clip-path: url(#clippath-568);\n            }\n\n            .cls-596 {\n                clip-path: url(#clippath-566);\n            }\n\n            .cls-597 {\n                clip-path: url(#clippath-562);\n            }\n\n            .cls-598 {\n                clip-path: url(#clippath-560);\n            }\n\n            .cls-599 {\n                clip-path: url(#clippath-586);\n            }\n\n            .cls-600 {\n                clip-path: url(#clippath-589);\n            }\n\n            .cls-601 {\n                clip-path: url(#clippath-581);\n            }\n\n            .cls-602 {\n                clip-path: url(#clippath-584);\n            }\n\n            .cls-603 {\n                clip-path: url(#clippath-582);\n            }\n\n            .cls-604 {\n                clip-path: url(#clippath-583);\n            }\n\n            .cls-605 {\n                clip-path: url(#clippath-585);\n            }\n\n            .cls-606 {\n                clip-path: url(#clippath-588);\n            }\n\n            .cls-607 {\n                clip-path: url(#clippath-587);\n            }\n\n            .cls-608 {\n                clip-path: url(#clippath-580);\n            }\n\n            .cls-609 {\n                clip-path: url(#clippath-556);\n            }\n\n            .cls-610 {\n                clip-path: url(#clippath-555);\n            }\n\n            .cls-611 {\n                clip-path: url(#clippath-557);\n            }\n\n            .cls-612 {\n                clip-path: url(#clippath-550);\n            }\n\n            .cls-613 {\n                clip-path: url(#clippath-558);\n            }\n\n            .cls-614 {\n                clip-path: url(#clippath-554);\n            }\n\n            .cls-615 {\n                clip-path: url(#clippath-559);\n            }\n\n            .cls-616 {\n                clip-path: url(#clippath-551);\n            }\n\n            .cls-617 {\n                clip-path: url(#clippath-553);\n            }\n\n            .cls-618 {\n                clip-path: url(#clippath-552);\n            }\n\n            .cls-619 {\n                clip-path: url(#clippath-501);\n            }\n\n            .cls-620 {\n                clip-path: url(#clippath-504);\n            }\n\n            .cls-621 {\n                clip-path: url(#clippath-505);\n            }\n\n            .cls-622 {\n                clip-path: url(#clippath-502);\n            }\n\n            .cls-623 {\n                clip-path: url(#clippath-503);\n            }\n\n            .cls-624 {\n                clip-path: url(#clippath-508);\n            }\n\n            .cls-625 {\n                clip-path: url(#clippath-500);\n            }\n\n            .cls-626 {\n                clip-path: url(#clippath-595);\n            }\n\n            .cls-627 {\n                clip-path: url(#clippath-594);\n            }\n\n            .cls-628 {\n                clip-path: url(#clippath-593);\n            }\n\n            .cls-629 {\n                clip-path: url(#clippath-596);\n            }\n\n            .cls-630 {\n                clip-path: url(#clippath-597);\n            }\n\n            .cls-631 {\n                clip-path: url(#clippath-598);\n            }\n\n            .cls-632 {\n                clip-path: url(#clippath-599);\n            }\n\n            .cls-633 {\n                clip-path: url(#clippath-592);\n            }\n\n            .cls-634 {\n                clip-path: url(#clippath-591);\n            }\n\n            .cls-635 {\n                clip-path: url(#clippath-590);\n            }\n\n            .cls-636 {\n                clip-path: url(#clippath-573);\n            }\n\n            .cls-637 {\n                clip-path: url(#clippath-576);\n            }\n\n            .cls-638 {\n                clip-path: url(#clippath-575);\n            }\n\n            .cls-639 {\n                clip-path: url(#clippath-579);\n            }\n\n            .cls-640 {\n                clip-path: url(#clippath-574);\n            }\n\n            .cls-641 {\n                clip-path: url(#clippath-572);\n            }\n\n            .cls-642 {\n                clip-path: url(#clippath-578);\n            }\n\n            .cls-643 {\n                clip-path: url(#clippath-577);\n            }\n\n            .cls-644 {\n                clip-path: url(#clippath-570);\n            }\n\n            .cls-645 {\n                clip-path: url(#clippath-571);\n            }\n\n            .cls-646 {\n                clip-path: url(#clippath-509);\n            }\n\n            .cls-647 {\n                clip-path: url(#clippath-506);\n            }\n\n            .cls-648 {\n                clip-path: url(#clippath-507);\n            }\n\n            .cls-649,\n            .cls-650 {\n                fill: #fff;\n            }\n\n            .cls-651 {\n                fill: #a5f3d0;\n                opacity: .75;\n            }\n\n            .cls-652 {\n                fill: #96f1c9;\n                opacity: .88;\n            }\n\n            .cls-650 {\n                opacity: 0;\n            }\n\n            .cls-653 {\n                fill: #f7fefb;\n                opacity: .06;\n            }\n\n            .cls-654 {\n                fill: url(#D\xE9grad\xE9_sans_nom_65);\n            }\n\n            .cls-655 {\n                fill: #e1fbef;\n                opacity: .25;\n            }\n\n            .cls-656 {\n                fill: #d9faec;\n                opacity: .31;\n            }\n\n            .cls-657 {\n                clip-path: url(#clippath);\n            }\n        '
        }
      </style>
      <linearGradient
        id="D\xE9grad\xE9_sans_nom_65"
        x1={89.96}
        y1={59.34}
        x2={222.61}
        y2={217.43}
        gradientTransform="translate(153.49 -73.09) rotate(45)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#feffff" />
        <stop offset={0.4} stopColor="#fffffe" />
        <stop offset={1} stopColor="#f0f2f1" />
      </linearGradient>
      <clipPath id="clippath">
        <path
          className="cls-1"
          d="M265.17,97.7s.06.07.09.1c0-.01-.02-.03-.03-.04-.02-.02-.04-.04-.06-.06h0ZM230.8,56.61c-2.14-1.57-9.72-5.25-9.79-5.29.21.24.48.57.69.81-.29.16-.67.37-.95.53,1.98,3.72,6.25,5.21,8.5,8.67q-.49-.16-3.71-1.88c.52,1.18,1.32,2.19,1.97,3.3-1.87-.17-2.24-.4-3.8-1.37-.65.19-1.45.69-1.9,1.19.93,2.73,4.55,2.84,5.44,5.61-.28.16-.65.36-.93.52.69.59,1.61,1.37,2.28,1.98-2.87-1.1-5.51-2.74-8.53-3.48.73,1.52,2.07,2.54,3.1,3.82q-3.13.02-4.35,1.67c-.72.08-1.7.06-2.4-.09-.84-1.53-3.26-5.38-7.65-7.88-.16.31-.38.73-.55,1.04.31.69.84,1.58,1.3,2.18q-5.38-2.96-5.47-2.96c.67,2.35,2.54,4.08,3.33,6.37-.04.05-4,5.56,1.8,7.89-1.53,3.4,2.3,4.81,2.77,7.47-.12-.3-.29-.7-.41-.99-.02.03-1.75,3.62-1.62,3.93,1.29,3.01,4.88,3.93,6.26,6.86-.18.36-.41.84-.59,1.2.23.23.53.54.75.77-.4.1-.93.23-1.33.33-4.72-2.98-7.19-8.04-10.97-11.88-.08,2.74-.14,4.55,4.85,9.06q-2.88-.58-5.45.27c.27,1.18.99,2.22,1.14,3.44-1.66.65-3.43.87-5.13,1.35-.22-.23-.52-.54-.75-.77-.4.03-.94.08-1.34.11-.17.76-.51,1.76-.83,2.47q-4.3-.37-4.61-.17c.68.98,1.53,2.34,1.91,3.47-.6,1.11-1.69,1.91-2,3.2l-.41.96c.17.54.39,1.25.55,1.78-.31-.02-.72-.05-1.03-.07-.18.66-.25,1.59-.18,2.27-.28.28-.65.66-.92.94-2.86-.83-2.52-4.29-4.69-5.69,4.02,1.01,5.58.91,6.44-.41l.45-.71c-2.06-6.13-5.61-6.28-12.68-6.58.38-.48.67-1.32.63-1.92q-2.47-1.07-3.44-.83c-.28-.24-.66-.56-.95-.8-.66.44-1.49,1.1-2.07,1.64-.69-.17-1.61-.35-2.31-.45q-1.97,3.83-2.23,4.11c.07.31.17.72.24,1.02-.31.1-.71.22-1.02.32-1.73,8.52-16.67,16.39-7.76,24.76q1.37-.23,3.15-1.9c1.64,1.33,1.4,3.81,3.12,5.1l1.28,1.17c3.29.34,4.34-2.54,4.35-2.57l-.25-9.95c-1.11-3.14,1.19-5.81,1.19-8.79.34-.21.79-.5,1.13-.71.35.15.81.35,1.15.51q-1.08,6.47.37,8.68c1.7,2.6,5.17.48,7.04,2.64-.26.22-.6.5-.85.72-.35-.04-.82-.09-1.17-.12-.88,1.02-1.63,2.15-2.63,3.06.38.26.89.61,1.28.87-.06.34-.15.79-.21,1.13-.27-.3-.63-.7-.9-1-.31.06-.73.14-1.04.2-.54,1.48-.67,2.09-1.22,4.66-3.51.93-4.81,1.53-6.66,3.73-.6-.16-1.4-.31-2.01-.39-.53-1.02-.18-2.17-.48-3.22l-.63-.61c-.36.35-.77.97-.8,1.47v-.07c-.12-.46-.27-1.08-.38-1.54-1.01.23-1.85.96-2.94.95-.33.66-.52,1.71-.37,2.44-2.99,2.11-5.48,4.85-8.63,6.76q-1.91-.81-3.51-.27c-.4,4.09,2.34,8.09.34,12.23-1.55,3.19-5.02.63-7.25,1.99q-.07,1.79-2.93,5.74c.13.35.31.82.44,1.17q12.77,2.29,12.66-1.01c1.82-.96,3.92-1.04,5.8-1.82q3.89,2.08,5.02,1.69c.75-5.35,7.11-1.43,7.18-1.38.29.22.48.69.69.99-2.12,5.4-3.66,9.31,2.54,7.65.18-.36.43-.85.61-1.21-.24-.29-.56-.67-.8-.96,5.35-7.85-2.27-10.73-5.53-11.96-.31-.93-.4-2.37-.04-3.28,1.58.01,10.01,4.34,12.42,9.58.25-.19.59-.44.84-.62.31.06.71.15,1.02.21,1.79-1.79,1.86-1.77,3.56-1.23.31,9.15,1.22,10.44,13.04,7.97,1.11,4.34-6.49,8.35-12.21,5.13-1.75-.98-3.25-2.4-5.24-2.95-2.84,2.3-3.25,6.03-5.24,8.83-.32-.12-.75-.27-1.08-.39-2.66-5.77-4.17-5.76-6.76-4.41-10.19-18.23-38.46,8.7-38.62,9.19-1.07,3.3-.94,3.5.72,5.96-2.2,3.67,2.08,12.09,2.78,12.96-2.24,4.29,1.77,9.09,4.36,11.56.6-.1,1.41-.25,2.01-.37.23.71.55,1.65.8,2.35q2.71,1.19,12.72-2.73c4.36-1.71,8.13,1.4,12.26,1.49.22.37.52.87.74,1.24-.65,1.54-1.7,2.84-2.54,4.26q6.07,9.84,5.8,11.26c-1.45,7.69-.02,12.18,0,12.22.3.1.7.24,1,.35-1.24,10.53,11.03,8.71,16.43,4.69.2-4.6,6.43-5.43,6.37-10.2q4.72-4.57,4.86-4.9c1.93-.32,4.11-.67,5.77-4.47-.27-.22-.63-.52-.9-.74.33-.58.59-1.47.6-2.14-.43-.44-1.25-.81-1.86-.83,2.5-6.34,11.69-6.64,12.85-14.2q1.94-.75,2.57-1.87c-.12-.3-.28-.7-.4-1,2.15-3.26,2.27-3.95,2.68-6.22-.3-.09-.69-.2-.99-.28-.05-.3-.12-.7-.17-1-2.62,1.33-5.6,1.07-8.34,1.86-3.6-6.46-6.76-13.15-10.18-19.71q.92.89,4.07,4.58c.72,0,1.68-.1,2.38-.24.14.31.32.73.46,1.05-.15.38-.34.88-.49,1.26q5.07,10.81,25.65-3.64.04-.87-.46-3.85c-4.51,2.58-16.71-.58-13.98-6.57.15-.32.47-.67.67-.96,1.94-.16,3.48-.29,6.16,2.58,1.58,1.69,4.52,4.84,15.45-1.47.97,1.31,1.55,2.84,2.37,4.24.35.07.83.16,1.18.23-.23.22-.53.52-.75.74,1.56,5.91,3.99,11.56,5.16,17.59,4.49-.5,9.29-17.71,9.83-19.67q.88-3.22,3.12-4.89c.39.1.91.23,1.3.33q1.04,2.27,1.71,7.24c.49-.33,1.15-.77,1.64-1.1.05.17.13.39.18.56q.46,1.37,1.09,3.14c.3-.06.7-.14.99-.19.19,2.09.32,4.18.5,6.27,6.5-9.31,4.3-13.2,3.57-14.48-1.2-2.13-1.18-6.55,1.12-7.96.29.08.68.19.97.27,2.67-4.31,2.83-10.59,2.91-13.6.15-5.89-3.48-11.2-2.61-17.19-.21.24-.48.56-.69.79q-.81-1.42-1.1-5.32c.32.41.76.96,1.08,1.37.24-.62.46-1.49.56-2.16q.8,1.38,2.57,7.53c2.41-14.04-10.96-41.26-11.64-42.02q-.19.85-1.14,3.05c-2.44-3.32-8.23-11.65-9.24-17.26.3.03.71.06,1.01.09-1.21-3.63-4.81-5.45-6.56-8.68.48.45,1.13,1.05,1.62,1.5q-1.52-1.92-3.4-3.7c7.16,5.75,17.35,21.1,17.78,21.76q-2.07-4.64-14.21-19.27c-5.94-7.15-13.77-12.25-20.35-18.69h0ZM203.12,150.39c-1.12,1.29-1.24,1.42-1.39,1.71.48.07,1.01-.54,1.43-.02.4.49.37.83.2,2.04-.91.64-1.7,1.2-2.59,1.34-1.88.3-3.72-.54-5.61-.16-1.2.25-2.36.7-3.6.78-.12,0-.27.02-.39.01-.94-.04-1.86-.39-1.48-2.62,0-.05,1.15-5.47,1.85-5.94.23.06.31.22.69,1.42,1.1,3.47,2.22,3.51,4.16,2.32-.86-.41-1.07-.5-1.14-.79.41-.23.61-.25,3.13-.33,3.69-.12,4.75-.47,5.61-.75-.26.3-.6.69-.86.99h0Z"
        />
      </clipPath>
      <clipPath id="clippath-1">
        <path
          className="cls-1"
          d="M225.89,53.33c.38.46.7.92.94,1.38-2.5-1.48-5.06-2.87-7.68-4.16-.22-.4-.49-.81-.83-1.21,2.59,1.23,5.11,2.56,7.57,3.99h0Z"
        />
      </clipPath>
      <clipPath id="clippath-2">
        <path
          className="cls-1"
          d="M233.05,57.9c.43.51.78,1.03,1.05,1.54-2.35-1.67-4.78-3.25-7.28-4.73-.25-.46-.56-.92-.94-1.38,2.46,1.43,4.85,2.95,7.17,4.57h0Z"
        />
      </clipPath>
      <clipPath id="clippath-3">
        <path
          className="cls-1"
          d="M239.79,63.02c.47.56.85,1.13,1.15,1.69-2.2-1.84-4.49-3.6-6.84-5.27-.27-.51-.62-1.03-1.05-1.54,2.32,1.62,4.57,3.32,6.74,5.12h0Z"
        />
      </clipPath>
      <clipPath id="clippath-4">
        <path
          className="cls-1"
          d="M246.06,68.65c.51.61.92,1.22,1.25,1.83-2.04-2.01-4.16-3.93-6.37-5.78-.3-.57-.69-1.13-1.15-1.69,2.17,1.79,4.26,3.67,6.27,5.63h0Z"
        />
      </clipPath>
      <clipPath id="clippath-5">
        <path
          className="cls-1"
          d="M219.61,51.76c-.1-.4-.25-.81-.47-1.21,2.63,1.29,5.19,2.68,7.68,4.16.25.46.42.92.54,1.38-2.52-1.54-5.1-2.99-7.75-4.33h0Z"
        />
      </clipPath>
      <clipPath id="clippath-6">
        <path
          className="cls-1"
          d="M227.36,56.09c-.11-.46-.29-.92-.54-1.38,2.5,1.48,4.92,3.06,7.28,4.73.27.52.47,1.03.6,1.55-2.37-1.72-4.82-3.35-7.34-4.89h0Z"
        />
      </clipPath>
      <clipPath id="clippath-7">
        <path
          className="cls-1"
          d="M234.7,60.98c-.12-.52-.32-1.03-.6-1.55,2.35,1.67,4.64,3.43,6.84,5.27.3.57.52,1.13.66,1.7-2.22-1.89-4.52-3.7-6.9-5.42h0Z"
        />
      </clipPath>
      <clipPath id="clippath-8">
        <path
          className="cls-1"
          d="M241.6,66.41c-.14-.57-.36-1.13-.66-1.7,2.2,1.84,4.32,3.77,6.37,5.78.33.61.56,1.23.71,1.84-2.06-2.05-4.2-4.03-6.42-5.92h0Z"
        />
      </clipPath>
      <clipPath id="clippath-9">
        <path
          className="cls-1"
          d="M253.19,76.75c.35.66.6,1.31.76,1.97-1.89-2.21-3.87-4.34-5.93-6.4-.15-.61-.38-1.23-.71-1.84,2.04,2.01,4,4.1,5.88,6.27h0Z"
        />
      </clipPath>
      <clipPath id="clippath-10">
        <path
          className="cls-1"
          d="M258.53,83.47c.37.7.64,1.39.81,2.09-1.71-2.35-3.5-4.63-5.39-6.84-.16-.66-.41-1.31-.76-1.97,1.87,2.17,3.66,4.41,5.35,6.72h0Z"
        />
      </clipPath>
      <clipPath id="clippath-11">
        <path
          className="cls-1"
          d="M263.32,90.61c.39.73.67,1.46.85,2.19-1.51-2.48-3.12-4.9-4.83-7.25-.17-.7-.44-1.39-.81-2.09,1.69,2.31,3.29,4.7,4.79,7.14h0Z"
        />
      </clipPath>
      <clipPath id="clippath-12">
        <path
          className="cls-1"
          d="M266.43,96.05l1.2,2.32c.35.69.61,1.38.77,2.07-1.31-2.61-2.72-5.15-4.23-7.64-.18-.73-.46-1.46-.85-2.19,1.09,1.78,2.12,3.59,3.11,5.44h0Z"
        />
      </clipPath>
      <clipPath id="clippath-13">
        <path
          className="cls-1"
          d="M219.73,52.97c.02-.4-.02-.81-.12-1.21,2.65,1.35,5.23,2.79,7.75,4.33.11.46.16.92.14,1.38-2.52-1.59-5.11-3.1-7.77-4.5h0Z"
        />
      </clipPath>
      <clipPath id="clippath-14">
        <path
          className="cls-1"
          d="M227.5,57.47c.02-.46-.03-.92-.14-1.38,2.52,1.54,4.96,3.17,7.34,4.89.12.52.18,1.03.15,1.54-2.38-1.77-4.83-3.46-7.36-5.05h0Z"
        />
      </clipPath>
      <clipPath id="clippath-15">
        <path
          className="cls-1"
          d="M234.86,62.53c.02-.51-.03-1.03-.15-1.54,2.37,1.72,4.68,3.53,6.9,5.42.14.57.19,1.13.17,1.69-2.23-1.94-4.53-3.8-6.91-5.57h0Z"
        />
      </clipPath>
      <clipPath id="clippath-16">
        <path
          className="cls-1"
          d="M241.77,68.1c.02-.56-.03-1.13-.17-1.69,2.22,1.89,4.36,3.86,6.42,5.92.15.61.21,1.23.18,1.84-2.06-2.1-4.21-4.12-6.43-6.06h0Z"
        />
      </clipPath>
      <clipPath id="clippath-17">
        <path
          className="cls-1"
          d="M248.2,74.16c.03-.61-.03-1.22-.18-1.84,2.06,2.05,4.04,4.19,5.93,6.4.16.66.22,1.31.19,1.97-1.89-2.25-3.87-4.43-5.94-6.53h0Z"
        />
      </clipPath>
      <clipPath id="clippath-18">
        <path
          className="cls-1"
          d="M259.34,85.56c.17.7.24,1.39.21,2.08-1.71-2.39-3.51-4.71-5.4-6.96.03-.65-.04-1.31-.19-1.97,1.89,2.21,3.69,4.49,5.39,6.84h0Z"
        />
      </clipPath>
      <clipPath id="clippath-19">
        <path
          className="cls-1"
          d="M264.17,92.81c.18.73.25,1.46.22,2.19-1.52-2.52-3.13-4.97-4.84-7.36.03-.69-.04-1.39-.21-2.08,1.71,2.35,3.32,4.77,4.83,7.25h0Z"
        />
      </clipPath>
      <clipPath id="clippath-20">
        <path
          className="cls-1"
          d="M219.51,54.17c.13-.4.21-.8.22-1.2,2.65,1.41,5.24,2.91,7.77,4.5-.02.46-.11.92-.25,1.37-2.51-1.65-5.09-3.21-7.73-4.67h0Z"
        />
      </clipPath>
      <clipPath id="clippath-21">
        <path
          className="cls-1"
          d="M227.25,58.85c.15-.46.23-.91.25-1.37,2.52,1.59,4.98,3.28,7.36,5.05-.02.51-.12,1.02-.28,1.53-2.37-1.82-4.81-3.56-7.33-5.21h0Z"
        />
      </clipPath>
      <clipPath id="clippath-22">
        <path
          className="cls-1"
          d="M234.57,64.06c.17-.51.26-1.02.28-1.53,2.38,1.77,4.69,3.63,6.91,5.57-.02.56-.13,1.12-.31,1.68-2.22-1.99-4.52-3.9-6.89-5.72h0Z"
        />
      </clipPath>
      <clipPath id="clippath-23">
        <path
          className="cls-1"
          d="M241.46,69.78c.18-.56.29-1.12.31-1.68,2.23,1.94,4.37,3.96,6.43,6.06-.03.61-.14,1.22-.34,1.82-2.05-2.14-4.19-4.21-6.41-6.2h0Z"
        />
      </clipPath>
      <clipPath id="clippath-24">
        <path
          className="cls-1"
          d="M247.87,75.98c.2-.6.31-1.21.34-1.82,2.07,2.1,4.05,4.28,5.94,6.53-.03.65-.15,1.3-.36,1.95-1.88-2.29-3.86-4.51-5.92-6.65h0Z"
        />
      </clipPath>
      <clipPath id="clippath-25">
        <path
          className="cls-1"
          d="M259.55,87.64c-.03.69-.16,1.38-.38,2.07-1.7-2.42-3.5-4.78-5.38-7.07.21-.65.33-1.3.36-1.95,1.89,2.25,3.7,4.57,5.4,6.96h0Z"
        />
      </clipPath>
      <clipPath id="clippath-26">
        <path
          className="cls-1"
          d="M268.63,102.73c-.03.76-.17,1.52-.42,2.27-1.31-2.66-2.72-5.27-4.23-7.82.24-.72.37-1.45.4-2.18,1.52,2.52,2.93,5.09,4.24,7.73h0Z"
        />
      </clipPath>
      <clipPath id="clippath-27">
        <path
          className="cls-1"
          d="M272.25,110.8c-.03.79-.18,1.57-.43,2.35-1.09-2.77-2.29-5.49-3.6-8.15.25-.75.39-1.51.42-2.27,1.31,2.63,2.52,5.33,3.62,8.07h0Z"
        />
      </clipPath>
      <clipPath id="clippath-28">
        <path
          className="cls-1"
          d="M275.2,119.18c-.04.81-.18,1.61-.45,2.41-.87-2.86-1.85-5.68-2.95-8.45.25-.78.4-1.56.43-2.35,1.1,2.74,2.08,5.54,2.96,8.38h0Z"
        />
      </clipPath>
      <clipPath id="clippath-29">
        <path
          className="cls-1"
          d="M226.61,60.2c.28-.45.49-.9.64-1.36,2.51,1.65,4.96,3.39,7.33,5.21-.17.51-.4,1.01-.71,1.52-2.35-1.88-4.77-3.67-7.25-5.37h0Z"
        />
      </clipPath>
      <clipPath id="clippath-30">
        <path
          className="cls-1"
          d="M233.86,65.58c.31-.5.55-1.01.71-1.52,2.37,1.82,4.67,3.73,6.89,5.72-.18.56-.44,1.11-.78,1.66-2.2-2.04-4.47-4-6.82-5.87h0Z"
        />
      </clipPath>
      <clipPath id="clippath-31">
        <path
          className="cls-1"
          d="M240.68,71.45c.34-.55.6-1.11.78-1.66,2.22,1.99,4.35,4.06,6.41,6.2-.2.6-.48,1.21-.85,1.8-2.03-2.19-4.15-4.3-6.34-6.34h0Z"
        />
      </clipPath>
      <clipPath id="clippath-32">
        <path
          className="cls-1"
          d="M247.02,77.79c.37-.6.65-1.2.85-1.8,2.06,2.15,4.03,4.37,5.92,6.65-.21.65-.51,1.29-.91,1.93-1.87-2.33-3.82-4.59-5.86-6.78h0Z"
        />
      </clipPath>
      <clipPath id="clippath-33">
        <path
          className="cls-1"
          d="M259.16,89.71c-.22.69-.55,1.37-.96,2.05-1.68-2.46-3.46-4.86-5.33-7.19.39-.64.69-1.28.91-1.93,1.88,2.29,3.68,4.65,5.38,7.07h0Z"
        />
      </clipPath>
      <clipPath id="clippath-34">
        <path
          className="cls-1"
          d="M262.97,99.33c.44-.71.77-1.43,1.01-2.15,1.51,2.55,2.92,5.16,4.23,7.82-.25.75-.6,1.5-1.05,2.24-1.29-2.69-2.69-5.33-4.18-7.91h0Z"
        />
      </clipPath>
      <clipPath id="clippath-35">
        <path
          className="cls-1"
          d="M267.16,107.24c.46-.74.81-1.49,1.05-2.24,1.31,2.66,2.51,5.38,3.6,8.15-.25.78-.62,1.55-1.09,2.32-1.08-2.79-2.27-5.53-3.56-8.23h0Z"
        />
      </clipPath>
      <clipPath id="clippath-36">
        <path
          className="cls-1"
          d="M270.72,115.46c.47-.77.84-1.54,1.09-2.32,1.09,2.77,2.08,5.58,2.95,8.45-.26.8-.64,1.6-1.12,2.38-.86-2.88-1.83-5.72-2.92-8.51h0Z"
        />
      </clipPath>
      <clipPath id="clippath-37">
        <path
          className="cls-1"
          d="M273.64,123.97c.48-.79.86-1.58,1.12-2.38.87,2.86,1.62,5.77,2.26,8.71-.27.82-.65,1.63-1.14,2.43-.63-2.96-1.38-5.88-2.24-8.76h0Z"
        />
      </clipPath>
      <clipPath id="clippath-38">
        <path
          className="cls-1"
          d="M278.56,139.25c-.27.83-.66,1.65-1.16,2.47-.39-3.03-.9-6.02-1.53-8.98.49-.81.88-1.62,1.14-2.43.64,2.94,1.15,5.93,1.54,8.95h0Z"
        />
      </clipPath>
      <clipPath id="clippath-39">
        <path
          className="cls-1"
          d="M226.61,60.2c-.28.45-.61.89-1.01,1.34-2.45-1.76-4.96-3.43-7.53-5,.35-.39.65-.78.89-1.17,2.62,1.52,5.17,3.14,7.66,4.84h0Z"
        />
      </clipPath>
      <clipPath id="clippath-40">
        <path
          className="cls-1"
          d="M225.6,61.54c.4-.44.74-.89,1.01-1.34,2.49,1.7,4.91,3.5,7.25,5.37-.31.5-.69,1-1.13,1.49-2.31-1.93-4.69-3.77-7.13-5.53h0Z"
        />
      </clipPath>
      <clipPath id="clippath-41">
        <path
          className="cls-1"
          d="M232.73,67.07c.45-.49.82-.99,1.13-1.49,2.35,1.88,4.62,3.84,6.82,5.87-.34.55-.75,1.1-1.24,1.64-2.16-2.09-4.4-4.09-6.71-6.02h0Z"
        />
      </clipPath>
      <clipPath id="clippath-42">
        <path
          className="cls-1"
          d="M239.43,73.09c.49-.54.9-1.09,1.24-1.64,2.19,2.04,4.31,4.15,6.34,6.34-.37.6-.82,1.19-1.35,1.77-2-2.23-4.08-4.39-6.24-6.47h0Z"
        />
      </clipPath>
      <clipPath id="clippath-43">
        <path
          className="cls-1"
          d="M245.67,79.56c.53-.59.98-1.18,1.35-1.77,2.04,2.19,3.99,4.45,5.86,6.78-.39.64-.87,1.27-1.44,1.9-1.84-2.37-3.76-4.68-5.76-6.91h0Z"
        />
      </clipPath>
      <clipPath id="clippath-44">
        <path
          className="cls-1"
          d="M251.43,86.47c.57-.63,1.05-1.26,1.44-1.9,1.87,2.33,3.64,4.73,5.33,7.19-.42.68-.93,1.35-1.53,2.01-1.66-2.5-3.41-4.93-5.24-7.3h0Z"
        />
      </clipPath>
      <clipPath id="clippath-45">
        <path
          className="cls-1"
          d="M256.68,93.77c.6-.66,1.11-1.34,1.53-2.01,1.68,2.46,3.28,4.99,4.77,7.57-.44.71-.97,1.42-1.61,2.12-1.47-2.61-3.04-5.17-4.69-7.67h0Z"
        />
      </clipPath>
      <clipPath id="clippath-46">
        <path
          className="cls-1"
          d="M261.37,101.44c.63-.7,1.17-1.4,1.61-2.12,1.49,2.58,2.89,5.22,4.18,7.91-.46.74-1.01,1.48-1.67,2.21-1.27-2.72-2.65-5.39-4.11-8h0Z"
        />
      </clipPath>
      <clipPath id="clippath-47">
        <path
          className="cls-1"
          d="M265.48,109.44c.66-.73,1.22-1.46,1.67-2.21,1.29,2.69,2.48,5.44,3.56,8.23-.47.77-1.05,1.53-1.73,2.28-1.06-2.81-2.23-5.58-3.51-8.3h0Z"
        />
      </clipPath>
      <clipPath id="clippath-48">
        <path
          className="cls-1"
          d="M268.99,117.75c.68-.75,1.26-1.52,1.73-2.28,1.08,2.79,2.06,5.63,2.92,8.51-.48.79-1.08,1.57-1.78,2.35-.85-2.9-1.8-5.76-2.87-8.57h0Z"
        />
      </clipPath>
      <clipPath id="clippath-49">
        <path
          className="cls-1"
          d="M271.86,126.32c.7-.77,1.3-1.56,1.78-2.35.86,2.88,1.61,5.8,2.24,8.76-.49.81-1.1,1.6-1.82,2.39-.62-2.97-1.35-5.91-2.2-8.81h0Z"
        />
      </clipPath>
      <clipPath id="clippath-50">
        <path
          className="cls-1"
          d="M277.4,141.72c-.5.82-1.12,1.63-1.84,2.43-.38-3.04-.88-6.04-1.5-9.01.72-.79,1.32-1.59,1.82-2.39.63,2.96,1.14,5.95,1.53,8.98h0Z"
        />
      </clipPath>
      <clipPath id="clippath-51">
        <path
          className="cls-1"
          d="M275.56,144.14c.73-.8,1.34-1.61,1.84-2.43.39,3.02.65,6.08.79,9.16-.5.82-1.12,1.64-1.85,2.44-.13-3.08-.39-6.14-.77-9.18h0Z"
        />
      </clipPath>
      <clipPath id="clippath-52">
        <path
          className="cls-1"
          d="M278.2,160.17c-.5.82-1.12,1.64-1.86,2.45.06-1.4.09-2.81.09-4.23,0-1.69-.03-3.38-.1-5.06.73-.81,1.35-1.62,1.85-2.44.07,1.68.11,3.36.11,5.06,0,1.42-.03,2.83-.09,4.23h0Z"
        />
      </clipPath>
      <clipPath id="clippath-53">
        <path
          className="cls-1"
          d="M225.6,61.54c-.4.44-.86.88-1.38,1.31-2.39-1.81-4.85-3.53-7.36-5.16.46-.38.86-.76,1.21-1.15,2.57,1.58,5.09,3.25,7.53,5h0Z"
        />
      </clipPath>
      <clipPath id="clippath-54">
        <path
          className="cls-1"
          d="M224.21,62.85c.52-.43.98-.87,1.38-1.31,2.45,1.76,4.83,3.6,7.13,5.53-.45.49-.96.98-1.54,1.46-2.26-1.98-4.58-3.87-6.97-5.68h0Z"
        />
      </clipPath>
      <clipPath id="clippath-55">
        <path
          className="cls-1"
          d="M231.19,68.53c.58-.48,1.1-.97,1.54-1.46,2.31,1.93,4.54,3.93,6.71,6.02-.49.54-1.05,1.08-1.69,1.6-2.11-2.13-4.3-4.19-6.55-6.16h0Z"
        />
      </clipPath>
      <clipPath id="clippath-56">
        <path
          className="cls-1"
          d="M237.74,74.69c.64-.53,1.2-1.06,1.69-1.6,2.16,2.08,4.24,4.24,6.24,6.47-.53.59-1.14,1.16-1.83,1.74-1.96-2.27-3.99-4.48-6.1-6.61h0Z"
        />
      </clipPath>
      <clipPath id="clippath-57">
        <path
          className="cls-1"
          d="M243.84,81.3c.69-.57,1.3-1.15,1.83-1.74,2,2.23,3.92,4.54,5.76,6.91-.57.63-1.22,1.25-1.96,1.86-1.79-2.41-3.67-4.76-5.63-7.03h0Z"
        />
      </clipPath>
      <clipPath id="clippath-58">
        <path
          className="cls-1"
          d="M249.47,88.33c.74-.61,1.4-1.23,1.96-1.86,1.84,2.37,3.58,4.81,5.24,7.3-.6.66-1.3,1.32-2.08,1.97-1.62-2.53-3.33-5.01-5.12-7.42h0Z"
        />
      </clipPath>
      <clipPath id="clippath-59">
        <path
          className="cls-1"
          d="M254.59,95.74c.79-.65,1.48-1.31,2.08-1.97,1.66,2.5,3.22,5.06,4.69,7.67-.63.7-1.36,1.39-2.19,2.07-1.44-2.65-2.97-5.24-4.59-7.77h0Z"
        />
      </clipPath>
      <clipPath id="clippath-60">
        <path
          className="cls-1"
          d="M259.18,103.51c.83-.68,1.56-1.37,2.19-2.07,1.47,2.61,2.84,5.28,4.11,8-.66.73-1.42,1.45-2.28,2.16-1.24-2.75-2.59-5.45-4.02-8.09h0Z"
        />
      </clipPath>
      <clipPath id="clippath-61">
        <path
          className="cls-1"
          d="M263.2,111.61c.86-.71,1.62-1.43,2.28-2.16,1.27,2.72,2.44,5.49,3.51,8.3-.68.75-1.47,1.5-2.36,2.24-1.04-2.84-2.18-5.63-3.43-8.38h0Z"
        />
      </clipPath>
      <clipPath id="clippath-62">
        <path
          className="cls-1"
          d="M266.63,119.98c.89-.74,1.68-1.48,2.36-2.24,1.06,2.81,2.02,5.67,2.87,8.57-.7.77-1.51,1.54-2.43,2.3-.83-2.92-1.76-5.8-2.8-8.63h0Z"
        />
      </clipPath>
      <clipPath id="clippath-63">
        <path
          className="cls-1"
          d="M269.43,128.62c.91-.76,1.72-1.52,2.43-2.3.85,2.9,1.58,5.84,2.2,8.81-.72.79-1.54,1.57-2.48,2.34-.6-2.99-1.32-5.94-2.15-8.86h0Z"
        />
      </clipPath>
      <clipPath id="clippath-64">
        <path
          className="cls-1"
          d="M271.58,137.47c.93-.77,1.76-1.55,2.48-2.34.62,2.97,1.12,5.98,1.5,9.01-.73.8-1.56,1.59-2.51,2.38-.37-3.04-.86-6.06-1.47-9.05h0Z"
        />
      </clipPath>
      <clipPath id="clippath-65">
        <path
          className="cls-1"
          d="M273.05,146.52c.95-.78,1.78-1.58,2.51-2.38.38,3.03.64,6.09.77,9.18-.73.81-1.57,1.61-2.53,2.39-.13-3.09-.38-6.15-.75-9.19h0Z"
        />
      </clipPath>
      <clipPath id="clippath-66">
        <path
          className="cls-1"
          d="M273.8,155.71c.95-.79,1.8-1.59,2.53-2.39.07,1.68.11,3.37.1,5.06,0,1.42-.03,2.83-.09,4.23-.73.81-1.58,1.61-2.53,2.39.05-1.4.08-2.81.09-4.23,0-1.69-.03-3.38-.1-5.06h0Z"
        />
      </clipPath>
      <clipPath id="clippath-67">
        <path
          className="cls-1"
          d="M275.6,171.71c-.73.8-1.57,1.6-2.51,2.38.36-2.98.61-6.01.73-9.08.95-.79,1.8-1.59,2.53-2.39-.12,3.08-.37,6.11-.74,9.1h0Z"
        />
      </clipPath>
      <clipPath id="clippath-68">
        <path
          className="cls-1"
          d="M274.13,180.53c-.72.79-1.54,1.57-2.48,2.35.6-2.88,1.08-5.81,1.44-8.79.95-.78,1.79-1.58,2.51-2.38-.37,2.99-.86,5.93-1.47,8.82h0Z"
        />
      </clipPath>
      <clipPath id="clippath-69">
        <path
          className="cls-1"
          d="M271.96,189.05c-.7.78-1.51,1.54-2.43,2.3.82-2.77,1.53-5.6,2.12-8.47.94-.77,1.76-1.56,2.48-2.35-.61,2.89-1.33,5.73-2.17,8.52h0Z"
        />
      </clipPath>
      <clipPath id="clippath-70">
        <path
          className="cls-1"
          d="M224.21,62.85c-.52.43-1.1.86-1.74,1.27-2.32-1.86-4.71-3.64-7.15-5.32.56-.37,1.07-.74,1.53-1.12,2.52,1.63,4.97,3.36,7.36,5.16h0Z"
        />
      </clipPath>
      <clipPath id="clippath-71">
        <path
          className="cls-1"
          d="M222.47,64.12c.64-.42,1.22-.84,1.74-1.27,2.39,1.81,4.72,3.7,6.97,5.68-.58.48-1.23.95-1.94,1.42-2.19-2.02-4.45-3.97-6.77-5.83h0Z"
        />
      </clipPath>
      <clipPath id="clippath-72">
        <path
          className="cls-1"
          d="M229.24,69.95c.71-.47,1.36-.94,1.94-1.42,2.26,1.98,4.44,4.03,6.55,6.16-.64.53-1.35,1.05-2.13,1.56-2.05-2.18-4.17-4.28-6.36-6.3h0Z"
        />
      </clipPath>
      <clipPath id="clippath-73">
        <path
          className="cls-1"
          d="M235.61,76.25c.78-.51,1.5-1.03,2.13-1.56,2.11,2.13,4.14,4.33,6.1,6.61-.69.57-1.46,1.14-2.31,1.69-1.9-2.31-3.87-4.56-5.92-6.74h0Z"
        />
      </clipPath>
      <clipPath id="clippath-74">
        <path
          className="cls-1"
          d="M241.53,82.99c.85-.56,1.62-1.12,2.31-1.69,1.96,2.28,3.84,4.62,5.63,7.03-.74.61-1.57,1.22-2.48,1.81-1.74-2.45-3.56-4.83-5.47-7.15h0Z"
        />
      </clipPath>
      <clipPath id="clippath-75">
        <path
          className="cls-1"
          d="M246.99,90.14c.91-.59,1.74-1.2,2.48-1.81,1.79,2.41,3.5,4.88,5.12,7.42-.79.65-1.66,1.29-2.63,1.92-1.57-2.57-3.23-5.08-4.97-7.53h0Z"
        />
      </clipPath>
      <clipPath id="clippath-76">
        <path
          className="cls-1"
          d="M251.97,97.67c.96-.63,1.84-1.27,2.63-1.92,1.62,2.53,3.15,5.12,4.59,7.77-.83.68-1.75,1.36-2.76,2.02-1.39-2.68-2.88-5.3-4.45-7.87h0Z"
        />
      </clipPath>
      <clipPath id="clippath-77">
        <path
          className="cls-1"
          d="M256.42,105.53c1.01-.66,1.93-1.34,2.76-2.02,1.44,2.65,2.78,5.34,4.02,8.09-.86.71-1.82,1.41-2.88,2.1-1.21-2.77-2.51-5.5-3.9-8.18h0Z"
        />
      </clipPath>
      <clipPath id="clippath-78">
        <path
          className="cls-1"
          d="M260.32,113.71c1.06-.69,2.02-1.39,2.88-2.1,1.24,2.75,2.39,5.54,3.43,8.38-.89.74-1.88,1.46-2.98,2.18-1.01-2.86-2.12-5.68-3.33-8.45h0Z"
        />
      </clipPath>
      <clipPath id="clippath-79">
        <path
          className="cls-1"
          d="M263.65,122.16c1.09-.71,2.09-1.44,2.98-2.18,1.04,2.84,1.98,5.72,2.8,8.63-.91.76-1.94,1.5-3.06,2.24-.8-2.93-1.71-5.83-2.72-8.69h0Z"
        />
      </clipPath>
      <clipPath id="clippath-80">
        <path
          className="cls-1"
          d="M266.37,130.85c1.12-.73,2.14-1.48,3.06-2.24.83,2.92,1.55,5.87,2.15,8.86-.93.77-1.98,1.53-3.12,2.28-.59-3-1.28-5.97-2.09-8.9h0Z"
        />
      </clipPath>
      <clipPath id="clippath-81">
        <path
          className="cls-1"
          d="M268.46,139.76c1.15-.75,2.19-1.51,3.12-2.28.6,2.99,1.1,6,1.47,9.05-.95.78-2,1.55-3.16,2.31-.36-3.05-.84-6.08-1.42-9.08h0Z"
        />
      </clipPath>
      <clipPath id="clippath-82">
        <path
          className="cls-1"
          d="M269.88,148.83c1.16-.76,2.22-1.53,3.16-2.31.37,3.04.62,6.11.75,9.19-.95.79-2.02,1.57-3.19,2.33-.13-3.09-.37-6.16-.73-9.21h0Z"
        />
      </clipPath>
      <clipPath id="clippath-83">
        <path
          className="cls-1"
          d="M270.61,158.04c1.17-.77,2.23-1.54,3.19-2.33.07,1.68.1,3.37.1,5.06,0,1.42-.03,2.83-.09,4.23-.95.79-2.02,1.57-3.19,2.33.05-1.4.08-2.81.08-4.23,0-1.69-.03-3.38-.1-5.07h0Z"
        />
      </clipPath>
      <clipPath id="clippath-84">
        <path
          className="cls-1"
          d="M270.63,167.34c1.17-.77,2.23-1.54,3.19-2.33-.12,3.07-.36,6.1-.73,9.08-.95.78-2,1.56-3.17,2.32.35-2.97.59-6,.71-9.07h0Z"
        />
      </clipPath>
      <clipPath id="clippath-85">
        <path
          className="cls-1"
          d="M269.92,176.4c1.16-.76,2.22-1.53,3.17-2.32-.36,2.98-.84,5.91-1.44,8.79-.94.77-1.98,1.54-3.13,2.29.58-2.87,1.05-5.79,1.4-8.76h0Z"
        />
      </clipPath>
      <clipPath id="clippath-86">
        <path
          className="cls-1"
          d="M269.53,191.35c-.92.76-1.94,1.51-3.06,2.24.79-2.75,1.48-5.56,2.06-8.43,1.15-.75,2.19-1.51,3.13-2.29-.6,2.88-1.31,5.71-2.12,8.47h0Z"
        />
      </clipPath>
      <clipPath id="clippath-87">
        <path
          className="cls-1"
          d="M229.24,69.95c-.71.47-1.49.93-2.34,1.38-2.11-2.07-4.29-4.06-6.53-5.97.76-.4,1.45-.81,2.09-1.23,2.32,1.86,4.58,3.8,6.77,5.83h0Z"
        />
      </clipPath>
      <clipPath id="clippath-88">
        <path
          className="cls-1"
          d="M226.91,71.33c.84-.45,1.62-.91,2.34-1.38,2.19,2.02,4.31,4.13,6.36,6.3-.78.51-1.64,1.02-2.57,1.51-1.98-2.22-4.02-4.37-6.13-6.44h0Z"
        />
      </clipPath>
      <clipPath id="clippath-89">
        <path
          className="cls-1"
          d="M233.04,77.76c.93-.49,1.78-1,2.57-1.51,2.05,2.17,4.02,4.42,5.92,6.74-.85.56-1.78,1.1-2.78,1.64-1.83-2.36-3.73-4.64-5.71-6.86h0Z"
        />
      </clipPath>
      <clipPath id="clippath-90">
        <path
          className="cls-1"
          d="M238.75,84.62c1-.54,1.93-1.08,2.78-1.64,1.9,2.32,3.72,4.7,5.47,7.15-.91.59-1.9,1.18-2.98,1.75-1.68-2.49-3.44-4.91-5.27-7.27h0Z"
        />
      </clipPath>
      <clipPath id="clippath-91">
        <path
          className="cls-1"
          d="M244.02,91.89c1.07-.57,2.07-1.16,2.98-1.75,1.74,2.45,3.4,4.96,4.97,7.53-.96.63-2.02,1.25-3.16,1.86-1.52-2.6-3.12-5.15-4.79-7.63h0Z"
        />
      </clipPath>
      <clipPath id="clippath-92">
        <path
          className="cls-1"
          d="M248.81,99.52c1.14-.61,2.19-1.23,3.16-1.86,1.57,2.57,3.06,5.19,4.45,7.87-1.01.66-2.12,1.31-3.32,1.95-1.34-2.71-2.78-5.36-4.29-7.96h0Z"
        />
      </clipPath>
      <clipPath id="clippath-93">
        <path
          className="cls-1"
          d="M253.1,107.49c1.2-.64,2.3-1.29,3.32-1.95,1.39,2.68,2.7,5.4,3.9,8.18-1.06.69-2.21,1.37-3.46,2.04-1.16-2.8-2.42-5.55-3.76-8.26h0Z"
        />
      </clipPath>
      <clipPath id="clippath-94">
        <path
          className="cls-1"
          d="M256.86,115.75c1.25-.67,2.4-1.35,3.46-2.04,1.21,2.77,2.32,5.59,3.33,8.45-1.09.71-2.29,1.42-3.58,2.11-.97-2.88-2.04-5.72-3.21-8.52h0Z"
        />
      </clipPath>
      <clipPath id="clippath-95">
        <path
          className="cls-1"
          d="M260.07,124.27c1.29-.69,2.49-1.39,3.58-2.11,1.01,2.86,1.92,5.76,2.72,8.69-1.12.73-2.35,1.46-3.68,2.17-.77-2.95-1.65-5.87-2.62-8.75h0Z"
        />
      </clipPath>
      <clipPath id="clippath-96">
        <path
          className="cls-1"
          d="M262.69,133.02c1.33-.71,2.55-1.43,3.68-2.17.8,2.93,1.5,5.9,2.09,8.9-1.15.75-2.4,1.49-3.75,2.21-.57-3.01-1.24-6-2.01-8.95h0Z"
        />
      </clipPath>
      <clipPath id="clippath-97">
        <path
          className="cls-1"
          d="M264.7,141.97c1.36-.72,2.61-1.46,3.75-2.21.59,3,1.06,6.03,1.42,9.08-1.16.76-2.43,1.51-3.81,2.24-.35-3.06-.81-6.1-1.37-9.11h0Z"
        />
      </clipPath>
      <clipPath id="clippath-98">
        <path
          className="cls-1"
          d="M266.08,151.08c1.37-.73,2.64-1.48,3.81-2.24.36,3.05.61,6.12.73,9.21-1.17.77-2.45,1.52-3.83,2.26-.12-3.09-.36-6.17-.71-9.23h0Z"
        />
      </clipPath>
      <clipPath id="clippath-99">
        <path
          className="cls-1"
          d="M266.78,160.3c1.38-.74,2.66-1.49,3.83-2.26.07,1.68.1,3.37.1,5.07,0,1.42-.03,2.83-.08,4.23-1.17.77-2.45,1.52-3.83,2.26.05-1.4.08-2.81.08-4.23,0-1.69-.03-3.38-.09-5.07h0Z"
        />
      </clipPath>
      <clipPath id="clippath-100">
        <path
          className="cls-1"
          d="M266.8,169.6c1.38-.74,2.66-1.49,3.83-2.26-.12,3.07-.35,6.09-.71,9.07-1.16.76-2.43,1.51-3.81,2.24.34-2.97.57-5.98.68-9.05h0Z"
        />
      </clipPath>
      <clipPath id="clippath-101">
        <path
          className="cls-1"
          d="M266.12,178.65c1.37-.73,2.65-1.48,3.81-2.24-.35,2.97-.82,5.89-1.4,8.76-1.15.75-2.4,1.49-3.76,2.21.56-2.85,1.01-5.77,1.35-8.73h0Z"
        />
      </clipPath>
      <clipPath id="clippath-102">
        <path
          className="cls-1"
          d="M226.91,71.33c-.84.45-1.75.89-2.72,1.32-2.02-2.11-4.1-4.15-6.24-6.11.87-.39,1.68-.78,2.44-1.18,2.24,1.91,4.41,3.9,6.53,5.97h0Z"
        />
      </clipPath>
      <clipPath id="clippath-103">
        <path
          className="cls-1"
          d="M224.19,72.65c.97-.43,1.88-.87,2.72-1.32,2.11,2.07,4.16,4.22,6.13,6.44-.93.49-1.92.98-2.99,1.45-1.89-2.26-3.85-4.45-5.87-6.57h0Z"
        />
      </clipPath>
      <clipPath id="clippath-104">
        <path
          className="cls-1"
          d="M230.05,79.22c1.06-.47,2.06-.96,2.99-1.45,1.97,2.22,3.88,4.51,5.71,6.86-1,.54-2.08,1.06-3.23,1.57-1.75-2.39-3.57-4.72-5.46-6.98h0Z"
        />
      </clipPath>
      <clipPath id="clippath-105">
        <path
          className="cls-1"
          d="M235.51,86.2c1.15-.51,2.23-1.04,3.23-1.57,1.83,2.36,3.59,4.78,5.27,7.27-1.07.57-2.23,1.14-3.46,1.68-1.61-2.52-3.29-4.98-5.04-7.38h0Z"
        />
      </clipPath>
      <clipPath id="clippath-106">
        <path
          className="cls-1"
          d="M240.55,93.58c1.23-.55,2.39-1.11,3.46-1.68,1.68,2.49,3.28,5.03,4.79,7.63-1.14.61-2.36,1.2-3.67,1.79-1.45-2.63-2.98-5.21-4.58-7.73h0Z"
        />
      </clipPath>
      <clipPath id="clippath-107">
        <path
          className="cls-1"
          d="M245.14,101.31c1.31-.58,2.53-1.18,3.67-1.79,1.52,2.6,2.95,5.26,4.29,7.96-1.2.64-2.48,1.27-3.86,1.88-1.29-2.73-2.66-5.42-4.11-8.05h0Z"
        />
      </clipPath>
      <clipPath id="clippath-108">
        <path
          className="cls-1"
          d="M249.24,109.36c1.38-.61,2.66-1.24,3.86-1.88,1.34,2.71,2.6,5.46,3.76,8.26-1.25.67-2.59,1.32-4.02,1.96-1.11-2.82-2.31-5.61-3.6-8.34h0Z"
        />
      </clipPath>
      <clipPath id="clippath-109">
        <path
          className="cls-1"
          d="M252.84,117.7c1.43-.64,2.78-1.29,4.02-1.96,1.16,2.8,2.23,5.64,3.21,8.52-1.29.69-2.68,1.36-4.16,2.03-.93-2.9-1.95-5.77-3.07-8.59h0Z"
        />
      </clipPath>
      <clipPath id="clippath-110">
        <path
          className="cls-1"
          d="M255.91,126.29c1.48-.66,2.87-1.34,4.16-2.03.97,2.88,1.85,5.8,2.62,8.75-1.33.71-2.75,1.4-4.28,2.08-.74-2.97-1.58-5.91-2.51-8.81h0Z"
        />
      </clipPath>
      <clipPath id="clippath-111">
        <path
          className="cls-1"
          d="M258.42,135.1c1.53-.68,2.95-1.37,4.28-2.08.77,2.95,1.45,5.94,2.01,8.95-1.35.72-2.81,1.43-4.37,2.12-.54-3.02-1.18-6.02-1.92-8.99h0Z"
        />
      </clipPath>
      <clipPath id="clippath-112">
        <path
          className="cls-1"
          d="M260.34,144.09c1.56-.69,3.01-1.4,4.37-2.12.57,3.01,1.02,6.05,1.37,9.11-1.37.73-2.85,1.45-4.43,2.15-.33-3.07-.77-6.11-1.31-9.14h0Z"
        />
      </clipPath>
      <clipPath id="clippath-113">
        <path
          className="cls-1"
          d="M261.65,153.23c1.58-.7,3.05-1.42,4.43-2.15.35,3.06.58,6.13.71,9.23-1.38.74-2.87,1.46-4.46,2.17-.12-3.1-.34-6.18-.67-9.24h0Z"
        />
      </clipPath>
      <clipPath id="clippath-114">
        <path
          className="cls-1"
          d="M262.32,162.47c1.59-.71,3.08-1.43,4.46-2.17.07,1.68.1,3.37.09,5.07,0,1.42-.03,2.83-.08,4.23-1.38.74-2.87,1.46-4.46,2.17.05-1.4.08-2.81.08-4.23,0-1.69-.03-3.38-.09-5.07h0Z"
        />
      </clipPath>
      <clipPath id="clippath-115">
        <path
          className="cls-1"
          d="M262.34,171.76c1.59-.71,3.08-1.43,4.46-2.17-.11,3.07-.34,6.09-.68,9.05-1.37.73-2.85,1.45-4.43,2.16.33-2.96.54-5.97.65-9.04h0Z"
        />
      </clipPath>
      <clipPath id="clippath-116">
        <path
          className="cls-1"
          d="M264.77,187.38c-1.36.72-2.81,1.43-4.37,2.13.53-2.84.97-5.75,1.29-8.7,1.58-.7,3.06-1.42,4.43-2.16-.34,2.97-.79,5.88-1.35,8.73h0Z"
        />
      </clipPath>
      <clipPath id="clippath-117">
        <path
          className="cls-1"
          d="M224.19,72.65c-.97.43-2,.85-3.1,1.26-1.91-2.16-3.89-4.24-5.92-6.24.98-.37,1.91-.75,2.77-1.13,2.14,1.96,4.22,4,6.24,6.11h0Z"
        />
      </clipPath>
      <clipPath id="clippath-118">
        <path
          className="cls-1"
          d="M221.09,73.91c1.09-.41,2.13-.83,3.1-1.26,2.02,2.11,3.98,4.31,5.87,6.57-1.07.47-2.2.94-3.4,1.39-1.79-2.3-3.65-4.53-5.56-6.69h0Z"
        />
      </clipPath>
      <clipPath id="clippath-119">
        <path
          className="cls-1"
          d="M226.65,80.6c1.2-.45,2.34-.91,3.4-1.39,1.89,2.26,3.71,4.59,5.46,6.98-1.15.51-2.38,1.02-3.69,1.5-1.66-2.43-3.39-4.8-5.18-7.1h0Z"
        />
      </clipPath>
      <clipPath id="clippath-120">
        <path
          className="cls-1"
          d="M231.83,87.7c1.3-.49,2.53-.99,3.69-1.5,1.75,2.4,3.43,4.86,5.04,7.38-1.24.55-2.55,1.09-3.95,1.61-1.52-2.55-3.12-5.05-4.78-7.49h0Z"
        />
      </clipPath>
      <clipPath id="clippath-121">
        <path
          className="cls-1"
          d="M236.61,95.19c1.39-.52,2.71-1.06,3.95-1.61,1.61,2.52,3.14,5.1,4.58,7.73-1.31.58-2.71,1.15-4.18,1.71-1.37-2.66-2.82-5.28-4.35-7.83h0Z"
        />
      </clipPath>
      <clipPath id="clippath-122">
        <path
          className="cls-1"
          d="M240.95,103.02c1.48-.56,2.87-1.13,4.18-1.71,1.45,2.63,2.82,5.32,4.11,8.05-1.38.61-2.84,1.21-4.4,1.8-1.22-2.76-2.52-5.48-3.89-8.14h0Z"
        />
      </clipPath>
      <clipPath id="clippath-123">
        <path
          className="cls-1"
          d="M244.84,111.16c1.55-.58,3.02-1.18,4.4-1.8,1.29,2.73,2.49,5.52,3.6,8.34-1.44.64-2.97,1.26-4.58,1.87-1.05-2.85-2.19-5.65-3.41-8.42h0Z"
        />
      </clipPath>
      <clipPath id="clippath-124">
        <path
          className="cls-1"
          d="M248.26,119.58c1.62-.61,3.15-1.23,4.58-1.87,1.11,2.82,2.14,5.69,3.07,8.59-1.49.66-3.07,1.31-4.74,1.94-.88-2.92-1.85-5.81-2.91-8.66h0Z"
        />
      </clipPath>
      <clipPath id="clippath-125">
        <path
          className="cls-1"
          d="M251.16,128.23c1.68-.63,3.26-1.28,4.74-1.94.93,2.9,1.77,5.84,2.51,8.81-1.53.68-3.15,1.34-4.87,1.99-.7-2.98-1.5-5.94-2.38-8.86h0Z"
        />
      </clipPath>
      <clipPath id="clippath-126">
        <path
          className="cls-1"
          d="M253.54,137.09c1.72-.65,3.35-1.31,4.87-1.99.74,2.97,1.38,5.97,1.92,8.99-1.56.69-3.22,1.37-4.97,2.03-.51-3.03-1.12-6.05-1.82-9.03h0Z"
        />
      </clipPath>
      <clipPath id="clippath-127">
        <path
          className="cls-1"
          d="M255.36,146.12c1.76-.66,3.42-1.34,4.97-2.03.54,3.02.98,6.07,1.31,9.14-1.58.7-3.26,1.39-5.04,2.06-.32-3.07-.73-6.13-1.24-9.17h0Z"
        />
      </clipPath>
      <clipPath id="clippath-128">
        <path
          className="cls-1"
          d="M256.61,155.29c1.78-.67,3.46-1.36,5.04-2.06.33,3.06.56,6.15.67,9.24-1.59.71-3.29,1.4-5.08,2.07-.11-3.1-.32-6.19-.64-9.26h0Z"
        />
      </clipPath>
      <clipPath id="clippath-129">
        <path
          className="cls-1"
          d="M257.24,164.54c1.79-.67,3.49-1.37,5.08-2.07.06,1.69.09,3.38.09,5.07,0,1.42-.03,2.83-.08,4.23-1.59.71-3.29,1.4-5.08,2.07.05-1.4.07-2.8.07-4.22,0-1.69-.03-3.38-.08-5.07h0Z"
        />
      </clipPath>
      <clipPath id="clippath-130">
        <path
          className="cls-1"
          d="M261.68,180.8c-1.58.7-3.26,1.39-5.05,2.06.31-2.95.52-5.96.62-9.02,1.79-.67,3.49-1.37,5.08-2.07-.11,3.07-.33,6.08-.65,9.04h0Z"
        />
      </clipPath>
      <clipPath id="clippath-131">
        <path
          className="cls-1"
          d="M215.17,67.67c-.98.37-2.02.73-3.1,1.07-1.91-2.04-3.86-4.01-5.87-5.89.95-.3,1.86-.62,2.72-.94,2.14,1.83,4.22,3.76,6.25,5.76h0Z"
        />
      </clipPath>
      <clipPath id="clippath-132">
        <path
          className="cls-1"
          d="M212.07,68.74c1.09-.35,2.12-.71,3.1-1.07,2.03,2,4,4.08,5.92,6.24-1.09.41-2.25.81-3.47,1.2-1.8-2.2-3.65-4.32-5.56-6.37h0Z"
        />
      </clipPath>
      <clipPath id="clippath-133">
        <path
          className="cls-1"
          d="M217.62,75.11c1.22-.39,2.37-.79,3.47-1.2,1.91,2.16,3.77,4.39,5.56,6.69-1.2.45-2.47.89-3.81,1.32-1.68-2.34-3.42-4.61-5.22-6.81h0Z"
        />
      </clipPath>
      <clipPath id="clippath-134">
        <path
          className="cls-1"
          d="M222.85,81.92c1.33-.43,2.6-.86,3.81-1.32,1.79,2.3,3.52,4.67,5.18,7.1-1.3.49-2.68.96-4.12,1.43-1.56-2.47-3.18-4.87-4.86-7.21h0Z"
        />
      </clipPath>
      <clipPath id="clippath-135">
        <path
          className="cls-1"
          d="M227.71,89.13c1.45-.46,2.82-.94,4.12-1.43,1.66,2.43,3.26,4.93,4.78,7.49-1.39.52-2.87,1.03-4.41,1.53-1.43-2.59-2.93-5.12-4.49-7.59h0Z"
        />
      </clipPath>
      <clipPath id="clippath-136">
        <path
          className="cls-1"
          d="M232.19,96.72c1.55-.49,3.02-1,4.41-1.53,1.52,2.55,2.97,5.17,4.35,7.83-1.48.56-3.04,1.1-4.68,1.62-1.29-2.69-2.65-5.34-4.08-7.92h0Z"
        />
      </clipPath>
      <clipPath id="clippath-137">
        <path
          className="cls-1"
          d="M236.27,104.64c1.64-.52,3.2-1.06,4.68-1.62,1.37,2.66,2.67,5.38,3.89,8.14-1.55.58-3.19,1.15-4.92,1.7-1.14-2.79-2.36-5.53-3.65-8.22h0Z"
        />
      </clipPath>
      <clipPath id="clippath-138">
        <path
          className="cls-1"
          d="M239.93,112.86c1.73-.55,3.37-1.12,4.92-1.7,1.22,2.76,2.36,5.57,3.41,8.42-1.62.61-3.33,1.2-5.13,1.77-.99-2.87-2.06-5.7-3.2-8.49h0Z"
        />
      </clipPath>
      <clipPath id="clippath-139">
        <path
          className="cls-1"
          d="M243.13,121.35c1.8-.57,3.51-1.17,5.13-1.77,1.05,2.85,2.02,5.73,2.91,8.66-1.68.63-3.45,1.24-5.31,1.84-.83-2.94-1.74-5.85-2.73-8.72h0Z"
        />
      </clipPath>
      <clipPath id="clippath-140">
        <path
          className="cls-1"
          d="M245.86,130.07c1.86-.59,3.63-1.21,5.31-1.84.88,2.92,1.68,5.88,2.38,8.86-1.72.65-3.54,1.28-5.45,1.89-.66-3-1.4-5.97-2.23-8.91h0Z"
        />
      </clipPath>
      <clipPath id="clippath-141">
        <path
          className="cls-1"
          d="M248.09,138.98c1.91-.61,3.73-1.24,5.45-1.89.7,2.98,1.31,6,1.82,9.03-1.76.66-3.61,1.3-5.57,1.92-.48-3.05-1.05-6.07-1.71-9.07h0Z"
        />
      </clipPath>
      <clipPath id="clippath-142">
        <path
          className="cls-1"
          d="M249.8,148.05c1.95-.62,3.81-1.26,5.57-1.92.51,3.03.93,6.09,1.24,9.17-1.78.67-3.66,1.32-5.64,1.95-.3-3.08-.69-6.15-1.17-9.19h0Z"
        />
      </clipPath>
      <clipPath id="clippath-143">
        <path
          className="cls-1"
          d="M250.96,157.24c1.98-.63,3.86-1.28,5.64-1.95.31,3.07.53,6.16.64,9.26-1.79.67-3.69,1.33-5.68,1.97-.1-3.1-.3-6.19-.6-9.27h0Z"
        />
      </clipPath>
      <clipPath id="clippath-144">
        <path
          className="cls-1"
          d="M251.56,166.51c1.99-.64,3.89-1.29,5.68-1.97.06,1.69.09,3.38.08,5.07,0,1.42-.03,2.83-.07,4.22-1.79.67-3.69,1.33-5.68,1.97.04-1.4.07-2.8.07-4.22,0-1.69-.02-3.38-.08-5.07h0Z"
        />
      </clipPath>
      <clipPath id="clippath-145">
        <path
          className="cls-1"
          d="M251.57,175.8c1.99-.64,3.89-1.29,5.68-1.97-.1,3.06-.31,6.07-.62,9.02-1.78.67-3.67,1.32-5.65,1.95.29-2.95.49-5.95.58-9.01h0Z"
        />
      </clipPath>
      <clipPath id="clippath-146">
        <path
          className="cls-1"
          d="M250.99,184.82c1.98-.63,3.86-1.28,5.65-1.95-.31,2.95-.72,5.85-1.22,8.68-1.76.66-3.62,1.3-5.57,1.93.48-2.82.86-5.71,1.15-8.65h0Z"
        />
      </clipPath>
      <clipPath id="clippath-147">
        <path
          className="cls-1"
          d="M253.61,199.85c-1.73.65-3.55,1.28-5.46,1.89.65-2.69,1.22-5.45,1.7-8.27,1.95-.62,3.81-1.27,5.57-1.93-.51,2.83-1.11,5.6-1.81,8.3h0Z"
        />
      </clipPath>
      <clipPath id="clippath-148">
        <path
          className="cls-1"
          d="M203.2,63.74c1.05-.28,2.05-.58,3-.88,2,1.88,3.96,3.85,5.87,5.89-1.09.35-2.23.68-3.43,1.01-1.77-2.09-3.58-4.09-5.45-6.01h0Z"
        />
      </clipPath>
      <clipPath id="clippath-149">
        <path
          className="cls-1"
          d="M208.64,69.75c1.19-.32,2.34-.66,3.43-1.01,1.91,2.04,3.76,4.17,5.56,6.37-1.22.39-2.49.76-3.82,1.13-1.67-2.24-3.39-4.4-5.16-6.48h0Z"
        />
      </clipPath>
      <clipPath id="clippath-150">
        <path
          className="cls-1"
          d="M213.8,76.24c1.33-.36,2.61-.74,3.82-1.13,1.8,2.2,3.54,4.47,5.22,6.81-1.33.43-2.74.84-4.2,1.24-1.56-2.38-3.18-4.68-4.85-6.92h0Z"
        />
      </clipPath>
      <clipPath id="clippath-151">
        <path
          className="cls-1"
          d="M218.65,83.16c1.46-.4,2.87-.81,4.2-1.24,1.68,2.34,3.3,4.74,4.86,7.21-1.45.46-2.96.91-4.55,1.34-1.45-2.5-2.95-4.94-4.51-7.31h0Z"
        />
      </clipPath>
      <clipPath id="clippath-152">
        <path
          className="cls-1"
          d="M223.16,90.47c1.59-.43,3.1-.88,4.55-1.34,1.56,2.47,3.06,5,4.49,7.59-1.55.49-3.17.97-4.87,1.43-1.33-2.62-2.72-5.18-4.16-7.68h0Z"
        />
      </clipPath>
      <clipPath id="clippath-153">
        <path
          className="cls-1"
          d="M227.32,98.15c1.7-.46,3.32-.94,4.87-1.43,1.43,2.59,2.79,5.23,4.08,7.92-1.64.52-3.36,1.03-5.17,1.52-1.2-2.72-2.46-5.39-3.79-8.01h0Z"
        />
      </clipPath>
      <clipPath id="clippath-154">
        <path
          className="cls-1"
          d="M231.11,106.16c1.8-.49,3.52-1,5.17-1.52,1.29,2.69,2.51,5.44,3.65,8.22-1.73.55-3.54,1.08-5.43,1.6-1.06-2.81-2.19-5.58-3.39-8.3h0Z"
        />
      </clipPath>
      <clipPath id="clippath-155">
        <path
          className="cls-1"
          d="M234.5,114.46c1.89-.51,3.7-1.05,5.43-1.6,1.14,2.79,2.21,5.62,3.2,8.49-1.8.57-3.69,1.13-5.66,1.67-.92-2.89-1.91-5.74-2.97-8.56h0Z"
        />
      </clipPath>
      <clipPath id="clippath-156">
        <path
          className="cls-1"
          d="M237.47,123.01c1.97-.54,3.86-1.09,5.66-1.67.99,2.87,1.9,5.78,2.73,8.72-1.86.59-3.81,1.17-5.86,1.72-.77-2.96-1.61-5.88-2.53-8.78h0Z"
        />
      </clipPath>
      <clipPath id="clippath-157">
        <path
          className="cls-1"
          d="M240,131.79c2.04-.55,4-1.13,5.86-1.72.83,2.94,1.57,5.91,2.23,8.91-1.91.61-3.92,1.2-6.02,1.77-.61-3.01-1.3-6-2.07-8.96h0Z"
        />
      </clipPath>
      <clipPath id="clippath-158">
        <path
          className="cls-1"
          d="M242.07,140.75c2.1-.57,4.11-1.16,6.02-1.77.66,3,1.23,6.02,1.71,9.07-1.95.62-4,1.23-6.14,1.81-.45-3.06-.98-6.09-1.59-9.11h0Z"
        />
      </clipPath>
      <clipPath id="clippath-159">
        <path
          className="cls-1"
          d="M243.66,149.85c2.14-.58,4.19-1.18,6.14-1.81.48,3.05.87,6.11,1.17,9.19-1.98.63-4.06,1.24-6.23,1.83-.27-3.09-.64-6.16-1.08-9.22h0Z"
        />
      </clipPath>
      <clipPath id="clippath-160">
        <path
          className="cls-1"
          d="M244.74,159.07c2.17-.59,4.25-1.2,6.23-1.83.3,3.08.5,6.17.6,9.27-1.99.64-4.08,1.25-6.27,1.85-.09-3.1-.28-6.2-.55-9.28h0Z"
        />
      </clipPath>
      <clipPath id="clippath-161">
        <path
          className="cls-1"
          d="M245.29,168.35c2.19-.59,4.28-1.21,6.27-1.85.06,1.69.08,3.38.08,5.07,0,1.42-.03,2.83-.07,4.22-1.99.64-4.08,1.25-6.27,1.85.04-1.4.06-2.8.07-4.22,0-1.69-.02-3.39-.07-5.08h0Z"
        />
      </clipPath>
      <clipPath id="clippath-162">
        <path
          className="cls-1"
          d="M245.3,177.65c2.19-.59,4.28-1.21,6.27-1.85-.1,3.06-.29,6.07-.58,9.01-1.98.63-4.06,1.24-6.23,1.83.27-2.94.45-5.94.54-9h0Z"
        />
      </clipPath>
      <clipPath id="clippath-163">
        <path
          className="cls-1"
          d="M244.76,186.65c2.17-.59,4.25-1.2,6.23-1.83-.29,2.95-.68,5.83-1.15,8.65-1.95.62-4.01,1.23-6.15,1.81.44-2.81.8-5.69,1.07-8.63h0Z"
        />
      </clipPath>
      <clipPath id="clippath-164">
        <path
          className="cls-1"
          d="M248.14,201.74c-1.92.61-3.93,1.2-6.03,1.77.61-2.68,1.13-5.42,1.58-8.23,2.14-.58,4.2-1.19,6.15-1.81-.48,2.82-1.04,5.58-1.7,8.27h0Z"
        />
      </clipPath>
      <clipPath id="clippath-165">
        <path
          className="cls-1"
          d="M208.64,69.75c-1.19.32-2.44.64-3.74.94-1.62-2.12-3.28-4.17-4.99-6.13,1.14-.26,2.23-.54,3.28-.82,1.86,1.92,3.68,3.93,5.45,6.01h0Z"
        />
      </clipPath>
      <clipPath id="clippath-166">
        <path
          className="cls-1"
          d="M204.9,70.69c1.3-.3,2.54-.61,3.74-.94,1.77,2.09,3.49,4.25,5.16,6.48-1.33.36-2.73.71-4.17,1.05-1.53-2.27-3.1-4.47-4.72-6.59h0Z"
        />
      </clipPath>
      <clipPath id="clippath-167">
        <path
          className="cls-1"
          d="M209.62,77.28c1.45-.33,2.84-.68,4.17-1.05,1.67,2.24,3.29,4.54,4.85,6.92-1.46.4-2.99.78-4.58,1.15-1.43-2.41-2.91-4.75-4.44-7.02h0Z"
        />
      </clipPath>
      <clipPath id="clippath-168">
        <path
          className="cls-1"
          d="M214.06,84.3c1.59-.37,3.12-.75,4.58-1.15,1.56,2.37,3.06,4.81,4.51,7.31-1.59.43-3.24.85-4.97,1.24-1.32-2.53-2.7-5-4.13-7.41h0Z"
        />
      </clipPath>
      <clipPath id="clippath-169">
        <path
          className="cls-1"
          d="M218.19,91.71c1.72-.4,3.38-.81,4.97-1.24,1.45,2.5,2.84,5.06,4.16,7.68-1.7.46-3.47.91-5.32,1.33-1.21-2.65-2.49-5.24-3.81-7.77h0Z"
        />
      </clipPath>
      <clipPath id="clippath-170">
        <path
          className="cls-1"
          d="M222,99.48c1.85-.43,3.62-.87,5.32-1.33,1.33,2.62,2.59,5.29,3.79,8.01-1.8.49-3.68.96-5.64,1.41-1.1-2.75-2.25-5.44-3.47-8.09h0Z"
        />
      </clipPath>
      <clipPath id="clippath-171">
        <path
          className="cls-1"
          d="M225.47,107.57c1.96-.45,3.84-.92,5.64-1.41,1.2,2.72,2.33,5.49,3.39,8.3-1.89.51-3.87,1.01-5.93,1.48-.97-2.83-2.01-5.63-3.1-8.37h0Z"
        />
      </clipPath>
      <clipPath id="clippath-172">
        <path
          className="cls-1"
          d="M228.57,115.94c2.06-.47,4.03-.97,5.93-1.48,1.06,2.81,2.05,5.67,2.97,8.56-1.97.54-4.03,1.05-6.18,1.55-.84-2.91-1.75-5.78-2.72-8.62h0Z"
        />
      </clipPath>
      <clipPath id="clippath-173">
        <path
          className="cls-1"
          d="M231.29,124.56c2.14-.49,4.2-1.01,6.18-1.55.92,2.89,1.76,5.82,2.53,8.78-2.04.55-4.17,1.09-6.39,1.6-.7-2.97-1.48-5.92-2.32-8.83h0Z"
        />
      </clipPath>
      <clipPath id="clippath-174">
        <path
          className="cls-1"
          d="M233.61,133.39c2.22-.51,4.35-1.05,6.39-1.6.77,2.96,1.46,5.95,2.07,8.96-2.1.57-4.29,1.12-6.57,1.64-.56-3.03-1.19-6.03-1.89-9h0Z"
        />
      </clipPath>
      <clipPath id="clippath-175">
        <path
          className="cls-1"
          d="M235.5,142.39c2.28-.53,4.47-1.07,6.57-1.64.61,3.01,1.14,6.05,1.59,9.11-2.14.58-4.38,1.14-6.7,1.68-.41-3.07-.89-6.11-1.45-9.14h0Z"
        />
      </clipPath>
      <clipPath id="clippath-176">
        <path
          className="cls-1"
          d="M236.95,151.53c2.33-.54,4.56-1.1,6.7-1.68.45,3.06.81,6.13,1.08,9.22-2.17.59-4.44,1.16-6.8,1.7-.25-3.09-.58-6.18-.99-9.24h0Z"
        />
      </clipPath>
      <clipPath id="clippath-177">
        <path
          className="cls-1"
          d="M237.94,160.77c2.36-.54,4.63-1.11,6.8-1.7.27,3.08.46,6.18.55,9.28-2.19.59-4.47,1.17-6.84,1.71-.09-3.1-.26-6.2-.51-9.29h0Z"
        />
      </clipPath>
      <clipPath id="clippath-178">
        <path
          className="cls-1"
          d="M238.45,170.07c2.38-.55,4.66-1.12,6.84-1.71.05,1.69.08,3.38.07,5.08,0,1.42-.02,2.83-.07,4.22-2.19.59-4.47,1.17-6.85,1.71.04-1.39.06-2.8.06-4.22,0-1.69-.02-3.39-.07-5.08h0Z"
        />
      </clipPath>
      <clipPath id="clippath-179">
        <path
          className="cls-1"
          d="M244.76,186.65c-2.17.59-4.44,1.16-6.8,1.7.25-2.93.41-5.93.5-8.99,2.38-.55,4.66-1.12,6.85-1.71-.09,3.06-.27,6.06-.54,9h0Z"
        />
      </clipPath>
      <clipPath id="clippath-180">
        <path
          className="cls-1"
          d="M209.62,77.28c-1.45.33-2.95.65-4.52.96-1.38-2.3-2.79-4.54-4.25-6.69,1.4-.27,2.75-.56,4.04-.86,1.62,2.12,3.19,4.32,4.72,6.59h0Z"
        />
      </clipPath>
      <clipPath id="clippath-181">
        <path
          className="cls-1"
          d="M205.11,78.24c1.56-.3,3.07-.62,4.52-.96,1.53,2.27,3.01,4.61,4.44,7.02-1.59.37-3.24.72-4.96,1.05-1.29-2.44-2.62-4.81-3.99-7.12h0Z"
        />
      </clipPath>
      <clipPath id="clippath-182">
        <path
          className="cls-1"
          d="M209.1,85.36c1.71-.33,3.37-.68,4.96-1.05,1.43,2.41,2.81,4.88,4.13,7.41-1.72.4-3.51.78-5.37,1.14-1.19-2.56-2.43-5.06-3.72-7.49h0Z"
        />
      </clipPath>
      <clipPath id="clippath-183">
        <path
          className="cls-1"
          d="M212.82,92.85c1.86-.36,3.65-.74,5.37-1.14,1.33,2.53,2.6,5.13,3.81,7.77-1.85.43-3.76.83-5.75,1.22-1.09-2.67-2.24-5.29-3.43-7.85h0Z"
        />
      </clipPath>
      <clipPath id="clippath-184">
        <path
          className="cls-1"
          d="M216.25,100.7c1.99-.39,3.91-.79,5.75-1.22,1.21,2.65,2.37,5.34,3.47,8.09-1.96.45-3.99.88-6.1,1.29-.99-2.77-2.03-5.49-3.12-8.16h0Z"
        />
      </clipPath>
      <clipPath id="clippath-185">
        <path
          className="cls-1"
          d="M219.37,108.86c2.11-.41,4.14-.84,6.1-1.29,1.1,2.75,2.13,5.54,3.1,8.37-2.06.47-4.19.93-6.41,1.36-.87-2.85-1.81-5.67-2.79-8.44h0Z"
        />
      </clipPath>
      <clipPath id="clippath-186">
        <path
          className="cls-1"
          d="M222.16,117.3c2.22-.43,4.35-.89,6.41-1.36.97,2.83,1.88,5.71,2.72,8.62-2.14.49-4.37.97-6.68,1.42-.76-2.93-1.57-5.82-2.45-8.68h0Z"
        />
      </clipPath>
      <clipPath id="clippath-187">
        <path
          className="cls-1"
          d="M224.61,125.98c2.31-.45,4.54-.92,6.68-1.42.84,2.91,1.61,5.86,2.32,8.83-2.22.51-4.52,1-6.92,1.47-.63-2.99-1.33-5.95-2.08-8.88h0Z"
        />
      </clipPath>
      <clipPath id="clippath-188">
        <path
          className="cls-1"
          d="M226.69,134.86c2.39-.47,4.7-.95,6.92-1.47.7,2.97,1.34,5.98,1.89,9-2.28.53-4.65,1.03-7.11,1.51-.5-3.04-1.07-6.05-1.7-9.04h0Z"
        />
      </clipPath>
      <clipPath id="clippath-189">
        <path
          className="cls-1"
          d="M228.4,143.9c2.46-.48,4.83-.98,7.11-1.51.56,3.03,1.04,6.07,1.45,9.14-2.33.54-4.75,1.05-7.25,1.54-.37-3.07-.8-6.13-1.31-9.17h0Z"
        />
      </clipPath>
      <clipPath id="clippath-190">
        <path
          className="cls-1"
          d="M229.7,153.07c2.51-.49,4.93-1,7.25-1.54.41,3.07.74,6.15.99,9.24-2.36.54-4.81,1.06-7.35,1.56-.22-3.1-.52-6.19-.89-9.26h0Z"
        />
      </clipPath>
      <clipPath id="clippath-191">
        <path
          className="cls-1"
          d="M230.59,162.33c2.54-.49,4.99-1.02,7.35-1.56.25,3.09.42,6.19.51,9.29-2.38.55-4.84,1.07-7.4,1.57-.08-3.11-.23-6.21-.45-9.31h0Z"
        />
      </clipPath>
      <clipPath id="clippath-192">
        <path
          className="cls-1"
          d="M231.04,171.64c2.56-.5,5.03-1.02,7.4-1.57.05,1.69.07,3.38.07,5.08,0,1.42-.02,2.83-.06,4.22-2.38.55-4.85,1.07-7.41,1.57.03-1.39.05-2.8.06-4.22,0-1.69-.02-3.39-.06-5.08h0Z"
        />
      </clipPath>
      <clipPath id="clippath-193">
        <path
          className="cls-1"
          d="M237.96,188.35c-2.36.54-4.81,1.07-7.36,1.56.22-2.93.37-5.92.45-8.98,2.56-.5,5.03-1.02,7.41-1.57-.08,3.06-.25,6.06-.5,8.99h0Z"
        />
      </clipPath>
      <clipPath id="clippath-194">
        <path
          className="cls-1"
          d="M212.82,92.85c-1.86.36-3.78.7-5.77,1.03-1.05-2.58-2.14-5.11-3.27-7.57,1.83-.3,3.61-.61,5.33-.95,1.29,2.44,2.52,4.94,3.72,7.49h0Z"
        />
      </clipPath>
      <clipPath id="clippath-195">
        <path
          className="cls-1"
          d="M207.05,93.88c1.99-.32,3.91-.67,5.77-1.03,1.19,2.56,2.34,5.18,3.43,7.85-1.99.39-4.05.75-6.18,1.1-.96-2.69-1.97-5.34-3.02-7.92h0Z"
        />
      </clipPath>
      <clipPath id="clippath-196">
        <path
          className="cls-1"
          d="M210.07,101.8c2.13-.35,4.19-.71,6.18-1.1,1.09,2.67,2.13,5.39,3.12,8.16-2.11.41-4.29.8-6.55,1.17-.87-2.79-1.79-5.53-2.75-8.23h0Z"
        />
      </clipPath>
      <clipPath id="clippath-197">
        <path
          className="cls-1"
          d="M212.82,110.03c2.26-.37,4.44-.76,6.55-1.17.99,2.77,1.92,5.58,2.79,8.44-2.22.43-4.51.84-6.88,1.23-.77-2.87-1.59-5.71-2.46-8.5h0Z"
        />
      </clipPath>
      <clipPath id="clippath-198">
        <path
          className="cls-1"
          d="M215.28,118.53c2.37-.39,4.67-.79,6.88-1.23.87,2.85,1.69,5.75,2.45,8.68-2.31.45-4.7.88-7.18,1.28-.67-2.94-1.39-5.86-2.15-8.73h0Z"
        />
      </clipPath>
      <clipPath id="clippath-199">
        <path
          className="cls-1"
          d="M217.43,127.26c2.47-.4,4.87-.83,7.18-1.28.76,2.93,1.45,5.89,2.08,8.88-2.39.47-4.87.91-7.43,1.32-.56-3-1.17-5.98-1.83-8.92h0Z"
        />
      </clipPath>
      <clipPath id="clippath-200">
        <path
          className="cls-1"
          d="M219.27,136.18c2.56-.42,5.03-.86,7.43-1.32.63,2.99,1.2,6.01,1.7,9.04-2.46.48-5,.93-7.63,1.36-.44-3.05-.94-6.08-1.5-9.08h0Z"
        />
      </clipPath>
      <clipPath id="clippath-201">
        <path
          className="cls-1"
          d="M220.77,145.26c2.63-.43,5.17-.88,7.63-1.36.5,3.04.94,6.1,1.31,9.17-2.51.49-5.1.95-7.79,1.39-.32-3.08-.71-6.15-1.15-9.2h0Z"
        />
      </clipPath>
      <clipPath id="clippath-202">
        <path
          className="cls-1"
          d="M221.91,154.46c2.68-.44,5.28-.9,7.79-1.39.37,3.07.66,6.16.89,9.26-2.54.49-5.17.96-7.89,1.41-.2-3.1-.46-6.2-.78-9.28h0Z"
        />
      </clipPath>
      <clipPath id="clippath-203">
        <path
          className="cls-1"
          d="M222.69,163.74c2.72-.44,5.35-.91,7.89-1.41.22,3.09.38,6.2.45,9.31-2.56.5-5.21.97-7.95,1.42-.07-3.11-.2-6.22-.4-9.32h0Z"
        />
      </clipPath>
      <clipPath id="clippath-204">
        <path
          className="cls-1"
          d="M223.09,173.05c2.74-.44,5.39-.92,7.95-1.42.04,1.69.06,3.39.06,5.08,0,1.42-.02,2.82-.06,4.22-2.56.5-5.21.97-7.95,1.42.03-1.39.05-2.8.05-4.22,0-1.69-.01-3.39-.05-5.08h0Z"
        />
      </clipPath>
      <clipPath id="clippath-205">
        <path
          className="cls-1"
          d="M223.09,182.35c2.74-.45,5.39-.92,7.95-1.42-.08,3.06-.23,6.05-.45,8.98-2.54.5-5.18.96-7.9,1.41.2-2.92.33-5.92.4-8.97h0Z"
        />
      </clipPath>
      <clipPath id="clippath-206">
        <path
          className="cls-1"
          d="M229.71,198.5c-2.51.49-5.11.95-7.8,1.39.32-2.79.58-5.64.78-8.57,2.72-.44,5.36-.91,7.9-1.41-.22,2.93-.52,5.79-.88,8.58h0Z"
        />
      </clipPath>
      <clipPath id="clippath-207">
        <path
          className="cls-1"
          d="M207.05,93.88c-1.88.31-3.82.59-5.82.86-.11.02-.22.03-.34.04-.9-2.61-1.83-5.15-2.8-7.64.1-.01.21-.03.31-.04,1.84-.25,3.63-.51,5.37-.8,1.13,2.46,2.22,4.99,3.27,7.57h0Z"
        />
      </clipPath>
      <clipPath id="clippath-208">
        <path
          className="cls-1"
          d="M200.9,94.78c.11-.01.22-.03.34-.04,2-.27,3.94-.56,5.82-.86,1.05,2.59,2.06,5.23,3.02,7.92-2.02.33-4.09.64-6.23.92-.12.02-.24.03-.36.05-.82-2.71-1.69-5.38-2.58-7.99h0Z"
        />
      </clipPath>
      <clipPath id="clippath-209">
        <path
          className="cls-1"
          d="M203.48,102.77c.12-.02.24-.03.36-.05,2.14-.29,4.21-.6,6.23-.92.96,2.69,1.88,5.44,2.75,8.23-2.14.35-4.34.67-6.61.98-.13.02-.25.03-.38.05-.74-2.81-1.53-5.57-2.35-8.29h0Z"
        />
      </clipPath>
      <clipPath id="clippath-210">
        <path
          className="cls-1"
          d="M205.83,111.06c.13-.02.25-.03.38-.05,2.27-.3,4.47-.63,6.61-.98.87,2.79,1.69,5.62,2.46,8.5-2.25.36-4.56.71-6.94,1.03-.13.02-.27.04-.4.05-.66-2.89-1.36-5.74-2.1-8.55h0Z"
        />
      </clipPath>
      <clipPath id="clippath-211">
        <path
          className="cls-1"
          d="M207.93,119.61c.13-.02.27-.04.4-.05,2.38-.32,4.7-.66,6.94-1.03.77,2.87,1.49,5.78,2.15,8.73-2.34.38-4.75.74-7.24,1.07-.14.02-.28.04-.42.06-.57-2.96-1.18-5.89-1.84-8.77h0Z"
        />
      </clipPath>
      <clipPath id="clippath-212">
        <path
          className="cls-1"
          d="M209.78,128.38c.14-.02.28-.04.42-.06,2.48-.33,4.9-.69,7.24-1.07.67,2.94,1.28,5.92,1.83,8.92-2.42.39-4.92.76-7.49,1.11-.14.02-.29.04-.43.06-.48-3.01-1-6-1.57-8.96h0Z"
        />
      </clipPath>
      <clipPath id="clippath-213">
        <path
          className="cls-1"
          d="M211.34,137.35c.14-.02.29-.04.43-.06,2.57-.35,5.07-.72,7.49-1.11.56,3,1.06,6.03,1.5,9.08-2.49.4-5.06.78-7.7,1.14-.15.02-.3.04-.44.06-.38-3.06-.81-6.1-1.28-9.11h0Z"
        />
      </clipPath>
      <clipPath id="clippath-214">
        <path
          className="cls-1"
          d="M212.63,146.46c.15-.02.3-.04.44-.06,2.64-.36,5.21-.74,7.7-1.14.44,3.05.83,6.12,1.15,9.2-2.54.41-5.16.8-7.85,1.16-.15.02-.3.04-.45.06-.28-3.09-.6-6.17-.98-9.22h0Z"
        />
      </clipPath>
      <clipPath id="clippath-215">
        <path
          className="cls-1"
          d="M213.61,155.68c.15-.02.3-.04.45-.06,2.69-.36,5.31-.75,7.85-1.16.32,3.08.58,6.18.78,9.28-2.58.42-5.23.81-7.96,1.18-.15.02-.31.04-.46.06-.17-3.11-.39-6.21-.67-9.3h0Z"
        />
      </clipPath>
      <clipPath id="clippath-216">
        <path
          className="cls-1"
          d="M214.27,164.98c.15-.02.31-.04.46-.06,2.73-.37,5.39-.76,7.96-1.18.2,3.1.33,6.21.4,9.32-2.59.42-5.27.82-8.02,1.19-.15.02-.31.04-.46.06-.06-3.11-.17-6.22-.34-9.32h0Z"
        />
      </clipPath>
      <clipPath id="clippath-217">
        <path
          className="cls-1"
          d="M214.61,174.3c.15-.02.31-.04.46-.06,2.75-.37,5.42-.77,8.02-1.19.04,1.69.05,3.39.05,5.08,0,1.42-.02,2.82-.05,4.22-2.6.42-5.27.82-8.02,1.19-.15.02-.31.04-.46.06.03-1.39.04-2.8.04-4.22,0-1.69-.01-3.39-.04-5.08h0Z"
        />
      </clipPath>
      <clipPath id="clippath-218">
        <path
          className="cls-1"
          d="M214.61,183.6c.15-.02.31-.04.46-.06,2.75-.37,5.43-.77,8.02-1.19-.07,3.05-.2,6.05-.4,8.97-2.58.42-5.24.81-7.97,1.18-.15.02-.31.04-.46.06.17-2.92.28-5.91.34-8.96h0Z"
        />
      </clipPath>
      <clipPath id="clippath-219">
        <path
          className="cls-1"
          d="M214.26,192.56c.15-.02.31-.04.46-.06,2.73-.37,5.39-.76,7.97-1.18-.2,2.92-.46,5.78-.78,8.57-2.54.41-5.17.8-7.87,1.16-.15.02-.3.04-.45.06.28-2.78.5-5.63.67-8.55h0Z"
        />
      </clipPath>
      <clipPath id="clippath-220">
        <path
          className="cls-1"
          d="M220.76,208.03c-2.49.41-5.07.79-7.71,1.14-.15.02-.3.04-.45.06.38-2.63.71-5.34.99-8.12.15-.02.3-.04.45-.06,2.7-.36,5.32-.75,7.87-1.16-.32,2.79-.71,5.5-1.15,8.14h0Z"
        />
      </clipPath>
      <clipPath id="clippath-221">
        <path
          className="cls-1"
          d="M219.26,215.72c-2.43.39-4.93.77-7.51,1.11-.14.02-.29.04-.43.06.48-2.48.91-5.03,1.29-7.66.15-.02.3-.04.45-.06,2.65-.36,5.22-.74,7.71-1.14-.44,2.64-.94,5.21-1.5,7.69h0Z"
        />
      </clipPath>
      <clipPath id="clippath-222">
        <path
          className="cls-1"
          d="M203.48,102.77c-2.26.3-4.54.57-6.84.82-.68-2.73-1.39-5.41-2.13-8.04,2.15-.23,4.28-.48,6.39-.76.9,2.61,1.76,5.27,2.58,7.99h0Z"
        />
      </clipPath>
      <clipPath id="clippath-223">
        <path
          className="cls-1"
          d="M196.63,103.59c2.3-.24,4.59-.52,6.84-.82.82,2.71,1.61,5.48,2.35,8.29-2.4.32-4.82.61-7.26.87-.61-2.82-1.26-5.61-1.94-8.34h0Z"
        />
      </clipPath>
      <clipPath id="clippath-224">
        <path
          className="cls-1"
          d="M198.57,111.92c2.44-.26,4.86-.55,7.26-.87.74,2.81,1.44,5.66,2.1,8.55-2.52.33-5.06.64-7.63.91-.54-2.9-1.12-5.77-1.73-8.59h0Z"
        />
      </clipPath>
      <clipPath id="clippath-225">
        <path
          className="cls-1"
          d="M200.31,120.52c2.56-.27,5.11-.57,7.63-.91.66,2.89,1.27,5.82,1.84,8.77-2.63.35-5.28.66-7.95.95-.47-2.97-.98-5.91-1.52-8.81h0Z"
        />
      </clipPath>
      <clipPath id="clippath-226">
        <path
          className="cls-1"
          d="M201.82,129.33c2.67-.28,5.33-.6,7.95-.95.57,2.96,1.09,5.95,1.57,8.96-2.72.36-5.46.69-8.23.98-.39-3.02-.82-6.02-1.29-8.99h0Z"
        />
      </clipPath>
      <clipPath id="clippath-227">
        <path
          className="cls-1"
          d="M203.12,138.33c2.77-.29,5.51-.62,8.23-.98.48,3.01.9,6.05,1.28,9.11-2.79.37-5.61.71-8.45,1.01-.31-3.07-.66-6.11-1.05-9.14h0Z"
        />
      </clipPath>
      <clipPath id="clippath-228">
        <path
          className="cls-1"
          d="M204.17,147.47c2.84-.3,5.66-.64,8.45-1.01.38,3.06.71,6.13.98,9.22-2.85.38-5.73.72-8.63,1.03-.23-3.09-.5-6.18-.81-9.24h0Z"
        />
      </clipPath>
      <clipPath id="clippath-229">
        <path
          className="cls-1"
          d="M204.98,156.71c2.9-.31,5.78-.65,8.63-1.03.28,3.09.5,6.19.67,9.3-2.89.38-5.81.73-8.75,1.04-.14-3.11-.32-6.22-.55-9.31h0Z"
        />
      </clipPath>
      <clipPath id="clippath-230">
        <path
          className="cls-1"
          d="M205.52,166.02c2.94-.31,5.86-.66,8.75-1.04.17,3.1.28,6.21.34,9.32-2.91.39-5.85.74-8.81,1.05-.05-3.11-.14-6.22-.28-9.33h0Z"
        />
      </clipPath>
      <clipPath id="clippath-231">
        <path
          className="cls-1"
          d="M205.8,175.35c2.96-.31,5.9-.66,8.81-1.05.03,1.69.04,3.39.04,5.08,0,1.42-.02,2.82-.04,4.22-2.91.39-5.85.74-8.81,1.05.02-1.39.03-2.8.04-4.22,0-1.69,0-3.39-.03-5.08h0Z"
        />
      </clipPath>
      <clipPath id="clippath-232">
        <path
          className="cls-1"
          d="M205.8,184.65c2.96-.31,5.9-.66,8.81-1.05-.06,3.05-.17,6.04-.34,8.96-2.89.38-5.81.73-8.76,1.04.14-2.92.24-5.9.29-8.95h0Z"
        />
      </clipPath>
      <clipPath id="clippath-233">
        <path
          className="cls-1"
          d="M205.51,193.61c2.94-.31,5.86-.66,8.76-1.04-.17,2.92-.39,5.77-.67,8.55-2.85.38-5.74.72-8.64,1.03.23-2.77.42-5.62.56-8.54h0Z"
        />
      </clipPath>
      <clipPath id="clippath-234">
        <path
          className="cls-1"
          d="M204.95,202.14c2.91-.31,5.79-.65,8.64-1.03-.28,2.78-.61,5.49-.99,8.12-2.8.37-5.62.71-8.47,1.01.31-2.62.59-5.32.82-8.1h0Z"
        />
      </clipPath>
      <clipPath id="clippath-235">
        <path
          className="cls-1"
          d="M204.14,210.24c2.85-.3,5.67-.64,8.47-1.01-.38,2.63-.81,5.19-1.29,7.66-2.72.36-5.48.69-8.25.98.4-2.47.75-5.01,1.06-7.64h0Z"
        />
      </clipPath>
      <clipPath id="clippath-236">
        <path
          className="cls-1"
          d="M209.75,224.08c-2.63.35-5.3.67-7.98.95.47-2.3.91-4.69,1.3-7.15,2.77-.29,5.53-.62,8.25-.98-.48,2.48-1,4.87-1.57,7.18h0Z"
        />
      </clipPath>
      <clipPath id="clippath-237">
        <path
          className="cls-1"
          d="M207.9,230.76c-2.53.34-5.08.64-7.66.91.55-2.13,1.06-4.35,1.53-6.65,2.68-.28,5.34-.6,7.98-.95-.57,2.31-1.19,4.54-1.85,6.69h0Z"
        />
      </clipPath>
      <clipPath id="clippath-238">
        <path
          className="cls-1"
          d="M205.79,236.93c-2.41.32-4.84.61-7.29.87.62-1.95,1.2-3.99,1.74-6.12,2.57-.27,5.13-.58,7.66-.91-.66,2.14-1.36,4.2-2.11,6.16h0Z"
        />
      </clipPath>
      <clipPath id="clippath-239">
        <path
          className="cls-1"
          d="M196.63,103.59c-2.3.24-4.62.46-6.95.65-.53-2.75-1.09-5.44-1.67-8.09,2.18-.18,4.34-.38,6.49-.6.74,2.63,1.45,5.31,2.13,8.04h0Z"
        />
      </clipPath>
      <clipPath id="clippath-240">
        <path
          className="cls-1"
          d="M189.69,104.23c2.33-.19,4.65-.4,6.95-.65.68,2.73,1.33,5.51,1.94,8.34-2.44.26-4.89.49-7.36.69-.48-2.84-.99-5.63-1.52-8.38h0Z"
        />
      </clipPath>
      <clipPath id="clippath-241">
        <path
          className="cls-1"
          d="M191.21,112.61c2.47-.2,4.93-.43,7.36-.69.61,2.82,1.19,5.69,1.73,8.59-2.56.27-5.14.51-7.74.72-.43-2.91-.88-5.79-1.36-8.63h0Z"
        />
      </clipPath>
      <clipPath id="clippath-242">
        <path
          className="cls-1"
          d="M192.57,121.24c2.6-.21,5.18-.45,7.74-.72.54,2.9,1.05,5.84,1.52,8.81-2.67.28-5.36.53-8.07.75-.37-2.98-.76-5.93-1.19-8.84h0Z"
        />
      </clipPath>
      <clipPath id="clippath-243">
        <path
          className="cls-1"
          d="M193.75,130.08c2.71-.22,5.4-.47,8.07-.75.47,2.97.9,5.97,1.29,8.99-2.76.29-5.55.55-8.35.78-.31-3.03-.64-6.04-1.01-9.02h0Z"
        />
      </clipPath>
      <clipPath id="clippath-244">
        <path
          className="cls-1"
          d="M194.77,139.1c2.8-.23,5.59-.48,8.35-.78.39,3.02.74,6.07,1.05,9.14-2.84.3-5.7.57-8.58.8-.24-3.07-.52-6.13-.82-9.16h0Z"
        />
      </clipPath>
      <clipPath id="clippath-245">
        <path
          className="cls-1"
          d="M204.98,156.71c-2.9.31-5.82.58-8.76.81-.18-3.1-.39-6.19-.63-9.26,2.88-.23,5.74-.5,8.58-.8.31,3.07.58,6.15.81,9.24h0Z"
        />
      </clipPath>
      <clipPath id="clippath-246">
        <path
          className="cls-1"
          d="M196.22,157.52c2.94-.24,5.86-.51,8.76-.81.23,3.09.41,6.2.55,9.31-2.94.31-5.9.59-8.88.83-.11-3.11-.25-6.22-.43-9.32h0Z"
        />
      </clipPath>
      <clipPath id="clippath-247">
        <path
          className="cls-1"
          d="M196.65,166.85c2.98-.24,5.94-.51,8.88-.83.14,3.11.23,6.22.28,9.33-2.96.31-5.94.59-8.94.83-.03-3.11-.11-6.23-.21-9.34h0Z"
        />
      </clipPath>
      <clipPath id="clippath-248">
        <path
          className="cls-1"
          d="M196.86,176.18c3-.24,5.98-.52,8.94-.83.02,1.69.04,3.39.03,5.08,0,1.42-.02,2.82-.04,4.22-2.96.31-5.94.59-8.94.83.02-1.39.03-2.8.03-4.22,0-1.69,0-3.39-.02-5.08h0Z"
        />
      </clipPath>
      <clipPath id="clippath-249">
        <path
          className="cls-1"
          d="M196.85,185.48c3-.24,5.98-.52,8.94-.83-.05,3.05-.15,6.04-.29,8.95-2.94.31-5.9.59-8.88.83.11-2.91.19-5.9.23-8.95h0Z"
        />
      </clipPath>
      <clipPath id="clippath-250">
        <path
          className="cls-1"
          d="M196.62,194.43c2.98-.24,5.94-.52,8.88-.83-.14,2.92-.33,5.76-.56,8.54-2.9.31-5.83.58-8.77.82.18-2.77.33-5.61.44-8.53h0Z"
        />
      </clipPath>
      <clipPath id="clippath-251">
        <path
          className="cls-1"
          d="M196.18,202.96c2.94-.24,5.87-.51,8.77-.82-.23,2.77-.5,5.47-.82,8.1-2.85.3-5.71.57-8.6.8.25-2.62.46-5.31.64-8.08h0Z"
        />
      </clipPath>
      <clipPath id="clippath-252">
        <path
          className="cls-1"
          d="M195.54,211.04c2.88-.23,5.75-.5,8.6-.8-.31,2.62-.67,5.17-1.06,7.64-2.77.29-5.56.55-8.37.78.31-2.46.59-5,.84-7.61h0Z"
        />
      </clipPath>
      <clipPath id="clippath-253">
        <path
          className="cls-1"
          d="M194.7,218.65c2.81-.23,5.6-.49,8.37-.78-.4,2.47-.83,4.85-1.3,7.15-2.68.28-5.38.53-8.1.75.37-2.29.71-4.67,1.03-7.13h0Z"
        />
      </clipPath>
      <clipPath id="clippath-254">
        <path
          className="cls-1"
          d="M193.67,225.78c2.72-.22,5.42-.47,8.1-.75-.47,2.3-.98,4.52-1.53,6.65-2.57.27-5.16.51-7.77.72.43-2.12.83-4.33,1.2-6.62h0Z"
        />
      </clipPath>
      <clipPath id="clippath-255">
        <path
          className="cls-1"
          d="M192.47,232.4c2.61-.21,5.2-.45,7.77-.72-.55,2.13-1.13,4.17-1.74,6.12-2.45.26-4.92.49-7.4.69.48-1.94.94-3.97,1.37-6.09h0Z"
        />
      </clipPath>
      <clipPath id="clippath-256">
        <path
          className="cls-1"
          d="M196.56,243.36c-2.31.24-4.64.46-6.98.65.54-1.75,1.05-3.59,1.53-5.53,2.48-.2,4.95-.43,7.4-.69-.61,1.95-1.26,3.8-1.94,5.57h0Z"
        />
      </clipPath>
      <clipPath id="clippath-257">
        <path
          className="cls-1"
          d="M189.69,104.23c-2.33.19-4.68.35-7.03.48-.38-2.76-.79-5.46-1.2-8.12,2.2-.12,4.39-.27,6.56-.45.58,2.64,1.14,5.34,1.67,8.09h0Z"
        />
      </clipPath>
      <clipPath id="clippath-258">
        <path
          className="cls-1"
          d="M182.66,104.71c2.35-.13,4.7-.29,7.03-.48.53,2.75,1.04,5.54,1.52,8.38-2.47.2-4.96.37-7.45.51-.35-2.85-.71-5.65-1.09-8.4h0Z"
        />
      </clipPath>
      <clipPath id="clippath-259">
        <path
          className="cls-1"
          d="M183.75,113.12c2.49-.14,4.98-.31,7.45-.51.48,2.84.93,5.71,1.36,8.63-2.6.21-5.21.39-7.83.54-.31-2.92-.63-5.81-.98-8.65h0Z"
        />
      </clipPath>
      <clipPath id="clippath-260">
        <path
          className="cls-1"
          d="M184.73,121.77c2.62-.15,5.24-.33,7.83-.54.42,2.91.82,5.86,1.19,8.84-2.71.22-5.43.4-8.17.56-.26-2.99-.55-5.94-.86-8.87h0Z"
        />
      </clipPath>
      <clipPath id="clippath-261">
        <path
          className="cls-1"
          d="M185.59,130.64c2.73-.15,5.46-.34,8.17-.56.37,2.98.7,5.99,1.01,9.02-2.8.23-5.62.42-8.45.58-.22-3.04-.46-6.05-.73-9.04h0Z"
        />
      </clipPath>
      <clipPath id="clippath-262">
        <path
          className="cls-1"
          d="M186.32,139.68c2.83-.16,5.65-.35,8.45-.58.31,3.03.58,6.09.82,9.16-2.88.23-5.78.43-8.68.59-.17-3.08-.37-6.14-.59-9.18h0Z"
        />
      </clipPath>
      <clipPath id="clippath-263">
        <path
          className="cls-1"
          d="M196.22,157.52c-2.94.24-5.9.44-8.86.61-.13-3.1-.28-6.2-.45-9.27,2.91-.16,5.8-.36,8.68-.59.24,3.07.45,6.16.63,9.26h0Z"
        />
      </clipPath>
      <clipPath id="clippath-264">
        <path
          className="cls-1"
          d="M187.36,158.13c2.97-.17,5.92-.37,8.86-.61.18,3.1.32,6.21.43,9.32-2.98.24-5.98.44-8.98.61-.08-3.12-.18-6.23-.3-9.33h0Z"
        />
      </clipPath>
      <clipPath id="clippath-265">
        <path
          className="cls-1"
          d="M187.66,167.46c3.01-.17,6-.37,8.98-.61.11,3.11.18,6.23.21,9.34-3,.24-6.02.45-9.05.62-.02-3.11-.07-6.23-.15-9.34h0Z"
        />
      </clipPath>
      <clipPath id="clippath-266">
        <path
          className="cls-1"
          d="M187.81,176.8c3.03-.17,6.05-.38,9.05-.62.02,1.7.03,3.39.02,5.08,0,1.42-.01,2.82-.03,4.22-3,.24-6.02.45-9.05.62.01-1.39.02-2.8.02-4.21,0-1.69,0-3.39-.01-5.08h0Z"
        />
      </clipPath>
      <clipPath id="clippath-267">
        <path
          className="cls-1"
          d="M187.8,186.1c3.03-.17,6.05-.38,9.05-.62-.04,3.05-.12,6.04-.23,8.95-2.98.24-5.98.45-8.99.61.08-2.91.14-5.89.17-8.95h0Z"
        />
      </clipPath>
      <clipPath id="clippath-268">
        <path
          className="cls-1"
          d="M187.63,195.05c3.01-.17,6.01-.37,8.99-.61-.11,2.91-.26,5.76-.44,8.53-2.94.24-5.91.44-8.88.61.13-2.77.24-5.61.32-8.52h0Z"
        />
      </clipPath>
      <clipPath id="clippath-269">
        <path
          className="cls-1"
          d="M187.31,203.57c2.97-.17,5.93-.37,8.88-.61-.18,2.77-.4,5.46-.64,8.08-2.89.23-5.79.43-8.7.6.18-2.61.34-5.3.47-8.07h0Z"
        />
      </clipPath>
      <clipPath id="clippath-270">
        <path
          className="cls-1"
          d="M186.84,211.63c2.91-.16,5.81-.36,8.7-.6-.25,2.62-.53,5.16-.84,7.61-2.81.23-5.64.42-8.47.58.23-2.45.43-4.99.61-7.6h0Z"
        />
      </clipPath>
      <clipPath id="clippath-271">
        <path
          className="cls-1"
          d="M186.23,219.23c2.84-.16,5.66-.35,8.47-.58-.31,2.46-.65,4.83-1.03,7.13-2.72.22-5.45.41-8.19.56.27-2.28.52-4.66.75-7.11h0Z"
        />
      </clipPath>
      <clipPath id="clippath-272">
        <path
          className="cls-1"
          d="M185.48,226.34c2.74-.15,5.48-.34,8.19-.56-.37,2.29-.77,4.5-1.2,6.62-2.61.21-5.23.39-7.86.54.31-2.11.6-4.31.87-6.59h0Z"
        />
      </clipPath>
      <clipPath id="clippath-273">
        <path
          className="cls-1"
          d="M184.61,232.94c2.63-.15,5.26-.33,7.86-.54-.43,2.12-.89,4.15-1.37,6.09-2.48.2-4.98.37-7.49.51.35-1.93.68-3.95,1-6.06h0Z"
        />
      </clipPath>
      <clipPath id="clippath-274">
        <path
          className="cls-1"
          d="M183.61,239c2.51-.14,5-.31,7.49-.51-.48,1.94-.99,3.78-1.53,5.53-2.35.19-4.7.35-7.07.48.39-1.74.76-3.57,1.11-5.5h0Z"
        />
      </clipPath>
      <clipPath id="clippath-275">
        <path
          className="cls-1"
          d="M182.5,244.49c2.37-.13,4.72-.29,7.07-.48-.54,1.75-1.1,3.4-1.68,4.96-2.19.18-4.4.33-6.61.45.42-1.54.83-3.19,1.22-4.93h0Z"
        />
      </clipPath>
      <clipPath id="clippath-276">
        <path
          className="cls-1"
          d="M186.07,253.34c-2.03.16-4.06.3-6.11.42.46-1.34.9-2.79,1.32-4.33,2.21-.12,4.42-.28,6.61-.45-.58,1.56-1.19,3.01-1.82,4.36h0Z"
        />
      </clipPath>
      <clipPath id="clippath-277">
        <path
          className="cls-1"
          d="M174.85,96.89c2.21-.07,4.41-.17,6.61-.3.42,2.65.82,5.36,1.2,8.12-2.35.13-4.71.24-7.08.32-.23-2.76-.48-5.48-.74-8.14h0Z"
        />
      </clipPath>
      <clipPath id="clippath-278">
        <path
          className="cls-1"
          d="M175.58,105.03c2.36-.08,4.72-.18,7.08-.32.38,2.76.75,5.56,1.09,8.4-2.49.14-5,.25-7.5.34-.21-2.85-.43-5.66-.67-8.42h0Z"
        />
      </clipPath>
      <clipPath id="clippath-279">
        <path
          className="cls-1"
          d="M176.25,113.46c2.5-.08,5.01-.2,7.5-.34.35,2.85.67,5.73.98,8.65-2.62.15-5.25.27-7.88.35-.19-2.93-.39-5.82-.6-8.67h0Z"
        />
      </clipPath>
      <clipPath id="clippath-280">
        <path
          className="cls-1"
          d="M176.85,122.13c2.63-.09,5.26-.21,7.88-.35.31,2.92.59,5.88.86,8.87-2.73.15-5.47.28-8.22.37-.16-2.99-.33-5.95-.52-8.88h0Z"
        />
      </clipPath>
      <clipPath id="clippath-281">
        <path
          className="cls-1"
          d="M177.37,131.01c2.74-.09,5.49-.21,8.22-.37.26,2.99.51,6,.73,9.04-2.83.16-5.67.29-8.5.38-.13-3.04-.28-6.06-.44-9.05h0Z"
        />
      </clipPath>
      <clipPath id="clippath-282">
        <path
          className="cls-1"
          d="M177.81,140.06c2.84-.1,5.68-.22,8.5-.38.22,3.04.42,6.1.59,9.18-2.91.16-5.82.29-8.74.39-.11-3.08-.22-6.14-.36-9.19h0Z"
        />
      </clipPath>
      <clipPath id="clippath-283">
        <path
          className="cls-1"
          d="M178.17,149.25c2.92-.1,5.83-.23,8.74-.39.17,3.08.32,6.17.45,9.27-2.97.17-5.94.3-8.92.4-.08-3.11-.17-6.2-.27-9.28h0Z"
        />
      </clipPath>
      <clipPath id="clippath-284">
        <path
          className="cls-1"
          d="M187.66,167.46c-3.01.17-6.02.31-9.04.41-.04-3.12-.1-6.23-.18-9.34,2.98-.1,5.95-.23,8.92-.4.13,3.1.23,6.22.3,9.33h0Z"
        />
      </clipPath>
      <clipPath id="clippath-285">
        <path
          className="cls-1"
          d="M187.81,176.8c-3.03.17-6.07.31-9.11.41-.01-3.11-.04-6.23-.09-9.34,3.02-.1,6.04-.24,9.04-.41.08,3.11.13,6.23.15,9.34h0Z"
        />
      </clipPath>
      <clipPath id="clippath-286">
        <path
          className="cls-1"
          d="M178.71,177.21c3.04-.1,6.08-.24,9.11-.41.01,1.7.02,3.39.01,5.08,0,1.42-.01,2.82-.02,4.21-3.03.17-6.07.31-9.11.41,0-1.39.02-2.8.02-4.21,0-1.69,0-3.39,0-5.08h0Z"
        />
      </clipPath>
      <clipPath id="clippath-287">
        <path
          className="cls-1"
          d="M178.69,186.51c3.04-.1,6.08-.24,9.11-.41-.03,3.05-.09,6.03-.17,8.95-3.01.17-6.03.31-9.05.41.05-2.91.09-5.89.11-8.94h0Z"
        />
      </clipPath>
      <clipPath id="clippath-288">
        <path
          className="cls-1"
          d="M178.58,195.45c3.02-.1,6.04-.24,9.05-.41-.08,2.91-.19,5.75-.32,8.52-2.97.17-5.95.3-8.93.4.08-2.76.15-5.6.21-8.51h0Z"
        />
      </clipPath>
      <clipPath id="clippath-289">
        <path
          className="cls-1"
          d="M178.38,203.97c2.98-.1,5.96-.23,8.93-.4-.13,2.77-.29,5.46-.47,8.07-2.91.16-5.83.3-8.76.39.11-2.61.21-5.3.3-8.06h0Z"
        />
      </clipPath>
      <clipPath id="clippath-290">
        <path
          className="cls-1"
          d="M178.08,212.03c2.92-.1,5.84-.23,8.76-.39-.18,2.61-.39,5.15-.61,7.6-2.84.16-5.68.29-8.53.38.14-2.45.27-4.98.38-7.59h0Z"
        />
      </clipPath>
      <clipPath id="clippath-291">
        <path
          className="cls-1"
          d="M177.7,219.62c2.85-.1,5.69-.22,8.53-.38-.23,2.45-.48,4.82-.75,7.11-2.74.16-5.49.28-8.25.37.17-2.28.32-4.65.46-7.09h0Z"
        />
      </clipPath>
      <clipPath id="clippath-292">
        <path
          className="cls-1"
          d="M177.23,226.71c2.75-.09,5.5-.22,8.25-.37-.27,2.28-.56,4.48-.87,6.59-2.63.15-5.27.27-7.91.36.19-2.1.37-4.3.54-6.58h0Z"
        />
      </clipPath>
      <clipPath id="clippath-293">
        <path
          className="cls-1"
          d="M176.69,233.29c2.64-.09,5.28-.21,7.91-.36-.31,2.11-.64,4.13-1,6.06-2.51.14-5.02.25-7.54.34.22-1.92.42-3.94.62-6.04h0Z"
        />
      </clipPath>
      <clipPath id="clippath-294">
        <path
          className="cls-1"
          d="M176.07,239.33c2.52-.08,5.03-.2,7.54-.34-.35,1.93-.72,3.76-1.11,5.5-2.37.13-4.74.24-7.11.32.24-1.73.47-3.56.69-5.48h0Z"
        />
      </clipPath>
      <clipPath id="clippath-295">
        <path
          className="cls-1"
          d="M175.39,244.81c2.38-.08,4.75-.19,7.11-.32-.39,1.74-.8,3.38-1.22,4.93-2.21.12-4.43.22-6.65.3.26-1.54.51-3.17.75-4.91h0Z"
        />
      </clipPath>
      <clipPath id="clippath-296">
        <path
          className="cls-1"
          d="M174.63,249.72c2.22-.07,4.44-.17,6.65-.3-.42,1.54-.86,2.99-1.32,4.33-2.04.12-4.09.21-6.14.28.28-1.33.56-2.77.82-4.31h0Z"
        />
      </clipPath>
      <clipPath id="clippath-297">
        <path
          className="cls-1"
          d="M168.23,97.04c2.2-.02,4.41-.07,6.62-.15.26,2.66.5,5.38.74,8.14-2.36.08-4.73.13-7.09.16-.08-2.77-.17-5.48-.27-8.15h0Z"
        />
      </clipPath>
      <clipPath id="clippath-298">
        <path
          className="cls-1"
          d="M168.5,105.19c2.36-.03,4.73-.08,7.09-.16.23,2.76.46,5.57.67,8.42-2.5.08-5.01.14-7.51.17-.08-2.85-.16-5.67-.24-8.43h0Z"
        />
      </clipPath>
      <clipPath id="clippath-299">
        <path
          className="cls-1"
          d="M168.74,113.62c2.5-.03,5.01-.08,7.51-.17.21,2.85.41,5.74.6,8.67-2.63.09-5.27.15-7.9.18-.07-2.93-.14-5.83-.21-8.68h0Z"
        />
      </clipPath>
      <clipPath id="clippath-300">
        <path
          className="cls-1"
          d="M177.37,131.01c-2.74.09-5.49.15-8.23.18-.06-2.99-.12-5.96-.19-8.89,2.63-.03,5.27-.09,7.9-.18.19,2.93.36,5.89.52,8.88h0Z"
        />
      </clipPath>
      <clipPath id="clippath-301">
        <path
          className="cls-1"
          d="M169.14,131.19c2.74-.03,5.49-.09,8.23-.18.16,2.99.31,6.01.44,9.05-2.84.1-5.68.16-8.52.19-.05-3.04-.1-6.07-.16-9.06h0Z"
        />
      </clipPath>
      <clipPath id="clippath-302">
        <path
          className="cls-1"
          d="M169.29,140.25c2.84-.03,5.68-.09,8.52-.19.13,3.04.25,6.11.36,9.19-2.92.1-5.84.16-8.75.2-.04-3.08-.08-6.15-.12-9.19h0Z"
        />
      </clipPath>
      <clipPath id="clippath-303">
        <path
          className="cls-1"
          d="M169.41,149.44c2.92-.03,5.84-.1,8.75-.2.11,3.08.2,6.18.27,9.28-2.98.1-5.96.17-8.93.2-.02-3.11-.06-6.2-.09-9.29h0Z"
        />
      </clipPath>
      <clipPath id="clippath-304">
        <path
          className="cls-1"
          d="M178.62,167.87c-3.02.1-6.04.17-9.06.2-.01-3.12-.03-6.23-.06-9.34,2.98-.03,5.96-.1,8.93-.2.08,3.11.14,6.22.18,9.34h0Z"
        />
      </clipPath>
      <clipPath id="clippath-305">
        <path
          className="cls-1"
          d="M178.71,177.21c-3.04.1-6.08.17-9.12.2,0-3.11,0-6.23-.02-9.35,3.02-.03,6.04-.1,9.06-.2.04,3.11.07,6.23.09,9.34h0Z"
        />
      </clipPath>
      <clipPath id="clippath-306">
        <path
          className="cls-1"
          d="M169.58,177.42c3.04-.03,6.08-.1,9.12-.2,0,1.7,0,3.39,0,5.08,0,1.42,0,2.82-.02,4.21-3.04.1-6.09.17-9.12.2,0-1.39,0-2.8.01-4.21,0-1.69,0-3.39,0-5.08h0Z"
        />
      </clipPath>
      <clipPath id="clippath-307">
        <path
          className="cls-1"
          d="M169.57,186.72c3.04-.03,6.08-.1,9.12-.2-.02,3.05-.06,6.03-.11,8.94-3.02.1-6.05.17-9.07.2.02-2.91.04-5.89.05-8.94h0Z"
        />
      </clipPath>
      <clipPath id="clippath-308">
        <path
          className="cls-1"
          d="M169.52,195.66c3.02-.03,6.04-.1,9.07-.2-.05,2.91-.12,5.75-.21,8.51-2.98.1-5.97.17-8.95.2.03-2.76.06-5.6.09-8.51h0Z"
        />
      </clipPath>
      <clipPath id="clippath-309">
        <path
          className="cls-1"
          d="M169.43,204.17c2.98-.03,5.97-.1,8.95-.2-.08,2.76-.18,5.45-.3,8.06-2.92.1-5.85.16-8.77.2.05-2.61.09-5.29.12-8.06h0Z"
        />
      </clipPath>
      <clipPath id="clippath-310">
        <path
          className="cls-1"
          d="M169.31,212.22c2.92-.03,5.85-.1,8.77-.2-.11,2.61-.24,5.14-.38,7.59-2.85.1-5.7.16-8.54.19.06-2.45.11-4.98.15-7.58h0Z"
        />
      </clipPath>
      <clipPath id="clippath-311">
        <path
          className="cls-1"
          d="M169.16,219.81c2.85-.03,5.7-.1,8.54-.19-.14,2.45-.3,4.81-.46,7.09-2.75.09-5.51.15-8.26.18.07-2.28.13-4.64.18-7.09h0Z"
        />
      </clipPath>
      <clipPath id="clippath-312">
        <path
          className="cls-1"
          d="M168.97,226.9c2.75-.03,5.51-.09,8.26-.18-.17,2.28-.35,4.47-.54,6.58-2.64.09-5.29.15-7.93.18.08-2.1.15-4.29.21-6.57h0Z"
        />
      </clipPath>
      <clipPath id="clippath-313">
        <path
          className="cls-1"
          d="M168.76,233.47c2.64-.03,5.29-.09,7.93-.18-.19,2.11-.4,4.12-.62,6.04-2.52.08-5.03.14-7.55.17.08-1.92.16-3.93.24-6.03h0Z"
        />
      </clipPath>
      <clipPath id="clippath-314">
        <path
          className="cls-1"
          d="M168.52,239.5c2.52-.03,5.03-.08,7.55-.17-.22,1.92-.45,3.75-.69,5.48-2.38.08-4.75.13-7.13.16.09-1.73.18-3.55.26-5.47h0Z"
        />
      </clipPath>
      <clipPath id="clippath-315">
        <path
          className="cls-1"
          d="M168.26,244.97c2.37-.03,4.75-.08,7.13-.16-.24,1.73-.49,3.37-.75,4.91-2.22.07-4.44.12-6.66.15.1-1.53.2-3.17.29-4.9h0Z"
        />
      </clipPath>
      <clipPath id="clippath-316">
        <path
          className="cls-1"
          d="M173.81,254.03c-2.05.07-4.1.11-6.16.14.11-1.33.21-2.76.31-4.3,2.22-.02,4.44-.07,6.66-.15-.26,1.54-.53,2.97-.82,4.31h0Z"
        />
      </clipPath>
      <clipPath id="clippath-317">
        <path
          className="cls-1"
          d="M168.74,113.62c-2.5.03-5,.03-7.49,0,.06-2.85.12-5.67.18-8.43,2.35.03,4.71.02,7.07,0,.08,2.77.17,5.58.24,8.43h0Z"
        />
      </clipPath>
      <clipPath id="clippath-318">
        <path
          className="cls-1"
          d="M161.24,113.63c2.49.03,4.99.03,7.49,0,.08,2.85.15,5.75.21,8.68-2.63.03-5.26.03-7.88,0,.05-2.93.11-5.83.17-8.68h0Z"
        />
      </clipPath>
      <clipPath id="clippath-319">
        <path
          className="cls-1"
          d="M161.07,122.31c2.62.03,5.24.03,7.88,0,.07,2.93.13,5.9.19,8.89-2.74.03-5.48.03-8.21,0,.05-2.99.1-5.96.15-8.89h0Z"
        />
      </clipPath>
      <clipPath id="clippath-320">
        <path
          className="cls-1"
          d="M160.93,131.2c2.73.03,5.47.03,8.21,0,.06,2.99.11,6.02.16,9.06-2.84.03-5.67.03-8.5,0,.04-3.04.08-6.07.13-9.06h0Z"
        />
      </clipPath>
      <clipPath id="clippath-321">
        <path
          className="cls-1"
          d="M160.8,140.26c2.82.03,5.66.03,8.5,0,.05,3.04.09,6.11.12,9.19-2.92.03-5.83.03-8.73,0,.03-3.08.07-6.15.11-9.19h0Z"
        />
      </clipPath>
      <clipPath id="clippath-322">
        <path
          className="cls-1"
          d="M160.68,149.45c2.9.03,5.81.03,8.73,0,.04,3.08.07,6.18.09,9.29-2.98.03-5.95.03-8.91,0,.03-3.11.06-6.2.09-9.29h0Z"
        />
      </clipPath>
      <clipPath id="clippath-323">
        <path
          className="cls-1"
          d="M169.56,168.07c-3.02.03-6.03.03-9.03,0,.02-3.12.04-6.23.07-9.34,2.96.03,5.93.03,8.91,0,.02,3.11.04,6.22.06,9.34h0Z"
        />
      </clipPath>
      <clipPath id="clippath-324">
        <path
          className="cls-1"
          d="M160.53,168.07c3,.03,6.02.03,9.03,0,.01,3.11.02,6.23.02,9.35-3.04.03-6.07.03-9.1,0,.01-3.11.02-6.23.04-9.35h0Z"
        />
      </clipPath>
      <clipPath id="clippath-325">
        <path
          className="cls-1"
          d="M160.49,177.42c3.02.03,6.06.03,9.1,0,0,1.7,0,3.39,0,5.08,0,1.42,0,2.82-.01,4.21-3.04.03-6.08.03-9.1,0,0-1.39,0-2.8,0-4.21,0-1.69,0-3.39.01-5.08h0Z"
        />
      </clipPath>
      <clipPath id="clippath-326">
        <path
          className="cls-1"
          d="M160.47,186.72c3.02.03,6.06.03,9.1,0-.01,3.05-.03,6.03-.05,8.94-3.02.03-6.04.03-9.04,0,0-2.91,0-5.89,0-8.94h0Z"
        />
      </clipPath>
      <clipPath id="clippath-327">
        <path
          className="cls-1"
          d="M160.48,195.66c3,.03,6.02.03,9.04,0-.02,2.91-.05,5.75-.09,8.51-2.98.03-5.96.03-8.92,0-.01-2.76-.02-5.6-.03-8.51h0Z"
        />
      </clipPath>
      <clipPath id="clippath-328">
        <path
          className="cls-1"
          d="M160.51,204.17c2.97.03,5.94.03,8.92,0-.03,2.76-.07,5.45-.12,8.06-2.92.03-5.84.03-8.75,0-.02-2.61-.04-5.29-.05-8.06h0Z"
        />
      </clipPath>
      <clipPath id="clippath-329">
        <path
          className="cls-1"
          d="M160.56,212.23c2.91.03,5.83.03,8.75,0-.05,2.61-.1,5.14-.15,7.58-2.85.03-5.69.03-8.52,0-.03-2.45-.06-4.98-.08-7.58h0Z"
        />
      </clipPath>
      <clipPath id="clippath-330">
        <path
          className="cls-1"
          d="M168.97,226.9c-2.75.03-5.5.03-8.24,0-.04-2.28-.07-4.64-.1-7.09,2.83.03,5.67.03,8.52,0-.06,2.45-.12,4.81-.18,7.09h0Z"
        />
      </clipPath>
      <clipPath id="clippath-331">
        <path
          className="cls-1"
          d="M161.07,122.31c-2.62-.03-5.23-.09-7.82-.17.17-2.93.35-5.82.55-8.67,2.47.08,4.95.13,7.44.16-.06,2.85-.11,5.75-.17,8.68h0Z"
        />
      </clipPath>
      <clipPath id="clippath-332">
        <path
          className="cls-1"
          d="M160.93,131.2c-2.73-.03-5.45-.09-8.15-.18.15-2.99.31-5.95.48-8.88,2.59.08,5.2.14,7.82.17-.05,2.93-.1,5.9-.15,8.89h0Z"
        />
      </clipPath>
      <clipPath id="clippath-333">
        <path
          className="cls-1"
          d="M160.8,140.26c-2.82-.03-5.64-.09-8.43-.18.13-3.04.26-6.06.41-9.05,2.7.09,5.42.15,8.15.18-.05,2.99-.09,6.02-.13,9.06h0Z"
        />
      </clipPath>
      <clipPath id="clippath-334">
        <path
          className="cls-1"
          d="M152.36,140.07c2.8.09,5.61.15,8.43.18-.04,3.04-.08,6.11-.11,9.19-2.9-.03-5.79-.09-8.67-.19.1-3.08.22-6.14.34-9.19h0Z"
        />
      </clipPath>
      <clipPath id="clippath-335">
        <path
          className="cls-1"
          d="M152.02,149.26c2.87.09,5.76.16,8.67.19-.03,3.08-.06,6.18-.09,9.29-2.96-.03-5.91-.1-8.84-.19.08-3.11.17-6.2.27-9.28h0Z"
        />
      </clipPath>
      <clipPath id="clippath-336">
        <path
          className="cls-1"
          d="M160.53,168.07c-3-.03-5.99-.1-8.97-.19.05-3.12.11-6.23.19-9.34,2.93.1,5.88.16,8.84.19-.03,3.11-.05,6.22-.07,9.34h0Z"
        />
      </clipPath>
      <clipPath id="clippath-337">
        <path
          className="cls-1"
          d="M151.56,167.88c2.97.1,5.96.16,8.97.19-.02,3.11-.03,6.23-.04,9.35-3.02-.03-6.04-.1-9.03-.2.02-3.11.06-6.23.11-9.34h0Z"
        />
      </clipPath>
      <clipPath id="clippath-338">
        <path
          className="cls-1"
          d="M151.46,177.22c2.99.1,6.01.16,9.03.2,0,1.7,0,3.39-.01,5.08,0,1.42,0,2.82,0,4.21-3.02-.03-6.04-.1-9.03-.2,0-1.39,0-2.8,0-4.21,0-1.69.01-3.39.02-5.08h0Z"
        />
      </clipPath>
      <clipPath id="clippath-339">
        <path
          className="cls-1"
          d="M151.44,186.52c3,.1,6.01.16,9.03.2,0,3.05,0,6.03,0,8.94-3-.03-6-.1-8.97-.19-.04-2.91-.06-5.89-.07-8.94h0Z"
        />
      </clipPath>
      <clipPath id="clippath-340">
        <path
          className="cls-1"
          d="M151.5,195.46c2.98.1,5.97.16,8.97.19,0,2.91.02,5.75.03,8.51-2.97-.03-5.92-.1-8.86-.19-.06-2.76-.11-5.6-.15-8.51h0Z"
        />
      </clipPath>
      <clipPath id="clippath-341">
        <path
          className="cls-1"
          d="M151.65,203.98c2.94.1,5.89.16,8.86.19.01,2.76.03,5.45.05,8.06-2.91-.03-5.8-.09-8.68-.19-.09-2.61-.17-5.3-.23-8.06h0Z"
        />
      </clipPath>
      <clipPath id="clippath-342">
        <path
          className="cls-1"
          d="M160.64,219.81c-2.83-.03-5.65-.09-8.46-.18-.11-2.45-.22-4.98-.3-7.59,2.88.09,5.78.16,8.68.19.02,2.61.05,5.14.08,7.58h0Z"
        />
      </clipPath>
      <clipPath id="clippath-343">
        <path
          className="cls-1"
          d="M152.02,149.26c-2.87-.09-5.73-.22-8.56-.37.17-3.08.36-6.14.57-9.18,2.76.15,5.54.27,8.33.36-.13,3.04-.24,6.11-.34,9.19h0Z"
        />
      </clipPath>
      <clipPath id="clippath-344">
        <path
          className="cls-1"
          d="M151.75,158.54c-2.93-.1-5.85-.22-8.74-.38.13-3.1.27-6.2.44-9.27,2.83.16,5.69.28,8.56.37-.1,3.08-.19,6.18-.27,9.28h0Z"
        />
      </clipPath>
      <clipPath id="clippath-345">
        <path
          className="cls-1"
          d="M143.01,158.16c2.89.16,5.81.29,8.74.38-.08,3.11-.14,6.22-.19,9.34-2.97-.1-5.93-.23-8.86-.39.08-3.12.18-6.23.31-9.33h0Z"
        />
      </clipPath>
      <clipPath id="clippath-346">
        <path
          className="cls-1"
          d="M142.71,167.49c2.93.16,5.89.29,8.86.39-.05,3.11-.08,6.23-.11,9.34-2.99-.1-5.97-.23-8.92-.39.03-3.11.09-6.23.17-9.34h0Z"
        />
      </clipPath>
      <clipPath id="clippath-347">
        <path
          className="cls-1"
          d="M142.54,176.83c2.95.16,5.93.29,8.92.39-.01,1.7-.02,3.39-.02,5.08,0,1.42,0,2.82,0,4.21-2.99-.1-5.97-.23-8.92-.39,0-1.39-.01-2.8,0-4.21,0-1.69.01-3.39.03-5.08h0Z"
        />
      </clipPath>
      <clipPath id="clippath-348">
        <path
          className="cls-1"
          d="M142.51,186.13c2.95.16,5.93.29,8.92.39,0,3.05.03,6.03.07,8.94-2.98-.1-5.93-.23-8.87-.39-.06-2.91-.11-5.89-.12-8.95h0Z"
        />
      </clipPath>
      <clipPath id="clippath-349">
        <path
          className="cls-1"
          d="M142.64,195.08c2.93.16,5.89.29,8.87.39.04,2.91.09,5.75.15,8.51-2.94-.1-5.86-.22-8.75-.38-.11-2.77-.2-5.61-.26-8.52h0Z"
        />
      </clipPath>
      <clipPath id="clippath-350">
        <path
          className="cls-1"
          d="M142.9,203.59c2.89.16,5.81.29,8.75.38.06,2.76.14,5.45.23,8.06-2.88-.09-5.74-.22-8.58-.37-.16-2.61-.29-5.3-.4-8.07h0Z"
        />
      </clipPath>
      <clipPath id="clippath-351">
        <path
          className="cls-1"
          d="M143.3,211.66c2.84.16,5.7.28,8.58.37.09,2.61.19,5.14.3,7.59-2.8-.09-5.59-.21-8.35-.36-.2-2.45-.37-4.99-.53-7.6h0Z"
        />
      </clipPath>
      <clipPath id="clippath-352">
        <path
          className="cls-1"
          d="M142.71,167.49c-2.93-.16-5.84-.35-8.71-.58.11-3.11.25-6.22.43-9.32,2.83.22,5.7.41,8.59.57-.13,3.1-.23,6.22-.31,9.33h0Z"
        />
      </clipPath>
      <clipPath id="clippath-353">
        <path
          className="cls-1"
          d="M142.54,176.83c-2.95-.16-5.88-.36-8.77-.58.04-3.11.12-6.23.23-9.34,2.87.22,5.78.41,8.71.58-.08,3.11-.14,6.23-.17,9.34h0Z"
        />
      </clipPath>
      <clipPath id="clippath-354">
        <path
          className="cls-1"
          d="M133.77,176.25c2.89.22,5.82.42,8.77.58-.02,1.7-.03,3.39-.03,5.08,0,1.42,0,2.82,0,4.21-2.95-.16-5.88-.36-8.77-.58-.01-1.39-.02-2.8-.01-4.22,0-1.69.02-3.39.04-5.08h0Z"
        />
      </clipPath>
      <clipPath id="clippath-355">
        <path
          className="cls-1"
          d="M133.74,185.55c2.9.22,5.82.42,8.77.58.02,3.05.06,6.03.12,8.95-2.93-.16-5.84-.35-8.72-.58-.09-2.91-.15-5.9-.18-8.95h0Z"
        />
      </clipPath>
      <clipPath id="clippath-356">
        <path
          className="cls-1"
          d="M133.92,194.5c2.88.22,5.78.42,8.72.58.06,2.91.15,5.75.26,8.52-2.89-.16-5.76-.35-8.6-.57-.16-2.77-.28-5.61-.38-8.53h0Z"
        />
      </clipPath>
      <clipPath id="clippath-357">
        <path
          className="cls-1"
          d="M134.3,203.03c2.84.22,5.71.41,8.6.57.11,2.77.24,5.46.4,8.07-2.84-.16-5.65-.34-8.43-.56-.22-2.62-.41-5.31-.57-8.08h0Z"
        />
      </clipPath>
      <clipPath id="clippath-358">
        <path
          className="cls-1"
          d="M143.83,219.26c-2.76-.15-5.5-.33-8.21-.54-.28-2.46-.53-5-.75-7.61,2.78.22,5.6.4,8.43.56.16,2.61.33,5.15.53,7.6h0Z"
        />
      </clipPath>
      <clipPath id="clippath-359">
        <path
          className="cls-1"
          d="M133.74,185.55c-2.9-.22-5.76-.48-8.58-.77-.02-1.39-.02-2.8-.02-4.22,0-1.69.02-3.39.05-5.08,2.82.29,5.69.54,8.58.77-.02,1.7-.04,3.39-.04,5.08,0,1.42,0,2.82.01,4.22h0Z"
        />
      </clipPath>
      <clipPath id="clippath-360">
        <path
          className="cls-1"
          d="M133.92,194.5c-2.88-.22-5.72-.48-8.53-.76-.12-2.92-.2-5.9-.24-8.95,2.82.29,5.69.54,8.58.77.03,3.05.09,6.04.18,8.95h0Z"
        />
      </clipPath>
      <clipPath id="clippath-361">
        <path
          className="cls-1"
          d="M134.3,203.03c-2.84-.22-5.65-.47-8.42-.75-.2-2.77-.37-5.62-.49-8.54,2.81.28,5.65.54,8.53.76.09,2.91.22,5.76.38,8.53h0Z"
        />
      </clipPath>
      <clipPath id="clippath-362">
        <path
          className="cls-1"
          d="M134.86,211.11c-2.78-.22-5.54-.46-8.25-.74-.28-2.62-.53-5.32-.73-8.09,2.77.28,5.58.53,8.42.75.16,2.77.35,5.46.57,8.08h0Z"
        />
      </clipPath>
      <clipPath id="clippath-363">
        <path
          className="cls-1"
          d="M203.12,138.33c2.77-.29,5.51-.62,8.23-.98.48,3.01.9,6.05,1.28,9.11-2.79.37-5.61.71-8.45,1.01-.31-3.07-.66-6.11-1.05-9.14h0Z"
        />
      </clipPath>
      <clipPath id="clippath-364">
        <path
          className="cls-1"
          d="M204.17,147.47c2.84-.3,5.66-.64,8.45-1.01.38,3.06.71,6.13.98,9.22-2.85.38-5.73.72-8.63,1.03-.23-3.09-.5-6.18-.81-9.24h0Z"
        />
      </clipPath>
      <clipPath id="clippath-365">
        <path
          className="cls-1"
          d="M204.98,156.71c2.9-.31,5.78-.65,8.63-1.03.28,3.09.5,6.19.67,9.3-2.89.38-5.81.73-8.75,1.04-.14-3.11-.32-6.22-.55-9.31h0Z"
        />
      </clipPath>
      <clipPath id="clippath-366">
        <path
          className="cls-1"
          d="M194.77,139.1c2.8-.23,5.59-.48,8.35-.78.39,3.02.74,6.07,1.05,9.14-2.84.3-5.7.57-8.58.8-.24-3.07-.52-6.13-.82-9.16h0Z"
        />
      </clipPath>
      <clipPath id="clippath-367">
        <path
          className="cls-1"
          d="M195.59,148.26c2.88-.23,5.74-.5,8.58-.8.31,3.07.58,6.15.81,9.24-2.9.31-5.82.58-8.76.81-.18-3.1-.39-6.19-.63-9.26h0Z"
        />
      </clipPath>
      <clipPath id="clippath-368">
        <path
          className="cls-1"
          d="M196.22,157.52c2.94-.24,5.86-.51,8.76-.81.23,3.09.41,6.2.55,9.31-2.94.31-5.9.59-8.88.83-.11-3.11-.25-6.22-.43-9.32h0Z"
        />
      </clipPath>
      <clipPath id="clippath-369">
        <path
          className="cls-1"
          d="M186.32,139.68c2.83-.16,5.65-.35,8.45-.58.31,3.03.58,6.09.82,9.16-2.88.23-5.78.43-8.68.59-.17-3.08-.37-6.14-.59-9.18h0Z"
        />
      </clipPath>
      <clipPath id="clippath-370">
        <path
          className="cls-1"
          d="M186.91,148.86c2.91-.16,5.8-.36,8.68-.59.24,3.07.45,6.16.63,9.26-2.94.24-5.9.44-8.86.61-.13-3.1-.28-6.2-.45-9.27h0Z"
        />
      </clipPath>
      <clipPath id="clippath-371">
        <path
          className="cls-1"
          d="M187.36,158.13c2.97-.17,5.92-.37,8.86-.61.18,3.1.32,6.21.43,9.32-2.98.24-5.98.44-8.98.61-.08-3.12-.18-6.23-.3-9.33h0Z"
        />
      </clipPath>
      <clipPath id="clippath-372">
        <path
          className="cls-1"
          d="M90.6,93.76c-1.29,1.52-2.91,2.74-4.05,4.4-.86,1.26-.62,1.48-.13,1.7,1.13-.87,1.52-.62,2.01.31.27.51.73,1.37,1.7.19,1.41-1.72,2.64-6.83,2.01-7.48-.43.08-1.54.89-1.55.9h0Z"
        />
      </clipPath>
      <clipPath id="clippath-373">
        <path
          className="cls-1"
          d="M94.93,86.61c1.28.53,2.62,1.04,4.03,1.53-1.62,2.45-3.17,4.95-4.66,7.52-1.51-.52-2.95-1.07-4.32-1.63,1.58-2.53,3.22-5,4.94-7.41h0Z"
        />
      </clipPath>
      <clipPath id="clippath-374">
        <path
          className="cls-1"
          d="M89.99,94.02c1.37.56,2.81,1.11,4.32,1.63-1.48,2.57-2.9,5.19-4.24,7.86-1.6-.56-3.13-1.13-4.58-1.73,1.42-2.64,2.93-5.23,4.5-7.76h0Z"
        />
      </clipPath>
      <clipPath id="clippath-375">
        <path
          className="cls-1"
          d="M86.11,92.27c1.22.6,2.51,1.19,3.88,1.75-1.58,2.53-3.08,5.12-4.5,7.76-1.45-.6-2.83-1.22-4.12-1.86,1.5-2.61,3.08-5.16,4.74-7.66h0Z"
        />
      </clipPath>
      <clipPath id="clippath-376">
        <path
          className="cls-1"
          d="M92.24,109.05l-.08-.25s.04-.03.06-.04c.05.23.05.56.05.8,0-.15,0-.36-.03-.51h0ZM113.13,223.49q-.17,2.08,1.18,12.75c-1.85.6-3.49,1.68-5.29,2.4-.8,2.79,2.73,9,2.77,9.05-.21.58-.83,1.25-1.38,1.52.24.35.56.81.8,1.16-.3.05-.71.12-1.01.17.05.05,5.52,4.96,16.11,9.21-31.7-10.74-58.77-51.77-58.43-56.9.61-.53,1.43-1.24,2.04-1.77-.75-3.09-2.98-5.41-4.29-8.21-.2.32-.47.76-.67,1.08-3.72-1.67-10.07-16.15-10.1-16.28-.21.25-.48.58-.69.82-13.22-42.06,4.57-73.63,4.75-73.93-.37,1.85-.58,2.87-1.58,4.84,1.73-1.51,16.24-30.34,16.26-30.52q-1.06.94-2.31,2.4l1.71-2.23c3.05-3.61,7.26-8.32,10.55-11.72q1.65-1.56,3.17-2.67c-.24.24-.56.57-.8.81,2.41-1.75,4.4-4.01,6.85-5.72-.18.32-.43.74-.61,1.06.15-.12,3.77-3.03,7.54-4.88-.25.31-.58.72-.83,1.03q3.46-1.07,4.04-1.15c-1.37,2.41-10.68,11.41-10.76,11.47.3.15.69.35.98.49.1.3.22.7.32,1.01.31-.15.71-.34,1.02-.48-3.43,3.22-2.97,9.17-7.94,11.31.37-.11.86-.25,1.23-.36.11.36.26.83.37,1.19-.27.32-.64.75-.91,1.07q2.65-1.32,3.2-1.68c.12.29.28.68.4.97q-1.61,3.61-1.64,4.97c.28.13.66.3.95.43,6.63-4.19,10.79-11.58,18.51-14.37-4.29,6.78-11.17,11.43-15.19,18.43,2.12-1.4,3.94-3.18,5.94-4.74-.14,4.43-4.94,7.65-6.83,8.19-.26-.32-.61-.74-.87-1.06-2.13,2.37-2.3,2.57-3.91,3.46q-4.14-1.81-13.43,13.03c.21.28.49.66.7.94-.39.93-.8,2.22-1.05,3.2q1.47,2.25,1.27,11.2c.33,0,.77.02,1.1.02,3.98-6.49,4.06-6.61,6.44-7.35,2.61-9.03,3.31-11.45,6.67-12.39q1.74,1.11,2.69,4.07c-1.43,4.22-.85,5.88-.61,6.59.85-.18,1.98-.44,2.82-.64l-2.97,18.3c-2.87.11-5.72-1.26-8.61-.13.17.61.57,1.39.98,1.87-.22.73-.53,1.7-.77,2.42,1.28,1,1.86,1.45,3.33.29,1.15,2.07.7,2.85.02,4.02-3.73.8-4.11.85-5.8.71-.19-.35-.43-.82-.62-1.17.26-.38.6-.89.86-1.27-1.94.91-3.77,1.78-2.34,4.66-5.63-4.37-15.86,20-15.93,20.27-1.54-2.03-.09-5.26-2.73-6.85-.67.65-1.49,1.62-1.97,2.42q-1.35-1.87-2.83-1.73c-3.11,10.78.35,16.41.39,16.46.51-.88,1.19-2.06,1.7-2.95.73,2.44,1.17,4.95,1.87,7.4,1.11.44,2.32.5,3.42.93q1.18,6.99,4.94,10.83c.58-.14,1.38-.25,1.98-.24,24.12,10.95,25.14,23.09,25.13,23.2.2-.04,19.34,1.62,18.7,9.29h0Z"
        />
      </clipPath>
      <clipPath id="clippath-377">
        <path
          className="cls-1"
          d="M104.98,214.74c2.37.43,4.79.84,7.26,1.21.51,2.49,1.08,4.89,1.69,7.22-2.39-.37-4.73-.76-7.02-1.17-.7-2.34-1.35-4.76-1.93-7.26h0Z"
        />
      </clipPath>
      <clipPath id="clippath-378">
        <path
          className="cls-1"
          d="M106.91,222c2.29.42,4.63.81,7.02,1.17.61,2.33,1.28,4.57,1.99,6.73-2.3-.35-4.54-.73-6.74-1.13-.81-2.17-1.57-4.43-2.27-6.77h0Z"
        />
      </clipPath>
      <clipPath id="clippath-379">
        <path
          className="cls-1"
          d="M118.21,236.11c-2.19-.33-4.33-.69-6.42-1.07-.92-2-1.79-4.09-2.6-6.26,2.2.4,4.45.78,6.74,1.13.71,2.16,1.47,4.23,2.28,6.21h0Z"
        />
      </clipPath>
      <clipPath id="clippath-380">
        <path
          className="cls-1"
          d="M120.76,241.78c-2.06-.32-4.09-.65-6.06-1.01-1.02-1.82-1.99-3.73-2.91-5.73,2.09.38,4.24.74,6.42,1.07.81,1.98,1.66,3.87,2.55,5.67h0Z"
        />
      </clipPath>
      <clipPath id="clippath-381">
        <path
          className="cls-1"
          d="M98.05,213.37c2.25.48,4.57.94,6.94,1.37.58,2.5,1.23,4.92,1.93,7.26-2.29-.42-4.53-.86-6.71-1.33-.78-2.36-1.5-4.79-2.16-7.3h0Z"
        />
      </clipPath>
      <clipPath id="clippath-382">
        <path
          className="cls-1"
          d="M100.2,220.67c2.18.47,4.42.91,6.71,1.33.7,2.34,1.46,4.6,2.27,6.77-2.2-.4-4.35-.83-6.44-1.28-.91-2.19-1.76-4.47-2.54-6.83h0Z"
        />
      </clipPath>
      <clipPath id="clippath-383">
        <path
          className="cls-1"
          d="M102.74,227.5c2.09.45,4.24.87,6.44,1.28.81,2.17,1.68,4.26,2.6,6.26-2.1-.38-4.14-.79-6.13-1.21-1.03-2.02-2-4.13-2.91-6.32h0Z"
        />
      </clipPath>
      <clipPath id="clippath-384">
        <path
          className="cls-1"
          d="M105.65,233.82c1.99.43,4.04.83,6.13,1.21.92,2,1.89,3.91,2.91,5.73-1.98-.36-3.91-.74-5.79-1.15-1.14-1.84-2.23-3.78-3.25-5.8h0Z"
        />
      </clipPath>
      <clipPath id="clippath-385">
        <path
          className="cls-1"
          d="M98.05,213.37c-2.25-.48-4.44-.99-6.56-1.53-.72-2.53-1.36-5.13-1.93-7.8,2.18.55,4.43,1.07,6.74,1.57.52,2.66,1.1,5.25,1.75,7.76h0Z"
        />
      </clipPath>
      <clipPath id="clippath-386">
        <path
          className="cls-1"
          d="M91.48,211.84c2.12.54,4.31,1.04,6.56,1.53.65,2.51,1.37,4.95,2.16,7.3-2.18-.47-4.3-.96-6.35-1.48-.86-2.37-1.65-4.83-2.37-7.35h0Z"
        />
      </clipPath>
      <clipPath id="clippath-387">
        <path
          className="cls-1"
          d="M93.85,219.19c2.05.52,4.17,1.01,6.35,1.48.78,2.36,1.63,4.63,2.54,6.83-2.09-.45-4.12-.92-6.09-1.42-1-2.21-1.93-4.51-2.8-6.88h0Z"
        />
      </clipPath>
      <clipPath id="clippath-388">
        <path
          className="cls-1"
          d="M96.65,226.08c1.97.5,4,.97,6.09,1.42.91,2.19,1.88,4.3,2.91,6.32-1.99-.43-3.93-.88-5.8-1.35-1.13-2.05-2.2-4.18-3.2-6.39h0Z"
        />
      </clipPath>
      <clipPath id="clippath-389">
        <path
          className="cls-1"
          d="M99.85,232.47c1.88.47,3.81.92,5.8,1.35,1.03,2.02,2.11,3.96,3.25,5.8-1.88-.4-3.71-.83-5.48-1.28-1.25-1.87-2.45-3.83-3.58-5.87h0Z"
        />
      </clipPath>
      <clipPath id="clippath-390">
        <path
          className="cls-1"
          d="M103.43,238.34c1.77.45,3.6.87,5.48,1.28,1.14,1.84,2.34,3.59,3.58,5.25-1.76-.38-3.47-.78-5.12-1.19-1.37-1.68-2.68-3.46-3.94-5.33h0Z"
        />
      </clipPath>
      <clipPath id="clippath-391">
        <path
          className="cls-1"
          d="M116.38,249.55c-1.62-.35-3.2-.72-4.73-1.1-1.48-1.49-2.91-3.08-4.28-4.77,1.66.42,3.36.82,5.12,1.19,1.25,1.66,2.54,3.22,3.89,4.68h0Z"
        />
      </clipPath>
      <clipPath id="clippath-392">
        <path
          className="cls-1"
          d="M94.34,123.49c-2.04-.52-4.02-1.05-5.92-1.62.96-2.87,2-5.71,3.11-8.5,1.83.54,3.72,1.06,5.68,1.55-1.02,2.82-1.98,5.67-2.87,8.57h0Z"
        />
      </clipPath>
      <clipPath id="clippath-393">
        <path
          className="cls-1"
          d="M88.42,121.87c1.9.56,3.88,1.1,5.92,1.62-.89,2.9-1.71,5.83-2.45,8.79-2.11-.53-4.16-1.09-6.13-1.67.81-2.95,1.7-5.86,2.66-8.74h0Z"
        />
      </clipPath>
      <clipPath id="clippath-394">
        <path
          className="cls-1"
          d="M89.87,141.26c-2.17-.55-4.27-1.12-6.3-1.72.65-3,1.38-5.98,2.18-8.93,1.97.58,4.02,1.14,6.13,1.67-.75,2.96-1.42,5.96-2.01,8.97h0Z"
        />
      </clipPath>
      <clipPath id="clippath-395">
        <path
          className="cls-1"
          d="M88.32,150.38c-2.22-.56-4.36-1.14-6.43-1.76.48-3.05,1.04-6.08,1.68-9.08,2.03.6,4.13,1.17,6.3,1.72-.6,3.02-1.12,6.06-1.55,9.12h0Z"
        />
      </clipPath>
      <clipPath id="clippath-396">
        <path
          className="cls-1"
          d="M89.55,204.04c-2.18-.55-4.29-1.12-6.32-1.73-.61-2.68-1.15-5.43-1.59-8.25,2.07.61,4.22,1.2,6.44,1.76.41,2.81.9,5.55,1.46,8.22h0Z"
        />
      </clipPath>
      <clipPath id="clippath-397">
        <path
          className="cls-1"
          d="M83.23,202.31c2.03.6,4.14,1.18,6.32,1.73.57,2.67,1.21,5.27,1.93,7.8-2.12-.53-4.17-1.1-6.15-1.68-.78-2.54-1.48-5.16-2.09-7.85h0Z"
        />
      </clipPath>
      <clipPath id="clippath-398">
        <path
          className="cls-1"
          d="M85.33,210.16c1.98.58,4.03,1.15,6.15,1.68.72,2.53,1.51,4.98,2.37,7.35-2.05-.52-4.04-1.06-5.95-1.62-.94-2.39-1.8-4.87-2.58-7.41h0Z"
        />
      </clipPath>
      <clipPath id="clippath-399">
        <path
          className="cls-1"
          d="M87.9,217.57c1.91.57,3.9,1.11,5.95,1.62.86,2.37,1.8,4.67,2.8,6.88-1.97-.5-3.88-1.02-5.71-1.56-1.09-2.24-2.1-4.55-3.03-6.95h0Z"
        />
      </clipPath>
      <clipPath id="clippath-400">
        <path
          className="cls-1"
          d="M90.94,224.52c1.84.54,3.74,1.06,5.71,1.56,1,2.21,2.07,4.35,3.2,6.39-1.88-.47-3.69-.97-5.44-1.49-1.23-2.07-2.38-4.23-3.47-6.47h0Z"
        />
      </clipPath>
      <clipPath id="clippath-401">
        <path
          className="cls-1"
          d="M94.41,230.98c1.75.52,3.56,1.01,5.44,1.49,1.13,2.05,2.32,4,3.58,5.87-1.77-.45-3.48-.91-5.14-1.4-1.36-1.9-2.66-3.89-3.88-5.96h0Z"
        />
      </clipPath>
      <clipPath id="clippath-402">
        <path
          className="cls-1"
          d="M98.29,236.94c1.65.49,3.36.96,5.14,1.4,1.25,1.87,2.57,3.65,3.94,5.33-1.66-.42-3.26-.85-4.8-1.31-1.49-1.72-2.91-3.53-4.27-5.42h0Z"
        />
      </clipPath>
      <clipPath id="clippath-403">
        <path
          className="cls-1"
          d="M102.57,242.36c1.54.46,3.15.89,4.8,1.31,1.37,1.68,2.8,3.28,4.28,4.77-1.53-.39-3.01-.79-4.44-1.21-1.61-1.53-3.16-3.15-4.64-4.87h0Z"
        />
      </clipPath>
      <clipPath id="clippath-404">
        <path
          className="cls-1"
          d="M116.24,252.63c-1.4-.35-2.75-.72-4.05-1.11-1.72-1.33-3.38-2.76-4.99-4.29,1.43.42,2.91.83,4.44,1.21,1.48,1.49,3.01,2.89,4.6,4.18h0Z"
        />
      </clipPath>
      <clipPath id="clippath-405">
        <path
          className="cls-1"
          d="M90.07,103.52c1.6.56,3.27,1.09,5.01,1.61-1.25,2.7-2.44,5.45-3.55,8.25-1.83-.54-3.58-1.1-5.27-1.69,1.19-2.77,2.46-5.49,3.8-8.17h0Z"
        />
      </clipPath>
      <clipPath id="clippath-406">
        <path
          className="cls-1"
          d="M86.27,111.68c1.68.59,3.44,1.15,5.27,1.69-1.11,2.79-2.15,5.63-3.11,8.5-1.9-.56-3.74-1.15-5.49-1.76,1.03-2.85,2.15-5.66,3.34-8.43h0Z"
        />
      </clipPath>
      <clipPath id="clippath-407">
        <path
          className="cls-1"
          d="M82.93,120.11c1.75.61,3.59,1.2,5.49,1.76-.96,2.88-1.85,5.79-2.66,8.74-1.97-.58-3.87-1.19-5.68-1.82.87-2.93,1.82-5.82,2.85-8.68h0Z"
        />
      </clipPath>
      <clipPath id="clippath-408">
        <path
          className="cls-1"
          d="M80.08,128.79c1.81.63,3.71,1.24,5.68,1.82-.81,2.95-1.54,5.92-2.18,8.93-2.03-.6-3.97-1.22-5.84-1.87.69-2.99,1.47-5.95,2.34-8.88h0Z"
        />
      </clipPath>
      <clipPath id="clippath-409">
        <path
          className="cls-1"
          d="M81.89,148.62c-2.07-.61-4.06-1.25-5.96-1.91.51-3.04,1.11-6.05,1.81-9.04,1.86.65,3.81,1.27,5.84,1.87-.65,3-1.21,6.03-1.68,9.08h0Z"
        />
      </clipPath>
      <clipPath id="clippath-410">
        <path
          className="cls-1"
          d="M75.67,192.15c1.91.66,3.9,1.3,5.97,1.91.44,2.82.98,5.57,1.59,8.25-2.03-.6-3.98-1.23-5.85-1.88-.66-2.7-1.23-5.46-1.71-8.29h0Z"
        />
      </clipPath>
      <clipPath id="clippath-411">
        <path
          className="cls-1"
          d="M77.38,200.44c1.87.65,3.82,1.28,5.85,1.88.62,2.69,1.32,5.3,2.09,7.85-1.98-.58-3.88-1.19-5.7-1.83-.84-2.56-1.59-5.2-2.25-7.9h0Z"
        />
      </clipPath>
      <clipPath id="clippath-412">
        <path
          className="cls-1"
          d="M79.63,208.33c1.82.63,3.72,1.24,5.7,1.83.78,2.54,1.64,5.02,2.58,7.41-1.91-.57-3.75-1.16-5.51-1.77-1-2.42-1.93-4.91-2.76-7.47h0Z"
        />
      </clipPath>
      <clipPath id="clippath-413">
        <path
          className="cls-1"
          d="M82.39,215.8c1.76.61,3.6,1.2,5.51,1.77.94,2.39,1.95,4.71,3.03,6.95-1.84-.54-3.6-1.11-5.29-1.7-1.16-2.26-2.25-4.6-3.25-7.02h0Z"
        />
      </clipPath>
      <clipPath id="clippath-414">
        <path
          className="cls-1"
          d="M85.64,222.82c1.69.59,3.46,1.15,5.29,1.7,1.09,2.24,2.24,4.39,3.47,6.47-1.75-.52-3.43-1.06-5.04-1.62-1.32-2.1-2.56-4.28-3.72-6.55h0Z"
        />
      </clipPath>
      <clipPath id="clippath-415">
        <path
          className="cls-1"
          d="M89.37,229.37c1.61.56,3.29,1.1,5.04,1.62,1.23,2.07,2.52,4.06,3.88,5.96-1.65-.49-3.24-1-4.76-1.53-1.46-1.93-2.85-3.95-4.17-6.05h0Z"
        />
      </clipPath>
      <clipPath id="clippath-416">
        <path
          className="cls-1"
          d="M93.53,235.41c1.52.53,3.11,1.04,4.76,1.53,1.36,1.9,2.79,3.71,4.27,5.42-1.54-.46-3.03-.93-4.45-1.43-1.6-1.75-3.12-3.59-4.58-5.52h0Z"
        />
      </clipPath>
      <clipPath id="clippath-417">
        <path
          className="cls-1"
          d="M98.12,240.94c1.42.49,2.91.97,4.45,1.43,1.49,1.72,3.04,3.34,4.64,4.87-1.43-.42-2.8-.86-4.11-1.32-1.72-1.56-3.38-3.23-4.98-4.98h0Z"
        />
      </clipPath>
      <clipPath id="clippath-418">
        <path
          className="cls-1"
          d="M103.1,245.91c1.31.46,2.69.9,4.11,1.32,1.61,1.53,3.27,2.96,4.99,4.29-1.3-.38-2.55-.79-3.75-1.2-1.84-1.37-3.63-2.84-5.35-4.4h0Z"
        />
      </clipPath>
      <clipPath id="clippath-419">
        <path
          className="cls-1"
          d="M108.45,250.32c1.2.42,2.45.82,3.75,1.2,1.72,1.33,3.49,2.56,5.31,3.68-1.17-.35-2.29-.7-3.37-1.08-1.95-1.17-3.85-2.44-5.69-3.8h0Z"
        />
      </clipPath>
      <clipPath id="clippath-420">
        <path
          className="cls-1"
          d="M114.14,254.12c1.07.37,2.2.73,3.37,1.08,1.82,1.13,3.69,2.15,5.61,3.06-1.03-.3-2.01-.62-2.96-.95-2.06-.96-4.07-2.02-6.02-3.19h0Z"
        />
      </clipPath>
      <clipPath id="clippath-421">
        <path
          className="cls-1"
          d="M129.01,260.67c-.69-.21-1.37-.42-2.02-.64l-1.14-.39c-1.94-.69-3.84-1.46-5.69-2.33.94.33,1.93.65,2.96.95,1.92.91,3.88,1.72,5.89,2.41h0Z"
        />
      </clipPath>
      <clipPath id="clippath-422">
        <path
          className="cls-1"
          d="M109.43,74.27c-1.18-.41-2.31-.84-3.39-1.28,1.98-2.13,4.02-4.18,6.11-6.15.96.4,1.97.78,3.03,1.15-1.97,2.02-3.89,4.11-5.75,6.28h0Z"
        />
      </clipPath>
      <clipPath id="clippath-423">
        <path
          className="cls-1"
          d="M104.01,81c-1.3-.45-2.54-.92-3.72-1.41,1.85-2.27,3.77-4.48,5.75-6.6,1.07.44,2.2.87,3.39,1.28-1.86,2.17-3.67,4.42-5.41,6.73h0Z"
        />
      </clipPath>
      <clipPath id="clippath-424">
        <path
          className="cls-1"
          d="M98.97,88.14c-1.41-.49-2.75-1-4.03-1.53,1.72-2.41,3.51-4.75,5.36-7.02,1.18.49,2.42.96,3.72,1.41-1.74,2.31-3.43,4.7-5.05,7.14h0Z"
        />
      </clipPath>
      <clipPath id="clippath-425">
        <path
          className="cls-1"
          d="M94.31,95.66c-1.51-.52-2.95-1.07-4.32-1.63,1.58-2.53,3.22-5,4.94-7.41,1.28.53,2.62,1.04,4.03,1.53-1.62,2.45-3.17,4.95-4.66,7.52h0Z"
        />
      </clipPath>
      <clipPath id="clippath-426">
        <path
          className="cls-1"
          d="M86.27,111.68c-1.68-.59-3.29-1.19-4.81-1.82,1.26-2.74,2.61-5.44,4.04-8.08,1.45.6,2.98,1.18,4.58,1.73-1.34,2.67-2.61,5.4-3.8,8.17h0Z"
        />
      </clipPath>
      <clipPath id="clippath-427">
        <path
          className="cls-1"
          d="M82.93,120.11c-1.75-.61-3.43-1.24-5.02-1.9,1.1-2.83,2.28-5.61,3.54-8.35,1.53.63,3.13,1.24,4.81,1.82-1.19,2.77-2.3,5.58-3.34,8.43h0Z"
        />
      </clipPath>
      <clipPath id="clippath-428">
        <path
          className="cls-1"
          d="M77.91,118.22c1.59.66,3.27,1.29,5.02,1.9-1.03,2.85-1.99,5.75-2.85,8.68-1.81-.63-3.55-1.29-5.19-1.96.92-2.91,1.93-5.78,3.03-8.61h0Z"
        />
      </clipPath>
      <clipPath id="clippath-429">
        <path
          className="cls-1"
          d="M74.88,126.83c1.65.68,3.38,1.33,5.19,1.96-.87,2.93-1.65,5.89-2.34,8.88-1.86-.65-3.65-1.32-5.34-2.02.73-2.97,1.56-5.92,2.48-8.82h0Z"
        />
      </clipPath>
      <clipPath id="clippath-430">
        <path
          className="cls-1"
          d="M72.4,135.65c1.69.7,3.47,1.37,5.34,2.02-.69,2.99-1.3,6.01-1.81,9.04-1.9-.66-3.72-1.35-5.45-2.06.54-3.03,1.18-6.03,1.92-9h0Z"
        />
      </clipPath>
      <clipPath id="clippath-431">
        <path
          className="cls-1"
          d="M74.69,155.88c-1.93-.67-3.77-1.37-5.52-2.09.34-3.07.78-6.12,1.32-9.15,1.73.71,3.54,1.4,5.45,2.06-.51,3.04-.93,6.1-1.25,9.17h0Z"
        />
      </clipPath>
      <clipPath id="clippath-432">
        <path
          className="cls-1"
          d="M70.21,190.08c1.73.71,3.55,1.4,5.46,2.07.48,2.83,1.05,5.59,1.71,8.29-1.87-.65-3.66-1.33-5.35-2.02-.7-2.71-1.31-5.49-1.81-8.33h0Z"
        />
      </clipPath>
      <clipPath id="clippath-433">
        <path
          className="cls-1"
          d="M72.03,198.41c1.7.7,3.48,1.37,5.35,2.02.66,2.7,1.41,5.33,2.25,7.9-1.82-.63-3.56-1.29-5.21-1.97-.89-2.58-1.69-5.23-2.39-7.95h0Z"
        />
      </clipPath>
      <clipPath id="clippath-434">
        <path
          className="cls-1"
          d="M74.41,206.36c1.65.68,3.39,1.34,5.21,1.97.84,2.56,1.76,5.05,2.76,7.47-1.76-.61-3.44-1.25-5.04-1.91-1.07-2.44-2.05-4.95-2.93-7.53h0Z"
        />
      </clipPath>
      <clipPath id="clippath-435">
        <path
          className="cls-1"
          d="M77.35,213.89c1.6.66,3.28,1.29,5.04,1.91,1,2.42,2.09,4.76,3.25,7.02-1.69-.59-3.31-1.2-4.84-1.83-1.24-2.29-2.39-4.66-3.46-7.1h0Z"
        />
      </clipPath>
      <clipPath id="clippath-436">
        <path
          className="cls-1"
          d="M80.81,220.99c1.53.63,3.15,1.24,4.84,1.83,1.16,2.26,2.41,4.45,3.72,6.55-1.61-.56-3.15-1.14-4.61-1.74-1.4-2.13-2.72-4.34-3.95-6.63h0Z"
        />
      </clipPath>
      <clipPath id="clippath-437">
        <path
          className="cls-1"
          d="M84.76,227.62c1.46.6,3,1.18,4.61,1.74,1.32,2.1,2.71,4.12,4.17,6.05-1.52-.53-2.97-1.08-4.35-1.65-1.55-1.96-3.03-4.01-4.42-6.14h0Z"
        />
      </clipPath>
      <clipPath id="clippath-438">
        <path
          className="cls-1"
          d="M89.18,233.77c1.38.57,2.83,1.12,4.35,1.65,1.46,1.93,2.99,3.77,4.58,5.52-1.42-.49-2.78-1.01-4.07-1.54-1.69-1.79-3.32-3.67-4.87-5.63h0Z"
        />
      </clipPath>
      <clipPath id="clippath-439">
        <path
          className="cls-1"
          d="M94.05,239.4c1.29.53,2.65,1.04,4.07,1.54,1.6,1.75,3.26,3.41,4.98,4.98-1.31-.46-2.57-.93-3.76-1.42-1.83-1.61-3.59-3.3-5.29-5.09h0Z"
        />
      </clipPath>
      <clipPath id="clippath-440">
        <path
          className="cls-1"
          d="M99.34,244.49c1.19.49,2.45.97,3.76,1.42,1.72,1.56,3.51,3.03,5.35,4.4-1.2-.42-2.34-.85-3.43-1.3-1.96-1.41-3.85-2.92-5.68-4.53h0Z"
        />
      </clipPath>
      <clipPath id="clippath-441">
        <path
          className="cls-1"
          d="M114.14,254.12c-1.07-.37-2.1-.76-3.08-1.16-2.07-1.21-4.09-2.53-6.04-3.94,1.09.45,2.23.88,3.43,1.3,1.84,1.37,3.74,2.64,5.69,3.8h0Z"
        />
      </clipPath>
      <clipPath id="clippath-442">
        <path
          className="cls-1"
          d="M120.16,257.31c-.94-.33-1.85-.67-2.7-1.02-2.18-1-4.32-2.12-6.39-3.33.97.4,2,.79,3.08,1.16,1.95,1.17,3.96,2.23,6.02,3.19h0Z"
        />
      </clipPath>
      <clipPath id="clippath-443">
        <path
          className="cls-1"
          d="M100.29,79.59c-1.18-.49-2.3-.99-3.34-1.51,1.95-2.23,3.97-4.39,6.05-6.47.95.47,1.97.93,3.04,1.37-1.98,2.13-3.89,4.33-5.75,6.6h0Z"
        />
      </clipPath>
      <clipPath id="clippath-444">
        <path
          className="cls-1"
          d="M96.95,78.08c1.05.52,2.17,1.02,3.34,1.51-1.85,2.27-3.64,4.62-5.36,7.02-1.28-.53-2.49-1.07-3.62-1.63,1.81-2.37,3.69-4.67,5.64-6.9h0Z"
        />
      </clipPath>
      <clipPath id="clippath-445">
        <path
          className="cls-1"
          d="M91.31,84.98c1.14.56,2.35,1.11,3.62,1.63-1.72,2.41-3.37,4.88-4.94,7.41-1.37-.56-2.66-1.15-3.88-1.75,1.66-2.49,3.39-4.93,5.2-7.29h0Z"
        />
      </clipPath>
      <clipPath id="clippath-446">
        <path
          className="cls-1"
          d="M85.49,101.78c-1.45-.6-2.83-1.22-4.12-1.86,1.5-2.61,3.08-5.16,4.74-7.66,1.22.6,2.51,1.19,3.88,1.75-1.58,2.53-3.08,5.12-4.5,7.76h0Z"
        />
      </clipPath>
      <clipPath id="clippath-447">
        <path
          className="cls-1"
          d="M77.91,118.22c-1.59-.66-3.1-1.33-4.51-2.03,1.15-2.8,2.4-5.56,3.73-8.27,1.36.67,2.8,1.32,4.33,1.95-1.26,2.74-2.45,5.53-3.54,8.35h0Z"
        />
      </clipPath>
      <clipPath id="clippath-448">
        <path
          className="cls-1"
          d="M73.4,116.18c1.41.7,2.92,1.38,4.51,2.03-1.1,2.83-2.11,5.7-3.03,8.61-1.65-.68-3.2-1.38-4.67-2.1.97-2.89,2.03-5.73,3.19-8.54h0Z"
        />
      </clipPath>
      <clipPath id="clippath-449">
        <path
          className="cls-1"
          d="M70.22,124.72c1.46.72,3.02,1.43,4.67,2.1-.92,2.91-1.75,5.85-2.48,8.82-1.69-.7-3.29-1.42-4.8-2.16.77-2.96,1.65-5.88,2.61-8.76h0Z"
        />
      </clipPath>
      <clipPath id="clippath-450">
        <path
          className="cls-1"
          d="M67.6,133.48c1.5.74,3.11,1.47,4.8,2.16-.73,2.97-1.37,5.98-1.92,9-1.73-.71-3.36-1.45-4.9-2.21.57-3.01,1.24-6,2.02-8.96h0Z"
        />
      </clipPath>
      <clipPath id="clippath-451">
        <path
          className="cls-1"
          d="M65.59,142.44c1.54.76,3.17,1.5,4.9,2.21-.54,3.03-.98,6.08-1.32,9.15-1.75-.72-3.41-1.47-4.96-2.24.36-3.06.82-6.1,1.39-9.11h0Z"
        />
      </clipPath>
      <clipPath id="clippath-452">
        <path
          className="cls-1"
          d="M68.46,163.05c-1.76-.73-3.43-1.48-5-2.25.13-3.1.38-6.18.74-9.24,1.56.77,3.21,1.52,4.96,2.24-.34,3.07-.57,6.16-.7,9.26h0Z"
        />
      </clipPath>
      <clipPath id="clippath-453">
        <path
          className="cls-1"
          d="M65.31,187.87c1.54.76,3.18,1.5,4.91,2.21.51,2.84,1.11,5.61,1.81,8.33-1.7-.7-3.3-1.42-4.81-2.17-.74-2.73-1.38-5.52-1.91-8.37h0Z"
        />
      </clipPath>
      <clipPath id="clippath-454">
        <path
          className="cls-1"
          d="M67.22,196.24c1.51.75,3.11,1.47,4.81,2.17.7,2.72,1.5,5.37,2.39,7.95-1.65-.68-3.22-1.39-4.68-2.11-.94-2.6-1.77-5.27-2.51-8h0Z"
        />
      </clipPath>
      <clipPath id="clippath-455">
        <path
          className="cls-1"
          d="M69.73,204.25c1.47.73,3.03,1.43,4.68,2.11.89,2.58,1.87,5.09,2.93,7.53-1.6-.66-3.11-1.34-4.53-2.04-1.12-2.47-2.15-5-3.09-7.6h0Z"
        />
      </clipPath>
      <clipPath id="clippath-456">
        <path
          className="cls-1"
          d="M72.82,211.85c1.42.7,2.93,1.38,4.53,2.04,1.07,2.44,2.22,4.81,3.46,7.1-1.53-.63-2.99-1.29-4.35-1.96-1.3-2.32-2.52-4.71-3.64-7.18h0Z"
        />
      </clipPath>
      <clipPath id="clippath-457">
        <path
          className="cls-1"
          d="M84.76,227.62c-1.46-.6-2.84-1.22-4.14-1.87-1.47-2.16-2.86-4.41-4.16-6.73,1.36.67,2.82,1.33,4.35,1.96,1.24,2.29,2.56,4.5,3.95,6.63h0Z"
        />
      </clipPath>
      <clipPath id="clippath-458">
        <path
          className="cls-1"
          d="M91.31,84.98c-.79-.39-1.54-.79-2.26-1.2-.32-.18-.62-.36-.92-.54,1.89-2.32,3.85-4.58,5.88-6.76.27.17.56.33.85.5.66.38,1.36.74,2.09,1.11-1.95,2.23-3.83,4.53-5.64,6.9h0Z"
        />
      </clipPath>
      <clipPath id="clippath-459">
        <path
          className="cls-1"
          d="M88.13,83.24c.3.18.6.36.92.54.72.41,1.47.81,2.26,1.2-1.81,2.37-3.54,4.8-5.2,7.29-.85-.42-1.65-.85-2.42-1.28-.34-.19-.67-.38-.98-.58,1.73-2.45,3.54-4.85,5.43-7.17h0Z"
        />
      </clipPath>
      <clipPath id="clippath-460">
        <path
          className="cls-1"
          d="M82.7,90.41c.32.19.65.39.98.58.77.44,1.58.86,2.42,1.28-1.66,2.49-3.24,5.05-4.74,7.66-.9-.44-1.75-.9-2.57-1.36-.36-.2-.71-.41-1.04-.61,1.56-2.57,3.21-5.09,4.94-7.54h0Z"
        />
      </clipPath>
      <clipPath id="clippath-461">
        <path
          className="cls-1"
          d="M77.13,107.91c-.94-.47-1.84-.94-2.7-1.43-.38-.21-.74-.43-1.1-.64,1.39-2.68,2.87-5.31,4.43-7.88.34.2.69.41,1.04.61.81.46,1.67.92,2.57,1.36-1.5,2.61-2.92,5.27-4.25,7.98h0Z"
        />
      </clipPath>
      <clipPath id="clippath-462">
        <path
          className="cls-1"
          d="M73.33,105.84c.35.22.72.43,1.1.64.86.49,1.76.96,2.7,1.43-1.33,2.71-2.57,5.47-3.73,8.27-.98-.49-1.92-.98-2.81-1.49-.39-.22-.77-.45-1.14-.67,1.2-2.77,2.5-5.5,3.89-8.18h0Z"
        />
      </clipPath>
      <clipPath id="clippath-463">
        <path
          className="cls-1"
          d="M69.44,114.02c.37.22.75.45,1.14.67.89.51,1.83,1,2.81,1.49-1.15,2.8-2.22,5.65-3.19,8.54-1.02-.5-1.99-1.02-2.91-1.54-.41-.23-.8-.46-1.18-.69,1.01-2.86,2.12-5.69,3.32-8.46h0Z"
        />
      </clipPath>
      <clipPath id="clippath-464">
        <path
          className="cls-1"
          d="M66.12,122.48c.38.23.78.46,1.18.69.92.52,1.9,1.04,2.91,1.54-.97,2.89-1.84,5.81-2.61,8.76-1.05-.52-2.04-1.05-2.99-1.58-.42-.24-.82-.47-1.22-.71.81-2.94,1.72-5.84,2.73-8.7h0Z"
        />
      </clipPath>
      <clipPath id="clippath-465">
        <path
          className="cls-1"
          d="M63.39,131.19c.39.24.8.48,1.22.71.95.54,1.95,1.07,2.99,1.58-.77,2.96-1.45,5.94-2.02,8.96-1.07-.53-2.09-1.07-3.05-1.62-.43-.24-.84-.48-1.24-.73.59-3,1.3-5.97,2.1-8.91h0Z"
        />
      </clipPath>
      <clipPath id="clippath-466">
        <path
          className="cls-1"
          d="M61.29,140.1c.4.24.82.49,1.24.73.97.55,1.99,1.09,3.05,1.62-.57,3.01-1.03,6.05-1.39,9.11-1.08-.54-2.11-1.08-3.1-1.64-.43-.25-.85-.49-1.26-.74.37-3.05.86-6.08,1.45-9.08h0Z"
        />
      </clipPath>
      <clipPath id="clippath-467">
        <path
          className="cls-1"
          d="M59.84,149.18c.41.25.83.49,1.26.74.98.56,2.02,1.11,3.1,1.64-.36,3.06-.6,6.14-.74,9.24-1.09-.54-2.13-1.09-3.12-1.65-.43-.25-.86-.49-1.27-.74.14-3.09.4-6.17.77-9.22h0Z"
        />
      </clipPath>
      <clipPath id="clippath-468">
        <path
          className="cls-1"
          d="M63.4,170.09c-1.09-.54-2.13-1.09-3.12-1.65-.44-.25-.86-.5-1.27-.74-.04-1.36-.07-2.72-.06-4.09,0-1.74.04-3.47.12-5.2.41.25.83.5,1.27.74.99.56,2.03,1.11,3.12,1.65-.07,1.73-.11,3.46-.12,5.2,0,1.37.02,2.74.06,4.09h0Z"
        />
      </clipPath>
      <clipPath id="clippath-469">
        <path
          className="cls-1"
          d="M65.31,187.87c-1.07-.53-2.09-1.07-3.06-1.62-.43-.24-.84-.49-1.24-.73-.56-2.87-1-5.79-1.34-8.76.41.25.83.49,1.26.74.98.56,2.02,1.11,3.1,1.64.32,2.97.75,5.88,1.28,8.73h0Z"
        />
      </clipPath>
      <clipPath id="clippath-470">
        <path
          className="cls-1"
          d="M61,185.52c.4.24.82.49,1.24.73.97.55,1.99,1.09,3.06,1.62.53,2.85,1.17,5.64,1.91,8.37-1.05-.52-2.05-1.05-3-1.59-.42-.24-.82-.48-1.22-.72-.77-2.75-1.44-5.55-1.99-8.42h0Z"
        />
      </clipPath>
      <clipPath id="clippath-471">
        <path
          className="cls-1"
          d="M69.73,204.25c-1.02-.51-2-1.02-2.92-1.55-.41-.23-.8-.46-1.19-.7-.98-2.63-1.85-5.32-2.62-8.07.39.24.8.48,1.22.72.95.54,1.95,1.07,3,1.59.74,2.73,1.58,5.4,2.51,8h0Z"
        />
      </clipPath>
      <clipPath id="clippath-472">
        <path
          className="cls-1"
          d="M72.82,211.85c-.99-.49-1.93-.99-2.83-1.5-.39-.22-.78-.45-1.15-.67-1.17-2.49-2.25-5.05-3.22-7.68.38.23.78.47,1.19.7.93.53,1.9,1.04,2.92,1.55.94,2.6,1.97,5.14,3.09,7.6h0Z"
        />
      </clipPath>
      <clipPath id="clippath-473">
        <path
          className="cls-1"
          d="M91.58,74.83c.72.55,1.53,1.1,2.43,1.65-2.03,2.18-4,4.44-5.88,6.76-.97-.59-1.85-1.19-2.64-1.79,1.95-2.28,3.98-4.49,6.08-6.63h0Z"
        />
      </clipPath>
      <clipPath id="clippath-474">
        <path
          className="cls-1"
          d="M85.49,81.46c.78.6,1.66,1.2,2.64,1.79-1.89,2.32-3.7,4.72-5.43,7.17-1.04-.63-1.98-1.27-2.82-1.91,1.79-2.41,3.66-4.76,5.61-7.04h0Z"
        />
      </clipPath>
      <clipPath id="clippath-475">
        <path
          className="cls-1"
          d="M79.88,88.5c.84.64,1.78,1.28,2.82,1.91-1.73,2.45-3.38,4.97-4.94,7.54-1.11-.67-2.1-1.35-2.99-2.03,1.62-2.54,3.32-5.01,5.11-7.43h0Z"
        />
      </clipPath>
      <clipPath id="clippath-476">
        <path
          className="cls-1"
          d="M74.77,95.93c.89.68,1.89,1.36,2.99,2.03-1.56,2.57-3.04,5.2-4.43,7.88-1.16-.7-2.21-1.42-3.15-2.13,1.44-2.65,2.97-5.24,4.58-7.78h0Z"
        />
      </clipPath>
      <clipPath id="clippath-477">
        <path
          className="cls-1"
          d="M70.18,103.71c.94.72,1.98,1.43,3.15,2.13-1.39,2.68-2.68,5.41-3.89,8.18-1.21-.73-2.3-1.48-3.28-2.22,1.24-2.75,2.59-5.44,4.02-8.09h0Z"
        />
      </clipPath>
      <clipPath id="clippath-478">
        <path
          className="cls-1"
          d="M66.16,111.8c.98.75,2.07,1.49,3.28,2.22-1.2,2.78-2.31,5.6-3.32,8.46-1.25-.76-2.39-1.53-3.39-2.3,1.04-2.84,2.19-5.64,3.44-8.39h0Z"
        />
      </clipPath>
      <clipPath id="clippath-479">
        <path
          className="cls-1"
          d="M62.72,120.18c1.01.77,2.14,1.54,3.39,2.3-1.01,2.86-1.92,5.77-2.73,8.7-1.29-.78-2.45-1.57-3.49-2.36.83-2.92,1.78-5.8,2.82-8.64h0Z"
        />
      </clipPath>
      <clipPath id="clippath-480">
        <path
          className="cls-1"
          d="M59.9,128.82c1.04.79,2.2,1.58,3.49,2.36-.81,2.94-1.51,5.91-2.1,8.91-1.32-.8-2.5-1.6-3.56-2.41.61-2.99,1.34-5.94,2.17-8.86h0Z"
        />
      </clipPath>
      <clipPath id="clippath-481">
        <path
          className="cls-1"
          d="M57.73,137.68c1.06.81,2.24,1.62,3.56,2.41-.59,3-1.08,6.03-1.45,9.08-1.33-.81-2.54-1.62-3.61-2.45.38-3.04.89-6.06,1.5-9.05h0Z"
        />
      </clipPath>
      <clipPath id="clippath-482">
        <path
          className="cls-1"
          d="M56.23,146.73c1.07.82,2.28,1.64,3.61,2.45-.37,3.05-.63,6.13-.77,9.22-1.34-.81-2.55-1.64-3.64-2.46.14-3.09.41-6.16.79-9.2h0Z"
        />
      </clipPath>
      <clipPath id="clippath-483">
        <path
          className="cls-1"
          d="M59.01,167.69c-1.34-.81-2.56-1.64-3.64-2.46-.05-1.36-.07-2.72-.07-4.09,0-1.74.05-3.47.13-5.2,1.08.83,2.29,1.65,3.64,2.46-.08,1.73-.12,3.46-.12,5.2,0,1.37.02,2.74.06,4.09h0Z"
        />
      </clipPath>
      <clipPath id="clippath-484">
        <path
          className="cls-1"
          d="M59.67,176.76c-1.34-.81-2.54-1.63-3.61-2.45-.34-2.98-.57-6.01-.68-9.08,1.08.83,2.29,1.65,3.64,2.46.1,3.07.32,6.1.65,9.07h0Z"
        />
      </clipPath>
      <clipPath id="clippath-485">
        <path
          className="cls-1"
          d="M56.05,174.31c1.07.82,2.28,1.64,3.61,2.45.33,2.97.78,5.89,1.34,8.76-1.32-.8-2.51-1.61-3.57-2.42-.58-2.88-1.04-5.81-1.38-8.79h0Z"
        />
      </clipPath>
      <clipPath id="clippath-486">
        <path
          className="cls-1"
          d="M63,193.94c-1.29-.78-2.46-1.57-3.5-2.37-.8-2.77-1.49-5.59-2.06-8.46,1.06.81,2.25,1.62,3.57,2.42.56,2.86,1.22,5.67,1.99,8.42h0Z"
        />
      </clipPath>
      <clipPath id="clippath-487">
        <path
          className="cls-1"
          d="M91.58,74.83c-.72-.55-1.36-1.11-1.91-1.67,2.16-2.09,4.39-4.1,6.7-6.03.5.51,1.08,1.02,1.74,1.52-2.25,1.98-4.42,4.04-6.53,6.18h0Z"
        />
      </clipPath>
      <clipPath id="clippath-488">
        <path
          className="cls-1"
          d="M89.67,73.16c.55.56,1.19,1.12,1.91,1.67-2.1,2.14-4.13,4.35-6.08,6.63-.78-.6-1.47-1.2-2.07-1.81,2-2.24,4.09-4.4,6.24-6.49h0Z"
        />
      </clipPath>
      <clipPath id="clippath-489">
        <path
          className="cls-1"
          d="M83.43,79.65c.6.61,1.29,1.21,2.07,1.81-1.95,2.28-3.82,4.63-5.61,7.04-.84-.64-1.58-1.29-2.22-1.94,1.84-2.37,3.76-4.68,5.76-6.92h0Z"
        />
      </clipPath>
      <clipPath id="clippath-490">
        <path
          className="cls-1"
          d="M77.67,86.56c.64.65,1.38,1.3,2.22,1.94-1.79,2.41-3.5,4.89-5.11,7.43-.89-.68-1.67-1.37-2.35-2.05,1.66-2.5,3.41-4.94,5.25-7.31h0Z"
        />
      </clipPath>
      <clipPath id="clippath-491">
        <path
          className="cls-1"
          d="M72.42,93.87c.68.69,1.46,1.37,2.35,2.05-1.62,2.54-3.15,5.13-4.58,7.78-.93-.72-1.76-1.44-2.47-2.16,1.47-2.62,3.04-5.18,4.7-7.68h0Z"
        />
      </clipPath>
      <clipPath id="clippath-492">
        <path
          className="cls-1"
          d="M67.71,101.55c.71.72,1.53,1.44,2.47,2.16-1.43,2.65-2.78,5.34-4.02,8.09-.97-.75-1.83-1.5-2.57-2.25,1.28-2.72,2.65-5.39,4.13-8h0Z"
        />
      </clipPath>
      <clipPath id="clippath-493">
        <path
          className="cls-1"
          d="M63.59,109.55c.74.75,1.6,1.51,2.57,2.25-1.25,2.75-2.39,5.55-3.44,8.39-1.01-.77-1.9-1.55-2.66-2.33,1.07-2.82,2.25-5.59,3.53-8.31h0Z"
        />
      </clipPath>
      <clipPath id="clippath-494">
        <path
          className="cls-1"
          d="M60.06,117.85c.77.78,1.66,1.56,2.66,2.33-1.04,2.84-1.99,5.72-2.82,8.64-1.04-.79-1.95-1.59-2.74-2.39.86-2.9,1.82-5.76,2.89-8.57h0Z"
        />
      </clipPath>
      <clipPath id="clippath-495">
        <path
          className="cls-1"
          d="M57.17,126.43c.79.8,1.7,1.6,2.74,2.39-.83,2.92-1.56,5.87-2.17,8.86-1.06-.81-1.99-1.62-2.79-2.44.63-2.97,1.38-5.91,2.23-8.81h0Z"
        />
      </clipPath>
      <clipPath id="clippath-496">
        <path
          className="cls-1"
          d="M54.94,135.24c.81.82,1.74,1.63,2.79,2.44-.61,2.99-1.11,6-1.5,9.05-1.07-.82-2.02-1.65-2.83-2.48.39-3.04.91-6.04,1.54-9.01h0Z"
        />
      </clipPath>
      <clipPath id="clippath-497">
        <path
          className="cls-1"
          d="M53.4,144.25c.82.83,1.76,1.66,2.83,2.48-.38,3.04-.65,6.11-.79,9.2-1.08-.83-2.03-1.66-2.85-2.5.15-3.09.42-6.15.81-9.19h0Z"
        />
      </clipPath>
      <clipPath id="clippath-498">
        <path
          className="cls-1"
          d="M52.58,153.44c.82.84,1.77,1.67,2.85,2.5-.08,1.73-.12,3.46-.13,5.2,0,1.37.02,2.74.07,4.09-1.08-.83-2.03-1.66-2.86-2.5-.05-1.36-.07-2.72-.07-4.1,0-1.74.05-3.47.13-5.2h0Z"
        />
      </clipPath>
      <clipPath id="clippath-499">
        <path
          className="cls-1"
          d="M56.05,174.31c-1.07-.82-2.02-1.65-2.84-2.48-.35-2.99-.59-6.02-.69-9.1.82.84,1.77,1.67,2.86,2.5.1,3.07.33,6.1.68,9.08h0Z"
        />
      </clipPath>
      <clipPath id="clippath-500">
        <path
          className="cls-1"
          d="M53.21,171.83c.82.83,1.76,1.66,2.84,2.48.34,2.98.81,5.91,1.38,8.79-1.06-.81-1.99-1.63-2.8-2.45-.59-2.89-1.07-5.83-1.42-8.82h0Z"
        />
      </clipPath>
      <clipPath id="clippath-501">
        <path
          className="cls-1"
          d="M95.09,65.6c.35.51.77,1.03,1.27,1.54-2.3,1.93-4.54,3.94-6.7,6.03-.55-.56-1.02-1.12-1.4-1.69,2.2-2.04,4.48-4,6.82-5.88h0Z"
        />
      </clipPath>
      <clipPath id="clippath-502">
        <path
          className="cls-1"
          d="M88.27,71.47c.38.56.85,1.13,1.4,1.69-2.16,2.09-4.24,4.25-6.24,6.49-.6-.61-1.1-1.22-1.52-1.83,2.04-2.19,4.16-4.31,6.36-6.35h0Z"
        />
      </clipPath>
      <clipPath id="clippath-503">
        <path
          className="cls-1"
          d="M81.91,77.82c.41.61.92,1.22,1.52,1.83-2,2.24-3.92,4.54-5.76,6.92-.64-.65-1.18-1.3-1.62-1.96,1.87-2.33,3.83-4.6,5.87-6.79h0Z"
        />
      </clipPath>
      <clipPath id="clippath-504">
        <path
          className="cls-1"
          d="M76.04,84.6c.44.65.98,1.31,1.62,1.96-1.84,2.37-3.59,4.81-5.25,7.31-.68-.69-1.25-1.38-1.72-2.08,1.69-2.46,3.47-4.86,5.35-7.19h0Z"
        />
      </clipPath>
      <clipPath id="clippath-505">
        <path
          className="cls-1"
          d="M70.7,91.8c.47.69,1.04,1.39,1.72,2.08-1.66,2.5-3.23,5.06-4.7,7.68-.71-.72-1.32-1.45-1.81-2.18,1.5-2.58,3.1-5.11,4.79-7.57h0Z"
        />
      </clipPath>
      <clipPath id="clippath-506">
        <path
          className="cls-1"
          d="M65.9,99.37c.49.73,1.1,1.46,1.81,2.18-1.47,2.61-2.85,5.28-4.13,8-.74-.76-1.37-1.51-1.89-2.27,1.3-2.69,2.7-5.33,4.2-7.91h0Z"
        />
      </clipPath>
      <clipPath id="clippath-507">
        <path
          className="cls-1"
          d="M61.7,107.27c.52.76,1.14,1.52,1.89,2.27-1.28,2.72-2.46,5.49-3.53,8.31-.77-.78-1.42-1.57-1.95-2.35,1.09-2.79,2.29-5.54,3.59-8.23h0Z"
        />
      </clipPath>
      <clipPath id="clippath-508">
        <path
          className="cls-1"
          d="M58.11,115.5c.53.79,1.18,1.57,1.95,2.35-1.07,2.82-2.04,5.68-2.89,8.57-.79-.8-1.46-1.61-2.01-2.42.87-2.88,1.86-5.72,2.95-8.51h0Z"
        />
      </clipPath>
      <clipPath id="clippath-509">
        <path
          className="cls-1"
          d="M55.16,124.01c.55.81,1.22,1.62,2.01,2.42-.86,2.9-1.6,5.84-2.23,8.81-.81-.82-1.49-1.64-2.05-2.47.64-2.96,1.4-5.88,2.27-8.76h0Z"
        />
      </clipPath>
      <clipPath id="clippath-510">
        <path
          className="cls-1"
          d="M52.89,132.77c.56.83,1.24,1.65,2.05,2.47-.63,2.97-1.14,5.98-1.54,9.01-.82-.83-1.51-1.67-2.08-2.5.4-3.03.92-6.02,1.57-8.98h0Z"
        />
      </clipPath>
      <clipPath id="clippath-511">
        <path
          className="cls-1"
          d="M51.32,141.75c.57.84,1.26,1.67,2.08,2.5-.39,3.04-.67,6.1-.81,9.19-.82-.84-1.52-1.68-2.09-2.52.15-3.08.43-6.14.83-9.17h0Z"
        />
      </clipPath>
      <clipPath id="clippath-512">
        <path
          className="cls-1"
          d="M50.49,150.92c.57.84,1.27,1.68,2.09,2.52-.08,1.72-.13,3.46-.13,5.2,0,1.37.02,2.74.07,4.1-.82-.84-1.52-1.68-2.09-2.52-.05-1.36-.07-2.72-.07-4.1,0-1.74.05-3.47.13-5.19h0Z"
        />
      </clipPath>
      <clipPath id="clippath-513">
        <path
          className="cls-1"
          d="M50.43,160.21c.57.84,1.27,1.69,2.09,2.52.11,3.08.34,6.11.69,9.1-.82-.83-1.51-1.67-2.08-2.51-.36-3-.6-6.04-.71-9.12h0Z"
        />
      </clipPath>
      <clipPath id="clippath-514">
        <path
          className="cls-1"
          d="M54.64,180.66c-.81-.82-1.49-1.65-2.05-2.47-.6-2.91-1.09-5.86-1.45-8.86.57.84,1.26,1.67,2.08,2.51.35,2.99.83,5.93,1.42,8.82h0Z"
        />
      </clipPath>
      <clipPath id="clippath-515">
        <path
          className="cls-1"
          d="M95.09,65.6c-.35-.51-.62-1.03-.82-1.54,2.38-1.82,4.82-3.56,7.34-5.21.18.46.42.92.73,1.38-2.49,1.7-4.91,3.5-7.25,5.38h0Z"
        />
      </clipPath>
      <clipPath id="clippath-516">
        <path
          className="cls-1"
          d="M94.28,64.05c.2.51.47,1.03.82,1.54-2.35,1.88-4.62,3.84-6.82,5.88-.38-.56-.68-1.13-.9-1.69,2.23-1.99,4.53-3.9,6.9-5.72h0Z"
        />
      </clipPath>
      <clipPath id="clippath-517">
        <path
          className="cls-1"
          d="M87.37,69.78c.22.57.51,1.13.9,1.69-2.2,2.04-4.32,4.16-6.36,6.35-.41-.61-.74-1.22-.97-1.84,2.06-2.15,4.21-4.22,6.44-6.21h0Z"
        />
      </clipPath>
      <clipPath id="clippath-518">
        <path
          className="cls-1"
          d="M80.94,75.98c.23.61.56,1.23.97,1.84-2.04,2.19-4,4.45-5.87,6.79-.44-.65-.79-1.31-1.04-1.97,1.89-2.29,3.87-4.51,5.94-6.66h0Z"
        />
      </clipPath>
      <clipPath id="clippath-519">
        <path
          className="cls-1"
          d="M75,82.64c.25.66.6,1.31,1.04,1.97-1.87,2.33-3.65,4.73-5.35,7.19-.47-.69-.84-1.39-1.1-2.09,1.71-2.42,3.52-4.78,5.41-7.07h0Z"
        />
      </clipPath>
      <clipPath id="clippath-520">
        <path
          className="cls-1"
          d="M69.59,89.71c.27.7.63,1.39,1.1,2.09-1.69,2.46-3.29,4.99-4.79,7.57-.49-.73-.88-1.46-1.16-2.19,1.52-2.55,3.14-5.04,4.85-7.46h0Z"
        />
      </clipPath>
      <clipPath id="clippath-521">
        <path
          className="cls-1"
          d="M64.74,97.17c.28.73.67,1.46,1.16,2.19-1.5,2.58-2.9,5.22-4.2,7.91-.52-.76-.92-1.52-1.21-2.29,1.32-2.66,2.74-5.27,4.25-7.81h0Z"
        />
      </clipPath>
      <clipPath id="clippath-522">
        <path
          className="cls-1"
          d="M60.49,104.99c.29.76.69,1.52,1.21,2.29-1.3,2.69-2.5,5.44-3.59,8.23-.53-.79-.95-1.58-1.25-2.37,1.1-2.77,2.32-5.48,3.64-8.15h0Z"
        />
      </clipPath>
      <clipPath id="clippath-523">
        <path
          className="cls-1"
          d="M56.86,113.13c.3.79.72,1.58,1.25,2.37-1.09,2.79-2.08,5.63-2.95,8.51-.55-.81-.98-1.62-1.29-2.43.88-2.86,1.88-5.68,2.98-8.44h0Z"
        />
      </clipPath>
      <clipPath id="clippath-524">
        <path
          className="cls-1"
          d="M53.87,121.58c.31.81.74,1.62,1.29,2.43-.87,2.88-1.63,5.8-2.27,8.76-.56-.83-1-1.65-1.31-2.48.65-2.94,1.42-5.85,2.3-8.71h0Z"
        />
      </clipPath>
      <clipPath id="clippath-525">
        <path
          className="cls-1"
          d="M51.57,130.29c.32.83.75,1.66,1.31,2.48-.64,2.96-1.17,5.95-1.57,8.98-.57-.84-1.01-1.68-1.33-2.52.41-3.02.94-6,1.58-8.95h0Z"
        />
      </clipPath>
      <clipPath id="clippath-526">
        <path
          className="cls-1"
          d="M49.99,139.23c.32.84.76,1.68,1.33,2.52-.4,3.03-.68,6.08-.83,9.17-.57-.84-1.02-1.69-1.34-2.53.15-3.08.43-6.13.84-9.15h0Z"
        />
      </clipPath>
      <clipPath id="clippath-527">
        <path
          className="cls-1"
          d="M49.15,148.39c.32.85.77,1.69,1.34,2.53-.08,1.72-.13,3.45-.13,5.19,0,1.37.02,2.74.07,4.1-.57-.84-1.02-1.69-1.34-2.53-.05-1.36-.07-2.73-.07-4.1,0-1.74.05-3.47.13-5.19h0Z"
        />
      </clipPath>
      <clipPath id="clippath-528">
        <path
          className="cls-1"
          d="M51.13,169.32c-.57-.84-1.01-1.68-1.33-2.52-.37-3-.61-6.05-.72-9.13.32.85.77,1.69,1.34,2.53.11,3.08.35,6.12.71,9.12h0Z"
        />
      </clipPath>
      <clipPath id="clippath-529">
        <path
          className="cls-1"
          d="M94.28,64.05c-.2-.51-.32-1.03-.37-1.54,2.39-1.77,4.85-3.46,7.38-5.05.04.46.15.92.33,1.38-2.52,1.65-4.96,3.39-7.34,5.21h0Z"
        />
      </clipPath>
      <clipPath id="clippath-530">
        <path
          className="cls-1"
          d="M93.91,62.51c.05.51.17,1.03.37,1.54-2.38,1.82-4.68,3.73-6.9,5.72-.22-.57-.35-1.13-.4-1.69,2.24-1.94,4.55-3.8,6.94-5.57h0Z"
        />
      </clipPath>
      <clipPath id="clippath-531">
        <path
          className="cls-1"
          d="M86.97,68.08c.05.56.19,1.13.4,1.69-2.23,1.99-4.37,4.06-6.44,6.21-.23-.61-.38-1.23-.44-1.84,2.07-2.1,4.23-4.12,6.47-6.06h0Z"
        />
      </clipPath>
      <clipPath id="clippath-532">
        <path
          className="cls-1"
          d="M80.5,74.15c.06.61.2,1.22.44,1.84-2.06,2.15-4.05,4.37-5.94,6.66-.25-.66-.41-1.31-.47-1.97,1.9-2.25,3.89-4.42,5.97-6.52h0Z"
        />
      </clipPath>
      <clipPath id="clippath-533">
        <path
          className="cls-1"
          d="M74.53,80.67c.06.65.22,1.31.47,1.97-1.89,2.29-3.7,4.65-5.41,7.07-.27-.7-.43-1.39-.5-2.09,1.72-2.39,3.53-4.71,5.44-6.96h0Z"
        />
      </clipPath>
      <clipPath id="clippath-534">
        <path
          className="cls-1"
          d="M69.09,87.63c.07.69.23,1.39.5,2.09-1.71,2.42-3.33,4.91-4.85,7.46-.28-.73-.45-1.46-.52-2.19,1.53-2.52,3.15-4.97,4.87-7.36h0Z"
        />
      </clipPath>
      <clipPath id="clippath-535">
        <path
          className="cls-1"
          d="M64.22,94.98c.07.73.24,1.46.52,2.19-1.52,2.55-2.94,5.15-4.25,7.81-.29-.76-.47-1.52-.55-2.29,1.32-2.63,2.75-5.21,4.27-7.72h0Z"
        />
      </clipPath>
      <clipPath id="clippath-536">
        <path
          className="cls-1"
          d="M59.95,102.7c.07.76.25,1.52.55,2.29-1.32,2.66-2.53,5.38-3.64,8.15-.3-.79-.49-1.58-.56-2.37,1.11-2.74,2.33-5.43,3.65-8.07h0Z"
        />
      </clipPath>
      <clipPath id="clippath-537">
        <path
          className="cls-1"
          d="M56.29,110.77c.07.79.26,1.58.56,2.37-1.1,2.77-2.1,5.58-2.98,8.44-.31-.81-.5-1.62-.58-2.43.89-2.84,1.89-5.64,3-8.38h0Z"
        />
      </clipPath>
      <clipPath id="clippath-538">
        <path
          className="cls-1"
          d="M53.29,119.15c.08.81.27,1.62.58,2.43-.88,2.86-1.65,5.77-2.3,8.71-.32-.83-.51-1.66-.59-2.48.65-2.93,1.42-5.82,2.31-8.66h0Z"
        />
      </clipPath>
      <clipPath id="clippath-539">
        <path
          className="cls-1"
          d="M50.98,127.81c.08.83.27,1.65.59,2.48-.65,2.94-1.18,5.93-1.58,8.95-.32-.84-.52-1.68-.6-2.52.41-3.01.94-5.98,1.59-8.91h0Z"
        />
      </clipPath>
      <clipPath id="clippath-540">
        <path
          className="cls-1"
          d="M49.15,148.39c-.32-.85-.52-1.69-.6-2.53.15-3.08.44-6.12.84-9.13.08.84.28,1.68.6,2.52-.41,3.02-.69,6.07-.84,9.15h0Z"
        />
      </clipPath>
      <clipPath id="clippath-541">
        <path
          className="cls-1"
          d="M101.29,57.46c-.04-.46-.02-.92.06-1.38,2.53-1.54,5.12-2.98,7.78-4.33-.08.4-.09.8-.06,1.21-2.66,1.41-5.26,2.91-7.79,4.5h0Z"
        />
      </clipPath>
      <clipPath id="clippath-542">
        <path
          className="cls-1"
          d="M101.35,56.08c-.09.46-.11.92-.06,1.38-2.53,1.59-4.99,3.28-7.38,5.05-.05-.51-.02-1.03.07-1.54,2.39-1.72,4.84-3.35,7.37-4.89h0Z"
        />
      </clipPath>
      <clipPath id="clippath-543">
        <path
          className="cls-1"
          d="M93.98,60.97c-.1.51-.12,1.02-.07,1.54-2.39,1.77-4.7,3.63-6.94,5.57-.05-.56-.03-1.13.08-1.69,2.23-1.89,4.55-3.7,6.93-5.42h0Z"
        />
      </clipPath>
      <clipPath id="clippath-544">
        <path
          className="cls-1"
          d="M87.05,66.4c-.11.56-.13,1.12-.08,1.69-2.24,1.94-4.39,3.96-6.47,6.06-.06-.61-.03-1.22.09-1.83,2.07-2.05,4.23-4.03,6.46-5.92h0Z"
        />
      </clipPath>
      <clipPath id="clippath-545">
        <path
          className="cls-1"
          d="M80.59,72.32c-.11.61-.14,1.22-.09,1.83-2.07,2.1-4.07,4.28-5.97,6.52-.06-.65-.03-1.31.09-1.96,1.9-2.21,3.89-4.34,5.96-6.39h0Z"
        />
      </clipPath>
      <clipPath id="clippath-546">
        <path
          className="cls-1"
          d="M74.62,78.71c-.12.65-.15,1.3-.09,1.96-1.9,2.25-3.72,4.57-5.44,6.96-.07-.69-.03-1.39.1-2.08,1.72-2.35,3.53-4.63,5.43-6.84h0Z"
        />
      </clipPath>
      <clipPath id="clippath-547">
        <path
          className="cls-1"
          d="M64.22,94.98c-.07-.73-.03-1.46.1-2.18,1.53-2.48,3.15-4.9,4.87-7.25-.13.69-.16,1.38-.1,2.08-1.72,2.39-3.35,4.84-4.87,7.36h0Z"
        />
      </clipPath>
      <clipPath id="clippath-548">
        <path
          className="cls-1"
          d="M59.95,102.7c-.07-.76-.04-1.52.11-2.28,1.32-2.6,2.75-5.15,4.27-7.63-.14.72-.17,1.45-.1,2.18-1.53,2.51-2.95,5.09-4.27,7.72h0Z"
        />
      </clipPath>
      <clipPath id="clippath-549">
        <path
          className="cls-1"
          d="M56.29,110.77c-.07-.79-.04-1.57.11-2.36,1.11-2.72,2.33-5.38,3.65-7.99-.14.76-.18,1.51-.11,2.28-1.32,2.63-2.54,5.33-3.65,8.07h0Z"
        />
      </clipPath>
      <clipPath id="clippath-550">
        <path
          className="cls-1"
          d="M50.98,127.81c-.08-.83-.04-1.65.12-2.47.65-2.92,1.42-5.79,2.31-8.61-.15.8-.19,1.61-.11,2.42-.89,2.84-1.66,5.73-2.31,8.66h0Z"
        />
      </clipPath>
      <clipPath id="clippath-551">
        <path
          className="cls-1"
          d="M101.8,54.72c-.21.45-.36.91-.45,1.36-2.53,1.54-4.99,3.17-7.37,4.89.1-.51.26-1.02.5-1.52,2.37-1.67,4.81-3.25,7.32-4.73h0Z"
        />
      </clipPath>
      <clipPath id="clippath-552">
        <path
          className="cls-1"
          d="M94.49,59.45c-.24.5-.41,1.01-.5,1.52-2.39,1.72-4.7,3.53-6.93,5.42.11-.56.29-1.12.55-1.67,2.22-1.84,4.51-3.6,6.88-5.27h0Z"
        />
      </clipPath>
      <clipPath id="clippath-553">
        <path
          className="cls-1"
          d="M87.6,64.72c-.26.55-.45,1.11-.55,1.67-2.23,1.89-4.39,3.87-6.46,5.92.11-.61.32-1.21.6-1.81,2.06-2.01,4.2-3.94,6.42-5.78h0Z"
        />
      </clipPath>
      <clipPath id="clippath-554">
        <path
          className="cls-1"
          d="M81.19,70.51c-.28.6-.48,1.2-.6,1.81-2.07,2.05-4.06,4.19-5.96,6.39.12-.65.34-1.3.64-1.94,1.89-2.17,3.86-4.26,5.92-6.27h0Z"
        />
      </clipPath>
      <clipPath id="clippath-555">
        <path
          className="cls-1"
          d="M69.19,85.55c.13-.69.36-1.38.68-2.06,1.71-2.31,3.51-4.55,5.39-6.72-.3.64-.52,1.29-.64,1.94-1.9,2.21-3.71,4.49-5.43,6.84h0Z"
        />
      </clipPath>
      <clipPath id="clippath-556">
        <path
          className="cls-1"
          d="M94.49,59.45c.24-.5.55-1.01.93-1.5,2.34-1.62,4.75-3.14,7.22-4.57-.34.44-.62.89-.83,1.34-2.51,1.48-4.95,3.06-7.32,4.73h0Z"
        />
      </clipPath>
      <clipPath id="clippath-557">
        <path
          className="cls-1"
          d="M95.41,57.95c-.38.5-.69,1-.93,1.5-2.37,1.67-4.66,3.43-6.88,5.27.26-.55.6-1.1,1.02-1.65,2.19-1.8,4.45-3.51,6.79-5.12h0Z"
        />
      </clipPath>
      <clipPath id="clippath-558">
        <path
          className="cls-1"
          d="M88.62,63.07c-.42.55-.76,1.1-1.02,1.65-2.22,1.84-4.36,3.77-6.42,5.78.28-.6.65-1.2,1.1-1.79,2.03-1.97,4.14-3.85,6.33-5.65h0Z"
        />
      </clipPath>
      <clipPath id="clippath-559">
        <path
          className="cls-1"
          d="M82.29,68.72c-.45.59-.82,1.19-1.1,1.79-2.06,2.01-4.03,4.1-5.92,6.27.3-.64.7-1.28,1.18-1.91,1.86-2.13,3.81-4.17,5.84-6.14h0Z"
        />
      </clipPath>
      <clipPath id="clippath-560">
        <path
          className="cls-1"
          d="M69.87,83.49c.3-.64.69-1.27,1.15-1.9l.92-1.23c1.44-1.89,2.94-3.73,4.5-5.51-.48.63-.88,1.27-1.18,1.91-1.89,2.17-3.69,4.41-5.39,6.72h0Z"
        />
      </clipPath>
      <clipPath id="clippath-561">
        <path
          className="cls-1"
          d="M88.62,63.07c.42-.55.91-1.09,1.47-1.62,2.15-1.75,4.37-3.41,6.66-4.98-.52.49-.96.98-1.34,1.47-2.34,1.62-4.6,3.33-6.79,5.12h0Z"
        />
      </clipPath>
      <clipPath id="clippath-562">
        <path
          className="cls-1"
          d="M82.29,68.72c.42-.56.92-1.11,1.49-1.65l.79-.76,5.52-4.86c-.57.53-1.06,1.07-1.47,1.62-2.19,1.8-4.3,3.68-6.33,5.65h0Z"
        />
      </clipPath>
      <clipPath id="clippath-563">
        <path
          className="cls-1"
          d="M76.45,74.86c.2-.26.42-.53.65-.79,1.99-2.11,4.6-4.97,6.68-7-.57.54-1.06,1.1-1.49,1.65-2.03,1.97-3.98,4.01-5.84,6.14h0Z"
        />
      </clipPath>
      <clipPath id="clippath-564">
        <path
          className="cls-1"
          d="M71.94,80.37l1.02-1.33,4.13-4.98c-.23.26-.45.53-.65.79-1.56,1.78-3.06,3.62-4.5,5.51h0Z"
        />
      </clipPath>
      <clipPath id="clippath-565">
        <path
          className="cls-1"
          d="M137.25,99.97c.58-1.58,2.43-2.54,2.22-4.51.19.69.75,2.79,1.9,1.04.02-.03,1.63-2.82.29-5.07.16.16.43.32.64.38.17-.19.52-.59-.88-2.05.09.02,2.2.47,2.74-2.2.27-1.31,2.86-3.64,2.89-3.66q.02-.22-1.22-3.15c.04.08.09.19.13.27q.12-.25.14-1.82c1.49-.61,4.75-6.33,4.81-6.82-.11-.1-.26-.23-.38-.34,2.1-.18,2.44-2.63,1.58-3.21-.58-.39-.7-.33-3.95,1.1.77-1.34,3.29-2.05,2.33-4.02-.09-.02-.22-.05-.31-.07,2.37-.14,1.42-3.26,1.06-3.53-1.07-.8-.63-2.46-1.82-3.19-1.7.45-3.2,3.06-3.21,3.09-.12-.18-.31-.41-.46-.57q-.3.09-1.45,1.37c-.23-.21-.93-.85-1.76.78-.78,1.55-1.53.91-1.53.91-.51-.61.18-1.87.41-2.25q-.32.24-1.48,1.48.25-.38,1.44-1.93c-1.92-.49-2.69-.56-4.89,1.51-1.61-.15-4.82,1.56-4.89,3.99-.08,2.81-3.37,2.09-5.05,3.15-1.64,1.03-3.66,1.23-5.22,2.42l-1.68,3.34c.04.08.14.16.19.23.51-.17.95-.51,1.47-.64.05.44-.15.85-.13,1.28.17.09.39.2.56.29q0,.13-.66,1.59.28.12,1.21-.24c.08.06.18.14.26.21-.43,1.32-1.97,1.86-2.26,3.28q-.97,4.82-1.13,5.22c-.05.13-.12.31-.18.44-.34.78-.87,1.44-1.28,2.17q-2.73,4.81-2.68,5.67c.02.32.04.81-.07,1.01-.85,1.49-2.34,2.44-3.22,3.9-1.33,2.21-1.51,2.53-1.53,2.57-.01.03-1.14,2.77-.55,4.14.25.05.61.05.85-.03-.9.68-8.51,6.71.34,9.32.26.08,2.98-.87,3-.88.02-.01,3.13-2.52,5.01-5.53,1.95-3.12,5.46-.39,7.8-2.08l4.82-4.86c.49-.61.37-1.44.72-2.1.73.08.88.82,1.34,1.21,1.41-.24,3.7-2.56,3.72-2.59h0Z"
        />
      </clipPath>
      <clipPath id="clippath-566">
        <path
          className="cls-1"
          d="M151.99,61.37c1.18.09,2.37.17,3.57.24-.52,1.95-1.03,3.98-1.53,6.1-1.41-.08-2.81-.17-4.19-.28.7-2.1,1.42-4.12,2.15-6.06h0Z"
        />
      </clipPath>
      <clipPath id="clippath-567">
        <path
          className="cls-1"
          d="M149.84,67.42c1.38.11,2.78.2,4.19.28-.5,2.11-.98,4.31-1.46,6.58-1.61-.09-3.2-.19-4.78-.32.67-2.26,1.35-4.44,2.05-6.54h0Z"
        />
      </clipPath>
      <clipPath id="clippath-568">
        <path
          className="cls-1"
          d="M147.8,73.96c1.58.12,3.17.23,4.78.32-.47,2.27-.93,4.61-1.38,7.02-1.8-.1-3.58-.22-5.34-.35.63-2.4,1.28-4.73,1.94-6.98h0Z"
        />
      </clipPath>
      <clipPath id="clippath-569">
        <path
          className="cls-1"
          d="M145.85,80.94c1.76.14,3.54.25,5.34.35-.45,2.41-.88,4.88-1.3,7.42-1.97-.11-3.93-.24-5.87-.39.59-2.53,1.2-4.99,1.83-7.39h0Z"
        />
      </clipPath>
      <clipPath id="clippath-570">
        <path
          className="cls-1"
          d="M151.36,55.58c.94.1,1.9.18,2.87.25-.76,1.75-1.5,3.6-2.23,5.53-1.18-.09-2.35-.19-3.5-.31.94-1.91,1.89-3.74,2.86-5.47h0Z"
        />
      </clipPath>
      <clipPath id="clippath-571">
        <path
          className="cls-1"
          d="M148.49,61.06c1.15.12,2.32.22,3.5.31-.73,1.93-1.45,3.96-2.15,6.06-1.38-.11-2.75-.23-4.1-.36.9-2.08,1.81-4.09,2.75-6h0Z"
        />
      </clipPath>
      <clipPath id="clippath-572">
        <path
          className="cls-1"
          d="M145.74,67.06c1.35.14,2.72.26,4.1.36-.7,2.1-1.38,4.28-2.05,6.54-1.58-.12-3.14-.26-4.68-.42.85-2.24,1.73-4.4,2.63-6.49h0Z"
        />
      </clipPath>
      <clipPath id="clippath-573">
        <path
          className="cls-1"
          d="M143.12,73.55c1.54.16,3.1.29,4.68.42-.67,2.26-1.31,4.58-1.94,6.98-1.76-.14-3.51-.29-5.23-.46.81-2.38,1.64-4.69,2.49-6.93h0Z"
        />
      </clipPath>
      <clipPath id="clippath-574">
        <path
          className="cls-1"
          d="M140.63,80.48c1.72.17,3.46.33,5.23.46-.63,2.4-1.24,4.86-1.83,7.39-1.94-.15-3.85-.32-5.74-.51.75-2.51,1.54-4.96,2.34-7.34h0Z"
        />
      </clipPath>
      <clipPath id="clippath-575">
        <path
          className="cls-1"
          d="M138.29,87.82c1.89.19,3.8.36,5.74.51-.59,2.53-1.16,5.11-1.7,7.75-2.1-.16-4.17-.35-6.22-.55.7-2.63,1.43-5.2,2.18-7.71h0Z"
        />
      </clipPath>
      <clipPath id="clippath-576">
        <path
          className="cls-1"
          d="M136.1,95.53c2.05.21,4.12.39,6.22.55-.55,2.64-1.07,5.34-1.57,8.08-2.25-.17-4.47-.37-6.66-.59.64-2.73,1.32-5.42,2.02-8.04h0Z"
        />
      </clipPath>
      <clipPath id="clippath-577">
        <path
          className="cls-1"
          d="M148.57,55.27c.91.12,1.84.22,2.79.32-.97,1.73-1.93,3.56-2.86,5.47-1.15-.12-2.29-.24-3.4-.39,1.14-1.89,2.3-3.69,3.48-5.41h0Z"
        />
      </clipPath>
      <clipPath id="clippath-578">
        <path
          className="cls-1"
          d="M145.09,60.67c1.12.14,2.25.27,3.4.39-.94,1.92-1.85,3.92-2.75,6-1.35-.14-2.68-.29-3.99-.45,1.09-2.06,2.2-4.04,3.34-5.94h0Z"
        />
      </clipPath>
      <clipPath id="clippath-579">
        <path
          className="cls-1"
          d="M141.75,66.61c1.31.16,2.64.32,3.99.45-.9,2.08-1.77,4.25-2.63,6.49-1.54-.16-3.06-.33-4.55-.52,1.04-2.22,2.1-4.36,3.19-6.42h0Z"
        />
      </clipPath>
      <clipPath id="clippath-580">
        <path
          className="cls-1"
          d="M138.56,73.03c1.49.19,3.01.36,4.55.52-.85,2.24-1.68,4.55-2.49,6.93-1.72-.17-3.42-.37-5.08-.58.98-2.36,1.99-4.65,3.02-6.87h0Z"
        />
      </clipPath>
      <clipPath id="clippath-581">
        <path
          className="cls-1"
          d="M135.54,79.9c1.67.21,3.36.4,5.08.58-.81,2.38-1.59,4.83-2.34,7.34-1.89-.19-3.75-.4-5.58-.63.92-2.49,1.86-4.92,2.84-7.28h0Z"
        />
      </clipPath>
      <clipPath id="clippath-582">
        <path
          className="cls-1"
          d="M132.7,87.19c1.83.23,3.7.44,5.58.63-.75,2.51-1.48,5.08-2.18,7.71-2.05-.21-4.07-.44-6.05-.68.85-2.61,1.73-5.17,2.65-7.66h0Z"
        />
      </clipPath>
      <clipPath id="clippath-583">
        <path
          className="cls-1"
          d="M130.05,94.85c1.99.25,4,.48,6.05.68-.7,2.63-1.37,5.31-2.02,8.04-2.19-.22-4.35-.47-6.48-.73.78-2.72,1.6-5.38,2.45-8h0Z"
        />
      </clipPath>
      <clipPath id="clippath-584">
        <path
          className="cls-1"
          d="M127.6,102.84c2.13.27,4.29.51,6.48.73-.64,2.73-1.26,5.51-1.84,8.34-2.32-.23-4.62-.49-6.87-.78.71-2.81,1.45-5.58,2.23-8.3h0Z"
        />
      </clipPath>
      <clipPath id="clippath-585">
        <path
          className="cls-1"
          d="M141.8,60.22c1.08.16,2.17.32,3.29.46-1.14,1.89-2.25,3.87-3.34,5.94-1.31-.16-2.6-.34-3.86-.54,1.27-2.04,2.58-3.99,3.91-5.86h0Z"
        />
      </clipPath>
      <clipPath id="clippath-586">
        <path
          className="cls-1"
          d="M137.89,66.07c1.26.19,2.55.37,3.86.54-1.09,2.06-2.15,4.2-3.19,6.42-1.49-.19-2.96-.39-4.4-.61,1.21-2.19,2.46-4.31,3.73-6.35h0Z"
        />
      </clipPath>
      <clipPath id="clippath-587">
        <path
          className="cls-1"
          d="M134.16,72.42c1.44.22,2.91.42,4.4.61-1.04,2.22-2.04,4.51-3.02,6.87-1.67-.21-3.31-.44-4.92-.68,1.14-2.34,2.32-4.61,3.54-6.8h0Z"
        />
      </clipPath>
      <clipPath id="clippath-588">
        <path
          className="cls-1"
          d="M130.63,79.22c1.61.25,3.25.47,4.92.68-.98,2.36-1.93,4.79-2.84,7.28-1.83-.23-3.63-.48-5.4-.75,1.07-2.47,2.18-4.88,3.33-7.22h0Z"
        />
      </clipPath>
      <clipPath id="clippath-589">
        <path
          className="cls-1"
          d="M127.3,86.44c1.77.27,3.57.52,5.4.75-.92,2.49-1.8,5.05-2.65,7.66-1.99-.25-3.94-.52-5.85-.81.99-2.59,2.03-5.13,3.1-7.6h0Z"
        />
      </clipPath>
      <clipPath id="clippath-590">
        <path
          className="cls-1"
          d="M124.2,94.03c1.91.29,3.87.56,5.85.81-.85,2.61-1.67,5.28-2.45,8-2.13-.27-4.22-.56-6.27-.87.91-2.7,1.87-5.35,2.86-7.94h0Z"
        />
      </clipPath>
      <clipPath id="clippath-591">
        <path
          className="cls-1"
          d="M121.34,101.97c2.05.31,4.14.6,6.27.87-.78,2.72-1.52,5.48-2.23,8.3-2.26-.28-4.47-.59-6.65-.92.83-2.79,1.7-5.54,2.61-8.24h0Z"
        />
      </clipPath>
      <clipPath id="clippath-592">
        <path
          className="cls-1"
          d="M138.64,59.69c1.03.19,2.08.36,3.16.53-1.33,1.87-2.64,3.82-3.91,5.86-1.26-.19-2.5-.4-3.7-.62,1.45-2.01,2.94-3.93,4.46-5.77h0Z"
        />
      </clipPath>
      <clipPath id="clippath-593">
        <path
          className="cls-1"
          d="M134.19,65.45c1.21.22,2.44.43,3.7.62-1.27,2.04-2.52,4.15-3.73,6.35-1.44-.22-2.85-.46-4.23-.71,1.38-2.17,2.8-4.25,4.25-6.26h0Z"
        />
      </clipPath>
      <clipPath id="clippath-594">
        <path
          className="cls-1"
          d="M129.94,71.71c1.38.25,2.79.49,4.23.71-1.21,2.19-2.39,4.46-3.54,6.8-1.61-.25-3.18-.51-4.72-.79,1.3-2.31,2.65-4.55,4.03-6.72h0Z"
        />
      </clipPath>
      <clipPath id="clippath-595">
        <path
          className="cls-1"
          d="M125.91,78.43c1.54.28,3.11.54,4.72.79-1.14,2.34-2.25,4.75-3.33,7.22-1.76-.27-3.49-.56-5.19-.87,1.22-2.45,2.49-4.83,3.79-7.14h0Z"
        />
      </clipPath>
      <clipPath id="clippath-596">
        <path
          className="cls-1"
          d="M122.11,85.57c1.69.31,3.42.6,5.19.87-1.07,2.47-2.11,5.01-3.1,7.6-1.91-.29-3.79-.61-5.62-.94,1.13-2.57,2.31-5.08,3.53-7.52h0Z"
        />
      </clipPath>
      <clipPath id="clippath-597">
        <path
          className="cls-1"
          d="M118.58,93.1c1.83.33,3.71.65,5.62.94-.99,2.59-1.95,5.24-2.86,7.94-2.05-.31-4.06-.65-6.02-1.01,1.04-2.68,2.13-5.3,3.26-7.87h0Z"
        />
      </clipPath>
      <clipPath id="clippath-598">
        <path
          className="cls-1"
          d="M115.32,100.97c1.96.36,3.97.69,6.02,1.01-.91,2.7-1.78,5.45-2.61,8.24-2.17-.33-4.3-.69-6.38-1.07.94-2.77,1.93-5.5,2.97-8.18h0Z"
        />
      </clipPath>
      <clipPath id="clippath-599">
        <path
          className="cls-1"
          d="M112.35,109.15c2.08.38,4.21.73,6.38,1.07-.83,2.79-1.61,5.63-2.34,8.51-2.28-.35-4.52-.72-6.71-1.12.84-2.86,1.72-5.68,2.66-8.46h0Z"
        />
      </clipPath>
      <clipPath id="clippath-600">
        <path
          className="cls-1"
          d="M135.63,59.09c.98.21,1.99.41,3.02.6-1.52,1.84-3,3.76-4.46,5.77-1.21-.22-2.39-.45-3.54-.7,1.62-1.97,3.28-3.86,4.98-5.66h0Z"
        />
      </clipPath>
      <clipPath id="clippath-601">
        <path
          className="cls-1"
          d="M130.65,64.75c1.15.25,2.33.48,3.54.7-1.45,2.01-2.87,4.1-4.25,6.26-1.38-.25-2.73-.52-4.04-.8,1.54-2.13,3.13-4.19,4.75-6.16h0Z"
        />
      </clipPath>
      <clipPath id="clippath-602">
        <path
          className="cls-1"
          d="M125.9,70.91c1.31.28,2.66.55,4.04.8-1.38,2.17-2.73,4.41-4.03,6.72-1.54-.28-3.05-.58-4.51-.89,1.46-2.28,2.96-4.49,4.5-6.63h0Z"
        />
      </clipPath>
      <clipPath id="clippath-603">
        <path
          className="cls-1"
          d="M121.4,77.54c1.46.31,2.97.61,4.51.89-1.3,2.31-2.57,4.69-3.79,7.14-1.69-.31-3.34-.64-4.95-.98,1.36-2.42,2.78-4.77,4.23-7.05h0Z"
        />
      </clipPath>
      <clipPath id="clippath-604">
        <path
          className="cls-1"
          d="M117.16,84.59c1.61.35,3.26.67,4.95.98-1.22,2.45-2.4,4.96-3.53,7.52-1.83-.33-3.62-.69-5.37-1.06,1.27-2.54,2.58-5.02,3.95-7.44h0Z"
        />
      </clipPath>
      <clipPath id="clippath-605">
        <path
          className="cls-1"
          d="M113.21,92.03c1.74.37,3.53.73,5.37,1.06-1.13,2.57-2.22,5.19-3.26,7.87-1.96-.36-3.88-.74-5.75-1.14,1.16-2.65,2.38-5.25,3.64-7.8h0Z"
        />
      </clipPath>
      <clipPath id="clippath-606">
        <path
          className="cls-1"
          d="M109.57,99.83c1.87.4,3.78.78,5.75,1.14-1.04,2.68-2.03,5.41-2.97,8.18-2.08-.38-4.12-.78-6.1-1.21,1.05-2.75,2.16-5.46,3.32-8.11h0Z"
        />
      </clipPath>
      <clipPath id="clippath-607">
        <path
          className="cls-1"
          d="M106.25,107.94c1.98.43,4.01.83,6.1,1.21-.94,2.77-1.83,5.6-2.66,8.46-2.19-.4-4.33-.82-6.41-1.27.93-2.84,1.93-5.64,2.98-8.39h0Z"
        />
      </clipPath>
      <clipPath id="clippath-608">
        <path
          className="cls-1"
          d="M122.08,70.02c1.23.31,2.51.61,3.82.89-1.54,2.13-3.04,4.34-4.5,6.63-1.46-.31-2.89-.65-4.27-.99,1.6-2.25,3.25-4.42,4.95-6.52h0Z"
        />
      </clipPath>
      <clipPath id="clippath-610">
        <path
          className="cls-1"
          d="M127.51,62.25q-3.15,3.44-3.15,3.58c.47-1.32-.62-.88-1.12-.63-1.39.71-1.92,2.35-3.3,3.08.6-.87.63-1.01.69-1.27-.04-.03-.1-.08-.14-.11l-4.61,3.82c-.36.31-.5.51-.68.78-.14.19-1.33,2.65-.19,3.16.19.09.93.29,2.29-.7,1.64-1.19,2.08-3.33,3.64-4.59,1.43-1.15,3.44-1.05,4.85-2.23.38-.31.84-.74.87-.98q.07,0,.67.58s.09,0,.13,0c0-.13,0-.31-.03-.45.73-.48,1.67-.34,1.68-.34.03.09.07.2.1.29,1.14.43,7.24-3.56,7.25-4.75,2.84-.32,4.08-1.4,4.3-3.72-.25-.07-.47.08-.71.1q0-.21.33-.71c.45-.68.43-1.38-.07-2.09q-.12,0-1.3.68.07-.2.34-.55s-.09-.05-.13-.07c-1.15.52-1.69,1.92-3.05,2.14.04-.09.1-.2.14-.29-.48,0-.73.52-1.21.53-.01-.09,0-.21.03-.29-.02.04-.06.08-.08.12-.17-.26.1-.53-.02-.79q-.2.04-.47.19c0-.05,0-.12,0-.17-.55-.15-1.98.42-2.16.78.06.02.13.05.19.07-.07.04-1.76,1.06-2.18,1.84,1.09,1.01-.16,2.13.16,3.18.13.04.32.05.44,0-.04.31-.05.33-.11.5-.04.02-.1.04-.15.05q-1.5-.95-2.37.09c.29-.43.74-1.24.59-1.73-.19,0-.55,0-1.47.91h0Z"
        />
      </clipPath>
      <clipPath id="clippath-611">
        <path
          className="cls-1"
          d="M143.28,54.46c.84.15,1.71.3,2.59.43-1.38,1.68-2.74,3.46-4.07,5.32-1.07-.16-2.13-.34-3.16-.53,1.52-1.83,3.06-3.58,4.64-5.23h0Z"
        />
      </clipPath>
      <clipPath id="clippath-612">
        <path
          className="cls-1"
          d="M138.64,59.69c1.03.19,2.08.36,3.16.53-1.33,1.87-2.64,3.82-3.91,5.86-1.26-.19-2.5-.4-3.7-.62,1.45-2.01,2.94-3.93,4.46-5.77h0Z"
        />
      </clipPath>
      <clipPath id="clippath-613">
        <path
          className="cls-1"
          d="M140.81,53.97c.8.17,1.63.34,2.47.49-1.58,1.65-3.12,3.39-4.64,5.23-1.03-.19-2.04-.39-3.02-.6,1.69-1.8,3.42-3.51,5.18-5.12h0Z"
        />
      </clipPath>
      <clipPath id="clippath-614">
        <path
          className="cls-1"
          d="M135.63,59.09c.98.21,1.99.41,3.02.6-1.52,1.84-3,3.76-4.46,5.77-1.21-.22-2.39-.45-3.54-.7,1.62-1.97,3.28-3.86,4.98-5.66h0Z"
        />
      </clipPath>
      <clipPath id="clippath-615">
        <path
          className="cls-1"
          d="M130.65,64.75c1.15.25,2.33.48,3.54.7-1.45,2.01-2.87,4.1-4.25,6.26-1.38-.25-2.73-.52-4.04-.8,1.54-2.13,3.13-4.19,4.75-6.16h0Z"
        />
      </clipPath>
      <clipPath id="clippath-616">
        <path
          className="cls-1"
          d="M138.47,53.43c.76.19,1.54.37,2.34.54-1.76,1.61-3.49,3.32-5.18,5.12-.98-.21-1.93-.43-2.85-.66,1.86-1.76,3.76-3.43,5.7-5h0Z"
        />
      </clipPath>
      <clipPath id="clippath-617">
        <path
          className="cls-1"
          d="M132.77,58.43c.92.23,1.88.45,2.85.66-1.7,1.8-3.36,3.69-4.98,5.66-1.15-.25-2.27-.51-3.35-.78,1.78-1.94,3.61-3.79,5.47-5.55h0Z"
        />
      </clipPath>
      <clipPath id="clippath-618">
        <path
          className="cls-1"
          d="M127.3,63.97c1.08.27,2.2.53,3.35.78-1.62,1.97-3.21,4.03-4.75,6.16-1.31-.28-2.59-.58-3.82-.89,1.7-2.1,3.44-4.12,5.22-6.05h0Z"
        />
      </clipPath>
      <clipPath id="clippath-619">
        <path
          className="cls-1"
          d="M136.28,52.83c.7.21,1.44.41,2.19.6-1.94,1.57-3.84,3.24-5.7,5-.92-.23-1.82-.48-2.68-.73,2.02-1.72,4.08-3.34,6.18-4.87h0Z"
        />
      </clipPath>
      <clipPath id="clippath-620">
        <path
          className="cls-1"
          d="M130.1,57.69c.86.25,1.75.5,2.68.73-1.86,1.76-3.69,3.61-5.47,5.55-1.08-.27-2.13-.56-3.14-.86,1.93-1.89,3.91-3.7,5.94-5.42h0Z"
        />
      </clipPath>
      <clipPath id="clippath-621">
        <path
          className="cls-1"
          d="M124.16,63.12c1.01.3,2.06.58,3.14.86-1.78,1.94-3.53,3.95-5.22,6.05-1.23-.31-2.43-.64-3.58-.98,1.84-2.06,3.73-4.04,5.66-5.93h0Z"
        />
      </clipPath>
      <clipPath id="clippath-622">
        <path
          className="cls-1"
          d="M118.5,69.05c1.15.34,2.35.67,3.58.98-1.7,2.1-3.35,4.27-4.95,6.52-1.38-.35-2.71-.71-4-1.09,1.74-2.21,3.53-4.35,5.37-6.41h0Z"
        />
      </clipPath>
      <clipPath id="clippath-623">
        <path
          className="cls-1"
          d="M115.18,67.98c1.06.37,2.17.72,3.32,1.06-1.84,2.06-3.63,4.2-5.37,6.41-1.29-.38-2.52-.78-3.71-1.19,1.86-2.17,3.78-4.27,5.75-6.28h0Z"
        />
      </clipPath>
      <clipPath id="clippath-624">
        <path
          className="cls-1"
          d="M102.15,67.92c-3.19.34-3.76.41-4.22.68-.06.03-.13.08-.18.12l-3.82,2.96c-.12.13-.68.79-.1,1.33.14.13.41.31.92.43-4.88,4.49-4.62,7.69-4.61,7.72.45.07.91-.51,2.28-2.57-1.74,2.93-.75,3.52-.21,3.31.59-.23,1.14-1.13,1.46-1.67.21-.35,1.86-1.08,2.18-.96,0,.15.02.36.05.51q.08-.05.28-.6c.12-.34.5-1.37,1.09-2.37,1.68-2.84,3.83-3.75,4.07-3.85.3-.12.8-.15,1.01-.4.89-1.08,1.5-2.11,1.63-2.54-.01-.02-.03-.04-.04-.06-.16.11-.25.23-.53.62.5-.78.55-.89.5-1.07-.23,0-.59.13-2.68,1.89q-1.07.89-1.47.99c.55-.74,1.63-.94,1.98-1.9-.85.26-1.25,1.24-2.19,1.34-.41.04-.25-.73-.17-1.1q-.03.16.02.28c.42.05,1.63-1.2,1.75-1.62q-.14-.05-.45.12,1.83-1.33,1.9-1.53-.12-.11-.45-.08h0Z"
        />
      </clipPath>
      <clipPath id="clippath-625">
        <path
          className="cls-1"
          d="M107.03,64.3c.22.14.45.27.69.41.54.31,1.11.61,1.7.9-2.2,1.92-4.35,3.92-6.43,6-.66-.33-1.3-.66-1.9-1.01-.26-.15-.52-.3-.77-.45,2.17-2.03,4.41-3.98,6.71-5.85h0Z"
        />
      </clipPath>
      <clipPath id="clippath-626">
        <path
          className="cls-1"
          d="M100.32,70.15c.25.15.51.3.77.45.6.34,1.24.68,1.9,1.01-2.08,2.08-4.1,4.24-6.05,6.47-.73-.36-1.42-.73-2.09-1.11-.29-.17-.57-.33-.85-.5,2.03-2.18,4.14-4.29,6.31-6.33h0Z"
        />
      </clipPath>
      <clipPath id="clippath-627">
        <path
          className="cls-1"
          d="M94.01,76.48c.27.17.56.33.85.5.66.38,1.36.74,2.09,1.11-1.95,2.23-3.83,4.53-5.64,6.9-.79-.39-1.54-.79-2.26-1.2-.32-.18-.62-.36-.92-.54,1.89-2.32,3.85-4.58,5.88-6.76h0Z"
        />
      </clipPath>
      <clipPath id="clippath-628">
        <path
          className="cls-1"
          d="M105.05,62.96c.59.45,1.25.9,1.98,1.34-2.3,1.87-4.54,3.82-6.71,5.85-.82-.5-1.56-1-2.21-1.5,2.25-1.98,4.56-3.88,6.94-5.69h0Z"
        />
      </clipPath>
      <clipPath id="clippath-629">
        <path
          className="cls-1"
          d="M98.11,68.65c.66.5,1.4,1,2.21,1.5-2.17,2.03-4.28,4.14-6.31,6.33-.9-.54-1.71-1.09-2.43-1.65,2.1-2.14,4.28-4.2,6.53-6.18h0Z"
        />
      </clipPath>
      <clipPath id="clippath-630">
        <path
          className="cls-1"
          d="M91.58,74.83c.72.55,1.53,1.1,2.43,1.65-2.03,2.18-4,4.44-5.88,6.76-.97-.59-1.85-1.19-2.64-1.79,1.95-2.28,3.98-4.49,6.08-6.63h0Z"
        />
      </clipPath>
      <clipPath id="clippath-631">
        <path
          className="cls-1"
          d="M96.37,67.13c.5.51,1.08,1.02,1.74,1.52-2.25,1.98-4.42,4.04-6.53,6.18-.72-.55-1.36-1.11-1.91-1.67,2.16-2.09,4.39-4.1,6.7-6.03h0Z"
        />
      </clipPath>
      <linearGradient
        id="linear-gradient"
        x1={52.61}
        y1={150.15}
        x2={279.09}
        y2={150.15}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor={secColor + '80'} />
        <stop offset={0.29} stopColor={secColor + '80'} />
        <stop offset={0.9} stopColor={secColor + '80'} />
        <stop offset={1} stopColor={secColor + '80'} />
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        x1={85.82}
        y1={245.53}
        x2={245.88}
        y2={54.77}
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-3"
        x1={98.86}
        y1={111.47}
        x2={245.89}
        y2={196.36}
        xlinkHref="#linear-gradient"
      />
    </defs>
    <g className="cls-13">
      <g id="Calque_2">
        <g id="Design">
          <circle
            className="cls-649"
            cx={164.97}
            cy={149.6}
            r={116.68}
            transform="translate(-57.47 160.47) rotate(-45)"
          />
          <circle
            className="cls-654"
            cx={164.97}
            cy={148.73}
            r={116.68}
            transform="translate(-56.85 160.21) rotate(-45)"
          />
          <g className="cls-657">
            <g className="cls-108">
              <path
                className="cls-107"
                d="M226.73,54.53c-.56-.34-.95-.61-1.04-.72,0,0,0-.02,0-.02.03,0,.18.02.83.4.07.12.14.23.21.35h0Z"
              />
              <path
                className="cls-107"
                d="M223.04,52.44c.28.16.85.49.95.63-.64-.35-1.27-.7-1.92-1.04,0,0,0,0,0-.01.04-.05.53.18.98.42h0Z"
              />
            </g>
            <g className="cls-111">
              <path
                className="cls-107"
                d="M230.04,56.15c.46.3.95.67.94.73-.12.04-1.61-.94-1.81-1.19,0,0,0-.02,0-.02.07-.02.5.23.88.48h0Z"
              />
              <path
                className="cls-107"
                d="M230.51,56.88c.27.18.81.56.91.72-.6-.4-1.21-.79-1.82-1.18,0,0,0-.02,0-.02.09-.02.53.24.91.49h0Z"
              />
              <path
                className="cls-107"
                d="M226.62,54.25c.4.24.97.63.94.7-.06.02-.35-.13-.83-.41-.07-.12-.14-.23-.21-.35.03.02.07.04.1.06h0Z"
              />
            </g>
            <g className="cls-109">
              <path
                className="cls-107"
                d="M240.83,64.5c-.5-.42-.86-.76-.96-.9,0,0,0-.02,0-.03.02,0,.13.03.71.5.09.14.18.28.26.42h0Z"
              />
              <path
                className="cls-107"
                d="M237.55,61.87c.25.2.76.62.88.8-.56-.44-1.13-.88-1.71-1.32,0,0,0-.02,0-.03.08-.02.58.35.84.55h0Z"
              />
            </g>
            <g className="cls-110">
              <path
                className="cls-107"
                d="M244.15,67.39c.24.22.71.68.83.87-.53-.49-1.06-.97-1.59-1.44,0,0,0-.02,0-.03.06-.02.53.38.77.6h0Z"
              />
              <path
                className="cls-107"
                d="M240.66,64.14c.35.3.87.78.88.86-.04.02-.28-.16-.7-.51-.08-.14-.17-.28-.26-.42.03.02.06.05.08.07h0Z"
              />
            </g>
            <g className="cls-116">
              <path
                className="cls-107"
                d="M226.06,54.5c.07.11.46.39,1.02.73-.05-.12-.1-.23-.16-.35-.51-.3-.83-.45-.86-.4,0,0,0,.01,0,.01h0Z"
              />
              <path
                className="cls-107"
                d="M226.32,55.18c.06.11.44.4,1,.74-.03-.12-.07-.23-.11-.35-.5-.3-.84-.45-.89-.41,0,0,0,.01,0,.01h0Z"
              />
              <path
                className="cls-107"
                d="M222.07,52.04c.16.23,1.74,1.1,1.92,1.06,0,0,0,0,0,0,0,0,0-.01,0-.01-.64-.35-1.27-.7-1.92-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M222.36,52.68c.14.23,1.83,1.17,1.93,1.07-.02-.2-1.81-1.2-1.93-1.09,0,0,0,0,0,.01h0Z"
              />
              <path
                className="cls-107"
                d="M222.56,53.31c.65.35,1.29.72,1.94,1.08-.11-.24-1.79-1.2-1.93-1.1,0,0,0,0,0,.01h0Z"
              />
            </g>
            <g className="cls-113">
              <path
                className="cls-107"
                d="M233.41,59.2c.08.13.45.44.97.82-.05-.13-.11-.26-.18-.39-.6-.42-.76-.47-.8-.46,0,0,0,.02,0,.03h0Z"
              />
              <path
                className="cls-107"
                d="M233.7,59.96c.06.13.42.44.95.83-.04-.13-.08-.26-.12-.39-.64-.46-.85-.51-.83-.44h0Z"
              />
              <path
                className="cls-107"
                d="M229.6,56.41c.17.25,1.67,1.25,1.82,1.21,0,0,0-.02,0-.03-.6-.4-1.21-.79-1.82-1.18h0Z"
              />
              <path
                className="cls-107"
                d="M229.94,57.14c.14.26,1.75,1.33,1.83,1.22-.04-.22-1.73-1.36-1.83-1.23,0,0,0,.01,0,.02h0Z"
              />
              <path
                className="cls-107"
                d="M230.16,57.86c.62.4,1.23.81,1.83,1.22-.12-.27-1.71-1.35-1.83-1.24,0,0,0,.01,0,.02h0Z"
              />
              <path
                className="cls-107"
                d="M226.92,54.88c.06.12.11.23.16.35.51.31.83.45.86.41-.02-.09-.45-.41-1.02-.75h0Z"
              />
              <path
                className="cls-107"
                d="M227.21,55.57c.04.12.08.23.11.35.52.31.84.46.89.42,0-.09-.42-.41-1-.76h0Z"
              />
            </g>
            <g className="cls-112">
              <path
                className="cls-107"
                d="M240.32,64.44c.08.14.44.49.93.91-.06-.14-.12-.28-.19-.42-.57-.47-.71-.52-.74-.51,0,0,0,.02,0,.03h0Z"
              />
              <path
                className="cls-107"
                d="M240.64,65.28c.06.14.41.49.91.92-.04-.14-.08-.28-.13-.42-.59-.49-.73-.53-.77-.52,0,0,0,.02,0,.03h0Z"
              />
              <path
                className="cls-107"
                d="M236.72,61.35c.18.28,1.59,1.38,1.71,1.34,0,0,0-.02,0-.03-.56-.44-1.13-.88-1.71-1.32h0Z"
              />
              <path
                className="cls-107"
                d="M237.09,62.15c.14.28,1.55,1.4,1.72,1.36.07-.13-1.53-1.43-1.71-1.39,0,0,0,.02,0,.03h0Z"
              />
              <path
                className="cls-107"
                d="M237.34,62.96c.58.45,1.15.9,1.72,1.35-.15-.4-1.69-1.48-1.72-1.37,0,0,0,.01,0,.02h0Z"
              />
              <path
                className="cls-107"
                d="M234.2,59.63c.06.13.12.26.18.39.45.32.73.48.8.47.03-.06-.4-.44-.97-.85h0Z"
              />
              <path
                className="cls-107"
                d="M234.53,60.41c.05.13.09.26.12.39.69.49.85.52.83.45-.02-.07-.29-.36-.95-.84h0Z"
              />
            </g>
            <g className="cls-115">
              <path
                className="cls-107"
                d="M246.77,70.19c.08.15.42.53.87.98-.06-.15-.14-.31-.21-.46-.38-.37-.62-.57-.67-.55,0,0,0,.02,0,.03h0Z"
              />
              <path
                className="cls-107"
                d="M247.12,71.1c.06.15.39.53.84.99-.04-.15-.09-.31-.14-.46-.38-.37-.63-.58-.7-.56,0,0,0,.02,0,.03h0Z"
              />
              <path
                className="cls-107"
                d="M243.39,66.82c.19.3,1.5,1.52,1.6,1.47,0,0,0-.02,0-.03-.53-.49-1.06-.97-1.59-1.44h0Z"
              />
              <path
                className="cls-107"
                d="M243.79,67.69c.15.3,1.46,1.53,1.6,1.49.05-.14-1.45-1.56-1.6-1.52,0,0,0,.02,0,.03h0Z"
              />
              <path
                className="cls-107"
                d="M244.07,68.57c.54.49,1.08.98,1.61,1.48-.12-.32-1.42-1.54-1.6-1.51,0,0,0,.02,0,.03h0Z"
              />
              <path
                className="cls-107"
                d="M241.06,64.92c.07.14.14.28.19.42.42.35.68.53.73.52.02-.07-.39-.48-.93-.94h0Z"
              />
              <path
                className="cls-107"
                d="M241.41,65.77c.05.14.09.28.13.42.42.35.69.54.76.52.04-.07-.35-.49-.89-.95h0Z"
              />
            </g>
            <g className="cls-114">
              <path
                className="cls-107"
                d="M251.07,75.31c.22.24.65.75.72.96-.49-.54-.98-1.07-1.48-1.6,0,0,0-.02,0-.03.09-.02.53.43.75.67h0Z"
              />
              <path
                className="cls-107"
                d="M247.51,70.8c.39.39.81.87.81.95-.05.02-.28-.18-.67-.57-.06-.15-.14-.31-.21-.46.02.02.06.06.08.08h0Z"
              />
              <path
                className="cls-107"
                d="M247.9,71.72c.33.34.8.87.77.96-.06.01-.31-.19-.7-.58-.04-.15-.09-.31-.14-.46.02.02.06.06.08.08h0Z"
              />
            </g>
            <g className="cls-22">
              <path
                className="cls-107"
                d="M259.27,85.3c-.37-.52-.65-.96-.72-1.13,0-.01,0-.02,0-.03.04-.02.24.22.56.65.06.17.12.35.16.52h0Z"
              />
              <path
                className="cls-107"
                d="M256.72,81.92c.2.26.6.8.67,1.02-.44-.57-.89-1.14-1.35-1.71,0-.01,0-.02,0-.03.08-.03.48.46.68.72h0Z"
              />
            </g>
            <g className="cls-19">
              <path
                className="cls-107"
                d="M264.1,92.53c-.33-.55-.59-1.02-.65-1.2,0-.01,0-.03,0-.04,0,0,0,0,0,0,.04.02.15.16.48.69.06.18.12.37.17.55h0Z"
              />
              <path
                className="cls-107"
                d="M261.82,88.96c.18.27.54.85.61,1.08-.4-.61-.8-1.21-1.21-1.81,0-.01,0-.02,0-.04.1,0,.48.59.6.76h0Z"
              />
              <path
                className="cls-107"
                d="M259.18,84.87c.28.39.67.99.66,1.08,0,0,0,0,0,0-.07-.03-.25-.25-.55-.66-.05-.17-.1-.35-.16-.52.02.03.05.06.07.09h0Z"
              />
            </g>
            <g className="cls-26">
              <path
                className="cls-107"
                d="M263.98,92.08c.24.4.6,1.04.6,1.14,0,0,0,0,0,0-.04-.02-.15-.16-.48-.7-.05-.18-.11-.37-.17-.55.02.03.04.07.06.1h0Z"
              />
            </g>
            <g className="cls-24">
              <path
                className="cls-107"
                d="M226.49,55.86c.04.11.42.4.97.75-.02-.12-.04-.23-.06-.35-.51-.31-.85-.46-.91-.42,0,0,0,.01,0,.01h0Z"
              />
              <path
                className="cls-107"
                d="M226.56,56.54c.03.11.39.41.95.76,0-.11,0-.23,0-.34-.69-.42-.94-.48-.94-.42h0Z"
              />
              <path
                className="cls-107"
                d="M222.56,53.31c.11.23,1.81,1.2,1.93,1.1,0,0,0-.01,0-.01-.64-.37-1.29-.73-1.94-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M222.67,53.95c.08.23,1.78,1.21,1.94,1.12.05-.2-1.74-1.24-1.93-1.13,0,0,0,0,0,.01h0Z"
              />
              <path
                className="cls-107"
                d="M222.69,54.59c.65.37,1.3.74,1.94,1.12-.07-.31-1.85-1.22-1.93-1.14,0,0,0,0,0,.01h0Z"
              />
            </g>
            <g className="cls-25">
              <path
                className="cls-107"
                d="M233.89,60.73c.04.13.4.45.92.84-.02-.13-.04-.26-.07-.39-.65-.46-.87-.52-.86-.45h0Z"
              />
              <path
                className="cls-107"
                d="M233.96,61.49c.03.13.37.45.9.85,0-.13,0-.26-.01-.38-.65-.47-.89-.53-.89-.46h0Z"
              />
              <path
                className="cls-107"
                d="M230.16,57.86c.14.34,1.79,1.33,1.83,1.24,0,0,0-.01,0-.02-.61-.41-1.22-.82-1.83-1.22h0Z"
              />
              <path
                className="cls-107"
                d="M230.29,58.58c.1.34,1.77,1.35,1.83,1.26.09-.14-1.63-1.35-1.82-1.28,0,0-.02.02-.02.02h0Z"
              />
              <path
                className="cls-107"
                d="M230.31,59.3c.62.42,1.23.84,1.84,1.26-.06-.35-1.75-1.37-1.83-1.28,0,0,0,.01,0,.02h0Z"
              />
              <path
                className="cls-107"
                d="M227.4,56.26c.02.12.04.23.06.35.51.31.85.47.91.43.01-.09-.4-.42-.97-.78h0Z"
              />
              <path
                className="cls-107"
                d="M227.5,56.96c0,.12.01.23,0,.34.64.4.94.5.94.42,0-.06-.26-.33-.95-.77h0Z"
              />
            </g>
            <g className="cls-23">
              <path
                className="cls-107"
                d="M240.84,66.12c.05.14.38.5.88.93-.02-.14-.04-.28-.07-.43-.61-.51-.82-.58-.8-.5h0Z"
              />
              <path
                className="cls-107"
                d="M240.93,66.95c.03.14.35.5.85.94,0-.14,0-.28-.01-.42-.61-.52-.84-.59-.84-.51h0Z"
              />
              <path
                className="cls-107"
                d="M237.34,62.96c.07.18,1.66,1.57,1.72,1.37,0,0,0-.01,0-.02-.57-.46-1.14-.91-1.72-1.35h0Z"
              />
              <path
                className="cls-107"
                d="M237.48,63.76c.04.16.5.58.88.89.37.3.8.58.84.51.09-.16-1.53-1.5-1.71-1.42,0,0-.01.02-.01.03h0Z"
              />
              <path
                className="cls-107"
                d="M237.5,64.56c.58.46,1.16.92,1.73,1.39-.06-.41-1.64-1.52-1.72-1.41,0,0,0,.01,0,.02h0Z"
              />
              <path
                className="cls-107"
                d="M234.75,61.18c.03.13.05.26.07.39.6.44.87.55.86.46,0-.07-.27-.36-.92-.85h0Z"
              />
              <path
                className="cls-107"
                d="M234.85,61.95c0,.13.01.26.01.38.61.44.89.56.89.47,0-.07-.24-.37-.9-.86h0Z"
              />
            </g>
            <g className="cls-20">
              <path
                className="cls-107"
                d="M247.34,72.02c.04.15.36.54.81,1-.02-.15-.05-.31-.08-.46-.56-.55-.75-.62-.73-.54h0Z"
              />
              <path
                className="cls-107"
                d="M247.43,72.92c.03.15.33.55.78,1.01,0-.15,0-.31-.01-.46-.56-.56-.77-.63-.77-.55h0Z"
              />
              <path
                className="cls-107"
                d="M244.07,68.57c.11.3,1.43,1.54,1.6,1.51,0,0,0-.02,0-.03-.53-.5-1.07-.99-1.61-1.48h0Z"
              />
              <path
                className="cls-107"
                d="M244.22,69.45c.04.15.36.53.83.97.35.33.74.63.78.55.08-.18-1.42-1.63-1.59-1.55,0,0-.01.02-.01.03h0Z"
              />
              <path
                className="cls-107"
                d="M244.24,70.32c.54.5,1.08,1,1.61,1.51-.05-.44-1.52-1.65-1.6-1.53,0,0,0,.01,0,.02h0Z"
              />
              <path
                className="cls-107"
                d="M241.65,66.62c.03.14.05.28.07.43.57.48.81.6.8.51-.01-.08-.26-.4-.87-.93h0Z"
              />
              <path
                className="cls-107"
                d="M241.76,67.47c0,.14.01.28.01.42.57.49.83.61.83.52,0-.08-.23-.4-.84-.94h0Z"
              />
            </g>
            <g className="cls-17">
              <path
                className="cls-107"
                d="M253.34,78.39c.04.16.34.58.75,1.07-.02-.16-.05-.33-.08-.49-.48-.56-.62-.62-.66-.61,0,0,0,.02,0,.03h0Z"
              />
              <path
                className="cls-107"
                d="M250.31,74.67c.11.33,1.33,1.67,1.48,1.63,0,0,0-.02,0-.03-.49-.54-.98-1.07-1.48-1.6h0Z"
              />
              <path
                className="cls-107"
                d="M248.07,72.55c.03.15.06.31.08.46.53.53.76.66.74.56-.01-.08-.24-.43-.82-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M248.2,73.47c0,.15.01.31.01.46.53.53.77.67.77.56,0-.08-.21-.43-.79-1.02h0Z"
              />
            </g>
            <g className="cls-21">
              <path
                className="cls-107"
                d="M259.49,86.34c-.37-.52-.64-.97-.68-1.14,0-.01,0-.03,0-.03.03-.01.16.06.59.65.04.17.07.35.09.52h0Z"
              />
              <path
                className="cls-107"
                d="M257.39,82.95s0,.02,0,.03c-.13.04-1.23-1.39-1.35-1.74.45.56.9,1.13,1.35,1.71h0Z"
              />
              <path
                className="cls-107"
                d="M254.08,79.05c.31.37.72.93.67,1.03-.07.02-.3-.2-.66-.62-.02-.16-.05-.33-.08-.49.02.03.05.06.07.09h0Z"
              />
            </g>
            <g className="cls-18">
              <path
                className="cls-107"
                d="M262.43,90.05s0,.03,0,.04c-.1.04-1.1-1.48-1.21-1.85.41.6.81,1.2,1.21,1.81h0Z"
              />
              <path
                className="cls-107"
                d="M259.47,85.91c.28.39.65.99.61,1.09-.06.02-.27-.22-.59-.66-.02-.17-.05-.35-.09-.52.02.03.05.06.07.09h0Z"
              />
            </g>
            <g className="cls-70">
              <path
                className="cls-107"
                d="M226.53,57.22c.02.12.37.41.92.77.02-.11.03-.23.04-.35-.69-.43-.95-.49-.96-.43h0Z"
              />
              <path
                className="cls-107"
                d="M226.4,57.9c0,.06.32.36.33.36,0,0,.19.16.57.42.03-.11.06-.23.09-.34-.64-.41-.95-.51-.99-.44h0Z"
              />
              <path
                className="cls-107"
                d="M222.69,54.59c.07.32,1.85,1.23,1.93,1.14,0,0,0,0,0-.01-.64-.38-1.29-.76-1.94-1.12h0Z"
              />
              <path
                className="cls-107"
                d="M222.62,55.23c.03.32,1.83,1.25,1.93,1.16.15-.13-1.5-1.17-1.88-1.18-.03,0-.05,0-.05.02h0Z"
              />
            </g>
            <g className="cls-71">
              <path
                className="cls-107"
                d="M233.93,62.25c.01.13.35.46.87.86.02-.13.03-.26.04-.39-.65-.48-.9-.54-.91-.47h0Z"
              />
              <path
                className="cls-107"
                d="M233.79,63c0,.13.32.46.84.87.04-.13.07-.25.1-.38-.7-.52-.92-.55-.94-.48h0Z"
              />
              <path
                className="cls-107"
                d="M230.31,59.3c.06.35,1.75,1.38,1.83,1.28,0,0,0-.01,0-.02-.61-.43-1.22-.85-1.84-1.26h0Z"
              />
              <path
                className="cls-107"
                d="M230.22,60.02c.02.35,1.73,1.39,1.83,1.3.15-.15-1.41-1.31-1.78-1.32-.03,0-.05,0-.05.03h0Z"
              />
              <path
                className="cls-107"
                d="M230.04,60.74c.61.43,1.22.86,1.83,1.3.02-.35-1.7-1.41-1.82-1.32,0,0,0,.01-.01.01h0Z"
              />
              <path
                className="cls-107"
                d="M227.49,57.65c0,.12-.02.23-.04.35.67.42,1,.53.96.41-.02-.07-.24-.32-.92-.76h0Z"
              />
              <path
                className="cls-107"
                d="M227.39,58.33c-.03.11-.05.23-.09.34.67.43,1.01.54.99.42-.01-.07-.22-.32-.9-.77h0Z"
              />
            </g>
            <g className="cls-72">
              <path
                className="cls-107"
                d="M240.89,67.79c.01.14.32.51.82.95.02-.14.04-.28.05-.42-.61-.53-.85-.6-.87-.52h0Z"
              />
              <path
                className="cls-107"
                d="M240.74,68.62c0,.14.3.51.79.95.04-.14.08-.28.11-.42-.62-.54-.87-.61-.89-.53h0Z"
              />
              <path
                className="cls-107"
                d="M237.5,64.56c.02.16.48.58.85.89.37.31.81.59.87.52,0,0,0-.01,0-.02-.57-.47-1.15-.93-1.73-1.39h0Z"
              />
              <path
                className="cls-107"
                d="M237.41,65.35c0,.13.33.49.83.9.37.31.82.6.89.53.15-.16-1.31-1.44-1.67-1.46-.03,0-.05,0-.05.03h0Z"
              />
              <path
                className="cls-107"
                d="M237.2,66.15c.58.47,1.15.95,1.72,1.43.02-.19-.52-.69-.71-.85-.62-.53-.95-.65-1-.6,0,0,0,.01-.01.02h0Z"
              />
              <path
                className="cls-107"
                d="M234.84,62.72c-.01.13-.02.26-.04.39.63.47.94.59.91.46-.02-.08-.22-.35-.87-.84h0Z"
              />
              <path
                className="cls-107"
                d="M234.73,63.49c-.03.13-.06.25-.1.38.63.48.96.6.94.47-.01-.08-.2-.35-.84-.85h0Z"
              />
            </g>
            <g className="cls-73">
              <path
                className="cls-107"
                d="M247.39,73.83c0,.16.29.55.75,1.02.02-.15.04-.31.05-.46-.56-.56-.79-.64-.8-.56h0Z"
              />
              <path
                className="cls-107"
                d="M247.22,74.73c-.01.15.27.55.71,1.02.04-.15.08-.3.12-.45-.56-.57-.81-.65-.83-.57h0Z"
              />
              <path
                className="cls-107"
                d="M244.24,70.32c.02.15.33.53.79.97.35.33.76.64.81.56,0,0,0-.01,0-.02-.53-.51-1.07-1.01-1.61-1.51h0Z"
              />
              <path
                className="cls-107"
                d="M244.14,71.19c0,.15.3.53.76.98.35.34.77.65.84.57.16-.18-1.21-1.57-1.55-1.58-.03,0-.04.01-.05.03h0Z"
              />
              <path
                className="cls-107"
                d="M243.92,72.05c.54.51,1.07,1.03,1.6,1.55.02-.2-.47-.74-.65-.92-.58-.57-.89-.7-.94-.65,0,0,0,.01-.01.02h0Z"
              />
              <path
                className="cls-107"
                d="M241.76,68.31c-.01.14-.03.28-.05.42.57.49.84.62.86.52.01-.08-.2-.4-.81-.95h0Z"
              />
              <path
                className="cls-107"
                d="M241.63,69.16c-.03.14-.07.28-.11.42.59.52.9.65.89.51,0-.08-.18-.39-.78-.93h0Z"
              />
            </g>
            <g className="cls-74">
              <path
                className="cls-107"
                d="M253.39,80.33c0,.17.27.58.68,1.09.02-.16.04-.33.06-.49-.52-.6-.72-.69-.74-.6h0Z"
              />
              <path
                className="cls-107"
                d="M253.21,81.3c-.01.16.24.59.64,1.09.05-.16.09-.32.12-.49-.52-.61-.74-.7-.77-.61h0Z"
              />
              <path
                className="cls-107"
                d="M250.39,77.5c0,.16.27.57.7,1.06.32.36.71.69.78.61.15-.18-1.12-1.69-1.43-1.7-.02,0-.04.01-.05.03h0Z"
              />
              <path
                className="cls-107"
                d="M250.15,78.43c.5.55.99,1.1,1.48,1.66.03-.22-.42-.8-.59-.98-.54-.62-.82-.76-.88-.7,0,0,0,.01-.01.02h0Z"
              />
              <path
                className="cls-107"
                d="M248.19,74.39c-.01.15-.03.31-.05.46.53.54.79.67.81.57.01-.08-.18-.44-.75-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M248.05,75.3c-.03.15-.07.3-.12.45.55.57.85.71.84.56,0-.09-.16-.42-.72-1.01h0Z"
              />
            </g>
            <g className="cls-75">
              <path
                className="cls-107"
                d="M254.2,81.02c.44.54.71,1.05.57,1.04-.04,0-.2-.05-.7-.64.02-.16.04-.33.06-.49.02.03.05.06.07.09h0Z"
              />
              <path
                className="cls-107"
                d="M254.05,82c.44.55.69,1.05.52,1.05-.04,0-.22-.06-.72-.65.05-.16.09-.32.12-.49.02.03.05.06.07.09h0Z"
              />
            </g>
            <g className="cls-68">
              <path
                className="cls-107"
                d="M268.3,104.71s-.04-.09-.06-.13c.02.04.04.08.06.13,0,0,0,0,0,0h0Z"
              />
              <path
                className="cls-107"
                d="M266.56,99.76c.33.62.51,1.2.39,1.19-.2-.02-1.06-1.57-1.02-1.99.06-.17.41.36.64.8h0Z"
              />
              <path
                className="cls-107"
                d="M266.31,100.87c.15.3.43.92.38,1.16-.35-.66-.7-1.31-1.06-1.96.09-.17.45.37.68.81h0Z"
              />
            </g>
            <g className="cls-66">
              <path
                className="cls-107"
                d="M270.22,108.85c.13.31.37.96.31,1.21-.29-.68-.6-1.37-.9-2.04.09-.18.4.38.59.83h0Z"
              />
              <path
                className="cls-107"
                d="M268.37,104.86s-.05-.1-.07-.15c0,0,0,0,0,0,.03.05.05.1.08.15,0,0,0,0,0,0h0Z"
              />
            </g>
            <g className="cls-69">
              <path
                className="cls-107"
                d="M273.5,117.14c.11.34.29.99.23,1.24-.24-.71-.48-1.41-.74-2.11.08-.18.32.36.46.76.01.03.03.08.04.11h0Z"
              />
            </g>
            <g className="cls-67">
              <path
                className="cls-107"
                d="M233.54,63.76c-.02.13.29.46.81.87.05-.13.11-.25.15-.38-.65-.49-.93-.57-.96-.49h0Z"
              />
              <path
                className="cls-107"
                d="M233.19,64.51c-.03.13.27.47.78.88.07-.13.14-.25.2-.38-.65-.5-.94-.58-.98-.51h0Z"
              />
              <path
                className="cls-107"
                d="M230.04,60.74c-.02.35,1.7,1.41,1.82,1.32,0,0,0-.01.01-.02-.61-.44-1.22-.87-1.83-1.3h0Z"
              />
              <path
                className="cls-107"
                d="M229.76,61.45c-.03.15.43.54.83.84.4.29.88.57.98.5.2-.14-1.2-1.25-1.7-1.36-.06-.01-.09,0-.1.02h0Z"
              />
              <path
                className="cls-107"
                d="M229.37,62.16c.61.44,1.21.89,1.81,1.34.05-.17-.5-.63-.7-.78-.66-.5-1.02-.61-1.09-.57,0,0-.01.01-.02.01h0Z"
              />
            </g>
            <g className="cls-62">
              <path
                className="cls-107"
                d="M240.47,69.45c-.02.14.27.51.75.96.06-.14.12-.28.17-.42-.61-.54-.89-.62-.92-.54h0Z"
              />
              <path
                className="cls-107"
                d="M240.08,70.27c-.04.14.24.51.72.97.08-.14.15-.28.22-.41-.61-.55-.9-.63-.95-.56h0Z"
              />
              <path
                className="cls-107"
                d="M237.2,66.15c-.01.13.3.49.79.91.37.32.83.61.91.54,0,0,0-.01.01-.02-.57-.48-1.14-.96-1.72-1.43h0Z"
              />
              <path
                className="cls-107"
                d="M236.89,66.94c-.03.16.39.6.76.92.37.32.84.62.94.55.21-.15-1.1-1.37-1.59-1.49-.06-.01-.09,0-.1.02h0Z"
              />
              <path
                className="cls-107"
                d="M236.47,67.72c.57.48,1.14.97,1.7,1.47.06-.18-.46-.69-.64-.86-.62-.54-.97-.67-1.04-.62,0,0-.01.01-.02.02h0Z"
              />
              <path
                className="cls-107"
                d="M234.51,64.25c-.05.13-.1.25-.15.38.63.48.97.61.96.48,0-.08-.18-.36-.81-.86h0Z"
              />
              <path
                className="cls-107"
                d="M234.18,65.01c-.06.13-.13.25-.2.38.66.51,1.03.64.99.46,0-.03-.07-.27-.78-.84h0Z"
              />
            </g>
            <g className="cls-56">
              <path
                className="cls-107"
                d="M246.93,75.63c-.03.15.23.55.68,1.03.07-.15.13-.3.18-.45-.56-.58-.82-.66-.86-.58h0Z"
              />
              <path
                className="cls-107"
                d="M246.51,76.53c-.05.15.21.56.64,1.04.09-.15.17-.3.24-.45-.56-.59-.84-.67-.89-.59h0Z"
              />
              <path
                className="cls-107"
                d="M243.92,72.05c-.02.15.27.54.73.99.35.34.78.66.86.58,0,0,0-.01.01-.02-.53-.52-1.06-1.04-1.6-1.55h0Z"
              />
              <path
                className="cls-107"
                d="M243.57,72.92c-.03.15.24.54.7,1,.35.35.78.67.88.59.23-.17-1.1-1.59-1.51-1.61-.03,0-.06,0-.07.03h0Z"
              />
              <path
                className="cls-107"
                d="M243.11,73.77c.53.52,1.06,1.05,1.59,1.58.07-.2-.41-.75-.58-.93-.57-.58-.91-.72-.99-.67,0,0-.01.01-.02.02h0Z"
              />
              <path
                className="cls-107"
                d="M241.39,69.99c-.05.14-.11.28-.17.42.59.53.91.66.92.52,0-.08-.15-.39-.75-.94h0Z"
              />
              <path
                className="cls-107"
                d="M241.02,70.83c-.07.14-.14.28-.22.41.62.56.97.69.94.5,0-.03-.06-.29-.72-.91h0Z"
              />
            </g>
            <g className="cls-57">
              <path
                className="cls-107"
                d="M252.9,82.26c-.04.16.2.59.61,1.1.07-.16.13-.32.19-.48-.52-.62-.76-.71-.8-.62h0Z"
              />
              <path
                className="cls-107"
                d="M252.45,83.22c-.05.16.17.6.57,1.11.09-.16.18-.32.26-.48-.52-.62-.78-.72-.83-.63h0Z"
              />
              <path
                className="cls-107"
                d="M250.15,78.43c-.02.16.24.58.66,1.06.32.37.72.7.8.62,0,0,0-.01.01-.02-.49-.56-.98-1.11-1.48-1.66h0Z"
              />
              <path
                className="cls-107"
                d="M249.78,79.36c-.04.16.2.58.63,1.07.32.37.73.71.83.63.22-.17-1.02-1.71-1.39-1.73-.03,0-.05.01-.07.03h0Z"
              />
              <path
                className="cls-107"
                d="M249.28,80.28c.49.56.98,1.12,1.46,1.69.08-.22-.36-.81-.52-.99-.53-.63-.85-.77-.93-.72,0,0-.01.01-.02.02h0Z"
              />
              <path
                className="cls-107"
                d="M247.79,76.21c-.05.15-.11.3-.18.45.55.57.86.72.87.57,0-.09-.13-.42-.69-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M247.4,77.11c-.08.15-.16.3-.24.45.55.58.88.73.9.58,0-.01.03-.27-.66-1.02h0Z"
              />
            </g>
            <g className="cls-58">
              <path
                className="cls-107"
                d="M255.82,87.96c.19.27.53.84.45,1.06-.44-.6-.88-1.2-1.33-1.8.14-.15.6.34.88.74h0Z"
              />
              <path
                className="cls-107"
                d="M253.77,82.97c.43.55.66,1.06.48,1.05-.05,0-.24-.06-.74-.66.07-.16.13-.32.19-.48.02.03.05.06.07.09h0Z"
              />
              <path
                className="cls-107"
                d="M253.35,83.94c.43.56.64,1.07.43,1.05-.05,0-.27-.06-.76-.66.09-.16.18-.32.26-.48.02.03.05.06.07.09h0Z"
              />
            </g>
            <g className="cls-59">
              <path
                className="cls-107"
                d="M267.51,104.56c-.05.19.09.68.38,1.28.08-.19.16-.37.22-.56-.36-.72-.56-.82-.6-.72h0Z"
              />
              <path
                className="cls-107"
                d="M266.99,105.68c-.07.19.06.69.33,1.28.11-.19.21-.37.3-.56-.39-.78-.59-.81-.64-.72h0Z"
              />
              <path
                className="cls-107"
                d="M265.64,100.06c-.09.47.86,2.07,1.03,2,.01,0,.02-.02.03-.04-.35-.66-.7-1.31-1.06-1.96h0Z"
              />
              <path
                className="cls-107"
                d="M265.2,101.16c-.15.47.81,2.07,1.02,2.01.27-.08-.47-1.77-.89-2.02-.08-.05-.11-.02-.13.01h0Z"
              />
              <path
                className="cls-107"
                d="M264.61,102.25c.36.66.71,1.32,1.05,1.99.2-.46-.76-2.08-1.01-2.02-.02,0-.03.02-.04.03h0Z"
              />
            </g>
            <g className="cls-60">
              <path
                className="cls-107"
                d="M271.19,112.69c-.06.2.06.71.29,1.33.08-.19.16-.39.23-.58-.33-.8-.49-.84-.52-.75h0Z"
              />
              <path
                className="cls-107"
                d="M270.64,113.85c-.08.2.02.71.25,1.33.11-.19.22-.38.31-.58-.33-.81-.51-.85-.56-.75h0Z"
              />
              <path
                className="cls-107"
                d="M269.63,108.01c-.1.48.71,2.15.88,2.08.01,0,.02-.02.03-.04-.29-.68-.6-1.37-.9-2.04h0Z"
              />
              <path
                className="cls-107"
                d="M269.18,109.15c-.16.48.66,2.16.86,2.09.26-.09-.42-1.97-.78-2.12-.05-.02-.08,0-.09.03h0Z"
              />
              <path
                className="cls-107"
                d="M268.57,110.28c.3.68.6,1.37.89,2.06.22-.48-.62-2.16-.85-2.1-.02,0-.03.02-.04.04h0Z"
              />
              <path
                className="cls-107"
                d="M268.11,105.28c-.07.19-.14.38-.22.56.34.68.55.85.6.72.04-.11-.02-.54-.38-1.28h0Z"
              />
              <path
                className="cls-107"
                d="M267.62,106.4c-.09.19-.19.37-.3.56.34.68.6.89.65.69.03-.11,0-.52-.35-1.25h0Z"
              />
            </g>
            <g className="cls-63">
              <path
                className="cls-107"
                d="M274.21,121.12c-.06.21.02.73.21,1.37.09-.2.17-.4.24-.6-.26-.83-.4-.87-.44-.77h0Z"
              />
              <path
                className="cls-107"
                d="M273.65,122.31c-.08.2-.02.73.16,1.37.11-.2.22-.4.32-.59-.26-.83-.43-.87-.48-.78h0Z"
              />
              <path
                className="cls-107"
                d="M272.99,116.27c-.11.5.56,2.22.71,2.15.01,0,.02-.03.03-.04-.24-.71-.48-1.41-.74-2.11h0Z"
              />
              <path
                className="cls-107"
                d="M272.52,117.45c-.17.5.51,2.22.7,2.15.24-.09-.3-2.03-.61-2.19-.05-.02-.07,0-.08.03h0Z"
              />
              <path
                className="cls-107"
                d="M271.89,118.62c.25.71.49,1.41.73,2.12.23-.49-.46-2.23-.69-2.16-.02,0-.03.02-.04.04h0Z"
              />
              <path
                className="cls-107"
                d="M271.71,113.44c-.07.19-.15.39-.23.58.28.7.47.88.52.75.05-.11,0-.55-.29-1.33h0Z"
              />
              <path
                className="cls-107"
                d="M271.21,114.6c-.1.19-.2.39-.31.58.3.75.5.86.56.76.06-.11.04-.55-.25-1.33h0Z"
              />
            </g>
            <g className="cls-64">
              <path
                className="cls-107"
                d="M275.98,131.02c-.09.21-.06.75.07,1.41.12-.2.23-.4.33-.61-.19-.86-.35-.9-.4-.8h0Z"
              />
              <path
                className="cls-107"
                d="M274.56,127.23c.19.73.38,1.46.56,2.19.25-.51-.27-2.3-.52-2.23-.02,0-.03.02-.04.04h0Z"
              />
              <path
                className="cls-107"
                d="M274.65,121.89c-.07.2-.15.4-.24.6.23.72.39.91.44.78.04-.11.03-.58-.21-1.37h0Z"
              />
              <path
                className="cls-107"
                d="M274.13,123.08c-.1.2-.21.4-.32.59.24.78.42.89.48.78.06-.11.07-.57-.16-1.38h0Z"
              />
            </g>
            <g className="cls-65">
              <path
                className="cls-107"
                d="M276.93,137.01c.05.34.11,1.05-.01,1.31-.12-.75-.25-1.5-.38-2.24.15-.19.32.43.4.93h0Z"
              />
              <path
                className="cls-107"
                d="M276.4,131.94c.15.76.13,1.43-.03,1.33-.05-.03-.17-.17-.32-.84.12-.2.23-.4.33-.61,0,.03.02.08.02.11h0Z"
              />
            </g>
            <g className="cls-61">
              <path
                className="cls-107"
                d="M226.27,60.71c-.54-.38-.85-.69-.81-.81.09-.08.5.11,1.04.47-.07.11-.15.22-.23.34h0Z"
              />
            </g>
            <g className="cls-83">
              <path
                className="cls-107"
                d="M232.74,65.25c-.05.13.24.47.75.89.09-.12.18-.25.26-.37-.65-.51-.95-.59-1-.52h0Z"
              />
              <path
                className="cls-107"
                d="M232.18,65.98c-.06.13.21.47.71.9.11-.12.21-.25.31-.37-.64-.52-.96-.6-1.02-.53h0Z"
              />
              <path
                className="cls-107"
                d="M229.37,62.16c-.04.15.4.55.8.84.39.3.89.58,1,.51,0,0,.01-.01.02-.02-.6-.45-1.2-.9-1.81-1.34h0Z"
              />
              <path
                className="cls-107"
                d="M228.89,62.86c-.06.15.37.55.76.85.39.3.89.59,1.02.52.24-.13-1-1.19-1.61-1.38-.12-.04-.16-.01-.17,0h0Z"
              />
              <path
                className="cls-107"
                d="M228.32,63.55c.6.45,1.19.92,1.78,1.38.09-.17-.43-.63-.64-.8-.65-.51-1.03-.64-1.12-.6,0,0-.01.01-.02.01h0Z"
              />
              <path
                className="cls-107"
                d="M226.5,60.37c-.07.11-.15.22-.23.34.69.47,1.08.59,1.05.43,0-.02-.07-.24-.82-.77h0Z"
              />
            </g>
            <g className="cls-77">
              <path
                className="cls-107"
                d="M239.58,71.09c-.06.14.21.51.69.98.1-.14.19-.27.28-.41-.61-.56-.91-.64-.97-.57h0Z"
              />
              <path
                className="cls-107"
                d="M238.96,71.9c-.07.14.18.52.65.98.12-.14.23-.27.34-.41-.61-.56-.93-.65-.99-.58h0Z"
              />
              <path
                className="cls-107"
                d="M236.47,67.72c-.04.13.24.5.73.93.37.32.84.63.96.56,0,0,.01-.01.02-.02-.56-.49-1.13-.98-1.7-1.47h0Z"
              />
              <path
                className="cls-107"
                d="M235.93,68.5c-.06.13.21.5.7.94.37.33.85.64.97.57.26-.14-.9-1.31-1.5-1.5-.12-.04-.16-.02-.17,0h0Z"
              />
              <path
                className="cls-107"
                d="M235.29,69.27c.56.5,1.12,1,1.67,1.5.1-.18-.39-.7-.58-.87-.6-.56-.98-.69-1.08-.65,0,0-.02.01-.02.02h0Z"
              />
              <path
                className="cls-107"
                d="M233.74,65.76c-.08.12-.17.25-.26.37.66.52,1.04.65,1.01.47,0-.03-.05-.27-.76-.85h0Z"
              />
              <path
                className="cls-107"
                d="M233.2,66.51c-.1.12-.2.25-.31.37.65.53,1.05.66,1.04.48,0-.03-.03-.27-.73-.85h0Z"
              />
            </g>
            <g className="cls-78">
              <path
                className="cls-107"
                d="M245.97,77.41c-.07.15.17.55.61,1.04.11-.15.21-.3.31-.44-.56-.59-.85-.68-.91-.6h0Z"
              />
              <path
                className="cls-107"
                d="M245.3,78.29c-.08.15.14.56.57,1.05.13-.15.25-.29.37-.44-.56-.6-.87-.69-.94-.61h0Z"
              />
              <path
                className="cls-107"
                d="M243.11,73.77c-.05.15.21.54.66,1,.34.35.79.67.91.6,0,0,.01-.01.02-.02-.52-.53-1.05-1.06-1.59-1.58h0Z"
              />
              <path
                className="cls-107"
                d="M242.53,74.62c-.07.15.17.54.62,1.01.34.35.79.68.93.61.28-.16-.89-1.51-1.43-1.64-.06-.02-.1,0-.12.02h0Z"
              />
              <path
                className="cls-107"
                d="M241.83,75.46c.53.53,1.05,1.07,1.56,1.62.22-.37-1.19-1.69-1.51-1.64-.02,0-.04.02-.05.03h0Z"
              />
              <path
                className="cls-107"
                d="M240.55,71.66c-.09.14-.18.27-.28.41.62.57.98.71.97.51,0-.03-.04-.29-.69-.92h0Z"
              />
              <path
                className="cls-107"
                d="M239.95,72.48c-.11.14-.22.27-.34.41.61.57,1,.72,1,.52,0-.03-.01-.29-.66-.93h0Z"
              />
            </g>
            <g className="cls-79">
              <path
                className="cls-107"
                d="M251.86,84.17c-.07.16.13.59.53,1.11.11-.16.22-.32.33-.48-.52-.63-.8-.72-.86-.63h0Z"
              />
              <path
                className="cls-107"
                d="M251.15,85.12c-.09.16.1.6.49,1.12.14-.16.27-.31.39-.47-.51-.64-.81-.73-.89-.64h0Z"
              />
              <path
                className="cls-107"
                d="M249.28,80.28c-.06.16.17.58.59,1.08.32.37.73.72.85.64,0,0,.01-.01.02-.02-.48-.57-.97-1.13-1.46-1.69h0Z"
              />
              <path
                className="cls-107"
                d="M248.65,81.2c-.2.4,1.11,1.79,1.4,1.74.32-.06-.43-1.22-1.07-1.65-.23-.16-.31-.12-.33-.09h0Z"
              />
              <path
                className="cls-107"
                d="M247.9,82.11c.48.57.96,1.15,1.44,1.73.25-.4-1.06-1.81-1.38-1.75-.02,0-.04.02-.06.03h0Z"
              />
              <path
                className="cls-107"
                d="M246.88,78.01c-.1.15-.2.3-.31.44.58.61.93.76.93.55,0-.03-.02-.32-.63-1h0Z"
              />
              <path
                className="cls-107"
                d="M246.24,78.9c-.12.15-.24.29-.37.44.57.62.95.77.97.56,0-.03,0-.32-.6-1h0Z"
              />
            </g>
            <g className="cls-80">
              <path
                className="cls-107"
                d="M257.24,91.34c-.08.17.09.62.46,1.17.12-.17.24-.34.35-.51-.47-.66-.74-.76-.8-.67h0Z"
              />
              <path
                className="cls-107"
                d="M256.48,92.34c-.1.17.06.63.42,1.18.14-.17.28-.33.42-.5-.46-.67-.75-.77-.83-.68h0Z"
              />
              <path
                className="cls-107"
                d="M254.94,87.22c-.17.42,1.03,1.89,1.29,1.83.02,0,.03-.02.04-.03-.44-.6-.88-1.2-1.33-1.8h0Z"
              />
              <path
                className="cls-107"
                d="M254.27,88.2c-.22.42.98,1.9,1.27,1.84.33-.07-.41-1.39-1-1.79-.07-.05-.21-.12-.27-.05h0Z"
              />
              <path
                className="cls-107"
                d="M253.47,89.17c.44.6.88,1.21,1.31,1.82.27-.42-.93-1.91-1.25-1.86-.02,0-.04.02-.06.03h0Z"
              />
              <path
                className="cls-107"
                d="M252.72,84.81c-.1.16-.21.32-.33.48.52.65.86.8.88.58,0-.03,0-.34-.55-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M252.04,85.76c-.13.16-.26.32-.39.47.52.65.88.81.91.58,0-.05.02-.35-.52-1.06h0Z"
              />
            </g>
            <g className="cls-81">
              <path
                className="cls-107"
                d="M262.07,98.89c-.09.18.05.66.38,1.23.13-.18.25-.35.36-.53-.41-.7-.67-.8-.74-.7h0Z"
              />
              <path
                className="cls-107"
                d="M261.27,99.94c-.11.18.02.66.33,1.24.15-.17.3-.35.44-.53-.41-.7-.69-.81-.77-.71h0Z"
              />
              <path
                className="cls-107"
                d="M259.36,95.59c-.24.45.85,2,1.13,1.94.34-.07-.38-1.58-.92-1.92-.1-.06-.17-.07-.21-.02h0Z"
              />
              <path
                className="cls-107"
                d="M258.5,96.61c.4.64.79,1.27,1.17,1.92.3-.45-.8-2.01-1.11-1.95-.02,0-.04.02-.06.03h0Z"
              />
              <path
                className="cls-107"
                d="M258.04,92.01c-.11.17-.23.34-.35.51.47.68.8.85.82.61,0-.03.02-.36-.48-1.11h0Z"
              />
              <path
                className="cls-107"
                d="M257.31,93.02c-.13.17-.27.33-.42.5.47.69.81.85.86.62.01-.06.04-.37-.45-1.12h0Z"
              />
            </g>
            <g className="cls-84">
              <path
                className="cls-107"
                d="M266.31,106.78c-.1.19.02.68.29,1.29.13-.18.26-.37.38-.55-.36-.73-.6-.84-.67-.73h0Z"
              />
              <path
                className="cls-107"
                d="M265.47,107.88c-.12.19-.02.69.25,1.29.16-.18.31-.37.46-.55-.39-.79-.63-.83-.71-.74h0Z"
              />
              <path
                className="cls-107"
                d="M264.61,102.25c-.2.46.76,2.08,1.01,2.02.02,0,.03-.02.04-.03-.34-.67-.69-1.33-1.05-1.99h0Z"
              />
              <path
                className="cls-107"
                d="M263.87,103.33c-.26.47.71,2.09.99,2.03.34-.08-.35-1.77-.83-2.04-.09-.05-.14-.02-.16,0h0Z"
              />
              <path
                className="cls-107"
                d="M262.98,104.4c.35.67.69,1.34,1.03,2.01.31-.46-.66-2.1-.97-2.04-.02,0-.04.02-.06.03h0Z"
              />
              <path
                className="cls-107"
                d="M262.81,99.59c-.12.18-.24.35-.36.53.4.68.69.86.76.68.04-.11,0-.5-.39-1.21h0Z"
              />
              <path
                className="cls-107"
                d="M262.04,100.65c-.14.18-.29.35-.44.53.41.7.75.9.81.64,0-.04.07-.37-.37-1.17h0Z"
              />
            </g>
            <g className="cls-85">
              <path
                className="cls-107"
                d="M269.94,114.99c-.1.2-.02.71.21,1.33.14-.19.27-.38.39-.57-.33-.81-.54-.85-.6-.76h0Z"
              />
              <path
                className="cls-107"
                d="M269.08,116.13c-.13.2-.06.71.16,1.33.16-.19.32-.38.47-.57-.33-.82-.56-.86-.64-.77h0Z"
              />
              <path
                className="cls-107"
                d="M268.57,110.28c-.22.48.62,2.16.85,2.1.02,0,.03-.02.04-.04-.29-.69-.59-1.38-.89-2.06h0Z"
              />
              <path
                className="cls-107"
                d="M267.8,111.41c-.28.48.56,2.17.84,2.11.34-.08-.23-1.84-.68-2.12-.09-.05-.13-.02-.15,0h0Z"
              />
              <path
                className="cls-107"
                d="M266.87,112.52c.3.69.59,1.39.88,2.08.33-.48-.51-2.18-.82-2.12-.02,0-.04.02-.06.04h0Z"
              />
              <path
                className="cls-107"
                d="M266.98,107.52c-.12.18-.25.37-.38.55.35.71.62.89.69.7.04-.11.03-.52-.31-1.26h0Z"
              />
              <path
                className="cls-107"
                d="M266.18,108.62c-.15.18-.3.37-.46.55.35.73.67.93.74.67.01-.04.09-.39-.29-1.22h0Z"
              />
            </g>
            <g className="cls-86">
              <path
                className="cls-107"
                d="M272.93,123.49c-.11.2-.06.73.12,1.37.14-.2.28-.39.4-.59-.26-.84-.46-.88-.52-.78h0Z"
              />
              <path
                className="cls-107"
                d="M272.04,124.66c-.13.2-.1.73.08,1.37.17-.19.33-.39.49-.58-.26-.84-.48-.88-.56-.79h0Z"
              />
              <path
                className="cls-107"
                d="M271.89,118.62c-.23.5.46,2.23.68,2.16.02,0,.03-.02.04-.04-.24-.71-.48-1.42-.73-2.12h0Z"
              />
              <path
                className="cls-107"
                d="M271.1,119.78c-.29.5.41,2.24.67,2.17.32-.08-.11-1.9-.52-2.18-.08-.06-.13-.02-.15,0h0Z"
              />
              <path
                className="cls-107"
                d="M270.14,120.93c.25.71.48,1.42.72,2.14.35-.49-.36-2.24-.66-2.18-.02,0-.04.02-.06.04h0Z"
              />
              <path
                className="cls-107"
                d="M270.54,115.75c-.12.19-.26.38-.39.57.29.74.54.93.62.73.05-.12.06-.54-.23-1.3h0Z"
              />
              <path
                className="cls-107"
                d="M269.71,116.9c-.15.19-.31.38-.47.57.29.74.56.93.66.74.06-.11.09-.53-.19-1.3h0Z"
              />
            </g>
            <g className="cls-82">
              <path
                className="cls-107"
                d="M275.24,132.23c-.11.21-.1.75.03,1.41.14-.2.28-.4.41-.6-.19-.86-.37-.9-.44-.81h0Z"
              />
              <path
                className="cls-107"
                d="M274.56,127.23c-.24.51.3,2.29.52,2.23.02,0,.03-.02.04-.04-.18-.73-.37-1.46-.56-2.19h0Z"
              />
              <path
                className="cls-107"
                d="M273.74,128.41c-.31.51.25,2.3.5,2.23.34-.09,0-2.08-.39-2.26-.06-.03-.09,0-.11.03h0Z"
              />
              <path
                className="cls-107"
                d="M272.76,129.59c.19.73.37,1.46.55,2.2.36-.5-.2-2.3-.49-2.24-.02,0-.04.02-.06.04h0Z"
              />
              <path
                className="cls-107"
                d="M273.45,124.27c-.13.2-.26.39-.4.59.24.76.46.96.54.75.05-.12.09-.55-.14-1.34h0Z"
              />
              <path
                className="cls-107"
                d="M272.6,125.45c-.16.19-.32.39-.49.58.24.76.48.96.58.76.06-.12.12-.55-.1-1.34h0Z"
              />
            </g>
            <g className="cls-40">
              <path
                className="cls-107"
                d="M275.82,143.84c-.08-.67-.03-1.24.11-1.45.15-.14.3.18.4.84-.16.2-.33.4-.5.6h0Z"
              />
              <path
                className="cls-107"
                d="M276.91,138.32c-.16.2-.36-.54-.43-1.17-.02-.19-.08-.83.04-1.08.13.75.26,1.49.38,2.24h0Z"
              />
              <path
                className="cls-107"
                d="M275.71,133.15c.14.76.1,1.43-.09,1.33-.05-.03-.19-.17-.34-.84.14-.2.28-.4.41-.6,0,.03.02.08.02.11h0Z"
              />
            </g>
            <g className="cls-53">
              <path
                className="cls-107"
                d="M276.8,151.56c-.14.21-.22.78-.2,1.46.18-.2.34-.4.51-.61-.05-.9-.22-.95-.3-.85h0Z"
              />
              <path
                className="cls-107"
                d="M276.94,146.35c-.33.53-.11,2.4.15,2.33.29-.08.24-2.17-.05-2.36-.05-.03-.08,0-.1.03h0Z"
              />
              <path
                className="cls-107"
                d="M275.93,147.57c.07.76.14,1.53.19,2.29.38-.51.12-2.39-.14-2.33-.02,0-.04.02-.06.04h0Z"
              />
              <path
                className="cls-107"
                d="M276.33,143.24c-.16.2-.33.4-.5.6.11.82.3.95.39.84.1-.11.2-.59.11-1.44h0Z"
              />
            </g>
            <g className="cls-42">
              <path
                className="cls-107"
                d="M276.7,157.79c0,.38-.07,1.09-.27,1.35,0-.25,0-.51,0-.76,0-.52,0-1.05,0-1.57.22-.2.29.5.28.98h0Z"
              />
              <path
                className="cls-107"
                d="M277.11,152.53c.02.85-.16,1.56-.33,1.35-.05-.06-.14-.25-.18-.87.18-.2.34-.4.51-.61,0,.04,0,.08,0,.12h0Z"
              />
            </g>
            <g className="cls-46">
              <path
                className="cls-107"
                d="M224.41,62.69c-.52-.4-.8-.72-.72-.83.13-.08.56.12,1.09.5-.12.11-.24.22-.37.33h0Z"
              />
            </g>
            <g className="cls-44">
              <path
                className="cls-107"
                d="M231.52,66.71c-.08.13.18.47.68.91.12-.12.24-.24.36-.37-.64-.52-.97-.61-1.04-.54h0Z"
              />
              <path
                className="cls-107"
                d="M230.76,67.43c-.09.13.15.47.65.91.14-.12.28-.24.41-.36-.63-.53-.98-.62-1.06-.55h0Z"
              />
              <path
                className="cls-107"
                d="M228.32,63.55c-.08.15.35.55.73.86.39.31.89.6,1.03.53,0,0,.01-.01.02-.01-.59-.47-1.18-.93-1.78-1.38h0Z"
              />
              <path
                className="cls-107"
                d="M227.64,64.24c-.19.29,1.4,1.45,1.71,1.42.21-.02-.05-.41-.55-.83-.5-.41-1.05-.7-1.15-.6h0Z"
              />
              <path
                className="cls-107"
                d="M226.87,64.92c.58.47,1.17.94,1.74,1.42.24-.3-1.34-1.47-1.68-1.44-.02,0-.04.01-.06.02h0Z"
              />
              <path
                className="cls-107"
                d="M224.78,62.36c-.12.11-.24.22-.37.33.71.52,1.15.65,1.1.43,0-.04-.09-.28-.73-.76h0Z"
              />
            </g>
            <g className="cls-41">
              <path
                className="cls-107"
                d="M238.24,72.7c-.09.14.15.52.62.99.14-.13.27-.27.4-.4-.6-.57-.93-.66-1.01-.59h0Z"
              />
              <path
                className="cls-107"
                d="M237.4,73.5c-.11.14.12.52.58,1,.16-.13.31-.27.45-.4-.6-.58-.94-.67-1.03-.6h0Z"
              />
              <path
                className="cls-107"
                d="M235.29,69.27c-.08.13.18.5.66.94.36.33.85.65.99.58,0,0,.02-.01.02-.02-.55-.51-1.11-1.01-1.67-1.5h0Z"
              />
              <path
                className="cls-107"
                d="M234.55,70.03c-.23.34,1.27,1.58,1.6,1.55.26-.03-.13-.63-.74-1.13-.4-.33-.76-.51-.86-.42h0Z"
              />
              <path
                className="cls-107"
                d="M233.69,70.78c.55.51,1.1,1.02,1.64,1.54.27-.33-1.22-1.59-1.57-1.56-.02,0-.05.01-.06.02h0Z"
              />
              <path
                className="cls-107"
                d="M232.56,67.25c-.12.12-.24.24-.36.37.65.54,1.05.68,1.06.49,0-.03-.01-.27-.7-.86h0Z"
              />
              <path
                className="cls-107"
                d="M231.81,67.98c-.13.12-.27.24-.41.36.67.57,1.11.71,1.08.47,0-.05-.06-.3-.67-.83h0Z"
              />
            </g>
            <g className="cls-45">
              <path
                className="cls-107"
                d="M244.51,79.16c-.1.15.11.56.53,1.05.15-.14.29-.29.43-.44-.56-.6-.88-.7-.96-.62h0Z"
              />
              <path
                className="cls-107"
                d="M243.6,80.02c-.12.15.08.56.49,1.06.17-.14.33-.29.49-.43-.55-.61-.89-.71-.98-.63h0Z"
              />
              <path
                className="cls-107"
                d="M241.83,75.46c-.22.37,1.19,1.69,1.51,1.64.02,0,.04-.02.05-.03-.52-.54-1.04-1.08-1.56-1.62h0Z"
              />
              <path
                className="cls-107"
                d="M241.01,76.29c-.26.36,1.14,1.7,1.48,1.66.32-.04-.22-.9-.89-1.42-.29-.23-.52-.32-.6-.24h0Z"
              />
              <path
                className="cls-107"
                d="M240.08,77.12c.51.55,1.02,1.1,1.53,1.65.31-.36-1.1-1.71-1.46-1.68-.02,0-.05.01-.07.02h0Z"
              />
              <path
                className="cls-107"
                d="M239.25,73.29c-.13.13-.26.27-.39.4.61.58,1.01.73,1.03.53,0-.03.01-.29-.63-.93h0Z"
              />
              <path
                className="cls-107"
                d="M238.43,74.09c-.15.13-.3.27-.45.4.63.62,1.06.76,1.05.5,0-.07-.05-.34-.6-.9h0Z"
              />
            </g>
            <g className="cls-43">
              <path
                className="cls-107"
                d="M250.3,86.05c-.11.16.07.6.45,1.12.16-.16.31-.31.46-.47-.51-.64-.83-.74-.91-.65h0Z"
              />
              <path
                className="cls-107"
                d="M249.33,86.97c-.13.16.03.6.41,1.13.18-.15.36-.31.53-.46-.51-.65-.84-.75-.94-.66h0Z"
              />
              <path
                className="cls-107"
                d="M247.9,82.11c-.25.39,1.07,1.8,1.38,1.75.02,0,.04-.02.06-.03-.47-.58-.95-1.15-1.44-1.73h0Z"
              />
              <path
                className="cls-107"
                d="M247.02,83c-.3.39,1.02,1.81,1.36,1.77.35-.05-.27-1.14-.92-1.63-.21-.16-.37-.21-.44-.14h0Z"
              />
              <path
                className="cls-107"
                d="M246.01,83.89c.47.58.94,1.17,1.41,1.76.34-.39-.97-1.83-1.34-1.78-.02,0-.05.02-.07.03h0Z"
              />
              <path
                className="cls-107"
                d="M245.47,79.78c-.14.15-.28.29-.43.44.58.64,1.01.81,1,.53,0-.08-.05-.37-.57-.97h0Z"
              />
              <path
                className="cls-107"
                d="M244.59,80.65c-.16.14-.32.29-.49.43.59.66,1.02.82,1.03.54,0-.08-.03-.37-.54-.97h0Z"
              />
            </g>
            <g className="cls-54">
              <path
                className="cls-107"
                d="M255.58,93.33c-.12.17.03.63.37,1.18.17-.16.33-.33.49-.5-.46-.68-.77-.78-.86-.69h0Z"
              />
              <path
                className="cls-107"
                d="M254.55,94.31c-.14.17,0,.63.33,1.19.19-.16.38-.33.56-.49-.46-.68-.78-.79-.89-.7h0Z"
              />
              <path
                className="cls-107"
                d="M253.47,89.17c-.27.42.94,1.91,1.25,1.85.02,0,.04-.02.06-.03-.43-.61-.87-1.22-1.31-1.82h0Z"
              />
              <path
                className="cls-107"
                d="M252.53,90.12c-.32.42.88,1.92,1.23,1.87.38-.05-.23-1.3-.86-1.77-.23-.17-.33-.13-.37-.1h0Z"
              />
              <path
                className="cls-107"
                d="M251.46,91.07c.43.61.86,1.23,1.28,1.85.37-.42-.83-1.93-1.21-1.88-.02,0-.05.02-.07.03h0Z"
              />
              <path
                className="cls-107"
                d="M251.22,86.7c-.15.16-.3.31-.46.47.54.69.94.85.95.55,0-.08-.02-.39-.49-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M250.27,87.63c-.17.15-.34.31-.53.46.54.7.95.85.99.56,0-.08,0-.39-.46-1.02h0Z"
              />
            </g>
            <g className="cls-55">
              <path
                className="cls-107"
                d="M260.32,100.99c-.13.18-.02.66.29,1.24.18-.17.35-.35.51-.52-.41-.71-.71-.82-.8-.72h0Z"
              />
              <path
                className="cls-107"
                d="M259.23,102.02c-.15.18-.05.66.25,1.24.2-.17.4-.34.59-.52-.41-.71-.72-.82-.84-.73h0Z"
              />
              <path
                className="cls-107"
                d="M258.5,96.61c-.29.44.8,2,1.11,1.95.02,0,.04-.02.06-.03-.38-.64-.78-1.28-1.17-1.92h0Z"
              />
              <path
                className="cls-107"
                d="M257.51,97.62c-.35.44.75,2.01,1.09,1.96.39-.06-.21-1.48-.79-1.9-.08-.05-.22-.13-.3-.06h0Z"
              />
              <path
                className="cls-107"
                d="M256.38,98.62c.39.64.77,1.29,1.15,1.94.4-.44-.7-2.02-1.07-1.97-.02,0-.05.02-.07.03h0Z"
              />
              <path
                className="cls-107"
                d="M256.45,94.02c-.16.17-.32.33-.49.5.47.69.83.86.9.63.02-.06.07-.37-.41-1.12h0Z"
              />
              <path
                className="cls-107"
                d="M255.44,95.01c-.18.16-.37.33-.56.49.49.73.89.9.94.59.01-.08.03-.41-.39-1.08h0Z"
              />
            </g>
            <g className="cls-30">
              <path
                className="cls-107"
                d="M264.49,108.97c-.14.19-.06.69.21,1.29.18-.18.36-.36.53-.54-.36-.73-.64-.85-.74-.75h0Z"
              />
              <path
                className="cls-107"
                d="M263.35,110.05c-.16.18-.1.69.16,1.29.21-.18.41-.36.61-.54-.35-.74-.66-.86-.77-.75h0Z"
              />
              <path
                className="cls-107"
                d="M262.98,104.4c-.31.46.66,2.1.97,2.04.02,0,.04-.02.06-.03-.34-.67-.68-1.34-1.03-2.01h0Z"
              />
              <path
                className="cls-107"
                d="M261.94,105.46c-.37.46.61,2.11.95,2.05.41-.06-.15-1.66-.71-2.03-.1-.07-.19-.08-.24-.02h0Z"
              />
              <path
                className="cls-107"
                d="M260.75,106.51c.34.67.68,1.35,1.01,2.03.42-.45-.56-2.11-.93-2.06-.02,0-.05.02-.07.03h0Z"
              />
              <path
                className="cls-107"
                d="M261.13,101.7c-.16.17-.33.35-.51.52.41.7.76.9.84.65.01-.04.1-.37-.33-1.17h0Z"
              />
              <path
                className="cls-107"
                d="M260.07,102.74c-.19.17-.38.34-.59.52.42.75.82.94.9.61.02-.09.06-.43-.31-1.13h0Z"
              />
            </g>
            <g className="cls-27">
              <path
                className="cls-107"
                d="M268.06,117.26c-.15.19-.1.71.12,1.33.19-.19.37-.37.55-.56-.32-.82-.58-.86-.67-.77h0Z"
              />
              <path
                className="cls-107"
                d="M266.88,118.37c-.17.19-.14.7.08,1.34.22-.19.43-.37.63-.56-.32-.82-.6-.87-.71-.78h0Z"
              />
              <path
                className="cls-107"
                d="M266.87,112.52c-.33.47.52,2.18.82,2.12.02,0,.04-.02.06-.03-.29-.7-.58-1.39-.88-2.08h0Z"
              />
              <path
                className="cls-107"
                d="M265.79,113.62c-.39.47.46,2.18.8,2.13.41-.07-.04-1.72-.57-2.1-.1-.07-.18-.08-.24-.03h0Z"
              />
              <path
                className="cls-107"
                d="M264.56,114.71c.29.7.58,1.4.86,2.1.22-.23.07-.88-.06-1.22-.2-.54-.52-.94-.72-.91-.02,0-.05.02-.08.03h0Z"
              />
              <path
                className="cls-107"
                d="M265.23,109.72c-.17.18-.35.36-.53.54.35.73.69.94.78.68.01-.04.12-.39-.25-1.22h0Z"
              />
              <path
                className="cls-107"
                d="M264.13,110.8c-.2.18-.4.36-.61.54.35.73.71.95.82.68.02-.04.15-.39-.21-1.22h0Z"
              />
            </g>
            <g className="cls-32">
              <path
                className="cls-107"
                d="M270.99,125.81c-.16.2-.14.73.03,1.37.2-.19.38-.38.57-.58-.26-.84-.51-.89-.6-.8h0Z"
              />
              <path
                className="cls-107"
                d="M269.78,126.96c-.18.2-.18.72-.01,1.37.22-.19.44-.38.65-.57-.26-.85-.53-.89-.64-.8h0Z"
              />
              <path
                className="cls-107"
                d="M270.14,120.93c-.35.49.36,2.24.66,2.18.02,0,.04-.02.06-.04-.23-.72-.47-1.43-.72-2.14h0Z"
              />
              <path
                className="cls-107"
                d="M269.03,122.06c-.41.49.31,2.25.64,2.18.41-.08.03-1.9-.46-2.19-.09-.06-.16-.02-.18,0h0Z"
              />
              <path
                className="cls-107"
                d="M267.75,123.19c.24.72.47,1.43.7,2.16.28-.29.05-1.15.02-1.25-.16-.56-.44-.97-.65-.94-.02,0-.05.02-.08.03h0Z"
              />
              <path
                className="cls-107"
                d="M268.73,118.03c-.18.19-.36.38-.55.56.3.76.61.97.72.7.02-.04.14-.4-.17-1.26h0Z"
              />
              <path
                className="cls-107"
                d="M267.59,119.15c-.2.19-.41.37-.63.56.29.76.63.98.76.71.02-.04.17-.4-.13-1.26h0Z"
              />
            </g>
            <g className="cls-35">
              <path
                className="cls-107"
                d="M272.03,135.78c-.19.2-.23.74-.1,1.41.23-.19.45-.39.66-.58-.19-.87-.45-.92-.56-.82h0Z"
              />
              <path
                className="cls-107"
                d="M272.76,129.59c-.36.5.2,2.3.49,2.24.02,0,.04-.02.06-.04-.18-.74-.36-1.47-.55-2.2h0Z"
              />
              <path
                className="cls-107"
                d="M271.62,130.76c-.42.5.15,2.3.48,2.24.4-.08.15-1.94-.3-2.25-.09-.06-.15-.02-.18,0h0Z"
              />
              <path
                className="cls-107"
                d="M270.31,131.91c.19.74.37,1.47.54,2.21.29-.3.12-1.18.1-1.28-.12-.57-.37-1-.57-.97-.02,0-.05.02-.08.04h0Z"
              />
              <path
                className="cls-107"
                d="M271.59,126.61c-.18.19-.37.39-.57.58.23.74.5.97.63.77.07-.12.16-.55-.06-1.34h0Z"
              />
              <path
                className="cls-107"
                d="M270.42,127.76c-.21.19-.43.38-.65.57.24.78.55,1.01.69.73.02-.04.19-.41-.05-1.3h0Z"
              />
            </g>
            <g className="cls-33">
              <path
                className="cls-107"
                d="M274.84,143.6c-.16.21-.22.77-.15,1.45.2-.2.4-.4.59-.6-.12-.83-.32-.96-.44-.85h0Z"
              />
              <path
                className="cls-107"
                d="M273.59,144.78c-.19.2-.26.77-.19,1.44.23-.2.45-.39.67-.59-.13-.89-.37-.95-.48-.85h0Z"
              />
              <path
                className="cls-107"
                d="M273.54,139.67c-.43.5,0,2.35.3,2.29.39-.07.28-1.98-.13-2.3-.08-.06-.14-.02-.17,0h0Z"
              />
              <path
                className="cls-107"
                d="M272.21,140.84c.13.75.25,1.5.37,2.26.25-.25.23-.94.19-1.31-.07-.58-.28-1.02-.48-.99-.02,0-.05.02-.08.04h0Z"
              />
              <path
                className="cls-107"
                d="M272.59,136.6c-.21.2-.43.39-.66.58.18.8.46,1.03.62.75.02-.04.21-.42.04-1.33h0Z"
              />
            </g>
            <g className="cls-31">
              <path
                className="cls-107"
                d="M275.71,152.77c-.17.21-.26.78-.24,1.46.2-.2.4-.4.59-.6-.05-.83-.23-.97-.35-.85h0Z"
              />
              <path
                className="cls-107"
                d="M274.44,153.97c-.19.21-.31.78-.29,1.45.23-.2.46-.4.68-.6-.05-.83-.26-.97-.39-.86h0Z"
              />
              <path
                className="cls-107"
                d="M275.93,147.57c-.39.52-.16,2.39.14,2.33.02,0,.04-.02.06-.04-.06-.77-.12-1.53-.19-2.29h0Z"
              />
              <path
                className="cls-107"
                d="M274.76,148.76c-.44.51-.17,2.39.13,2.33.41-.08.41-2.15,0-2.36-.07-.03-.11.01-.13.03h0Z"
              />
              <path
                className="cls-107"
                d="M273.42,149.95c.07.76.13,1.53.19,2.3.25-.25.29-.95.27-1.33-.03-.6-.2-1.04-.38-1.01-.02,0-.05.02-.07.04h0Z"
              />
              <path
                className="cls-107"
                d="M275.28,144.44c-.19.2-.38.4-.59.6.11.77.32,1.02.46.8.08-.12.21-.57.12-1.4h0Z"
              />
              <path
                className="cls-107"
                d="M274.07,145.63c-.22.2-.44.4-.67.59.11.8.35,1.02.51.81.1-.12.25-.57.16-1.4h0Z"
              />
            </g>
            <g className="cls-34">
              <path
                className="cls-107"
                d="M275.82,162.06c-.17.21-.3.78-.34,1.45.2-.2.4-.4.59-.6.02-.83-.14-.97-.25-.85h0Z"
              />
              <path
                className="cls-107"
                d="M274.55,163.26c-.2.21-.35.77-.38,1.45.23-.2.46-.4.68-.6.02-.83-.17-.97-.3-.85h0Z"
              />
              <path
                className="cls-107"
                d="M276.43,156.81c-.39.52-.33,2.43-.05,2.37.02,0,.04-.02.05-.04,0-.25,0-.51,0-.76,0-.52,0-1.05,0-1.57h0Z"
              />
              <path
                className="cls-107"
                d="M275.25,158.01c-.45.51-.34,2.42-.06,2.37.37-.07.53-2.19.18-2.39-.06-.03-.11.01-.12.03h0Z"
              />
              <path
                className="cls-107"
                d="M273.9,159.21c0,.52,0,1.05,0,1.57,0,.25,0,.51,0,.76.46-.45.43-2.31.1-2.37-.04,0-.08.02-.11.04h0Z"
              />
              <path
                className="cls-107"
                d="M276.05,153.62c-.19.2-.39.4-.59.6.04.79.21,1,.34.87.11-.11.27-.6.25-1.47h0Z"
              />
              <path
                className="cls-107"
                d="M274.83,154.82c-.22.2-.44.4-.68.6.05.82.25,1.04.42.84.11-.13.28-.58.26-1.43h0Z"
              />
            </g>
            <g className="cls-28">
              <path
                className="cls-107"
                d="M276.06,163.03c-.05.83-.3,1.53-.47,1.34-.06-.07-.13-.27-.11-.85.2-.2.4-.4.59-.6,0,.04,0,.08,0,.12h0Z"
              />
              <path
                className="cls-107"
                d="M274.84,164.23c-.06.84-.34,1.53-.53,1.33-.07-.07-.15-.28-.14-.86.23-.2.46-.4.68-.6,0,.04,0,.08,0,.12h0Z"
              />
            </g>
            <g className="cls-29">
              <path
                className="cls-107"
                d="M272,182.59c.14-.63.36-1.17.55-1.37.25-.19.17.45.15.58,0,.06-.03.15-.04.21-.21.2-.44.39-.66.59h0Z"
              />
              <path
                className="cls-107"
                d="M272.79,178.35c-.07.36-.25,1.03-.51,1.27.13-.73.25-1.46.36-2.2.28-.19.24.46.15.92h0Z"
              />
            </g>
            <g className="cls-76">
              <path
                className="cls-107"
                d="M272.64,182.12c-.18.79-.53,1.45-.66,1.27-.04-.05-.09-.23.02-.79.23-.19.45-.39.66-.59,0,.03-.02.08-.02.11h0Z"
              />
            </g>
            <g className="cls-47">
              <path
                className="cls-107"
                d="M223.6,63.33c-.51-.41-.78-.73-.68-.84.15-.07.58.13,1.1.52-.13.11-.27.21-.41.32h0Z"
              />
              <path
                className="cls-107"
                d="M222.71,63.96c-.51-.41-.75-.74-.65-.85.16-.07.59.14,1.11.53-.15.11-.3.21-.46.32h0Z"
              />
            </g>
            <g className="cls-50">
              <path
                className="cls-107"
                d="M229.9,68.14c-.11.12.13.48.61.92.16-.12.31-.24.46-.36-.63-.54-.98-.63-1.07-.56h0Z"
              />
              <path
                className="cls-107"
                d="M228.94,68.85c-.12.12.09.48.57.93.17-.12.35-.24.51-.35-.62-.54-.99-.64-1.08-.57h0Z"
              />
              <path
                className="cls-107"
                d="M226.87,64.92c-.24.3,1.34,1.47,1.68,1.44.02,0,.04-.01.06-.02-.58-.48-1.16-.95-1.74-1.42h0Z"
              />
              <path
                className="cls-107"
                d="M226.01,65.59c-.16.18.51.78.54.81.44.38.91.66,1.11.65.24-.02.01-.41-.48-.84-.48-.42-1.04-.72-1.18-.62h0Z"
              />
              <path
                className="cls-107"
                d="M224.02,63.01c-.13.11-.27.21-.41.32.68.52,1.15.66,1.12.45,0-.04-.07-.28-.7-.77h0Z"
              />
              <path
                className="cls-107"
                d="M223.17,63.65c-.15.11-.3.21-.46.32.68.53,1.16.68,1.14.46,0-.04-.06-.28-.68-.78h0Z"
              />
            </g>
            <g className="cls-52">
              <path
                className="cls-107"
                d="M236.45,74.28c-.12.14.08.52.54,1,.17-.13.34-.26.51-.39-.59-.58-.95-.68-1.05-.61h0Z"
              />
              <path
                className="cls-107"
                d="M235.4,75.05c-.14.14.05.52.5,1.01.19-.13.38-.26.56-.39-.58-.59-.96-.69-1.06-.62h0Z"
              />
              <path
                className="cls-107"
                d="M233.69,70.78c-.27.33,1.22,1.59,1.57,1.56.02,0,.05-.01.06-.02-.54-.52-1.09-1.03-1.64-1.54h0Z"
              />
              <path
                className="cls-107"
                d="M232.74,71.52c-.31.33,1.17,1.61,1.55,1.58.3-.02-.05-.63-.65-1.14-.4-.34-.78-.52-.89-.44h0Z"
              />
              <path
                className="cls-107"
                d="M231.68,72.26c.53.52,1.06,1.04,1.59,1.57.32-.3-.97-1.54-1.47-1.59-.06,0-.09,0-.12.02h0Z"
              />
              <path
                className="cls-107"
                d="M230.97,68.71c-.15.12-.3.24-.46.36.65.56,1.12.72,1.1.48,0-.05-.05-.3-.64-.84h0Z"
              />
              <path
                className="cls-107"
                d="M230.02,69.42c-.17.12-.34.24-.51.35.64.57,1.12.73,1.12.49,0-.05-.03-.3-.61-.85h0Z"
              />
            </g>
            <g className="cls-51">
              <path
                className="cls-107"
                d="M242.58,80.87c-.13.15.04.56.45,1.07.19-.14.37-.28.55-.43-.55-.62-.9-.72-1-.64h0Z"
              />
              <path
                className="cls-107"
                d="M241.43,81.71c-.16.15,0,.56.41,1.07.21-.14.41-.28.61-.42-.54-.62-.91-.73-1.02-.65h0Z"
              />
              <path
                className="cls-107"
                d="M240.08,77.12c-.3.36,1.1,1.71,1.46,1.68.02,0,.05-.01.07-.02-.5-.56-1.01-1.11-1.53-1.65h0Z"
              />
              <path
                className="cls-107"
                d="M239.04,77.93c-.21.22.37.92.4.95.37.44.82.76,1.03.75.34-.03-.07-.82-.72-1.37-.32-.28-.6-.4-.72-.32h0Z"
              />
              <path
                className="cls-107"
                d="M237.88,78.73c.5.56.99,1.12,1.48,1.68.36-.32-.85-1.65-1.36-1.71-.06,0-.1,0-.12.02h0Z"
              />
              <path
                className="cls-107"
                d="M237.5,74.89c-.16.13-.33.26-.51.39.61.61,1.07.77,1.08.51,0-.05-.02-.33-.57-.91h0Z"
              />
              <path
                className="cls-107"
                d="M236.46,75.67c-.18.13-.37.26-.56.39.6.62,1.08.79,1.11.52,0-.07-.01-.34-.54-.91h0Z"
              />
            </g>
            <g className="cls-49">
              <path
                className="cls-107"
                d="M248.23,87.88c-.15.16,0,.6.37,1.13.2-.15.4-.3.59-.46-.5-.65-.85-.76-.96-.68h0Z"
              />
              <path
                className="cls-107"
                d="M247,88.78c-.17.16-.04.59.33,1.14.22-.15.44-.3.65-.45-.5-.66-.86-.77-.98-.69h0Z"
              />
              <path
                className="cls-107"
                d="M246.01,83.89c-.34.38.97,1.82,1.34,1.78.02,0,.05-.02.07-.03-.46-.59-.93-1.18-1.41-1.76h0Z"
              />
              <path
                className="cls-107"
                d="M244.89,84.76c-.39.38.92,1.83,1.31,1.8.39-.04-.09-1.05-.76-1.59-.25-.2-.45-.28-.55-.21h0Z"
              />
              <path
                className="cls-107"
                d="M243.64,85.63c.46.59.91,1.19,1.36,1.79.38-.34-.74-1.76-1.24-1.81-.06,0-.1.01-.13.02h0Z"
              />
              <path
                className="cls-107"
                d="M243.58,81.51c-.18.14-.36.28-.55.43.57.65,1.03.83,1.06.55,0-.08,0-.37-.51-.98h0Z"
              />
              <path
                className="cls-107"
                d="M242.45,82.36c-.2.14-.4.28-.61.42.56.66,1.04.84,1.09.56.01-.08.02-.37-.48-.98h0Z"
              />
            </g>
            <g className="cls-38">
              <path
                className="cls-107"
                d="M253.38,95.28c-.16.17-.05.63.29,1.19.21-.16.42-.32.62-.48-.45-.69-.8-.8-.91-.71h0Z"
              />
              <path
                className="cls-107"
                d="M252.08,96.23c-.18.17-.09.63.25,1.2.24-.16.47-.32.69-.48-.45-.69-.81-.81-.94-.72h0Z"
              />
              <path
                className="cls-107"
                d="M251.46,91.07c-.23.25.27,1.03.29,1.06.36.56.74.84.92.82.02,0,.05-.02.07-.03-.42-.62-.85-1.24-1.28-1.85h0Z"
              />
              <path
                className="cls-107"
                d="M250.25,92c-.37.36.67,1.84,1.14,1.89.38.04.2-.72-.32-1.38-.32-.41-.66-.62-.81-.51h0Z"
              />
              <path
                className="cls-107"
                d="M248.92,92.92c.42.62.83,1.25,1.24,1.88.41-.36-.61-1.86-1.11-1.91-.06,0-.1.01-.13.03h0Z"
              />
              <path
                className="cls-107"
                d="M249.19,88.56c-.19.15-.39.3-.59.46.53.7.97.87,1.02.57.01-.08.03-.39-.43-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M247.98,89.46c-.21.15-.43.3-.65.45.55.74,1.03.89,1.06.53.01-.13-.03-.43-.41-.98h0Z"
              />
            </g>
            <g className="cls-36">
              <path
                className="cls-107"
                d="M258,103.03c-.17.17-.09.66.21,1.24.22-.17.44-.34.65-.51-.4-.72-.74-.83-.86-.74h0Z"
              />
              <path
                className="cls-107"
                d="M256.63,104.04c-.19.17-.13.66.16,1.25.25-.17.49-.33.73-.5-.4-.72-.75-.84-.89-.75h0Z"
              />
              <path
                className="cls-107"
                d="M256.38,98.62c-.24.27.19,1.08.21,1.12.32.59.68.88.86.86.02,0,.05-.02.07-.03-.38-.65-.76-1.3-1.15-1.94h0Z"
              />
              <path
                className="cls-107"
                d="M255.11,99.61c-.39.37.54,1.93,1,1.98.42.05.2-.94-.35-1.62-.26-.32-.52-.46-.65-.37h0Z"
              />
              <path
                className="cls-107"
                d="M253.7,100.58c.38.65.75,1.31,1.11,1.97.44-.38-.48-1.94-.98-1.99-.06,0-.1.01-.14.03h0Z"
              />
              <path
                className="cls-107"
                d="M254.29,95.99c-.2.16-.41.32-.62.48.48.74.9.91.98.6.02-.08.05-.41-.36-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M253.02,96.95c-.23.16-.46.32-.69.48.5.78.97.94,1.03.55.02-.14,0-.46-.34-1.03h0Z"
              />
            </g>
            <g className="cls-48">
              <path
                className="cls-107"
                d="M262.07,111.11c-.18.18-.13.69.12,1.29.23-.18.46-.35.68-.53-.35-.74-.67-.86-.8-.76h0Z"
              />
              <path
                className="cls-107"
                d="M260.64,112.15c-.21.18-.18.69.07,1.3.26-.17.51-.35.76-.52-.35-.75-.69-.87-.83-.77h0Z"
              />
              <path
                className="cls-107"
                d="M260.75,106.51c-.21.22,0,.86.14,1.17.28.61.62.91.79.89.02,0,.05-.02.07-.03-.33-.68-.67-1.36-1.01-2.03h0Z"
              />
              <path
                className="cls-107"
                d="M259.42,107.54c-.42.39.41,2.02.87,2.07.44.05.25-1.07-.3-1.76-.22-.28-.44-.4-.57-.31h0Z"
              />
              <path
                className="cls-107"
                d="M257.95,108.56c.33.68.66,1.36.98,2.05.49-.41-.33-2.02-.84-2.08-.06,0-.1.01-.14.03h0Z"
              />
              <path
                className="cls-107"
                d="M258.87,103.77c-.21.17-.43.34-.65.51.42.75.84.95.93.62.03-.09.08-.43-.28-1.13h0Z"
              />
              <path
                className="cls-107"
                d="M257.52,104.78c-.24.17-.48.34-.73.5.42.76.86.96.98.63.03-.09.11-.43-.25-1.13h0Z"
              />
            </g>
            <g className="cls-37">
              <path
                className="cls-107"
                d="M265.55,119.47c-.19.19-.18.7.03,1.34.24-.18.48-.36.71-.55-.32-.83-.62-.88-.74-.79h0Z"
              />
              <path
                className="cls-107"
                d="M264.07,120.55c-.22.19-.22.7-.01,1.34.27-.18.53-.36.78-.54-.32-.83-.64-.88-.77-.8h0Z"
              />
              <path
                className="cls-107"
                d="M264.56,114.71c-.22.23-.06.89.06,1.21.21.56.52.96.73.93.02,0,.05-.02.07-.03-.28-.7-.57-1.4-.86-2.1h0Z"
              />
              <path
                className="cls-107"
                d="M263.17,115.78c-.46.43.25,2.09.72,2.14.45.05.29-1.23-.23-1.9-.19-.24-.37-.33-.49-.24h0Z"
              />
              <path
                className="cls-107"
                d="M261.64,116.84c.28.7.56,1.41.83,2.12.51-.42-.19-2.09-.7-2.15-.06,0-.1.01-.14.03h0Z"
              />
              <path
                className="cls-107"
                d="M262.87,111.87c-.22.18-.45.35-.68.53.37.78.77.98.88.64.03-.09.11-.45-.2-1.17h0Z"
              />
              <path
                className="cls-107"
                d="M261.47,112.93c-.25.18-.5.35-.76.52.36.79.79.99.93.65.04-.09.13-.45-.17-1.18h0Z"
              />
            </g>
            <g className="cls-39">
              <path
                className="cls-107"
                d="M268.41,128.09c-.2.2-.22.72-.05,1.37.25-.19.49-.37.72-.56-.26-.85-.55-.9-.67-.81h0Z"
              />
              <path
                className="cls-107"
                d="M266.89,129.2c-.23.2-.27.72-.1,1.38.28-.18.54-.37.81-.56-.26-.85-.57-.91-.7-.82h0Z"
              />
              <path
                className="cls-107"
                d="M267.75,123.19c-.23.24-.11.92-.02,1.24.16.57.44.98.65.95.02,0,.05-.02.08-.03-.23-.72-.46-1.44-.7-2.16h0Z"
              />
              <path
                className="cls-107"
                d="M266.33,124.3c-.46.42.12,2.15.56,2.2.46.05.36-1.36-.15-2.02-.15-.2-.3-.26-.42-.18h0Z"
              />
              <path
                className="cls-107"
                d="M264.74,125.39c.23.72.46,1.44.68,2.17.53-.43-.04-2.14-.54-2.2-.06,0-.1.01-.14.03h0Z"
              />
              <path
                className="cls-107"
                d="M266.29,120.26c-.23.18-.46.37-.71.55.31.81.69,1.01.83.66.04-.09.14-.46-.12-1.21h0Z"
              />
              <path
                className="cls-107"
                d="M264.84,121.35c-.26.18-.52.36-.78.54.31.81.71,1.02.87.67.04-.09.16-.46-.09-1.21h0Z"
              />
            </g>
            <g className="cls-96">
              <path
                className="cls-107"
                d="M270.63,136.93c-.21.2-.27.74-.14,1.4.25-.19.5-.38.74-.57-.19-.87-.47-.92-.6-.83h0Z"
              />
              <path
                className="cls-107"
                d="M269.07,138.07c-.24.2-.31.74-.19,1.41.28-.19.56-.38.82-.57-.19-.87-.5-.93-.63-.84h0Z"
              />
              <path
                className="cls-107"
                d="M270.31,131.91c-.24.25-.17.94-.1,1.28.12.58.36,1,.57.97.02,0,.05-.02.08-.04-.17-.74-.35-1.48-.54-2.21h0Z"
              />
              <path
                className="cls-107"
                d="M268.85,133.05c-.48.43-.03,2.2.4,2.25.47.06.44-1.51-.05-2.13-.17-.21-.29-.17-.35-.13h0Z"
              />
              <path
                className="cls-107"
                d="M267.23,134.17c.18.74.35,1.48.52,2.22.55-.44.1-2.19-.38-2.26-.06,0-.1.01-.14.03h0Z"
              />
              <path
                className="cls-107"
                d="M269.08,128.9c-.24.19-.48.38-.72.56.24.78.57,1.01.74.74.02-.04.22-.41-.01-1.3h0Z"
              />
              <path
                className="cls-107"
                d="M267.59,130.02c-.26.19-.53.37-.81.56.27.9.65,1.01.81.69.05-.1.19-.47,0-1.24h0Z"
              />
            </g>
            <g className="cls-98">
              <path
                className="cls-107"
                d="M272.17,145.95c-.21.2-.3.77-.23,1.44.26-.19.51-.39.75-.58-.12-.83-.37-.97-.52-.86h0Z"
              />
              <path
                className="cls-107"
                d="M270.59,147.11c-.24.2-.35.76-.28,1.44.28-.19.56-.38.83-.58-.12-.83-.39-.97-.55-.86h0Z"
              />
              <path
                className="cls-107"
                d="M272.21,140.84c-.25.25-.23.96-.19,1.3.08.59.28,1.02.48.99.02,0,.05-.02.07-.04-.11-.76-.24-1.51-.37-2.26h0Z"
              />
              <path
                className="cls-107"
                d="M270.72,142c-.51.46-.19,2.24.24,2.3.44.06.51-1.56.09-2.17-.15-.21-.27-.17-.33-.13h0Z"
              />
              <path
                className="cls-107"
                d="M269.07,143.14c.13.75.24,1.51.36,2.27.56-.45.25-2.24-.22-2.3-.06,0-.1.02-.14.03h0Z"
              />
              <path
                className="cls-107"
                d="M271.23,137.76c-.24.19-.49.38-.74.57.18.8.49,1.04.66.75.03-.04.24-.42.08-1.33h0Z"
              />
              <path
                className="cls-107"
                d="M269.71,138.91c-.27.19-.54.38-.82.57.18.81.51,1.04.71.76.03-.04.27-.41.11-1.33h0Z"
              />
            </g>
            <g className="cls-99">
              <path
                className="cls-107"
                d="M273.01,155.15c-.22.2-.35.77-.33,1.45.26-.19.51-.39.76-.59-.05-.83-.28-.97-.43-.86h0Z"
              />
              <path
                className="cls-107"
                d="M271.42,156.31c-.24.2-.39.77-.37,1.45.29-.19.57-.39.84-.58-.05-.84-.31-.98-.47-.87h0Z"
              />
              <path
                className="cls-107"
                d="M273.42,149.95c-.51.51-.26,2.39.12,2.33.02,0,.05-.02.07-.04-.06-.77-.12-1.53-.19-2.3h0Z"
              />
              <path
                className="cls-107"
                d="M271.91,151.12c-.52.46-.34,2.27.06,2.34.45.07.61-1.7.21-2.26-.05-.07-.15-.17-.27-.08h0Z"
              />
              <path
                className="cls-107"
                d="M270.24,152.27c.07.77.13,1.53.18,2.3.57-.46.39-2.27-.05-2.34-.05,0-.1.02-.14.03h0Z"
              />
              <path
                className="cls-107"
                d="M272.69,146.81c-.24.19-.49.39-.75.58.11.82.39,1.06.59.77.03-.04.26-.42.16-1.35h0Z"
              />
              <path
                className="cls-107"
                d="M271.15,147.97c-.27.19-.55.38-.83.58.11.82.42,1.06.64.77.03-.04.29-.42.2-1.35h0Z"
              />
            </g>
            <g className="cls-100">
              <path
                className="cls-107"
                d="M273.12,164.44c-.22.2-.38.77-.42,1.45.26-.19.51-.39.76-.59.02-.83-.19-.97-.33-.86h0Z"
              />
              <path
                className="cls-107"
                d="M271.53,165.61c-.25.2-.43.77-.47,1.44.29-.19.57-.39.84-.58.02-.83-.22-.97-.38-.86h0Z"
              />
              <path
                className="cls-107"
                d="M273.9,159.21c-.26.25-.34.96-.35,1.34-.02.61.11,1.05.29,1.03.02,0,.05-.02.07-.04,0-.25,0-.51,0-.76,0-.52,0-1.05,0-1.57h0Z"
              />
              <path
                className="cls-107"
                d="M272.38,160.38c-.53.46-.49,2.3-.12,2.36.45.08.73-1.86.34-2.33-.07-.08-.14-.09-.22-.03h0Z"
              />
              <path
                className="cls-107"
                d="M270.71,161.54c0,.52,0,1.05,0,1.57,0,.25,0,.51,0,.76.56-.44.53-2.3.13-2.36-.05,0-.1.02-.13.03h0Z"
              />
              <path
                className="cls-107"
                d="M273.44,156.01c-.24.2-.5.39-.76.59.05.82.28,1.05.46.84.11-.12.31-.57.29-1.43h0Z"
              />
              <path
                className="cls-107"
                d="M271.89,157.18c-.27.19-.55.39-.84.58.05.82.3,1.05.51.84.12-.12.35-.57.33-1.42h0Z"
              />
            </g>
            <g className="cls-101">
              <path
                className="cls-107"
                d="M270.91,174.71c-.25.2-.46.75-.55,1.41.29-.19.56-.38.84-.58.08-.81-.12-.94-.28-.83h0Z"
              />
              <path
                className="cls-107"
                d="M270.45,170.78c-.05.76-.11,1.51-.18,2.26.59-.46.7-2.24.3-2.3-.05,0-.09.02-.13.04h0Z"
              />
              <path
                className="cls-107"
                d="M273.46,165.3c-.24.2-.5.39-.76.59-.02.81.18,1.02.37.82.12-.13.34-.57.38-1.41h0Z"
              />
              <path
                className="cls-107"
                d="M271.9,166.47c-.27.19-.55.39-.84.58-.02.81.2,1.03.42.82.13-.13.37-.56.42-1.4h0Z"
              />
            </g>
            <g className="cls-93">
              <path
                className="cls-107"
                d="M271.15,182.38c-.22.2-.45.73-.59,1.37.25-.19.5-.38.74-.58.15-.78,0-.9-.15-.79h0Z"
              />
              <path
                className="cls-107"
                d="M269.58,183.52c-.25.2-.49.73-.63,1.36.28-.19.56-.38.82-.57.15-.78-.04-.9-.19-.79h0Z"
              />
              <path
                className="cls-107"
                d="M272.63,177.43c-.48.46-.73,2.18-.46,2.23.03,0,.07-.02.1-.04.13-.73.25-1.46.36-2.2h0Z"
              />
              <path
                className="cls-107"
                d="M271.14,178.59c-.53.45-.78,2.18-.46,2.23.38.06.92-1.77.65-2.2-.05-.07-.11-.08-.19-.03h0Z"
              />
              <path
                className="cls-107"
                d="M269.48,179.73c-.11.73-.23,1.46-.35,2.19.59-.45.83-2.17.47-2.22-.04,0-.09.02-.12.04h0Z"
              />
              <path
                className="cls-107"
                d="M271.19,175.54c-.27.19-.55.39-.84.58-.08.78.11.99.33.79.14-.13.4-.55.51-1.36h0Z"
              />
            </g>
            <g className="cls-94">
              <path
                className="cls-107"
                d="M269.56,188.13c-.22.81-.66,1.47-.79,1.21-.16-.32.26-1.73.7-2.1.28-.17.22.38.12.78,0,.03-.02.08-.03.11h0Z"
              />
              <path
                className="cls-107"
                d="M271.27,183.28c-.19.82-.6,1.5-.74,1.23-.06-.12-.05-.38.02-.76.25-.19.5-.38.74-.58,0,.03-.02.08-.02.11h0Z"
              />
              <path
                className="cls-107"
                d="M269.75,184.43c-.2.83-.63,1.5-.8,1.22-.07-.12-.07-.38,0-.76.28-.19.56-.38.82-.57,0,.03-.02.08-.02.11h0Z"
              />
            </g>
            <g className="cls-95">
              <path
                className="cls-107"
                d="M228.41,70.47c-.47-.45-.67-.81-.53-.93.19-.08.61.14,1.09.59-.18.12-.37.23-.56.35h0Z"
              />
              <path
                className="cls-107"
                d="M227.22,71.15c-.46-.46-.65-.82-.49-.94.2-.08.63.16,1.1.6-.2.11-.4.23-.61.34h0Z"
              />
            </g>
            <g className="cls-102">
              <path
                className="cls-107"
                d="M234.23,75.81c-.15.13.02.52.46,1.01.21-.13.41-.25.61-.38-.58-.6-.96-.71-1.08-.63h0Z"
              />
              <path
                className="cls-107"
                d="M232.97,76.56c-.17.13,0,.52.42,1.02.23-.12.45-.25.67-.37-.57-.6-.96-.72-1.09-.64h0Z"
              />
              <path
                className="cls-107"
                d="M231.68,72.26c-.35.32,1.12,1.62,1.52,1.6.02,0,.05-.01.07-.02-.53-.53-1.06-1.05-1.59-1.57h0Z"
              />
              <path
                className="cls-107"
                d="M230.52,72.98c-.35.29.92,1.55,1.43,1.61.29.04.23-.3-.13-.75-.43-.54-1.1-.98-1.31-.85h0Z"
              />
              <path
                className="cls-107"
                d="M229.25,73.68c.51.53,1.03,1.07,1.53,1.61.39-.29-.85-1.56-1.4-1.62-.07,0-.1,0-.13.02h0Z"
              />
              <path
                className="cls-107"
                d="M228.97,70.12c-.18.12-.37.23-.56.35.67.62,1.17.76,1.14.46-.01-.09-.09-.34-.58-.81h0Z"
              />
              <path
                className="cls-107"
                d="M227.83,70.81c-.2.11-.4.23-.61.34.66.63,1.18.77,1.16.48,0-.09-.07-.34-.55-.82h0Z"
              />
            </g>
            <g className="cls-97">
              <path
                className="cls-107"
                d="M240.17,82.53c-.17.14-.02.56.37,1.07.23-.14.45-.27.67-.41-.53-.63-.91-.74-1.04-.66h0Z"
              />
              <path
                className="cls-107"
                d="M238.79,83.34c-.19.14-.06.56.33,1.08.25-.13.49-.27.72-.41-.52-.63-.92-.75-1.05-.67h0Z"
              />
              <path
                className="cls-107"
                d="M237.88,78.73c-.35.32.85,1.65,1.36,1.71.06,0,.1,0,.13-.02-.49-.57-.98-1.13-1.48-1.68h0Z"
              />
              <path
                className="cls-107"
                d="M236.61,79.51c-.39.32.79,1.66,1.32,1.72.34.04.25-.44-.19-.98-.41-.51-.94-.85-1.13-.74h0Z"
              />
              <path
                className="cls-107"
                d="M235.23,80.29c.48.57.96,1.14,1.43,1.72.44-.32-.73-1.67-1.29-1.73-.07,0-.11,0-.14.02h0Z"
              />
              <path
                className="cls-107"
                d="M235.31,76.44c-.2.13-.41.25-.61.38.63.66,1.14.81,1.13.49,0-.09-.06-.36-.52-.87h0Z"
              />
              <path
                className="cls-107"
                d="M234.05,77.2c-.22.13-.44.25-.67.37.62.67,1.14.83,1.15.5,0-.09-.04-.37-.49-.88h0Z"
              />
            </g>
            <g className="cls-87">
              <path
                className="cls-107"
                d="M245.65,89.67c-.18.15-.07.6.29,1.14.24-.15.48-.29.71-.44-.49-.66-.87-.78-1-.7h0Z"
              />
              <path
                className="cls-107"
                d="M244.17,90.53c-.21.15-.11.59.25,1.14.26-.14.52-.29.77-.43-.48-.67-.88-.79-1.02-.71h0Z"
              />
              <path
                className="cls-107"
                d="M243.64,85.63c-.39.35.72,1.75,1.24,1.81.06,0,.1,0,.13-.02-.45-.6-.91-1.19-1.36-1.79h0Z"
              />
              <path
                className="cls-107"
                d="M242.27,86.48c-.43.34.67,1.76,1.2,1.82.39.05.26-.61-.24-1.23-.36-.44-.78-.7-.96-.59h0Z"
              />
              <path
                className="cls-107"
                d="M240.78,87.31c.44.6.88,1.21,1.32,1.82.48-.34-.6-1.77-1.17-1.84-.07,0-.11,0-.15.02h0Z"
              />
              <path
                className="cls-107"
                d="M241.21,83.19c-.22.14-.44.28-.67.41.59.71,1.1.87,1.12.53,0-.12-.04-.41-.46-.94h0Z"
              />
              <path
                className="cls-107"
                d="M239.85,84.02c-.24.14-.48.27-.72.41.58.72,1.11.88,1.15.54.02-.12-.02-.41-.42-.94h0Z"
              />
            </g>
            <g className="cls-105">
              <path
                className="cls-107"
                d="M250.64,97.17c-.2.16-.12.63.21,1.2.26-.16.51-.31.76-.47-.44-.7-.82-.82-.96-.73h0Z"
              />
              <path
                className="cls-107"
                d="M249.07,98.1c-.22.16-.16.62.16,1.2.28-.15.55-.31.82-.46-.44-.7-.83-.83-.98-.74h0Z"
              />
              <path
                className="cls-107"
                d="M248.92,92.92c-.42.37.59,1.85,1.11,1.91.06,0,.1-.01.13-.03-.41-.63-.82-1.26-1.24-1.88h0Z"
              />
              <path
                className="cls-107"
                d="M247.46,93.83c-.47.36.54,1.85,1.08,1.92.42.05.3-.72-.22-1.39-.32-.41-.68-.64-.86-.53h0Z"
              />
              <path
                className="cls-107"
                d="M245.87,94.72c.4.63.8,1.27,1.2,1.91.52-.37-.47-1.87-1.05-1.93-.07,0-.11,0-.15.02h0Z"
              />
              <path
                className="cls-107"
                d="M246.65,90.36c-.23.15-.47.3-.71.44.54.74,1.04.9,1.09.54.02-.13,0-.43-.38-.99h0Z"
              />
              <path
                className="cls-107"
                d="M245.19,91.24c-.25.15-.51.29-.77.43.58.81,1.06.87,1.12.56.03-.13.02-.43-.35-.99h0Z"
              />
            </g>
            <g className="cls-103">
              <path
                className="cls-107"
                d="M255.12,105.02c-.21.17-.17.66.12,1.25.27-.16.54-.33.79-.49-.4-.73-.76-.85-.91-.76h0Z"
              />
              <path
                className="cls-107"
                d="M253.47,106c-.24.17-.21.65.08,1.25.29-.16.58-.32.86-.48-.39-.73-.78-.86-.94-.77h0Z"
              />
              <path
                className="cls-107"
                d="M253.7,100.58c-.45.39.46,1.93.98,1.99.06,0,.1-.01.14-.03-.37-.66-.74-1.31-1.11-1.97h0Z"
              />
              <path
                className="cls-107"
                d="M252.16,101.54c-.5.38.4,1.94.95,2,.47.06.32-.93-.24-1.62-.27-.33-.54-.47-.7-.38h0Z"
              />
              <path
                className="cls-107"
                d="M250.48,102.48c.36.66.72,1.32,1.07,1.99.56-.38-.34-1.95-.92-2.01-.07,0-.12.01-.15.03h0Z"
              />
              <path
                className="cls-107"
                d="M251.6,97.9c-.25.16-.5.31-.76.47.49.78.98.95,1.07.57.03-.14.03-.45-.31-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M250.06,98.83c-.27.15-.54.31-.82.46.52.85,1.01.91,1.1.58.04-.14.05-.46-.28-1.04h0Z"
              />
            </g>
            <g className="cls-89">
              <path
                className="cls-107"
                d="M259.06,113.19c-.22.18-.21.69.03,1.3.28-.17.56-.34.83-.51-.34-.75-.7-.88-.86-.78h0Z"
              />
              <path
                className="cls-107"
                d="M257.34,114.2c-.25.18-.25.67,0,1.3.31-.17.61-.34.9-.5-.34-.75-.72-.89-.89-.79h0Z"
              />
              <path
                className="cls-107"
                d="M257.95,108.56c-.48.41.33,2.02.84,2.08.06,0,.1-.01.14-.03-.32-.69-.65-1.37-.98-2.05h0Z"
              />
              <path
                className="cls-107"
                d="M256.33,109.56c-.53.4.27,2.02.82,2.09.49.06.37-1.06-.19-1.77-.23-.29-.47-.41-.62-.32h0Z"
              />
              <path
                className="cls-107"
                d="M254.57,110.55c.32.69.64,1.38.94,2.07.58-.4-.21-2.03-.79-2.1-.07,0-.12.01-.16.03h0Z"
              />
              <path
                className="cls-107"
                d="M256.04,105.78c-.26.16-.52.33-.79.49.44.81.92.99,1.03.59.04-.14.06-.48-.24-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M254.41,106.76c-.28.16-.57.32-.86.48.43.82.94,1,1.07.6.04-.12.09-.46-.21-1.08h0Z"
              />
            </g>
            <g className="cls-91">
              <path
                className="cls-107"
                d="M262.43,121.62c-.24.19-.26.7-.05,1.34.29-.18.58-.35.86-.53-.31-.84-.66-.89-.8-.81h0Z"
              />
              <path
                className="cls-107"
                d="M260.65,122.67c-.26.18-.3.7-.1,1.34.32-.17.63-.35.93-.52-.31-.84-.68-.9-.83-.81h0Z"
              />
              <path
                className="cls-107"
                d="M261.64,116.84c-.5.42.19,2.09.7,2.15.06,0,.1-.01.14-.03-.27-.71-.55-1.42-.83-2.12h0Z"
              />
              <path
                className="cls-107"
                d="M259.96,117.89c-.55.41.13,2.09.67,2.16.51.06.43-1.22-.13-1.91-.2-.24-.4-.34-.54-.25h0Z"
              />
              <path
                className="cls-107"
                d="M258.13,118.91c.27.71.54,1.42.8,2.14.61-.41-.07-2.1-.64-2.17-.07,0-.12.01-.16.03h0Z"
              />
              <path
                className="cls-107"
                d="M259.92,113.97c-.27.17-.55.34-.83.51.38.84.85,1.02.99.6.05-.15.09-.49-.16-1.12h0Z"
              />
              <path
                className="cls-107"
                d="M258.23,114.99c-.29.17-.59.34-.9.5.38.85.87,1.03,1.03.62.05-.12.13-.47-.13-1.12h0Z"
              />
            </g>
            <g className="cls-88">
              <path
                className="cls-107"
                d="M265.21,130.3c-.25.19-.3.72-.14,1.37.3-.18.59-.36.88-.55-.25-.86-.59-.91-.74-.83h0Z"
              />
              <path
                className="cls-107"
                d="M263.38,131.38c-.27.19-.34.71-.19,1.37.33-.18.64-.36.96-.54-.25-.86-.61-.92-.77-.83h0Z"
              />
              <path
                className="cls-107"
                d="M264.74,125.39c-.53.44.04,2.14.54,2.2.06,0,.1-.01.14-.03-.22-.73-.45-1.45-.68-2.17h0Z"
              />
              <path
                className="cls-107"
                d="M263.01,126.46c-.58.43-.01,2.14.52,2.21.53.06.5-1.35-.05-2.02-.16-.2-.34-.27-.47-.19h0Z"
              />
              <path
                className="cls-107"
                d="M261.12,127.52c.22.73.44,1.45.66,2.19.64-.42.07-2.14-.49-2.21-.07,0-.12.01-.16.03h0Z"
              />
              <path
                className="cls-107"
                d="M263.24,122.43c-.28.18-.56.35-.86.53.3.81.73,1.03.92.68.05-.09.19-.46-.06-1.21h0Z"
              />
              <path
                className="cls-107"
                d="M261.49,123.49c-.3.17-.61.35-.93.52.32.87.8,1.06.99.63.05-.12.16-.49-.05-1.15h0Z"
              />
            </g>
            <g className="cls-92">
              <path
                className="cls-107"
                d="M267.36,139.19c-.26.2-.35.73-.23,1.4.31-.18.61-.37.9-.56-.19-.88-.52-.94-.67-.84h0Z"
              />
              <path
                className="cls-107"
                d="M265.49,140.29c-.28.19-.38.73-.27,1.4.33-.18.66-.36.98-.55-.19-.88-.54-.94-.7-.85h0Z"
              />
              <path
                className="cls-107"
                d="M267.23,134.17c-.55.45-.1,2.2.38,2.26.06,0,.1-.01.14-.03-.17-.74-.34-1.48-.52-2.22h0Z"
              />
              <path
                className="cls-107"
                d="M265.45,135.27c-.6.44-.15,2.19.36,2.26.52.07.58-1.38.09-2.07-.15-.2-.31-.28-.45-.2h0Z"
              />
              <path
                className="cls-107"
                d="M263.52,136.35c.17.74.34,1.49.5,2.23.66-.43.22-2.19-.34-2.26-.07,0-.12.01-.16.03h0Z"
              />
              <path
                className="cls-107"
                d="M265.95,131.13c-.29.18-.58.36-.88.55.24.83.65,1.06.86.7.05-.1.22-.47.02-1.24h0Z"
              />
              <path
                className="cls-107"
                d="M264.15,132.22c-.31.18-.63.36-.96.54.24.84.67,1.06.9.71.06-.1.24-.47.06-1.24h0Z"
              />
            </g>
            <g className="cls-104">
              <path
                className="cls-107"
                d="M268.85,148.25c-.26.2-.38.76-.32,1.44.31-.19.61-.38.91-.56-.13-.9-.44-.96-.59-.87h0Z"
              />
              <path
                className="cls-107"
                d="M266.95,149.37c-.29.2-.42.74-.36,1.43.34-.18.67-.37.99-.55-.12-.83-.44-.98-.63-.88h0Z"
              />
              <path
                className="cls-107"
                d="M269.07,143.14c-.56.45-.24,2.23.22,2.3.06,0,.1-.01.14-.03-.11-.76-.23-1.51-.36-2.27h0Z"
              />
              <path
                className="cls-107"
                d="M267.26,144.26c-.61.44-.29,2.23.2,2.3.52.08.66-1.54.18-2.17-.17-.22-.31-.18-.38-.14h0Z"
              />
              <path
                className="cls-107"
                d="M265.3,145.36c.12.76.24,1.52.34,2.27.67-.44.36-2.23-.18-2.31-.07,0-.12.01-.16.03h0Z"
              />
              <path
                className="cls-107"
                d="M268.02,140.04c-.29.19-.59.37-.9.56.18.85.57,1.08.79.71.06-.1.24-.48.11-1.27h0Z"
              />
              <path
                className="cls-107"
                d="M266.19,141.15c-.32.18-.64.37-.98.55.18.85.59,1.09.84.72.07-.1.27-.48.14-1.27h0Z"
              />
            </g>
            <g className="cls-106">
              <path
                className="cls-107"
                d="M269.67,157.46c-.26.2-.42.76-.41,1.44.31-.19.62-.38.92-.57-.06-.9-.36-.97-.51-.87h0Z"
              />
              <path
                className="cls-107"
                d="M267.75,158.58c-.29.2-.46.75-.45,1.44.34-.19.67-.37,1-.56-.05-.84-.35-.98-.54-.88h0Z"
              />
              <path
                className="cls-107"
                d="M270.24,152.27c-.57.45-.39,2.27.05,2.34.05,0,.1-.01.13-.03-.05-.77-.11-1.54-.18-2.3h0Z"
              />
              <path
                className="cls-107"
                d="M268.41,153.41c-.62.45-.44,2.26.03,2.34.5.08.74-1.56.33-2.2-.15-.22-.29-.18-.36-.14h0Z"
              />
              <path
                className="cls-107"
                d="M266.42,154.52c.07.77.12,1.54.18,2.31.68-.45.5-2.26-.02-2.34-.06,0-.12.01-.16.03h0Z"
              />
              <path
                className="cls-107"
                d="M269.44,149.12c-.3.19-.6.38-.91.56.11.82.44,1.07.68.78.03-.04.32-.42.23-1.35h0Z"
              />
              <path
                className="cls-107"
                d="M267.58,150.24c-.32.19-.65.37-.99.55.12.87.5,1.1.77.74.07-.1.3-.48.22-1.29h0Z"
              />
            </g>
            <g className="cls-90">
              <path
                className="cls-107"
                d="M269.77,166.76c-.27.2-.46.76-.5,1.44.31-.19.62-.38.92-.57.01-.78-.21-1-.42-.87h0Z"
              />
              <path
                className="cls-107"
                d="M267.85,167.88c-.29.2-.5.75-.54,1.43.34-.19.67-.37,1-.56.01-.83-.27-.98-.46-.87h0Z"
              />
              <path
                className="cls-107"
                d="M270.71,161.54c-.58.45-.54,2.29-.13,2.36.05,0,.09-.01.13-.03,0-.25,0-.51,0-.76,0-.52,0-1.05,0-1.57h0Z"
              />
              <path
                className="cls-107"
                d="M268.87,162.68c-.63.45-.59,2.28-.14,2.36.51.09.86-1.7.44-2.28-.05-.07-.16-.17-.3-.08h0Z"
              />
              <path
                className="cls-107"
                d="M266.87,163.8c0,.52,0,1.05,0,1.57,0,.25,0,.51,0,.76.7-.45.65-2.29.15-2.36-.06,0-.11.01-.16.03h0Z"
              />
              <path
                className="cls-107"
                d="M270.17,158.33c-.3.19-.6.38-.92.57.05.86.35,1.09.6.81.06-.07.34-.44.32-1.37h0Z"
              />
              <path
                className="cls-107"
                d="M268.3,159.46c-.33.19-.66.37-1,.56.05.87.38,1.1.64.81.04-.04.37-.42.35-1.37h0Z"
              />
            </g>
            <g className="cls-463">
              <path
                className="cls-107"
                d="M269.16,175.86c-.27.2-.5.74-.59,1.4.31-.19.61-.38.91-.57.09-.87-.18-.92-.33-.83h0Z"
              />
              <path
                className="cls-107"
                d="M267.25,176.98c-.29.2-.53.73-.62,1.39.34-.18.67-.37.99-.56.08-.8-.18-.94-.37-.84h0Z"
              />
              <path
                className="cls-107"
                d="M270.45,170.78c-.58.45-.69,2.23-.3,2.3.05,0,.09-.02.13-.03.07-.75.12-1.51.18-2.26h0Z"
              />
              <path
                className="cls-107"
                d="M268.62,171.91c-.63.44-.74,2.23-.31,2.29.48.08.95-1.66.59-2.22-.04-.07-.13-.16-.28-.08h0Z"
              />
              <path
                className="cls-107"
                d="M266.62,173.03c-.05.76-.11,1.51-.17,2.26.7-.45.79-2.23.32-2.29-.06,0-.11.01-.15.03h0Z"
              />
              <path
                className="cls-107"
                d="M270.19,167.62c-.3.19-.6.38-.92.57-.01.81.23,1.03.46.83.15-.12.41-.56.45-1.4h0Z"
              />
              <path
                className="cls-107"
                d="M268.31,168.76c-.33.19-.66.37-1,.56-.01.84.28,1.07.56.79.06-.06.39-.43.44-1.35h0Z"
              />
            </g>
            <g className="cls-457">
              <path
                className="cls-107"
                d="M269.48,179.73c-.58.44-.83,2.17-.47,2.22.04,0,.09-.02.12-.03.12-.73.24-1.46.35-2.19h0Z"
              />
              <path
                className="cls-107"
                d="M267.66,180.86c-.63.44-.87,2.16-.48,2.22.47.07,1.06-1.75.71-2.19-.06-.08-.14-.09-.24-.03h0Z"
              />
              <path
                className="cls-107"
                d="M269.48,176.69c-.3.19-.6.38-.91.57-.08.78.13.99.37.79.15-.12.43-.55.54-1.36h0Z"
              />
              <path
                className="cls-107"
                d="M267.62,177.81c-.32.19-.65.37-.99.56-.07.78.16.99.42.8.16-.12.46-.54.57-1.35h0Z"
              />
            </g>
            <g className="cls-456">
              <path
                className="cls-107"
                d="M225.93,71.83c-.45-.46-.62-.82-.45-.94.21-.08.64.16,1.11.61-.21.11-.43.22-.66.33h0Z"
              />
              <path
                className="cls-107"
                d="M224.55,72.49c-.44-.47-.59-.83-.41-.95.22-.07.66.17,1.12.62-.23.11-.47.22-.7.33h0Z"
              />
              <path
                className="cls-107"
                d="M222.84,68.83c.45.45.6.85.31.85-.53,0-1.81-1.24-1.54-1.51,0,0,.02-.01.03-.02.28-.09.87.34,1.2.67h0Z"
              />
            </g>
            <g className="cls-461">
              <path
                className="cls-107"
                d="M231.59,77.29c-.19.13-.04.52.38,1.02.24-.12.48-.24.72-.37-.56-.61-.96-.73-1.1-.66h0Z"
              />
              <path
                className="cls-107"
                d="M230.11,78.01c-.2.13-.07.52.34,1.03.26-.12.52-.24.77-.36-.55-.62-.96-.74-1.11-.67h0Z"
              />
              <path
                className="cls-107"
                d="M229.25,73.68c-.39.29.86,1.56,1.4,1.62.07,0,.1,0,.13-.02-.51-.54-1.02-1.08-1.53-1.61h0Z"
              />
              <path
                className="cls-107"
                d="M227.89,74.38c-.42.28.8,1.57,1.36,1.64.31.04.29-.3-.05-.76-.4-.55-1.08-1-1.31-.88h0Z"
              />
              <path
                className="cls-107"
                d="M226.43,75.06c.49.54.98,1.09,1.47,1.64.42-.26-.64-1.48-1.26-1.64-.11-.03-.15-.01-.2,0h0Z"
              />
              <path
                className="cls-107"
                d="M226.59,71.49c-.21.11-.43.22-.66.33.65.63,1.18.78,1.18.49,0-.09-.05-.34-.52-.82h0Z"
              />
              <path
                className="cls-107"
                d="M225.25,72.16c-.23.11-.47.22-.7.33.64.64,1.18.8,1.19.5,0-.09-.03-.34-.49-.83h0Z"
              />
            </g>
            <g className="cls-458">
              <path
                className="cls-107"
                d="M237.3,84.14c-.21.14-.1.56.29,1.08.26-.13.52-.26.78-.4-.51-.64-.92-.76-1.07-.68h0Z"
              />
              <path
                className="cls-107"
                d="M235.7,84.92c-.22.14-.13.55.25,1.08.28-.13.56-.26.84-.39-.5-.65-.92-.77-1.08-.7h0Z"
              />
              <path
                className="cls-107"
                d="M235.23,80.29c-.43.31.74,1.67,1.29,1.73.07,0,.11,0,.14-.02-.47-.58-.95-1.15-1.43-1.72h0Z"
              />
              <path
                className="cls-107"
                d="M233.74,81.04c-.43.29.57,1.58,1.19,1.74.35.09.41-.23.14-.71-.35-.61-1.05-1.16-1.33-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M232.15,81.79c.46.58.91,1.16,1.37,1.75.47-.28-.51-1.58-1.15-1.75-.11-.03-.16-.01-.21,0h0Z"
              />
              <path
                className="cls-107"
                d="M232.69,77.95c-.24.12-.48.25-.72.37.61.68,1.14.84,1.18.52.01-.12-.03-.38-.46-.88h0Z"
              />
              <path
                className="cls-107"
                d="M231.22,78.68c-.25.12-.51.24-.77.36.66.76,1.2.83,1.2.48,0-.12-.06-.38-.43-.84h0Z"
              />
            </g>
            <g className="cls-462">
              <path
                className="cls-107"
                d="M242.57,91.39c-.22.15-.15.59.2,1.14.28-.14.56-.28.84-.43-.47-.68-.88-.8-1.04-.72h0Z"
              />
              <path
                className="cls-107"
                d="M240.85,92.22c-.24.15-.18.59.16,1.15.3-.14.6-.28.9-.42-.46-.68-.89-.81-1.06-.73h0Z"
              />
              <path
                className="cls-107"
                d="M240.78,87.31c-.47.34.61,1.77,1.17,1.84.07,0,.11,0,.15-.02-.43-.61-.87-1.21-1.32-1.82h0Z"
              />
              <path
                className="cls-107"
                d="M239.18,88.13c-.47.31.45,1.67,1.07,1.84.4.11.46-.35.11-.94-.35-.59-.92-1.02-1.18-.89h0Z"
              />
              <path
                className="cls-107"
                d="M237.46,88.93c.42.61.84,1.22,1.26,1.84.52-.31-.39-1.68-1.04-1.85-.11-.03-.16-.01-.22,0h0Z"
              />
              <path
                className="cls-107"
                d="M238.37,84.82c-.26.13-.52.27-.78.4.57.73,1.11.89,1.18.55.02-.12,0-.41-.4-.95h0Z"
              />
              <path
                className="cls-107"
                d="M236.78,85.62c-.27.13-.55.26-.84.39.62.81,1.18.89,1.21.51.01-.15-.04-.44-.37-.9h0Z"
              />
            </g>
            <g className="cls-460">
              <path
                className="cls-107"
                d="M247.37,99c-.24.16-.19.63.12,1.2.3-.15.6-.3.89-.45-.43-.71-.84-.83-1-.75h0Z"
              />
              <path
                className="cls-107"
                d="M245.55,99.89c-.26.16-.23.62.07,1.2.32-.15.64-.29.95-.44-.42-.71-.84-.84-1.02-.76h0Z"
              />
              <path
                className="cls-107"
                d="M245.87,94.72c-.51.36.48,1.86,1.05,1.93.07,0,.11,0,.15-.02-.39-.64-.79-1.27-1.2-1.91h0Z"
              />
              <path
                className="cls-107"
                d="M244.16,95.59c-.51.33.32,1.76.95,1.93.43.12.5-.43.14-1.09-.32-.57-.83-.97-1.09-.84h0Z"
              />
              <path
                className="cls-107"
                d="M242.33,96.44c.39.64.77,1.28,1.15,1.93.56-.33-.26-1.77-.92-1.94-.11-.03-.17-.01-.23,0h0Z"
              />
              <path
                className="cls-107"
                d="M243.61,92.11c-.27.14-.55.28-.84.43.58.83,1.12.91,1.17.51.02-.16-.02-.45-.33-.94h0Z"
              />
              <path
                className="cls-107"
                d="M241.91,92.95c-.29.14-.59.28-.9.42.58.87,1.13.92,1.2.52.03-.16,0-.46-.3-.94h0Z"
              />
            </g>
            <g className="cls-465">
              <path
                className="cls-107"
                d="M251.69,106.95c-.25.17-.24.66.03,1.25.32-.16.63-.32.93-.47-.38-.73-.79-.87-.96-.78h0Z"
              />
              <path
                className="cls-107"
                d="M249.77,107.88c-.28.17-.28.64-.01,1.25.34-.15.67-.31,1-.46-.38-.74-.8-.87-.99-.79h0Z"
              />
              <path
                className="cls-107"
                d="M250.48,102.48c-.54.38.34,1.94.92,2.01.07,0,.12,0,.15-.02-.35-.67-.71-1.33-1.07-1.99h0Z"
              />
              <path
                className="cls-107"
                d="M248.67,103.4c-.55.34.2,1.83.82,2.01.49.14.55-.6.11-1.34-.29-.5-.7-.78-.94-.67h0Z"
              />
              <path
                className="cls-107"
                d="M246.74,104.3c.35.67.69,1.34,1.03,2.01.59-.34-.13-1.84-.79-2.02-.11-.03-.17-.01-.23,0h0Z"
              />
              <path
                className="cls-107"
                d="M248.38,99.75c-.29.15-.59.3-.89.45.52.87,1.07.94,1.15.53.03-.17.01-.47-.27-.98h0Z"
              />
              <path
                className="cls-107"
                d="M246.57,100.65c-.31.15-.63.3-.95.44.53.91,1.09.96,1.19.54.04-.17.03-.48-.24-.98h0Z"
              />
            </g>
            <g className="cls-464">
              <path
                className="cls-107"
                d="M255.48,115.19c-.27.17-.29.68-.05,1.3.33-.16.65-.33.97-.49-.34-.76-.73-.9-.92-.8h0Z"
              />
              <path
                className="cls-107"
                d="M253.47,116.17c-.29.17-.33.67-.1,1.29.35-.16.7-.32,1.04-.48-.33-.76-.74-.9-.94-.81h0Z"
              />
              <path
                className="cls-107"
                d="M254.57,110.55c-.58.39.21,2.03.79,2.1.07,0,.12,0,.16-.03-.31-.69-.62-1.38-.94-2.07h0Z"
              />
              <path
                className="cls-107"
                d="M252.68,111.51c-.58.36.07,1.91.7,2.09.51.15.6-.72.16-1.5-.26-.46-.62-.71-.85-.6h0Z"
              />
              <path
                className="cls-107"
                d="M250.65,112.46c.31.69.61,1.39.9,2.09.62-.35-.01-1.91-.66-2.1-.11-.03-.17-.01-.24,0h0Z"
              />
              <path
                className="cls-107"
                d="M252.65,107.73c-.3.16-.62.32-.93.47.43.82.95,1.01,1.11.61.06-.14.11-.47-.18-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M250.75,108.67c-.33.16-.66.31-1,.46.46.92,1.04.99,1.17.56.05-.18.07-.5-.17-1.02h0Z"
              />
            </g>
            <g className="cls-459">
              <path
                className="cls-107"
                d="M258.72,123.7c-.28.18-.34.69-.14,1.33.34-.17.68-.34,1-.51-.31-.84-.7-.91-.86-.82h0Z"
              />
              <path
                className="cls-107"
                d="M256.65,124.71c-.3.18-.38.69-.19,1.33.37-.17.72-.33,1.08-.5-.3-.85-.71-.91-.89-.83h0Z"
              />
              <path
                className="cls-107"
                d="M258.13,118.91c-.6.41.08,2.09.64,2.17.07,0,.12-.01.16-.03-.26-.72-.53-1.43-.8-2.14h0Z"
              />
              <path
                className="cls-107"
                d="M256.16,119.91c-.6.37-.06,1.97.56,2.16.53.16.66-.84.21-1.65-.23-.41-.54-.62-.76-.51h0Z"
              />
              <path
                className="cls-107"
                d="M254.05,120.89c.26.72.52,1.43.77,2.16.65-.37.12-1.98-.53-2.16-.11-.03-.17-.01-.24,0h0Z"
              />
              <path
                className="cls-107"
                d="M256.39,116c-.32.17-.64.33-.97.49.37.85.89,1.04,1.07.63.07-.15.14-.49-.1-1.12h0Z"
              />
              <path
                className="cls-107"
                d="M254.42,116.98c-.34.16-.69.32-1.04.48.4.95.98,1.02,1.14.57.07-.18.1-.52-.1-1.06h0Z"
              />
            </g>
            <g className="cls-470">
              <path
                className="cls-107"
                d="M261.39,132.44c-.29.19-.38.71-.23,1.37.35-.17.69-.35,1.03-.53-.25-.86-.63-.93-.8-.84h0Z"
              />
              <path
                className="cls-107"
                d="M259.26,133.48c-.32.18-.42.71-.27,1.37.38-.17.74-.34,1.11-.51-.24-.86-.65-.93-.83-.85h0Z"
              />
              <path
                className="cls-107"
                d="M261.12,127.52c-.63.42-.07,2.14.49,2.21.07,0,.12-.01.16-.03-.21-.73-.43-1.46-.66-2.19h0Z"
              />
              <path
                className="cls-107"
                d="M259.09,128.56c-.61.37-.17,2.03.41,2.21.55.17.72-.96.27-1.77-.2-.37-.47-.53-.68-.43h0Z"
              />
              <path
                className="cls-107"
                d="M256.91,129.57c.21.73.42,1.46.63,2.2.67-.38.25-2.02-.38-2.21-.11-.03-.18-.01-.24.01h0Z"
              />
              <path
                className="cls-107"
                d="M259.58,124.53c-.33.17-.66.34-1,.51.32.88.82,1.07,1.03.64.08-.15.17-.51-.03-1.15h0Z"
              />
              <path
                className="cls-107"
                d="M257.54,125.54c-.35.17-.71.33-1.08.5.31.88.84,1.08,1.07.65.07-.12.2-.48,0-1.15h0Z"
              />
            </g>
            <g className="cls-469">
              <path
                className="cls-107"
                d="M263.46,141.38c-.3.19-.42.72-.32,1.4.36-.18.71-.36,1.05-.54-.19-.88-.56-.95-.74-.86h0Z"
              />
              <path
                className="cls-107"
                d="M261.28,142.44c-.33.19-.46.72-.36,1.39.38-.17.76-.35,1.13-.53-.19-.88-.58-.95-.77-.87h0Z"
              />
              <path
                className="cls-107"
                d="M263.52,136.35c-.65.43-.21,2.19.34,2.26.07,0,.12-.01.16-.03-.16-.75-.33-1.49-.5-2.23h0Z"
              />
              <path
                className="cls-107"
                d="M261.44,137.41c-.65.4-.32,2.07.26,2.26.56.18.79-1.1.34-1.9-.18-.31-.41-.45-.6-.35h0Z"
              />
              <path
                className="cls-107"
                d="M259.21,138.45c.17.75.33,1.5.48,2.25.7-.39.38-2.06-.24-2.26-.11-.03-.17-.01-.24.01h0Z"
              />
              <path
                className="cls-107"
                d="M262.19,133.28c-.34.18-.68.35-1.03.53.26.9.75,1.09.98.66.08-.16.2-.52.05-1.18h0Z"
              />
              <path
                className="cls-107"
                d="M260.09,134.33c-.36.17-.73.34-1.11.51.25.9.77,1.1,1.03.67.08-.13.23-.49.08-1.18h0Z"
              />
            </g>
            <g className="cls-472">
              <path
                className="cls-107"
                d="M264.89,150.47c-.3.19-.46.75-.4,1.43.36-.18.72-.36,1.07-.54-.12-.9-.49-.97-.66-.88h0Z"
              />
              <path
                className="cls-107"
                d="M262.68,151.54c-.33.19-.5.74-.45,1.42.39-.18.77-.35,1.15-.53-.11-.84-.48-.99-.7-.89h0Z"
              />
              <path
                className="cls-107"
                d="M265.3,145.36c-.66.43-.35,2.23.18,2.3.07,0,.12-.01.16-.03-.11-.76-.22-1.52-.34-2.27h0Z"
              />
              <path
                className="cls-107"
                d="M263.18,146.44c-.71.43-.4,2.22.16,2.31.56.08.79-1.41.32-2.1-.14-.21-.32-.29-.49-.21h0Z"
              />
              <path
                className="cls-107"
                d="M260.9,147.5c.12.76.23,1.52.33,2.28.71-.39.51-2.1-.09-2.29-.1-.03-.17-.01-.24.01h0Z"
              />
              <path
                className="cls-107"
                d="M264.19,142.24c-.34.18-.7.36-1.05.54.19.91.66,1.11.93.67.09-.16.24-.53.13-1.2h0Z"
              />
              <path
                className="cls-107"
                d="M262.05,143.31c-.37.18-.75.35-1.13.53.19.92.69,1.12.97.68.08-.13.26-.5.16-1.2h0Z"
              />
            </g>
            <g className="cls-471">
              <path
                className="cls-107"
                d="M265.68,159.69c-.31.19-.5.75-.49,1.43.37-.18.72-.36,1.08-.55-.06-.9-.41-.97-.58-.88h0Z"
              />
              <path
                className="cls-107"
                d="M263.45,160.78c-.34.19-.54.74-.53,1.43.39-.18.78-.36,1.15-.54-.05-.84-.4-.99-.62-.89h0Z"
              />
              <path
                className="cls-107"
                d="M266.42,154.52c-.67.44-.49,2.26.02,2.34.06,0,.12-.01.16-.03-.05-.77-.11-1.54-.18-2.31h0Z"
              />
              <path
                className="cls-107"
                d="M264.28,155.61c-.72.43-.54,2.25,0,2.34.57.09.88-1.55.41-2.19-.16-.22-.33-.19-.42-.15h0Z"
              />
              <path
                className="cls-107"
                d="M261.98,156.68c.06.77.12,1.54.17,2.31.72-.4.64-2.12.07-2.32-.1-.04-.17-.01-.24.01h0Z"
              />
              <path
                className="cls-107"
                d="M265.56,151.35c-.35.18-.71.36-1.07.54.12.87.53,1.11.82.74.08-.1.32-.48.25-1.29h0Z"
              />
              <path
                className="cls-107"
                d="M263.38,152.43c-.38.18-.76.36-1.15.53.13.93.6,1.14.91.69.09-.13.29-.51.23-1.22h0Z"
              />
            </g>
            <g className="cls-467">
              <path
                className="cls-107"
                d="M265.78,168.99c-.31.19-.54.75-.58,1.42.37-.18.72-.36,1.08-.55.01-.78-.25-1-.5-.88h0Z"
              />
              <path
                className="cls-107"
                d="M263.55,170.08c-.34.19-.58.74-.62,1.42.39-.18.78-.36,1.15-.54,0-.83-.32-.98-.54-.88h0Z"
              />
              <path
                className="cls-107"
                d="M266.87,163.8c-.68.44-.64,2.28-.15,2.36.06,0,.11-.01.15-.03,0-.25,0-.51,0-.76,0-.52,0-1.05,0-1.57h0Z"
              />
              <path
                className="cls-107"
                d="M264.72,164.89c-.73.43-.69,2.27-.16,2.36.55.09.97-1.56.56-2.21-.14-.22-.31-.19-.39-.15h0Z"
              />
              <path
                className="cls-107"
                d="M262.41,165.97c0,.52,0,1.05,0,1.57,0,.25,0,.51,0,.76.74-.4.77-2.14.23-2.34-.09-.03-.16-.01-.23.01h0Z"
              />
              <path
                className="cls-107"
                d="M266.26,160.58c-.35.18-.71.37-1.08.55.06.88.44,1.13.74.76.08-.1.35-.48.33-1.31h0Z"
              />
              <path
                className="cls-107"
                d="M264.07,161.67c-.38.18-.76.36-1.15.54.06.96.5,1.1.79.77.09-.1.37-.48.36-1.31h0Z"
              />
            </g>
            <g className="cls-474">
              <path
                className="cls-107"
                d="M265.19,178.08c-.31.19-.57.73-.66,1.38.36-.18.72-.36,1.07-.54.07-.75-.16-.96-.41-.84h0Z"
              />
              <path
                className="cls-107"
                d="M266.62,173.03c-.69.44-.78,2.22-.32,2.29.06,0,.11-.01.15-.03.06-.75.12-1.5.17-2.26h0Z"
              />
              <path
                className="cls-107"
                d="M264.47,174.13c-.74.43-.83,2.21-.33,2.29.56.09,1.08-1.64.66-2.2-.05-.07-.16-.17-.33-.08h0Z"
              />
              <path
                className="cls-107"
                d="M266.27,169.87c-.35.18-.71.37-1.08.55-.01.84.31,1.07.61.79.07-.06.42-.43.47-1.34h0Z"
              />
              <path
                className="cls-107"
                d="M264.08,170.96c-.38.18-.76.36-1.15.54-.01.97.41,1.06.71.75.09-.1.4-.47.45-1.28h0Z"
              />
            </g>
            <g className="cls-475">
              <path
                className="cls-107"
                d="M265.58,179.04c-.14.9-.69,1.58-.96,1.19-.15-.21-.11-.62-.1-.76.36-.18.72-.36,1.07-.54,0,.03-.01.08-.02.12h0Z"
              />
            </g>
            <g className="cls-473">
              <path
                className="cls-107"
                d="M223.07,73.13c-.42-.47-.57-.84-.37-.95.24-.07.67.17,1.12.63-.25.11-.5.21-.75.32h0Z"
              />
              <path
                className="cls-107"
                d="M221.5,73.76c-.41-.48-.54-.84-.33-.96.25-.07.69.19,1.13.64-.26.1-.53.21-.8.31h0Z"
              />
            </g>
            <g className="cls-466">
              <path
                className="cls-107"
                d="M228.53,78.71c-.22.13-.1.52.29,1.03.28-.12.55-.23.82-.35-.54-.62-.96-.75-1.12-.68h0Z"
              />
              <path
                className="cls-107"
                d="M226.85,79.4c-.23.12-.14.52.25,1.03.3-.11.59-.23.88-.34-.52-.63-.96-.76-1.12-.69h0Z"
              />
              <path
                className="cls-107"
                d="M226.43,75.06c-.41.25.65,1.49,1.26,1.64.11.03.16.01.21,0-.48-.55-.97-1.1-1.47-1.64h0Z"
              />
              <path
                className="cls-107"
                d="M224.87,75.72c-.45.26.57,1.49,1.21,1.66.37.1.44-.2.15-.66-.35-.58-1.08-1.11-1.37-.99h0Z"
              />
              <path
                className="cls-107"
                d="M223.22,76.37c.47.55.93,1.11,1.39,1.67.45-.23-.44-1.41-1.1-1.65-.16-.06-.24-.04-.29-.02h0Z"
              />
              <path
                className="cls-107"
                d="M223.82,72.81c-.25.11-.5.21-.75.32.64.67,1.23.83,1.21.47,0-.13-.09-.38-.46-.79h0Z"
              />
              <path
                className="cls-107"
                d="M222.29,73.45c-.26.1-.53.21-.8.31.63.68,1.22.84,1.23.48,0-.11-.05-.36-.43-.79h0Z"
              />
            </g>
            <g className="cls-468">
              <path
                className="cls-107"
                d="M233.98,85.68c-.24.14-.16.55.2,1.09.3-.13.6-.25.89-.38-.49-.65-.93-.78-1.09-.71h0Z"
              />
              <path
                className="cls-107"
                d="M232.16,86.43c-.26.13-.2.55.16,1.09.32-.12.64-.25.95-.37-.48-.66-.93-.79-1.1-.72h0Z"
              />
              <path
                className="cls-107"
                d="M232.15,81.79c-.47.28.51,1.59,1.15,1.75.11.03.16.01.22,0-.45-.59-.91-1.17-1.37-1.75h0Z"
              />
              <path
                className="cls-107"
                d="M230.44,82.51c-.5.28.45,1.59,1.1,1.76.4.11.48-.27.18-.8-.34-.6-.99-1.09-1.29-.96h0Z"
              />
              <path
                className="cls-107"
                d="M228.64,83.22c.44.59.87,1.18,1.29,1.77.5-.25-.32-1.5-.99-1.75-.16-.06-.25-.04-.3-.02h0Z"
              />
              <path
                className="cls-107"
                d="M229.65,79.39c-.27.12-.55.23-.82.35.61.71,1.2.88,1.23.49,0-.14-.06-.41-.4-.84h0Z"
              />
              <path
                className="cls-107"
                d="M227.97,80.09c-.29.11-.58.23-.88.34.59.72,1.2.89,1.25.5.02-.14-.04-.41-.37-.85h0Z"
              />
            </g>
            <g className="cls-498">
              <path
                className="cls-107"
                d="M239.01,93.04c-.26.15-.22.59.12,1.15.32-.14.64-.27.96-.41-.46-.69-.89-.82-1.07-.74h0Z"
              />
              <path
                className="cls-107"
                d="M237.05,93.84c-.28.14-.25.58.07,1.15.34-.13.68-.26,1.02-.4-.45-.69-.89-.83-1.09-.75h0Z"
              />
              <path
                className="cls-107"
                d="M237.46,88.93c-.52.3.38,1.68,1.03,1.85.11.03.17.01.23,0-.41-.62-.83-1.23-1.26-1.84h0Z"
              />
              <path
                className="cls-107"
                d="M235.62,89.71c-.55.3.33,1.68.99,1.86.46.12.54-.4.16-1.03-.34-.56-.87-.94-1.15-.83h0Z"
              />
              <path
                className="cls-107"
                d="M233.67,90.47c.4.62.8,1.24,1.19,1.87.55-.27-.19-1.59-.88-1.85-.16-.06-.25-.04-.31-.02h0Z"
              />
              <path
                className="cls-107"
                d="M235.07,86.39c-.29.13-.59.25-.89.38.57.76,1.18.94,1.24.52.02-.15-.02-.43-.34-.9h0Z"
              />
              <path
                className="cls-107"
                d="M233.26,87.15c-.31.12-.63.25-.95.37.55.77,1.18.95,1.26.53.03-.15,0-.44-.31-.91h0Z"
              />
            </g>
            <g className="cls-501">
              <path
                className="cls-107"
                d="M243.59,100.76c-.28.16-.27.62.03,1.2.34-.14.68-.29,1.01-.43-.41-.72-.85-.85-1.04-.77h0Z"
              />
              <path
                className="cls-107"
                d="M241.52,101.61c-.3.15-.3.61-.02,1.2.36-.14.72-.28,1.08-.42-.41-.72-.86-.86-1.06-.78h0Z"
              />
              <path
                className="cls-107"
                d="M242.33,96.44c-.56.32.26,1.76.91,1.94.12.03.17.01.23,0-.38-.65-.76-1.29-1.15-1.93h0Z"
              />
              <path
                className="cls-107"
                d="M240.37,97.28c-.59.31.2,1.76.87,1.95.5.14.6-.48.19-1.19-.31-.54-.78-.88-1.07-.76h0Z"
              />
              <path
                className="cls-107"
                d="M238.29,98.09c.37.65.73,1.3,1.09,1.96.59-.29-.07-1.67-.77-1.94-.16-.06-.26-.04-.32-.02h0Z"
              />
              <path
                className="cls-107"
                d="M240.08,93.78c-.31.14-.63.27-.96.41.55.85,1.14.93,1.23.53.04-.16.02-.45-.28-.94h0Z"
              />
              <path
                className="cls-107"
                d="M238.14,94.59c-.33.13-.67.27-1.02.4.54.85,1.15.94,1.26.55.04-.16.04-.46-.24-.95h0Z"
              />
            </g>
            <g className="cls-500">
              <path
                className="cls-107"
                d="M247.71,108.8c-.29.16-.31.65-.06,1.25.36-.15.72-.3,1.07-.45-.37-.74-.81-.88-1.01-.8h0Z"
              />
              <path
                className="cls-107"
                d="M245.53,109.69c-.31.16-.35.65-.1,1.25.38-.15.76-.29,1.13-.44-.36-.75-.81-.89-1.03-.81h0Z"
              />
              <path
                className="cls-107"
                d="M246.74,104.3c-.59.34.13,1.84.79,2.02.12.03.17.01.24,0-.34-.67-.68-1.34-1.03-2.01h0Z"
              />
              <path
                className="cls-107"
                d="M244.66,105.18c-.63.33.08,1.84.75,2.03.53.15.65-.59.23-1.34-.28-.5-.71-.8-.98-.69h0Z"
              />
              <path
                className="cls-107"
                d="M242.47,106.04c.33.67.65,1.35.97,2.03.62-.3.05-1.74-.65-2.01-.16-.06-.27-.04-.33-.02h0Z"
              />
              <path
                className="cls-107"
                d="M244.64,101.53c-.33.14-.67.29-1.01.43.5.89,1.1.97,1.22.55.05-.17.05-.47-.21-.99h0Z"
              />
              <path
                className="cls-107"
                d="M242.58,102.39c-.35.14-.71.28-1.08.42.49.89,1.11.98,1.26.57.06-.17.07-.48-.18-.99h0Z"
              />
            </g>
            <g className="cls-502">
              <path
                className="cls-107"
                d="M251.33,117.12c-.31.17-.36.67-.14,1.29.38-.16.75-.31,1.11-.47-.35-.83-.78-.9-.97-.82h0Z"
              />
              <path
                className="cls-107"
                d="M249.05,118.05c-.33.16-.4.67-.19,1.29.4-.15.79-.31,1.18-.46-.32-.77-.77-.92-.99-.83h0Z"
              />
              <path
                className="cls-107"
                d="M250.65,112.46c-.63.36,0,1.92.66,2.1.12.03.17.01.24-.01-.3-.7-.6-1.4-.9-2.09h0Z"
              />
              <path
                className="cls-107"
                d="M248.48,113.38c-.66.35-.05,1.91.63,2.11.55.16.71-.71.28-1.49-.26-.47-.64-.72-.9-.62h0Z"
              />
              <path
                className="cls-107"
                d="M246.18,114.28c.29.7.58,1.41.86,2.11.7-.34.11-1.91-.59-2.12-.12-.04-.19-.02-.26,0h0Z"
              />
              <path
                className="cls-107"
                d="M248.72,109.6c-.35.15-.7.3-1.07.45.42.86,1.04,1.05,1.21.57.06-.18.09-.5-.14-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M246.55,110.5c-.37.15-.75.3-1.13.44.41.86,1.05,1.06,1.24.58.07-.18.11-.5-.11-1.02h0Z"
              />
            </g>
            <g className="cls-503">
              <path
                className="cls-107"
                d="M254.42,125.7c-.33.18-.41.69-.23,1.33.39-.16.77-.33,1.15-.49-.3-.85-.73-.92-.92-.84h0Z"
              />
              <path
                className="cls-107"
                d="M252.06,126.67c-.35.17-.45.68-.28,1.33.41-.16.82-.32,1.22-.48-.29-.85-.75-.93-.95-.85h0Z"
              />
              <path
                className="cls-107"
                d="M254.05,120.89c-.65.37-.12,1.98.52,2.17.11.03.18.01.25-.01-.25-.72-.51-1.44-.77-2.16h0Z"
              />
              <path
                className="cls-107"
                d="M251.8,121.86c-.69.36-.18,1.97.49,2.17.58.17.78-.83.33-1.64-.23-.42-.56-.63-.82-.53h0Z"
              />
              <path
                className="cls-107"
                d="M249.41,122.79c.25.72.49,1.45.73,2.17.74-.35.24-1.97-.46-2.18-.12-.04-.19-.02-.27,0h0Z"
              />
              <path
                className="cls-107"
                d="M252.29,117.94c-.36.16-.73.32-1.11.47.37.89.98,1.08,1.18.58.07-.18.12-.51-.07-1.06h0Z"
              />
              <path
                className="cls-107"
                d="M250.04,118.89c-.39.15-.78.31-1.18.46.36.89,1,1.09,1.22.6.08-.18.14-.51-.04-1.06h0Z"
              />
            </g>
            <g className="cls-499">
              <path
                className="cls-107"
                d="M256.97,134.5c-.34.18-.46.7-.32,1.36.4-.17.79-.33,1.18-.5-.24-.87-.67-.94-.86-.86h0Z"
              />
              <path
                className="cls-107"
                d="M254.54,135.49c-.36.18-.5.7-.36,1.36.42-.16.84-.33,1.25-.49-.24-.87-.69-.95-.89-.87h0Z"
              />
              <path
                className="cls-107"
                d="M256.91,129.57c-.66.37-.24,2.03.38,2.21.11.03.18.01.25-.01-.2-.74-.41-1.47-.63-2.2h0Z"
              />
              <path
                className="cls-107"
                d="M254.58,130.56c-.72.37-.31,2.02.35,2.22.6.18.85-.95.39-1.77-.21-.37-.5-.55-.74-.45h0Z"
              />
              <path
                className="cls-107"
                d="M252.12,131.53c.2.74.4,1.47.59,2.21.76-.36.37-2.01-.32-2.22-.12-.04-.19-.02-.27,0h0Z"
              />
              <path
                className="cls-107"
                d="M255.34,126.54c-.38.16-.76.33-1.15.49.31.91.92,1.11,1.15.6.09-.19.16-.53,0-1.09h0Z"
              />
              <path
                className="cls-107"
                d="M253.01,127.52c-.4.16-.81.32-1.22.48.31.91.93,1.12,1.2.61.1-.19.18-.53.02-1.09h0Z"
              />
            </g>
            <g className="cls-505">
              <path
                className="cls-107"
                d="M258.94,143.48c-.35.18-.5.72-.4,1.39.41-.17.81-.34,1.21-.51-.18-.88-.6-.96-.8-.87h0Z"
              />
              <path
                className="cls-107"
                d="M256.46,144.49c-.37.18-.54.71-.45,1.38.43-.17.86-.33,1.28-.5-.18-.89-.62-.97-.83-.88h0Z"
              />
              <path
                className="cls-107"
                d="M259.21,138.45c-.68.38-.37,2.07.23,2.26.11.03.18.01.25-.01-.15-.75-.31-1.5-.48-2.25h0Z"
              />
              <path
                className="cls-107"
                d="M256.82,139.47c-.75.38-.44,2.06.21,2.26.63.19.93-1.06.45-1.89-.18-.32-.44-.46-.66-.37h0Z"
              />
              <path
                className="cls-107"
                d="M254.29,140.46c.16.75.31,1.5.46,2.26.79-.37.49-2.05-.18-2.26-.12-.04-.19-.02-.27,0h0Z"
              />
              <path
                className="cls-107"
                d="M257.83,135.36c-.39.17-.78.34-1.18.5.26.93.84,1.13,1.11.61.1-.19.19-.54.07-1.11h0Z"
              />
              <path
                className="cls-107"
                d="M255.44,136.36c-.41.16-.83.33-1.25.49.25.93.87,1.14,1.16.62.11-.19.21-.54.09-1.11h0Z"
              />
            </g>
            <g className="cls-507">
              <path
                className="cls-107"
                d="M260.31,152.6c-.35.18-.54.74-.49,1.42.41-.17.82-.35,1.22-.52-.12-.91-.53-.98-.74-.9h0Z"
              />
              <path
                className="cls-107"
                d="M257.8,153.62c-.37.18-.58.74-.53,1.41.44-.17.87-.34,1.3-.51-.11-.84-.52-1-.77-.91h0Z"
              />
              <path
                className="cls-107"
                d="M260.9,147.5c-.72.39-.51,2.1.08,2.3.11.03.17.01.24-.01-.1-.76-.21-1.52-.33-2.28h0Z"
              />
              <path
                className="cls-107"
                d="M258.47,148.53c-.75.38-.56,2.09.06,2.29.6.2.98-1.1.57-1.92-.16-.32-.4-.47-.63-.37h0Z"
              />
              <path
                className="cls-107"
                d="M255.9,149.54c.11.76.21,1.52.31,2.29.8-.38.62-2.08-.04-2.3-.12-.04-.19-.02-.27,0h0Z"
              />
              <path
                className="cls-107"
                d="M259.74,144.35c-.4.17-.8.34-1.21.51.19.92.71,1.13,1.02.69.11-.16.28-.52.18-1.2h0Z"
              />
              <path
                className="cls-107"
                d="M257.3,145.37c-.42.17-.85.34-1.28.5.19.95.79,1.16,1.12.63.12-.2.25-.55.16-1.13h0Z"
              />
            </g>
            <g className="cls-506">
              <path
                className="cls-107"
                d="M261.06,161.84c-.35.19-.58.74-.57,1.42.42-.17.83-.35,1.23-.52-.06-.91-.46-.98-.66-.9h0Z"
              />
              <path
                className="cls-107"
                d="M258.52,162.88c-.38.18-.62.74-.61,1.42.44-.17.88-.34,1.31-.51-.06-.84-.45-1-.7-.9h0Z"
              />
              <path
                className="cls-107"
                d="M261.98,156.68c-.73.4-.64,2.12-.07,2.32.1.04.17.01.24-.01-.05-.77-.11-1.54-.17-2.31h0Z"
              />
              <path
                className="cls-107"
                d="M259.52,157.73c-.77.39-.69,2.11-.09,2.32.6.21,1.06-1.23.65-2.03-.14-.27-.35-.38-.56-.3h0Z"
              />
              <path
                className="cls-107"
                d="M256.92,158.75c.06.77.11,1.54.16,2.31.82-.38.74-2.11.11-2.32-.11-.04-.19-.02-.27,0h0Z"
              />
              <path
                className="cls-107"
                d="M261.05,153.49c-.4.17-.81.35-1.22.52.13.93.63,1.14.96.7.12-.16.31-.53.26-1.22h0Z"
              />
              <path
                className="cls-107"
                d="M258.57,154.53c-.43.17-.86.34-1.3.51.12.91.66,1.15,1.01.71.1-.13.34-.51.29-1.22h0Z"
              />
            </g>
            <g className="cls-504">
              <path
                className="cls-107"
                d="M261.15,171.14c-.36.19-.61.74-.66,1.41.42-.17.83-.35,1.23-.52,0-.9-.37-.97-.58-.89h0Z"
              />
              <path
                className="cls-107"
                d="M258.62,172.18c-.38.18-.65.73-.69,1.41.44-.17.88-.34,1.31-.51,0-.83-.37-.99-.61-.89h0Z"
              />
              <path
                className="cls-107"
                d="M262.41,165.97c-.74.4-.78,2.14-.23,2.34.1.04.16.01.23-.01,0-.25,0-.51,0-.76,0-.52,0-1.05,0-1.57h0Z"
              />
              <path
                className="cls-107"
                d="M259.94,167.02c-.78.39-.82,2.13-.24,2.34.57.21,1.12-1.24.77-2.04-.12-.27-.32-.38-.53-.29h0Z"
              />
              <path
                className="cls-107"
                d="M257.32,168.04c0,.52,0,1.05,0,1.57,0,.25,0,.51,0,.76.83-.39.87-2.12.26-2.34-.11-.04-.18-.02-.26,0h0Z"
              />
              <path
                className="cls-107"
                d="M261.72,162.74c-.4.18-.81.35-1.23.52.06.89.49,1.14.84.78.09-.1.4-.48.39-1.3h0Z"
              />
              <path
                className="cls-107"
                d="M259.22,163.78c-.43.17-.86.34-1.31.51.06.95.57,1.17.95.73.14-.16.37-.54.36-1.24h0Z"
              />
            </g>
            <g className="cls-508">
              <path
                className="cls-107"
                d="M257.68,178.26c-.04.34-.25,1.04-.74,1.26.06-.75.11-1.5.15-2.25.51-.15.65.49.58.99h0Z"
              />
              <path
                className="cls-107"
                d="M261.72,172.15c-.08.93-.67,1.61-1.03,1.2-.2-.23-.19-.65-.19-.79.42-.17.83-.35,1.23-.52,0,.04,0,.08,0,.12h0Z"
              />
              <path
                className="cls-107"
                d="M259.22,173.19c-.08.93-.71,1.61-1.09,1.18-.21-.23-.21-.65-.21-.79.44-.17.88-.34,1.31-.51,0,.04,0,.08,0,.12h0Z"
              />
            </g>
            <g className="cls-510">
              <path
                className="cls-107"
                d="M212.47,68.61c-.41-.45-.54-.79-.33-.89.25-.05.69.19,1.12.63-.26.09-.53.18-.8.26h0Z"
              />
              <path
                className="cls-107"
                d="M209.62,65.69c.22.24.53.67.28.79-.49-.5-.97-.99-1.47-1.47.32-.06.89.36,1.19.69h0Z"
              />
            </g>
            <g className="cls-509">
              <path
                className="cls-107"
                d="M219.54,73.41c-.22.11-.11.48.29.96.29-.1.57-.2.85-.3-.54-.59-.97-.71-1.13-.65h0Z"
              />
              <path
                className="cls-107"
                d="M217.84,74c-.24.11-.14.48.24.96.3-.1.6-.2.89-.3-.52-.59-.96-.72-1.13-.67h0Z"
              />
              <path
                className="cls-107"
                d="M214.19,71.07c.47.53.93,1.06,1.39,1.59.45-.2-.43-1.32-1.1-1.56-.16-.06-.24-.04-.29-.03h0Z"
              />
              <path
                className="cls-107"
                d="M213.27,68.35c-.26.09-.53.18-.8.26.63.64,1.22.81,1.23.48,0-.1-.05-.33-.43-.74h0Z"
              />
            </g>
            <g className="cls-512">
              <path
                className="cls-107"
                d="M225.06,80.07c-.25.12-.17.52.2,1.04.31-.11.62-.22.93-.34-.51-.63-.96-.77-1.13-.7h0Z"
              />
              <path
                className="cls-107"
                d="M223.18,80.72c-.26.12-.2.52.16,1.04.33-.11.65-.22.98-.32-.5-.64-.95-.78-1.13-.72h0Z"
              />
              <path
                className="cls-107"
                d="M223.22,76.37c-.45.23.43,1.41,1.1,1.65.16.06.24.04.29.02-.46-.56-.92-1.12-1.39-1.67h0Z"
              />
              <path
                className="cls-107"
                d="M221.46,77c-.47.23.38,1.41,1.05,1.66.4.15.56-.1.35-.56-.29-.61-1.06-1.22-1.4-1.1h0Z"
              />
              <path
                className="cls-107"
                d="M219.62,77.61c.44.56.87,1.13,1.3,1.7.51-.22-.31-1.42-1-1.67-.16-.06-.25-.04-.3-.03h0Z"
              />
              <path
                className="cls-107"
                d="M220.68,74.07c-.28.1-.56.2-.85.3.61.68,1.22.85,1.25.49.01-.13-.05-.38-.4-.8h0Z"
              />
              <path
                className="cls-107"
                d="M218.96,74.67c-.29.1-.59.2-.89.3.59.69,1.21.87,1.26.5.02-.13-.03-.38-.37-.8h0Z"
              />
            </g>
            <g className="cls-511">
              <path
                className="cls-107"
                d="M230.22,87.16c-.27.13-.23.55.11,1.09.34-.12.68-.24,1.01-.36-.47-.66-.93-.8-1.12-.73h0Z"
              />
              <path
                className="cls-107"
                d="M228.18,87.86c-.29.13-.26.55.07,1.09.36-.12.71-.23,1.06-.35-.46-.67-.92-.81-1.12-.74h0Z"
              />
              <path
                className="cls-107"
                d="M228.64,83.22c-.49.25.31,1.5.99,1.75.16.06.25.04.31.02-.43-.6-.86-1.19-1.29-1.77h0Z"
              />
              <path
                className="cls-107"
                d="M226.72,83.91c-.52.25.26,1.5.94,1.76.44.17.62-.15.39-.68-.28-.64-.98-1.2-1.33-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M224.71,84.58c.41.6.81,1.2,1.22,1.8.56-.24-.19-1.51-.9-1.77-.17-.06-.26-.04-.32-.03h0Z"
              />
              <path
                className="cls-107"
                d="M226.2,80.77c-.31.11-.62.22-.93.34.57.73,1.2.91,1.27.52.02-.14-.01-.41-.34-.85h0Z"
              />
              <path
                className="cls-107"
                d="M224.32,81.44c-.32.11-.65.22-.98.32.58.77,1.26.93,1.29.47.02-.21-.09-.48-.32-.8h0Z"
              />
            </g>
            <g className="cls-517">
              <path
                className="cls-107"
                d="M234.98,94.62c-.3.14-.29.58.02,1.15.36-.13.72-.26,1.08-.39-.43-.69-.9-.84-1.1-.76h0Z"
              />
              <path
                className="cls-107"
                d="M232.79,95.38c-.31.14-.32.58-.02,1.15.38-.12.76-.25,1.13-.38-.42-.7-.9-.85-1.11-.77h0Z"
              />
              <path
                className="cls-107"
                d="M233.67,90.47c-.54.27.19,1.58.88,1.85.16.06.26.04.32.02-.39-.63-.79-1.25-1.19-1.87h0Z"
              />
              <path
                className="cls-107"
                d="M231.61,91.22c-.57.26.13,1.59.83,1.86.47.18.68-.21.43-.82-.27-.64-.9-1.16-1.26-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M229.44,91.94c.38.63.75,1.26,1.12,1.9.61-.26-.07-1.59-.79-1.87-.17-.06-.27-.04-.33-.03h0Z"
              />
              <path
                className="cls-107"
                d="M231.34,87.89c-.33.12-.67.24-1.01.36.54.77,1.18.96,1.29.55.04-.15.02-.44-.28-.91h0Z"
              />
              <path
                className="cls-107"
                d="M229.3,88.6c-.35.12-.7.23-1.06.35.55.81,1.25.99,1.32.5.03-.22-.05-.51-.27-.85h0Z"
              />
            </g>
            <g className="cls-513">
              <path
                className="cls-107"
                d="M239.31,102.44c-.32.15-.34.61-.06,1.2.39-.14.77-.27,1.14-.41-.4-.72-.86-.87-1.08-.79h0Z"
              />
              <path
                className="cls-107"
                d="M236.99,103.24c-.33.14-.37.62-.11,1.2.4-.13.8-.26,1.2-.4-.39-.73-.86-.88-1.09-.8h0Z"
              />
              <path
                className="cls-107"
                d="M238.29,98.09c-.58.28.07,1.66.76,1.93.16.07.27.04.33.02-.36-.66-.72-1.31-1.09-1.96h0Z"
              />
              <path
                className="cls-107"
                d="M236.09,98.89c-.61.28.01,1.66.72,1.94.51.2.75-.28.47-.96-.26-.64-.83-1.11-1.19-.99h0Z"
              />
              <path
                className="cls-107"
                d="M233.77,99.65c.34.66.68,1.32,1.02,1.98.66-.28.05-1.67-.68-1.95-.17-.07-.28-.04-.34-.03h0Z"
              />
              <path
                className="cls-107"
                d="M236.08,95.38c-.35.13-.71.26-1.08.39.57.92,1.22.96,1.31.5.07-.35-.16-.75-.23-.88h0Z"
              />
              <path
                className="cls-107"
                d="M233.9,96.15c-.37.13-.75.25-1.13.38.51.87,1.21,1.03,1.34.51.08-.35-.13-.75-.2-.89h0Z"
              />
            </g>
            <g className="cls-515">
              <path
                className="cls-107"
                d="M243.21,110.56c-.33.15-.39.64-.15,1.25.41-.14.81-.29,1.2-.43-.35-.75-.82-.9-1.05-.82h0Z"
              />
              <path
                className="cls-107"
                d="M240.76,111.41c-.35.15-.43.64-.19,1.25.43-.14.85-.28,1.26-.42-.35-.75-.83-.91-1.07-.83h0Z"
              />
              <path
                className="cls-107"
                d="M242.47,106.04c-.62.3-.05,1.73.64,2.01.16.07.27.04.33.02-.32-.68-.64-1.36-.97-2.03h0Z"
              />
              <path
                className="cls-107"
                d="M240.14,106.88c-.65.29-.1,1.73.6,2.02.54.22.81-.36.52-1.1-.25-.62-.76-1.04-1.12-.92h0Z"
              />
              <path
                className="cls-107"
                d="M237.7,107.69c.31.68.61,1.37.91,2.05.7-.29.17-1.74-.56-2.03-.17-.07-.28-.04-.35-.03h0Z"
              />
              <path
                className="cls-107"
                d="M240.39,103.23c-.38.14-.76.28-1.14.41.52.96,1.18,1,1.31.51.1-.36-.1-.79-.17-.92h0Z"
              />
              <path
                className="cls-107"
                d="M238.08,104.04c-.39.13-.79.27-1.2.4.47.9,1.18,1.07,1.34.53.11-.36-.08-.79-.15-.93h0Z"
              />
            </g>
            <g className="cls-516">
              <path
                className="cls-107"
                d="M246.63,118.96c-.35.16-.44.67-.23,1.29.42-.15.84-.3,1.25-.45-.31-.77-.78-.93-1.02-.84h0Z"
              />
              <path
                className="cls-107"
                d="M244.08,119.85c-.37.16-.48.66-.28,1.29.44-.14.88-.29,1.31-.44-.3-.78-.78-.93-1.03-.85h0Z"
              />
              <path
                className="cls-107"
                d="M246.18,114.28c-.68.33-.09,1.92.59,2.12.12.04.19.02.27,0-.28-.71-.57-1.41-.86-2.11h0Z"
              />
              <path
                className="cls-107"
                d="M243.74,115.16c-.69.31-.22,1.8.48,2.1.57.24.88-.45.56-1.25-.23-.59-.7-.97-1.04-.85h0Z"
              />
              <path
                className="cls-107"
                d="M241.18,116.01c.27.71.54,1.42.8,2.13.73-.3.28-1.8-.44-2.1-.17-.07-.29-.04-.36-.03h0Z"
              />
              <path
                className="cls-107"
                d="M244.26,111.38c-.4.15-.8.29-1.2.43.42.9,1.13,1.08,1.31.52.08-.25.05-.57-.11-.96h0Z"
              />
              <path
                className="cls-107"
                d="M241.83,112.24c-.41.14-.84.28-1.26.42.41.91,1.14,1.1,1.35.54.09-.25.06-.57-.08-.96h0Z"
              />
            </g>
            <g className="cls-514">
              <path
                className="cls-107"
                d="M249.56,127.61c-.37.17-.49.68-.32,1.33.44-.15.87-.31,1.3-.47-.28-.86-.76-.94-.98-.86h0Z"
              />
              <path
                className="cls-107"
                d="M246.91,128.52c-.39.16-.53.67-.36,1.32.46-.15.91-.3,1.36-.45-.28-.86-.77-.95-1-.87h0Z"
              />
              <path
                className="cls-107"
                d="M249.41,122.79c-.74.35-.24,1.97.46,2.18.12.04.2.02.27,0-.24-.73-.48-1.45-.73-2.17h0Z"
              />
              <path
                className="cls-107"
                d="M246.87,123.7c-.72.32-.34,1.85.35,2.15.59.26.95-.56.61-1.41-.21-.54-.63-.86-.96-.75h0Z"
              />
              <path
                className="cls-107"
                d="M244.21,124.59c.23.73.46,1.46.68,2.19.76-.31.4-1.85-.32-2.16-.17-.07-.29-.04-.37-.03h0Z"
              />
              <path
                className="cls-107"
                d="M247.65,119.8c-.41.15-.83.3-1.25.45.37.93,1.08,1.11,1.3.54.1-.26.08-.59-.05-.99h0Z"
              />
              <path
                className="cls-107"
                d="M245.11,120.7c-.43.15-.87.29-1.31.44.36.94,1.09,1.13,1.34.55.11-.26.1-.59-.02-.99h0Z"
              />
            </g>
            <g className="cls-488">
              <path
                className="cls-107"
                d="M251.96,136.46c-.38.17-.54.69-.4,1.36.45-.16.89-.32,1.33-.48-.23-.87-.71-.95-.93-.88h0Z"
              />
              <path
                className="cls-107"
                d="M249.25,137.4c-.4.17-.57.69-.45,1.35.47-.15.94-.31,1.4-.46-.23-.88-.72-.96-.95-.89h0Z"
              />
              <path
                className="cls-107"
                d="M252.12,131.53c-.74.35-.35,2.02.32,2.22.12.04.2.01.27,0-.19-.74-.39-1.48-.59-2.21h0Z"
              />
              <path
                className="cls-107"
                d="M249.5,132.47c-.75.33-.47,1.89.22,2.2.63.28,1.03-.64.67-1.54-.2-.49-.57-.77-.89-.66h0Z"
              />
              <path
                className="cls-107"
                d="M246.75,133.38c.19.74.38,1.48.56,2.23.79-.32.52-1.89-.19-2.2-.17-.07-.29-.04-.37-.03h0Z"
              />
              <path
                className="cls-107"
                d="M250.53,128.47c-.43.16-.86.31-1.3.47.3.92.95,1.13,1.24.62.11-.19.2-.53.05-1.09h0Z"
              />
              <path
                className="cls-107"
                d="M247.91,129.39c-.45.15-.9.3-1.36.45.31.96,1.04,1.15,1.32.56.13-.27.14-.61.04-1.01h0Z"
              />
            </g>
            <g className="cls-484">
              <path
                className="cls-107"
                d="M253.83,145.48c-.39.18-.58.7-.49,1.38.46-.16.91-.33,1.36-.49-.18-.89-.65-.97-.87-.89h0Z"
              />
              <path
                className="cls-107"
                d="M251.06,146.44c-.41.17-.62.7-.53,1.37.48-.16.96-.31,1.43-.47-.17-.89-.66-.98-.9-.9h0Z"
              />
              <path
                className="cls-107"
                d="M254.29,140.46c-.77.36-.48,2.06.18,2.26.12.04.19.01.27,0-.15-.75-.3-1.51-.46-2.26h0Z"
              />
              <path
                className="cls-107"
                d="M251.61,141.42c-.77.34-.58,1.93.09,2.24.61.28,1.07-.66.76-1.57-.17-.5-.53-.78-.85-.67h0Z"
              />
              <path
                className="cls-107"
                d="M248.79,142.36c.15.75.29,1.51.43,2.27.81-.33.64-1.92-.06-2.24-.17-.08-.29-.05-.37-.03h0Z"
              />
              <path
                className="cls-107"
                d="M252.89,137.33c-.44.16-.88.32-1.33.48.25.93.89,1.15,1.21.63.12-.19.24-.54.12-1.11h0Z"
              />
              <path
                className="cls-107"
                d="M250.2,138.28c-.46.16-.93.31-1.4.46.25.98.98,1.17,1.3.57.15-.27.18-.62.1-1.03h0Z"
              />
            </g>
            <g className="cls-486">
              <path
                className="cls-107"
                d="M255.13,154.63c-.39.18-.62.73-.57,1.41.47-.16.92-.33,1.38-.5-.12-.91-.58-.99-.81-.91h0Z"
              />
              <path
                className="cls-107"
                d="M252.31,155.6c-.41.17-.65.72-.61,1.4.49-.16.97-.32,1.45-.48-.11-.84-.56-1.01-.84-.92h0Z"
              />
              <path
                className="cls-107"
                d="M255.9,149.54c-.8.38-.62,2.08.04,2.3.12.04.19.02.27,0-.1-.76-.2-1.53-.31-2.29h0Z"
              />
              <path
                className="cls-107"
                d="M253.17,150.53c-.85.37-.67,2.08.02,2.3.66.21,1.11-1.07.68-1.91-.17-.33-.44-.48-.7-.39h0Z"
              />
              <path
                className="cls-107"
                d="M250.3,151.48c.1.76.2,1.53.29,2.3.83-.33.75-1.95.08-2.27-.16-.08-.29-.05-.37-.03h0Z"
              />
              <path
                className="cls-107"
                d="M254.7,146.37c-.45.16-.9.33-1.36.49.19.95.82,1.16,1.17.64.13-.19.27-.55.19-1.13h0Z"
              />
              <path
                className="cls-107"
                d="M251.95,147.34c-.47.16-.94.32-1.43.47.18.95.84,1.18,1.21.65.14-.19.29-.55.21-1.13h0Z"
              />
            </g>
            <g className="cls-482">
              <path
                className="cls-107"
                d="M255.83,163.89c-.4.18-.65.73-.65,1.41.47-.17.93-.33,1.39-.5-.06-.84-.47-1-.74-.91h0Z"
              />
              <path
                className="cls-107"
                d="M252.99,164.87c-.42.17-.69.72-.69,1.4.49-.16.98-.32,1.46-.48-.06-.84-.49-1.01-.77-.92h0Z"
              />
              <path
                className="cls-107"
                d="M256.92,158.75c-.82.38-.74,2.11-.11,2.32.11.04.19.02.27,0-.05-.77-.1-1.54-.16-2.31h0Z"
              />
              <path
                className="cls-107"
                d="M254.16,159.74c-.86.37-.79,2.1-.13,2.32.64.21,1.17-1.08.79-1.93-.15-.33-.4-.48-.66-.39h0Z"
              />
              <path
                className="cls-107"
                d="M251.26,160.71c.06.77.11,1.54.15,2.32.84-.34.86-1.97.21-2.29-.15-.08-.28-.05-.36-.03h0Z"
              />
              <path
                className="cls-107"
                d="M255.93,155.54c-.45.17-.91.33-1.38.5.13.96.74,1.18,1.12.65.14-.2.3-.55.26-1.14h0Z"
              />
              <path
                className="cls-107"
                d="M253.15,156.52c-.48.16-.96.32-1.45.48.13.96.76,1.19,1.17.66.15-.2.32-.55.28-1.14h0Z"
              />
            </g>
            <g className="cls-483">
              <path
                className="cls-107"
                d="M255.92,173.19c-.4.18-.69.73-.73,1.4.47-.17.93-.33,1.39-.5,0-.83-.39-.99-.66-.9h0Z"
              />
              <path
                className="cls-107"
                d="M253.08,174.18c-.42.17-.72.72-.76,1.39.49-.16.98-.32,1.46-.48,0-.83-.41-1-.69-.91h0Z"
              />
              <path
                className="cls-107"
                d="M257.32,168.04c-.83.38-.87,2.12-.26,2.34.11.04.18.02.26,0,0-.25,0-.51,0-.76,0-.52,0-1.05,0-1.57h0Z"
              />
              <path
                className="cls-107"
                d="M254.55,169.04c-.87.37-.91,2.11-.27,2.33.64.22,1.25-1.22.86-2.03-.13-.27-.35-.39-.59-.31h0Z"
              />
              <path
                className="cls-107"
                d="M251.64,170.01c0,.52,0,1.05,0,1.57,0,.25,0,.51,0,.76.85-.34.98-1.98.35-2.3-.15-.08-.28-.04-.36-.03h0Z"
              />
              <path
                className="cls-107"
                d="M256.57,164.8c-.46.17-.92.33-1.39.5.06.95.6,1.18,1,.74.15-.16.39-.53.39-1.24h0Z"
              />
              <path
                className="cls-107"
                d="M253.76,165.79c-.48.16-.96.32-1.46.48.06.98.68,1.21,1.11.68.16-.2.35-.56.35-1.16h0Z"
              />
            </g>
            <g className="cls-489">
              <path
                className="cls-107"
                d="M255.39,182.26c-.4.18-.71.71-.8,1.35.47-.16.93-.33,1.38-.5.06-.8-.31-.95-.58-.86h0Z"
              />
              <path
                className="cls-107"
                d="M252.56,183.23c-.42.17-.75.7-.83,1.35.49-.16.97-.32,1.45-.48.05-.8-.34-.96-.61-.87h0Z"
              />
              <path
                className="cls-107"
                d="M257.1,177.27c-.83.38-.99,2.06-.41,2.26.1.04.18.01.26,0,.06-.75.11-1.5.15-2.25h0Z"
              />
              <path
                className="cls-107"
                d="M254.33,178.27c-.87.37-1.03,2.05-.42,2.26.64.22,1.34-1.31.94-2.04-.12-.21-.31-.29-.52-.22h0Z"
              />
              <path
                className="cls-107"
                d="M251.42,179.23c-.04.75-.09,1.5-.15,2.25.85-.34,1.08-1.92.49-2.23-.14-.07-.27-.04-.35-.02h0Z"
              />
              <path
                className="cls-107"
                d="M256.58,174.09c-.46.17-.92.33-1.39.5,0,.92.51,1.14.93.71.15-.16.42-.52.46-1.21h0Z"
              />
              <path
                className="cls-107"
                d="M253.77,175.08c-.48.16-.96.32-1.46.48,0,.92.53,1.15.98.72.16-.16.44-.52.48-1.2h0Z"
              />
            </g>
            <g className="cls-490">
              <path
                className="cls-107"
                d="M251.46,191.94c-.42.17-.77.68-.9,1.3.48-.16.96-.32,1.43-.47.11-.77-.26-.91-.53-.82h0Z"
              />
              <path
                className="cls-107"
                d="M253.51,187.15c-.87.36-1.13,1.98-.56,2.17.61.21,1.39-1.27,1.05-1.97-.1-.2-.28-.28-.49-.2h0Z"
              />
              <path
                className="cls-107"
                d="M250.62,188.11c-.09.72-.19,1.44-.29,2.16.85-.33,1.17-1.86.62-2.14-.13-.07-.26-.04-.33-.02h0Z"
              />
              <path
                className="cls-107"
                d="M255.96,183.11c-.45.17-.91.33-1.38.5-.06.85.36,1.07.78.73.11-.09.49-.45.6-1.23h0Z"
              />
              <path
                className="cls-107"
                d="M253.17,184.1c-.48.16-.96.32-1.45.48-.06.89.44,1.1.9.68.17-.15.46-.5.54-1.16h0Z"
              />
            </g>
            <g className="cls-491">
              <path
                className="cls-107"
                d="M249.75,197.53c-.08.31-.38.95-.91,1.16.15-.69.29-1.38.43-2.07.54-.14.61.46.49.92h0Z"
              />
              <path
                className="cls-107"
                d="M251.97,192.87c-.21.9-1,1.53-1.32,1.04-.15-.22-.1-.54-.08-.68.48-.16.96-.32,1.43-.47,0,.03-.01.08-.02.11h0Z"
              />
            </g>
            <g className="cls-485">
              <path
                className="cls-107"
                d="M210.54,68.24c-.22.1-.11.44.28.89.28-.08.56-.17.84-.26-.53-.56-.96-.69-1.12-.64h0Z"
              />
              <path
                className="cls-107"
                d="M208.85,68.73c-.23.09-.14.44.24.9.3-.08.59-.16.88-.25-.56-.61-.97-.69-1.11-.65h0Z"
              />
              <path
                className="cls-107"
                d="M208.43,65c-.38.18.57,1.22,1.19,1.44.15.05.23.04.27.03-.49-.5-.97-.99-1.47-1.47h0Z"
              />
              <path
                className="cls-107"
                d="M205.27,65.93c.46.5.91,1,1.36,1.5.43-.17-.33-1.14-1.01-1.44-.2-.09-.29-.07-.35-.06h0Z"
              />
            </g>
            <g className="cls-487">
              <path
                className="cls-107"
                d="M216.04,74.58c-.25.11-.18.48.19.97.32-.09.63-.19.94-.29-.51-.6-.95-.73-1.13-.68h0Z"
              />
              <path
                className="cls-107"
                d="M214.15,75.13c-.26.1-.21.47.15.97.33-.09.66-.18.98-.28-.53-.65-.97-.74-1.13-.69h0Z"
              />
              <path
                className="cls-107"
                d="M214.19,71.07c-.44.2.45,1.33,1.1,1.56.16.06.24.04.29.03-.46-.53-.92-1.07-1.39-1.59h0Z"
              />
              <path
                className="cls-107"
                d="M212.44,71.61c-.45.19.3,1.24.97,1.54.41.19.62,0,.45-.4-.24-.59-1.07-1.25-1.42-1.14h0Z"
              />
              <path
                className="cls-107"
                d="M210.61,72.13c.43.54.86,1.08,1.29,1.62.49-.19-.21-1.23-.92-1.55-.21-.09-.31-.08-.37-.07h0Z"
              />
              <path
                className="cls-107"
                d="M211.66,68.87c-.28.09-.56.17-.84.26.65.7,1.22.79,1.24.49,0-.12-.05-.35-.4-.75h0Z"
              />
              <path
                className="cls-107"
                d="M209.96,69.38c-.29.08-.58.17-.88.25.59.66,1.2.84,1.24.5.02-.12-.03-.35-.37-.75h0Z"
              />
            </g>
            <g className="cls-481">
              <path
                className="cls-107"
                d="M221.21,81.35c-.28.12-.24.52.11,1.04.35-.1.69-.21,1.03-.32-.48-.64-.94-.79-1.14-.73h0Z"
              />
              <path
                className="cls-107"
                d="M219.13,81.96c-.29.11-.27.51.07,1.04.36-.1.72-.2,1.07-.3-.46-.65-.94-.8-1.14-.74h0Z"
              />
              <path
                className="cls-107"
                d="M219.62,77.61c-.5.22.31,1.42.99,1.67.17.06.26.04.31.03-.43-.57-.87-1.14-1.3-1.7h0Z"
              />
              <path
                className="cls-107"
                d="M217.68,78.21c-.53.22.25,1.42.94,1.68.44.17.63-.13.4-.63-.28-.61-.98-1.16-1.34-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M215.65,78.78c.41.57.81,1.15,1.21,1.73.55-.21-.1-1.32-.82-1.66-.21-.1-.32-.08-.39-.07h0Z"
              />
              <path
                className="cls-107"
                d="M217.17,75.26c-.31.1-.62.19-.94.29.6.73,1.27.9,1.28.46,0-.19-.11-.45-.34-.75h0Z"
              />
              <path
                className="cls-107"
                d="M215.27,75.82c-.32.09-.65.18-.98.28.58.73,1.26.91,1.29.48.02-.19-.09-.45-.32-.75h0Z"
              />
            </g>
            <g className="cls-478">
              <path
                className="cls-107"
                d="M226.03,88.55c-.31.13-.3.55.01,1.1.38-.11.75-.23,1.11-.34-.44-.67-.92-.82-1.13-.75h0Z"
              />
              <path
                className="cls-107"
                d="M223.78,89.21c-.32.12-.33.54-.03,1.09.39-.11.78-.22,1.16-.33-.43-.68-.91-.83-1.13-.77h0Z"
              />
              <path
                className="cls-107"
                d="M224.71,84.58c-.56.24.19,1.51.89,1.77.17.06.27.04.33.03-.4-.6-.81-1.21-1.22-1.8h0Z"
              />
              <path
                className="cls-107"
                d="M222.59,85.23c-.58.23.13,1.51.84,1.78.48.19.7-.18.44-.76-.27-.61-.92-1.13-1.28-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M220.38,85.85c.38.61.76,1.21,1.13,1.83.59-.22,0-1.42-.71-1.76-.22-.11-.34-.08-.41-.07h0Z"
              />
              <path
                className="cls-107"
                d="M222.34,82.08c-.34.11-.68.21-1.03.32.57.77,1.26.95,1.32.48.03-.21-.07-.48-.29-.8h0Z"
              />
              <path
                className="cls-107"
                d="M220.26,82.7c-.35.1-.71.2-1.07.3.55.78,1.25.96,1.34.5.04-.21-.05-.48-.26-.8h0Z"
              />
            </g>
            <g className="cls-493">
              <path
                className="cls-107"
                d="M230.49,96.11c-.33.14-.36.58-.07,1.15.4-.12.8-.24,1.19-.37-.41-.7-.89-.86-1.12-.79h0Z"
              />
              <path
                className="cls-107"
                d="M228.07,96.83c-.34.13-.39.58-.12,1.15.42-.12.83-.23,1.24-.35-.4-.71-.89-.87-1.13-.8h0Z"
              />
              <path
                className="cls-107"
                d="M229.44,91.94c-.61.26.07,1.59.78,1.87.17.07.28.04.34.03-.37-.64-.74-1.27-1.12-1.9h0Z"
              />
              <path
                className="cls-107"
                d="M227.15,92.64c-.64.25,0,1.59.73,1.87.53.21.77-.25.49-.9-.27-.62-.85-1.08-1.23-.97h0Z"
              />
              <path
                className="cls-107"
                d="M224.76,93.31c.35.64.7,1.28,1.04,1.92.64-.23.11-1.5-.61-1.85-.22-.11-.35-.08-.43-.07h0Z"
              />
              <path
                className="cls-107"
                d="M227.16,89.3c-.37.11-.74.23-1.11.34.57.88,1.26.96,1.35.51.05-.22-.03-.51-.24-.85h0Z"
              />
              <path
                className="cls-107"
                d="M224.91,89.98c-.38.11-.77.22-1.16.33.55.88,1.26.97,1.37.53.09-.33-.14-.73-.21-.86h0Z"
              />
            </g>
            <g className="cls-492">
              <path
                className="cls-107"
                d="M234.55,104.02c-.36.14-.42.6-.16,1.2.43-.13.85-.26,1.27-.39-.37-.73-.87-.89-1.1-.82h0Z"
              />
              <path
                className="cls-107"
                d="M231.98,104.77c-.37.14-.44.61-.2,1.2.44-.12.88-.25,1.32-.37-.36-.74-.87-.9-1.12-.83h0Z"
              />
              <path
                className="cls-107"
                d="M233.77,99.65c-.65.27-.05,1.66.67,1.95.17.07.28.04.35.03-.34-.66-.68-1.32-1.02-1.98h0Z"
              />
              <path
                className="cls-107"
                d="M231.33,100.4c-.68.27-.11,1.66.62,1.96.57.23.85-.32.54-1.05-.26-.6-.79-1.02-1.17-.91h0Z"
              />
              <path
                className="cls-107"
                d="M228.79,101.12c.32.66.63,1.33.95,2,.69-.25.23-1.56-.5-1.93-.22-.11-.36-.09-.44-.07h0Z"
              />
              <path
                className="cls-107"
                d="M231.61,96.9c-.39.12-.79.24-1.19.37.52.91,1.23.99,1.37.52.1-.35-.11-.75-.18-.89h0Z"
              />
              <path
                className="cls-107"
                d="M229.2,97.62c-.41.12-.83.24-1.24.35.5.91,1.24,1,1.4.54.12-.34-.08-.75-.15-.89h0Z"
              />
            </g>
            <g className="cls-495">
              <path
                className="cls-107"
                d="M238.19,112.23c-.38.15-.47.63-.25,1.25.45-.13.89-.27,1.33-.41-.34-.76-.83-.92-1.08-.84h0Z"
              />
              <path
                className="cls-107"
                d="M235.49,113.02c-.39.14-.5.63-.29,1.24.47-.13.93-.26,1.39-.39-.33-.76-.84-.93-1.1-.85h0Z"
              />
              <path
                className="cls-107"
                d="M237.7,107.69c-.69.29-.17,1.73.55,2.03.17.07.29.04.36.03-.3-.69-.6-1.37-.91-2.05h0Z"
              />
              <path
                className="cls-107"
                d="M235.12,108.48c-.72.28-.23,1.73.51,2.03.6.25.93-.41.59-1.2-.25-.58-.73-.94-1.1-.83h0Z"
              />
              <path
                className="cls-107"
                d="M232.43,109.24c.29.69.57,1.38.85,2.07.73-.26.34-1.63-.39-2-.22-.11-.36-.09-.46-.07h0Z"
              />
              <path
                className="cls-107"
                d="M235.65,104.83c-.42.13-.84.26-1.27.39.47.95,1.21,1.03,1.38.54.13-.36-.06-.79-.12-.93h0Z"
              />
              <path
                className="cls-107"
                d="M233.1,105.6c-.44.13-.88.25-1.32.37.46.95,1.22,1.04,1.41.55.15-.36-.03-.79-.09-.93h0Z"
              />
            </g>
            <g className="cls-497">
              <path
                className="cls-107"
                d="M241.4,120.7c-.4.16-.52.65-.33,1.29.47-.14.93-.28,1.39-.42-.29-.78-.79-.94-1.05-.86h0Z"
              />
              <path
                className="cls-107"
                d="M238.58,121.53c-.41.15-.55.65-.37,1.28.49-.14.97-.27,1.45-.41-.29-.78-.8-.95-1.07-.87h0Z"
              />
              <path
                className="cls-107"
                d="M241.18,116.01c-.73.3-.29,1.8.44,2.1.17.07.29.04.37.03-.26-.71-.53-1.42-.8-2.13h0Z"
              />
              <path
                className="cls-107"
                d="M238.48,116.84c-.76.29-.35,1.8.4,2.11.63.26,1.01-.52.64-1.35-.24-.54-.68-.86-1.04-.76h0Z"
              />
              <path
                className="cls-107"
                d="M235.66,117.64c.25.71.5,1.43.75,2.15.8-.28.41-1.79-.36-2.11-.18-.08-.31-.05-.39-.04h0Z"
              />
              <path
                className="cls-107"
                d="M239.27,113.07c-.44.14-.88.27-1.33.41.4.92,1.16,1.11,1.39.55.1-.25.08-.57-.06-.96h0Z"
              />
              <path
                className="cls-107"
                d="M236.59,113.87c-.46.13-.92.26-1.39.39.39.92,1.17,1.12,1.42.57.11-.25.1-.57-.03-.96h0Z"
              />
            </g>
            <g className="cls-479">
              <path
                className="cls-107"
                d="M244.14,129.41c-.41.16-.57.67-.42,1.32.48-.15.96-.29,1.44-.44-.27-.86-.78-.95-1.02-.88h0Z"
              />
              <path
                className="cls-107"
                d="M241.22,130.27c-.43.16-.6.66-.46,1.32.5-.14,1-.28,1.5-.42-.26-.86-.8-.96-1.04-.89h0Z"
              />
              <path
                className="cls-107"
                d="M244.21,124.59c-.76.31-.4,1.85.31,2.16.17.07.3.05.37.03-.22-.73-.45-1.46-.68-2.19h0Z"
              />
              <path
                className="cls-107"
                d="M241.4,125.45c-.79.3-.46,1.85.28,2.16.63.27,1.06-.54.73-1.39-.21-.55-.64-.88-1.01-.77h0Z"
              />
              <path
                className="cls-107"
                d="M238.47,126.28c.22.73.43,1.47.64,2.2.84-.3.52-1.84-.24-2.17-.18-.08-.32-.05-.39-.04h0Z"
              />
              <path
                className="cls-107"
                d="M242.45,121.56c-.46.14-.92.28-1.39.42.35.94,1.11,1.14,1.39.56.12-.26.12-.59,0-.99h0Z"
              />
              <path
                className="cls-107"
                d="M239.65,122.4c-.48.14-.96.27-1.45.41.34.95,1.13,1.15,1.42.58.13-.26.14-.59.02-.99h0Z"
              />
            </g>
            <g className="cls-494">
              <path
                className="cls-107"
                d="M246.39,138.31c-.43.17-.62.68-.5,1.35.5-.15.99-.3,1.47-.45-.22-.88-.74-.97-.98-.9h0Z"
              />
              <path
                className="cls-107"
                d="M243.39,139.19c-.44.16-.65.67-.54,1.34.52-.14,1.03-.29,1.54-.43-.22-.88-.75-.98-1-.91h0Z"
              />
              <path
                className="cls-107"
                d="M246.75,133.38c-.79.32-.53,1.89.18,2.2.17.07.3.04.37.02-.18-.74-.37-1.49-.56-2.23h0Z"
              />
              <path
                className="cls-107"
                d="M243.86,134.27c-.83.31-.58,1.88.15,2.2.67.29,1.15-.62.79-1.53-.19-.49-.59-.78-.94-.68h0Z"
              />
              <path
                className="cls-107"
                d="M240.83,135.13c.18.74.35,1.49.52,2.24.87-.3.64-1.87-.12-2.2-.18-.08-.32-.05-.4-.04h0Z"
              />
              <path
                className="cls-107"
                d="M245.16,130.29c-.47.15-.95.29-1.44.44.3.97,1.06,1.16,1.37.57.14-.27.16-.61.06-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M242.26,131.16c-.49.14-.99.28-1.5.42.29.97,1.08,1.17,1.41.59.15-.26.18-.6.08-1.01h0Z"
              />
            </g>
            <g className="cls-496">
              <path
                className="cls-107"
                d="M248.14,147.37c-.44.17-.66.69-.58,1.37.51-.15,1.01-.31,1.5-.46-.17-.89-.68-.99-.93-.91h0Z"
              />
              <path
                className="cls-107"
                d="M245.07,148.27c-.45.16-.69.69-.61,1.36.53-.15,1.05-.29,1.57-.44-.17-.89-.7-.99-.95-.92h0Z"
              />
              <path
                className="cls-107"
                d="M248.79,142.36c-.82.33-.64,1.93.05,2.24.17.07.3.04.37.02-.14-.76-.28-1.51-.43-2.27h0Z"
              />
              <path
                className="cls-107"
                d="M245.82,143.27c-.85.32-.7,1.92.03,2.24.69.31,1.22-.75.84-1.66-.19-.45-.54-.68-.87-.58h0Z"
              />
              <path
                className="cls-107"
                d="M242.72,144.14c.14.76.27,1.51.4,2.27.89-.31.75-1.91,0-2.24-.18-.08-.32-.05-.4-.03h0Z"
              />
              <path
                className="cls-107"
                d="M247.37,139.21c-.49.15-.98.3-1.47.45.25.99,1,1.18,1.35.58.16-.27.2-.62.12-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M244.39,140.1c-.51.15-1.02.29-1.54.43.24.99,1.02,1.19,1.4.6.17-.27.21-.61.14-1.03h0Z"
              />
            </g>
            <g className="cls-480">
              <path
                className="cls-107"
                d="M249.35,156.54c-.45.17-.7.71-.66,1.4.51-.15,1.02-.31,1.53-.47-.11-.84-.58-1.02-.87-.93h0Z"
              />
              <path
                className="cls-107"
                d="M246.24,157.46c-.46.16-.73.71-.69,1.39.54-.15,1.07-.3,1.59-.45-.12-.91-.64-1.01-.9-.94h0Z"
              />
              <path
                className="cls-107"
                d="M250.3,151.48c-.83.33-.75,1.95-.08,2.27.16.08.29.05.37.03-.09-.77-.19-1.53-.29-2.3h0Z"
              />
              <path
                className="cls-107"
                d="M247.28,152.4c-.86.32-.8,1.94-.1,2.27.67.31,1.27-.75.94-1.68-.16-.45-.5-.69-.84-.59h0Z"
              />
              <path
                className="cls-107"
                d="M244.12,153.3c.1.77.19,1.53.27,2.3.91-.31.85-1.93.13-2.27-.17-.08-.32-.05-.4-.03h0Z"
              />
              <path
                className="cls-107"
                d="M249.06,148.28c-.5.15-1,.31-1.5.46.19,1,.94,1.2,1.32.59.17-.28.23-.63.18-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M246.02,149.19c-.52.15-1.04.3-1.57.44.18,1,.96,1.21,1.37.6.18-.27.25-.62.2-1.05h0Z"
              />
            </g>
            <g className="cls-420">
              <path
                className="cls-107"
                d="M250.01,165.82c-.44.17-.73.72-.73,1.4.52-.16,1.03-.31,1.54-.47-.06-.84-.51-1.02-.8-.93h0Z"
              />
              <path
                className="cls-107"
                d="M246.87,166.74c-.46.17-.76.71-.76,1.39.54-.15,1.07-.3,1.6-.45-.06-.91-.57-1.01-.84-.94h0Z"
              />
              <path
                className="cls-107"
                d="M251.26,160.71c-.84.33-.86,1.97-.22,2.29.15.08.29.05.37.03-.04-.77-.09-1.55-.15-2.32h0Z"
              />
              <path
                className="cls-107"
                d="M248.2,161.64c-.88.33-.91,1.96-.24,2.29.67.33,1.35-.88,1-1.79-.15-.39-.45-.59-.76-.5h0Z"
              />
              <path
                className="cls-107"
                d="M245.01,162.55c.05.77.1,1.55.14,2.32.92-.32.96-1.95.26-2.29-.17-.08-.31-.05-.4-.03h0Z"
              />
              <path
                className="cls-107"
                d="M250.22,157.48c-.5.16-1.01.31-1.53.47.12.97.79,1.2,1.22.67.16-.19.34-.55.3-1.14h0Z"
              />
              <path
                className="cls-107"
                d="M247.14,158.4c-.52.15-1.05.3-1.59.45.13,1.01.89,1.22,1.33.61.2-.27.29-.63.26-1.06h0Z"
              />
            </g>
            <g className="cls-421">
              <path
                className="cls-107"
                d="M250.09,175.13c-.45.17-.76.71-.81,1.38.52-.16,1.03-.31,1.54-.47,0-.83-.44-1-.73-.91h0Z"
              />
              <path
                className="cls-107"
                d="M246.95,176.05c-.46.16-.79.7-.84,1.37.54-.15,1.07-.3,1.6-.45,0-.9-.5-1-.77-.92h0Z"
              />
              <path
                className="cls-107"
                d="M251.64,170.01c-.92.36-.97,2.1-.29,2.33.12.04.2.02.29,0,0-.25,0-.51,0-.76,0-.52,0-1.05,0-1.57h0Z"
              />
              <path
                className="cls-107"
                d="M248.57,170.95c-.89.33-1.02,1.97-.37,2.3.64.33,1.38-.88,1.09-1.8-.12-.39-.41-.59-.72-.49h0Z"
              />
              <path
                className="cls-107"
                d="M245.36,171.86c0,.52,0,1.05,0,1.57,0,.25,0,.51,0,.76.94-.32,1.07-1.96.39-2.3-.16-.08-.3-.05-.39-.03h0Z"
              />
              <path
                className="cls-107"
                d="M250.81,166.75c-.51.16-1.02.32-1.54.47.07,1.05.76,1.17,1.17.69.17-.2.37-.56.37-1.16h0Z"
              />
              <path
                className="cls-107"
                d="M247.71,167.68c-.53.15-1.06.3-1.6.45.06.98.74,1.22,1.22.7.17-.19.38-.55.38-1.15h0Z"
              />
            </g>
            <g className="cls-424">
              <path
                className="cls-107"
                d="M249.59,184.18c-.45.17-.79.69-.87,1.34.51-.15,1.02-.31,1.53-.47.05-.8-.36-.96-.65-.87h0Z"
              />
              <path
                className="cls-107"
                d="M246.47,185.1c-.46.16-.82.68-.9,1.33.54-.15,1.07-.3,1.59-.45.05-.86-.43-.95-.69-.88h0Z"
              />
              <path
                className="cls-107"
                d="M251.42,179.23c-.85.33-1.08,1.92-.49,2.23.14.07.27.04.35.02.05-.75.1-1.5.15-2.25h0Z"
              />
              <path
                className="cls-107"
                d="M248.36,180.17c-.89.32-1.12,1.91-.5,2.22.66.34,1.47-.95,1.15-1.84-.11-.32-.36-.47-.65-.38h0Z"
              />
              <path
                className="cls-107"
                d="M245.16,181.07c-.04.75-.08,1.5-.14,2.25.94-.32,1.16-1.9.52-2.22-.15-.08-.3-.05-.38-.03h0Z"
              />
              <path
                className="cls-107"
                d="M250.82,176.04c-.51.16-1.02.32-1.54.47,0,1.02.67,1.13,1.1.66.18-.19.39-.54.43-1.13h0Z"
              />
              <path
                className="cls-107"
                d="M247.72,176.97c-.53.15-1.06.3-1.6.45,0,1.02.7,1.14,1.16.67.18-.19.41-.54.45-1.13h0Z"
              />
            </g>
            <g className="cls-418">
              <path
                className="cls-107"
                d="M248.53,192.87c-.44.17-.81.67-.93,1.29.51-.15,1.01-.31,1.51-.46.1-.77-.29-.92-.57-.83h0Z"
              />
              <path
                className="cls-107"
                d="M250.62,188.11c-.85.33-1.17,1.85-.62,2.14.13.07.26.04.34.02.1-.72.2-1.44.29-2.16h0Z"
              />
              <path
                className="cls-107"
                d="M247.59,189.04c-.88.32-1.2,1.84-.63,2.14.62.32,1.48-.93,1.24-1.77-.09-.31-.32-.45-.61-.36h0Z"
              />
              <path
                className="cls-107"
                d="M250.24,185.05c-.5.16-1.01.31-1.53.47-.06.96.54,1.05.96.69.17-.15.48-.5.56-1.16h0Z"
              />
              <path
                className="cls-107"
                d="M247.16,185.98c-.52.15-1.06.3-1.59.45-.06.98.62,1.08,1.09.64.19-.18.43-.52.51-1.09h0Z"
              />
            </g>
            <g className="cls-426">
              <path
                className="cls-107"
                d="M248.84,198.69c-.69.17-.66-.76-.27-1.42.29-.5.6-.61.7-.65-.14.7-.28,1.39-.43,2.07h0Z"
              />
              <path
                className="cls-107"
                d="M249.08,193.81c-.21.9-1.04,1.52-1.39,1.03-.16-.22-.12-.54-.1-.68.51-.15,1.01-.31,1.51-.46,0,.03-.01.08-.02.11h0Z"
              />
            </g>
            <g className="cls-419">
              <path
                className="cls-107"
                d="M207.28,70.11c-.36-.46-.44-.81-.19-.9.28-.05.71.21,1.11.66-.3.08-.61.16-.91.24h0Z"
              />
              <path
                className="cls-107"
                d="M206.63,67.43c-.59.1-1.65-1.11-1.45-1.43.02-.04.06-.05.09-.07.46.5.91,1,1.36,1.5h0Z"
              />
            </g>
            <g className="cls-427">
              <path
                className="cls-107"
                d="M212.17,75.67c-.28.1-.24.47.1.97.34-.09.68-.18,1.02-.27-.47-.61-.93-.75-1.12-.7h0Z"
              />
              <path
                className="cls-107"
                d="M210.11,76.18c-.29.1-.27.47.05.97.36-.08.71-.17,1.06-.26-.49-.66-.94-.76-1.12-.72h0Z"
              />
              <path
                className="cls-107"
                d="M210.61,72.13c-.48.18.24,1.24.91,1.55.21.1.31.08.38.07-.43-.54-.86-1.08-1.29-1.62h0Z"
              />
              <path
                className="cls-107"
                d="M208.69,72.63c-.5.18.17,1.25.85,1.56.45.21.69,0,.5-.47-.23-.59-.98-1.19-1.35-1.09h0Z"
              />
              <path
                className="cls-107"
                d="M206.7,73.11c.4.54.79,1.09,1.18,1.65.54-.18-.09-1.24-.79-1.57-.21-.1-.31-.08-.38-.07h0Z"
              />
              <path
                className="cls-107"
                d="M208.19,69.87c-.3.08-.61.16-.91.24.63.74,1.24.83,1.25.47,0-.18-.11-.42-.34-.7h0Z"
              />
            </g>
            <g className="cls-423">
              <path
                className="cls-107"
                d="M216.96,82.55c-.31.11-.3.51.02,1.04.38-.1.75-.19,1.12-.29-.45-.65-.93-.81-1.14-.75h0Z"
              />
              <path
                className="cls-107"
                d="M214.69,83.12c-.32.11-.33.51-.03,1.04.39-.09.78-.19,1.17-.28-.43-.66-.92-.82-1.14-.76h0Z"
              />
              <path
                className="cls-107"
                d="M215.65,78.78c-.53.2.12,1.33.81,1.66.21.1.33.08.4.07-.4-.58-.8-1.16-1.21-1.73h0Z"
              />
              <path
                className="cls-107"
                d="M213.53,79.33c-.55.19.06,1.33.75,1.67.49.24.77-.05.56-.59-.23-.6-.93-1.18-1.32-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M211.32,79.86c.37.58.74,1.17,1.11,1.75.6-.19.03-1.32-.7-1.68-.22-.1-.33-.09-.41-.08h0Z"
              />
              <path
                className="cls-107"
                d="M213.3,76.37c-.34.09-.68.18-1.02.27.6.79,1.25.88,1.31.49.03-.19-.07-.45-.28-.76h0Z"
              />
              <path
                className="cls-107"
                d="M211.23,76.9c-.35.09-.71.17-1.06.26.54.75,1.23.94,1.32.5.04-.19-.05-.45-.26-.76h0Z"
              />
            </g>
            <g className="cls-422">
              <path
                className="cls-107"
                d="M221.42,89.85c-.34.12-.37.54-.08,1.09.41-.1.81-.21,1.21-.32-.42-.68-.91-.84-1.14-.78h0Z"
              />
              <path
                className="cls-107"
                d="M218.96,90.47c-.35.11-.4.54-.13,1.09.43-.1.85-.2,1.27-.3-.4-.69-.9-.85-1.14-.79h0Z"
              />
              <path
                className="cls-107"
                d="M220.38,85.85c-.58.22,0,1.42.71,1.76.22.11.34.09.42.07-.37-.61-.75-1.22-1.13-1.83h0Z"
              />
              <path
                className="cls-107"
                d="M218.06,86.46c-.61.21-.06,1.42.65,1.77.54.27.85-.1.62-.72-.23-.62-.87-1.15-1.28-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M215.65,87.04c.35.61.69,1.23,1.03,1.85.64-.21.12-1.42-.6-1.77-.22-.11-.35-.09-.43-.08h0Z"
              />
              <path
                className="cls-107"
                d="M218.09,83.3c-.37.1-.74.2-1.12.29.56.84,1.25.93,1.35.51.05-.21-.03-.48-.23-.81h0Z"
              />
              <path
                className="cls-107"
                d="M215.82,83.89c-.39.09-.78.19-1.17.28.51.79,1.24.99,1.37.53.06-.2,0-.48-.2-.81h0Z"
              />
            </g>
            <g className="cls-425">
              <path
                className="cls-107"
                d="M225.54,97.51c-.36.13-.43.57-.16,1.15.44-.11.87-.23,1.3-.34-.38-.71-.89-.87-1.14-.81h0Z"
              />
              <path
                className="cls-107"
                d="M222.9,98.17c-.37.12-.46.57-.21,1.15.46-.11.91-.22,1.36-.33-.37-.72-.89-.88-1.14-.82h0Z"
              />
              <path
                className="cls-107"
                d="M224.76,93.31c-.63.23-.11,1.49.6,1.85.22.11.35.09.44.07-.34-.64-.69-1.28-1.04-1.92h0Z"
              />
              <path
                className="cls-107"
                d="M222.26,93.96c-.66.22-.17,1.49.55,1.85.55.28.91-.11.72-.76-.19-.65-.83-1.2-1.27-1.09h0Z"
              />
              <path
                className="cls-107"
                d="M219.66,94.59c.32.64.64,1.29.95,1.94.7-.22.24-1.49-.5-1.86-.22-.11-.36-.09-.45-.08h0Z"
              />
              <path
                className="cls-107"
                d="M222.56,90.63c-.4.11-.81.21-1.21.32.53.89,1.26.99,1.39.54.07-.22,0-.51-.18-.86h0Z"
              />
              <path
                className="cls-107"
                d="M220.1,91.26c-.42.1-.84.2-1.27.3.5.89,1.31,1.05,1.44.49.07-.32-.11-.68-.17-.79h0Z"
              />
            </g>
            <g className="cls-476">
              <path
                className="cls-107"
                d="M229.3,105.5c-.39.13-.49.59-.25,1.2.46-.12.92-.24,1.38-.36-.35-.74-.87-.91-1.13-.84h0Z"
              />
              <path
                className="cls-107"
                d="M226.5,106.2c-.4.13-.52.6-.3,1.2.48-.11.96-.23,1.44-.35-.34-.74-.87-.92-1.14-.85h0Z"
              />
              <path
                className="cls-107"
                d="M228.79,101.12c-.68.25-.23,1.56.5,1.93.22.11.36.09.45.07-.31-.67-.63-1.34-.95-2h0Z"
              />
              <path
                className="cls-107"
                d="M226.12,101.82c-.71.24-.29,1.56.44,1.93.58.3,1-.18.78-.9-.19-.64-.79-1.14-1.22-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M223.34,102.48c.29.67.58,1.34.87,2.02.75-.23.35-1.56-.4-1.94-.23-.12-.37-.09-.47-.08h0Z"
              />
              <path
                className="cls-107"
                d="M226.68,98.32c-.43.11-.86.23-1.3.34.52.99,1.3,1.03,1.44.48.09-.33-.09-.7-.14-.82h0Z"
              />
              <path
                className="cls-107"
                d="M224.04,98.99c-.45.11-.9.22-1.36.33.46.91,1.3,1.08,1.47.5.1-.33-.06-.7-.12-.82h0Z"
              />
            </g>
            <g className="cls-431">
              <path
                className="cls-107"
                d="M232.67,113.79c-.41.14-.54.62-.34,1.24.49-.12.97-.25,1.45-.38-.32-.76-.84-.94-1.11-.86h0Z"
              />
              <path
                className="cls-107"
                d="M229.72,114.53c-.42.14-.57.62-.38,1.24.51-.12,1.01-.24,1.51-.36-.3-.77-.84-.94-1.13-.88h0Z"
              />
              <path
                className="cls-107"
                d="M232.43,109.24c-.72.26-.34,1.62.39,2,.22.12.37.09.46.07-.28-.69-.56-1.39-.85-2.07h0Z"
              />
              <path
                className="cls-107"
                d="M229.61,109.98c-.75.25-.4,1.62.34,2,.63.33,1.09-.24.84-1.04-.2-.62-.74-1.07-1.17-.96h0Z"
              />
              <path
                className="cls-107"
                d="M226.68,110.68c.26.69.52,1.39.78,2.09.8-.25.47-1.62-.29-2.01-.23-.12-.38-.1-.48-.08h0Z"
              />
              <path
                className="cls-107"
                d="M230.43,106.34c-.45.12-.91.24-1.38.36.48,1.03,1.29,1.06,1.47.5.11-.35-.04-.73-.09-.86h0Z"
              />
              <path
                className="cls-107"
                d="M227.63,107.05c-.47.12-.95.23-1.44.35.42.95,1.28,1.12,1.51.51.13-.34-.02-.73-.07-.86h0Z"
              />
            </g>
            <g className="cls-430">
              <path
                className="cls-107"
                d="M235.63,122.33c-.43.15-.59.64-.42,1.28.51-.13,1.01-.26,1.51-.39-.28-.79-.8-.96-1.09-.88h0Z"
              />
              <path
                className="cls-107"
                d="M232.56,123.1c-.44.14-.63.64-.47,1.27.53-.12,1.06-.25,1.57-.38-.27-.79-.81-.97-1.11-.9h0Z"
              />
              <path
                className="cls-107"
                d="M235.66,117.64c-.8.29-.41,1.79.35,2.11.18.08.31.05.39.04-.24-.72-.49-1.43-.75-2.15h0Z"
              />
              <path
                className="cls-107"
                d="M232.71,118.41c-.8.26-.51,1.68.23,2.08.66.36,1.18-.33.89-1.19-.2-.6-.7-.99-1.12-.89h0Z"
              />
              <path
                className="cls-107"
                d="M229.64,119.14c.23.72.46,1.44.68,2.16.83-.25.57-1.67-.19-2.08-.23-.12-.39-.1-.5-.08h0Z"
              />
              <path
                className="cls-107"
                d="M233.78,114.65c-.48.13-.96.25-1.45.38.39.97,1.25,1.14,1.49.51.14-.36,0-.75-.04-.88h0Z"
              />
              <path
                className="cls-107"
                d="M230.85,115.4c-.5.12-1,.24-1.51.36.38.98,1.26,1.15,1.53.52.15-.36.02-.75-.02-.88h0Z"
              />
            </g>
            <g className="cls-433">
              <path
                className="cls-107"
                d="M238.17,131.09c-.45.15-.64.65-.5,1.31.53-.13,1.05-.27,1.56-.41-.24-.8-.77-.98-1.06-.9h0Z"
              />
              <path
                className="cls-107"
                d="M234.98,131.89c-.47.15-.68.65-.55,1.31.55-.13,1.09-.26,1.63-.39-.25-.87-.82-.98-1.08-.91h0Z"
              />
              <path
                className="cls-107"
                d="M238.47,126.28c-.83.29-.52,1.84.24,2.17.18.08.32.05.4.04-.21-.74-.42-1.47-.64-2.2h0Z"
              />
              <path
                className="cls-107"
                d="M235.4,127.08c-.83.27-.62,1.72.12,2.13.66.37,1.22-.35.98-1.23-.17-.6-.66-1.01-1.09-.9h0Z"
              />
              <path
                className="cls-107"
                d="M232.21,127.85c.2.74.39,1.47.58,2.21.87-.26.68-1.72-.08-2.13-.23-.13-.4-.1-.5-.08h0Z"
              />
              <path
                className="cls-107"
                d="M236.73,123.21c-.5.13-1,.26-1.51.39.35,1,1.21,1.17,1.5.52.16-.37.05-.78.01-.91h0Z"
              />
              <path
                className="cls-107"
                d="M233.66,124c-.52.13-1.04.25-1.57.38.33,1.01,1.23,1.18,1.54.53.17-.37.07-.77.03-.91h0Z"
              />
            </g>
            <g className="cls-429">
              <path
                className="cls-107"
                d="M240.25,140.04c-.46.16-.69.67-.58,1.34.54-.14,1.08-.28,1.61-.42-.21-.88-.76-.99-1.03-.92h0Z"
              />
              <path
                className="cls-107"
                d="M236.98,140.86c-.48.15-.72.66-.62,1.33.56-.13,1.12-.27,1.67-.4-.2-.89-.78-.99-1.05-.93h0Z"
              />
              <path
                className="cls-107"
                d="M240.83,135.13c-.87.31-.64,1.88.12,2.2.18.08.32.05.4.03-.17-.75-.34-1.49-.52-2.24h0Z"
              />
              <path
                className="cls-107"
                d="M237.66,135.95c-.86.28-.73,1.76,0,2.17.68.39,1.31-.44,1.03-1.36-.17-.55-.62-.91-1.03-.8h0Z"
              />
              <path
                className="cls-107"
                d="M234.37,136.74c.16.75.32,1.5.47,2.25.9-.27.78-1.75.04-2.16-.23-.13-.4-.1-.51-.08h0Z"
              />
              <path
                className="cls-107"
                d="M239.23,132c-.52.14-1.04.27-1.56.41.28.97,1.09,1.19,1.45.6.16-.26.2-.6.11-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M236.06,132.81c-.54.13-1.08.26-1.63.39.29,1.03,1.19,1.2,1.54.54.2-.38.11-.79.08-.93h0Z"
              />
            </g>
            <g className="cls-435">
              <path
                className="cls-107"
                d="M241.87,149.14c-.48.16-.73.68-.66,1.36.55-.14,1.1-.28,1.64-.43-.16-.9-.71-1-.98-.93h0Z"
              />
              <path
                className="cls-107"
                d="M238.52,149.98c-.5.15-.76.67-.7,1.35.58-.14,1.15-.27,1.71-.41-.16-.9-.73-1.01-1.01-.94h0Z"
              />
              <path
                className="cls-107"
                d="M242.72,144.14c-.9.31-.75,1.91,0,2.24.18.08.32.05.4.03-.13-.76-.26-1.52-.4-2.27h0Z"
              />
              <path
                className="cls-107"
                d="M239.48,144.99c-.89.29-.83,1.79-.12,2.2.67.39,1.35-.45,1.12-1.39-.14-.56-.58-.92-1-.81h0Z"
              />
              <path
                className="cls-107"
                d="M236.1,145.8c.13.76.25,1.52.36,2.28.92-.28.88-1.77.15-2.2-.23-.13-.4-.1-.51-.08h0Z"
              />
              <path
                className="cls-107"
                d="M241.28,140.96c-.53.14-1.07.28-1.61.42.23.99,1.04,1.2,1.44.61.18-.27.24-.61.17-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M238.03,141.79c-.55.14-1.11.27-1.67.4.24,1.05,1.15,1.22,1.54.54.22-.38.16-.81.14-.95h0Z"
              />
            </g>
            <g className="cls-434">
              <path
                className="cls-107"
                d="M242.99,158.34c-.48.16-.76.69-.73,1.38.56-.14,1.11-.29,1.66-.43-.11-.85-.62-1.03-.93-.95h0Z"
              />
              <path
                className="cls-107"
                d="M239.59,159.19c-.5.15-.8.69-.77,1.38.58-.14,1.16-.28,1.73-.42-.11-.91-.68-1.03-.96-.96h0Z"
              />
              <path
                className="cls-107"
                d="M244.12,153.3c-.91.31-.85,1.93-.13,2.27.17.08.32.05.4.04-.08-.77-.17-1.54-.27-2.3h0Z"
              />
              <path
                className="cls-107"
                d="M240.82,154.16c-.94.3-.91,1.92-.16,2.27.73.33,1.4-.72,1.06-1.66-.16-.45-.53-.7-.9-.61h0Z"
              />
              <path
                className="cls-107"
                d="M237.38,154.98c.09.77.17,1.54.25,2.31.94-.28.98-1.8.26-2.22-.22-.13-.39-.1-.51-.08h0Z"
              />
              <path
                className="cls-107"
                d="M242.85,150.07c-.54.14-1.09.29-1.64.43.18,1,.98,1.22,1.41.62.19-.27.27-.62.23-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M239.53,150.92c-.56.14-1.13.28-1.71.41.18,1.01,1.01,1.23,1.47.63.2-.27.29-.62.24-1.04h0Z"
              />
            </g>
            <g className="cls-477">
              <path
                className="cls-107"
                d="M243.6,167.63c-.49.16-.8.69-.8,1.38.56-.14,1.12-.29,1.67-.44-.06-.84-.55-1.03-.87-.94h0Z"
              />
              <path
                className="cls-107"
                d="M240.17,168.49c-.5.16-.83.69-.84,1.37.59-.14,1.17-.28,1.74-.42-.06-.91-.62-1.02-.91-.95h0Z"
              />
              <path
                className="cls-107"
                d="M245.01,162.55c-.92.32-.96,1.95-.26,2.29.17.08.31.05.4.04-.04-.77-.09-1.55-.14-2.32h0Z"
              />
              <path
                className="cls-107"
                d="M241.67,163.42c-.96.31-1.01,1.94-.28,2.28.74.35,1.49-.84,1.11-1.77-.16-.4-.49-.6-.83-.51h0Z"
              />
              <path
                className="cls-107"
                d="M238.19,164.25c.05.77.09,1.55.13,2.32,1-.3,1.06-1.93.3-2.28-.18-.08-.34-.06-.43-.04h0Z"
              />
              <path
                className="cls-107"
                d="M243.92,159.29c-.55.15-1.1.29-1.66.43.12,1.01.92,1.23,1.38.62.21-.27.3-.63.28-1.06h0Z"
              />
              <path
                className="cls-107"
                d="M240.55,160.15c-.57.14-1.15.28-1.73.42.12,1.01.95,1.24,1.43.64.22-.27.32-.62.3-1.05h0Z"
              />
            </g>
            <g className="cls-428">
              <path
                className="cls-107"
                d="M243.67,176.94c-.49.16-.83.69-.87,1.37.56-.14,1.12-.29,1.67-.44,0-.83-.48-1.01-.8-.93h0Z"
              />
              <path
                className="cls-107"
                d="M245.36,171.86c-.93.32-1.06,1.96-.39,2.29.16.08.3.05.39.04,0-.25,0-.51,0-.76,0-.52,0-1.05,0-1.57h0Z"
              />
              <path
                className="cls-107"
                d="M242,172.73c-.97.31-1.11,1.95-.41,2.29.71.35,1.52-.85,1.2-1.78-.13-.4-.45-.6-.8-.51h0Z"
              />
              <path
                className="cls-107"
                d="M238.51,173.57c0,.52,0,1.05,0,1.57,0,.25,0,.51,0,.76,1.02-.3,1.16-1.94.42-2.29-.17-.08-.33-.06-.42-.04h0Z"
              />
              <path
                className="cls-107"
                d="M244.47,168.58c-.55.15-1.11.29-1.67.44.07,1.05.82,1.18,1.27.71.18-.19.4-.55.41-1.15h0Z"
              />
              <path
                className="cls-107"
                d="M241.08,169.44c-.58.14-1.16.28-1.74.42.07,1.1.92,1.2,1.39.65.35-.41.35-.91.35-1.07h0Z"
              />
            </g>
            <g className="cls-432">
              <path
                className="cls-107"
                d="M245.02,183.32c-.79.16-.97-.99-.46-1.76.24-.36.49-.45.6-.48-.04.75-.08,1.5-.14,2.25h0Z"
              />
              <path
                className="cls-107"
                d="M244.47,177.99c-.1.98-.96,1.62-1.45,1.07-.22-.25-.22-.6-.22-.75.56-.14,1.12-.29,1.67-.44,0,.04,0,.08,0,.12h0Z"
              />
            </g>
            <g className="cls-448">
              <path
                className="cls-107"
                d="M207.97,77.65c-.31-.5-.31-.88,0-.97.33-.05.77.24,1.11.73-.37.08-.73.16-1.11.24h0Z"
              />
              <path
                className="cls-107"
                d="M207.88,74.75c-.71.1-1.61-1.22-1.3-1.58.04-.04.09-.06.12-.07.4.54.79,1.09,1.18,1.65h0Z"
              />
            </g>
            <g className="cls-441">
              <path
                className="cls-107"
                d="M212.33,83.67c-.34.1-.37.5-.08,1.04.41-.09.81-.18,1.22-.27-.41-.66-.9-.83-1.13-.78h0Z"
              />
              <path
                className="cls-107"
                d="M211.32,79.86c-.58.19,0,1.33.69,1.68.22.11.34.09.42.08-.37-.59-.74-1.17-1.11-1.75h0Z"
              />
              <path
                className="cls-107"
                d="M209.02,80.37c-.61.18-.08,1.34.63,1.68.5.25.82-.03.65-.58-.18-.61-.86-1.2-1.28-1.11h0Z"
              />
              <path
                className="cls-107"
                d="M209.08,77.41c-.37.08-.73.16-1.11.24.55.8,1.23.91,1.33.52.05-.19-.03-.45-.22-.76h0Z"
              />
            </g>
            <g className="cls-439">
              <path
                className="cls-107"
                d="M216.4,91.06c-.37.11-.44.53-.17,1.09.44-.1.88-.19,1.32-.29-.38-.69-.89-.86-1.14-.8h0Z"
              />
              <path
                className="cls-107"
                d="M213.74,91.62c-.38.11-.47.54-.22,1.09.46-.09.92-.18,1.37-.28-.37-.69-.88-.87-1.14-.81h0Z"
              />
              <path
                className="cls-107"
                d="M215.65,87.04c-.64.2-.12,1.42.59,1.77.22.11.35.09.44.08-.34-.62-.69-1.24-1.03-1.85h0Z"
              />
              <path
                className="cls-107"
                d="M213.14,87.59c-.67.2-.2,1.42.53,1.78.55.27.91-.08.72-.71-.19-.62-.82-1.17-1.25-1.07h0Z"
              />
              <path
                className="cls-107"
                d="M210.53,88.12c.31.62.62,1.25.93,1.87.67-.18.3-1.31-.4-1.74-.27-.16-.44-.14-.53-.13h0Z"
              />
              <path
                className="cls-107"
                d="M213.46,84.44c-.4.09-.81.18-1.22.27.51.84,1.29,1.01,1.4.48.06-.3-.12-.64-.18-.75h0Z"
              />
            </g>
            <g className="cls-447">
              <path
                className="cls-107"
                d="M220.16,98.81c-.4.12-.5.56-.26,1.15.47-.1.94-.21,1.41-.31-.35-.72-.88-.89-1.15-.83h0Z"
              />
              <path
                className="cls-107"
                d="M217.3,99.41c-.41.11-.53.56-.31,1.14.49-.1.98-.2,1.46-.3-.34-.72-.87-.9-1.15-.85h0Z"
              />
              <path
                className="cls-107"
                d="M219.66,94.59c-.69.22-.24,1.49.49,1.86.23.12.37.09.46.08-.31-.65-.63-1.3-.95-1.94h0Z"
              />
              <path
                className="cls-107"
                d="M216.96,95.19c-.73.21-.31,1.49.43,1.87.6.3,1.01-.14.79-.84-.19-.62-.79-1.12-1.22-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M217.54,91.86c-.43.1-.87.2-1.32.29.48.89,1.3,1.07,1.46.5.09-.32-.08-.68-.14-.8h0Z"
              />
              <path
                className="cls-107"
                d="M214.88,92.44c-.45.09-.91.19-1.37.28.46.9,1.3,1.08,1.48.52.1-.32-.06-.68-.11-.8h0Z"
              />
            </g>
            <g className="cls-443">
              <path
                className="cls-107"
                d="M223.58,106.88c-.42.13-.56.58-.35,1.19.5-.11,1-.22,1.49-.33-.32-.75-.86-.93-1.15-.86h0Z"
              />
              <path
                className="cls-107"
                d="M220.55,107.52c-.43.12-.59.59-.4,1.19.52-.1,1.04-.21,1.55-.32-.31-.75-.86-.93-1.16-.87h0Z"
              />
              <path
                className="cls-107"
                d="M223.34,102.48c-.74.23-.35,1.55.39,1.94.23.12.38.1.47.08-.28-.68-.57-1.35-.87-2.02h0Z"
              />
              <path
                className="cls-107"
                d="M220.46,103.12c-.78.22-.43,1.55.33,1.94.64.33,1.11-.21.86-.99-.2-.6-.76-1.05-1.19-.96h0Z"
              />
              <path
                className="cls-107"
                d="M217.46,103.73c.26.68.52,1.36.78,2.04.78-.21.53-1.44-.2-1.9-.27-.17-.48-.15-.58-.13h0Z"
              />
              <path
                className="cls-107"
                d="M221.31,99.64c-.47.11-.94.21-1.41.31.47.98,1.31,1.04,1.5.51.12-.33-.04-.7-.09-.83h0Z"
              />
              <path
                className="cls-107"
                d="M218.45,100.26c-.48.1-.97.2-1.46.3.42.93,1.3,1.11,1.53.53.13-.33-.02-.7-.06-.83h0Z"
              />
            </g>
            <g className="cls-440">
              <path
                className="cls-107"
                d="M226.66,115.23c-.45.13-.61.61-.43,1.23.53-.11,1.05-.23,1.57-.35-.29-.77-.84-.95-1.14-.89h0Z"
              />
              <path
                className="cls-107"
                d="M223.47,115.91c-.46.13-.65.61-.48,1.23.55-.11,1.09-.22,1.63-.33-.28-.77-.84-.96-1.15-.9h0Z"
              />
              <path
                className="cls-107"
                d="M226.68,110.68c-.79.24-.46,1.61.29,2.01.23.12.39.1.49.08-.25-.7-.51-1.4-.78-2.09h0Z"
              />
              <path
                className="cls-107"
                d="M223.63,111.36c-.83.24-.54,1.61.23,2.01.65.34,1.17-.23.95-1.02-.17-.62-.72-1.09-1.18-.99h0Z"
              />
              <path
                className="cls-107"
                d="M220.46,112c.24.7.47,1.4.7,2.11.86-.23.6-1.61-.19-2.02-.24-.12-.4-.1-.51-.09h0Z"
              />
              <path
                className="cls-107"
                d="M224.73,107.74c-.49.11-.99.22-1.49.33.43,1.02,1.31,1.08,1.53.53.14-.34,0-.73-.04-.86h0Z"
              />
              <path
                className="cls-107"
                d="M221.71,108.39c-.51.11-1.03.21-1.55.32.39.96,1.29,1.15,1.57.54.16-.34.03-.73-.02-.86h0Z"
              />
            </g>
            <g className="cls-444">
              <path
                className="cls-107"
                d="M229.36,123.84c-.47.14-.67.62-.51,1.27.55-.12,1.1-.24,1.64-.36-.26-.79-.81-.98-1.13-.91h0Z"
              />
              <path
                className="cls-107"
                d="M226.03,124.54c-.48.13-.7.63-.56,1.27.57-.11,1.14-.23,1.7-.35-.25-.8-.82-.99-1.14-.92h0Z"
              />
              <path
                className="cls-107"
                d="M229.64,119.14c-.83.26-.57,1.67.18,2.08.23.13.39.1.5.08-.22-.72-.45-1.44-.68-2.16h0Z"
              />
              <path
                className="cls-107"
                d="M226.44,119.85c-.87.25-.64,1.67.13,2.08.7.37,1.28-.29,1.01-1.17-.18-.6-.69-1.01-1.14-.91h0Z"
              />
              <path
                className="cls-107"
                d="M223.12,120.53c.21.72.41,1.45.61,2.18.9-.24.7-1.66-.09-2.08-.24-.13-.41-.11-.53-.09h0Z"
              />
              <path
                className="cls-107"
                d="M227.8,116.12c-.52.12-1.04.23-1.57.35.36.98,1.27,1.17,1.56.54.17-.36.05-.75.01-.88h0Z"
              />
              <path
                className="cls-107"
                d="M224.62,116.81c-.54.11-1.08.22-1.63.33.35.99,1.28,1.18,1.6.55.18-.35.07-.75.03-.88h0Z"
              />
            </g>
            <g className="cls-445">
              <path
                className="cls-107"
                d="M231.67,132.66c-.49.14-.72.64-.59,1.3.57-.12,1.14-.25,1.69-.38-.22-.81-.78-1-1.1-.93h0Z"
              />
              <path
                className="cls-107"
                d="M228.22,133.39c-.51.14-.75.63-.64,1.29.59-.12,1.18-.24,1.76-.36-.23-.88-.83-1-1.12-.94h0Z"
              />
              <path
                className="cls-107"
                d="M232.21,127.85c-.86.26-.68,1.72.07,2.13.23.13.4.1.51.08-.19-.74-.38-1.48-.58-2.21h0Z"
              />
              <path
                className="cls-107"
                d="M228.89,128.58c-.91.26-.75,1.71.02,2.13.7.38,1.33-.31,1.1-1.21-.15-.61-.66-1.02-1.12-.92h0Z"
              />
              <path
                className="cls-107"
                d="M225.43,129.28c.18.74.35,1.48.52,2.23.94-.25.8-1.7.01-2.13-.24-.13-.42-.11-.54-.09h0Z"
              />
              <path
                className="cls-107"
                d="M230.48,124.75c-.54.12-1.09.24-1.64.36.32,1.01,1.24,1.19,1.58.55.19-.37.09-.78.06-.91h0Z"
              />
              <path
                className="cls-107"
                d="M227.17,125.46c-.56.12-1.13.23-1.7.35.31,1.02,1.26,1.21,1.62.56.2-.36.11-.77.08-.91h0Z"
              />
            </g>
            <g className="cls-442">
              <path
                className="cls-107"
                d="M233.57,141.65c-.5.15-.76.65-.67,1.33.59-.13,1.17-.26,1.74-.39-.2-.89-.79-1-1.07-.94h0Z"
              />
              <path
                className="cls-107"
                d="M230.02,142.4c-.52.14-.8.65-.71,1.32.61-.12,1.21-.24,1.81-.37-.19-.89-.8-1.01-1.1-.95h0Z"
              />
              <path
                className="cls-107"
                d="M234.37,136.74c-.9.27-.79,1.75-.04,2.17.23.13.4.1.51.08-.15-.75-.31-1.5-.47-2.25h0Z"
              />
              <path
                className="cls-107"
                d="M230.94,137.5c-.95.26-.86,1.74-.08,2.17.74.4,1.43-.4,1.16-1.34-.16-.56-.63-.92-1.07-.82h0Z"
              />
              <path
                className="cls-107"
                d="M227.38,138.23c.15.75.29,1.5.43,2.26.97-.25.9-1.73.12-2.16-.24-.13-.42-.11-.55-.09h0Z"
              />
              <path
                className="cls-107"
                d="M232.77,133.58c-.56.13-1.12.25-1.69.38.28,1.03,1.21,1.22,1.59.55.22-.38.14-.79.11-.93h0Z"
              />
              <path
                className="cls-107"
                d="M229.34,134.32c-.58.12-1.17.24-1.76.36.27,1.04,1.23,1.23,1.63.57.23-.37.15-.79.13-.93h0Z"
              />
            </g>
            <g className="cls-446">
              <path
                className="cls-107"
                d="M235.04,150.78c-.52.15-.8.66-.74,1.34.6-.13,1.19-.26,1.78-.39-.15-.9-.75-1.01-1.04-.95h0Z"
              />
              <path
                className="cls-107"
                d="M231.42,151.55c-.54.14-.84.66-.78,1.34.62-.12,1.24-.25,1.84-.38-.15-.9-.76-1.02-1.06-.96h0Z"
              />
              <path
                className="cls-107"
                d="M236.1,145.8c-.92.28-.89,1.78-.15,2.2.23.13.4.1.51.08-.12-.76-.24-1.52-.36-2.28h0Z"
              />
              <path
                className="cls-107"
                d="M232.59,146.58c-.97.27-.95,1.77-.19,2.2.72.41,1.47-.41,1.24-1.36-.13-.56-.59-.93-1.05-.84h0Z"
              />
              <path
                className="cls-107"
                d="M228.93,147.32c.11.76.22,1.53.33,2.29.99-.26.99-1.76.22-2.2-.24-.14-.42-.11-.55-.09h0Z"
              />
              <path
                className="cls-107"
                d="M234.64,142.59c-.57.13-1.16.26-1.74.39.23,1.05,1.17,1.23,1.58.56.24-.38.18-.81.16-.95h0Z"
              />
              <path
                className="cls-107"
                d="M231.12,143.35c-.6.12-1.2.25-1.81.37.22,1.05,1.19,1.25,1.63.58.25-.38.19-.8.18-.94h0Z"
              />
            </g>
            <g className="cls-436">
              <path
                className="cls-107"
                d="M236.06,160.01c-.53.15-.84.68-.81,1.37.61-.13,1.21-.26,1.8-.4-.1-.85-.65-1.04-.99-.97h0Z"
              />
              <path
                className="cls-107"
                d="M232.39,160.79c-.54.14-.87.68-.85,1.36.63-.13,1.25-.25,1.87-.38-.11-.92-.72-1.04-1.02-.98h0Z"
              />
              <path
                className="cls-107"
                d="M237.38,154.98c-.94.28-.98,1.8-.26,2.22.22.13.4.1.51.09-.08-.77-.16-1.54-.25-2.31h0Z"
              />
              <path
                className="cls-107"
                d="M233.8,155.78c-.98.27-1.04,1.79-.3,2.22.74.43,1.56-.51,1.29-1.49-.14-.51-.56-.82-.99-.73h0Z"
              />
              <path
                className="cls-107"
                d="M230.08,156.53c.08.77.15,1.54.22,2.31,1.01-.26,1.08-1.78.33-2.22-.23-.14-.42-.11-.55-.09h0Z"
              />
              <path
                className="cls-107"
                d="M236.08,151.73c-.59.13-1.18.26-1.78.39.18,1.06,1.11,1.25,1.57.57.26-.39.22-.82.21-.96h0Z"
              />
              <path
                className="cls-107"
                d="M232.48,152.51c-.61.13-1.22.25-1.84.38.17,1.06,1.14,1.26,1.62.58.27-.38.23-.81.22-.96h0Z"
              />
            </g>
            <g className="cls-438">
              <path
                className="cls-107"
                d="M236.62,169.31c-.53.15-.87.67-.88,1.36.61-.13,1.22-.27,1.81-.4-.06-.84-.59-1.04-.94-.96h0Z"
              />
              <path
                className="cls-107"
                d="M232.91,170.1c-.54.14-.9.68-.91,1.35.63-.13,1.26-.25,1.88-.38-.06-.85-.61-1.04-.97-.97h0Z"
              />
              <path
                className="cls-107"
                d="M238.19,164.25c-1,.3-1.06,1.93-.3,2.28.18.08.34.06.43.04-.04-.78-.08-1.55-.13-2.32h0Z"
              />
              <path
                className="cls-107"
                d="M234.57,165.05c-1,.27-1.13,1.8-.41,2.24.72.44,1.58-.52,1.36-1.5-.12-.52-.52-.83-.95-.74h0Z"
              />
              <path
                className="cls-107"
                d="M230.81,165.82c.04.78.08,1.55.11,2.33,1.03-.26,1.17-1.79.43-2.23-.23-.14-.42-.11-.55-.09h0Z"
              />
              <path
                className="cls-107"
                d="M237.05,160.98c-.59.13-1.2.27-1.8.4.12,1.01.97,1.25,1.48.65.23-.27.34-.62.32-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M233.41,161.77c-.62.13-1.24.26-1.87.38.12,1.07,1.09,1.27,1.6.58.29-.39.28-.82.27-.96h0Z"
              />
            </g>
            <g className="cls-449">
              <path
                className="cls-107"
                d="M238.51,173.57c-1.01.3-1.16,1.93-.42,2.29.18.08.33.06.42.04,0-.25,0-.51,0-.76,0-.52,0-1.05,0-1.57h0Z"
              />
              <path
                className="cls-107"
                d="M234.88,174.38c-1.01.28-1.21,1.8-.52,2.24.74.47,1.67-.61,1.41-1.61-.12-.46-.48-.71-.88-.63h0Z"
              />
              <path
                className="cls-107"
                d="M231.1,175.14c0,.52,0,1.05,0,1.57,0,.25,0,.51,0,.76,1.04-.27,1.26-1.79.54-2.24-.22-.14-.41-.11-.54-.09h0Z"
              />
              <path
                className="cls-107"
                d="M237.55,170.27c-.6.14-1.2.27-1.81.4.07,1.13.95,1.21,1.44.66.24-.27.37-.63.37-1.06h0Z"
              />
              <path
                className="cls-107"
                d="M233.88,171.07c-.62.13-1.25.26-1.88.38.07,1.1.99,1.22,1.5.68.38-.4.38-.9.39-1.06h0Z"
              />
            </g>
            <g className="cls-450">
              <path
                className="cls-107"
                d="M231.82,185.4c-.05.36-.31,1.02-1,1.19.04-.74.08-1.49.11-2.24.76-.1.95.59.89,1.05h0Z"
              />
            </g>
            <g className="cls-453">
              <path
                className="cls-107"
                d="M207.79,93.75c-.21-.56-.08-.99.33-1.09.44-.04.88.28,1.14.84-.49.08-.98.17-1.47.25h0Z"
              />
              <path
                className="cls-107"
                d="M211.46,90c-.85.1-1.57-1.28-1.15-1.75.07-.08.15-.1.22-.12.31.62.62,1.25.93,1.87h0Z"
              />
              <path
                className="cls-107"
                d="M206.2,90.02c.11.3.16.85-.35.97-.27-.63-.54-1.27-.82-1.89.56-.05,1.01.51,1.16.92h0Z"
              />
            </g>
            <g className="cls-452">
              <path
                className="cls-107"
                d="M214.34,99.99c-.42.11-.57.56-.36,1.14.51-.09,1.02-.19,1.52-.28-.32-.73-.87-.91-1.15-.86h0Z"
              />
              <path
                className="cls-107"
                d="M211.28,100.53c-.44.11-.6.55-.41,1.14.53-.09,1.05-.18,1.58-.27-.31-.73-.86-.92-1.16-.87h0Z"
              />
              <path
                className="cls-107"
                d="M211.23,96.3c-.75.19-.48,1.37.23,1.83.63.4,1.17-.03.98-.78-.16-.62-.75-1.13-1.22-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M208.22,96.82c.25.66.51,1.32.75,1.98.78-.18.55-1.37-.18-1.84-.27-.17-.48-.15-.57-.14h0Z"
              />
              <path
                className="cls-107"
                d="M209.26,93.5c-.49.08-.98.17-1.47.25.41.9,1.29,1.11,1.52.55.14-.32,0-.68-.05-.8h0Z"
              />
            </g>
            <g className="cls-455">
              <path
                className="cls-107"
                d="M217.41,108.13c-.45.12-.63.58-.45,1.19.54-.1,1.08-.2,1.61-.3-.3-.75-.86-.94-1.16-.89h0Z"
              />
              <path
                className="cls-107"
                d="M214.16,108.71c-.47.11-.66.58-.5,1.18.56-.09,1.12-.19,1.67-.28-.28-.76-.86-.95-1.17-.9h0Z"
              />
              <path
                className="cls-107"
                d="M217.46,103.73c-.8.22-.48,1.55.28,1.95.24.12.39.1.5.09-.26-.68-.52-1.36-.78-2.04h0Z"
              />
              <path
                className="cls-107"
                d="M214.35,104.31c-.8.2-.59,1.43.14,1.9.64.41,1.23-.04,1.08-.82-.13-.65-.72-1.18-1.22-1.09h0Z"
              />
              <path
                className="cls-107"
                d="M211.13,104.86c.23.68.46,1.37.69,2.06.83-.19.66-1.43-.09-1.91-.28-.18-.49-.16-.6-.15h0Z"
              />
              <path
                className="cls-107"
                d="M215.5,100.84c-.5.1-1.01.19-1.52.28.4.93,1.29,1.12,1.55.55.15-.33.01-.7-.03-.83h0Z"
              />
              <path
                className="cls-107"
                d="M212.44,101.4c-.52.09-1.05.18-1.58.27.4.98,1.37,1.15,1.61.49.11-.31,0-.62-.04-.75h0Z"
              />
            </g>
            <g className="cls-454">
              <path
                className="cls-107"
                d="M220.16,116.55c-.48.12-.68.6-.53,1.23.57-.1,1.13-.21,1.69-.31-.27-.78-.84-.97-1.16-.91h0Z"
              />
              <path
                className="cls-107"
                d="M216.74,117.16c-.49.12-.72.6-.58,1.22.59-.1,1.18-.2,1.76-.3-.25-.78-.84-.98-1.18-.92h0Z"
              />
              <path
                className="cls-107"
                d="M220.46,112c-.85.23-.59,1.6.18,2.01.24.13.41.11.51.09-.23-.71-.46-1.41-.7-2.11h0Z"
              />
              <path
                className="cls-107"
                d="M217.18,112.61c-.84.21-.69,1.48.04,1.97.68.45,1.35-.11,1.15-.95-.14-.63-.7-1.1-1.2-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M213.78,113.19c.21.7.41,1.41.61,2.12.88-.2.76-1.48,0-1.97-.28-.18-.51-.16-.62-.15h0Z"
              />
              <path
                className="cls-107"
                d="M218.57,109.02c-.53.1-1.07.2-1.61.3.37.96,1.29,1.16,1.6.56.17-.34.05-.73.01-.86h0Z"
              />
              <path
                className="cls-107"
                d="M215.33,109.61c-.55.1-1.11.19-1.67.28.36,1.01,1.38,1.19,1.67.5.14-.32.04-.64,0-.78h0Z"
              />
            </g>
            <g className="cls-437">
              <path
                className="cls-107"
                d="M222.58,125.21c-.5.13-.74.62-.61,1.26.59-.11,1.18-.22,1.76-.33-.24-.8-.82-.99-1.15-.93h0Z"
              />
              <path
                className="cls-107"
                d="M219.01,125.85c-.52.12-.77.61-.65,1.25.62-.1,1.23-.21,1.83-.31-.23-.8-.83-1-1.18-.94h0Z"
              />
              <path
                className="cls-107"
                d="M223.12,120.53c-.9.24-.7,1.66.09,2.08.24.13.41.11.53.09-.2-.73-.41-1.45-.61-2.18h0Z"
              />
              <path
                className="cls-107"
                d="M219.68,121.17c-.89.22-.8,1.54-.05,2.03.68.46,1.4-.11,1.24-.98-.12-.65-.68-1.14-1.19-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M216.12,121.77c.18.73.36,1.46.54,2.19.92-.21.85-1.53.1-2.03-.29-.19-.52-.17-.64-.16h0Z"
              />
              <path
                className="cls-107"
                d="M221.33,117.46c-.56.11-1.12.21-1.69.31.33.99,1.28,1.19,1.63.57.2-.35.09-.75.06-.88h0Z"
              />
              <path
                className="cls-107"
                d="M217.92,118.08c-.58.1-1.17.2-1.76.3.33,1.04,1.38,1.22,1.71.5.16-.33.08-.66.04-.8h0Z"
              />
            </g>
            <g className="cls-451">
              <path
                className="cls-107"
                d="M224.65,134.08c-.53.13-.79.63-.68,1.29.61-.11,1.22-.22,1.82-.34-.2-.81-.79-1.01-1.14-.95h0Z"
              />
              <path
                className="cls-107"
                d="M220.95,134.74c-.55.13-.82.62-.73,1.28.64-.11,1.27-.21,1.89-.32-.21-.88-.85-1.01-1.17-.96h0Z"
              />
              <path
                className="cls-107"
                d="M225.43,129.28c-.93.24-.8,1.7-.02,2.13.24.13.42.11.54.1-.17-.74-.34-1.49-.52-2.23h0Z"
              />
              <path
                className="cls-107"
                d="M221.86,129.95c-.97.23-.86,1.69-.06,2.13.76.42,1.48-.37,1.19-1.3-.17-.55-.67-.92-1.13-.83h0Z"
              />
              <path
                className="cls-107"
                d="M218.16,130.58c.16.74.31,1.49.46,2.24.96-.22.95-1.57.19-2.08-.29-.19-.53-.17-.65-.16h0Z"
              />
              <path
                className="cls-107"
                d="M223.74,126.15c-.58.11-1.17.22-1.76.33.29,1.01,1.27,1.22,1.65.58.22-.36.14-.77.11-.91h0Z"
              />
              <path
                className="cls-107"
                d="M220.18,126.79c-.61.11-1.22.21-1.83.31.29,1.07,1.37,1.24,1.75.51.18-.34.11-.68.08-.82h0Z"
              />
            </g>
            <g className="cls-300">
              <path
                className="cls-107"
                d="M226.35,143.12c-.54.14-.83.64-.75,1.31.63-.11,1.25-.23,1.87-.35-.17-.83-.76-1.03-1.12-.96h0Z"
              />
              <path
                className="cls-107"
                d="M222.54,143.79c-.56.13-.87.63-.8,1.3.65-.11,1.3-.22,1.95-.33-.18-.89-.83-1.03-1.15-.97h0Z"
              />
              <path
                className="cls-107"
                d="M227.38,138.23c-.97.25-.9,1.73-.12,2.17.24.13.42.11.54.09-.14-.75-.28-1.51-.43-2.26h0Z"
              />
              <path
                className="cls-107"
                d="M223.69,138.91c-1.01.24-.97,1.72-.16,2.17.75.41,1.53-.39,1.28-1.32-.15-.56-.64-.93-1.11-.85h0Z"
              />
              <path
                className="cls-107"
                d="M219.87,139.56c.13.75.25,1.51.37,2.27.99-.22,1.04-1.59.29-2.11-.28-.2-.54-.17-.66-.16h0Z"
              />
              <path
                className="cls-107"
                d="M225.79,135.03c-.6.11-1.21.23-1.82.34.25,1.03,1.24,1.24,1.67.59.24-.37.18-.79.15-.93h0Z"
              />
              <path
                className="cls-107"
                d="M222.11,135.7c-.63.11-1.26.22-1.89.32.25,1.09,1.35,1.26,1.77.52.2-.35.15-.69.12-.84h0Z"
              />
            </g>
            <g className="cls-299">
              <path
                className="cls-107"
                d="M227.67,152.28c-.56.14-.87.65-.82,1.33.64-.12,1.28-.24,1.91-.36-.14-.9-.78-1.03-1.09-.97h0Z"
              />
              <path
                className="cls-107"
                d="M223.78,152.97c-.58.13-.91.64-.86,1.32.67-.11,1.33-.22,1.99-.34-.14-.9-.79-1.04-1.12-.98h0Z"
              />
              <path
                className="cls-107"
                d="M228.93,147.32c-1,.26-1,1.76-.22,2.2.24.13.42.11.55.09-.1-.76-.21-1.53-.33-2.29h0Z"
              />
              <path
                className="cls-107"
                d="M225.15,148.03c-1.04.25-1.06,1.75-.26,2.2.79.45,1.64-.48,1.33-1.45-.16-.51-.61-.83-1.06-.75h0Z"
              />
              <path
                className="cls-107"
                d="M221.24,148.69c.1.76.19,1.53.29,2.3,1.02-.22,1.12-1.61.38-2.14-.28-.2-.54-.17-.67-.16h0Z"
              />
              <path
                className="cls-107"
                d="M227.47,144.08c-.62.12-1.24.23-1.87.35.21,1.05,1.21,1.26,1.67.59.27-.38.22-.8.2-.94h0Z"
              />
              <path
                className="cls-107"
                d="M223.69,144.77c-.64.11-1.29.22-1.95.33.21,1.1,1.32,1.28,1.78.52.22-.35.18-.71.16-.86h0Z"
              />
            </g>
            <g className="cls-301">
              <path
                className="cls-107"
                d="M228.58,161.53c-.56.14-.91.67-.89,1.35.65-.12,1.3-.24,1.94-.36-.1-.85-.68-1.06-1.05-.99h0Z"
              />
              <path
                className="cls-107"
                d="M224.64,162.23c-.58.13-.94.66-.93,1.34.68-.11,1.35-.23,2.01-.34-.09-.85-.7-1.06-1.09-1h0Z"
              />
              <path
                className="cls-107"
                d="M230.08,156.53c-1.01.26-1.08,1.77-.33,2.22.23.14.42.11.55.1-.07-.77-.14-1.54-.22-2.31h0Z"
              />
              <path
                className="cls-107"
                d="M226.24,157.25c-1.05.25-1.14,1.76-.36,2.21.78.46,1.67-.47,1.4-1.46-.14-.52-.58-.83-1.04-.75h0Z"
              />
              <path
                className="cls-107"
                d="M222.25,157.93c.07.77.13,1.54.2,2.32,1.08-.24,1.19-1.75.39-2.21-.25-.14-.45-.12-.58-.11h0Z"
              />
              <path
                className="cls-107"
                d="M228.76,153.25c-.63.12-1.27.24-1.91.36.17,1.06,1.17,1.27,1.67.6.29-.38.26-.81.24-.95h0Z"
              />
              <path
                className="cls-107"
                d="M224.9,153.95c-.66.11-1.32.23-1.99.34.16,1.06,1.19,1.28,1.72.61.3-.38.27-.81.26-.95h0Z"
              />
            </g>
            <g className="cls-302">
              <path
                className="cls-107"
                d="M229.08,170.84c-.56.14-.94.67-.95,1.35.66-.12,1.31-.24,1.95-.36-.06-.85-.63-1.05-1-.98h0Z"
              />
              <path
                className="cls-107"
                d="M225.1,171.55c-.58.13-.97.66-.98,1.34.68-.11,1.36-.23,2.03-.35-.06-.85-.66-1.06-1.04-.99h0Z"
              />
              <path
                className="cls-107"
                d="M230.81,165.82c-1.02.26-1.16,1.79-.43,2.23.23.14.42.11.54.1-.03-.78-.07-1.55-.11-2.33h0Z"
              />
              <path
                className="cls-107"
                d="M226.92,166.54c-1.06.25-1.22,1.77-.46,2.23.76.46,1.7-.48,1.47-1.47-.12-.52-.54-.84-1.01-.76h0Z"
              />
              <path
                className="cls-107"
                d="M222.89,167.23c.04.78.07,1.55.1,2.33,1.1-.24,1.27-1.76.48-2.22-.24-.14-.45-.12-.58-.11h0Z"
              />
              <path
                className="cls-107"
                d="M229.63,162.52c-.64.12-1.29.24-1.94.36.12,1.07,1.11,1.28,1.65.6.31-.39.29-.82.29-.96h0Z"
              />
              <path
                className="cls-107"
                d="M225.72,163.23c-.67.12-1.34.23-2.01.34.12,1.07,1.15,1.29,1.71.62.32-.38.31-.82.31-.96h0Z"
              />
            </g>
            <g className="cls-303">
              <path
                className="cls-107"
                d="M231.1,175.14c-1.03.26-1.25,1.79-.53,2.23.22.14.41.11.54.1,0-.25,0-.51,0-.76,0-.52,0-1.05,0-1.57h0Z"
              />
              <path
                className="cls-107"
                d="M227.19,175.87c-1.07.25-1.29,1.78-.56,2.23.77.47,1.78-.59,1.51-1.58-.13-.46-.52-.72-.95-.65h0Z"
              />
              <path
                className="cls-107"
                d="M230.08,171.82c-.64.12-1.3.24-1.95.36.07,1.08,1.05,1.29,1.62.61.32-.39.33-.83.33-.98h0Z"
              />
              <path
                className="cls-107"
                d="M226.14,172.54c-.67.12-1.35.23-2.03.35.07,1.1,1.08,1.32,1.68.63.34-.39.35-.83.35-.97h0Z"
              />
            </g>
            <g className="cls-304">
              <path
                className="cls-107"
                d="M224.79,189.89c-.58.13-1.01.63-1.08,1.27.68-.11,1.35-.23,2.02-.34.02-.8-.55-.99-.93-.93h0Z"
              />
              <path
                className="cls-107"
                d="M230.93,184.35c-1.03.26-1.32,1.73-.64,2.15.21.13.4.1.52.09.04-.74.08-1.49.11-2.24h0Z"
              />
              <path
                className="cls-107"
                d="M227.03,185.08c-1.07.25-1.36,1.72-.65,2.15.74.45,1.79-.58,1.56-1.53-.1-.44-.48-.69-.91-.62h0Z"
              />
              <path
                className="cls-107"
                d="M222.99,185.77c-.03.75-.06,1.5-.1,2.24,1.11-.24,1.4-1.71.67-2.14-.23-.13-.43-.11-.57-.1h0Z"
              />
            </g>
            <g className="cls-306">
              <path
                className="cls-107"
                d="M225.71,190.93c-.16.99-1.3,1.54-1.82.89-.19-.24-.19-.52-.18-.66.68-.11,1.35-.23,2.02-.34,0,.03,0,.08-.01.11h0Z"
              />
            </g>
            <g className="cls-298">
              <path
                className="cls-107"
                d="M205.85,91c-.83.08-1.51-1.21-1.11-1.72.1-.12.22-.15.29-.17.28.63.55,1.26.82,1.89h0Z"
              />
            </g>
            <g className="cls-307">
              <path
                className="cls-107"
                d="M208.11,101.05c-.45.1-.64.55-.46,1.13.54-.08,1.08-.17,1.62-.25-.29-.73-.85-.93-1.16-.88h0Z"
              />
              <path
                className="cls-107"
                d="M204.85,101.53c-.47.1-.68.54-.52,1.13.56-.08,1.12-.16,1.68-.24-.27-.74-.84-.94-1.16-.89h0Z"
              />
              <path
                className="cls-107"
                d="M208.22,96.82c-.77.18-.55,1.37.17,1.83.28.18.48.16.58.15-.25-.66-.5-1.32-.75-1.98h0Z"
              />
              <path
                className="cls-107"
                d="M205.11,97.3c-.8.17-.61,1.36.11,1.83.63.41,1.24,0,1.09-.76-.12-.63-.7-1.15-1.2-1.07h0Z"
              />
            </g>
            <g className="cls-305">
              <path
                className="cls-107"
                d="M210.8,109.26c-.48.11-.7.57-.55,1.18.58-.09,1.15-.18,1.72-.27-.27-.76-.85-.96-1.17-.91h0Z"
              />
              <path
                className="cls-107"
                d="M207.33,109.77c-.51.1-.74.56-.6,1.17.6-.08,1.19-.16,1.78-.25-.25-.76-.84-.97-1.18-.92h0Z"
              />
              <path
                className="cls-107"
                d="M211.13,104.86c-.83.19-.65,1.43.08,1.9.28.18.5.16.6.15-.23-.69-.45-1.37-.69-2.06h0Z"
              />
              <path
                className="cls-107"
                d="M207.82,105.37c-.85.18-.72,1.42.02,1.91.68.45,1.36-.07,1.18-.9-.14-.61-.7-1.08-1.19-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M204.39,105.85c.2.69.39,1.38.59,2.07.89-.17.78-1.42.03-1.91-.28-.18-.51-.17-.62-.16h0Z"
              />
              <path
                className="cls-107"
                d="M209.27,101.93c-.54.09-1.08.17-1.62.25.37.98,1.36,1.17,1.63.5.13-.31.03-.62-.01-.76h0Z"
              />
              <path
                className="cls-107"
                d="M206,102.42c-.56.08-1.11.16-1.68.24.35.99,1.36,1.18,1.67.52.14-.31.05-.62.01-.76h0Z"
              />
            </g>
            <g className="cls-293">
              <path
                className="cls-107"
                d="M213.2,117.74c-.51.11-.76.59-.63,1.21.61-.09,1.21-.18,1.81-.28-.24-.78-.84-.99-1.18-.94h0Z"
              />
              <path
                className="cls-107"
                d="M209.56,118.27c-.53.11-.8.58-.68,1.21.63-.09,1.25-.17,1.87-.26-.23-.79-.83-1-1.19-.95h0Z"
              />
              <path
                className="cls-107"
                d="M213.78,113.19c-.88.2-.76,1.48-.01,1.97.29.19.51.17.62.15-.2-.71-.41-1.42-.61-2.12h0Z"
              />
              <path
                className="cls-107"
                d="M210.27,113.74c-.9.19-.82,1.47-.07,1.97.69.46,1.43-.08,1.27-.93-.12-.63-.68-1.12-1.2-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M206.65,114.24c.18.71.35,1.42.53,2.14.94-.18.88-1.47.12-1.97-.29-.19-.53-.17-.65-.16h0Z"
              />
              <path
                className="cls-107"
                d="M211.97,110.17c-.57.09-1.14.18-1.72.27.34,1.02,1.37,1.2,1.69.52.15-.32.06-.64.03-.78h0Z"
              />
              <path
                className="cls-107"
                d="M208.51,110.69c-.59.08-1.18.17-1.78.25.32,1.03,1.38,1.22,1.73.53.16-.32.08-.64.05-.78h0Z"
              />
            </g>
            <g className="cls-291">
              <path
                className="cls-107"
                d="M215.32,126.45c-.53.12-.81.61-.7,1.25.63-.1,1.26-.19,1.88-.29-.21-.8-.82-1.01-1.18-.96h0Z"
              />
              <path
                className="cls-107"
                d="M211.51,127.01c-.56.11-.86.6-.76,1.24.65-.09,1.31-.18,1.95-.27-.2-.8-.82-1.02-1.19-.97h0Z"
              />
              <path
                className="cls-107"
                d="M216.12,121.77c-.92.21-.85,1.53-.1,2.03.29.19.53.17.64.16-.18-.73-.36-1.46-.54-2.19h0Z"
              />
              <path
                className="cls-107"
                d="M212.45,122.34c-.95.2-.92,1.52-.16,2.03.74.5,1.56-.15,1.34-1.07-.14-.61-.67-1.04-1.19-.96h0Z"
              />
              <path
                className="cls-107"
                d="M208.65,122.87c.16.73.31,1.47.46,2.2.98-.19.97-1.51.2-2.03-.29-.2-.54-.18-.67-.17h0Z"
              />
              <path
                className="cls-107"
                d="M214.38,118.67c-.6.09-1.2.19-1.81.28.31,1.05,1.38,1.23,1.74.52.17-.33.1-.66.07-.8h0Z"
              />
              <path
                className="cls-107"
                d="M210.74,119.22c-.62.09-1.24.18-1.87.26.29,1.06,1.39,1.25,1.78.54.18-.33.12-.66.09-.8h0Z"
              />
            </g>
            <g className="cls-288">
              <path
                className="cls-107"
                d="M217.13,135.36c-.56.12-.86.61-.77,1.27.65-.1,1.3-.2,1.95-.3-.19-.82-.8-1.03-1.17-.97h0Z"
              />
              <path
                className="cls-107"
                d="M213.19,135.94c-.59.12-.91.6-.83,1.27.68-.09,1.35-.19,2.02-.28-.19-.88-.86-1.03-1.19-.98h0Z"
              />
              <path
                className="cls-107"
                d="M218.16,130.58c-.96.22-.95,1.57-.19,2.08.29.2.54.17.65.16-.15-.75-.3-1.49-.46-2.24h0Z"
              />
              <path
                className="cls-107"
                d="M214.34,131.17c-.99.2-1.01,1.56-.25,2.08.75.51,1.61-.16,1.43-1.11-.12-.61-.65-1.05-1.18-.97h0Z"
              />
              <path
                className="cls-107"
                d="M210.4,131.72c.13.75.27,1.5.39,2.25,1.02-.2,1.07-1.55.29-2.08-.29-.2-.56-.18-.68-.17h0Z"
              />
              <path
                className="cls-107"
                d="M216.5,127.41c-.62.1-1.25.2-1.88.29.28,1.07,1.37,1.26,1.78.53.19-.34.13-.68.1-.82h0Z"
              />
              <path
                className="cls-107"
                d="M212.71,127.98c-.65.09-1.3.18-1.95.27.26,1.08,1.39,1.28,1.82.55.2-.34.15-.68.13-.82h0Z"
              />
            </g>
            <g className="cls-292">
              <path
                className="cls-107"
                d="M218.62,144.43c-.58.12-.9.62-.84,1.3.67-.1,1.34-.2,2-.31-.16-.83-.78-1.04-1.16-.99h0Z"
              />
              <path
                className="cls-107"
                d="M214.56,145.03c-.61.12-.95.61-.9,1.29.7-.1,1.39-.19,2.07-.29-.16-.9-.84-1.05-1.18-1h0Z"
              />
              <path
                className="cls-107"
                d="M219.87,139.56c-1,.22-1.04,1.59-.29,2.11.29.2.54.17.66.16-.12-.76-.25-1.51-.37-2.27h0Z"
              />
              <path
                className="cls-107"
                d="M215.93,140.17c-1.03.21-1.1,1.58-.33,2.11.74.51,1.66-.17,1.51-1.12-.1-.62-.63-1.07-1.18-.99h0Z"
              />
              <path
                className="cls-107"
                d="M211.86,140.74c.11.76.22,1.52.32,2.28,1.05-.2,1.15-1.57.37-2.1-.29-.2-.56-.18-.69-.17h0Z"
              />
              <path
                className="cls-107"
                d="M218.3,136.33c-.64.1-1.29.2-1.95.3.24,1.09,1.36,1.28,1.81.54.21-.35.16-.69.14-.84h0Z"
              />
              <path
                className="cls-107"
                d="M214.38,136.93c-.67.1-1.34.19-2.02.28.23,1.1,1.38,1.3,1.86.56.22-.35.18-.69.16-.84h0Z"
              />
            </g>
            <g className="cls-290">
              <path
                className="cls-107"
                d="M219.77,153.62c-.6.13-.94.63-.91,1.31.69-.1,1.37-.21,2.04-.32-.13-.91-.8-1.05-1.14-1h0Z"
              />
              <path
                className="cls-107"
                d="M215.63,154.23c-.62.12-.99.62-.96,1.3.71-.1,1.42-.2,2.12-.3-.13-.91-.81-1.06-1.16-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M221.24,148.69c-1.02.23-1.13,1.62-.38,2.14.28.2.54.17.67.16-.09-.77-.19-1.53-.29-2.3h0Z"
              />
              <path
                className="cls-107"
                d="M217.2,149.32c-1.05.22-1.18,1.6-.42,2.14.78.55,1.78-.25,1.56-1.26-.12-.57-.62-.96-1.14-.88h0Z"
              />
              <path
                className="cls-107"
                d="M213.03,149.9c.08.77.17,1.53.24,2.3,1.08-.2,1.23-1.59.46-2.13-.29-.21-.57-.18-.7-.17h0Z"
              />
              <path
                className="cls-107"
                d="M219.78,145.42c-.66.1-1.33.21-2,.31.2,1.11,1.34,1.3,1.82.54.23-.35.19-.7.18-.85h0Z"
              />
              <path
                className="cls-107"
                d="M215.74,146.03c-.69.1-1.38.2-2.07.29.19,1.11,1.36,1.31,1.88.56.24-.35.21-.7.2-.85h0Z"
              />
            </g>
            <g className="cls-294">
              <path
                className="cls-107"
                d="M220.57,162.89c-.6.13-.98.65-.96,1.33.7-.11,1.39-.21,2.07-.32-.09-.85-.71-1.07-1.11-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M216.36,163.51c-.62.12-1.02.64-1.01,1.32.72-.1,1.44-.2,2.15-.3-.09-.85-.73-1.08-1.13-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M222.25,157.93c-1.08.24-1.18,1.75-.39,2.21.25.14.45.12.58.11-.06-.77-.13-1.55-.2-2.32h0Z"
              />
              <path
                className="cls-107"
                d="M218.14,158.56c-1.07.22-1.25,1.62-.51,2.15.77.56,1.81-.25,1.63-1.27-.1-.57-.59-.96-1.12-.89h0Z"
              />
              <path
                className="cls-107"
                d="M213.89,159.16c.06.77.11,1.55.17,2.32,1.1-.21,1.3-1.6.54-2.15-.29-.21-.57-.18-.71-.17h0Z"
              />
              <path
                className="cls-107"
                d="M220.9,154.62c-.68.11-1.36.21-2.04.32.16,1.12,1.3,1.31,1.83.55.25-.36.22-.71.22-.86h0Z"
              />
              <path
                className="cls-107"
                d="M216.79,155.24c-.7.1-1.41.2-2.12.3.16,1.12,1.34,1.32,1.88.56.26-.35.24-.71.23-.86h0Z"
              />
            </g>
            <g className="cls-296">
              <path
                className="cls-107"
                d="M221,172.22c-.6.13-1,.65-1.02,1.33.7-.11,1.4-.21,2.09-.32-.06-.85-.67-1.06-1.07-1h0Z"
              />
              <path
                className="cls-107"
                d="M216.76,172.84c-.63.12-1.04.64-1.06,1.32.73-.1,1.45-.2,2.16-.3-.06-.85-.69-1.07-1.1-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M222.89,167.23c-1.1.24-1.26,1.76-.48,2.22.24.14.45.12.58.11-.03-.78-.06-1.55-.1-2.33h0Z"
              />
              <path
                className="cls-107"
                d="M218.73,167.87c-1.08.22-1.32,1.62-.59,2.16.75.56,1.82-.25,1.68-1.27-.08-.58-.56-.97-1.09-.89h0Z"
              />
              <path
                className="cls-107"
                d="M214.44,168.47c.03.78.06,1.55.08,2.33,1.11-.21,1.37-1.61.62-2.16-.28-.21-.57-.18-.7-.17h0Z"
              />
              <path
                className="cls-107"
                d="M221.67,163.9c-.68.11-1.38.22-2.07.32.11,1.07,1.17,1.3,1.75.64.33-.38.32-.81.32-.96h0Z"
              />
              <path
                className="cls-107"
                d="M217.5,164.53c-.71.1-1.42.2-2.15.3.12,1.13,1.3,1.33,1.88.57.27-.36.27-.71.27-.87h0Z"
              />
            </g>
            <g className="cls-289">
              <path
                className="cls-107"
                d="M221.04,181.53c-.6.13-1.02.64-1.07,1.31.7-.11,1.4-.21,2.09-.32-.02-.83-.62-1.05-1.02-.98h0Z"
              />
              <path
                className="cls-107"
                d="M216.8,182.16c-.63.12-1.06.63-1.11,1.3.73-.1,1.45-.2,2.16-.3-.02-.83-.64-1.05-1.05-.99h0Z"
              />
              <path
                className="cls-107"
                d="M214.65,177.81c0,.52,0,1.05,0,1.57,0,.25,0,.51,0,.76,1.13-.21,1.43-1.62.7-2.16-.27-.2-.56-.18-.7-.17h0Z"
              />
              <path
                className="cls-107"
                d="M222.06,173.22c-.69.11-1.38.22-2.09.32.07,1.08,1.12,1.32,1.72.65.35-.38.36-.82.36-.97h0Z"
              />
              <path
                className="cls-107"
                d="M217.86,173.85c-.71.1-1.43.2-2.16.3.07,1.09,1.16,1.33,1.79.66.36-.38.37-.82.37-.96h0Z"
              />
            </g>
            <g className="cls-297">
              <path
                className="cls-107"
                d="M220.71,190.55c-.6.13-1.04.62-1.11,1.26.7-.11,1.39-.21,2.07-.32.01-.8-.57-1-.96-.94h0Z"
              />
              <path
                className="cls-107"
                d="M216.49,191.17c-.63.12-1.08.61-1.15,1.25.72-.1,1.44-.2,2.15-.3,0-.8-.59-1-1-.95h0Z"
              />
              <path
                className="cls-107"
                d="M222.99,185.77c-1.11.24-1.4,1.7-.66,2.14.23.13.43.11.56.1.04-.74.07-1.49.1-2.24h0Z"
              />
              <path
                className="cls-107"
                d="M218.82,186.41c-1.14.23-1.44,1.69-.68,2.13.79.46,1.9-.54,1.65-1.5-.12-.44-.52-.7-.98-.64h0Z"
              />
              <path
                className="cls-107"
                d="M214.52,187.01c-.03.75-.05,1.5-.09,2.24,1.12-.21,1.47-1.56.77-2.08-.27-.2-.55-.17-.69-.16h0Z"
              />
              <path
                className="cls-107"
                d="M222.06,182.52c-.69.11-1.39.22-2.09.32.03,1.07,1.04,1.28,1.69.62.36-.37.39-.8.4-.94h0Z"
              />
              <path
                className="cls-107"
                d="M217.86,183.15c-.71.1-1.44.2-2.16.3.03,1.05,1.1,1.28,1.75.64.37-.37.4-.8.41-.94h0Z"
              />
            </g>
            <g className="cls-295">
              <path
                className="cls-107"
                d="M218.32,195.23c-1.08.21-1.48,1.51-.83,1.99.71.53,1.89-.32,1.78-1.29-.06-.48-.46-.77-.95-.7h0Z"
              />
              <path
                className="cls-107"
                d="M214.05,195.82c-.05.72-.11,1.43-.17,2.14,1.12-.2,1.51-1.49.84-1.98-.25-.19-.53-.16-.67-.15h0Z"
              />
              <path
                className="cls-107"
                d="M221.67,191.49c-.69.11-1.38.22-2.07.32-.02,1.02.98,1.22,1.64.58.37-.36.42-.77.43-.9h0Z"
              />
              <path
                className="cls-107"
                d="M217.49,192.12c-.71.1-1.43.2-2.15.3-.01,1,1.04,1.22,1.71.6.38-.36.43-.77.44-.9h0Z"
              />
            </g>
            <g className="cls-308">
              <path
                className="cls-107"
                d="M213.65,209.09c.11-.58.58-1.02,1.19-1.13.59-.05.94.28.88.84-.69.1-1.38.2-2.08.29h0Z"
              />
              <path
                className="cls-107"
                d="M218.34,204.6c-.22.95-1.51,1.44-1.94.74-.31-.51.09-1.53,1.06-1.72.78-.08.98.53.87.98h0Z"
              />
              <path
                className="cls-107"
                d="M214.18,205.19c-.07.32-.4.91-1.16,1.05.09-.67.17-1.35.25-2.04.85-.07,1.01.57.92.99h0Z"
              />
            </g>
            <g className="cls-309">
              <path
                className="cls-107"
                d="M213.01,213.08c-.08.31-.43.87-1.17,1,.11-.64.22-1.28.32-1.92.82-.07.96.53.85.92h0Z"
              />
              <path
                className="cls-107"
                d="M215.71,208.9c-.24.94-1.52,1.41-1.96.71-.13-.2-.11-.4-.1-.52.7-.1,1.39-.19,2.08-.29,0,.03-.01.07-.02.1h0Z"
              />
            </g>
            <g className="cls-310">
              <path
                className="cls-107"
                d="M200.93,103.1c-.14-.59.08-1.03.56-1.12.51-.03.94.32,1.15.91-.57.07-1.13.14-1.7.21h0Z"
              />
              <path
                className="cls-107"
                d="M197.5,103.49c-.13-.6.1-1.03.59-1.11.5-.03.94.34,1.13.92-.57.07-1.14.13-1.72.19h0Z"
              />
            </g>
            <g className="cls-312">
              <path
                className="cls-107"
                d="M203.76,110.24c-.51.1-.76.55-.64,1.16.6-.07,1.2-.15,1.8-.23-.23-.77-.83-.98-1.17-.94h0Z"
              />
              <path
                className="cls-107"
                d="M200.16,110.67c-.52.09-.78.53-.67,1.16.61-.07,1.22-.13,1.82-.2-.22-.77-.81-.99-1.15-.95h0Z"
              />
              <path
                className="cls-107"
                d="M204.39,105.85c-.88.17-.78,1.41-.04,1.91.28.19.51.17.62.16-.19-.69-.39-1.38-.59-2.07h0Z"
              />
              <path
                className="cls-107"
                d="M200.91,106.29c-.89.16-.82,1.4-.09,1.9.68.46,1.41-.04,1.26-.87-.11-.61-.66-1.1-1.17-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M197.39,106.69c.16.69.32,1.39.48,2.08.92-.15.88-1.4.14-1.91-.28-.19-.51-.18-.62-.17h0Z"
              />
              <path
                className="cls-107"
                d="M202.63,102.88c-.57.07-1.13.14-1.7.21.32,1,1.34,1.2,1.67.54.15-.3.07-.62.04-.75h0Z"
              />
              <path
                className="cls-107"
                d="M199.22,103.3c-.57.07-1.14.13-1.72.19.3.99,1.31,1.21,1.66.56.16-.3.09-.62.06-.75h0Z"
              />
            </g>
            <g className="cls-311">
              <path
                className="cls-107"
                d="M205.8,118.77c-.54.1-.82.57-.71,1.2.63-.08,1.27-.16,1.9-.24-.21-.79-.82-1.01-1.18-.96h0Z"
              />
              <path
                className="cls-107"
                d="M202.02,119.22c-.55.09-.84.55-.74,1.19.64-.07,1.28-.14,1.91-.22-.2-.79-.81-1.02-1.17-.98h0Z"
              />
              <path
                className="cls-107"
                d="M206.65,114.24c-.93.18-.88,1.46-.12,1.97.29.19.53.18.65.17-.17-.71-.35-1.43-.53-2.14h0Z"
              />
              <path
                className="cls-107"
                d="M202.97,114.71c-.94.17-.92,1.45-.17,1.97.73.5,1.55-.11,1.34-1.01-.13-.59-.66-1.02-1.17-.96h0Z"
              />
              <path
                className="cls-107"
                d="M199.25,115.12c.15.71.29,1.43.43,2.15.97-.16.97-1.44.22-1.97-.28-.2-.53-.18-.65-.18h0Z"
              />
              <path
                className="cls-107"
                d="M204.93,111.18c-.6.08-1.2.15-1.8.23.3,1.03,1.36,1.24,1.73.55.17-.31.1-.64.07-.78h0Z"
              />
              <path
                className="cls-107"
                d="M201.31,111.62c-.61.07-1.21.14-1.82.2.27,1.03,1.34,1.25,1.73.58.18-.31.12-.64.09-.78h0Z"
              />
            </g>
            <g className="cls-313">
              <path
                className="cls-107"
                d="M207.6,127.53c-.56.1-.87.59-.78,1.23.66-.08,1.32-.16,1.98-.25-.19-.81-.82-1.03-1.19-.98h0Z"
              />
              <path
                className="cls-107"
                d="M203.64,128c-.58.1-.89.57-.81,1.22.67-.07,1.33-.15,1.99-.22-.18-.81-.8-1.04-1.18-1h0Z"
              />
              <path
                className="cls-107"
                d="M208.65,122.87c-.98.19-.97,1.51-.2,2.03.29.2.55.18.67.17-.15-.74-.31-1.47-.46-2.2h0Z"
              />
              <path
                className="cls-107"
                d="M204.8,123.36c-.99.18-1.01,1.5-.25,2.03.74.51,1.61-.12,1.43-1.04-.12-.61-.65-1.05-1.19-.99h0Z"
              />
              <path
                className="cls-107"
                d="M200.9,123.8c.13.74.26,1.47.38,2.21,1.01-.17,1.06-1.49.29-2.03-.29-.2-.55-.19-.67-.19h0Z"
              />
              <path
                className="cls-107"
                d="M206.99,119.73c-.63.08-1.26.16-1.9.24.27,1.06,1.38,1.27,1.79.56.19-.33.13-.66.11-.8h0Z"
              />
              <path
                className="cls-107"
                d="M203.19,120.2c-.64.07-1.27.15-1.91.22.25,1.06,1.35,1.28,1.79.58.2-.33.15-.66.13-.8h0Z"
              />
            </g>
            <g className="cls-314">
              <path
                className="cls-107"
                d="M209.13,136.48c-.59.11-.92.59-.85,1.26.68-.08,1.37-.17,2.05-.26-.18-.89-.86-1.04-1.19-1h0Z"
              />
              <path
                className="cls-107"
                d="M205.04,136.97c-.6.1-.94.58-.88,1.25.69-.08,1.38-.15,2.06-.23-.15-.82-.79-1.06-1.19-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M210.4,131.72c-1.01.19-1.06,1.54-.29,2.07.3.2.56.18.68.17-.13-.75-.26-1.5-.39-2.25h0Z"
              />
              <path
                className="cls-107"
                d="M206.39,132.23c-1.03.18-1.09,1.53-.33,2.07.75.53,1.67-.12,1.52-1.07-.1-.62-.63-1.06-1.19-1h0Z"
              />
              <path
                className="cls-107"
                d="M202.34,132.68c.11.75.22,1.5.32,2.26,1.05-.17,1.15-1.52.37-2.07-.29-.21-.56-.19-.69-.19h0Z"
              />
              <path
                className="cls-107"
                d="M208.79,128.51c-.66.09-1.32.17-1.98.25.24,1.08,1.38,1.29,1.84.57.21-.33.16-.68.14-.82h0Z"
              />
              <path
                className="cls-107"
                d="M204.83,129c-.66.08-1.33.15-1.99.22.22,1.08,1.36,1.31,1.83.59.22-.33.18-.67.16-.82h0Z"
              />
            </g>
            <g className="cls-315">
              <path
                className="cls-107"
                d="M210.99,142.02c.12.67.58,1.05,1.19,1-.61.05-1.07-.34-1.19-1h0Z"
              />
              <path
                className="cls-107"
                d="M204.73,142.76c.05.67-.31,1.16-.93,1.26.62-.1.98-.58.93-1.26h0Z"
              />
              <path
                className="cls-107"
                d="M210.33,137.48c.12,1.11-.93,1.6-1.63,1.02-.32-.27-.39-.62-.42-.76.21,1.1,1.38,1.31,1.87.58.23-.34.19-.69.18-.84h0Z"
              />
              <path
                className="cls-107"
                d="M206.22,137.98c.1,1.12-.97,1.6-1.66,1-.32-.28-.38-.62-.41-.77.2,1.1,1.36,1.33,1.87.6.24-.34.21-.69.19-.83h0Z"
              />
            </g>
            <g className="cls-316">
              <path
                className="cls-107"
                d="M212.1,151.19c.1.67.55,1.06,1.18,1.01-.63.05-1.08-.34-1.18-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M205.69,151.95c.03.68-.35,1.17-.99,1.27.64-.1,1.02-.59.99-1.27h0Z"
              />
              <path
                className="cls-107"
                d="M211.58,146.59c.08,1.12-1.01,1.63-1.7,1.04-.32-.28-.38-.62-.4-.77.18,1.11,1.36,1.33,1.89.58.25-.35.22-.7.21-.85h0Z"
              />
              <path
                className="cls-107"
                d="M207.37,147.11c.07,1.13-1.04,1.62-1.73,1.02-.32-.28-.37-.63-.39-.78.17,1.11,1.35,1.34,1.9.61.25-.34.23-.7.22-.85h0Z"
              />
            </g>
            <g className="cls-317">
              <path
                className="cls-107"
                d="M212.9,160.46c.08.67.53,1.07,1.16,1.02-.62.05-1.08-.35-1.16-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M206.39,161.24c0,.69-.39,1.18-1.04,1.28.65-.1,1.05-.59,1.04-1.28h0Z"
              />
              <path
                className="cls-107"
                d="M212.54,155.82c.05,1.13-1.08,1.64-1.76,1.05-.32-.28-.36-.63-.38-.78.15,1.12,1.34,1.34,1.9.59.26-.35.25-.71.24-.86h0Z"
              />
              <path
                className="cls-107"
                d="M208.24,156.35c.04,1.14-1.11,1.63-1.79,1.03-.31-.28-.36-.63-.38-.78.14,1.12,1.34,1.35,1.91.61.27-.35.26-.7.25-.85h0Z"
              />
            </g>
            <g className="cls-278">
              <path
                className="cls-107"
                d="M212.4,173.42c-.63.11-1.05.62-1.07,1.3.73-.09,1.46-.18,2.19-.28-.06-.85-.7-1.08-1.12-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M208,173.94c-.65.11-1.06.6-1.09,1.29.74-.08,1.47-.16,2.21-.25-.06-.85-.7-1.09-1.12-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M214.44,168.47c-1.11.21-1.36,1.61-.61,2.16.28.21.56.19.7.18-.02-.78-.05-1.55-.08-2.33h0Z"
              />
              <path
                className="cls-107"
                d="M210.07,169.02c-1.12.19-1.38,1.59-.63,2.15.77.57,1.89-.21,1.76-1.23-.08-.58-.57-.98-1.13-.92h0Z"
              />
              <path
                className="cls-107"
                d="M205.66,169.52c.03.78.05,1.56.07,2.33,1.15-.18,1.41-1.58.65-2.14-.29-.21-.58-.2-.72-.19h0Z"
              />
              <path
                className="cls-107"
                d="M213.19,165.12c-.72.09-1.45.19-2.17.27.11,1.13,1.31,1.34,1.9.59.28-.35.27-.71.27-.86h0Z"
              />
              <path
                className="cls-107"
                d="M208.83,165.66c-.73.08-1.46.17-2.19.25.1,1.13,1.31,1.36,1.91.61.28-.35.28-.71.28-.86h0Z"
              />
            </g>
            <g className="cls-285">
              <path
                className="cls-107"
                d="M212.44,182.74c-.63.11-1.07.62-1.11,1.28.73-.09,1.46-.18,2.19-.28-.02-.84-.66-1.06-1.08-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M208.04,183.26c-.65.11-1.08.59-1.12,1.27.74-.08,1.48-.16,2.21-.25-.03-.83-.66-1.07-1.09-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M214.65,177.81c-1.12.21-1.42,1.61-.69,2.16.28.21.56.19.69.18,0-.25,0-.51,0-.76,0-.52,0-1.05,0-1.57h0Z"
              />
              <path
                className="cls-107"
                d="M210.27,178.36c-1.13.19-1.43,1.59-.7,2.15.75.57,1.89-.21,1.8-1.23-.06-.59-.53-.98-1.1-.91h0Z"
              />
              <path
                className="cls-107"
                d="M205.83,178.86c0,.52,0,1.05,0,1.57,0,.25,0,.51,0,.76,1.16-.18,1.47-1.58.71-2.14-.28-.21-.57-.2-.71-.19h0Z"
              />
              <path
                className="cls-107"
                d="M213.52,174.45c-.73.09-1.46.19-2.19.28.07,1.14,1.27,1.36,1.89.6.29-.36.3-.72.3-.87h0Z"
              />
              <path
                className="cls-107"
                d="M209.13,174.98c-.74.09-1.47.17-2.21.25.07,1.16,1.26,1.39,1.9.62.3-.35.31-.72.31-.87h0Z"
              />
            </g>
            <g className="cls-280">
              <path
                className="cls-107"
                d="M212.15,191.75c-.63.11-1.08.6-1.15,1.23.73-.09,1.45-.18,2.18-.27,0-.8-.61-1.01-1.03-.96h0Z"
              />
              <path
                className="cls-107"
                d="M214.52,187.01c-1.12.21-1.47,1.55-.77,2.07.27.2.55.18.68.16.03-.74.06-1.49.09-2.24h0Z"
              />
              <path
                className="cls-107"
                d="M210.14,187.57c-1.13.19-1.48,1.54-.77,2.06.78.58,1.98-.28,1.81-1.3-.09-.5-.52-.83-1.05-.76h0Z"
              />
              <path
                className="cls-107"
                d="M213.52,183.74c-.73.09-1.46.19-2.19.28.03,1.1,1.21,1.31,1.86.57.3-.34.32-.7.33-.85h0Z"
              />
              <path
                className="cls-107"
                d="M209.13,184.28c-.74.09-1.47.17-2.21.25.04,1.2,1.26,1.28,1.87.6.31-.34.33-.7.34-.85h0Z"
              />
            </g>
            <g className="cls-282">
              <path
                className="cls-107"
                d="M207.22,200.86c-.64.1-1.09.55-1.17,1.16.72-.08,1.45-.16,2.17-.24.03-.76-.58-.97-.99-.92h0Z"
              />
              <path
                className="cls-107"
                d="M214.05,195.82c-1.11.2-1.5,1.49-.83,1.98.26.19.53.16.66.15.06-.71.12-1.42.17-2.14h0Z"
              />
              <path
                className="cls-107"
                d="M210.6,196.75c.04.14.08.25.13.38-.02-.15-.05-.26-.13-.38h0Z"
              />
              <path
                className="cls-107"
                d="M205.33,196.86c-.04.72-.09,1.43-.14,2.13,1.15-.18,1.53-1.46.83-1.96-.27-.19-.55-.18-.69-.17h0Z"
              />
              <path
                className="cls-107"
                d="M213.18,192.7c-.72.09-1.45.19-2.18.27,0,1.05,1.15,1.25,1.82.54.31-.33.35-.67.36-.81h0Z"
              />
            </g>
            <g className="cls-281">
              <path
                className="cls-107"
                d="M210.64,208.51c-.61.11-1.08.55-1.19,1.12.7-.09,1.41-.17,2.11-.27.06-.72-.51-.9-.92-.85h0Z"
              />
              <path
                className="cls-107"
                d="M206.4,209.02c-.63.1-1.08.52-1.19,1.1.71-.08,1.42-.16,2.13-.24.05-.72-.53-.91-.94-.87h0Z"
              />
              <path
                className="cls-107"
                d="M213.26,204.21c-1.1.2-1.53,1.43-.89,1.89.24.18.51.15.64.14.09-.67.17-1.35.25-2.04h0Z"
              />
              <path
                className="cls-107"
                d="M208.99,204.74c-1.11.18-1.53,1.41-.88,1.88.71.52,1.93-.27,1.84-1.19-.05-.46-.45-.75-.96-.69h0Z"
              />
              <path
                className="cls-107"
                d="M204.68,205.23c-.07.68-.13,1.36-.21,2.03,1.12-.17,1.54-1.39.88-1.87-.25-.18-.54-.17-.67-.16h0Z"
              />
              <path
                className="cls-107"
                d="M208.22,201.78c-.72.08-1.44.16-2.17.24-.03,1.02,1.09,1.21,1.78.53.32-.32.36-.63.38-.77h0Z"
              />
            </g>
            <g className="cls-279">
              <path
                className="cls-107"
                d="M209.44,216.23c-.61.1-1.07.51-1.2,1.06.69-.08,1.37-.17,2.05-.26.1-.73-.52-.84-.86-.8h0Z"
              />
              <path
                className="cls-107"
                d="M205.31,216.72c-.61.1-1.07.5-1.19,1.04.69-.08,1.38-.15,2.07-.23.08-.68-.48-.85-.88-.81h0Z"
              />
              <path
                className="cls-107"
                d="M212.16,212.15c-1.07.19-1.54,1.35-.94,1.79.23.17.49.14.62.13.11-.64.22-1.28.32-1.92h0Z"
              />
              <path
                className="cls-107"
                d="M207.99,212.68c-1.08.18-1.54,1.33-.92,1.78.69.5,1.99-.37,1.82-1.22-.07-.38-.44-.61-.9-.55h0Z"
              />
              <path
                className="cls-107"
                d="M203.77,213.16c-.09.64-.18,1.28-.27,1.92,1.1-.17,1.55-1.32.92-1.77-.24-.17-.52-.16-.65-.15h0Z"
              />
              <path
                className="cls-107"
                d="M211.56,209.37c-.7.09-1.4.18-2.11.27-.07.9.93,1.1,1.62.54.39-.32.46-.69.49-.81h0Z"
              />
              <path
                className="cls-107"
                d="M207.34,209.89c-.71.08-1.42.16-2.13.24-.07.96,1.03,1.14,1.72.49.32-.3.38-.6.4-.73h0Z"
              />
            </g>
            <g className="cls-284">
              <path
                className="cls-107"
                d="M203.46,221.49c-.09.29-.43.8-1.17.91.11-.59.22-1.19.33-1.79.73-.05.98.42.85.88h0Z"
              />
              <path
                className="cls-107"
                d="M210.28,217.12c-.25.86-1.55,1.3-1.95.66-.12-.19-.1-.37-.08-.49.69-.08,1.37-.17,2.05-.26,0,.03-.01.07-.02.09h0Z"
              />
              <path
                className="cls-107"
                d="M206.17,217.62c-.24.86-1.54,1.28-1.96.63-.12-.19-.1-.38-.09-.5.69-.08,1.38-.15,2.07-.23,0,.03-.01.07-.02.09h0Z"
              />
            </g>
            <g className="cls-287">
              <path
                className="cls-107"
                d="M201.21,231.57c.15-.47.6-.82,1.18-.91.56-.04.85.23.75.69-.64.07-1.28.15-1.92.22h0Z"
              />
              <path
                className="cls-107"
                d="M202,228.39c-.09.27-.44.74-1.16.85.13-.55.26-1.1.38-1.66.71-.05.93.39.78.81h0Z"
              />
            </g>
            <g className="cls-286">
              <path
                className="cls-107"
                d="M203.11,231.44c-.31.8-1.61,1.14-1.88.5-.06-.14-.03-.28-.01-.37.64-.07,1.28-.14,1.92-.22,0,.02-.02.06-.03.08h0Z"
              />
            </g>
            <g className="cls-283">
              <path
                className="cls-107"
                d="M194.04,103.85c-.11-.59.14-1.03.62-1.11.51-.02.94.34,1.11.94-.58.06-1.15.12-1.73.17h0Z"
              />
            </g>
            <g className="cls-338">
              <path
                className="cls-107"
                d="M196.52,111.06c-.52.08-.79.53-.7,1.15.61-.06,1.22-.12,1.84-.18-.2-.77-.79-1-1.14-.96h0Z"
              />
              <path
                className="cls-107"
                d="M192.86,111.4c-.53.08-.81.51-.73,1.14.62-.05,1.23-.1,1.85-.16-.18-.77-.77-1.01-1.12-.98h0Z"
              />
              <path
                className="cls-107"
                d="M197.39,106.69c-.9.15-.86,1.39-.14,1.9.28.2.51.19.62.18-.16-.7-.32-1.39-.48-2.08h0Z"
              />
              <path
                className="cls-107"
                d="M193.84,107.04c-.14.01-.23.06-.23.06-.1.1-.17.23-.27.33q-.17.17-.19.31c-.07.5.17.92.42,1.13.63.55,1.43.17,1.4-.67-.02-.59-.51-1.21-1.14-1.17h0Z"
              />
              <path
                className="cls-107"
                d="M190.28,107.35c.13.69.25,1.39.38,2.09.92-.13.95-1.38.23-1.9-.27-.2-.5-.19-.61-.19h0Z"
              />
              <path
                className="cls-107"
                d="M195.77,103.68c-.58.06-1.15.12-1.73.17.27,1,1.29,1.23,1.65.58.17-.3.1-.62.08-.75h0Z"
              />
            </g>
            <g className="cls-341">
              <path
                className="cls-107"
                d="M198.19,119.63c-.55.09-.85.55-.77,1.18.64-.06,1.29-.13,1.93-.19-.18-.79-.79-1.03-1.16-.99h0Z"
              />
              <path
                className="cls-107"
                d="M194.34,119.99c-.56.08-.87.53-.8,1.17.65-.05,1.3-.11,1.94-.17-.16-.79-.77-1.04-1.14-1h0Z"
              />
              <path
                className="cls-107"
                d="M199.25,115.12c-.95.16-.96,1.44-.21,1.96.28.2.53.19.65.18-.14-.72-.29-1.43-.43-2.15h0Z"
              />
              <path
                className="cls-107"
                d="M195.5,115.5c-.96.15-.99,1.43-.26,1.96.72.52,1.57-.07,1.4-.97-.11-.59-.62-1.03-1.14-.98h0Z"
              />
              <path
                className="cls-107"
                d="M191.74,115.82c.11.72.23,1.43.34,2.16.98-.14,1.04-1.42.3-1.96-.28-.2-.52-.2-.64-.19h0Z"
              />
              <path
                className="cls-107"
                d="M197.66,112.02c-.61.06-1.22.12-1.84.18.25,1.03,1.32,1.27,1.73.6.19-.31.13-.64.11-.78h0Z"
              />
              <path
                className="cls-107"
                d="M193.98,112.37c-.61.06-1.23.11-1.85.16.23,1.03,1.29,1.28,1.72.62.2-.31.15-.64.13-.78h0Z"
              />
            </g>
            <g className="cls-342">
              <path
                className="cls-107"
                d="M199.65,128.43c-.57.09-.9.57-.84,1.21.67-.06,1.34-.13,2.01-.2-.16-.81-.79-1.05-1.17-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M195.63,128.8c-.59.08-.92.54-.86,1.2.68-.06,1.35-.12,2.02-.18-.15-.81-.78-1.06-1.16-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M200.9,123.8c-1,.16-1.05,1.49-.29,2.02.29.21.55.19.67.19-.12-.74-.25-1.48-.38-2.21h0Z"
              />
              <path
                className="cls-107"
                d="M196.98,124.19c-1.01.15-1.08,1.47-.33,2.02.73.53,1.64-.08,1.49-1-.1-.61-.62-1.07-1.16-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M193.03,124.53c.1.74.2,1.48.3,2.22,1.02-.14,1.11-1.46.37-2.02-.28-.21-.54-.21-.66-.2h0Z"
              />
              <path
                className="cls-107"
                d="M199.34,120.62c-.64.07-1.28.13-1.93.19.23,1.06,1.34,1.3,1.79.61.21-.32.16-.66.14-.8h0Z"
              />
              <path
                className="cls-107"
                d="M195.48,120.99c-.65.06-1.29.11-1.94.17.21,1.06,1.31,1.31,1.78.63.22-.32.18-.65.16-.8h0Z"
              />
            </g>
            <g className="cls-343">
              <path
                className="cls-107"
                d="M200.9,137.41c-.6.09-.95.57-.9,1.23.69-.07,1.39-.14,2.08-.21-.15-.89-.84-1.06-1.18-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M196.74,137.79c-.61.09-.96.55-.92,1.22.7-.06,1.4-.12,2.09-.18-.13-.83-.77-1.08-1.17-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M202.34,132.68c-1.04.17-1.13,1.52-.36,2.07.29.21.56.2.69.19-.11-.75-.21-1.51-.32-2.26h0Z"
              />
              <path
                className="cls-107"
                d="M198.26,133.09c-1.04.16-1.16,1.5-.4,2.06.74.54,1.7-.08,1.57-1.03-.08-.62-.61-1.08-1.17-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M194.16,133.44c.09.75.17,1.51.25,2.26,1.06-.15,1.19-1.49.43-2.06-.29-.21-.56-.21-.68-.2h0Z"
              />
              <path
                className="cls-107"
                d="M200.82,129.44c-.67.07-1.34.14-2.01.2.21,1.09,1.35,1.33,1.84.62.23-.33.19-.67.17-.82h0Z"
              />
              <path
                className="cls-107"
                d="M196.79,129.82c-.67.06-1.35.12-2.02.18.19,1.08,1.33,1.34,1.83.64.24-.33.2-.67.19-.81h0Z"
              />
            </g>
            <g className="cls-345">
              <path
                className="cls-107"
                d="M202.62,142.98c.11.67.56,1.06,1.18,1.03-.62.03-1.08-.36-1.18-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M196.27,143.58c.03.68-.34,1.15-.96,1.23.63-.08.99-.56.96-1.23h0Z"
              />
              <path
                className="cls-107"
                d="M202.08,138.43c.09,1.11-1,1.58-1.68.98-.32-.28-.38-.62-.4-.77.18,1.11,1.36,1.35,1.88.62.24-.33.21-.68.2-.83h0Z"
              />
              <path
                className="cls-107"
                d="M197.91,138.84c.07,1.12-1.03,1.57-1.71.96-.31-.28-.37-.63-.39-.78.17,1.1,1.34,1.36,1.88.65.25-.33.23-.68.22-.83h0Z"
              />
            </g>
            <g className="cls-347">
              <path
                className="cls-107"
                d="M203.53,152.24v-.06s0,.04,0,.06h0Z"
              />
              <path
                className="cls-107"
                d="M203.54,152.3s0-.04,0-.06c0,.02,0,.04,0,.06h0Z"
              />
              <path
                className="cls-107"
                d="M203.56,152.36s0-.04-.01-.06c0,.02,0,.04.01.06h0Z"
              />
              <path
                className="cls-107"
                d="M203.57,152.42s-.01-.04-.01-.06c0,.02.01.04.01.06h0Z"
              />
              <path
                className="cls-107"
                d="M203.59,152.47s-.01-.04-.02-.05c0,.02.01.04.02.06h0Z"
              />
              <path
                className="cls-107"
                d="M203.61,152.52s-.01-.04-.02-.05c0,.02.01.04.02.05h0Z"
              />
              <path
                className="cls-107"
                d="M203.63,152.58s-.02-.04-.02-.05c0,.02.01.04.02.05h0Z"
              />
              <path
                className="cls-107"
                d="M203.65,152.63s-.02-.04-.02-.05c0,.02.02.04.02.05h0Z"
              />
              <path className="cls-107" d="M203.68,152.68l-.03-.05.03.05h0Z" />
              <path
                className="cls-107"
                d="M203.71,152.72s-.02-.03-.03-.05c0,.01.02.03.03.05h0Z"
              />
              <path
                className="cls-107"
                d="M203.74,152.77s-.02-.03-.03-.05c0,.01.02.03.03.05h0Z"
              />
              <path
                className="cls-107"
                d="M203.77,152.81s-.02-.03-.03-.04c0,.01.02.03.03.04h0Z"
              />
              <path
                className="cls-107"
                d="M203.8,152.86s-.02-.03-.03-.04c.01.01.02.03.03.04h0Z"
              />
              <path
                className="cls-107"
                d="M203.84,152.9s-.03-.03-.04-.04c.01.01.02.03.04.04h0Z"
              />
              <path
                className="cls-107"
                d="M203.87,152.93s-.03-.03-.04-.04c.01.01.03.03.04.04h0Z"
              />
              <path
                className="cls-107"
                d="M203.91,152.97s-.03-.03-.04-.04c.01.01.03.03.04.04h0Z"
              />
              <path
                className="cls-107"
                d="M203.95,153s-.03-.02-.04-.03c.01.01.03.02.04.03h0Z"
              />
              <path
                className="cls-107"
                d="M204,153.04s-.03-.02-.04-.03c.01,0,.03.02.04.03h0Z"
              />
              <path
                className="cls-107"
                d="M204.04,153.07s-.03-.02-.04-.03c.01,0,.03.02.04.03h0Z"
              />
              <path
                className="cls-107"
                d="M204.09,153.09s-.03-.02-.05-.03c.01,0,.03.02.05.03h0Z"
              />
              <path
                className="cls-107"
                d="M204.13,153.12s-.03-.02-.05-.03c.01,0,.03.02.05.03h0Z"
              />
              <path
                className="cls-107"
                d="M204.18,153.14s-.03-.02-.05-.02c.01,0,.03.02.05.02h0Z"
              />
              <path
                className="cls-107"
                d="M204.23,153.16s-.03-.01-.05-.02c.01,0,.03.01.05.02h0Z"
              />
              <path
                className="cls-107"
                d="M204.28,153.18s-.03-.01-.05-.02c.01,0,.03.01.05.02h0Z"
              />
              <path
                className="cls-107"
                d="M204.33,153.2s-.04-.01-.05-.02c.02,0,.04.01.05.02h0Z"
              />
              <path
                className="cls-107"
                d="M204.38,153.21s-.04,0-.05-.01c.02,0,.04,0,.05.01h0Z"
              />
              <path
                className="cls-107"
                d="M204.43,153.22s-.04,0-.05-.01c.02,0,.04,0,.05.01h0Z"
              />
              <path
                className="cls-107"
                d="M204.49,153.23s-.04,0-.05,0c.02,0,.04,0,.05,0h0Z"
              />
              <path
                className="cls-107"
                d="M204.54,153.23s-.04,0-.05,0c.02,0,.04,0,.05,0h0Z"
              />
              <path
                className="cls-107"
                d="M204.59,153.23s-.04,0-.05,0c.02,0,.04,0,.05,0h0Z"
              />
              <path
                className="cls-107"
                d="M204.65,153.23s-.04,0-.06,0c.02,0,.04,0,.06,0h0Z"
              />
              <path
                className="cls-107"
                d="M204.65,153.23h.06s-.04,0-.06,0h0Z"
              />
              <path
                className="cls-107"
                d="M200.98,147.91l-.02-.12s.01.08.02.12h0Z"
              />
              <path
                className="cls-107"
                d="M201.01,148.02s-.02-.08-.03-.11c0,.03.02.08.03.11h0Z"
              />
              <path
                className="cls-107"
                d="M201.05,148.12s-.03-.08-.04-.11c.01.03.03.08.04.11h0Z"
              />
              <path
                className="cls-107"
                d="M201.09,148.23s-.03-.07-.05-.1c.01.03.03.07.05.1h0Z"
              />
              <path
                className="cls-107"
                d="M201.15,148.32s-.04-.07-.05-.1c.02.03.04.07.05.1h0Z"
              />
              <path
                className="cls-107"
                d="M201.21,148.41s-.04-.06-.06-.09c.02.03.04.06.06.09h0Z"
              />
              <path
                className="cls-107"
                d="M201.28,148.49s-.05-.06-.07-.08c.02.02.05.06.07.08h0Z"
              />
              <path
                className="cls-107"
                d="M201.36,148.57s-.05-.05-.08-.08c.02.02.05.05.08.08h0Z"
              />
              <path
                className="cls-107"
                d="M201.44,148.64s-.06-.05-.08-.07c.02.02.06.05.08.07h0Z"
              />
              <path
                className="cls-107"
                d="M201.53,148.7s-.06-.04-.09-.06c.03.02.06.04.09.06h0Z"
              />
              <path
                className="cls-107"
                d="M201.62,148.74s-.07-.03-.09-.05c.03.01.07.03.09.05h0Z"
              />
              <path
                className="cls-107"
                d="M201.72,148.78s-.07-.03-.1-.04c.03.01.07.03.1.04h0Z"
              />
              <path
                className="cls-107"
                d="M201.82,148.81s-.07-.02-.1-.03c.03,0,.07.02.1.03h0Z"
              />
              <path
                className="cls-107"
                d="M201.93,148.83s-.07-.01-.11-.02c.03,0,.07.01.11.02h0Z"
              />
              <path
                className="cls-107"
                d="M202.04,148.84s-.08,0-.11,0c.03,0,.08,0,.11,0h0Z"
              />
              <path
                className="cls-107"
                d="M202.15,148.83s-.08,0-.11,0c.03,0,.08,0,.11,0h0Z"
              />
              <path
                className="cls-107"
                d="M202.26,148.82s-.08.01-.11.02c.03,0,.08-.01.11-.02h0Z"
              />
              <path
                className="cls-107"
                d="M202.36,148.79s-.07.02-.11.03c.03,0,.07-.02.11-.03h0Z"
              />
              <path
                className="cls-107"
                d="M202.46,148.75s-.07.03-.1.04c.03-.01.07-.03.1-.04h0Z"
              />
              <path
                className="cls-107"
                d="M202.56,148.7s-.07.03-.1.05c.03-.01.07-.03.1-.05h0Z"
              />
              <path
                className="cls-107"
                d="M202.65,148.64s-.06.04-.09.06c.03-.02.06-.04.09-.06h0Z"
              />
              <path
                className="cls-107"
                d="M202.73,148.58s-.06.05-.08.07c.02-.02.06-.05.08-.07h0Z"
              />
              <path
                className="cls-107"
                d="M202.8,148.5s-.05.05-.08.07c.02-.02.05-.05.08-.07h0Z"
              />
              <path
                className="cls-107"
                d="M202.87,148.42s-.05.06-.07.08c.02-.02.05-.06.07-.08h0Z"
              />
              <path
                className="cls-107"
                d="M202.93,148.33s-.04.06-.06.09c.02-.03.04-.06.06-.09h0Z"
              />
              <path
                className="cls-107"
                d="M202.99,148.24s-.04.07-.05.09c.02-.03.04-.07.05-.09h0Z"
              />
              <path
                className="cls-107"
                d="M203.03,148.14s-.03.07-.04.1c.01-.03.03-.07.04-.1h0Z"
              />
              <path
                className="cls-107"
                d="M203.07,148.03s-.02.07-.03.1c.01-.03.02-.07.03-.1h0Z"
              />
              <path
                className="cls-107"
                d="M203.09,147.92s-.02.08-.03.11c0-.03.02-.08.03-.11h0Z"
              />
              <path
                className="cls-107"
                d="M203.11,147.81s-.01.08-.02.11c0-.03.01-.08.02-.11h0Z"
              />
              <path
                className="cls-107"
                d="M203.11,147.69s0,.08,0,.12c0-.07,0-.16,0-.23,0,.04,0,.08,0,.12h0Z"
              />
              <path
                className="cls-107"
                d="M196.68,148.29l-.02-.12s.01.08.02.12h0Z"
              />
              <path
                className="cls-107"
                d="M196.71,148.4s-.02-.08-.03-.11c0,.03.02.08.03.11h0Z"
              />
              <path
                className="cls-107"
                d="M196.75,148.51s-.02-.08-.04-.11c.01.03.02.08.04.11h0Z"
              />
              <path
                className="cls-107"
                d="M196.79,148.61s-.03-.07-.04-.1c.01.03.03.07.04.1h0Z"
              />
              <path
                className="cls-107"
                d="M196.84,148.71s-.04-.07-.05-.1c.02.03.04.07.05.1h0Z"
              />
              <path
                className="cls-107"
                d="M196.9,148.8s-.04-.06-.06-.09c.02.03.04.06.06.09h0Z"
              />
              <path
                className="cls-107"
                d="M196.97,148.88s-.05-.06-.07-.08c.02.02.05.06.07.08h0Z"
              />
              <path className="cls-107" d="M197.05,148.96l-.08-.08.08.08h0Z" />
              <path
                className="cls-107"
                d="M197.13,149.03s-.06-.05-.08-.07c.02.02.06.05.08.07h0Z"
              />
              <path
                className="cls-107"
                d="M197.22,149.09s-.06-.04-.09-.06c.03.02.06.04.09.06h0Z"
              />
              <path
                className="cls-107"
                d="M197.31,149.14s-.07-.04-.09-.05c.03.02.07.04.09.05h0Z"
              />
              <path
                className="cls-107"
                d="M197.41,149.18s-.07-.03-.1-.04c.03.01.07.03.1.04h0Z"
              />
              <path
                className="cls-107"
                d="M197.51,149.21s-.07-.02-.1-.03c.03,0,.07.02.1.03h0Z"
              />
              <path
                className="cls-107"
                d="M197.62,149.23s-.07-.01-.11-.02c.03,0,.07.01.11.02h0Z"
              />
              <path
                className="cls-107"
                d="M197.73,149.24s-.08,0-.11,0c.03,0,.08,0,.11,0h0Z"
              />
              <path
                className="cls-107"
                d="M197.84,149.23s-.08,0-.11,0c.03,0,.08,0,.11,0h0Z"
              />
              <path
                className="cls-107"
                d="M197.95,149.22s-.08.01-.11.02c.03,0,.08-.01.11-.02h0Z"
              />
              <path
                className="cls-107"
                d="M198.06,149.19s-.07.02-.11.03c.03,0,.07-.02.11-.03h0Z"
              />
              <path
                className="cls-107"
                d="M198.16,149.15s-.07.03-.1.04c.03-.01.07-.03.1-.04h0Z"
              />
              <path
                className="cls-107"
                d="M198.25,149.11s-.07.03-.1.05c.03-.01.07-.03.1-.05h0Z"
              />
              <path
                className="cls-107"
                d="M198.34,149.05s-.06.04-.09.06c.03-.02.06-.04.09-.06h0Z"
              />
              <path
                className="cls-107"
                d="M198.43,148.98s-.06.05-.08.07c.03-.02.06-.05.08-.07h0Z"
              />
              <path
                className="cls-107"
                d="M198.51,148.91s-.05.05-.08.07c.02-.02.05-.05.08-.07h0Z"
              />
              <path
                className="cls-107"
                d="M198.58,148.83s-.05.06-.07.08c.02-.02.05-.06.07-.08h0Z"
              />
              <path
                className="cls-107"
                d="M198.64,148.74s-.04.06-.06.09c.02-.03.04-.06.06-.09h0Z"
              />
              <path
                className="cls-107"
                d="M198.69,148.65s-.04.07-.05.09c.02-.03.04-.07.05-.09h0Z"
              />
              <path
                className="cls-107"
                d="M198.74,148.55s-.03.07-.05.1c.01-.03.03-.07.05-.1h0Z"
              />
              <path
                className="cls-107"
                d="M198.78,148.44s-.03.07-.04.1c.01-.03.03-.07.04-.1h0Z"
              />
              <path
                className="cls-107"
                d="M198.8,148.33s-.02.08-.03.11c0-.03.02-.08.03-.11h0Z"
              />
              <path
                className="cls-107"
                d="M198.82,148.22s-.01.08-.02.11c0-.03.01-.08.02-.11h0Z"
              />
              <path
                className="cls-107"
                d="M198.83,148.11s0,.08,0,.12c0-.07,0-.16,0-.23,0,.04,0,.08,0,.12h0Z"
              />
            </g>
            <g className="cls-340">
              <path
                className="cls-107"
                d="M204.19,161.47c.07.67.53,1.08,1.16,1.05-.64.03-1.09-.38-1.16-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M197.57,162.08c0,.68-.42,1.17-1.06,1.26.64-.09,1.06-.58,1.06-1.26h0Z"
              />
              <path
                className="cls-107"
                d="M203.89,156.82c.03,1.14-1.13,1.62-1.81,1-.32-.29-.36-.64-.38-.79.13,1.13,1.34,1.37,1.92.63.27-.34.26-.7.26-.85h0Z"
              />
              <path
                className="cls-107"
                d="M199.52,157.24c.02,1.14-1.15,1.61-1.83.98-.31-.29-.35-.64-.37-.79.12,1.12,1.33,1.38,1.92.66.28-.34.27-.7.27-.85h0Z"
              />
            </g>
            <g className="cls-344">
              <path
                className="cls-107"
                d="M203.56,174.41c-.64.1-1.07.6-1.1,1.28.74-.07,1.49-.15,2.23-.22-.05-.85-.71-1.1-1.13-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M199.09,174.83c-.66.09-1.08.57-1.11,1.26.75-.06,1.5-.13,2.24-.19-.05-.85-.71-1.1-1.14-1.07h0Z"
              />
              <path
                className="cls-107"
                d="M205.66,169.52c-1.13.18-1.39,1.58-.64,2.14.29.22.57.2.71.19-.02-.78-.04-1.56-.07-2.33h0Z"
              />
              <path
                className="cls-107"
                d="M201.22,169.96c-1.14.17-1.41,1.56-.65,2.13.78.59,1.92-.16,1.79-1.19-.07-.58-.57-1-1.14-.94h0Z"
              />
              <path
                className="cls-107"
                d="M204.42,166.14c-.74.08-1.47.15-2.21.22.1,1.13,1.31,1.38,1.93.64.28-.35.29-.7.29-.86h0Z"
              />
              <path
                className="cls-107"
                d="M199.99,166.56c-.74.07-1.48.13-2.23.19.09,1.13,1.31,1.39,1.93.66.29-.34.29-.7.3-.85h0Z"
              />
            </g>
            <g className="cls-346">
              <path
                className="cls-107"
                d="M203.59,183.73c-.64.1-1.09.59-1.13,1.26.74-.07,1.49-.15,2.23-.22-.03-.84-.67-1.08-1.1-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M199.11,184.15c-.66.09-1.09.57-1.14,1.24.75-.06,1.5-.13,2.24-.19-.03-.84-.68-1.08-1.11-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M205.83,178.86c-1.14.18-1.44,1.57-.71,2.14.28.21.57.2.7.19,0-.25,0-.51,0-.76,0-.52,0-1.05,0-1.57h0Z"
              />
              <path
                className="cls-107"
                d="M201.37,179.31c-1.15.17-1.46,1.56-.71,2.13.76.59,1.92-.17,1.82-1.19-.06-.59-.54-.99-1.11-.94h0Z"
              />
              <path
                className="cls-107"
                d="M196.88,179.7c0,.52,0,1.05,0,1.57,0,.25,0,.51,0,.76,1.17-.16,1.47-1.54.72-2.12-.28-.22-.58-.21-.72-.21h0Z"
              />
              <path
                className="cls-107"
                d="M204.69,175.47c-.74.08-1.48.15-2.23.22.07,1.14,1.28,1.39,1.92.64.3-.35.31-.71.31-.87h0Z"
              />
              <path
                className="cls-107"
                d="M200.23,175.9c-.75.07-1.49.13-2.24.19.07,1.16,1.27,1.42,1.92.67.3-.35.31-.71.32-.86h0Z"
              />
            </g>
            <g className="cls-339">
              <path
                className="cls-107"
                d="M203.35,192.74c-.64.1-1.1.57-1.16,1.2.74-.07,1.48-.14,2.21-.22,0-.8-.63-1.03-1.06-.98h0Z"
              />
              <path
                className="cls-107"
                d="M198.9,193.15c-.66.09-1.1.55-1.16,1.19.74-.06,1.49-.13,2.23-.19,0-.8-.64-1.03-1.07-1h0Z"
              />
              <path
                className="cls-107"
                d="M201.27,188.51c-1.15.16-1.49,1.5-.76,2.05.8.6,2.01-.23,1.83-1.26-.09-.51-.54-.84-1.07-.79h0Z"
              />
              <path
                className="cls-107"
                d="M196.79,188.89c-.02.75-.04,1.49-.06,2.24,1.16-.15,1.5-1.48.76-2.04-.28-.21-.57-.2-.71-.2h0Z"
              />
              <path
                className="cls-107"
                d="M204.68,184.77c-.74.08-1.48.15-2.23.22.04,1.1,1.24,1.34,1.89.62.3-.34.33-.69.34-.84h0Z"
              />
              <path
                className="cls-107"
                d="M200.22,185.2c-.75.07-1.49.13-2.24.19.04,1.2,1.29,1.31,1.9.64.31-.33.33-.69.34-.84h0Z"
              />
            </g>
            <g className="cls-328">
              <path
                className="cls-107"
                d="M202.85,201.33c-.63.09-1.09.54-1.17,1.15.73-.07,1.46-.14,2.19-.22.02-.76-.59-.97-1.01-.93h0Z"
              />
              <path
                className="cls-107"
                d="M198.46,201.73c-.65.09-1.1.52-1.17,1.13.73-.06,1.47-.12,2.2-.19.01-.76-.61-.98-1.03-.94h0Z"
              />
              <path
                className="cls-107"
                d="M205.33,196.86c-1.13.17-1.51,1.45-.82,1.96.26.19.54.18.68.17.05-.71.1-1.42.14-2.13h0Z"
              />
              <path
                className="cls-107"
                d="M200.92,197.3c-1.14.16-1.51,1.43-.81,1.95.77.57,1.99-.23,1.84-1.2-.07-.48-.51-.8-1.03-.75h0Z"
              />
              <path
                className="cls-107"
                d="M196.48,197.69c-.03.71-.07,1.42-.11,2.13,1.15-.15,1.52-1.42.8-1.94-.27-.2-.56-.19-.69-.18h0Z"
              />
              <path
                className="cls-107"
                d="M204.41,193.72c-.74.08-1.47.15-2.21.22,0,1.05,1.19,1.28,1.86.59.31-.32.34-.66.36-.81h0Z"
              />
              <path
                className="cls-107"
                d="M199.97,194.15c-.74.07-1.48.13-2.23.19.01,1.07,1.19,1.3,1.87.61.32-.32.35-.66.36-.8h0Z"
              />
            </g>
            <g className="cls-332">
              <path
                className="cls-107"
                d="M202.11,209.47c-.62.09-1.09.52-1.18,1.09.72-.07,1.43-.14,2.14-.21.04-.72-.55-.92-.96-.88h0Z"
              />
              <path
                className="cls-107"
                d="M197.8,209.87c-.64.08-1.09.5-1.18,1.08.72-.06,1.44-.12,2.16-.19.03-.72-.57-.92-.98-.89h0Z"
              />
              <path
                className="cls-107"
                d="M204.68,205.23c-1.12.17-1.53,1.39-.86,1.87.25.18.53.17.66.16.07-.67.14-1.35.21-2.03h0Z"
              />
              <path
                className="cls-107"
                d="M200.34,205.66c-1.12.16-1.53,1.37-.85,1.86.74.54,1.96-.22,1.84-1.15-.06-.46-.48-.76-.99-.72h0Z"
              />
              <path
                className="cls-107"
                d="M195.97,206.04c-.05.68-.11,1.36-.16,2.03,1.12-.14,1.52-1.35.84-1.85-.26-.19-.54-.18-.68-.18h0Z"
              />
              <path
                className="cls-107"
                d="M203.86,202.26c-.73.07-1.46.15-2.19.22-.02,1,1.13,1.21,1.81.55.32-.31.36-.63.38-.76h0Z"
              />
              <path
                className="cls-107"
                d="M199.49,202.68c-.73.07-1.47.13-2.2.19-.01,1.02,1.13,1.23,1.82.57.32-.31.36-.62.38-.76h0Z"
              />
            </g>
            <g className="cls-331">
              <path
                className="cls-107"
                d="M201.13,217.16c-.62.09-1.07.48-1.18,1.03.7-.07,1.39-.14,2.09-.21.07-.73-.56-.86-.9-.82h0Z"
              />
              <path
                className="cls-107"
                d="M196.93,217.55c-.62.08-1.07.47-1.17,1.01.7-.06,1.4-.12,2.1-.18.06-.67-.52-.87-.93-.83h0Z"
              />
              <path
                className="cls-107"
                d="M203.77,213.16c-1.09.16-1.53,1.31-.9,1.77.24.17.51.16.64.15.09-.63.18-1.27.27-1.92h0Z"
              />
              <path
                className="cls-107"
                d="M199.52,213.58c-1.1.15-1.52,1.3-.88,1.76.69.49,1.92-.24,1.83-1.09-.05-.43-.44-.71-.95-.67h0Z"
              />
              <path
                className="cls-107"
                d="M195.25,213.95c-.07.64-.14,1.28-.21,1.91,1.1-.14,1.52-1.28.87-1.75-.25-.18-.52-.17-.66-.16h0Z"
              />
              <path
                className="cls-107"
                d="M203.07,210.35c-.71.07-1.43.14-2.14.21-.05.94,1.07,1.14,1.75.51.32-.29.37-.59.39-.72h0Z"
              />
              <path
                className="cls-107"
                d="M198.78,210.76c-.72.06-1.44.13-2.16.19-.04.96,1.08,1.16,1.77.53.32-.29.37-.59.39-.72h0Z"
              />
            </g>
            <g className="cls-330">
              <path
                className="cls-107"
                d="M199.92,224.37c-.6.08-1.05.45-1.18.96.67-.06,1.35-.13,2.02-.2.1-.68-.51-.8-.84-.76h0Z"
              />
              <path
                className="cls-107"
                d="M195.85,224.75c-.6.08-1.05.44-1.16.95.68-.06,1.35-.12,2.03-.18.08-.63-.48-.81-.87-.77h0Z"
              />
              <path
                className="cls-107"
                d="M202.61,220.61c-1.07.16-1.53,1.23-.94,1.65.22.16.48.14.61.13.11-.59.22-1.19.33-1.79h0Z"
              />
              <path
                className="cls-107"
                d="M198.49,221.02c-1.07.15-1.52,1.22-.91,1.64.7.49,1.96-.29,1.79-1.1-.07-.36-.44-.58-.88-.54h0Z"
              />
              <path
                className="cls-107"
                d="M194.34,221.38c-.08.6-.17,1.19-.26,1.78,1.07-.13,1.51-1.19.89-1.63-.24-.17-.5-.16-.63-.15h0Z"
              />
              <path
                className="cls-107"
                d="M202.03,217.98c-.69.07-1.39.14-2.09.21-.08.89,1,1.06,1.68.47.32-.28.38-.56.4-.68h0Z"
              />
              <path
                className="cls-107"
                d="M197.85,218.39c-.7.06-1.4.12-2.1.18-.07.9,1.01,1.09,1.7.49.32-.27.38-.56.4-.68h0Z"
              />
            </g>
            <g className="cls-335">
              <path
                className="cls-107"
                d="M198.5,231.07c-.58.08-1.02.42-1.16.9.65-.06,1.29-.13,1.94-.19.12-.63-.45-.73-.78-.7h0Z"
              />
              <path
                className="cls-107"
                d="M194.59,231.44c-.58.07-1.02.41-1.15.88.65-.05,1.3-.11,1.95-.17.09-.58-.43-.74-.8-.71h0Z"
              />
              <path
                className="cls-107"
                d="M201.22,227.58c-1.03.15-1.52,1.15-.96,1.54.21.14.46.13.58.12.13-.55.26-1.1.38-1.66h0Z"
              />
              <path
                className="cls-107"
                d="M197.25,227.97c-1.03.14-1.5,1.13-.93,1.53.66.45,1.89-.27,1.76-1.03-.06-.33-.4-.54-.83-.5h0Z"
              />
              <path
                className="cls-107"
                d="M193.24,228.32c-.1.56-.2,1.11-.3,1.65.97-.12,1.45-1.04.96-1.47-.23-.2-.53-.19-.66-.19h0Z"
              />
              <path
                className="cls-107"
                d="M200.76,225.13c-.67.07-1.34.14-2.02.2-.11.84.91,1,1.6.44.32-.26.39-.52.41-.64h0Z"
              />
              <path
                className="cls-107"
                d="M196.72,225.52c-.68.06-1.35.12-2.03.18-.09.84.94,1.01,1.62.46.32-.26.38-.52.41-.63h0Z"
              />
            </g>
            <g className="cls-333">
              <path
                className="cls-107"
                d="M193.15,237.59c-.55.07-.98.38-1.12.82.62-.05,1.24-.11,1.86-.16.11-.54-.38-.69-.73-.66h0Z"
              />
              <path
                className="cls-107"
                d="M195.81,234.41c-.98.13-1.47,1.05-.94,1.41.61.42,1.81-.25,1.72-.95-.04-.31-.36-.49-.77-.45h0Z"
              />
              <path
                className="cls-107"
                d="M191.98,234.74c-.11.51-.23,1.02-.34,1.52.93-.11,1.42-.96.97-1.35-.21-.19-.5-.18-.63-.17h0Z"
              />
              <path
                className="cls-107"
                d="M199.28,231.78c-.64.07-1.29.13-1.94.19-.13.74.76.91,1.43.45.38-.25.47-.55.5-.65h0Z"
              />
              <path
                className="cls-107"
                d="M195.4,232.15c-.65.06-1.3.11-1.95.17-.12.77.87.93,1.54.42.31-.24.38-.48.41-.58h0Z"
              />
            </g>
            <g className="cls-334">
              <path
                className="cls-107"
                d="M193.39,240.64s-.06.05-.08.07c.03-.03.06-.05.09-.08,0,0,0,0,0,0h0Z"
              />
              <path
                className="cls-107"
                d="M191.23,241.31c-.08.2-.42.61-1.07.69.13-.45.26-.92.38-1.38.69-.03.82.39.69.69h0Z"
              />
              <path
                className="cls-107"
                d="M193.86,238.32c-.29.72-1.54,1.01-1.81.42-.06-.13-.04-.26-.02-.33.62-.05,1.24-.11,1.86-.16,0,.02-.02.05-.03.07h0Z"
              />
            </g>
            <g className="cls-336">
              <path
                className="cls-107"
                d="M187.05,104.43c-.08-.6.19-1.02.69-1.09.52,0,.92.36,1.06.96-.58.05-1.17.09-1.75.13h0Z"
              />
              <path
                className="cls-107"
                d="M183.54,104.66c-.06-.6.22-1.02.72-1.08.51,0,.92.38,1.04.97-.59.04-1.17.07-1.76.11h0Z"
              />
            </g>
            <g className="cls-337">
              <path
                className="cls-107"
                d="M185.48,111.94c-.53.06-.84.5-.79,1.12.62-.04,1.24-.08,1.87-.12-.14-.78-.72-1.03-1.08-1h0Z"
              />
              <path
                className="cls-107"
                d="M190.28,107.35c-.92.13-.95,1.37-.25,1.9.27.2.51.2.62.19-.12-.7-.25-1.4-.38-2.09h0Z"
              />
              <path
                className="cls-107"
                d="M186.68,107.62c-.92.12-.98,1.36-.29,1.89.68.52,1.5-.03,1.36-.91-.09-.59-.56-1.02-1.07-.98h0Z"
              />
              <path
                className="cls-107"
                d="M183.08,107.84c.09.7.18,1.4.27,2.1.94-.11,1.02-1.35.33-1.9-.26-.2-.49-.2-.6-.2h0Z"
              />
              <path
                className="cls-107"
                d="M188.81,104.3c-.58.05-1.17.09-1.75.13.22,1.01,1.23,1.26,1.63.62.19-.29.14-.61.12-.75h0Z"
              />
              <path
                className="cls-107"
                d="M185.3,104.55c-.59.04-1.17.07-1.76.11.19,1.01,1.19,1.27,1.62.64.2-.29.16-.61.14-.75h0Z"
              />
            </g>
            <g className="cls-329">
              <path
                className="cls-107"
                d="M190.46,120.3c-.56.07-.88.53-.83,1.16.65-.05,1.3-.09,1.95-.15-.15-.8-.75-1.04-1.12-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M186.57,120.57c-.56.07-.89.52-.85,1.15.65-.04,1.31-.08,1.96-.12-.13-.8-.73-1.05-1.11-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M191.74,115.82c-.97.13-1.04,1.41-.31,1.96.28.21.53.2.65.2-.11-.72-.22-1.44-.34-2.16h0Z"
              />
              <path
                className="cls-107"
                d="M187.94,116.11c-.97.12-1.06,1.4-.35,1.95.7.54,1.58-.03,1.45-.94-.08-.6-.57-1.05-1.1-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M184.13,116.34c.08.72.16,1.44.24,2.16.99-.11,1.1-1.39.39-1.95-.27-.21-.52-.21-.63-.21h0Z"
              />
              <path
                className="cls-107"
                d="M186.55,112.95c-.62.04-1.24.08-1.87.12.18,1.04,1.23,1.31,1.7.66.21-.3.18-.63.17-.77h0Z"
              />
            </g>
            <g className="cls-355">
              <path
                className="cls-107"
                d="M191.58,129.12c-.58.08-.93.54-.89,1.19.68-.05,1.36-.1,2.04-.15-.13-.81-.76-1.07-1.15-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M187.52,129.4c-.58.07-.94.53-.91,1.18.68-.04,1.36-.08,2.04-.13-.12-.82-.74-1.08-1.13-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M193.03,124.53c-1.02.14-1.13,1.46-.38,2.02.29.21.55.21.68.2-.1-.74-.2-1.48-.3-2.22h0Z"
              />
              <path
                className="cls-107"
                d="M189.05,124.82c-1.02.13-1.15,1.45-.41,2.01.72.55,1.65-.04,1.54-.97-.07-.61-.58-1.08-1.13-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M185.07,125.07c.07.74.14,1.48.21,2.22,1.03-.12,1.17-1.43.44-2.01-.28-.22-.54-.22-.66-.22h0Z"
              />
              <path
                className="cls-107"
                d="M191.58,121.32c-.65.05-1.3.1-1.95.15.19,1.07,1.29,1.33,1.78.65.22-.32.19-.65.18-.79h0Z"
              />
              <path
                className="cls-107"
                d="M187.67,121.59c-.65.04-1.31.08-1.96.12.17,1.07,1.27,1.34,1.76.67.23-.31.21-.65.2-.79h0Z"
              />
            </g>
            <g className="cls-377">
              <path
                className="cls-107"
                d="M192.55,138.13c-.61.08-.97.54-.95,1.21.7-.05,1.4-.1,2.11-.16-.13-.89-.82-1.08-1.16-1.06h0Z"
              />
              <path
                className="cls-107"
                d="M188.34,138.42c-.62.07-.99.53-.97,1.2.71-.04,1.41-.09,2.12-.13-.11-.83-.75-1.09-1.15-1.07h0Z"
              />
              <path
                className="cls-107"
                d="M194.16,133.44c-1.06.14-1.2,1.49-.44,2.06.29.22.56.21.69.21-.08-.76-.17-1.51-.25-2.26h0Z"
              />
              <path
                className="cls-107"
                d="M190.02,133.75c-1.06.13-1.22,1.47-.47,2.05.73.56,1.71-.04,1.62-1-.06-.62-.58-1.09-1.15-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M185.88,134.01c.06.75.12,1.51.18,2.27,1.07-.12,1.25-1.46.5-2.05-.28-.22-.55-.22-.68-.22h0Z"
              />
              <path
                className="cls-107"
                d="M192.73,130.16c-.68.05-1.36.1-2.04.15.17,1.09,1.32,1.36,1.83.66.24-.32.21-.67.2-.81h0Z"
              />
              <path
                className="cls-107"
                d="M188.66,130.45c-.68.04-1.36.09-2.04.13.15,1.09,1.29,1.37,1.82.68.25-.32.23-.66.22-.81h0Z"
              />
            </g>
            <g className="cls-354">
              <path
                className="cls-107"
                d="M194.13,143.75c.09.67.54,1.08,1.18,1.06-.64.02-1.09-.39-1.18-1.06h0Z"
              />
              <path
                className="cls-107"
                d="M186.55,143.1c.05.76.1,1.53.15,2.29.63-.07,1.02-.53,1-1.21.01.68-.37,1.14-1,1.21-.05-.76-.1-1.53-.15-2.29h0Z"
              />
              <path
                className="cls-107"
                d="M193.71,139.19c.06,1.11-1.05,1.55-1.72.94-.31-.29-.36-.63-.38-.78.15,1.11,1.33,1.38,1.88.67.25-.33.24-.68.23-.83h0Z"
              />
              <path
                className="cls-107"
                d="M189.49,139.49c.04,1.11-1.08,1.54-1.74.92-.31-.29-.35-.64-.37-.79.14,1.11,1.31,1.39,1.87.69.26-.33.25-.68.25-.82h0Z"
              />
            </g>
            <g className="cls-351">
              <path
                className="cls-107"
                d="M187.21,154.64c-.04-.77-.07-1.54-.11-2.32.04.77.08,1.54.11,2.32h0Z"
              />
              <path
                className="cls-107"
                d="M187.32,154.62h-.11s.08,0,.11,0h0Z"
              />
              <path
                className="cls-107"
                d="M187.43,154.6s-.08.02-.11.02c.03,0,.08-.02.11-.02h0Z"
              />
              <path
                className="cls-107"
                d="M187.53,154.57s-.07.02-.1.03c.03-.01.07-.02.1-.03h0Z"
              />
              <path
                className="cls-107"
                d="M187.63,154.52s-.07.03-.1.04c.03-.01.07-.03.1-.04h0Z"
              />
              <path
                className="cls-107"
                d="M187.72,154.47l-.09.05s.07-.04.09-.05h0Z"
              />
              <path
                className="cls-107"
                d="M187.81,154.41s-.06.04-.09.06c.03-.02.06-.04.09-.06h0Z"
              />
              <path
                className="cls-107"
                d="M187.89,154.33s-.06.05-.08.07c.02-.02.06-.05.08-.07h0Z"
              />
              <path
                className="cls-107"
                d="M187.97,154.26s-.05.06-.07.08c.02-.02.05-.06.07-.08h0Z"
              />
              <path
                className="cls-107"
                d="M188.04,154.17s-.05.06-.07.09c.02-.03.05-.06.07-.09h0Z"
              />
              <path
                className="cls-107"
                d="M188.1,154.08s-.04.06-.06.09c.02-.03.04-.07.06-.09h0Z"
              />
              <path
                className="cls-107"
                d="M188.15,153.98s-.04.07-.05.1c.02-.03.04-.07.05-.1h0Z"
              />
              <path
                className="cls-107"
                d="M188.19,153.87s-.03.07-.04.1c.01-.03.03-.07.04-.1h0Z"
              />
              <path
                className="cls-107"
                d="M188.22,153.76s-.02.08-.03.11c0-.03.02-.08.03-.11h0Z"
              />
              <path
                className="cls-107"
                d="M188.24,153.65s-.02.08-.02.11c0-.03.02-.08.02-.11h0Z"
              />
              <path
                className="cls-107"
                d="M188.25,153.53s0,.08-.01.12c0-.07.01-.17.01-.24,0,.04,0,.08,0,.12h0Z"
              />
              <path
                className="cls-107"
                d="M192.35,148.63v-.12s0,.08,0,.12h0Z"
              />
              <path
                className="cls-107"
                d="M192.38,148.74s-.02-.08-.02-.11c0,.03.02.08.02.11h0Z"
              />
              <path
                className="cls-107"
                d="M192.41,148.85s-.02-.08-.03-.11c.01.03.02.08.03.11h0Z"
              />
              <path
                className="cls-107"
                d="M192.45,148.95s-.03-.07-.04-.1c.01.03.03.07.04.1h0Z"
              />
              <path
                className="cls-107"
                d="M192.51,149.05s-.04-.07-.05-.1c.02.03.04.07.05.1h0Z"
              />
              <path
                className="cls-107"
                d="M192.57,149.14s-.04-.06-.06-.09c.02.03.04.06.06.09h0Z"
              />
              <path
                className="cls-107"
                d="M192.64,149.22s-.05-.06-.07-.08c.02.03.05.06.07.08h0Z"
              />
              <path
                className="cls-107"
                d="M192.71,149.3s-.05-.05-.08-.08c.02.02.05.05.08.08h0Z"
              />
              <path
                className="cls-107"
                d="M192.8,149.37s-.06-.05-.08-.07c.02.02.06.05.08.07h0Z"
              />
              <path
                className="cls-107"
                d="M192.88,149.43s-.06-.04-.09-.06c.03.02.06.04.09.06h0Z"
              />
              <path
                className="cls-107"
                d="M192.98,149.48s-.07-.04-.09-.05c.03.02.07.04.09.05h0Z"
              />
              <path
                className="cls-107"
                d="M193.08,149.52s-.07-.03-.1-.04c.03.01.07.03.1.04h0Z"
              />
              <path
                className="cls-107"
                d="M193.18,149.55s-.07-.02-.1-.03c.03,0,.07.02.1.03h0Z"
              />
              <path
                className="cls-107"
                d="M193.28,149.58s-.07-.01-.11-.02c.03,0,.07.01.11.02h0Z"
              />
              <path
                className="cls-107"
                d="M193.39,149.59s-.08,0-.11,0c.03,0,.08,0,.11,0h0Z"
              />
              <path
                className="cls-107"
                d="M193.5,149.58s-.08,0-.11,0c.03,0,.08,0,.11,0h0Z"
              />
              <path
                className="cls-107"
                d="M193.62,149.57s-.08.01-.11.01c.03,0,.08-.01.11-.01h0Z"
              />
              <path
                className="cls-107"
                d="M193.72,149.54s-.08.02-.11.03c.03,0,.08-.02.11-.03h0Z"
              />
              <path
                className="cls-107"
                d="M193.83,149.51s-.07.03-.1.04c.03-.01.07-.03.1-.04h0Z"
              />
              <path
                className="cls-107"
                d="M193.92,149.46s-.07.03-.1.05c.03-.01.07-.03.1-.05h0Z"
              />
              <path
                className="cls-107"
                d="M194.01,149.4s-.06.04-.09.06c.03-.02.06-.04.09-.06h0Z"
              />
              <path
                className="cls-107"
                d="M194.1,149.34s-.06.05-.09.06c.03-.02.06-.05.09-.06h0Z"
              />
              <path
                className="cls-107"
                d="M194.18,149.27s-.05.05-.08.07c.02-.02.05-.05.08-.07h0Z"
              />
              <path
                className="cls-107"
                d="M194.25,149.19s-.05.06-.07.08c.02-.02.05-.06.07-.08h0Z"
              />
              <path
                className="cls-107"
                d="M194.31,149.1s-.04.06-.06.09c.02-.03.04-.06.06-.09h0Z"
              />
              <path
                className="cls-107"
                d="M194.37,149.01s-.04.07-.06.09c.02-.03.04-.07.06-.09h0Z"
              />
              <path
                className="cls-107"
                d="M194.41,148.91s-.03.07-.05.1c.01-.03.03-.07.05-.1h0Z"
              />
              <path
                className="cls-107"
                d="M194.45,148.8s-.03.07-.04.1c.01-.03.03-.07.04-.1h0Z"
              />
              <path
                className="cls-107"
                d="M194.48,148.69s-.02.08-.03.11c0-.03.02-.08.03-.11h0Z"
              />
              <path
                className="cls-107"
                d="M194.5,148.58s-.01.08-.02.11c0-.03.01-.08.02-.11h0Z"
              />
              <path
                className="cls-107"
                d="M194.51,148.47s0,.08,0,.12c0-.03,0-.08,0-.12h0Z"
              />
              <path
                className="cls-107"
                d="M194.51,148.47v-.12s0,.08,0,.12h0Z"
              />
              <path
                className="cls-107"
                d="M188.01,148.91v-.12s0,.08,0,.12h0Z"
              />
              <path
                className="cls-107"
                d="M188.03,149.02s-.02-.08-.02-.11c0,.03.02.08.02.11h0Z"
              />
              <path
                className="cls-107"
                d="M188.07,149.13s-.02-.08-.03-.11c.01.03.02.08.03.11h0Z"
              />
              <path
                className="cls-107"
                d="M188.11,149.24s-.03-.07-.04-.1c.01.03.03.07.04.1h0Z"
              />
              <path
                className="cls-107"
                d="M188.16,149.33s-.04-.07-.05-.1l.05.1h0Z"
              />
              <path
                className="cls-107"
                d="M188.22,149.43s-.04-.06-.06-.09c.02.03.04.06.06.09h0Z"
              />
              <path
                className="cls-107"
                d="M188.29,149.51s-.05-.06-.07-.09c.02.03.05.06.07.09h0Z"
              />
              <path
                className="cls-107"
                d="M188.36,149.59s-.05-.05-.08-.08c.02.02.05.05.08.08h0Z"
              />
              <path
                className="cls-107"
                d="M188.45,149.66s-.06-.05-.08-.07c.02.02.06.05.08.07h0Z"
              />
              <path
                className="cls-107"
                d="M188.53,149.72s-.06-.04-.09-.06c.03.02.06.04.09.06h0Z"
              />
              <path
                className="cls-107"
                d="M188.63,149.77s-.07-.04-.09-.05c.03.02.07.04.09.05h0Z"
              />
              <path
                className="cls-107"
                d="M188.73,149.82s-.07-.03-.1-.04c.03.01.07.03.1.04h0Z"
              />
              <path
                className="cls-107"
                d="M188.83,149.85s-.07-.02-.1-.03c.03,0,.07.02.1.03h0Z"
              />
              <path
                className="cls-107"
                d="M188.93,149.87s-.07-.02-.11-.02c.03,0,.07.02.11.02h0Z"
              />
              <path
                className="cls-107"
                d="M189.04,149.88s-.08,0-.11-.01c.03,0,.08,0,.11.01h0Z"
              />
              <path
                className="cls-107"
                d="M189.15,149.88s-.08,0-.11,0c.03,0,.08,0,.11,0h0Z"
              />
              <path
                className="cls-107"
                d="M189.26,149.87s-.08,0-.11.01c.03,0,.08,0,.11-.01h0Z"
              />
              <path
                className="cls-107"
                d="M189.37,149.84s-.07.02-.11.02c.03,0,.07-.02.11-.02h0Z"
              />
              <path
                className="cls-107"
                d="M189.47,149.81s-.07.02-.1.04c.03-.01.07-.02.1-.04h0Z"
              />
              <path
                className="cls-107"
                d="M189.57,149.76s-.07.03-.1.05c.03-.01.07-.03.1-.05h0Z"
              />
              <path
                className="cls-107"
                d="M189.66,149.71s-.06.04-.09.05c.03-.02.06-.04.09-.05h0Z"
              />
              <path
                className="cls-107"
                d="M189.75,149.64s-.06.04-.09.06c.03-.02.06-.04.09-.06h0Z"
              />
              <path
                className="cls-107"
                d="M189.83,149.57s-.06.05-.08.07c.02-.02.06-.05.08-.07h0Z"
              />
              <path
                className="cls-107"
                d="M189.9,149.49s-.05.06-.07.08c.02-.02.05-.06.07-.08h0Z"
              />
              <path
                className="cls-107"
                d="M189.97,149.41s-.05.06-.07.09c.02-.03.05-.06.07-.09h0Z"
              />
              <path
                className="cls-107"
                d="M190.02,149.31s-.04.07-.06.09c.02-.03.04-.06.06-.09h0Z"
              />
              <path
                className="cls-107"
                d="M190.07,149.21s-.03.07-.05.1c.01-.03.03-.07.05-.1h0Z"
              />
              <path
                className="cls-107"
                d="M190.11,149.11s-.03.07-.04.1c.01-.03.03-.07.04-.1h0Z"
              />
              <path
                className="cls-107"
                d="M190.14,149s-.02.08-.03.11c0-.03.02-.08.03-.11h0Z"
              />
              <path
                className="cls-107"
                d="M190.16,148.89s-.01.08-.02.11c0-.03.01-.08.02-.11h0Z"
              />
              <path
                className="cls-107"
                d="M190.17,148.78s0,.08,0,.12c0-.03,0-.08,0-.12h0Z"
              />
              <path
                className="cls-107"
                d="M190.17,148.78v-.12s0,.08,0,.12h0Z"
              />
            </g>
            <g className="cls-348">
              <path
                className="cls-107"
                d="M195.34,162.26c.06.68.51,1.09,1.17,1.08-.66.02-1.11-.39-1.17-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M187.49,161.62c.03.78.05,1.55.08,2.33.65-.07,1.07-.55,1.08-1.23-.01.68-.43,1.16-1.08,1.23-.02-.78-.05-1.55-.08-2.33h0Z"
              />
              <path
                className="cls-107"
                d="M195.11,157.61c0,1.14-1.17,1.59-1.84.96-.32-.29-.35-.65-.37-.8.11,1.13,1.33,1.4,1.93.68.28-.34.28-.69.28-.84h0Z"
              />
              <path
                className="cls-107"
                d="M190.69,157.93c0,1.13-1.19,1.57-1.86.94-.32-.3-.35-.65-.36-.8.1,1.13,1.32,1.42,1.93.7.29-.34.29-.69.29-.84h0Z"
              />
            </g>
            <g className="cls-353">
              <path
                className="cls-107"
                d="M194.58,175.19c-.65.08-1.09.57-1.11,1.25.75-.05,1.5-.11,2.25-.17-.05-.85-.71-1.11-1.14-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M190.07,175.5c-.65.08-1.09.56-1.12,1.24.76-.04,1.51-.09,2.26-.14-.05-.85-.71-1.12-1.14-1.09h0Z"
              />
              <path
                className="cls-107"
                d="M195.52,166.94c-.75.06-1.49.11-2.24.17.09,1.13,1.32,1.41,1.94.68.29-.34.3-.7.3-.85h0Z"
              />
              <path
                className="cls-107"
                d="M191.04,167.26c-.75.05-1.5.1-2.25.14.08,1.13,1.31,1.42,1.94.71.3-.34.3-.69.31-.85h0Z"
              />
            </g>
            <g className="cls-350">
              <path
                className="cls-107"
                d="M194.6,184.51c-.65.08-1.1.56-1.14,1.23.75-.05,1.5-.11,2.26-.17-.03-.84-.68-1.09-1.11-1.06h0Z"
              />
              <path
                className="cls-107"
                d="M190.08,184.82c-.65.07-1.1.55-1.14,1.22.76-.04,1.51-.09,2.27-.14-.03-.84-.69-1.1-1.12-1.07h0Z"
              />
              <path
                className="cls-107"
                d="M196.88,179.7c-1.17.15-1.48,1.54-.72,2.12.29.22.58.21.72.21,0-.25,0-.5,0-.76,0-.52,0-1.05,0-1.57h0Z"
              />
              <path
                className="cls-107"
                d="M192.36,180.03c-1.16.14-1.47,1.52-.72,2.11.77.6,1.94-.12,1.85-1.15-.06-.59-.54-1.01-1.13-.97h0Z"
              />
              <path
                className="cls-107"
                d="M187.83,180.32c0,.52,0,1.05,0,1.57,0,.25,0,.51,0,.76,1.18-.13,1.49-1.51.72-2.11-.29-.22-.58-.22-.72-.22h0Z"
              />
              <path
                className="cls-107"
                d="M195.73,176.27c-.75.06-1.5.11-2.25.17.07,1.14,1.29,1.42,1.94.69.3-.34.31-.7.32-.86h0Z"
              />
              <path
                className="cls-107"
                d="M191.21,176.6c-.75.05-1.51.1-2.26.14.06,1.14,1.29,1.43,1.94.71.31-.34.32-.7.33-.86h0Z"
              />
            </g>
            <g className="cls-356">
              <path
                className="cls-107"
                d="M194.41,193.51c-.65.08-1.1.54-1.16,1.18.75-.05,1.49-.11,2.24-.17-.01-.8-.65-1.04-1.08-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M189.92,193.82c-.65.07-1.11.53-1.16,1.16.75-.04,1.5-.09,2.25-.14-.02-.8-.66-1.05-1.09-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M196.79,188.89c-1.16.15-1.51,1.48-.77,2.04.28.21.57.2.71.2.02-.74.04-1.49.06-2.24h0Z"
              />
              <path
                className="cls-107"
                d="M192.28,189.23c-1.16.14-1.5,1.46-.76,2.03.81.62,2.03-.19,1.85-1.21-.09-.52-.54-.85-1.09-.82h0Z"
              />
              <path
                className="cls-107"
                d="M187.76,189.51c-.01.75-.03,1.49-.04,2.23,1.17-.12,1.5-1.45.76-2.02-.28-.22-.57-.21-.71-.21h0Z"
              />
              <path
                className="cls-107"
                d="M195.72,185.57c-.75.06-1.5.11-2.26.17.04,1.1,1.26,1.37,1.92.67.31-.33.33-.68.34-.83h0Z"
              />
              <path
                className="cls-107"
                d="M191.2,185.9c-.75.05-1.51.1-2.27.14.04,1.12,1.25,1.4,1.92.69.31-.33.33-.68.34-.83h0Z"
              />
            </g>
            <g className="cls-352">
              <path
                className="cls-107"
                d="M194.03,202.09c-.64.08-1.1.52-1.17,1.12.74-.05,1.48-.11,2.21-.16,0-.76-.62-.99-1.04-.96h0Z"
              />
              <path
                className="cls-107"
                d="M189.58,202.39c-.64.07-1.1.51-1.16,1.11.74-.04,1.48-.09,2.22-.14,0-.76-.63-1-1.06-.97h0Z"
              />
              <path
                className="cls-107"
                d="M196.48,197.69c-1.15.15-1.53,1.42-.81,1.94.27.2.56.19.7.19.04-.71.08-1.41.11-2.13h0Z"
              />
              <path
                className="cls-107"
                d="M192.01,198.02c-1.15.13-1.51,1.4-.79,1.93.78.58,2.01-.18,1.85-1.16-.08-.49-.52-.81-1.06-.77h0Z"
              />
              <path
                className="cls-107"
                d="M187.53,198.3c-.03.71-.05,1.42-.08,2.13,1.16-.12,1.51-1.38.78-1.93-.28-.2-.56-.2-.7-.2h0Z"
              />
              <path
                className="cls-107"
                d="M195.5,194.52c-.75.06-1.49.11-2.24.17.02,1.05,1.22,1.31,1.89.63.31-.32.34-.65.35-.8h0Z"
              />
              <path
                className="cls-107"
                d="M191.01,194.84c-.75.05-1.5.1-2.25.14.02,1.07,1.21,1.33,1.9.65.32-.31.34-.65.36-.79h0Z"
              />
            </g>
            <g className="cls-349">
              <path
                className="cls-107"
                d="M193.45,210.22c-.63.08-1.09.49-1.17,1.06.72-.05,1.45-.11,2.17-.16.03-.72-.58-.93-1-.9h0Z"
              />
              <path
                className="cls-107"
                d="M189.09,210.52c-.63.07-1.09.48-1.16,1.05.73-.04,1.45-.09,2.18-.14.02-.72-.6-.94-1.02-.91h0Z"
              />
              <path
                className="cls-107"
                d="M195.97,206.04c-1.14.14-1.54,1.35-.84,1.85.26.19.55.18.68.17.06-.67.11-1.35.16-2.03h0Z"
              />
              <path
                className="cls-107"
                d="M191.56,206.37c-1.14.13-1.52,1.34-.82,1.84.76.55,1.98-.18,1.84-1.1-.07-.46-.5-.78-1.02-.74h0Z"
              />
              <path
                className="cls-107"
                d="M187.15,206.64c-.04.68-.08,1.35-.12,2.02,1.13-.12,1.51-1.32.81-1.83-.27-.2-.55-.19-.69-.19h0Z"
              />
              <path
                className="cls-107"
                d="M195.07,203.05c-.74.06-1.47.11-2.21.16,0,1,1.17,1.24,1.84.59.31-.3.35-.62.37-.76h0Z"
              />
              <path
                className="cls-107"
                d="M190.64,203.36c-.74.05-1.48.09-2.22.14,0,1.02,1.17,1.26,1.86.61.32-.3.35-.62.37-.75h0Z"
              />
            </g>
            <g className="cls-318">
              <path
                className="cls-107"
                d="M192.69,217.89c-.62.07-1.07.46-1.16,1,.7-.05,1.41-.1,2.11-.16.05-.73-.6-.87-.95-.84h0Z"
              />
              <path
                className="cls-107"
                d="M188.44,218.18c-.63.07-1.07.44-1.15.99.71-.04,1.41-.09,2.12-.13.03-.67-.56-.88-.97-.86h0Z"
              />
              <path
                className="cls-107"
                d="M195.25,213.95c-1.11.14-1.53,1.28-.87,1.75.25.18.53.17.66.16.07-.63.14-1.27.21-1.91h0Z"
              />
              <path
                className="cls-107"
                d="M190.94,214.27c-1.11.13-1.51,1.26-.84,1.74.73.52,1.94-.17,1.82-1.05-.06-.43-.47-.72-.98-.69h0Z"
              />
              <path
                className="cls-107"
                d="M186.62,214.54c-.05.64-.1,1.28-.15,1.91,1.05-.11,1.47-1.16.89-1.67-.27-.24-.6-.24-.74-.24h0Z"
              />
              <path
                className="cls-107"
                d="M194.45,211.13c-.72.06-1.44.11-2.17.16-.03.94,1.12,1.16,1.79.55.32-.29.36-.59.38-.71h0Z"
              />
              <path
                className="cls-107"
                d="M190.11,211.44c-.73.05-1.45.09-2.18.14-.02.96,1.12,1.19,1.8.57.32-.28.36-.58.37-.71h0Z"
              />
            </g>
            <g className="cls-327">
              <path
                className="cls-107"
                d="M191.75,225.08c-.61.07-1.05.43-1.15.94.68-.05,1.36-.1,2.04-.15.07-.68-.55-.81-.89-.78h0Z"
              />
              <path
                className="cls-107"
                d="M187.64,225.36c-.61.06-1.04.42-1.14.92.68-.04,1.37-.08,2.05-.13.05-.63-.52-.82-.92-.79h0Z"
              />
              <path
                className="cls-107"
                d="M194.34,221.38c-1.02.13-1.49,1.12-.96,1.58.25.22.56.2.7.2.09-.59.17-1.18.26-1.78h0Z"
              />
              <path
                className="cls-107"
                d="M190.15,221.69c-1.02.11-1.46,1.1-.92,1.57.65.56,1.95-.09,1.86-.93-.04-.41-.44-.68-.93-.64h0Z"
              />
              <path
                className="cls-107"
                d="M185.96,221.95c-.06.6-.12,1.19-.19,1.77,1.02-.1,1.45-1.08.9-1.55-.26-.23-.58-.22-.71-.22h0Z"
              />
              <path
                className="cls-107"
                d="M193.64,218.74c-.7.05-1.41.11-2.11.16-.05.88,1.06,1.09,1.73.51.31-.27.36-.55.39-.67h0Z"
              />
              <path
                className="cls-107"
                d="M189.41,219.04c-.71.05-1.41.09-2.12.13-.04.93,1.18,1.11,1.82.47.25-.25.29-.48.3-.6h0Z"
              />
            </g>
            <g className="cls-321">
              <path
                className="cls-107"
                d="M190.65,231.75c-.58.07-1.02.4-1.13.87.65-.05,1.31-.1,1.96-.15.08-.63-.51-.75-.83-.72h0Z"
              />
              <path
                className="cls-107"
                d="M186.7,232.02c-.58.06-1.01.39-1.11.86.66-.04,1.31-.08,1.97-.12.06-.58-.48-.76-.86-.73h0Z"
              />
              <path
                className="cls-107"
                d="M193.24,228.32c-.99.12-1.46,1.04-.97,1.47.23.2.54.19.67.18.1-.55.2-1.1.3-1.65h0Z"
              />
              <path
                className="cls-107"
                d="M189.21,228.62c-.98.11-1.44,1.02-.93,1.46.61.52,1.88-.09,1.81-.87-.03-.38-.4-.63-.88-.59h0Z"
              />
              <path
                className="cls-107"
                d="M185.17,228.87c-.07.55-.14,1.1-.22,1.65.98-.09,1.42-1,.9-1.44-.24-.21-.55-.2-.68-.2h0Z"
              />
              <path
                className="cls-107"
                d="M192.65,225.86c-.68.05-1.36.1-2.04.15-.07.84.98,1.02,1.65.47.31-.25.37-.51.39-.63h0Z"
              />
              <path
                className="cls-107"
                d="M188.56,226.15c-.68.04-1.37.09-2.05.13-.05.87,1.11,1.03,1.74.43.24-.23.29-.45.31-.56h0Z"
              />
            </g>
            <g className="cls-322">
              <path
                className="cls-107"
                d="M189.4,237.89c-.55.06-.98.38-1.1.8.62-.04,1.25-.09,1.87-.14.1-.58-.45-.69-.76-.67h0Z"
              />
              <path
                className="cls-107"
                d="M185.63,238.15c-.55.06-.97.37-1.08.79.63-.04,1.25-.08,1.87-.12.08-.54-.43-.7-.79-.67h0Z"
              />
              <path
                className="cls-107"
                d="M191.98,234.74c-.94.11-1.43.96-.97,1.35.21.18.5.17.63.17.12-.5.23-1.01.34-1.52h0Z"
              />
              <path
                className="cls-107"
                d="M188.12,235.03c-.94.1-1.4.94-.93,1.34.56.48,1.79-.08,1.75-.8-.02-.35-.37-.58-.82-.54h0Z"
              />
              <path
                className="cls-107"
                d="M184.25,235.27c-.08.51-.16,1.01-.25,1.51.94-.09,1.37-.92.9-1.33-.23-.19-.52-.19-.65-.19h0Z"
              />
              <path
                className="cls-107"
                d="M191.48,232.48c-.65.05-1.31.1-1.96.15-.09.78.91.94,1.57.43.3-.23.37-.48.39-.58h0Z"
              />
              <path
                className="cls-107"
                d="M187.56,232.76c-.66.04-1.31.08-1.97.12-.07.8,1.04.94,1.66.39.24-.21.29-.42.31-.52h0Z"
              />
            </g>
            <g className="cls-323">
              <path
                className="cls-107"
                d="M187.99,243.49c-.52.06-.94.34-1.07.72.59-.04,1.18-.09,1.76-.13.11-.48-.35-.62-.69-.59h0Z"
              />
              <path
                className="cls-107"
                d="M184.43,243.73c-.52.05-.93.33-1.04.71.59-.04,1.18-.07,1.77-.11.09-.48-.39-.62-.73-.6h0Z"
              />
              <path
                className="cls-107"
                d="M190.54,240.62c-.91.11-1.4.87-.97,1.23.19.17.47.15.59.15.13-.45.26-.92.38-1.38h0Z"
              />
              <path
                className="cls-107"
                d="M186.88,240.89c-.89.09-1.35.86-.92,1.22.52.43,1.69-.08,1.68-.73,0-.32-.33-.52-.76-.49h0Z"
              />
              <path
                className="cls-107"
                d="M183.21,241.12c-.09.46-.18.92-.28,1.37.89-.08,1.33-.84.89-1.21-.21-.17-.49-.17-.61-.17h0Z"
              />
              <path
                className="cls-107"
                d="M190.16,238.56c-.62.05-1.24.09-1.87.14-.11.71.83.86,1.47.39.3-.21.36-.44.39-.53h0Z"
              />
              <path
                className="cls-107"
                d="M186.42,238.82c-.62.04-1.25.08-1.87.12-.09.73.96.86,1.56.35.23-.2.29-.38.31-.47h0Z"
              />
            </g>
            <g className="cls-319">
              <path
                className="cls-107"
                d="M186.44,248.51c-.49.05-.89.31-1.03.65.55-.04,1.1-.08,1.65-.12.13-.43-.3-.55-.62-.52h0Z"
              />
              <path
                className="cls-107"
                d="M183.11,248.74c-.49.05-.88.3-1,.63.55-.03,1.1-.07,1.65-.1.1-.43-.33-.55-.65-.53h0Z"
              />
              <path
                className="cls-107"
                d="M185.51,246.2c-.86.09-1.31.77-.91,1.1.49.41,1.68-.12,1.6-.72-.03-.25-.31-.41-.69-.38h0Z"
              />
              <path
                className="cls-107"
                d="M182.05,246.41c-.1.42-.2.83-.3,1.23.84-.08,1.28-.76.87-1.08-.19-.15-.45-.15-.57-.15h0Z"
              />
              <path
                className="cls-107"
                d="M188.68,244.08c-.59.05-1.17.09-1.76.13-.13.64.75.78,1.37.35.29-.2.36-.4.39-.49h0Z"
              />
              <path
                className="cls-107"
                d="M185.16,244.33c-.59.04-1.18.08-1.77.11-.11.64.78.78,1.39.37.28-.19.35-.39.38-.48h0Z"
              />
            </g>
            <g className="cls-324">
              <path
                className="cls-107"
                d="M181.41,251.68c-.07.16-.37.48-.94.53.11-.35.22-.71.33-1.08.57-.01.74.28.61.55h0Z"
              />
              <path
                className="cls-107"
                d="M187.03,249.1c-.3.6-1.49.81-1.63.28-.02-.09,0-.15.01-.22.55-.04,1.1-.08,1.65-.12,0,.02-.02.04-.03.06h0Z"
              />
              <path
                className="cls-107"
                d="M183.74,249.33c-.27.6-1.46.79-1.63.27-.03-.09-.01-.15,0-.22.55-.03,1.1-.07,1.65-.1,0,.02-.01.04-.02.06h0Z"
              />
            </g>
            <g className="cls-325">
              <path
                className="cls-107"
                d="M180.76,103.78c-.5.06-.8.48-.75,1.07.59-.03,1.18-.06,1.77-.09-.13-.75-.68-1-1.02-.98h0Z"
              />
              <path
                className="cls-107"
                d="M177.25,103.94c-.5.05-.81.47-.78,1.07.59-.02,1.18-.04,1.77-.07-.11-.75-.65-1.01-.99-1h0Z"
              />
              <path
                className="cls-107"
                d="M178.52,99.78c-.87.09-.97,1.29-.33,1.82.62.52,1.42,0,1.31-.85-.07-.57-.5-.99-.98-.97h0Z"
              />
              <path
                className="cls-107"
                d="M175.13,99.92c.06.67.12,1.35.18,2.03.88-.08,1.01-1.28.38-1.82-.24-.2-.46-.21-.56-.21h0Z"
              />
            </g>
            <g className="cls-326">
              <path
                className="cls-107"
                d="M181.76,112.16c-.53.06-.85.49-.82,1.11.63-.03,1.25-.06,1.88-.1-.13-.78-.7-1.03-1.06-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M178.03,112.32c-.54.05-.87.48-.85,1.1.63-.02,1.25-.05,1.88-.07-.11-.78-.67-1.04-1.03-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M183.08,107.84c-.92.11-1.02,1.35-.34,1.89.26.21.5.21.61.21-.09-.7-.18-1.4-.27-2.1h0Z"
              />
              <path
                className="cls-107"
                d="M179.46,108.02c-.93.1-1.05,1.33-.39,1.89.65.54,1.51,0,1.41-.88-.07-.59-.51-1.03-1.02-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M175.84,108.17c.06.7.11,1.4.17,2.1.94-.09,1.09-1.33.43-1.89-.25-.21-.48-.21-.6-.22h0Z"
              />
              <path
                className="cls-107"
                d="M181.78,104.76c-.59.03-1.18.06-1.77.09.16,1.01,1.17,1.28,1.61.66.21-.29.18-.61.16-.75h0Z"
              />
              <path
                className="cls-107"
                d="M178.24,104.93c-.59.02-1.18.05-1.77.07.14,1.01,1.13,1.3,1.58.68.21-.29.19-.61.18-.75h0Z"
              />
            </g>
            <g className="cls-320">
              <path
                className="cls-107"
                d="M182.65,120.79c-.56.06-.91.51-.88,1.14.66-.03,1.32-.06,1.98-.1-.12-.8-.72-1.06-1.1-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M178.74,120.96c-.56.05-.92.5-.9,1.13.66-.02,1.31-.05,1.97-.08-.1-.8-.69-1.07-1.07-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M184.13,116.34c-.98.11-1.1,1.39-.4,1.95.27.21.52.21.64.21-.08-.72-.16-1.44-.24-2.16h0Z"
              />
              <path
                className="cls-107"
                d="M180.31,116.54c-.98.1-1.13,1.38-.44,1.94.68.55,1.59,0,1.5-.91-.06-.61-.52-1.06-1.06-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M176.48,116.69c.05.72.1,1.44.15,2.17.99-.09,1.17-1.37.48-1.94-.26-.22-.51-.22-.63-.22h0Z"
              />
              <path
                className="cls-107"
                d="M182.82,113.17c-.63.03-1.25.07-1.88.1.15,1.04,1.21,1.32,1.69.68.22-.3.2-.63.19-.77h0Z"
              />
              <path
                className="cls-107"
                d="M179.06,113.35c-.62.03-1.25.05-1.88.07.13,1.04,1.17,1.34,1.67.7.23-.3.21-.63.21-.77h0Z"
              />
            </g>
            <g className="cls-360">
              <path
                className="cls-107"
                d="M183.44,129.63c-.59.06-.95.52-.94,1.17.69-.03,1.37-.07,2.06-.1-.11-.82-.73-1.08-1.12-1.06h0Z"
              />
              <path
                className="cls-107"
                d="M179.35,129.82c-.59.06-.96.51-.96,1.16.69-.02,1.37-.05,2.05-.08-.09-.82-.71-1.09-1.1-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M185.07,125.07c-1.03.12-1.18,1.43-.45,2.01.28.22.54.22.67.22-.07-.74-.14-1.49-.21-2.22h0Z"
              />
              <path
                className="cls-107"
                d="M181.06,125.28c-1.03.1-1.21,1.42-.49,2,.7.57,1.66,0,1.58-.93-.05-.62-.54-1.1-1.09-1.07h0Z"
              />
              <path
                className="cls-107"
                d="M183.75,121.83c-.66.04-1.32.07-1.98.1.14,1.07,1.25,1.36,1.76.69.24-.31.22-.65.21-.79h0Z"
              />
              <path
                className="cls-107"
                d="M179.8,122.02c-.66.03-1.31.05-1.97.08.12,1.07,1.22,1.37,1.74.71.25-.31.23-.64.23-.79h0Z"
              />
            </g>
            <g className="cls-359">
              <path
                className="cls-107"
                d="M184.11,138.66c-.62.06-1,.52-.99,1.19.71-.03,1.42-.07,2.13-.11-.1-.9-.79-1.1-1.15-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M179.88,138.85c-.62.06-1,.51-1,1.18.71-.03,1.42-.05,2.13-.08-.08-.83-.72-1.11-1.12-1.1h0Z"
              />
              <path
                className="cls-107"
                d="M185.88,134.01c-1.06.12-1.24,1.46-.51,2.04.28.22.56.22.69.22-.06-.76-.12-1.51-.18-2.27h0Z"
              />
              <path
                className="cls-107"
                d="M181.71,134.22c-1.07.11-1.27,1.45-.54,2.04.71.58,1.72,0,1.65-.96-.04-.62-.54-1.11-1.12-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M177.54,134.38c.04.76.07,1.51.11,2.27,1.08-.1,1.3-1.43.56-2.04-.28-.23-.55-.23-.68-.24h0Z"
              />
              <path
                className="cls-107"
                d="M184.56,130.7c-.69.04-1.37.07-2.06.1.13,1.09,1.28,1.38,1.82.7.26-.32.24-.66.24-.81h0Z"
              />
              <path
                className="cls-107"
                d="M180.45,130.89c-.68.03-1.37.06-2.05.08.11,1.09,1.25,1.4,1.8.72.26-.32.25-.66.25-.8h0Z"
              />
            </g>
            <g className="cls-369">
              <path
                className="cls-107"
                d="M184.66,147.82c-.64.07-1.03.53-1.03,1.21.73-.03,1.46-.07,2.19-.11-.09-.91-.8-1.11-1.16-1.09h0Z"
              />
              <path
                className="cls-107"
                d="M180.31,148.02c-.64.06-1.04.52-1.05,1.19.73-.03,1.46-.05,2.18-.09-.08-.84-.72-1.12-1.14-1.11h0Z"
              />
              <path
                className="cls-107"
                d="M186.55,143.1c-1.1.12-1.31,1.48-.56,2.07.29.22.57.22.7.22-.05-.76-.1-1.53-.15-2.29h0Z"
              />
              <path
                className="cls-107"
                d="M182.25,143.32c-1.11.11-1.33,1.47-.58,2.06.77.61,1.86-.08,1.71-1.08-.09-.58-.57-1-1.13-.98h0Z"
              />
              <path
                className="cls-107"
                d="M177.95,143.49c.03.76.06,1.53.09,2.29,1.11-.1,1.35-1.45.6-2.05-.28-.23-.56-.24-.69-.24h0Z"
              />
              <path
                className="cls-107"
                d="M185.26,139.74c-.71.04-1.42.07-2.13.11.12,1.11,1.3,1.4,1.87.71.27-.32.26-.67.26-.82h0Z"
              />
              <path
                className="cls-107"
                d="M181,139.94c-.71.03-1.42.06-2.13.08.11,1.11,1.27,1.42,1.86.73.27-.32.27-.67.27-.82h0Z"
              />
            </g>
            <g className="cls-374">
              <path
                className="cls-107"
                d="M185.08,157.09c-.65.07-1.06.53-1.07,1.22.75-.04,1.49-.07,2.23-.11-.08-.92-.8-1.12-1.17-1.1h0Z"
              />
              <path
                className="cls-107"
                d="M180.64,157.29c-.65.06-1.07.52-1.08,1.2.74-.03,1.49-.06,2.23-.09-.07-.85-.72-1.13-1.15-1.12h0Z"
              />
              <path
                className="cls-107"
                d="M187.09,152.32c-1.13.12-1.37,1.5-.6,2.09.29.23.58.22.72.22-.04-.77-.07-1.54-.11-2.32h0Z"
              />
              <path
                className="cls-107"
                d="M182.69,152.54c-1.14.11-1.38,1.48-.62,2.09.78.62,1.9-.08,1.76-1.1-.08-.59-.57-1.01-1.14-.99h0Z"
              />
              <path
                className="cls-107"
                d="M178.28,152.72c.02.77.05,1.54.07,2.32,1.14-.1,1.4-1.46.64-2.08-.29-.23-.57-.24-.71-.24h0Z"
              />
              <path
                className="cls-107"
                d="M185.82,148.92c-.73.04-1.46.08-2.19.11.11,1.12,1.31,1.42,1.91.72.28-.33.28-.68.28-.83h0Z"
              />
              <path
                className="cls-107"
                d="M181.45,149.13c-.73.03-1.46.06-2.18.09.1,1.12,1.29,1.44,1.9.74.28-.33.29-.68.29-.83h0Z"
              />
            </g>
            <g className="cls-371">
              <path
                className="cls-107"
                d="M187.57,163.95c-1.15,0-1.5-1.34-.78-2.02.27-.26.57-.29.7-.31.03.78.05,1.55.08,2.33h0Z"
              />
              <path
                className="cls-107"
                d="M186.25,158.31c-.06,1.02-1.3,1.48-1.95.72-.24-.28-.27-.58-.28-.73.75-.04,1.49-.07,2.23-.11,0,.04,0,.08,0,.12h0Z"
              />
              <path
                className="cls-107"
                d="M181.78,158.52c-.07,1.04-1.29,1.48-1.95.7-.24-.29-.26-.59-.28-.73.74-.03,1.49-.06,2.23-.09,0,.04,0,.08,0,.12h0Z"
              />
            </g>
            <g className="cls-375">
              <path
                className="cls-107"
                d="M184.4,176.98c.03-.68.47-1.16,1.13-1.22.66,0,1.12.44,1.15,1.11-.76.04-1.52.08-2.28.12h0Z"
              />
              <path
                className="cls-107"
                d="M179.84,177.17c.03-.68.47-1.15,1.13-1.21.66,0,1.11.45,1.14,1.12-.76.03-1.52.06-2.28.09h0Z"
              />
              <path
                className="cls-107"
                d="M184.35,172.43c-.09,1.05-1.34,1.49-2,.71-.56-.67-.2-1.85.85-1.95.86,0,1.19.73,1.15,1.23h0Z"
              />
            </g>
            <g className="cls-376">
              <path
                className="cls-107"
                d="M185.53,185.08c-.66.07-1.11.54-1.15,1.2.76-.04,1.52-.07,2.28-.12-.03-.84-.7-1.11-1.14-1.09h0Z"
              />
              <path
                className="cls-107"
                d="M180.98,185.28c-.66.06-1.11.53-1.15,1.19.76-.03,1.52-.06,2.28-.09-.04-.84-.7-1.12-1.13-1.1h0Z"
              />
              <path
                className="cls-107"
                d="M187.83,180.32c-1.17.12-1.48,1.5-.73,2.1.29.23.58.23.72.23,0-.25,0-.51,0-.76,0-.52,0-1.05,0-1.57h0Z"
              />
              <path
                className="cls-107"
                d="M183.27,180.55c-1.17.11-1.48,1.49-.73,2.1.78.62,1.96-.08,1.86-1.1-.06-.59-.54-1.02-1.13-.99h0Z"
              />
              <path
                className="cls-107"
                d="M178.71,180.73c0,.52,0,1.05,0,1.57,0,.25,0,.51,0,.76,1.18-.1,1.49-1.48.73-2.09-.29-.23-.58-.24-.72-.24h0Z"
              />
              <path
                className="cls-107"
                d="M186.68,176.87c-.76.04-1.52.08-2.28.12.06,1.16,1.28,1.46,1.95.74.31-.33.32-.7.33-.85h0Z"
              />
              <path
                className="cls-107"
                d="M182.12,177.08c-.76.03-1.52.06-2.28.09.06,1.14,1.29,1.46,1.95.76.31-.33.32-.69.33-.85h0Z"
              />
            </g>
            <g className="cls-370">
              <path
                className="cls-107"
                d="M185.39,194.08c-.65.07-1.11.52-1.16,1.15.76-.04,1.51-.07,2.27-.11-.02-.8-.68-1.06-1.11-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M180.87,194.28c-.65.06-1.11.5-1.15,1.14.75-.03,1.51-.06,2.26-.09-.02-.8-.68-1.06-1.11-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M187.76,189.51c-1.16.12-1.5,1.45-.76,2.02.28.22.58.22.72.21.02-.74.03-1.49.04-2.23h0Z"
              />
              <path
                className="cls-107"
                d="M183.21,189.74c-1.17.11-1.5,1.43-.75,2.01.78.61,1.95-.05,1.86-1.06-.05-.57-.53-.98-1.11-.95h0Z"
              />
              <path
                className="cls-107"
                d="M178.66,189.92c0,.75-.02,1.49-.03,2.23,1.17-.1,1.5-1.42.75-2-.28-.22-.58-.23-.72-.23h0Z"
              />
              <path
                className="cls-107"
                d="M186.67,186.16c-.76.04-1.52.08-2.28.12.05,1.12,1.26,1.41,1.94.71.31-.32.33-.68.34-.83h0Z"
              />
              <path
                className="cls-107"
                d="M182.11,186.38c-.76.03-1.52.06-2.28.09.05,1.12,1.26,1.43,1.94.73.31-.32.33-.67.34-.82h0Z"
              />
            </g>
            <g className="cls-373">
              <path
                className="cls-107"
                d="M185.12,202.65c-.65.06-1.1.49-1.16,1.09.75-.04,1.49-.07,2.24-.11,0-.76-.65-1-1.08-.98h0Z"
              />
              <path
                className="cls-107"
                d="M180.65,202.85c-.65.06-1.1.48-1.15,1.08.74-.03,1.49-.06,2.23-.09-.01-.76-.65-1.01-1.08-.99h0Z"
              />
              <path
                className="cls-107"
                d="M187.53,198.3c-1.15.12-1.51,1.38-.79,1.92.27.21.57.2.71.2.03-.7.06-1.41.08-2.13h0Z"
              />
              <path
                className="cls-107"
                d="M183.02,198.53c-1.16.11-1.5,1.36-.77,1.92.8.6,2.02-.14,1.85-1.12-.09-.5-.53-.82-1.08-.8h0Z"
              />
              <path
                className="cls-107"
                d="M178.52,198.7c-.02.71-.03,1.42-.05,2.13,1.1-.09,1.48-1.25.84-1.84-.3-.28-.64-.28-.79-.28h0Z"
              />
              <path
                className="cls-107"
                d="M186.5,195.11c-.76.04-1.51.08-2.27.11.03,1.07,1.23,1.34,1.91.67.32-.31.34-.65.35-.79h0Z"
              />
              <path
                className="cls-107"
                d="M181.98,195.33c-.75.03-1.51.06-2.26.09.04,1.11,1.35,1.36,1.99.62.24-.28.26-.57.27-.71h0Z"
              />
            </g>
            <g className="cls-372">
              <path
                className="cls-107"
                d="M184.71,210.77c-.63.06-1.09.47-1.15,1.04.73-.03,1.46-.07,2.19-.11,0-.72-.62-.95-1.04-.92h0Z"
              />
              <path
                className="cls-107"
                d="M180.32,210.97c-.64.05-1.08.46-1.14,1.02.73-.03,1.46-.06,2.19-.09,0-.72-.63-.95-1.05-.94h0Z"
              />
              <path
                className="cls-107"
                d="M187.15,206.64c-1.14.12-1.51,1.32-.81,1.83.27.19.55.19.69.19.04-.67.08-1.34.12-2.02h0Z"
              />
              <path
                className="cls-107"
                d="M182.71,206.87c-1.08.1-1.47,1.21-.86,1.76.7.63,1.97.04,1.92-.9-.03-.52-.49-.89-1.06-.86h0Z"
              />
              <path
                className="cls-107"
                d="M178.28,207.04c-.02.68-.05,1.35-.07,2.02,1.1-.09,1.47-1.18.85-1.75-.29-.27-.63-.27-.77-.27h0Z"
              />
              <path
                className="cls-107"
                d="M186.2,203.63c-.75.04-1.49.08-2.24.11.01,1.05,1.31,1.27,1.95.56.25-.27.27-.54.29-.67h0Z"
              />
              <path
                className="cls-107"
                d="M181.73,203.84c-.74.03-1.49.06-2.23.09.02,1.05,1.32,1.29,1.95.58.24-.27.27-.54.28-.67h0Z"
              />
            </g>
            <g className="cls-358">
              <path
                className="cls-107"
                d="M184.17,218.43c-.63.06-1.07.43-1.14.97.71-.03,1.43-.07,2.14-.11.02-.73-.64-.88-1-.87h0Z"
              />
              <path
                className="cls-107"
                d="M179.89,218.62c-.63.05-1.06.42-1.13.96.71-.03,1.42-.05,2.13-.08,0-.67-.6-.89-1.01-.88h0Z"
              />
              <path
                className="cls-107"
                d="M186.62,214.54c-1.07.11-1.48,1.14-.89,1.67.27.24.6.24.74.24.05-.63.1-1.27.15-1.91h0Z"
              />
              <path
                className="cls-107"
                d="M182.29,214.76c-1.07.1-1.47,1.13-.87,1.66.68.6,1.93.03,1.89-.85-.02-.48-.46-.83-1.02-.81h0Z"
              />
              <path
                className="cls-107"
                d="M177.95,214.93c-.03.64-.06,1.27-.1,1.9,1.05-.08,1.44-1.12.85-1.65-.28-.25-.61-.25-.75-.25h0Z"
              />
              <path
                className="cls-107"
                d="M185.75,211.69c-.73.04-1.46.08-2.19.11,0,.99,1.26,1.2,1.9.52.25-.26.28-.51.29-.63h0Z"
              />
              <path
                className="cls-107"
                d="M181.36,211.9c-.73.03-1.46.06-2.19.09.01.99,1.27,1.21,1.91.54.24-.26.27-.51.28-.63h0Z"
              />
            </g>
            <g className="cls-357">
              <path
                className="cls-107"
                d="M183.51,225.59c-.61.06-1.04.4-1.12.91.69-.03,1.38-.07,2.07-.1.04-.68-.6-.82-.95-.81h0Z"
              />
              <path
                className="cls-107"
                d="M179.37,225.78c-.61.05-1.03.39-1.1.9.69-.02,1.37-.05,2.06-.08.02-.63-.56-.83-.96-.82h0Z"
              />
              <path
                className="cls-107"
                d="M185.96,221.95c-1.02.1-1.45,1.08-.9,1.56.26.22.58.22.71.21.06-.59.13-1.18.19-1.77h0Z"
              />
              <path
                className="cls-107"
                d="M181.75,222.17c-1.03.09-1.43,1.07-.87,1.55.64.55,1.87.02,1.84-.8-.01-.45-.43-.78-.98-.75h0Z"
              />
              <path
                className="cls-107"
                d="M177.53,222.33c-.04.6-.08,1.19-.12,1.77,1.02-.08,1.41-1.05.84-1.53-.27-.23-.59-.24-.73-.24h0Z"
              />
              <path
                className="cls-107"
                d="M185.16,219.29c-.71.04-1.42.07-2.14.11-.02.93,1.21,1.12,1.84.49.24-.24.28-.48.3-.59h0Z"
              />
              <path
                className="cls-107"
                d="M180.9,219.5c-.71.03-1.42.06-2.13.08,0,.93,1.22,1.13,1.85.51.24-.24.27-.48.29-.59h0Z"
              />
            </g>
            <g className="cls-361">
              <path
                className="cls-107"
                d="M182.73,232.25c-.59.05-1,.38-1.09.84.66-.03,1.32-.07,1.98-.1.05-.63-.56-.76-.89-.74h0Z"
              />
              <path
                className="cls-107"
                d="M178.75,232.43c-.59.05-1,.36-1.07.83.66-.02,1.32-.05,1.98-.08.03-.58-.53-.77-.91-.75h0Z"
              />
              <path
                className="cls-107"
                d="M185.17,228.87c-.98.1-1.42,1.01-.9,1.45.24.2.55.2.68.2.07-.54.15-1.09.22-1.65h0Z"
              />
              <path
                className="cls-107"
                d="M181.1,229.08c-.99.09-1.4.99-.86,1.44.64.53,1.89-.04,1.78-.82-.05-.38-.44-.64-.92-.62h0Z"
              />
              <path
                className="cls-107"
                d="M177.04,229.24c-.04.55-.09,1.1-.14,1.64.98-.07,1.37-.97.83-1.42-.26-.22-.57-.22-.7-.22h0Z"
              />
              <path
                className="cls-107"
                d="M184.45,226.4c-.69.04-1.38.07-2.07.1-.03.87,1.15,1.04,1.77.45.24-.23.28-.45.3-.55h0Z"
              />
              <path
                className="cls-107"
                d="M180.33,226.59c-.69.03-1.37.06-2.06.08-.02.87,1.17,1.05,1.78.47.24-.23.27-.45.28-.55h0Z"
              />
            </g>
            <g className="cls-367">
              <path
                className="cls-107"
                d="M181.84,238.36c-.55.05-.97.35-1.06.78.63-.03,1.26-.06,1.89-.1.06-.54-.46-.7-.83-.68h0Z"
              />
              <path
                className="cls-107"
                d="M178.05,238.53c-.55.04-.96.34-1.04.77.63-.02,1.26-.05,1.88-.07.04-.53-.49-.71-.85-.69h0Z"
              />
              <path
                className="cls-107"
                d="M184.25,235.27c-.96.09-1.39.92-.89,1.33.23.19.52.18.64.18.08-.5.17-1,.25-1.51h0Z"
              />
              <path
                className="cls-107"
                d="M180.36,235.47c-.94.08-1.35.91-.85,1.32.6.49,1.8-.04,1.72-.76-.04-.35-.41-.58-.87-.56h0Z"
              />
              <path
                className="cls-107"
                d="M176.47,235.62c-.05.51-.1,1.01-.15,1.51.94-.07,1.33-.89.82-1.31-.24-.2-.54-.2-.66-.2h0Z"
              />
              <path
                className="cls-107"
                d="M183.62,232.99c-.66.04-1.32.07-1.98.1-.05.8,1.08.96,1.69.41.24-.21.28-.41.3-.51h0Z"
              />
              <path
                className="cls-107"
                d="M179.66,233.18c-.66.03-1.32.05-1.98.08-.03.8,1.1.97,1.7.43.23-.21.27-.41.28-.51h0Z"
              />
            </g>
            <g className="cls-363">
              <path
                className="cls-107"
                d="M180.85,243.93c-.52.05-.92.32-1.02.7.59-.03,1.19-.06,1.78-.09.07-.48-.42-.63-.76-.61h0Z"
              />
              <path
                className="cls-107"
                d="M177.27,244.1c-.52.04-.91.31-.99.69.59-.02,1.19-.04,1.78-.07.05-.48-.44-.63-.79-.62h0Z"
              />
              <path
                className="cls-107"
                d="M183.21,241.12c-.91.09-1.34.84-.88,1.21.21.17.49.17.6.16.09-.45.19-.91.28-1.37h0Z"
              />
              <path
                className="cls-107"
                d="M179.52,241.31c-.89.07-1.3.83-.83,1.2.56.44,1.71-.04,1.64-.69-.03-.32-.37-.53-.81-.51h0Z"
              />
              <path
                className="cls-107"
                d="M175.82,241.46c-.06.46-.11.92-.17,1.37.89-.06,1.27-.81.8-1.19-.23-.18-.51-.18-.63-.18h0Z"
              />
              <path
                className="cls-107"
                d="M182.67,239.05c-.63.03-1.26.07-1.89.1-.07.75.99.88,1.59.37.23-.19.27-.38.3-.47h0Z"
              />
              <path
                className="cls-107"
                d="M178.9,239.23c-.63.03-1.26.05-1.88.07-.04.73,1.03.88,1.61.39.22-.19.26-.38.28-.46h0Z"
              />
            </g>
            <g className="cls-368">
              <path
                className="cls-107"
                d="M179.76,248.93c-.49.04-.87.29-.97.62.56-.03,1.11-.05,1.67-.08.08-.43-.37-.56-.69-.54h0Z"
              />
              <path
                className="cls-107"
                d="M176.41,249.08c-.49.04-.86.28-.94.61.55-.02,1.11-.04,1.66-.07.06-.42-.4-.56-.72-.55h0Z"
              />
              <path
                className="cls-107"
                d="M182.05,246.41c-.91.08-1.24.78-.86,1.09.19.15.45.15.56.15.1-.4.2-.81.3-1.23h0Z"
              />
              <path
                className="cls-107"
                d="M178.58,246.59c-.86.07-1.25.74-.81,1.08.52.41,1.6-.02,1.56-.62-.02-.29-.33-.47-.75-.45h0Z"
              />
              <path
                className="cls-107"
                d="M175.11,246.73c-.06.41-.12.82-.19,1.23.8-.06,1.18-.68.82-1.02-.21-.2-.53-.2-.63-.2h0Z"
              />
              <path
                className="cls-107"
                d="M181.61,244.54c-.59.03-1.19.06-1.78.09-.08.68.91.8,1.49.34.22-.18.27-.35.29-.43h0Z"
              />
              <path
                className="cls-107"
                d="M178.05,244.71c-.59.02-1.19.05-1.78.07-.05.68.94.81,1.5.35.21-.17.25-.34.27-.42h0Z"
              />
            </g>
            <g className="cls-365">
              <path
                className="cls-107"
                d="M180.8,251.12c-.85.08-1.18.69-.84.96.17.13.41.13.51.13.11-.35.22-.71.33-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M177.56,251.28c-.76.06-1.15.6-.83.91.43.41,1.53.04,1.51-.51,0-.25-.29-.42-.68-.4h0Z"
              />
              <path
                className="cls-107"
                d="M180.45,249.47c-.56.03-1.11.06-1.67.08-.1.59.82.7,1.38.29.21-.15.26-.3.29-.38h0Z"
              />
              <path
                className="cls-107"
                d="M177.13,249.63c-.55.02-1.11.05-1.66.07-.07.59.86.71,1.4.31.2-.15.25-.3.27-.37h0Z"
              />
            </g>
            <g className="cls-362">
              <path
                className="cls-107"
                d="M173.74,104.05c-.51.04-.83.46-.82,1.06.59-.01,1.19-.03,1.78-.05-.09-.76-.62-1.02-.96-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M170.22,104.13c-.51.04-.84.45-.84,1.05.59,0,1.18-.02,1.77-.03-.07-.76-.6-1.02-.93-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M175.13,99.92c-.87.08-1,1.28-.39,1.82.24.21.46.21.57.22-.06-.68-.12-1.36-.18-2.03h0Z"
              />
              <path
                className="cls-107"
                d="M171.73,100.01c-.88.07-1.04,1.27-.44,1.81.59.54,1.41.04,1.36-.82-.04-.57-.44-1.01-.92-.99h0Z"
              />
            </g>
            <g className="cls-366">
              <path
                className="cls-107"
                d="M170.57,112.53c-.54.04-.89.46-.9,1.08.63,0,1.25-.02,1.88-.03-.07-.78-.62-1.06-.98-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M175.84,108.17c-.93.08-1.09,1.32-.44,1.88.25.21.49.22.6.22-.05-.7-.11-1.41-.17-2.1h0Z"
              />
              <path
                className="cls-107"
                d="M172.21,108.27c-.93.07-1.12,1.31-.48,1.88.62.55,1.5.04,1.45-.85-.04-.59-.46-1.04-.97-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M168.59,108.33c.02.7.04,1.4.06,2.11.94-.07,1.15-1.3.52-1.88-.24-.21-.47-.23-.58-.23h0Z"
              />
              <path
                className="cls-107"
                d="M174.7,105.06c-.59.02-1.19.03-1.78.05.11,1.01,1.1,1.31,1.57.69.22-.29.21-.61.2-.74h0Z"
              />
              <path
                className="cls-107"
                d="M171.15,105.15c-.59.01-1.18.02-1.77.03.08,1.02,1.06,1.33,1.55.71.23-.28.22-.6.22-.74h0Z"
              />
            </g>
            <g className="cls-364">
              <path
                className="cls-107"
                d="M170.89,121.18c-.57.04-.94.48-.95,1.11.66,0,1.31-.02,1.97-.03-.07-.8-.65-1.08-1.02-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M176.48,116.69c-.98.09-1.16,1.36-.49,1.94.26.22.51.23.63.23-.05-.72-.1-1.45-.15-2.17h0Z"
              />
              <path
                className="cls-107"
                d="M168.82,116.86c.02.72.04,1.44.05,2.17,1-.07,1.22-1.34.56-1.93-.25-.22-.5-.23-.61-.24h0Z"
              />
              <path
                className="cls-107"
                d="M171.55,113.58c-.63.01-1.25.02-1.88.03.08,1.05,1.11,1.37,1.64.73.24-.29.24-.62.24-.76h0Z"
              />
            </g>
            <g className="cls-202">
              <path
                className="cls-107"
                d="M170.16,131.18c.02-.65.41-1.09,1-1.14.6.02,1.01.44,1.06,1.1-.69.01-1.37.02-2.06.03h0Z"
              />
              <path
                className="cls-107"
                d="M170.05,126.83c-.02.33-.26.96-.98,1.01-.02-.75-.03-1.49-.05-2.23.76.03,1.06.73,1.03,1.22h0Z"
              />
              <path
                className="cls-107"
                d="M171.91,122.37c-.05.91-1.06,1.33-1.66.69-.28-.29-.3-.63-.31-.77.66,0,1.31-.02,1.97-.03,0,.03,0,.08,0,.11h0Z"
              />
            </g>
            <g className="cls-203">
              <path
                className="cls-107"
                d="M175.64,138.99c-.63.05-1.02.5-1.03,1.17.71-.02,1.42-.04,2.14-.06-.07-.83-.7-1.12-1.11-1.11h0Z"
              />
              <path
                className="cls-107"
                d="M171.39,139.08c-.62.04-1.02.49-1.04,1.16.71,0,1.42-.02,2.13-.04-.06-.9-.74-1.13-1.09-1.12h0Z"
              />
              <path
                className="cls-107"
                d="M177.54,134.38c-1.07.09-1.29,1.43-.57,2.03.28.23.55.24.68.24-.04-.76-.07-1.52-.11-2.27h0Z"
              />
              <path
                className="cls-107"
                d="M173.37,134.5c-1.07.08-1.31,1.42-.6,2.03.7.59,1.72.03,1.68-.92-.02-.62-.51-1.12-1.08-1.1h0Z"
              />
              <path
                className="cls-107"
                d="M172.22,131.15c-.69.01-1.37.02-2.06.03.08,1.1,1.2,1.43,1.78.76.27-.31.27-.65.27-.8h0Z"
              />
            </g>
            <g className="cls-200">
              <path
                className="cls-107"
                d="M175.95,148.16c-.64.05-1.05.5-1.07,1.18.73-.02,1.46-.04,2.2-.06-.07-.84-.71-1.13-1.13-1.12h0Z"
              />
              <path
                className="cls-107"
                d="M171.58,148.26c-.64.04-1.05.49-1.07,1.17.73-.01,1.46-.02,2.19-.04-.06-.91-.75-1.14-1.11-1.13h0Z"
              />
              <path
                className="cls-107"
                d="M177.95,143.49c-1.11.1-1.36,1.45-.61,2.06.28.23.56.23.7.24-.03-.77-.06-1.53-.09-2.29h0Z"
              />
              <path
                className="cls-107"
                d="M173.64,143.61c-1.11.09-1.37,1.43-.63,2.05.76.63,1.86-.03,1.73-1.04-.07-.59-.55-1.02-1.1-1h0Z"
              />
              <path
                className="cls-107"
                d="M169.34,143.68c.01.76.02,1.53.03,2.3,1.11-.07,1.39-1.42.66-2.04-.28-.24-.55-.25-.69-.25h0Z"
              />
              <path
                className="cls-107"
                d="M176.75,140.1c-.71.02-1.42.04-2.14.06.09,1.11,1.26,1.44,1.86.76.28-.32.28-.67.28-.81h0Z"
              />
              <path
                className="cls-107"
                d="M172.48,140.2c-.71.01-1.42.03-2.13.04.07,1.12,1.24,1.45,1.84.78.28-.31.29-.66.29-.81h0Z"
              />
            </g>
            <g className="cls-201">
              <path
                className="cls-107"
                d="M171.72,157.54c-.65.05-1.08.5-1.1,1.18.74-.01,1.49-.02,2.23-.04-.06-.92-.76-1.15-1.13-1.14h0Z"
              />
              <path
                className="cls-107"
                d="M178.28,152.72c-1.14.1-1.4,1.46-.65,2.08.29.23.58.24.71.24-.02-.77-.04-1.55-.07-2.32h0Z"
              />
              <path
                className="cls-107"
                d="M173.86,152.84c-1.14.09-1.42,1.45-.66,2.07.77.64,1.9-.04,1.78-1.06-.07-.59-.55-1.03-1.12-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M177.08,149.28c-.73.02-1.46.04-2.2.06.08,1.13,1.28,1.45,1.9.76.29-.32.29-.67.3-.82h0Z"
              />
              <path
                className="cls-107"
                d="M172.69,149.39c-.73.01-1.46.03-2.19.04.07,1.13,1.26,1.47,1.88.78.29-.32.3-.67.3-.82h0Z"
              />
            </g>
            <g className="cls-198">
              <path
                className="cls-107"
                d="M170.69,168.06c.03-.68.47-1.15,1.12-1.2.66.02,1.1.47,1.14,1.16-.75.01-1.51.03-2.26.04h0Z"
              />
              <path
                className="cls-107"
                d="M175.15,163.41c-.09,1.05-1.33,1.46-1.98.67-.56-.68-.19-1.85.84-1.92.85.03,1.18.75,1.14,1.26h0Z"
              />
              <path
                className="cls-107"
                d="M172.85,158.8c-.09,1.04-1.32,1.45-1.96.65-.24-.29-.25-.59-.26-.74.74-.01,1.49-.02,2.23-.04,0,.04,0,.08,0,.12h0Z"
              />
            </g>
            <g className="cls-199">
              <path
                className="cls-107"
                d="M170.72,177.4c.03-.67.48-1.14,1.14-1.18.67.02,1.11.46,1.14,1.15-.76.01-1.52.03-2.28.04h0Z"
              />
              <path
                className="cls-107"
                d="M172.95,168.14c-.09,1.05-1.34,1.46-1.99.66-.24-.29-.26-.59-.26-.74.75-.01,1.51-.02,2.26-.04,0,.04,0,.08,0,.12h0Z"
              />
            </g>
            <g className="cls-204">
              <path
                className="cls-107"
                d="M176.42,185.44c-.66.05-1.12.51-1.16,1.18.76-.02,1.53-.04,2.29-.06-.04-.84-.7-1.12-1.13-1.11h0Z"
              />
              <path
                className="cls-107"
                d="M171.85,185.54c-.66.04-1.11.5-1.14,1.16.76-.01,1.52-.02,2.28-.04-.04-.84-.7-1.13-1.13-1.13h0Z"
              />
              <path
                className="cls-107"
                d="M178.71,180.73c-1.17.1-1.49,1.47-.73,2.09.29.23.58.24.73.24,0-.25,0-.5,0-.76,0-.52,0-1.05,0-1.57h0Z"
              />
              <path
                className="cls-107"
                d="M174.14,180.85c-1.17.09-1.49,1.45-.73,2.08.78.64,1.96-.03,1.86-1.06-.06-.59-.54-1.03-1.13-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M169.58,180.93c0,.52,0,1.05,0,1.57,0,.25,0,.51,0,.76,1.18-.07,1.49-1.44.73-2.08-.29-.24-.58-.25-.72-.26h0Z"
              />
              <path
                className="cls-107"
                d="M173,177.36c-.76.01-1.52.03-2.28.04.06,1.15,1.29,1.5,1.95.8.31-.32.32-.69.33-.84h0Z"
              />
            </g>
            <g className="cls-197">
              <path
                className="cls-107"
                d="M176.33,194.43c-.66.05-1.12.49-1.16,1.12.76-.02,1.52-.04,2.27-.06-.03-.8-.68-1.07-1.12-1.06h0Z"
              />
              <path
                className="cls-107"
                d="M171.79,194.53c-.65.04-1.1.48-1.14,1.11.75-.01,1.51-.02,2.26-.04-.03-.8-.69-1.08-1.12-1.07h0Z"
              />
              <path
                className="cls-107"
                d="M178.66,189.92c-1.17.1-1.5,1.41-.75,2,.28.22.58.23.72.23.01-.74.02-1.48.03-2.23h0Z"
              />
              <path
                className="cls-107"
                d="M174.1,190.05c-1.17.08-1.49,1.4-.74,1.99.79.63,1.95-.01,1.86-1.02-.05-.57-.53-.99-1.12-.98h0Z"
              />
              <path
                className="cls-107"
                d="M169.55,190.12c0,.75,0,1.49-.01,2.23,1.1-.07,1.47-1.28.81-1.92-.31-.3-.65-.31-.8-.32h0Z"
              />
              <path
                className="cls-107"
                d="M177.55,186.55c-.76.02-1.53.04-2.29.06.05,1.1,1.29,1.43,1.95.75.31-.32.33-.67.34-.82h0Z"
              />
              <path
                className="cls-107"
                d="M172.99,186.66c-.76.01-1.52.03-2.28.04.05,1.11,1.28,1.44,1.94.78.31-.31.33-.66.34-.81h0Z"
              />
            </g>
            <g className="cls-205">
              <path
                className="cls-107"
                d="M176.17,203c-.65.05-1.11.47-1.15,1.07.75-.02,1.5-.04,2.24-.06-.02-.76-.66-1.02-1.09-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M171.68,203.1c-.65.04-1.09.46-1.13,1.06.74-.01,1.49-.02,2.23-.04-.03-.76-.67-1.03-1.1-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M178.52,198.7c-1.09.09-1.47,1.25-.84,1.84.3.28.64.28.79.28.02-.7.04-1.41.05-2.13h0Z"
              />
              <path
                className="cls-107"
                d="M174,198.83c-1.09.08-1.46,1.23-.82,1.83.7.66,1.91.16,1.93-.79.01-.6-.48-1.05-1.11-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M169.49,198.91c0,.71-.01,1.42-.02,2.13,1.09-.06,1.46-1.22.81-1.82-.3-.28-.65-.3-.79-.3h0Z"
              />
              <path
                className="cls-107"
                d="M177.45,195.49c-.76.02-1.52.04-2.27.06.04,1.12,1.37,1.38,2,.64.24-.28.26-.57.27-.7h0Z"
              />
              <path
                className="cls-107"
                d="M172.91,195.6c-.75.01-1.51.03-2.26.04.05,1.12,1.37,1.4,2,.66.24-.28.26-.56.26-.7h0Z"
              />
            </g>
            <g className="cls-206">
              <path
                className="cls-107"
                d="M175.93,211.11c-.64.05-1.09.44-1.14,1.01.73-.02,1.47-.04,2.2-.06-.01-.72-.64-.96-1.06-.95h0Z"
              />
              <path
                className="cls-107"
                d="M171.52,211.21c-.64.04-1.07.43-1.12,1,.73-.01,1.46-.02,2.19-.04-.02-.72-.65-.97-1.07-.96h0Z"
              />
              <path
                className="cls-107"
                d="M178.28,207.04c-1.08.09-1.46,1.19-.85,1.75.29.26.63.27.77.27.03-.67.05-1.34.07-2.02h0Z"
              />
              <path
                className="cls-107"
                d="M173.83,207.16c-1.08.07-1.45,1.18-.82,1.74.72.65,1.98.08,1.9-.86-.04-.52-.51-.9-1.08-.89h0Z"
              />
              <path
                className="cls-107"
                d="M169.39,207.24c0,.68-.02,1.35-.03,2.02,1.09-.06,1.45-1.14.81-1.73-.3-.27-.63-.28-.78-.29h0Z"
              />
              <path
                className="cls-107"
                d="M177.26,204c-.75.02-1.5.04-2.24.06.03,1.06,1.34,1.31,1.97.6.24-.27.26-.54.27-.66h0Z"
              />
              <path
                className="cls-107"
                d="M172.78,204.12c-.74.01-1.49.03-2.23.04.04,1.06,1.34,1.32,1.97.62.24-.27.26-.53.27-.66h0Z"
              />
            </g>
            <g className="cls-210">
              <path
                className="cls-107"
                d="M175.61,218.76c-.64.04-1.06.41-1.12.95.71-.02,1.43-.04,2.14-.06,0-.67-.61-.9-1.02-.89h0Z"
              />
              <path
                className="cls-107"
                d="M171.32,218.86c-.63.04-1.05.4-1.09.94.71,0,1.42-.02,2.13-.04-.02-.73-.69-.91-1.04-.9h0Z"
              />
              <path
                className="cls-107"
                d="M177.95,214.93c-1.07.08-1.45,1.11-.85,1.65.28.25.61.25.75.25.03-.63.06-1.26.1-1.9h0Z"
              />
              <path
                className="cls-107"
                d="M173.6,215.05c-1.07.07-1.44,1.09-.82,1.64.7.62,1.93.08,1.87-.81-.04-.48-.49-.84-1.05-.83h0Z"
              />
              <path
                className="cls-107"
                d="M169.26,215.12c-.01.64-.03,1.27-.04,1.9,1.05-.06,1.41-1.09.8-1.63-.29-.26-.62-.27-.76-.27h0Z"
              />
              <path
                className="cls-107"
                d="M176.99,212.06c-.73.02-1.47.04-2.2.06.02,1,1.3,1.23,1.92.57.24-.25.26-.51.28-.63h0Z"
              />
              <path
                className="cls-107"
                d="M172.59,212.17c-.73.01-1.46.03-2.19.04.04,1,1.31,1.25,1.93.59.23-.25.25-.5.26-.62h0Z"
              />
            </g>
            <g className="cls-213">
              <path
                className="cls-107"
                d="M175.22,225.92c-.62.04-1.03.38-1.09.89.69-.02,1.38-.04,2.07-.06,0-.63-.58-.84-.98-.83h0Z"
              />
              <path
                className="cls-107"
                d="M171.07,226.01c-.61.04-1.02.37-1.07.87.69,0,1.37-.02,2.06-.03,0-.68-.66-.84-1-.84h0Z"
              />
              <path
                className="cls-107"
                d="M177.53,222.33c-1.02.08-1.42,1.05-.84,1.54.27.23.59.23.73.23.04-.59.08-1.18.12-1.77h0Z"
              />
              <path
                className="cls-107"
                d="M173.31,222.45c-1.03.07-1.4,1.03-.81,1.53.67.56,1.87.06,1.82-.76-.03-.45-.47-.79-1.01-.77h0Z"
              />
              <path
                className="cls-107"
                d="M169.09,222.52c-.01.6-.03,1.19-.05,1.77,1.02-.05,1.37-1.01.78-1.52-.28-.24-.6-.25-.74-.25h0Z"
              />
              <path
                className="cls-107"
                d="M176.63,219.65c-.71.02-1.43.04-2.14.06.01.94,1.25,1.15,1.87.53.24-.24.26-.47.28-.59h0Z"
              />
              <path
                className="cls-107"
                d="M172.36,219.76c-.71.01-1.42.03-2.13.04.03.94,1.27,1.17,1.87.55.23-.24.25-.47.26-.58h0Z"
              />
            </g>
            <g className="cls-214">
              <path
                className="cls-107"
                d="M174.77,232.56c-.59.04-1,.35-1.06.82.66-.02,1.33-.04,1.99-.06.01-.58-.55-.77-.93-.76h0Z"
              />
              <path
                className="cls-107"
                d="M170.78,232.65c-.59.03-.98.34-1.03.81.66,0,1.32-.02,1.98-.03,0-.62-.62-.78-.95-.77h0Z"
              />
              <path
                className="cls-107"
                d="M177.04,229.24c-.99.07-1.38.97-.83,1.43.25.21.56.21.69.21.05-.54.09-1.09.14-1.64h0Z"
              />
              <path
                className="cls-107"
                d="M172.96,229.35c-.99.06-1.35.96-.79,1.42.64.52,1.8.06,1.76-.7-.03-.42-.44-.73-.97-.72h0Z"
              />
              <path
                className="cls-107"
                d="M176.2,226.74c-.69.02-1.38.04-2.07.06,0,.87,1.2,1.07,1.8.49.23-.22.26-.44.27-.55h0Z"
              />
              <path
                className="cls-107"
                d="M172.07,226.85c-.69.01-1.38.02-2.06.03.02.87,1.22,1.09,1.8.51.22-.22.25-.44.26-.54h0Z"
              />
            </g>
            <g className="cls-215">
              <path
                className="cls-107"
                d="M174.26,238.66c-.56.04-.96.33-1.02.76.63-.02,1.26-.03,1.89-.05.02-.53-.51-.71-.87-.7h0Z"
              />
              <path
                className="cls-107"
                d="M170.45,238.75c-.11,0-.41.02-.69.23-.22.17-.24.28-.29.52.62,0,1.25-.02,1.87-.03,0-.57-.59-.72-.9-.71h0Z"
              />
              <path
                className="cls-107"
                d="M176.47,235.62c-.96.07-1.34.89-.81,1.31.24.2.53.2.66.2.05-.5.1-1,.15-1.51h0Z"
              />
              <path
                className="cls-107"
                d="M172.57,235.73c-.94.06-1.3.88-.77,1.3.6.48,1.72.05,1.69-.64-.02-.39-.41-.67-.92-.66h0Z"
              />
              <path
                className="cls-107"
                d="M175.7,233.32c-.66.02-1.33.04-1.99.06,0,.8,1.14.98,1.72.45.22-.21.25-.41.27-.51h0Z"
              />
              <path
                className="cls-107"
                d="M171.73,233.42c-.66.01-1.32.02-1.98.03.02.86,1.25,1.02,1.79.41.16-.18.18-.34.19-.44h0Z"
              />
            </g>
            <g className="cls-208">
              <path
                className="cls-107"
                d="M173.68,244.22c-.52.03-.91.3-.97.68.6-.01,1.19-.03,1.79-.05.03-.48-.47-.64-.81-.63h0Z"
              />
              <path
                className="cls-107"
                d="M175.82,241.46c-.91.06-1.28.81-.79,1.19.22.18.5.18.62.18.06-.45.12-.91.17-1.37h0Z"
              />
              <path
                className="cls-107"
                d="M172.12,241.56c-.85.05-1.22.74-.8,1.14.54.51,1.69.14,1.66-.54-.01-.35-.38-.61-.86-.6h0Z"
              />
              <path
                className="cls-107"
                d="M175.13,239.36c-.63.02-1.26.04-1.89.05-.02.78,1.15.91,1.69.35.16-.17.19-.31.2-.41h0Z"
              />
              <path
                className="cls-107"
                d="M171.35,239.46c-.62.01-1.25.02-1.87.03-.09.48.78.97,1.5.53.33-.21.37-.47.38-.56h0Z"
              />
            </g>
            <g className="cls-212">
              <path
                className="cls-107"
                d="M173.05,249.19c-.49.03-.85.27-.92.6.56-.01,1.11-.03,1.67-.05.04-.42-.43-.56-.75-.56h0Z"
              />
              <path
                className="cls-107"
                d="M175.11,246.73c-.87.06-1.16.7-.82,1.03.21.2.52.2.63.2.06-.4.13-.81.19-1.23h0Z"
              />
              <path
                className="cls-107"
                d="M171.63,246.82c-.82.05-1.16.66-.77,1.02.5.45,1.58.12,1.57-.48,0-.31-.35-.54-.8-.53h0Z"
              />
              <path
                className="cls-107"
                d="M174.5,244.84c-.6.02-1.19.03-1.79.05-.03.71,1.07.82,1.59.32.16-.15.18-.28.2-.37h0Z"
              />
            </g>
            <g className="cls-209">
              <path
                className="cls-107"
                d="M173.79,249.81c-.18.59-1.36.74-1.62.21-.04-.09-.04-.15-.04-.22.56-.01,1.11-.03,1.67-.05,0,.02,0,.04-.01.06h0Z"
              />
            </g>
            <g className="cls-207">
              <path
                className="cls-107"
                d="M165.93,113.64c.02-.63.37-1.04.92-1.07.54.03.91.44.95,1.06-.62,0-1.25,0-1.87.01h0Z"
              />
              <path
                className="cls-107"
                d="M168.65,110.43c-.95-.05-1.23-1.28-.63-1.86.22-.22.46-.24.57-.24.02.7.04,1.4.06,2.11h0Z"
              />
              <path
                className="cls-107"
                d="M165.76,109.95c-.09.16-.21.29-.36.39.11-.14.22-.26.37-.4,0,0,0,.01,0,.02h0Z"
              />
            </g>
            <g className="cls-211">
              <path
                className="cls-107"
                d="M166.97,121.22c-.57.04-.95.46-.97,1.1.66,0,1.31,0,1.97-.01-.05-.8-.63-1.09-1-1.09h0Z"
              />
              <path
                className="cls-107"
                d="M163.05,121.23c-.56.03-.95.46-.99,1.09.65,0,1.31,0,1.96.01-.03-.8-.6-1.1-.97-1.1h0Z"
              />
              <path
                className="cls-107"
                d="M168.82,116.86c-.99.07-1.22,1.34-.57,1.93.25.23.5.24.62.24-.02-.73-.04-1.45-.05-2.17h0Z"
              />
              <path
                className="cls-107"
                d="M164.99,116.88c-.99.06-1.25,1.32-.61,1.92.63.59,1.59.08,1.58-.84,0-.6-.44-1.08-.97-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M161.18,116.86c-.01.72-.03,1.44-.04,2.17.99-.05,1.28-1.31.64-1.92-.24-.23-.48-.24-.6-.25h0Z"
              />
              <path
                className="cls-107"
                d="M167.8,113.63c-.62,0-1.25,0-1.87.01.05,1.05,1.08,1.38,1.61.75.25-.29.26-.62.26-.76h0Z"
              />
            </g>
            <g className="cls-216">
              <path
                className="cls-107"
                d="M167.07,130.09c-.6.04-.99.47-1.01,1.12.68,0,1.37,0,2.05-.01-.05-.82-.65-1.11-1.04-1.11h0Z"
              />
              <path
                className="cls-107"
                d="M169.02,125.61c-1.03.07-1.28,1.38-.6,1.98.26.23.52.24.65.25-.02-.75-.03-1.49-.05-2.23h0Z"
              />
              <path
                className="cls-107"
                d="M165.01,125.63c-1.03.06-1.31,1.36-.64,1.98.65.6,1.66.08,1.65-.86,0-.62-.46-1.12-1.02-1.12h0Z"
              />
              <path
                className="cls-107"
                d="M161.02,125.61c-.01.74-.03,1.49-.04,2.23,1.03-.05,1.33-1.35.67-1.97-.25-.24-.51-.25-.63-.26h0Z"
              />
              <path
                className="cls-107"
                d="M167.97,122.31c-.66,0-1.31,0-1.97.01.06,1.07,1.13,1.41,1.69.77.26-.3.27-.64.28-.78h0Z"
              />
              <path
                className="cls-107"
                d="M164.02,122.33c-.66,0-1.31,0-1.96-.01.04,1.08,1.1,1.43,1.68.79.27-.3.28-.63.29-.78h0Z"
              />
            </g>
            <g className="cls-194">
              <path
                className="cls-107"
                d="M167.16,139.13c-.62.04-1.02.47-1.05,1.14.71,0,1.42,0,2.12-.01-.05-.83-.67-1.13-1.07-1.13h0Z"
              />
              <path
                className="cls-107"
                d="M162.92,139.13c-.62.03-1.03.46-1.07,1.13.71,0,1.41,0,2.12.01-.04-.9-.71-1.14-1.05-1.14h0Z"
              />
              <path
                className="cls-107"
                d="M165.03,134.59c-1.07.06-1.35,1.39-.66,2.01.68.61,1.72.08,1.72-.88,0-.62-.48-1.13-1.06-1.13h0Z"
              />
              <path
                className="cls-107"
                d="M161.85,135.35s.02.07.03.11c0-.04-.02-.07-.03-.11h0Z"
              />
              <path
                className="cls-107"
                d="M168.11,131.2c-.68,0-1.37,0-2.05.01.06,1.1,1.17,1.44,1.76.78.28-.31.29-.65.29-.79h0Z"
              />
            </g>
            <g className="cls-189">
              <path
                className="cls-107"
                d="M167.22,148.31c-.64.04-1.05.48-1.08,1.16.73,0,1.45,0,2.18-.01-.05-.84-.68-1.15-1.1-1.15h0Z"
              />
              <path
                className="cls-107"
                d="M162.87,148.31c-.64.03-1.06.47-1.09,1.15.73,0,1.45,0,2.18.01-.04-.91-.73-1.16-1.08-1.16h0Z"
              />
              <path
                className="cls-107"
                d="M169.34,143.68c-1.11.07-1.39,1.42-.66,2.04.28.24.56.25.69.25-.01-.77-.02-1.53-.03-2.3h0Z"
              />
              <path
                className="cls-107"
                d="M165.04,143.71c-1.11.06-1.4,1.4-.68,2.03.74.65,1.87.01,1.76-1.01-.06-.58-.53-1.03-1.08-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M160.75,143.68c0,.76-.02,1.53-.03,2.3,1.11-.05,1.41-1.39.7-2.03-.27-.24-.54-.26-.68-.27h0Z"
              />
              <path
                className="cls-107"
                d="M168.23,140.26c-.71,0-1.42.01-2.12.01.06,1.11,1.21,1.46,1.82.8.29-.31.3-.66.3-.81h0Z"
              />
              <path
                className="cls-107"
                d="M163.97,140.28c-.71,0-1.41,0-2.12-.01.04,1.12,1.19,1.48,1.81.82.29-.31.3-.66.31-.8h0Z"
              />
            </g>
            <g className="cls-188">
              <path
                className="cls-107"
                d="M167.27,157.59c-.65.04-1.08.48-1.11,1.17.74,0,1.48,0,2.23-.01-.05-.85-.69-1.16-1.12-1.16h0Z"
              />
              <path
                className="cls-107"
                d="M162.82,157.59c-.65.03-1.08.47-1.12,1.16.74,0,1.48,0,2.22.01-.04-.92-.74-1.17-1.11-1.17h0Z"
              />
              <path
                className="cls-107"
                d="M165.04,152.94c-1.14.06-1.44,1.42-.7,2.06.76.66,1.91.01,1.81-1.02-.06-.58-.54-1.04-1.11-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M160.65,152.92c0,.77-.01,1.55-.02,2.32,1.13-.05,1.44-1.4.72-2.05-.28-.25-.56-.26-.69-.27h0Z"
              />
              <path
                className="cls-107"
                d="M168.32,149.46c-.73,0-1.46.01-2.18.01.06,1.12,1.24,1.48,1.87.81.29-.32.31-.67.31-.82h0Z"
              />
              <path
                className="cls-107"
                d="M163.95,149.47c-.73,0-1.45,0-2.18-.01.05,1.13,1.22,1.5,1.86.83.29-.31.31-.66.32-.81h0Z"
              />
            </g>
            <g className="cls-193">
              <path
                className="cls-107"
                d="M168.39,158.86c-.09,1.02-1.35,1.42-1.97.63-.23-.29-.25-.59-.25-.74.74,0,1.48,0,2.23-.01,0,.04,0,.08,0,.12h0Z"
              />
              <path
                className="cls-107"
                d="M163.92,158.87c-.1,1.04-1.33,1.42-1.97.61-.23-.3-.24-.6-.25-.74.74,0,1.48,0,2.22.01,0,.04,0,.08,0,.12h0Z"
              />
            </g>
            <g className="cls-190">
              <path
                className="cls-107"
                d="M167.31,176.27c-.67.04-1.1.49-1.14,1.17.76,0,1.52,0,2.27-.01-.04-.85-.7-1.16-1.14-1.16h0Z"
              />
              <path
                className="cls-107"
                d="M162.76,176.27c-.66.03-1.1.49-1.14,1.16.76,0,1.51.01,2.27.01-.04-.86-.7-1.17-1.13-1.17h0Z"
              />
              <path
                className="cls-107"
                d="M168.44,172.75s0,.13.04.31c0-.11-.02-.21-.04-.31h0Z"
              />
              <path
                className="cls-107"
                d="M165.03,171.6c-1.16.06-1.47,1.43-.72,2.07.78.67,1.96.02,1.86-1.02-.06-.59-.56-1.05-1.14-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M160.51,171.58c0,.78,0,1.56-.01,2.34,1.16-.05,1.48-1.41.73-2.06-.29-.25-.58-.27-.72-.27h0Z"
              />
            </g>
            <g className="cls-191">
              <path
                className="cls-107"
                d="M167.3,185.59c-.67.04-1.11.48-1.14,1.15.76,0,1.52,0,2.28-.01-.04-.84-.7-1.14-1.13-1.14h0Z"
              />
              <path
                className="cls-107"
                d="M162.74,185.59c-.66.03-1.1.48-1.14,1.14.76,0,1.51.01,2.27.01-.04-.84-.7-1.15-1.13-1.15h0Z"
              />
              <path
                className="cls-107"
                d="M169.58,180.93c-1.17.07-1.48,1.44-.73,2.07.29.24.58.25.72.26,0-.25,0-.51,0-.76,0-.52,0-1.05,0-1.57h0Z"
              />
              <path
                className="cls-107"
                d="M165.02,180.95c-1.17.06-1.48,1.42-.73,2.06.78.66,1.97.01,1.87-1.02-.06-.6-.55-1.04-1.14-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M160.48,180.93c0,.52,0,1.05,0,1.57,0,.25,0,.51,0,.76,1.17-.05,1.49-1.41.72-2.06-.29-.24-.58-.26-.72-.27h0Z"
              />
              <path
                className="cls-107"
                d="M168.45,177.43c-.76,0-1.52.01-2.27.01.05,1.14,1.28,1.51,1.94.82.31-.32.33-.68.33-.84h0Z"
              />
              <path
                className="cls-107"
                d="M163.89,177.44c-.76,0-1.51,0-2.27-.01.05,1.15,1.28,1.52,1.94.85.31-.32.32-.68.33-.83h0Z"
              />
            </g>
            <g className="cls-192">
              <path
                className="cls-107"
                d="M167.26,194.58c-.66.04-1.1.46-1.14,1.1.75,0,1.51,0,2.26-.01-.04-.8-.69-1.09-1.12-1.09h0Z"
              />
              <path
                className="cls-107"
                d="M162.73,194.58c-.65.03-1.09.45-1.13,1.09.75,0,1.5,0,2.25.01-.04-.8-.7-1.1-1.13-1.1h0Z"
              />
              <path
                className="cls-107"
                d="M169.55,190.12c-1.17.07-1.49,1.38-.73,1.99.29.23.58.24.72.25,0-.74,0-1.48.01-2.23h0Z"
              />
              <path
                className="cls-107"
                d="M165,190.15c-1.1.05-1.46,1.26-.8,1.91.71.7,1.94.19,1.95-.79,0-.62-.51-1.12-1.14-1.12h0Z"
              />
              <path
                className="cls-107"
                d="M160.47,190.13c0,.75,0,1.49,0,2.23,1.1-.04,1.45-1.25.8-1.9-.31-.3-.65-.33-.8-.33h0Z"
              />
              <path
                className="cls-107"
                d="M168.43,186.73c-.76,0-1.52.01-2.28.01.05,1.17,1.38,1.48,2.01.72.24-.29.26-.59.26-.73h0Z"
              />
              <path
                className="cls-107"
                d="M163.87,186.74c-.76,0-1.51,0-2.27-.01.06,1.18,1.39,1.5,2.01.74.24-.29.25-.58.26-.73h0Z"
              />
            </g>
            <g className="cls-195">
              <path
                className="cls-107"
                d="M167.21,203.15c-.66.03-1.09.43-1.12,1.04.74,0,1.49,0,2.23-.01-.03-.76-.68-1.03-1.11-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M162.73,203.15c-.64.03-1.08.43-1.11,1.03.74,0,1.48,0,2.23.01-.04-.76-.69-1.04-1.11-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M169.49,198.91c-1.09.06-1.45,1.22-.81,1.82.3.28.64.3.79.3,0-.7.01-1.41.02-2.13h0Z"
              />
              <path
                className="cls-107"
                d="M164.98,198.93c-1.09.05-1.44,1.2-.8,1.81.7.66,1.92.18,1.93-.75,0-.59-.5-1.06-1.13-1.06h0Z"
              />
              <path
                className="cls-107"
                d="M160.48,198.91c0,.71,0,1.42,0,2.13,1.09-.04,1.43-1.19.78-1.81-.3-.29-.65-.31-.79-.32h0Z"
              />
              <path
                className="cls-107"
                d="M168.39,195.67c-.75,0-1.51.01-2.26.01.05,1.11,1.37,1.41,2,.68.24-.28.26-.56.26-.7h0Z"
              />
              <path
                className="cls-107"
                d="M163.86,195.68c-.75,0-1.5,0-2.25-.01.06,1.12,1.38,1.43,2,.71.23-.27.25-.56.26-.69h0Z"
              />
            </g>
            <g className="cls-196">
              <path
                className="cls-107"
                d="M167.13,211.26c-.64.03-1.07.41-1.1.99.73,0,1.46,0,2.19-.01-.03-.72-.66-.98-1.08-.97h0Z"
              />
              <path
                className="cls-107"
                d="M162.74,211.26c-.63.03-1.06.41-1.09.97.73,0,1.45,0,2.18.01-.04-.72-.68-.98-1.09-.98h0Z"
              />
              <path
                className="cls-107"
                d="M169.39,207.24c-1.08.06-1.44,1.16-.81,1.74.3.27.63.28.78.29.01-.67.02-1.34.03-2.02h0Z"
              />
              <path
                className="cls-107"
                d="M164.95,207.26c-1.07.05-1.42,1.14-.78,1.73.68.62,1.89.17,1.9-.71,0-.56-.49-1.02-1.11-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M160.52,207.24c0,.68,0,1.35.01,2.02,1.09-.04,1.42-1.11.77-1.72-.3-.28-.64-.3-.78-.31h0Z"
              />
              <path
                className="cls-107"
                d="M168.31,204.18c-.74,0-1.49.01-2.23.01.05,1.06,1.35,1.33,1.97.65.24-.26.25-.53.26-.66h0Z"
              />
              <path
                className="cls-107"
                d="M163.84,204.19c-.74,0-1.48,0-2.23-.01.06,1.06,1.36,1.35,1.97.67.23-.26.25-.53.25-.65h0Z"
              />
            </g>
            <g className="cls-217">
              <path
                className="cls-107"
                d="M167.04,218.91c-.63.03-1.04.38-1.08.92.71,0,1.42,0,2.13-.01-.03-.67-.64-.91-1.05-.91h0Z"
              />
              <path
                className="cls-107"
                d="M169.26,215.12c-1.07.06-1.42,1.08-.79,1.63.29.25.62.27.76.27.01-.63.03-1.26.04-1.9h0Z"
              />
              <path
                className="cls-107"
                d="M168.21,212.23c-.73,0-1.46.01-2.19.01.05,1,1.32,1.26,1.93.61.23-.25.25-.5.26-.62h0Z"
              />
              <path
                className="cls-107"
                d="M163.83,212.25c-.73,0-1.46,0-2.18-.01.06,1,1.34,1.28,1.93.63.23-.25.24-.5.25-.62h0Z"
              />
            </g>
            <g className="cls-248">
              <path
                className="cls-107"
                d="M169.05,224.29c-.99-.03-1.31-.9-.77-1.44.3-.31.69-.33.82-.33-.01.6-.03,1.19-.05,1.77h0Z"
              />
              <path
                className="cls-107"
                d="M168.08,219.91c-.12.84-1.41,1.13-1.95.43-.16-.21-.17-.39-.17-.51.71,0,1.42,0,2.13-.01,0,.03,0,.07,0,.09h0Z"
              />
            </g>
            <g className="cls-252">
              <path
                className="cls-107"
                d="M158.14,122.26c.05-.64.44-1.06,1.01-1.08.56.04.93.48.95,1.11-.65,0-1.31-.02-1.96-.03h0Z"
              />
              <path
                className="cls-107"
                d="M161.14,119.03c-.99-.07-1.22-1.34-.57-1.93.25-.22.49-.23.61-.24-.01.72-.03,1.44-.04,2.17h0Z"
              />
            </g>
            <g className="cls-253">
              <path
                className="cls-107"
                d="M160.98,127.84c-1.03-.07-1.28-1.38-.6-1.98.26-.23.51-.24.64-.25-.01.74-.03,1.49-.04,2.23h0Z"
              />
              <path
                className="cls-107"
                d="M160.09,122.41c-.1.91-1.13,1.3-1.69.64-.25-.3-.26-.64-.26-.78.65.01,1.3.02,1.96.03,0,.03,0,.08,0,.11h0Z"
              />
            </g>
            <g className="cls-254">
              <path
                className="cls-107"
                d="M157.79,139.63s0-.02.01-.03c0,0,0,.01,0,.02-.1.18-.16.37-.16.59.02,0,.05,0,.08,0,0-.08,0-.13,0-.17,0-.07.01-.22.09-.4h0ZM158.25,140.22c.5,0,.99.02,1.49.02v-.05c-.03-.55-.36-.97-.86-1.08,0,.02-.01.05-.02.07-.09.27-.24.63-.61,1.05h0Z"
              />
            </g>
            <g className="cls-251">
              <path
                className="cls-107"
                d="M158.53,148.26c-.64.02-1.06.46-1.1,1.13.72.01,1.45.03,2.17.04-.03-.85-.65-1.16-1.07-1.17h0Z"
              />
              <path
                className="cls-107"
                d="M154.21,148.17c-.63.02-1.06.45-1.11,1.12.72.02,1.44.04,2.16.06-.02-.91-.69-1.17-1.05-1.18h0Z"
              />
              <path
                className="cls-107"
                d="M160.75,143.68c-1.11.05-1.42,1.39-.71,2.03.27.24.55.26.68.27,0-.77.02-1.53.03-2.3h0Z"
              />
              <path
                className="cls-107"
                d="M156.48,143.62c-1.11.04-1.44,1.37-.74,2.02.72.66,1.85.05,1.78-.97-.04-.58-.5-1.04-1.04-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M152.22,143.5c-.03.76-.06,1.53-.09,2.29,1.1-.02,1.44-1.35.75-2.01-.26-.25-.53-.27-.67-.28h0Z"
              />
              <path
                className="cls-107"
                d="M159.74,140.24c-.5,0-.99-.01-1.49-.02-.14.15-.26.27-.43.4-.07-.14-.1-.26-.11-.41-.03,0-.05,0-.08,0,.02,1.11,1.16,1.49,1.79.84.29-.31.32-.65.32-.8h0Z"
              />
            </g>
            <g className="cls-257">
              <path
                className="cls-107"
                d="M158.39,157.54c-.65.02-1.08.46-1.12,1.14.74.01,1.48.03,2.21.04-.03-.85-.67-1.17-1.09-1.18h0Z"
              />
              <path
                className="cls-107"
                d="M153.98,157.44c-.65.02-1.08.45-1.13,1.13.73.02,1.47.04,2.2.06-.03-.92-.72-1.18-1.08-1.19h0Z"
              />
              <path
                className="cls-107"
                d="M160.65,152.92c-1.13.05-1.45,1.4-.72,2.05.28.24.56.26.7.27,0-.77.01-1.55.02-2.32h0Z"
              />
              <path
                className="cls-107"
                d="M156.27,152.84c-1.14.04-1.47,1.39-.74,2.04.74.67,1.89.05,1.81-.98-.05-.58-.52-1.05-1.07-1.06h0Z"
              />
              <path
                className="cls-107"
                d="M151.91,152.73c-.02.77-.05,1.54-.07,2.32,1.12-.02,1.46-1.37.75-2.03-.27-.25-.55-.28-.69-.29h0Z"
              />
              <path
                className="cls-107"
                d="M159.6,149.43c-.72,0-1.45-.02-2.17-.04.03,1.13,1.2,1.51,1.84.85.3-.31.32-.66.33-.81h0Z"
              />
              <path
                className="cls-107"
                d="M155.26,149.35c-.72-.02-1.44-.04-2.16-.06.02,1.13,1.18,1.52,1.82.87.3-.3.32-.66.33-.81h0Z"
              />
            </g>
            <g className="cls-250">
              <path
                className="cls-107"
                d="M152.75,163.35c-.04.37-.33,1-1.12,1.01.01-.78.03-1.56.05-2.33.84.07,1.13.81,1.08,1.32h0Z"
              />
              <path
                className="cls-107"
                d="M159.48,158.84c-.11,1.02-1.36,1.39-1.97.59-.23-.3-.24-.6-.24-.74.74.01,1.48.03,2.21.04,0,.04,0,.08,0,.12h0Z"
              />
              <path
                className="cls-107"
                d="M155.05,158.75c-.12,1.04-1.34,1.39-1.96.57-.22-.3-.23-.6-.24-.75.73.02,1.47.04,2.2.06,0,.04,0,.08,0,.12h0Z"
              />
            </g>
            <g className="cls-255">
              <path
                className="cls-107"
                d="M158.23,176.22c-.66.02-1.1.46-1.13,1.15.75.01,1.51.03,2.26.04-.04-.86-.69-1.18-1.13-1.18h0Z"
              />
              <path
                className="cls-107"
                d="M153.71,176.12c-.65.02-1.09.46-1.13,1.14.75.02,1.5.04,2.25.06-.04-.86-.69-1.18-1.12-1.2h0Z"
              />
              <path
                className="cls-107"
                d="M160.51,171.58c-1.16.05-1.47,1.41-.73,2.06.29.25.58.27.72.28,0-.78,0-1.56.01-2.34h0Z"
              />
              <path
                className="cls-107"
                d="M156.01,171.5c-1.16.04-1.49,1.39-.74,2.05.77.68,1.94.05,1.85-.98-.05-.59-.54-1.06-1.11-1.07h0Z"
              />
              <path
                className="cls-107"
                d="M151.51,171.38c0,.78-.02,1.56-.03,2.34,1.15-.02,1.47-1.38.74-2.05-.28-.25-.57-.28-.71-.29h0Z"
              />
            </g>
            <g className="cls-256">
              <path
                className="cls-107"
                d="M158.21,185.54c-.66.02-1.1.45-1.13,1.13.75.01,1.51.03,2.26.04-.04-.84-.7-1.16-1.13-1.16h0Z"
              />
              <path
                className="cls-107"
                d="M153.68,185.44c-.65.02-1.09.45-1.12,1.11.75.02,1.5.04,2.25.06-.04-.84-.7-1.16-1.13-1.17h0Z"
              />
              <path
                className="cls-107"
                d="M160.48,180.93c-1.16.05-1.48,1.41-.72,2.06.29.25.58.27.72.27,0-.25,0-.5,0-.76,0-.52,0-1.05,0-1.57h0Z"
              />
              <path
                className="cls-107"
                d="M155.95,180.86c-1.17.03-1.49,1.39-.73,2.05.77.67,1.95.05,1.85-.98-.06-.6-.54-1.06-1.12-1.07h0Z"
              />
              <path
                className="cls-107"
                d="M151.44,180.73c0,.52,0,1.05,0,1.57,0,.25,0,.51,0,.76,1.16-.02,1.47-1.38.72-2.04-.28-.25-.58-.27-.72-.29h0Z"
              />
              <path
                className="cls-107"
                d="M159.36,177.4c-.75-.01-1.51-.02-2.26-.04.05,1.14,1.27,1.53,1.93.87.31-.31.33-.68.34-.83h0Z"
              />
              <path
                className="cls-107"
                d="M154.83,177.32c-.75-.02-1.5-.04-2.25-.06.05,1.15,1.26,1.55,1.92.89.3-.31.32-.67.33-.83h0Z"
              />
            </g>
            <g className="cls-249">
              <path
                className="cls-107"
                d="M158.22,194.53c-.66.02-1.09.43-1.12,1.07.75.01,1.5.03,2.25.04-.04-.8-.7-1.1-1.13-1.11h0Z"
              />
              <path
                className="cls-107"
                d="M153.72,194.44c-.65.01-1.08.43-1.11,1.06.74.02,1.49.04,2.24.06-.05-.8-.7-1.11-1.13-1.12h0Z"
              />
              <path
                className="cls-107"
                d="M160.47,190.13c-1.1.04-1.45,1.25-.8,1.9.31.31.65.33.8.34,0-.74,0-1.48,0-2.23h0Z"
              />
              <path
                className="cls-107"
                d="M155.95,190.05c-1.1.03-1.45,1.23-.79,1.89.72.72,1.93.26,1.92-.75,0-.62-.51-1.13-1.13-1.14h0Z"
              />
              <path
                className="cls-107"
                d="M151.45,189.93c0,.75.01,1.49.02,2.23,1.09-.02,1.43-1.22.78-1.88-.3-.31-.65-.34-.8-.35h0Z"
              />
              <path
                className="cls-107"
                d="M159.34,186.7c-.75-.01-1.51-.02-2.26-.04.06,1.17,1.38,1.51,2,.76.24-.28.25-.58.26-.72h0Z"
              />
              <path
                className="cls-107"
                d="M154.81,186.62c-.75-.02-1.5-.04-2.25-.06.06,1.18,1.38,1.53,2,.78.23-.28.25-.58.25-.72h0Z"
              />
            </g>
            <g className="cls-258">
              <path
                className="cls-107"
                d="M158.28,203.1c-.65.02-1.07.41-1.1,1.02.74.01,1.48.03,2.22.04-.05-.76-.69-1.05-1.12-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M153.83,203c-.64.01-1.06.41-1.08,1.01.73.02,1.47.04,2.21.06-.05-.76-.7-1.06-1.12-1.07h0Z"
              />
              <path
                className="cls-107"
                d="M160.48,198.91c-1.09.04-1.43,1.19-.78,1.81.3.29.64.31.79.32,0-.7,0-1.41,0-2.13h0Z"
              />
              <path
                className="cls-107"
                d="M156.01,198.83c-1.09.03-1.43,1.17-.78,1.8.72.69,1.91.25,1.9-.71,0-.59-.51-1.08-1.13-1.09h0Z"
              />
              <path
                className="cls-107"
                d="M151.55,198.71c.01.71.02,1.42.04,2.13,1.07-.02,1.4-1.16.76-1.79-.3-.3-.65-.32-.79-.34h0Z"
              />
              <path
                className="cls-107"
                d="M159.35,195.64c-.75-.01-1.5-.02-2.25-.04.06,1.12,1.38,1.44,1.99.73.23-.27.25-.55.25-.69h0Z"
              />
              <path
                className="cls-107"
                d="M154.85,195.56c-.75-.02-1.49-.04-2.24-.06.07,1.12,1.38,1.46,1.99.75.23-.27.24-.55.25-.69h0Z"
              />
            </g>
            <g className="cls-265">
              <path
                className="cls-107"
                d="M158.37,211.22c-.64.02-1.05.39-1.07.96.72.01,1.45.03,2.17.04-.05-.72-.69-.99-1.1-1h0Z"
              />
              <path
                className="cls-107"
                d="M154.01,211.12c-.63.01-1.04.38-1.05.95.72.02,1.44.04,2.16.06-.06-.72-.69-1-1.11-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M160.52,207.24c-1.07.04-1.41,1.13-.76,1.72.3.28.63.29.78.3,0-.67,0-1.34-.01-2.02h0Z"
              />
              <path
                className="cls-107"
                d="M156.12,207.17c-1.07.03-1.4,1.11-.75,1.71.71.65,1.88.23,1.86-.67,0-.56-.51-1.03-1.11-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M151.73,207.05c.02.68.04,1.35.06,2.02,1.07-.01,1.38-1.08.73-1.7-.3-.29-.64-.31-.78-.32h0Z"
              />
              <path
                className="cls-107"
                d="M159.4,204.16c-.74-.01-1.48-.02-2.22-.04.07,1.06,1.37,1.36,1.97.69.23-.26.24-.52.25-.65h0Z"
              />
              <path
                className="cls-107"
                d="M154.96,204.07c-.74-.02-1.47-.04-2.21-.06.08,1.07,1.38,1.38,1.97.71.22-.26.23-.52.24-.65h0Z"
              />
            </g>
            <g className="cls-260">
              <path
                className="cls-107"
                d="M159.47,212.31c-.09.9-1.4,1.17-1.98.41-.17-.23-.18-.42-.19-.55.72.01,1.45.03,2.17.04,0,.03,0,.07,0,.1h0Z"
              />
              <path
                className="cls-107"
                d="M155.12,212.23c-.08.89-1.38,1.15-1.96.39-.17-.23-.19-.42-.2-.55.72.02,1.44.04,2.16.06,0,.03,0,.07,0,.1h0Z"
              />
            </g>
            <g className="cls-261">
              <path
                className="cls-107"
                d="M152.14,145.79c-1.09-.09-1.33-1.45-.6-2.05.28-.23.55-.24.68-.24-.03.76-.06,1.53-.09,2.29h0Z"
              />
            </g>
            <g className="cls-259">
              <path
                className="cls-107"
                d="M148.46,158.42c.05-.68.49-1.11,1.13-1.12.64.06,1.05.52,1.06,1.2-.73-.03-1.46-.05-2.19-.08h0Z"
              />
              <path
                className="cls-107"
                d="M144.1,158.22c.06-.68.49-1.1,1.13-1.11.64.07,1.05.53,1.05,1.21-.73-.03-1.46-.07-2.18-.11h0Z"
              />
              <path
                className="cls-107"
                d="M151.84,155.04c-1.12-.1-1.38-1.46-.63-2.08.28-.23.56-.24.7-.24-.02.77-.05,1.54-.07,2.32h0Z"
              />
            </g>
            <g className="cls-266">
              <path
                className="cls-107"
                d="M151.67,162.03c-1.14.02-1.47,1.38-.75,2.04.28.25.56.28.7.29.01-.78.03-1.56.05-2.33h0Z"
              />
              <path
                className="cls-107"
                d="M147.27,161.86c-1.13.01-1.47,1.36-.76,2.03.74.7,1.9.1,1.82-.94-.04-.59-.51-1.07-1.07-1.09h0Z"
              />
              <path
                className="cls-107"
                d="M142.88,161.65c-.03.78-.05,1.55-.08,2.33,1.12,0,1.47-1.35.76-2.03-.27-.26-.55-.29-.69-.3h0Z"
              />
              <path
                className="cls-107"
                d="M150.65,158.5c-.73-.03-1.46-.05-2.19-.08.02,1.13,1.19,1.54,1.85.89.31-.31.33-.66.34-.81h0Z"
              />
              <path
                className="cls-107"
                d="M146.28,158.32c-.73-.03-1.46-.07-2.18-.11.01,1.13,1.18,1.55,1.83.91.31-.3.34-.66.35-.81h0Z"
              />
            </g>
            <g className="cls-263">
              <path
                className="cls-107"
                d="M149.23,175.98c-.65,0-1.09.45-1.13,1.12.74.03,1.49.06,2.24.09-.04-.86-.68-1.19-1.11-1.21h0Z"
              />
              <path
                className="cls-107"
                d="M144.76,175.78c-.64,0-1.08.44-1.12,1.11.74.04,1.49.08,2.23.11-.03-.86-.68-1.2-1.11-1.22h0Z"
              />
              <path
                className="cls-107"
                d="M151.51,171.38c-1.15.02-1.47,1.38-.73,2.05.28.26.57.28.71.29,0-.78.02-1.56.03-2.34h0Z"
              />
              <path
                className="cls-107"
                d="M147.06,171.21c-1.14.01-1.47,1.36-.74,2.04.75.7,1.92.1,1.83-.94-.05-.59-.53-1.07-1.09-1.1h0Z"
              />
            </g>
            <g className="cls-264">
              <path
                className="cls-107"
                d="M149.19,185.3c-.65,0-1.08.44-1.11,1.1.74.03,1.49.06,2.24.09-.04-.84-.7-1.17-1.12-1.19h0Z"
              />
              <path
                className="cls-107"
                d="M144.72,185.1c-.64,0-1.08.43-1.1,1.09.74.04,1.49.08,2.23.11-.05-.84-.7-1.18-1.13-1.2h0Z"
              />
              <path
                className="cls-107"
                d="M151.44,180.73c-1.15.02-1.46,1.37-.72,2.04.28.25.57.28.71.29,0-.25,0-.5,0-.76,0-.52,0-1.05,0-1.57h0Z"
              />
              <path
                className="cls-107"
                d="M146.96,180.56c-1.15,0-1.46,1.36-.72,2.03.76.7,1.92.1,1.82-.94-.06-.6-.53-1.07-1.11-1.09h0Z"
              />
              <path
                className="cls-107"
                d="M142.51,180.34c0,.52,0,1.05,0,1.57,0,.25,0,.51,0,.76,1.14,0,1.45-1.35.71-2.03-.28-.26-.57-.29-.71-.3h0Z"
              />
              <path
                className="cls-107"
                d="M150.34,177.18c-.75-.03-1.49-.05-2.24-.09.05,1.14,1.25,1.56,1.9.91.31-.31.33-.67.33-.82h0Z"
              />
              <path
                className="cls-107"
                d="M145.87,177c-.74-.03-1.49-.07-2.23-.11.04,1.17,1.23,1.59,1.89.93.31-.3.33-.66.34-.82h0Z"
              />
            </g>
            <g className="cls-267">
              <path
                className="cls-107"
                d="M149.26,194.29c-.64,0-1.07.42-1.09,1.05.74.03,1.48.06,2.22.08-.05-.8-.7-1.12-1.13-1.13h0Z"
              />
              <path
                className="cls-107"
                d="M144.82,194.1c-.64,0-1.06.41-1.08,1.04.74.04,1.48.07,2.22.11-.06-.8-.71-1.13-1.13-1.15h0Z"
              />
              <path
                className="cls-107"
                d="M151.45,189.93c-1.09.02-1.43,1.22-.78,1.88.31.31.65.34.79.35,0-.74-.01-1.48-.02-2.23h0Z"
              />
              <path
                className="cls-107"
                d="M146.99,189.76c-1.08,0-1.41,1.2-.77,1.87.7.73,1.9.28,1.89-.7,0-.62-.51-1.14-1.12-1.17h0Z"
              />
              <path
                className="cls-107"
                d="M142.54,189.54c0,.75.02,1.49.03,2.23,1.07,0,1.4-1.19.76-1.87-.3-.32-.64-.35-.79-.37h0Z"
              />
              <path
                className="cls-107"
                d="M150.32,186.48c-.75-.03-1.49-.05-2.24-.09.06,1.17,1.37,1.54,1.98.8.23-.28.25-.58.25-.72h0Z"
              />
              <path
                className="cls-107"
                d="M145.85,186.3c-.74-.03-1.49-.07-2.23-.11.06,1.17,1.37,1.55,1.98.83.23-.28.25-.57.25-.72h0Z"
              />
            </g>
            <g className="cls-262">
              <path
                className="cls-107"
                d="M149.43,202.86c-.63,0-1.05.4-1.07,1,.73.03,1.46.06,2.19.08-.06-.76-.71-1.06-1.12-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M145.04,202.67c-.63,0-1.04.39-1.05.98.73.04,1.46.07,2.19.11-.07-.76-.72-1.07-1.14-1.09h0Z"
              />
              <path
                className="cls-107"
                d="M151.55,198.71c-1.07.02-1.4,1.16-.75,1.79.31.3.64.33.79.34-.01-.7-.03-1.41-.04-2.13h0Z"
              />
              <path
                className="cls-107"
                d="M147.12,198.54c-1.07,0-1.38,1.14-.74,1.78.7.69,1.88.27,1.86-.67-.01-.59-.52-1.09-1.13-1.11h0Z"
              />
              <path
                className="cls-107"
                d="M142.72,198.33c.02.71.04,1.42.07,2.13,1.06,0,1.37-1.13.72-1.77-.3-.3-.64-.34-.79-.35h0Z"
              />
              <path
                className="cls-107"
                d="M150.39,195.43c-.74-.03-1.48-.05-2.22-.08.08,1.12,1.38,1.47,1.98.77.23-.27.24-.55.24-.69h0Z"
              />
              <path
                className="cls-107"
                d="M145.95,195.24c-.74-.03-1.48-.07-2.22-.11.08,1.12,1.38,1.48,1.98.79.23-.26.24-.55.24-.68h0Z"
              />
            </g>
            <g className="cls-268">
              <path
                className="cls-107"
                d="M149.69,210.98c-.62,0-1.03.37-1.04.94.72.03,1.43.06,2.15.08-.07-.72-.7-1.01-1.11-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M145.38,210.79c-.62,0-1.02.36-1.02.93.71.04,1.43.07,2.14.11-.08-.72-.72-1.01-1.13-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M151.73,207.05c-1.06.02-1.37,1.1-.72,1.7.3.28.64.31.78.32-.02-.67-.04-1.34-.06-2.02h0Z"
              />
              <path
                className="cls-107"
                d="M147.37,206.88c-1.05,0-1.35,1.08-.7,1.69.7.66,1.85.26,1.82-.63-.02-.56-.52-1.04-1.12-1.07h0Z"
              />
              <path
                className="cls-107"
                d="M143.03,206.67c.03.68.07,1.35.1,2.02,1.06,0,1.33-1.05.68-1.68-.3-.29-.64-.33-.78-.34h0Z"
              />
              <path
                className="cls-107"
                d="M150.55,203.94c-.73-.03-1.46-.05-2.19-.08.09,1.06,1.38,1.39,1.96.73.22-.25.23-.52.23-.65h0Z"
              />
              <path
                className="cls-107"
                d="M146.17,203.76c-.73-.03-1.46-.07-2.19-.11.1,1.06,1.38,1.41,1.96.75.22-.25.23-.52.23-.64h0Z"
              />
            </g>
            <g className="cls-274">
              <path
                className="cls-107"
                d="M151.49,215.03c-.19.09-.31.2-.41.36.15-.13.27-.23.41-.36h0Z"
              />
              <path
                className="cls-107"
                d="M147.72,214.77c-.99,0-1.29.92-.73,1.52.64.68,1.79.42,1.84-.43.03-.56-.48-1.07-1.11-1.09h0Z"
              />
              <path
                className="cls-107"
                d="M143.48,214.56c.04.64.09,1.28.13,1.91.97,0,1.25-.92.71-1.51-.31-.34-.71-.38-.84-.39h0Z"
              />
              <path
                className="cls-107"
                d="M150.8,212c-.72-.03-1.43-.05-2.15-.08.1,1,1.37,1.31,1.93.69.22-.24.22-.49.22-.61h0Z"
              />
              <path
                className="cls-107"
                d="M146.51,211.82c-.72-.03-1.43-.07-2.14-.11.12,1.07,1.47,1.36,1.99.64.15-.21.16-.41.16-.54h0Z"
              />
            </g>
            <g className="cls-269">
              <path
                className="cls-107"
                d="M142.81,163.98c-1.12-.12-1.37-1.5-.62-2.1.28-.23.57-.23.7-.23-.03.78-.05,1.55-.08,2.33h0Z"
              />
            </g>
            <g className="cls-270">
              <path
                className="cls-107"
                d="M139.23,176.64c.04-.67.48-1.1,1.11-1.1.64.07,1.06.56,1.09,1.23-.74-.04-1.47-.09-2.2-.13h0Z"
              />
            </g>
            <g className="cls-271">
              <path
                className="cls-107"
                d="M140.3,184.86c-.64,0-1.07.42-1.09,1.08.73.05,1.47.09,2.2.13-.05-.84-.69-1.19-1.11-1.21h0Z"
              />
              <path
                className="cls-107"
                d="M135.92,184.57c-.64-.01-1.06.41-1.09,1.07.73.05,1.46.11,2.19.16-.05-.84-.68-1.19-1.1-1.22h0Z"
              />
              <path
                className="cls-107"
                d="M142.51,180.34c-1.14,0-1.44,1.34-.71,2.02.28.26.56.29.7.31,0-.25,0-.51,0-.76,0-.52,0-1.05,0-1.57h0Z"
              />
              <path
                className="cls-107"
                d="M138.1,180.08c-1.13-.02-1.43,1.33-.71,2.02.7.67,1.8.19,1.8-.78,0-.64-.49-1.2-1.09-1.24h0Z"
              />
              <path
                className="cls-107"
                d="M133.73,179.76c0,.52,0,1.05,0,1.57,0,.25,0,.51,0,.76,1.12.03,1.42-1.32.7-2.01-.27-.26-.56-.3-.69-.32h0Z"
              />
              <path
                className="cls-107"
                d="M141.43,176.77c-.74-.04-1.47-.09-2.2-.13.04,1.15,1.23,1.59,1.87.95.3-.3.32-.66.33-.81h0Z"
              />
            </g>
            <g className="cls-272">
              <path
                className="cls-107"
                d="M140.42,193.86c-.63,0-1.05.4-1.07,1.03.73.05,1.46.09,2.19.13-.06-.8-.7-1.13-1.12-1.16h0Z"
              />
              <path
                className="cls-107"
                d="M136.06,193.57c-.63-.01-1.05.38-1.06,1.01.72.05,1.45.11,2.18.16-.06-.8-.7-1.14-1.12-1.17h0Z"
              />
              <path
                className="cls-107"
                d="M142.54,189.54c-1.07,0-1.4,1.19-.75,1.86.3.32.64.35.78.37-.01-.74-.02-1.49-.03-2.23h0Z"
              />
              <path
                className="cls-107"
                d="M138.15,189.27c-1.06-.02-1.38,1.17-.74,1.86.66.71,1.77.38,1.85-.55.06-.65-.46-1.26-1.11-1.3h0Z"
              />
              <path
                className="cls-107"
                d="M133.78,188.96c.01.75.03,1.49.04,2.24,1.05.03,1.37-1.16.73-1.85-.3-.32-.63-.37-.77-.39h0Z"
              />
              <path
                className="cls-107"
                d="M141.41,186.07c-.74-.04-1.47-.09-2.2-.13.06,1.17,1.35,1.57,1.95.85.23-.27.24-.57.25-.71h0Z"
              />
              <path
                className="cls-107"
                d="M137.01,185.79c-.73-.05-1.46-.1-2.19-.16.07,1.18,1.35,1.58,1.95.87.23-.27.24-.57.24-.71h0Z"
              />
            </g>
            <g className="cls-273">
              <path
                className="cls-107"
                d="M140.69,202.43c-.62,0-1.03.37-1.03.97.72.05,1.44.09,2.16.13-.07-.76-.71-1.08-1.13-1.1h0Z"
              />
              <path
                className="cls-107"
                d="M136.38,202.15c-.62-.01-1.03.36-1.02.96.71.05,1.43.1,2.15.15-.08-.76-.72-1.09-1.12-1.12h0Z"
              />
              <path
                className="cls-107"
                d="M142.72,198.33c-1.06,0-1.36,1.13-.71,1.77.31.3.64.34.78.35-.02-.7-.05-1.41-.07-2.13h0Z"
              />
              <path
                className="cls-107"
                d="M138.36,198.06c-1.05-.02-1.34,1.11-.7,1.77.7.71,1.85.31,1.82-.63-.02-.59-.52-1.1-1.12-1.14h0Z"
              />
              <path
                className="cls-107"
                d="M134.04,197.75c.03.71.06,1.42.09,2.13,1.04.03,1.32-1.1.68-1.76-.3-.31-.63-.35-.77-.37h0Z"
              />
              <path
                className="cls-107"
                d="M141.54,195.01c-.73-.04-1.46-.09-2.19-.13.09,1.12,1.37,1.5,1.95.81.22-.26.23-.54.23-.68h0Z"
              />
              <path
                className="cls-107"
                d="M137.17,194.74c-.73-.05-1.45-.1-2.18-.16.09,1.12,1.37,1.52,1.95.83.22-.26.23-.54.23-.68h0Z"
              />
            </g>
            <g className="cls-275">
              <path
                className="cls-107"
                d="M141.11,210.56c-.61,0-1,.35-.99.92.7.04,1.41.09,2.12.13-.08-.72-.72-1.02-1.12-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M136.89,210.28c-.61-.02-1,.34-.98.91.7.05,1.4.1,2.11.15-.09-.72-.72-1.03-1.12-1.06h0Z"
              />
              <path
                className="cls-107"
                d="M143.03,206.67c-1.04,0-1.32,1.07-.67,1.69.31.29.63.32.77.34-.03-.67-.07-1.34-.1-2.02h0Z"
              />
              <path
                className="cls-107"
                d="M138.74,206.41c-1.03-.02-1.3,1.06-.65,1.68.7.67,1.83.29,1.78-.59-.03-.56-.54-1.05-1.13-1.09h0Z"
              />
              <path
                className="cls-107"
                d="M134.49,206.11c.05.68.09,1.36.14,2.03,1.04.03,1.28-1.02.63-1.67-.3-.3-.63-.34-.77-.36h0Z"
              />
              <path
                className="cls-107"
                d="M141.82,203.53c-.72-.04-1.44-.09-2.16-.13.11,1.06,1.38,1.42,1.94.77.22-.25.22-.51.22-.64h0Z"
              />
              <path
                className="cls-107"
                d="M137.51,203.26c-.72-.05-1.43-.1-2.15-.15.11,1.07,1.38,1.44,1.94.79.21-.25.21-.51.21-.64h0Z"
              />
            </g>
            <g className="cls-276">
              <path
                className="cls-107"
                d="M143.62,216.47c-1.02-.1-1.42-1.15-.86-1.67.27-.24.59-.24.72-.24.04.64.09,1.28.13,1.91h0Z"
              />
              <path
                className="cls-107"
                d="M142.24,211.7c-.04.86-1.19,1.11-1.83.41-.24-.26-.27-.51-.28-.64.7.04,1.41.09,2.12.13,0,.03,0,.07,0,.1h0Z"
              />
              <path
                className="cls-107"
                d="M138.02,211.44c-.03.86-1.17,1.1-1.82.39-.24-.26-.27-.52-.29-.64.7.05,1.4.1,2.11.15,0,.03,0,.07,0,.1h0Z"
              />
            </g>
            <g className="cls-277">
              <path
                className="cls-107"
                d="M130.5,185.29c.03-.66.44-1.07,1.07-1.05.63.09,1.05.56,1.09,1.23-.72-.06-1.44-.12-2.16-.18h0Z"
              />
              <path
                className="cls-107"
                d="M133.72,182.09c-1.12-.15-1.41-1.54-.68-2.12.28-.22.56-.21.69-.21,0,.52,0,1.05,0,1.57,0,.25,0,.51,0,.76h0Z"
              />
            </g>
            <g className="cls-227">
              <path
                className="cls-107"
                d="M130.7,194.24c0-.63.41-1.02,1.03-1,.63.08,1.06.54,1.11,1.18-.72-.06-1.43-.12-2.14-.18h0Z"
              />
              <path
                className="cls-107"
                d="M133.83,191.2c-1.12-.15-1.44-1.48-.73-2.03.27-.21.55-.2.68-.2.01.75.03,1.49.05,2.24h0Z"
              />
              <path
                className="cls-107"
                d="M132.65,185.58c-.08.95-1.17,1.27-1.83.54-.3-.33-.32-.69-.32-.84.72.06,1.44.12,2.16.18,0,.04,0,.08,0,.12h0Z"
              />
            </g>
            <g className="cls-226">
              <path
                className="cls-107"
                d="M134.13,199.88c-1.11-.14-1.46-1.41-.76-1.94.26-.2.54-.19.67-.19.03.71.06,1.42.09,2.13h0Z"
              />
              <path
                className="cls-107"
                d="M132.84,194.53c-.06.91-1.13,1.21-1.8.51-.3-.32-.33-.66-.34-.8.71.06,1.43.12,2.14.18,0,.03,0,.08,0,.11h0Z"
              />
            </g>
            <g className="cls-223">
              <path
                className="cls-107"
                d="M134.63,208.13c-1.08-.14-1.46-1.34-.8-1.85.25-.19.52-.18.65-.18.05.68.09,1.36.14,2.03h0Z"
              />
            </g>
            <g className="cls-222">
              <path
                className="cls-107"
                d="M210.39,145.58c-.61.11-.96.6-.91,1.28.7-.09,1.4-.17,2.1-.26-.15-.9-.84-1.05-1.19-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M206.18,146.09c-.62.1-.98.59-.94,1.26.71-.08,1.42-.16,2.12-.24-.13-.84-.78-1.07-1.18-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M211.86,140.74c-.59.11-.93.61-.87,1.27.12.67.58,1.05,1.19,1-.1-.76-.21-1.52-.32-2.28h0Z"
              />
              <path
                className="cls-107"
                d="M207.72,141.26c-1.07.19-1.18,1.56-.4,2.1.75.52,1.72-.14,1.59-1.09-.08-.63-.62-1.08-1.19-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M203.54,141.73c.09.76.18,1.52.26,2.28.62-.1.98-.58.93-1.26-.11-.65-.58-1.06-1.19-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M210.33,137.48c-.68.09-1.36.17-2.05.26.21,1.1,1.38,1.31,1.87.58.23-.34.19-.69.18-.84h0Z"
              />
              <path
                className="cls-107"
                d="M206.22,137.98c-.69.08-1.37.16-2.06.23.2,1.1,1.36,1.33,1.87.6.24-.34.21-.69.19-.83h0Z"
              />
            </g>
            <g className="cls-225">
              <path
                className="cls-107"
                d="M211.37,154.8c-.62.11-1,.61-.97,1.29.72-.09,1.43-.18,2.15-.27-.12-.91-.82-1.06-1.17-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M207.06,155.31c-.63.1-1.01.59-.99,1.28.72-.08,1.44-.16,2.16-.24-.11-.84-.76-1.08-1.17-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M213.03,149.9c-.61.11-.97.62-.93,1.29.1.67.55,1.06,1.18,1.01-.08-.77-.16-1.54-.24-2.3h0Z"
              />
              <path
                className="cls-107"
                d="M208.79,150.44c-1.09.19-1.26,1.58-.48,2.13.8.56,1.84-.21,1.64-1.22-.11-.57-.62-.97-1.16-.91h0Z"
              />
              <path
                className="cls-107"
                d="M204.5,150.92c.07.77.14,1.54.2,2.31.64-.1,1.02-.59.99-1.27-.09-.66-.56-1.07-1.19-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M211.58,146.59c-.7.09-1.4.18-2.1.26.18,1.11,1.36,1.33,1.89.58.25-.35.22-.7.21-.85h0Z"
              />
              <path
                className="cls-107"
                d="M207.37,147.11c-.71.08-1.41.16-2.12.24.17,1.11,1.35,1.34,1.9.61.25-.34.23-.7.22-.85h0Z"
              />
            </g>
            <g className="cls-219">
              <path
                className="cls-107"
                d="M212.04,164.08c-.63.11-1.03.63-1.03,1.31.73-.09,1.45-.18,2.17-.27-.09-.92-.79-1.08-1.15-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M207.68,164.6c-.64.11-1.04.6-1.04,1.3.73-.08,1.46-.16,2.19-.25-.08-.86-.73-1.1-1.15-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M213.89,159.16c-.62.12-1.01.63-.99,1.3.08.67.53,1.07,1.16,1.02-.05-.77-.11-1.55-.17-2.32h0Z"
              />
              <path
                className="cls-107"
                d="M209.58,159.7c-1.11.19-1.32,1.59-.56,2.14.79.57,1.87-.21,1.7-1.23-.09-.58-.6-.98-1.15-.91h0Z"
              />
              <path
                className="cls-107"
                d="M205.21,160.19c.05.77.09,1.55.14,2.33.64-.1,1.05-.61,1.04-1.28-.07-.67-.53-1.08-1.17-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M212.54,155.82c-.71.09-1.43.18-2.15.27.15,1.12,1.34,1.34,1.9.59.26-.35.25-.71.24-.86h0Z"
              />
              <path
                className="cls-107"
                d="M208.24,156.35c-.72.08-1.44.16-2.16.24.14,1.12,1.34,1.35,1.91.61.27-.35.26-.7.25-.85h0Z"
              />
            </g>
            <g className="cls-220">
              <path
                className="cls-107"
                d="M201.93,146.54c-.62.1-.99.58-.96,1.25.71-.07,1.43-.14,2.14-.21-.13-.9-.83-1.08-1.18-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M197.65,146.93c-.63.09-1,.56-.98,1.24.72-.06,1.44-.12,2.15-.19-.11-.84-.76-1.09-1.17-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M203.54,141.73c-.6.1-.96.59-.92,1.25.11.67.56,1.06,1.18,1.03-.09-.76-.17-1.52-.26-2.28h0Z"
              />
              <path
                className="cls-107"
                d="M199.33,142.15c-1.09.16-1.24,1.53-.47,2.09.8.58,1.83-.16,1.62-1.16-.12-.57-.62-.98-1.16-.93h0Z"
              />
              <path
                className="cls-107"
                d="M195.1,142.52c.07.76.14,1.52.21,2.29.63-.08.99-.56.96-1.23-.09-.66-.55-1.07-1.17-1.06h0Z"
              />
              <path
                className="cls-107"
                d="M202.08,138.43c-.69.07-1.39.14-2.08.21.18,1.11,1.36,1.35,1.88.62.24-.33.21-.68.2-.83h0Z"
              />
              <path
                className="cls-107"
                d="M197.91,138.84c-.7.06-1.4.12-2.09.18.17,1.1,1.34,1.36,1.88.65.25-.33.23-.68.22-.83h0Z"
              />
            </g>
            <g className="cls-224">
              <path
                className="cls-107"
                d="M202.72,155.77c-.64.1-1.02.58-1.01,1.27.73-.07,1.46-.14,2.18-.22-.11-.91-.81-1.08-1.17-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M198.35,156.18c-.64.09-1.03.57-1.03,1.25.73-.06,1.47-.12,2.2-.19-.09-.85-.75-1.1-1.17-1.06h0Z"
              />
              <path
                className="cls-107"
                d="M204.5,150.92c-.62.1-1,.6-.97,1.27.09.68.54,1.08,1.18,1.04-.06-.77-.13-1.54-.2-2.31h0Z"
              />
              <path
                className="cls-107"
                d="M203.1,147.58c-.71.07-1.42.14-2.14.21.16,1.12,1.35,1.36,1.91.63.26-.34.24-.69.23-.84h0Z"
              />
              <path
                className="cls-107"
                d="M198.82,147.99c-.72.06-1.43.13-2.15.19.14,1.12,1.34,1.37,1.91.65.27-.34.25-.69.25-.84h0Z"
              />
            </g>
            <g className="cls-218">
              <path
                className="cls-107"
                d="M203.27,165.07c-.64.1-1.05.6-1.06,1.28.74-.07,1.48-.14,2.21-.22-.08-.92-.79-1.1-1.16-1.06h0Z"
              />
              <path
                className="cls-107"
                d="M198.83,165.48c-.65.09-1.06.58-1.07,1.27.74-.06,1.49-.13,2.23-.19-.07-.86-.73-1.12-1.16-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M205.21,160.19c-.63.1-1.03.6-1.03,1.28.07.67.53,1.08,1.16,1.05-.04-.78-.09-1.55-.14-2.33h0Z"
              />
              <path
                className="cls-107"
                d="M200.82,160.63c-1.13.17-1.36,1.55-.59,2.12.79.59,1.9-.16,1.75-1.18-.09-.58-.59-.99-1.15-.94h0Z"
              />
              <path
                className="cls-107"
                d="M196.41,161.01c.04.78.07,1.55.11,2.33.64-.09,1.06-.58,1.06-1.26-.06-.67-.52-1.09-1.16-1.07h0Z"
              />
              <path
                className="cls-107"
                d="M203.89,156.82c-.73.07-1.45.15-2.18.22.13,1.13,1.34,1.37,1.92.63.27-.34.26-.7.26-.85h0Z"
              />
              <path
                className="cls-107"
                d="M199.52,157.24c-.73.07-1.46.13-2.2.19.12,1.12,1.33,1.38,1.92.66.28-.34.27-.7.27-.85h0Z"
              />
            </g>
            <g className="cls-221">
              <path
                className="cls-107"
                d="M193.33,147.28c-.63.08-1.01.55-1,1.23.72-.05,1.44-.11,2.16-.16-.11-.91-.81-1.1-1.17-1.07h0Z"
              />
              <path
                className="cls-107"
                d="M189.01,147.58c-.63.07-1.02.54-1.01,1.22.73-.04,1.45-.09,2.17-.14-.09-.84-.75-1.11-1.16-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M195.1,142.52c-.62.08-1,.57-.97,1.23.09.67.54,1.08,1.18,1.06-.07-.76-.14-1.53-.21-2.29h0Z"
              />
              <path
                className="cls-107"
                d="M190.83,142.84c-1.1.14-1.29,1.5-.52,2.08.78.6,1.85-.12,1.67-1.12-.1-.58-.59-.99-1.15-.95h0Z"
              />
              <path
                className="cls-107"
                d="M186.55,143.1c.05.76.1,1.53.15,2.29.63-.07,1.02-.53,1-1.21-.08-.66-.53-1.08-1.15-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M193.71,139.19c-.7.05-1.4.11-2.11.16.15,1.11,1.33,1.38,1.88.67.25-.33.24-.68.23-.83h0Z"
              />
              <path
                className="cls-107"
                d="M189.49,139.49c-.7.05-1.41.09-2.12.13.14,1.11,1.31,1.39,1.87.69.26-.33.25-.68.25-.82h0Z"
              />
            </g>
            <g className="cls-178">
              <path
                className="cls-107"
                d="M193.94,156.53c-.64.08-1.04.56-1.04,1.24.74-.05,1.47-.11,2.21-.16-.09-.91-.8-1.1-1.17-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M189.53,156.84c-.65.07-1.05.55-1.06,1.23.74-.04,1.48-.09,2.22-.14-.08-.85-.74-1.12-1.16-1.09h0Z"
              />
              <path
                className="cls-107"
                d="M187.09,152.32c.04.77.08,1.54.11,2.32.65-.07,1.05-.54,1.04-1.22-.07-.67-.52-1.1-1.16-1.09h0Z"
              />
              <path
                className="cls-107"
                d="M194.5,148.35c-.72.06-1.44.11-2.16.16.13,1.12,1.33,1.39,1.91.68.27-.33.26-.69.25-.84h0Z"
              />
              <path
                className="cls-107"
                d="M190.17,148.66c-.72.05-1.45.09-2.17.14.12,1.12,1.32,1.41,1.91.7.28-.33.27-.68.27-.83h0Z"
              />
            </g>
            <g className="cls-179">
              <path
                className="cls-107"
                d="M194.36,165.84c-.64.08-1.07.58-1.08,1.26.75-.05,1.49-.11,2.24-.17-.07-.93-.79-1.12-1.16-1.09h0Z"
              />
              <path
                className="cls-107"
                d="M189.88,166.15c-.65.07-1.08.56-1.09,1.25.75-.04,1.5-.09,2.25-.14-.07-.86-.73-1.13-1.16-1.11h0Z"
              />
              <path
                className="cls-107"
                d="M196.41,161.01c-.64.09-1.06.58-1.07,1.25.06.67.52,1.09,1.17,1.08-.03-.78-.07-1.55-.11-2.33h0Z"
              />
              <path
                className="cls-107"
                d="M191.95,161.34c-1.14.14-1.39,1.52-.63,2.11.79.61,1.92-.12,1.78-1.14-.08-.59-.58-1.01-1.15-.97h0Z"
              />
              <path
                className="cls-107"
                d="M187.49,161.62c.03.78.05,1.55.08,2.33.65-.07,1.07-.55,1.08-1.23-.06-.67-.51-1.1-1.16-1.1h0Z"
              />
              <path
                className="cls-107"
                d="M195.11,157.61c-.74.06-1.47.11-2.21.16.11,1.13,1.33,1.4,1.93.68.28-.34.28-.69.28-.84h0Z"
              />
              <path
                className="cls-107"
                d="M190.69,157.93c-.74.05-1.48.09-2.22.14.1,1.13,1.32,1.42,1.93.7.29-.34.29-.69.29-.84h0Z"
              />
            </g>
          </g>
          <g className="cls-185">
            <g className="cls-186">
              <path
                className="cls-107"
                d="M91.61,93.49c-.32-.09-.75.2-1.11.74.35.14.7.28,1.05.42.44-.76.23-1.09.06-1.16h0Z"
              />
            </g>
            <g className="cls-187">
              <path
                className="cls-107"
                d="M90.41,97.74c-.7-.19-1.57,1.25-1.27,1.79.28.51,1.19-.13,1.45-1,.11-.39.04-.7-.18-.79h0Z"
              />
              <path
                className="cls-107"
                d="M88.25,96.89c-.38.64-.75,1.29-1.12,1.94.68.21,1.55-1.21,1.28-1.78-.05-.1-.1-.13-.16-.16h0Z"
              />
              <path
                className="cls-107"
                d="M91.56,94.65c-.36-.14-.71-.28-1.05-.42-.45.77-.27,1.29.2,1.17.17-.04.5-.19.85-.75h0Z"
              />
            </g>
            <g className="cls-180">
              <path
                className="cls-107"
                d="M88.25,96.89c-.67-.2-1.55,1.23-1.29,1.78.05.1.1.13.16.16.37-.65.75-1.3,1.12-1.94h0Z"
              />
            </g>
          </g>
          <g className="cls-181">
            <g className="cls-182">
              <path
                className="cls-107"
                d="M111.92,222.02c-.51-.06-.76.23-.65.73.59.1,1.18.19,1.77.28-.21-.65-.79-.96-1.13-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M108.39,221.43c-.51-.06-.74.21-.61.73.58.1,1.15.2,1.74.3-.22-.65-.79-.97-1.12-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M109.22,218.14c-.83-.1-.85.73-.39,1.29.58.7,1.49.72,1.53.03.04-.55-.54-1.22-1.15-1.32h0Z"
              />
              <path
                className="cls-107"
                d="M105.67,217.52c.16.61.32,1.21.48,1.81.76.1.85-.67.35-1.28-.23-.28-.51-.46-.83-.53h0Z"
              />
            </g>
            <g className="cls-183">
              <path
                className="cls-107"
                d="M110.55,228.25c-.48-.06-.69.19-.54.67.55.1,1.11.2,1.67.29-.25-.6-.81-.91-1.13-.96h0Z"
              />
              <path
                className="cls-107"
                d="M111.15,225.2c-.77-.09-.77.61-.36,1.12.55.68,1.44.79,1.52.18.07-.52-.54-1.2-1.16-1.3h0Z"
              />
              <path
                className="cls-107"
                d="M107.73,224.6c.19.57.38,1.13.57,1.69.69.09.77-.55.32-1.11-.17-.21-.45-.48-.89-.58h0Z"
              />
              <path
                className="cls-107"
                d="M113.04,223.04c-.59-.09-1.19-.19-1.77-.28.31.94,1.49,1.32,1.76.75.08-.18.04-.35.02-.46h0Z"
              />
              <path
                className="cls-107"
                d="M109.51,222.46c-.58-.1-1.16-.2-1.74-.3.33.96,1.47,1.35,1.73.77.08-.18.04-.35,0-.46h0Z"
              />
            </g>
            <g className="cls-184">
              <path
                className="cls-107"
                d="M112.57,235.18c-.18-.44,0-.67.46-.61.47.1.91.45,1.13.89-.53-.09-1.06-.18-1.59-.28h0Z"
              />
              <path
                className="cls-107"
                d="M111.28,232.2c.07.24.05.63-.51.55-.22-.52-.44-1.04-.65-1.57.63.14,1.06.68,1.16,1.02h0Z"
              />
              <path
                className="cls-107"
                d="M111.7,229.29c.14.56-.38.78-1,.42-.22-.13-.52-.37-.7-.79.55.1,1.11.2,1.67.29,0,.02.02.06.03.08h0Z"
              />
            </g>
            <g className="cls-228">
              <path
                className="cls-107"
                d="M114.19,235.53c.16.48-.25.69-.82.42-.2-.1-.57-.33-.79-.77.53.09,1.06.19,1.59.28,0,.02.02.05.03.08h0Z"
              />
            </g>
            <g className="cls-229">
              <path
                className="cls-107"
                d="M104.93,220.8c-.49-.07-.71.21-.58.72.56.11,1.13.22,1.7.32-.23-.65-.79-.98-1.12-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M101.56,220.13c-.48-.07-.69.2-.54.71.55.12,1.1.23,1.65.34-.24-.65-.8-.99-1.11-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M105.67,217.52c-.79-.1-.82.65-.42,1.2.16.22.45.51.9.61-.16-.6-.32-1.2-.48-1.81h0Z"
              />
              <path
                className="cls-107"
                d="M102.19,216.86c-.76-.11-.77.64-.37,1.2.53.74,1.42.87,1.51.22.07-.56-.52-1.3-1.14-1.42h0Z"
              />
              <path
                className="cls-107"
                d="M98.81,216.17c.18.61.36,1.22.54,1.82.69.11.77-.58.33-1.19-.16-.23-.44-.52-.87-.63h0Z"
              />
            </g>
            <g className="cls-237">
              <path
                className="cls-107"
                d="M107.23,227.65c-.46-.07-.66.19-.5.66.54.1,1.08.21,1.63.31-.26-.61-.82-.91-1.13-.97h0Z"
              />
              <path
                className="cls-107"
                d="M103.99,227.01c-.46-.07-.64.18-.46.66.53.11,1.06.22,1.59.33-.27-.61-.82-.92-1.13-.99h0Z"
              />
              <path
                className="cls-107"
                d="M107.73,224.6c-.76-.1-.74.6-.33,1.11.17.21.46.48.89.58-.19-.56-.38-1.12-.57-1.69h0Z"
              />
              <path
                className="cls-107"
                d="M104.37,223.97c-.66-.1-.73.48-.34,1.03.51.71,1.39.93,1.5.37.1-.5-.54-1.27-1.16-1.4h0Z"
              />
              <path
                className="cls-107"
                d="M101.11,223.29c.21.57.42,1.14.64,1.7.64.1.68-.48.3-1.03-.14-.2-.45-.55-.93-.68h0Z"
              />
              <path
                className="cls-107"
                d="M106.05,221.84c-.57-.11-1.13-.21-1.7-.32.34.95,1.48,1.35,1.7.79.07-.17.02-.35,0-.46h0Z"
              />
              <path
                className="cls-107"
                d="M102.68,221.19c-.56-.11-1.11-.23-1.65-.34.34.9,1.38,1.35,1.65.86.1-.19.04-.41,0-.52h0Z"
              />
            </g>
            <g className="cls-230">
              <path
                className="cls-107"
                d="M109.87,233.99c-.44-.06-.61.17-.42.61.51.1,1.03.2,1.55.29-.29-.56-.83-.85-1.13-.9h0Z"
              />
              <path
                className="cls-107"
                d="M106.78,233.38c-.44-.07-.58.16-.38.6.5.11,1,.21,1.51.31-.3-.56-.84-.85-1.13-.91h0Z"
              />
              <path
                className="cls-107"
                d="M110.12,231.18c-.66-.09-.7.45-.29.96.14.18.46.5.95.61-.22-.52-.44-1.04-.65-1.57h0Z"
              />
              <path
                className="cls-107"
                d="M106.91,230.57c-.64-.1-.61.45-.3.88.51.71,1.43.97,1.5.42.06-.47-.6-1.19-1.2-1.3h0Z"
              />
              <path
                className="cls-107"
                d="M103.79,229.93c.24.53.48,1.06.73,1.59.57.09.6-.38.26-.87-.09-.13-.44-.58-.99-.72h0Z"
              />
              <path
                className="cls-107"
                d="M108.36,228.62c-.55-.1-1.09-.2-1.63-.31.38.88,1.49,1.26,1.66.74.05-.16,0-.33-.04-.43h0Z"
              />
              <path
                className="cls-107"
                d="M105.12,227.99c-.53-.11-1.06-.22-1.59-.33.41.9,1.48,1.29,1.63.76.05-.16-.01-.33-.05-.43h0Z"
              />
            </g>
            <g className="cls-235">
              <path
                className="cls-107"
                d="M109.79,236.67c-.53-.08-.57.31-.27.72.47.65,1.4.98,1.48.52.08-.41-.63-1.13-1.22-1.25h0Z"
              />
              <path
                className="cls-107"
                d="M106.83,236.06c.27.49.54.98.82,1.45.55.09.48-.36.22-.72-.04-.06-.44-.58-1.04-.73h0Z"
              />
              <path
                className="cls-107"
                d="M111,234.89c-.52-.1-1.04-.19-1.55-.29.43.83,1.49,1.18,1.62.69.04-.15-.03-.3-.06-.39h0Z"
              />
              <path
                className="cls-107"
                d="M107.91,234.29c-.51-.1-1.01-.21-1.51-.31.45.82,1.48,1.19,1.59.7.03-.15-.04-.3-.08-.39h0Z"
              />
            </g>
            <g className="cls-236">
              <path
                className="cls-107"
                d="M92.28,212.04c-.13-.54.08-.84.54-.75.48.14.9.59,1.07,1.14-.54-.13-1.08-.26-1.61-.39h0Z"
              />
              <path
                className="cls-107"
                d="M91.29,208.3c.05.3-.02.78-.58.67-.17-.65-.33-1.29-.48-1.95.62.19,1,.86,1.07,1.28h0Z"
              />
            </g>
            <g className="cls-233">
              <path
                className="cls-107"
                d="M98.28,219.43c-.46-.08-.66.2-.5.71.53.12,1.07.24,1.62.36-.25-.66-.8-1-1.11-1.07h0Z"
              />
              <path
                className="cls-107"
                d="M95.09,218.69c-.44-.08-.63.19-.47.7.52.13,1.04.25,1.56.38-.26-.66-.8-1.01-1.1-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M98.81,216.17c-.74-.12-.73.63-.33,1.19.16.23.44.52.87.63-.18-.6-.36-1.21-.54-1.82h0Z"
              />
              <path
                className="cls-107"
                d="M95.51,215.43c-.72-.13-.69.63-.29,1.19.5.7,1.31.89,1.42.33.1-.54-.52-1.38-1.13-1.52h0Z"
              />
              <path
                className="cls-107"
                d="M92.32,214.66c.19.62.39,1.23.59,1.84.64.13.69-.56.25-1.18-.16-.23-.44-.53-.84-.65h0Z"
              />
              <path
                className="cls-107"
                d="M93.89,212.43c-.54-.13-1.08-.26-1.61-.39.31.97,1.33,1.46,1.6.95.1-.2.05-.44.02-.56h0Z"
              />
            </g>
            <g className="cls-234">
              <path
                className="cls-107"
                d="M100.84,226.33c-.44-.08-.61.18-.42.65.51.12,1.03.23,1.55.35-.28-.61-.83-.93-1.13-1h0Z"
              />
              <path
                className="cls-107"
                d="M97.77,225.62c-.43-.08-.58.17-.38.65.5.12,1,.24,1.5.36-.3-.62-.83-.94-1.12-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M101.11,223.29c-.7-.12-.64.54-.3,1.03.14.2.45.55.93.68-.22-.56-.43-1.13-.64-1.7h0Z"
              />
              <path
                className="cls-107"
                d="M97.93,222.58c-.63-.11-.65.47-.25,1.02.51.71,1.36.95,1.43.4.06-.5-.59-1.29-1.18-1.42h0Z"
              />
              <path
                className="cls-107"
                d="M94.86,221.84c.23.58.46,1.15.7,1.72.56.11.6-.4.27-.93-.09-.14-.43-.62-.97-.79h0Z"
              />
              <path
                className="cls-107"
                d="M99.39,220.5c-.54-.12-1.08-.24-1.62-.36.35.91,1.38,1.36,1.62.88.09-.18.03-.41,0-.52h0Z"
              />
              <path
                className="cls-107"
                d="M96.19,219.77c-.52-.12-1.05-.25-1.56-.38.36.91,1.36,1.38,1.58.9.08-.18.01-.41-.02-.52h0Z"
              />
            </g>
            <g className="cls-231">
              <path
                className="cls-107"
                d="M103.77,232.73c-.42-.07-.55.16-.34.6.49.11.98.22,1.48.33-.32-.57-.85-.87-1.14-.93h0Z"
              />
              <path
                className="cls-107"
                d="M100.85,232.05c-.4-.08-.52.15-.3.59.47.12.95.23,1.43.35-.33-.57-.85-.87-1.13-.94h0Z"
              />
              <path
                className="cls-107"
                d="M103.79,229.93c-.62-.1-.57.44-.26.88.09.13.44.57.99.71-.25-.52-.49-1.05-.73-1.59h0Z"
              />
              <path
                className="cls-107"
                d="M100.75,229.25c-.61-.11-.53.43-.21.87.49.67,1.34.98,1.42.52.08-.45-.62-1.25-1.21-1.39h0Z"
              />
              <path
                className="cls-107"
                d="M97.8,228.53c.26.54.53,1.07.8,1.6.52.1.52-.32.23-.78-.04-.07-.43-.64-1.03-.82h0Z"
              />
              <path
                className="cls-107"
                d="M101.96,227.33c-.52-.11-1.04-.23-1.55-.35.4.84,1.4,1.27,1.59.83.07-.17,0-.38-.04-.48h0Z"
              />
              <path
                className="cls-107"
                d="M98.89,226.63c-.5-.12-1-.24-1.5-.36.41.85,1.39,1.29,1.56.85.06-.17-.02-.38-.06-.48h0Z"
              />
            </g>
            <g className="cls-232">
              <path
                className="cls-107"
                d="M107.07,238.61c-.39-.07-.49.14-.26.54.46.11.93.21,1.4.31-.37-.56-.91-.8-1.14-.85h0Z"
              />
              <path
                className="cls-107"
                d="M104.31,237.97c-.39-.08-.47.13-.21.54.45.11.9.22,1.35.33-.36-.52-.88-.8-1.13-.86h0Z"
              />
              <path
                className="cls-107"
                d="M106.83,236.06c-.53-.09-.53.3-.22.72.07.1.45.58,1.04.73-.28-.48-.55-.96-.82-1.45h0Z"
              />
              <path
                className="cls-107"
                d="M103.94,235.41c-.52-.1-.45.32-.23.64.45.66,1.37,1.09,1.47.68.1-.39-.64-1.19-1.24-1.32h0Z"
              />
              <path
                className="cls-107"
                d="M101.15,234.73c.3.5.59.99.9,1.47.5.1.41-.31.18-.64-.15-.22-.57-.68-1.08-.83h0Z"
              />
              <path
                className="cls-107"
                d="M104.91,233.66c-.5-.11-.99-.22-1.48-.33.44.78,1.41,1.18,1.56.77.06-.16-.04-.35-.08-.44h0Z"
              />
              <path
                className="cls-107"
                d="M101.98,232.99c-.48-.11-.96-.23-1.43-.35.46.78,1.41,1.19,1.52.79.05-.16-.05-.36-.1-.44h0Z"
              />
            </g>
            <g className="cls-246">
              <path
                className="cls-107"
                d="M108.12,243.35c-.48-.1-.27.28-.22.35.02.04.06.09.09.13.42.1.84.2,1.26.31-.39-.47-.89-.73-1.13-.78h0Z"
              />
              <path
                className="cls-107"
                d="M107.49,241.04c-.47-.09-.37.26-.19.51.44.61,1.42,1.07,1.47.69.05-.34-.73-1.08-1.28-1.2h0Z"
              />
              <path
                className="cls-107"
                d="M104.86,240.4c.32.45.65.89.98,1.33.44.09.33-.23.2-.43-.18-.28-.67-.75-1.18-.9h0Z"
              />
              <path
                className="cls-107"
                d="M108.2,239.47c-.47-.1-.93-.21-1.4-.31.48.71,1.42,1.08,1.51.71.04-.14-.07-.32-.12-.4h0Z"
              />
              <path
                className="cls-107"
                d="M105.44,238.84c-.45-.11-.9-.22-1.35-.33.5.71,1.42,1.1,1.48.73.03-.14-.09-.33-.13-.4h0Z"
              />
            </g>
            <g className="cls-238">
              <path
                className="cls-107"
                d="M110.11,246.34c.2.25.2.41,0,.4-.03,0-.08-.01-.11-.02-.36-.39-.72-.79-1.07-1.19.48.14.98.56,1.18.81h0Z"
              />
              <path
                className="cls-107"
                d="M109.3,244.2c.2.28.15.46-.11.42-.25-.04-.78-.31-1.19-.79.42.1.84.2,1.26.31.01.02.03.04.05.06h0Z"
              />
            </g>
            <g className="cls-243">
              <path
                className="cls-107"
                d="M89.14,122.08c.23-.62.65-.96,1.08-.87.41.15.55.65.37,1.28-.49-.14-.97-.27-1.45-.41h0Z"
              />
              <path
                className="cls-107"
                d="M93.46,118.71c-.36.84-1.17,1.07-1.43.39-.28-.72.36-1.91,1.12-1.76.53.19.5.92.31,1.37h0Z"
              />
              <path
                className="cls-107"
                d="M90.58,117.91c-.14.33-.53.86-1.05.75.25-.71.51-1.42.78-2.13.51.2.47.92.27,1.37h0Z"
              />
            </g>
            <g className="cls-244">
              <path
                className="cls-107"
                d="M90.61,130.77c-.47-.09-.88.26-1.07.9.52.14,1.04.28,1.57.41.18-.82-.2-1.23-.49-1.31h0Z"
              />
              <path
                className="cls-107"
                d="M87.55,129.94c-.44-.09-.85.26-1.05.89.5.14,1,.29,1.5.43.19-.82-.17-1.24-.45-1.32h0Z"
              />
              <path
                className="cls-107"
                d="M90.31,125.97c-.87-.17-1.44,1.3-.96,1.96.43.59,1.31.05,1.44-.89.08-.53-.12-.97-.48-1.07h0Z"
              />
              <path
                className="cls-107"
                d="M87.37,125.13c-.23.73-.45,1.45-.66,2.18.85.18,1.42-1.28.97-1.95-.11-.16-.23-.2-.3-.23h0Z"
              />
              <path
                className="cls-107"
                d="M90.59,122.5c-.49-.14-.97-.27-1.45-.41-.29.97.25,1.55.84,1.23.27-.15.47-.42.62-.81h0Z"
              />
            </g>
            <g className="cls-245">
              <path
                className="cls-107"
                d="M84.34,139.76c.16-.64.56-1,1.01-.9.44.16.65.69.53,1.34-.52-.14-1.03-.29-1.55-.44h0Z"
              />
              <path
                className="cls-107"
                d="M91.07,132.2c-.29.87-1.13,1.1-1.47.41-.19-.38-.09-.8-.06-.93.52.14,1.04.28,1.57.41,0,.03-.02.08-.03.11h0Z"
              />
              <path
                className="cls-107"
                d="M87.98,131.34c-.13.39-.4.71-.68.8l-.64-.19s-.06-.07-.1-.16c-.13-.26-.15-.59-.06-.96.5.14,1,.29,1.5.43,0,.03-.02.06-.02.08h0Z"
              />
            </g>
            <g className="cls-239">
              <path
                className="cls-107"
                d="M85.85,140.32c-.25.88-1.06,1.11-1.42.4-.2-.39-.12-.81-.1-.95.51.15,1.03.29,1.55.44,0,.03-.02.08-.03.12h0Z"
              />
            </g>
            <g className="cls-240">
              <path
                className="cls-107"
                d="M84,202.54c-.11-.58.11-.88.55-.79.46.16.85.64,1,1.23-.52-.15-1.04-.29-1.55-.44h0Z"
              />
            </g>
            <g className="cls-241">
              <path
                className="cls-107"
                d="M89.63,210.48c-.46-.09-.65.19-.51.74.52.14,1.04.28,1.57.41-.23-.71-.76-1.08-1.06-1.16h0Z"
              />
              <path
                className="cls-107"
                d="M86.54,209.64c-.43-.1-.61.19-.47.74.5.14,1,.29,1.51.43-.24-.71-.75-1.09-1.04-1.17h0Z"
              />
              <path
                className="cls-107"
                d="M90.22,207.02c-.77-.15-.73.74-.29,1.35.32.46.66.56.78.6-.17-.65-.33-1.29-.48-1.95h0Z"
              />
              <path
                className="cls-107"
                d="M87.03,206.18c-.7-.15-.69.65-.31,1.26.47.76,1.25.97,1.37.37.11-.57-.47-1.47-1.06-1.63h0Z"
              />
              <path
                className="cls-107"
                d="M83.96,205.31c.17.66.34,1.31.52,1.96.62.14.68-.58.27-1.25-.15-.25-.41-.57-.8-.71h0Z"
              />
              <path
                className="cls-107"
                d="M85.55,202.98c-.52-.15-1.04-.29-1.55-.44.27,1.04,1.24,1.58,1.52,1.03.1-.21.06-.47.03-.59h0Z"
              />
            </g>
            <g className="cls-242">
              <path
                className="cls-107"
                d="M92,217.91c-.44-.09-.61.17-.43.69.5.13,1.01.27,1.52.4-.27-.66-.8-1.02-1.09-1.09h0Z"
              />
              <path
                className="cls-107"
                d="M89.01,217.09c-.41-.09-.57.18-.39.69.48.14.97.28,1.46.41-.28-.67-.79-1.03-1.07-1.1h0Z"
              />
              <path
                className="cls-107"
                d="M92.32,214.66c-.69-.14-.65.62-.25,1.18.16.23.44.53.84.65-.2-.61-.4-1.22-.59-1.84h0Z"
              />
              <path
                className="cls-107"
                d="M89.22,213.84c-.61-.13-.64.49-.27,1.09.46.73,1.24,1.03,1.37.52.14-.53-.5-1.44-1.11-1.61h0Z"
              />
              <path
                className="cls-107"
                d="M86.24,213c.21.62.42,1.24.64,1.85.58.14.6-.48.22-1.09-.13-.22-.43-.61-.87-.76h0Z"
              />
              <path
                className="cls-107"
                d="M90.69,211.64c-.53-.14-1.05-.27-1.57-.41.32.98,1.32,1.48,1.57.97.09-.2.03-.44,0-.56h0Z"
              />
              <path
                className="cls-107"
                d="M87.58,210.81c-.51-.14-1.01-.28-1.51-.43.33.98,1.29,1.49,1.52.99.09-.19.02-.44,0-.56h0Z"
              />
            </g>
            <g className="cls-247">
              <path
                className="cls-107"
                d="M94.81,224.87c-.42-.09-.55.16-.35.64.48.13.97.26,1.46.38-.31-.62-.83-.95-1.11-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M91.93,224.08c-.4-.09-.51.16-.3.64.46.13.93.27,1.4.4-.32-.62-.83-.96-1.1-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M94.86,221.84c-.61-.12-.57.46-.27.94.09.14.43.62.97.78-.24-.57-.47-1.14-.7-1.72h0Z"
              />
              <path
                className="cls-107"
                d="M91.87,221.05c-.59-.13-.53.46-.22.93.47.73,1.31,1.08,1.39.58.09-.49-.58-1.35-1.17-1.51h0Z"
              />
              <path
                className="cls-107"
                d="M88.99,220.24c.25.58.5,1.16.76,1.74.52.12.52-.39.18-.93-.09-.15-.43-.63-.94-.81h0Z"
              />
              <path
                className="cls-107"
                d="M93.09,219c-.51-.13-1.02-.26-1.52-.4.38.92,1.36,1.4,1.55.92.08-.18,0-.41-.04-.52h0Z"
              />
              <path
                className="cls-107"
                d="M90.08,218.19c-.49-.14-.98-.28-1.46-.41.39.92,1.34,1.41,1.51.94.07-.18-.01-.41-.05-.52h0Z"
              />
            </g>
            <g className="cls-171">
              <path
                className="cls-107"
                d="M98.02,231.34c-.39-.08-.5.15-.27.59.46.12.92.24,1.39.36-.34-.57-.86-.88-1.12-.95h0Z"
              />
              <path
                className="cls-107"
                d="M95.28,230.59c-.38-.09-.46.14-.22.59.44.13.89.25,1.33.38-.35-.58-.86-.89-1.12-.97h0Z"
              />
              <path
                className="cls-107"
                d="M97.8,228.53c-.56-.11-.49.39-.22.79.07.11.44.64,1.02.81-.27-.53-.54-1.06-.8-1.6h0Z"
              />
              <path
                className="cls-107"
                d="M94.94,227.78c-.54-.12-.45.38-.18.79.46.69,1.3,1.09,1.4.68.1-.42-.64-1.31-1.22-1.47h0Z"
              />
              <path
                className="cls-107"
                d="M92.19,227c.29.55.58,1.09.87,1.62.49.12.41-.33.19-.69-.16-.26-.56-.76-1.06-.93h0Z"
              />
              <path
                className="cls-107"
                d="M95.92,225.89c-.49-.13-.98-.25-1.46-.38.43.86,1.39,1.31,1.53.87.06-.17-.03-.38-.07-.48h0Z"
              />
              <path
                className="cls-107"
                d="M93.03,225.12c-.47-.13-.94-.26-1.4-.4.44.86,1.37,1.32,1.49.88.05-.17-.05-.39-.09-.48h0Z"
              />
            </g>
            <g className="cls-173">
              <path
                className="cls-107"
                d="M101.63,237.3c-.46-.1-.36.24-.23.46.01.02.03.05.05.07.43.12.87.23,1.31.34-.38-.52-.88-.81-1.13-.88h0Z"
              />
              <path
                className="cls-107"
                d="M99.04,236.59c-.44-.1-.32.24-.18.46.01.02.03.05.05.07.42.12.84.24,1.26.36-.39-.53-.89-.82-1.13-.89h0Z"
              />
              <path
                className="cls-107"
                d="M101.15,234.73c-.53-.11-.4.34-.19.64.16.24.58.68,1.08.83-.3-.49-.6-.98-.9-1.47h0Z"
              />
              <path
                className="cls-107"
                d="M98.43,234.02c-.47-.11-.37.28-.19.56.41.65,1.34,1.18,1.46.83.12-.35-.68-1.24-1.27-1.39h0Z"
              />
              <path
                className="cls-107"
                d="M95.82,233.28c.32.5.65,1,.97,1.49.43.11.33-.25.19-.48-.18-.32-.66-.84-1.17-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M99.15,232.29c-.47-.12-.93-.24-1.39-.36.48.79,1.41,1.21,1.5.81.04-.16-.07-.36-.11-.44h0Z"
              />
              <path
                className="cls-107"
                d="M96.4,231.56c-.45-.12-.89-.25-1.33-.38.5.79,1.4,1.23,1.47.82.03-.15-.08-.36-.13-.45h0Z"
              />
            </g>
            <g className="cls-172">
              <path
                className="cls-107"
                d="M105.61,242.72c-.47-.1-.24.27-.19.35.03.04.07.09.1.13.41.11.81.22,1.23.32-.41-.47-.9-.74-1.13-.8h0Z"
              />
              <path
                className="cls-107"
                d="M103.19,242.06c-.39-.09-.24.2-.18.29.04.07.1.13.14.18.39.11.78.22,1.18.33-.42-.48-.91-.75-1.14-.81h0Z"
              />
              <path
                className="cls-107"
                d="M104.86,240.4c-.45-.09-.34.23-.2.44.17.26.65.74,1.18.89-.33-.44-.66-.88-.98-1.33h0Z"
              />
              <path
                className="cls-107"
                d="M102.31,239.73c-.48-.11-.23.32-.2.37.38.62,1.44,1.24,1.51.9.07-.31-.77-1.12-1.32-1.27h0Z"
              />
              <path
                className="cls-107"
                d="M99.85,239.04c.35.46.71.91,1.07,1.35.44.11.21-.28.16-.36-.2-.31-.73-.82-1.23-.99h0Z"
              />
              <path
                className="cls-107"
                d="M102.77,238.17c-.44-.11-.88-.23-1.31-.34.53.72,1.42,1.12,1.46.75.02-.16-.15-.4-.15-.4h0Z"
              />
              <path
                className="cls-107"
                d="M100.17,237.48c-.42-.12-.84-.24-1.26-.36.53.7,1.35,1.11,1.43.8.04-.16-.16-.44-.17-.45h0Z"
              />
            </g>
            <g className="cls-168">
              <path
                className="cls-107"
                d="M109.94,247.59c-.32-.07-.25.1-.18.21.05.08.11.14.18.21.37.1.75.2,1.13.3-.44-.42-.92-.66-1.13-.71h0Z"
              />
              <path
                className="cls-107"
                d="M107.7,246.97c-.26-.06-.24.05-.17.16.06.1.16.2.22.26.36.1.72.21,1.09.31-.45-.43-.93-.67-1.13-.73h0Z"
              />
              <path
                className="cls-107"
                d="M108.93,245.53c-.4-.08-.25.19-.2.28.18.28.75.76,1.27.91-.36-.39-.72-.79-1.07-1.19h0Z"
              />
              <path
                className="cls-107"
                d="M106.55,244.91c-.33-.08-.26.11-.19.23.29.5,1.45,1.21,1.55.94.09-.24-.83-1.03-1.35-1.17h0Z"
              />
              <path
                className="cls-107"
                d="M104.26,244.25c.38.41.77.82,1.16,1.22.31.08.23-.1.16-.22-.18-.29-.81-.83-1.32-1h0Z"
              />
              <path
                className="cls-107"
                d="M106.75,243.52c-.41-.11-.82-.21-1.23-.32.55.63,1.36.99,1.41.72.03-.15-.19-.4-.19-.4h0Z"
              />
              <path
                className="cls-107"
                d="M104.32,242.87c-.4-.11-.79-.22-1.18-.33.57.63,1.36,1.01,1.39.73.01-.15-.21-.4-.21-.4h0Z"
              />
            </g>
            <g className="cls-174">
              <path
                className="cls-107"
                d="M110.23,249.65c.22.2.29.34.17.35-.03,0-.08-.01-.12-.02-.42-.35-.83-.71-1.25-1.07.41.14.95.52,1.19.74h0Z"
              />
              <path
                className="cls-107"
                d="M111.13,248.36c.22.24.24.39.05.37-.21-.01-.76-.27-1.24-.73.37.1.75.2,1.13.3.02.02.04.04.05.06h0Z"
              />
              <path
                className="cls-107"
                d="M108.89,247.76c.23.24.26.39.09.37-.2-.02-.74-.28-1.23-.74.36.1.72.21,1.09.31.02.02.04.04.06.06h0Z"
              />
            </g>
            <g className="cls-170">
              <path
                className="cls-107"
                d="M90.61,111.91c-.41-.09-.83.23-1.1.84.44.14.89.28,1.34.41.29-.78.01-1.18-.24-1.26h0Z"
              />
              <path
                className="cls-107"
                d="M87.99,111.07c-.38-.09-.81.23-1.09.83.42.14.85.29,1.29.43.32-.84,0-1.19-.2-1.26h0Z"
              />
              <path
                className="cls-107"
                d="M91.09,107.38c-.82-.19-1.54,1.31-1.13,1.89.38.54,1.3-.15,1.45-1.07.07-.41-.06-.73-.31-.82h0Z"
              />
              <path
                className="cls-107"
                d="M88.59,106.54c-.32.68-.64,1.36-.95,2.04.78.2,1.52-1.3,1.15-1.88-.07-.1-.13-.13-.2-.16h0Z"
              />
            </g>
            <g className="cls-169">
              <path
                className="cls-107"
                d="M87.38,120.37c-.42-.09-.83.23-1.07.86.46.15.93.29,1.4.43.24-.8-.07-1.21-.33-1.29h0Z"
              />
              <path
                className="cls-107"
                d="M84.64,119.5c-.4-.1-.81.23-1.05.84.44.15.89.3,1.34.45.27-.86-.07-1.22-.29-1.29h0Z"
              />
              <path
                className="cls-107"
                d="M90.31,116.53c-.82-.17-1.47,1.25-1.07,1.9.1.16.22.2.29.23.25-.71.51-1.42.78-2.13h0Z"
              />
              <path
                className="cls-107"
                d="M87.58,115.69c-.78-.18-1.45,1.24-1.08,1.89.32.56,1.13.14,1.39-.72.17-.54.03-1.05-.31-1.16h0Z"
              />
              <path
                className="cls-107"
                d="M84.96,114.82c-.28.7-.56,1.4-.83,2.11.75.19,1.43-1.22,1.09-1.87-.08-.16-.19-.2-.25-.23h0Z"
              />
              <path
                className="cls-107"
                d="M90.85,113.17c-.45-.14-.9-.27-1.34-.41-.36.96.12,1.43.62,1.23.2-.08.49-.29.72-.81h0Z"
              />
              <path
                className="cls-107"
                d="M88.19,112.33c-.43-.14-.86-.29-1.29-.43-.35.89.03,1.45.57,1.23.2-.08.48-.28.72-.8h0Z"
              />
            </g>
            <g className="cls-176">
              <path
                className="cls-107"
                d="M84.61,129.07c-.43-.1-.83.24-1.03.88.48.15.96.3,1.45.45.2-.82-.14-1.24-.42-1.32h0Z"
              />
              <path
                className="cls-107"
                d="M81.77,128.16c-.41-.1-.81.24-1.01.86.46.16.92.31,1.39.46.22-.88-.15-1.25-.38-1.33h0Z"
              />
              <path
                className="cls-107"
                d="M87.37,125.13c-.84-.18-1.42,1.28-.97,1.95.11.16.23.21.31.24.22-.73.44-1.46.66-2.18h0Z"
              />
              <path
                className="cls-107"
                d="M84.52,124.26c-.81-.19-1.4,1.26-.98,1.94.36.58,1.16.15,1.37-.74.14-.57-.03-1.08-.39-1.2h0Z"
              />
              <path
                className="cls-107"
                d="M81.8,123.35c-.24.72-.48,1.44-.71,2.17.79.2,1.38-1.25.99-1.93-.09-.16-.21-.21-.27-.24h0Z"
              />
              <path
                className="cls-107"
                d="M87.71,121.66c-.47-.14-.94-.29-1.4-.43-.32,1.03.26,1.53.78,1.24.26-.14.47-.41.62-.81h0Z"
              />
              <path
                className="cls-107"
                d="M84.93,120.79c-.45-.15-.9-.3-1.34-.45-.33,1.03.21,1.53.73,1.25.38-.21.55-.65.61-.8h0Z"
              />
            </g>
            <g className="cls-175">
              <path
                className="cls-107"
                d="M82.32,137.96c-.44-.1-.82.24-.99.89.49.15.99.31,1.49.46.15-.83-.21-1.26-.5-1.35h0Z"
              />
              <path
                className="cls-107"
                d="M79.41,137.03c-.42-.1-.8.24-.97.88.47.16.95.32,1.43.48.16-.83-.19-1.27-.46-1.36h0Z"
              />
              <path
                className="cls-107"
                d="M81.95,133.04c-.83-.2-1.34,1.29-.87,1.98.4.59,1.18.15,1.34-.75.11-.58-.1-1.11-.47-1.23h0Z"
              />
              <path
                className="cls-107"
                d="M79.14,132.1c-.2.74-.4,1.48-.58,2.22.81.21,1.32-1.28.88-1.97-.1-.16-.22-.21-.29-.25h0Z"
              />
              <path
                className="cls-107"
                d="M85.02,130.39c-.49-.15-.97-.3-1.45-.45-.27,1.08.35,1.55.87,1.26.39-.21.53-.67.58-.82h0Z"
              />
              <path
                className="cls-107"
                d="M82.15,129.49c-.47-.15-.93-.31-1.39-.46-.27,1.04.31,1.56.82,1.28.37-.21.52-.66.57-.81h0Z"
              />
            </g>
            <g className="cls-177">
              <path
                className="cls-107"
                d="M77.45,142.53c-.09.33-.39.91-.91.77.14-.75.3-1.51.45-2.26.53.23.58,1.01.45,1.49h0Z"
              />
              <path
                className="cls-107"
                d="M82.79,139.43c-.24.82-.98,1.08-1.34.46-.24-.4-.15-.88-.12-1.04.49.15.99.31,1.49.46,0,.03-.02.08-.03.11h0Z"
              />
              <path
                className="cls-107"
                d="M79.84,138.5c-.24.82-.96,1.07-1.3.45-.23-.41-.13-.88-.1-1.04.47.16.95.32,1.43.48,0,.03-.02.08-.03.11h0Z"
              />
            </g>
            <g className="cls-144">
              <path
                className="cls-107"
                d="M81.5,200.85c-.43-.11-.63.19-.51.78.49.15.99.31,1.49.46-.2-.75-.7-1.15-.98-1.24h0Z"
              />
              <path
                className="cls-107"
                d="M78.56,199.91c-.41-.11-.59.19-.47.77.47.16.95.32,1.43.48-.2-.75-.69-1.16-.96-1.25h0Z"
              />
              <path
                className="cls-107"
                d="M79.15,196.27c-.64-.16-.72.69-.29,1.42.44.74,1.12.92,1.25.32.13-.6-.4-1.56-.96-1.74h0Z"
              />
              <path
                className="cls-107"
                d="M76.25,195.3c.14.69.28,1.39.43,2.07.61.17.67-.68.25-1.41-.19-.33-.42-.55-.68-.66h0Z"
              />
            </g>
            <g className="cls-143">
              <path
                className="cls-107"
                d="M83.57,208.76c-.42-.1-.58.18-.43.73.48.15.96.3,1.45.45-.24-.71-.75-1.1-1.02-1.18h0Z"
              />
              <path
                className="cls-107"
                d="M80.7,207.84c-.4-.11-.55.18-.39.73.46.16.92.31,1.39.47-.25-.71-.74-1.1-1.01-1.19h0Z"
              />
              <path
                className="cls-107"
                d="M83.96,205.31c-.67-.16-.64.65-.27,1.25.15.25.41.57.8.71-.18-.65-.35-1.3-.52-1.96h0Z"
              />
              <path
                className="cls-107"
                d="M81,204.4c-.64-.17-.6.64-.23,1.25.44.73,1.12.99,1.26.48.15-.55-.44-1.54-1.03-1.73h0Z"
              />
              <path
                className="cls-107"
                d="M78.16,203.45c.18.66.37,1.32.56,1.97.57.16.59-.57.19-1.25-.15-.25-.4-.58-.75-.73h0Z"
              />
              <path
                className="cls-107"
                d="M82.48,202.09c-.5-.15-1-.3-1.49-.46.27,1.01,1.14,1.57,1.44,1.11.14-.21.08-.52.05-.65h0Z"
              />
              <path
                className="cls-107"
                d="M79.52,201.16c-.48-.16-.96-.32-1.43-.48.27,1,1.13,1.58,1.4,1.13.13-.21.06-.52.04-.65h0Z"
              />
            </g>
            <g className="cls-142">
              <path
                className="cls-107"
                d="M86.13,216.24c-.4-.1-.54.16-.35.68.46.15.93.29,1.41.43-.29-.67-.79-1.04-1.06-1.12h0Z"
              />
              <path
                className="cls-107"
                d="M83.36,215.35c-.38-.1-.5.16-.3.68.44.15.89.3,1.35.45-.3-.67-.79-1.05-1.04-1.13h0Z"
              />
              <path
                className="cls-107"
                d="M86.24,213c-.64-.15-.56.55-.23,1.09.14.22.43.61.87.76-.22-.61-.43-1.23-.64-1.85h0Z"
              />
              <path
                className="cls-107"
                d="M83.36,212.11c-.57-.15-.52.48-.24.99.42.75,1.17,1.15,1.33.7.17-.49-.49-1.5-1.09-1.69h0Z"
              />
              <path
                className="cls-107"
                d="M80.61,211.19c.22.63.45,1.25.69,1.87.5.14.51-.4.19-.99-.09-.16-.4-.68-.88-.88h0Z"
              />
              <path
                className="cls-107"
                d="M84.59,209.94c-.49-.15-.97-.3-1.45-.45.34.98,1.27,1.51,1.48,1,.08-.19.01-.44-.02-.56h0Z"
              />
              <path
                className="cls-107"
                d="M81.71,209.03c-.47-.15-.93-.31-1.39-.47.33.94,1.19,1.49,1.41,1.08.1-.19.02-.49-.01-.61h0Z"
              />
            </g>
            <g className="cls-141">
              <path
                className="cls-107"
                d="M89.17,223.26c-.39-.1-.49.15-.26.64.45.14.9.28,1.35.42-.33-.63-.83-.97-1.09-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M86.5,222.41c-.36-.1-.45.15-.22.63.43.15.86.29,1.29.43-.34-.63-.83-.98-1.08-1.06h0Z"
              />
              <path
                className="cls-107"
                d="M88.99,220.24c-.57-.14-.49.45-.18.93.09.15.44.63.94.81-.26-.57-.51-1.15-.76-1.74h0Z"
              />
              <path
                className="cls-107"
                d="M86.21,219.38c-.52-.14-.45.4-.19.84.44.75,1.25,1.2,1.36.76.11-.45-.6-1.41-1.17-1.6h0Z"
              />
              <path
                className="cls-107"
                d="M83.56,218.49c.27.59.54,1.17.81,1.75.49.14.4-.39.15-.83-.07-.12-.43-.71-.96-.92h0Z"
              />
              <path
                className="cls-107"
                d="M87.19,217.36c-.47-.14-.94-.29-1.41-.43.4.92,1.32,1.43,1.47.96.06-.18-.03-.41-.07-.52h0Z"
              />
              <path
                className="cls-107"
                d="M84.4,216.48c-.45-.15-.9-.3-1.35-.45.4.9,1.23,1.42,1.41,1.02.08-.18-.02-.46-.07-.57h0Z"
              />
            </g>
            <g className="cls-140">
              <path
                className="cls-107"
                d="M92.65,229.81c-.37-.09-.43.13-.17.58.42.13.85.26,1.29.4-.37-.58-.86-.9-1.11-.98h0Z"
              />
              <path
                className="cls-107"
                d="M90.1,229c-.43-.12-.3.28-.18.5.01.02.03.06.05.08.41.14.82.28,1.23.41-.38-.59-.87-.91-1.1-.99h0Z"
              />
              <path
                className="cls-107"
                d="M92.19,227c-.53-.13-.39.36-.19.7.16.26.56.75,1.06.92-.29-.54-.58-1.08-.87-1.62h0Z"
              />
              <path
                className="cls-107"
                d="M89.53,226.18c-.46-.12-.37.3-.19.62.4.72,1.29,1.3,1.42.93.13-.38-.65-1.36-1.23-1.54h0Z"
              />
              <path
                className="cls-107"
                d="M86.99,225.33c.31.55.62,1.1.93,1.64.43.13.33-.29.15-.6-.18-.32-.61-.85-1.09-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M90.25,224.31c-.45-.14-.9-.28-1.35-.42.46.86,1.36,1.34,1.46.9.04-.17-.06-.39-.11-.48h0Z"
              />
              <path
                className="cls-107"
                d="M87.58,223.47c-.44-.14-.87-.29-1.29-.43.45.83,1.28,1.32,1.41.96.06-.17-.06-.42-.11-.53h0Z"
              />
            </g>
            <g className="cls-139">
              <path
                className="cls-107"
                d="M96.55,235.85c-.46-.12-.23.3-.18.39.03.04.07.1.09.14.4.13.8.25,1.21.37-.4-.53-.89-.83-1.13-.9h0Z"
              />
              <path
                className="cls-107"
                d="M94.15,235.08c-.39-.11-.24.22-.18.32.04.08.1.15.14.21.38.13.77.26,1.16.39-.45-.58-.93-.85-1.12-.92h0Z"
              />
              <path
                className="cls-107"
                d="M95.82,233.28c-.44-.11-.33.25-.2.48.18.32.67.84,1.17,1.01-.33-.49-.65-.99-.97-1.49h0Z"
              />
              <path
                className="cls-107"
                d="M93.29,232.5c-.43-.11-.29.26-.16.48.41.68,1.38,1.31,1.46.94.07-.35-.75-1.25-1.3-1.43h0Z"
              />
              <path
                className="cls-107"
                d="M90.88,231.69c.34.51.69,1.02,1.04,1.52.43.13.21-.32.16-.41-.19-.34-.71-.92-1.2-1.11h0Z"
              />
              <path
                className="cls-107"
                d="M93.76,230.79c-.43-.13-.86-.26-1.29-.4.49.77,1.32,1.22,1.42.89.06-.18-.14-.49-.14-.49h0Z"
              />
              <path
                className="cls-107"
                d="M91.21,229.99c-.42-.14-.83-.27-1.23-.41.51.78,1.32,1.24,1.39.9.04-.18-.16-.49-.16-.49h0Z"
              />
            </g>
            <g className="cls-138">
              <path
                className="cls-107"
                d="M100.86,241.37c-.32-.09-.25.11-.18.23.05.09.11.16.18.24.37.12.75.23,1.13.35-.44-.48-.92-.76-1.13-.82h0Z"
              />
              <path
                className="cls-107"
                d="M98.61,240.65c-.26-.08-.24.06-.17.18.06.11.16.22.22.29.36.12.72.24,1.09.36-.49-.53-.95-.78-1.13-.84h0Z"
              />
              <path
                className="cls-107"
                d="M99.85,239.04c-.4-.1-.25.21-.2.31.18.32.75.87,1.27,1.04-.36-.45-.72-.9-1.07-1.35h0Z"
              />
              <path
                className="cls-107"
                d="M97.47,238.3c-.38-.1-.22.21-.16.31.35.59,1.41,1.31,1.51,1.02.09-.27-.82-1.16-1.35-1.33h0Z"
              />
              <path
                className="cls-107"
                d="M95.2,237.55c.38.47.76.93,1.15,1.38.3.09.23-.11.16-.24-.18-.32-.8-.94-1.3-1.14h0Z"
              />
              <path
                className="cls-107"
                d="M97.68,236.76c-.41-.12-.81-.25-1.21-.37.54.71,1.35,1.12,1.4.82.03-.16-.18-.45-.19-.45h0Z"
              />
              <path
                className="cls-107"
                d="M95.27,236c-.39-.13-.78-.26-1.16-.39.56.72,1.35,1.14,1.37.84.01-.16-.21-.45-.21-.45h0Z"
              />
            </g>
            <g className="cls-145">
              <path
                className="cls-107"
                d="M105.54,246.33c-.07-.02-.28-.07-.17.12.06.11.18.23.26.3.35.11.7.22,1.05.32-.47-.43-.94-.68-1.14-.74h0Z"
              />
              <path
                className="cls-107"
                d="M103.46,245.67c-.06-.02-.23-.07-.16.08.05.11.22.27.29.34.33.11.67.22,1.01.34-.52-.47-.97-.7-1.14-.75h0Z"
              />
              <path
                className="cls-107"
                d="M104.26,244.25c-.27-.07-.25.06-.19.18.15.28.82.86,1.35,1.04-.39-.4-.78-.8-1.16-1.22h0Z"
              />
              <path
                className="cls-107"
                d="M102.05,243.57c-.26-.07-.23.06-.16.17.29.5,1.52,1.3,1.56,1.03.04-.24-.91-1.04-1.41-1.2h0Z"
              />
              <path
                className="cls-107"
                d="M99.94,242.87c.41.42.83.83,1.24,1.24.06.02.26.08.15-.12-.15-.28-.88-.92-1.39-1.12h0Z"
              />
              <path
                className="cls-107"
                d="M101.99,242.19c-.38-.12-.76-.23-1.13-.35.59.64,1.36,1.02,1.37.75,0-.14-.23-.4-.23-.4h0Z"
              />
              <path
                className="cls-107"
                d="M99.74,241.49c-.37-.12-.73-.24-1.09-.36.57.61,1.31,1.01,1.34.8.02-.13-.25-.43-.25-.43h0Z"
              />
            </g>
            <g className="cls-147">
              <path
                className="cls-107"
                d="M108.67,250.11c-.06-.02-.19-.06-.13.04.06.1.26.25.35.32.3.1.61.21.92.31-.56-.42-.99-.62-1.14-.67h0Z"
              />
              <path
                className="cls-107"
                d="M109.04,248.91c-.07-.02-.27-.07-.15.11.17.26.92.8,1.4.96-.42-.35-.83-.71-1.25-1.07h0Z"
              />
              <path
                className="cls-107"
                d="M107,248.28c-.06-.02-.23-.06-.15.08.2.35,1.55,1.19,1.6,1,.05-.17-.97-.93-1.46-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M105.06,247.63c.44.37.89.74,1.34,1.1.06.02.19.06.13-.05-.1-.2-.95-.86-1.47-1.06h0Z"
              />
              <path
                className="cls-107"
                d="M106.68,247.07c-.35-.11-.7-.21-1.05-.32.6.54,1.31.89,1.33.7,0-.12-.28-.38-.28-.38h0Z"
              />
              <path
                className="cls-107"
                d="M104.6,246.42c-.34-.11-.67-.22-1.01-.34.61.54,1.32.9,1.31.72,0-.12-.3-.38-.31-.39h0Z"
              />
            </g>
            <g className="cls-146">
              <path
                className="cls-107"
                d="M115.94,254.51c-.08-.02-.11-.03-.12-.01,0,.04.12.14.39.31.28.09.57.18.86.26-.53-.32-.96-.51-1.12-.56h0Z"
              />
              <path
                className="cls-107"
                d="M114.23,253.96c-.08-.02-.1-.03-.11-.01,0,.04.14.14.42.31.27.09.55.18.82.27-.6-.36-1-.53-1.13-.57h0Z"
              />
              <path
                className="cls-107"
                d="M112.31,252.41c-.05-.01-.16-.05-.13.02.11.23,1.55,1.05,1.63.93.06-.1-1.06-.81-1.5-.95h0Z"
              />
              <path
                className="cls-107"
                d="M110.54,251.82c.47.32.95.64,1.42.95.08.02.1.03.11.01-.01-.13-1.06-.79-1.54-.96h0Z"
              />
              <path
                className="cls-107"
                d="M109.81,250.78c-.31-.1-.61-.2-.92-.31.61.45,1.27.77,1.28.66,0-.08-.36-.35-.36-.35h0Z"
              />
            </g>
            <g className="cls-119">
              <path
                className="cls-107"
                d="M120.12,257.2c-.06-.02-.07-.02-.08-.02,0,.01.03.05.48.26.24.08.48.16.72.24-.64-.3-1-.44-1.12-.48h0Z"
              />
              <path
                className="cls-107"
                d="M117.93,255.92c-.07-.02-.08-.02-.1-.02,0,0,0,.01,0,.01.14.16,1.49.82,1.65.8,0-.09-1.23-.7-1.55-.8h0Z"
              />
              <path
                className="cls-107"
                d="M116.36,255.4c.5.27,1,.54,1.5.8.06.02.07.02.09.02-.04-.09-1.2-.67-1.59-.82h0Z"
              />
              <path
                className="cls-107"
                d="M117.07,255.07c-.29-.09-.57-.18-.86-.26.56.33,1.18.62,1.25.57,0-.07-.39-.3-.39-.3h0Z"
              />
              <path
                className="cls-107"
                d="M115.36,254.54c-.28-.09-.55-.18-.82-.27.56.33,1.2.63,1.25.58-.02-.07-.42-.31-.42-.31h0Z"
              />
            </g>
            <g className="cls-120">
              <path
                className="cls-107"
                d="M125.05,259.26c.36.15.4.17.41.18-.12,0-1.58-.58-1.67-.65t.07.02c.36.12,1.15.44,1.18.45h0Z"
              />
              <path
                className="cls-107"
                d="M121.31,257.71c.36.17.39.2.4.21-.03.02-.69-.25-1.2-.49.24.08.48.16.72.24.02.01.05.02.08.04h0Z"
              />
            </g>
            <g className="cls-122">
              <path
                className="cls-107"
                d="M106.44,73.15c.44-.46.88-.7,1.14-.63.22.12.09.48-.32.96-.28-.11-.55-.22-.83-.33h0Z"
              />
            </g>
            <g className="cls-121">
              <path
                className="cls-107"
                d="M103.46,76.49c-.24.26-.73.67-1.06.57.48-.56.96-1.11,1.44-1.66.29.16-.05.73-.38,1.09h0Z"
              />
              <path
                className="cls-107"
                d="M107.19,73.56c-.55.56-1.16.76-1.18.38,0-.11.05-.36.43-.79.27.11.55.22.83.33-.02.02-.05.06-.08.08h0Z"
              />
            </g>
            <g className="cls-125">
              <path
                className="cls-107"
                d="M97.41,87.58c.38-.53.81-.8,1.13-.72.28.13.24.55-.1,1.1-.35-.12-.69-.25-1.03-.37h0Z"
              />
              <path
                className="cls-107"
                d="M97.96,83.32c-.23.28-.71.71-1.06.61.44-.59.89-1.18,1.34-1.76.32.18.03.78-.28,1.15h0Z"
              />
            </g>
            <g className="cls-127">
              <path
                className="cls-107"
                d="M94.91,91.36c-.48.68-1.17.89-1.25.37-.1-.62.79-1.76,1.4-1.59.37.18.14.82-.14,1.22h0Z"
              />
              <path
                className="cls-107"
                d="M92.84,90.56c-.21.29-.67.74-1.05.63.41-.62.82-1.24,1.23-1.85.35.19.1.83-.19,1.22h0Z"
              />
              <path
                className="cls-107"
                d="M98.38,88.04c-.5.67-1.19.88-1.25.37-.03-.22.07-.5.29-.84.34.13.68.25,1.03.37-.02.03-.04.06-.06.09h0Z"
              />
            </g>
            <g className="cls-124">
              <path
                className="cls-107"
                d="M84.41,111.02c.29-.6.7-.92,1.07-.82.35.16.41.65.16,1.26-.42-.15-.83-.3-1.23-.45h0Z"
              />
              <path
                className="cls-107"
                d="M87.64,108.58c-.67-.3-.12-1.74.6-2.02.17-.07.28-.04.35-.02-.32.68-.64,1.36-.95,2.04h0Z"
              />
            </g>
            <g className="cls-123">
              <path
                className="cls-107"
                d="M80.99,119.42c.25-.62.65-.94,1.04-.83.36.16.45.67.25,1.3-.43-.15-.86-.31-1.28-.47h0Z"
              />
              <path
                className="cls-107"
                d="M84.13,116.92c-.71-.32-.24-1.8.48-2.09.17-.07.29-.04.36-.02-.28.7-.56,1.4-.83,2.11h0Z"
              />
              <path
                className="cls-107"
                d="M85.59,111.57c-.38.76-1.1.98-1.29.41-.08-.25-.05-.57.11-.96.41.15.82.3,1.23.45-.01.03-.03.07-.05.1h0Z"
              />
            </g>
            <g className="cls-126">
              <path
                className="cls-107"
                d="M79.07,127.22c-.4-.11-.78.22-.99.85.44.16.88.32,1.33.48.21-.81-.08-1.24-.33-1.33h0Z"
              />
              <path
                className="cls-107"
                d="M76.48,126.24c-.37-.11-.76.22-.97.84.42.17.84.33,1.27.5.24-.87-.09-1.26-.29-1.34h0Z"
              />
              <path
                className="cls-107"
                d="M81.8,123.35c-.78-.2-1.38,1.25-.99,1.92.09.16.21.21.28.24.23-.72.47-1.45.71-2.17h0Z"
              />
              <path
                className="cls-107"
                d="M79.2,122.4c-.75-.22-1.37,1.23-1,1.91.32.59,1.06.19,1.3-.71.15-.56.02-1.08-.31-1.21h0Z"
              />
              <path
                className="cls-107"
                d="M82.28,119.88c-.43-.15-.86-.31-1.28-.47-.35,1.03.17,1.53.67,1.26.25-.14.46-.4.61-.79h0Z"
              />
            </g>
            <g className="cls-118">
              <path
                className="cls-107"
                d="M76.62,136.06c-.41-.11-.77.22-.95.87.45.17.91.33,1.37.5.17-.83-.16-1.27-.42-1.36h0Z"
              />
              <path
                className="cls-107"
                d="M73.96,135.05c-.38-.12-.74.22-.92.86.43.17.86.34,1.3.51.17-.83-.13-1.27-.38-1.37h0Z"
              />
              <path
                className="cls-107"
                d="M79.14,132.1c-.8-.21-1.32,1.27-.88,1.97.1.17.22.22.29.25.19-.74.38-1.48.58-2.22h0Z"
              />
              <path
                className="cls-107"
                d="M76.45,131.13c-.77-.22-1.3,1.25-.88,1.96.33.56,1.01.23,1.24-.6.16-.61,0-1.21-.36-1.35h0Z"
              />
              <path
                className="cls-107"
                d="M73.88,130.12c-.21.73-.42,1.47-.62,2.2.73.23,1.26-1.24.88-1.95-.09-.17-.2-.22-.26-.25h0Z"
              />
              <path
                className="cls-107"
                d="M79.4,128.55c-.45-.16-.89-.32-1.33-.48-.29,1.07.27,1.56.76,1.29.37-.2.52-.66.57-.81h0Z"
              />
              <path
                className="cls-107"
                d="M76.77,127.58c-.43-.16-.85-.33-1.27-.5-.29,1.04.23,1.57.71,1.3.35-.2.51-.65.56-.8h0Z"
              />
            </g>
            <g className="cls-158">
              <path
                className="cls-107"
                d="M72,144.04c-.39-.12-.73.22-.86.87.44.18.88.35,1.33.52.12-.84-.21-1.3-.46-1.39h0Z"
              />
              <path
                className="cls-107"
                d="M76.99,141.05c-.77-.2-1.22,1.18-.81,1.93.13.23.27.29.36.33.14-.75.3-1.51.45-2.26h0Z"
              />
              <path
                className="cls-107"
                d="M74.24,140.05c-.74-.22-1.19,1.16-.81,1.92.31.6.93.44,1.19-.31.23-.66.04-1.44-.38-1.6h0Z"
              />
              <path
                className="cls-107"
                d="M71.61,139.01c-.17.75-.33,1.5-.48,2.25.71.22,1.15-1.15.79-1.91-.11-.23-.23-.29-.32-.34h0Z"
              />
              <path
                className="cls-107"
                d="M77.04,137.42c-.46-.16-.92-.33-1.37-.5-.22,1.1.37,1.6.85,1.32.36-.21.48-.67.52-.82h0Z"
              />
              <path
                className="cls-107"
                d="M74.34,136.42c-.44-.17-.87-.34-1.3-.51-.23,1.06.33,1.6.79,1.33.34-.2.47-.66.51-.82h0Z"
              />
            </g>
            <g className="cls-161">
              <path
                className="cls-107"
                d="M70.38,149.59c-.07.35-.32.91-.8.76.1-.77.21-1.53.33-2.29.49.25.57,1.05.46,1.53h0Z"
              />
              <path
                className="cls-107"
                d="M72.44,145.55c-.19.79-.78,1.05-1.13.5-.13-.2-.26-.56-.17-1.14.44.18.88.35,1.33.52,0,.03-.02.08-.02.11h0Z"
              />
            </g>
            <g className="cls-160">
              <path
                className="cls-107"
                d="M75.75,198.93c-.4-.12-.56.18-.43.77.45.17.91.33,1.37.5-.21-.75-.67-1.17-.94-1.26h0Z"
              />
              <path
                className="cls-107"
                d="M73.06,197.91c-.37-.12-.52.18-.39.76.43.17.86.34,1.3.51-.21-.76-.66-1.18-.91-1.27h0Z"
              />
              <path
                className="cls-107"
                d="M76.25,195.3c-.61-.17-.67.68-.25,1.41.19.33.42.55.68.66-.15-.69-.29-1.38-.43-2.07h0Z"
              />
              <path
                className="cls-107"
                d="M73.47,194.3c-.61-.19-.6.66-.27,1.31.39.78,1.03,1.06,1.18.52.16-.57-.36-1.63-.9-1.83h0Z"
              />
              <path
                className="cls-107"
                d="M70.83,193.25c.15.7.3,1.39.45,2.08.53.18.58-.58.23-1.3-.13-.27-.35-.62-.68-.78h0Z"
              />
            </g>
            <g className="cls-159">
              <path
                className="cls-107"
                d="M77.96,206.89c-.38-.11-.52.16-.35.72.44.16.88.32,1.33.48-.26-.72-.73-1.11-.99-1.21h0Z"
              />
              <path
                className="cls-107"
                d="M75.34,205.9c-.36-.12-.48.16-.31.72.42.17.84.34,1.27.5-.26-.72-.72-1.12-.96-1.22h0Z"
              />
              <path
                className="cls-107"
                d="M78.16,203.45c-.56-.16-.59.5-.25,1.15.12.23.39.65.81.82-.19-.65-.38-1.31-.56-1.97h0Z"
              />
              <path
                className="cls-107"
                d="M75.45,202.47c-.58-.18-.51.57-.21,1.14.4.76,1.04,1.12,1.19.67.17-.5-.43-1.6-.98-1.81h0Z"
              />
              <path
                className="cls-107"
                d="M72.86,201.44c.19.67.39,1.33.6,1.99.5.17.5-.49.16-1.14-.12-.24-.38-.66-.76-.84h0Z"
              />
              <path
                className="cls-107"
                d="M76.68,200.19c-.46-.16-.92-.33-1.37-.5.29,1.02,1.09,1.6,1.35,1.15.12-.21.05-.52.02-.65h0Z"
              />
              <path
                className="cls-107"
                d="M73.97,199.19c-.44-.17-.87-.34-1.3-.51.29,1,1.07,1.6,1.3,1.16.1-.21.03-.52,0-.65h0Z"
              />
            </g>
            <g className="cls-164">
              <path
                className="cls-107"
                d="M80.71,214.43c-.37-.11-.47.15-.26.68.42.16.85.31,1.29.47-.3-.68-.78-1.05-1.03-1.14h0Z"
              />
              <path
                className="cls-107"
                d="M78.17,213.47c-.35-.11-.43.15-.22.67.4.16.81.32,1.23.48-.31-.68-.77-1.06-1.01-1.16h0Z"
              />
              <path
                className="cls-107"
                d="M80.61,211.19c-.55-.16-.48.47-.19.99.09.16.41.68.88.88-.24-.62-.47-1.24-.69-1.87h0Z"
              />
              <path
                className="cls-107"
                d="M77.97,210.23c-.5-.16-.44.41-.21.89.38.77,1.1,1.27,1.26.88.18-.43-.49-1.56-1.06-1.77h0Z"
              />
              <path
                className="cls-107"
                d="M75.45,209.24c.24.63.48,1.26.73,1.88.46.16.39-.41.16-.88-.06-.13-.39-.76-.89-1h0Z"
              />
              <path
                className="cls-107"
                d="M78.95,208.09c-.45-.16-.89-.32-1.33-.48.35.96,1.16,1.51,1.36,1.09.1-.19,0-.48-.03-.61h0Z"
              />
              <path
                className="cls-107"
                d="M76.31,207.11c-.43-.17-.85-.33-1.27-.5.36.96,1.14,1.53,1.32,1.11.08-.19,0-.48-.05-.61h0Z"
              />
            </g>
            <g className="cls-166">
              <path
                className="cls-107"
                d="M83.95,221.52c-.35-.11-.42.13-.18.63.41.15.82.3,1.24.45-.35-.63-.83-.99-1.06-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M81.52,220.6c-.41-.14-.3.27-.18.54.01.03.03.06.04.09.39.16.78.31,1.18.47-.36-.64-.82-1-1.05-1.09h0Z"
              />
              <path
                className="cls-107"
                d="M83.56,218.49c-.48-.14-.4.35-.2.74.14.26.53.82,1.01,1.01-.28-.58-.55-1.16-.81-1.75h0Z"
              />
              <path
                className="cls-107"
                d="M81.01,217.57c-.46-.15-.37.34-.16.74.41.76,1.19,1.31,1.31.93.13-.4-.6-1.46-1.15-1.67h0Z"
              />
              <path
                className="cls-107"
                d="M78.59,216.61c.28.6.57,1.19.86,1.77.41.14.32-.31.15-.64-.16-.34-.57-.92-1.02-1.13h0Z"
              />
              <path
                className="cls-107"
                d="M81.73,215.57c-.43-.15-.86-.31-1.29-.47.41.9,1.21,1.43,1.37,1.04.07-.18-.03-.46-.08-.57h0Z"
              />
              <path
                className="cls-107"
                d="M79.18,214.62c-.41-.16-.82-.32-1.23-.48.42.91,1.2,1.45,1.33,1.06.06-.18-.05-.46-.1-.57h0Z"
              />
            </g>
            <g className="cls-167">
              <path
                className="cls-107"
                d="M87.68,228.15c-.45-.14-.23.33-.18.42.02.05.06.11.09.15.39.14.78.29,1.18.43-.39-.59-.87-.93-1.09-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M86.99,225.33c-.44-.13-.33.3-.15.61.18.31.61.84,1.08,1.03-.32-.54-.63-1.09-.93-1.64h0Z"
              />
              <path
                className="cls-107"
                d="M84.55,224.45c-.41-.13-.29.27-.16.52.37.7,1.25,1.39,1.39,1.08.14-.33-.67-1.4-1.23-1.61h0Z"
              />
              <path
                className="cls-107"
                d="M82.23,223.53c.33.56.66,1.11.99,1.66.42.15.2-.34.15-.43-.18-.38-.68-1.01-1.15-1.23h0Z"
              />
              <path
                className="cls-107"
                d="M85.01,222.6c-.42-.15-.83-.3-1.24-.45.47.85,1.26,1.34,1.37.98.06-.2-.13-.53-.13-.53h0Z"
              />
              <path
                className="cls-107"
                d="M82.56,221.69c-.4-.15-.79-.31-1.18-.47.47.84,1.25,1.35,1.33,1,.04-.19-.15-.53-.15-.53h0Z"
              />
            </g>
            <g className="cls-163">
              <path
                className="cls-107"
                d="M91.85,234.28c-.32-.1-.25.12-.18.26.05.1.11.18.18.27.37.14.74.27,1.11.4-.43-.54-.9-.85-1.11-.93h0Z"
              />
              <path
                className="cls-107"
                d="M90.88,231.69c-.45-.13-.19.35-.16.41.19.34.72.92,1.2,1.11-.35-.5-.7-1.01-1.04-1.52h0Z"
              />
              <path
                className="cls-107"
                d="M88.57,230.85c-.38-.12-.22.22-.16.33.34.65,1.38,1.47,1.47,1.16.09-.3-.78-1.29-1.31-1.49h0Z"
              />
              <path
                className="cls-107"
                d="M88.77,229.16c-.4-.14-.79-.28-1.18-.43.52.78,1.3,1.25,1.36.92.03-.18-.18-.49-.18-.49h0Z"
              />
            </g>
            <g className="cls-162">
              <path
                className="cls-107"
                d="M96.46,239.9c-.07-.02-.27-.09-.17.13.06.12.18.26.26.34.34.13.69.25,1.04.38-.47-.49-.93-.78-1.13-.85h0Z"
              />
              <path
                className="cls-107"
                d="M95.2,237.55c-.31-.09-.23.12-.16.25.18.32.8.94,1.3,1.13-.39-.45-.77-.91-1.15-1.38h0Z"
              />
              <path
                className="cls-107"
                d="M93.03,236.76c-.26-.08-.23.06-.16.19.27.53,1.42,1.43,1.53,1.2.11-.22-.85-1.19-1.37-1.39h0Z"
              />
              <path
                className="cls-107"
                d="M92.97,235.22c-.38-.13-.75-.27-1.11-.4.55.69,1.28,1.12,1.34.89.04-.15-.22-.48-.22-.48h0Z"
              />
            </g>
            <g className="cls-165">
              <path
                className="cls-107"
                d="M101.47,244.98c-.06-.02-.22-.07-.14.08.06.11.24.27.31.34.32.12.64.23.96.35-.5-.44-.95-.7-1.14-.77h0Z"
              />
              <path
                className="cls-107"
                d="M99.94,242.87c-.07-.02-.27-.08-.15.13.16.3.91.93,1.4,1.11-.42-.41-.83-.82-1.24-1.24h0Z"
              />
              <path
                className="cls-107"
                d="M97.91,242.13c-.06-.02-.23-.08-.15.09.2.4,1.54,1.39,1.59,1.17.05-.19-.98-1.08-1.44-1.25h0Z"
              />
              <path
                className="cls-107"
                d="M97.59,240.75c-.35-.12-.7-.25-1.04-.38.59.62,1.3,1.02,1.32.81,0-.13-.27-.43-.28-.44h0Z"
              />
            </g>
            <g className="cls-130">
              <path
                className="cls-107"
                d="M106.85,249.48c-.05-.02-.16-.05-.12.02.05.09.31.28.39.35.29.11.58.21.88.32-.54-.39-.98-.63-1.15-.68h0Z"
              />
              <path
                className="cls-107"
                d="M105.06,247.63c-.06-.02-.19-.06-.14.05.11.22.98.86,1.48,1.05-.45-.36-.89-.73-1.34-1.1h0Z"
              />
              <path
                className="cls-107"
                d="M103.2,246.96c-.05-.02-.16-.06-.13.02.09.25,1.56,1.25,1.64,1.11.07-.12-1.05-.96-1.51-1.13h0Z"
              />
              <path
                className="cls-107"
                d="M102.61,245.74c-.32-.12-.64-.23-.96-.35.62.55,1.32.92,1.29.74-.02-.11-.32-.39-.33-.39h0Z"
              />
            </g>
            <g className="cls-133">
              <path
                className="cls-107"
                d="M112.95,253.7c-.29-.17-.43-.27-.45-.32,0,0,0,0,0,0,.02,0,.03,0,.1.02.25.09.68.32,1.14.59-.27-.09-.53-.19-.79-.29h0Z"
              />
              <path
                className="cls-107"
                d="M111.96,252.77c-.5-.19-1.54-.84-1.54-.96.02-.02.04-.01.12.01.47.32.95.64,1.42.95h0Z"
              />
              <path
                className="cls-107"
                d="M108.07,250.21c.26.2.37.32.29.33-.11,0-.64-.27-1.24-.7.29.11.58.21.88.32.02.02.05.04.07.05h0Z"
              />
            </g>
            <g className="cls-135">
              <path
                className="cls-107"
                d="M117.86,256.19c-.44-.16-1.53-.7-1.6-.81.02,0,.02,0,.09.02.5.27,1,.54,1.5.8h0Z"
              />
              <path
                className="cls-107"
                d="M113.81,254.03c.35.21.37.25.38.27,0,0,0,0,0,0-.07.01-.63-.25-1.24-.6.26.1.52.19.79.29.02.01.05.03.07.04h0Z"
              />
            </g>
            <g className="cls-131">
              <path
                className="cls-107"
                d="M98.99,79.03c.42-.48.87-.74,1.13-.66.23.13.12.53-.27,1.03-.29-.12-.58-.25-.86-.37h0Z"
              />
              <path
                className="cls-107"
                d="M102.4,77.06c-.48-.27.56-1.5,1.22-1.66.12-.03.16-.01.22,0-.48.55-.96,1.1-1.44,1.66h0Z"
              />
            </g>
            <g className="cls-132">
              <path
                className="cls-107"
                d="M94.64,85.32c-.29-.09-.72.17-1.12.69.31.13.62.27.93.4.49-.72.34-1.03.19-1.1h0Z"
              />
              <path
                className="cls-107"
                d="M92.85,84.51c-.27-.09-.71.17-1.11.68.29.14.58.28.88.42.51-.71.37-1.03.23-1.1h0Z"
              />
              <path
                className="cls-107"
                d="M98.24,82.17c-.66-.19-1.69,1.23-1.45,1.67.03.05.07.08.11.1.44-.59.89-1.18,1.34-1.76h0Z"
              />
              <path
                className="cls-107"
                d="M96.46,81.41c-.63-.2-1.7,1.2-1.48,1.65.22.45,1.31-.38,1.56-1.18.08-.24.04-.41-.08-.47h0Z"
              />
              <path
                className="cls-107"
                d="M99.85,79.4c-.29-.12-.58-.25-.86-.37-.57.71-.45,1.09-.11,1.05.1-.01.47-.1.97-.68h0Z"
              />
            </g>
            <g className="cls-134">
              <path
                className="cls-107"
                d="M89.58,92.65c-.31-.1-.73.18-1.1.73.33.14.66.29,1,.43.45-.75.26-1.09.1-1.16h0Z"
              />
              <path
                className="cls-107"
                d="M87.65,91.78c-.29-.1-.71.17-1.08.71.31.15.63.3.95.45.46-.75.29-1.09.14-1.16h0Z"
              />
              <path
                className="cls-107"
                d="M93.03,89.34c-.34-.1-.76.26-1.05.62-.28.36-.47.87-.31,1.12.04.06.08.08.12.1.41-.62.82-1.24,1.23-1.85h0Z"
              />
              <path
                className="cls-107"
                d="M91.12,88.52c-.64-.21-1.64,1.28-1.38,1.73.25.45,1.24-.32,1.49-1.15.09-.29.05-.51-.11-.58h0Z"
              />
              <path
                className="cls-107"
                d="M89.31,87.67c-.44.6-.87,1.21-1.3,1.82.63.23,1.63-1.24,1.4-1.72-.03-.06-.07-.08-.1-.11h0Z"
              />
              <path
                className="cls-107"
                d="M94.46,86.41c-.31-.13-.63-.27-.93-.4-.53.76-.37,1.16-.02,1.12.1-.01.48-.1.95-.72h0Z"
              />
              <path
                className="cls-107"
                d="M92.62,85.6c-.3-.14-.59-.28-.88-.42-.5.69-.45,1.16-.07,1.12.1-.01.47-.09.95-.71h0Z"
              />
            </g>
            <g className="cls-136">
              <path
                className="cls-107"
                d="M84.09,96.38c-.2.3-.64.76-1,.63.39-.64.78-1.28,1.18-1.91.35.22.07.9-.18,1.28h0Z"
              />
              <path
                className="cls-107"
                d="M89.42,93.91c-.46.66-1.09.88-1.2.42-.04-.16-.03-.46.27-.94.33.14.66.29,1,.43-.02.03-.04.07-.06.1h0Z"
              />
              <path
                className="cls-107"
                d="M87.45,93.04c-.47.66-1.09.87-1.17.4-.03-.17,0-.46.29-.94.31.15.63.3.95.45-.02.03-.04.07-.06.09h0Z"
              />
            </g>
            <g className="cls-128">
              <path
                className="cls-107"
                d="M73.93,116.44c.26-.6.65-.91.97-.79.31.18.36.69.12,1.31-.37-.17-.74-.34-1.1-.52h0Z"
              />
            </g>
            <g className="cls-137">
              <path
                className="cls-107"
                d="M74.02,125.23c-.36-.12-.73.2-.95.83.39.17.79.35,1.2.52.23-.81-.02-1.24-.25-1.34h0Z"
              />
              <path
                className="cls-107"
                d="M71.69,124.18c-.34-.12-.7.2-.92.81.37.18.75.36,1.14.54.24-.8,0-1.25-.21-1.35h0Z"
              />
              <path
                className="cls-107"
                d="M74.36,120.41c-.67-.23-1.31,1.19-1.01,1.89.23.53.83.29,1.15-.45.26-.61.19-1.28-.14-1.43h0Z"
              />
              <path
                className="cls-107"
                d="M72.14,119.36c-.27.71-.54,1.42-.8,2.13.64.24,1.28-1.18,1.01-1.88-.06-.16-.16-.22-.21-.25h0Z"
              />
              <path
                className="cls-107"
                d="M75.03,116.96c-.37-.17-.74-.34-1.1-.52-.34.91-.05,1.51.43,1.32.18-.07.43-.27.67-.8h0Z"
              />
            </g>
            <g className="cls-129">
              <path
                className="cls-107"
                d="M71.43,134.01c-.37-.12-.71.2-.9.84.41.18.82.36,1.23.53.18-.82-.1-1.27-.34-1.38h0Z"
              />
              <path
                className="cls-107"
                d="M69.04,132.93c-.34-.13-.68.2-.87.83.38.19.77.37,1.17.55.19-.82-.08-1.28-.3-1.38h0Z"
              />
              <path
                className="cls-107"
                d="M73.88,130.12c-.73-.23-1.26,1.24-.88,1.95.09.17.2.22.26.26.2-.74.41-1.47.62-2.2h0Z"
              />
              <path
                className="cls-107"
                d="M71.46,129.07c-.69-.24-1.23,1.22-.88,1.93.26.55.85.3,1.12-.46.22-.63.11-1.32-.24-1.47h0Z"
              />
              <path
                className="cls-107"
                d="M69.16,127.99c-.22.73-.44,1.46-.65,2.19.66.25,1.2-1.21.88-1.93-.07-.17-.17-.23-.23-.26h0Z"
              />
              <path
                className="cls-107"
                d="M74.27,126.57c-.41-.17-.81-.34-1.2-.52-.31,1.07.18,1.57.65,1.31.35-.19.5-.64.55-.79h0Z"
              />
              <path
                className="cls-107"
                d="M71.91,125.53c-.38-.18-.76-.36-1.14-.54-.32,1.06.14,1.57.59,1.32.33-.19.5-.64.55-.78h0Z"
              />
            </g>
            <g className="cls-155">
              <path
                className="cls-107"
                d="M69.42,142.98c-.38-.13-.7.2-.83.86.41.18.83.36,1.26.54.13-.84-.18-1.3-.42-1.4h0Z"
              />
              <path
                className="cls-107"
                d="M66.97,141.88c-.35-.13-.66.2-.8.85.39.19.79.38,1.19.56.13-.84-.16-1.3-.39-1.41h0Z"
              />
              <path
                className="cls-107"
                d="M71.61,139.01c-.7-.22-1.15,1.15-.8,1.91.11.24.23.3.32.34.15-.75.31-1.5.48-2.25h0Z"
              />
              <path
                className="cls-107"
                d="M69.12,137.94c-.7-.25-1.14,1.25-.75,1.97.3.56.87.31,1.08-.47.18-.64.02-1.34-.33-1.5h0Z"
              />
              <path
                className="cls-107"
                d="M66.77,136.83c-.17.74-.34,1.49-.5,2.24.67.26,1.11-1.23.75-1.97-.09-.17-.18-.23-.24-.27h0Z"
              />
              <path
                className="cls-107"
                d="M71.77,135.39c-.42-.18-.83-.35-1.23-.53-.24,1.09.28,1.61.73,1.34.33-.2.46-.66.5-.81h0Z"
              />
              <path
                className="cls-107"
                d="M69.34,134.31c-.4-.18-.78-.37-1.17-.55-.23,1.01.2,1.64.67,1.35.32-.19.45-.65.5-.8h0Z"
              />
            </g>
            <g className="cls-148">
              <path
                className="cls-107"
                d="M68,152.1c-.38-.13-.67.21-.77.87.42.18.84.37,1.28.55.07-.85-.27-1.32-.51-1.42h0Z"
              />
              <path
                className="cls-107"
                d="M65.52,150.98c-.35-.13-.64.21-.73.86.4.19.8.38,1.21.57.07-.85-.24-1.32-.48-1.43h0Z"
              />
              <path
                className="cls-107"
                d="M69.92,148.06c-.71-.23-1.07,1.17-.67,1.95.12.24.25.3.34.35.1-.77.21-1.53.33-2.29h0Z"
              />
              <path
                className="cls-107"
                d="M67.39,146.97c-.67-.24-1.03,1.16-.66,1.94.28.58.79.49,1.03-.19.23-.68.05-1.56-.37-1.75h0Z"
              />
              <path
                className="cls-107"
                d="M64.99,145.84c-.12.76-.24,1.52-.35,2.29.63.25.99-1.14.64-1.93-.11-.24-.22-.31-.3-.36h0Z"
              />
              <path
                className="cls-107"
                d="M69.84,144.38c-.43-.18-.84-.36-1.26-.54-.15,1.01.34,1.66.81,1.36.21-.14.36-.41.45-.82h0Z"
              />
              <path
                className="cls-107"
                d="M67.36,143.29c-.4-.19-.8-.37-1.19-.56-.16,1.01.31,1.67.75,1.38.2-.13.35-.41.44-.81h0Z"
              />
            </g>
            <g className="cls-151">
              <path
                className="cls-107"
                d="M64.32,156.56c-.05.36-.24.92-.67.76.05-.77.12-1.55.19-2.32.46.28.54,1.1.48,1.56h0Z"
              />
              <path
                className="cls-107"
                d="M68.49,153.64c-.13.75-.63,1.03-.99.56-.13-.16-.33-.54-.27-1.23.42.18.84.37,1.28.55,0,.03-.01.08-.02.12h0Z"
              />
              <path
                className="cls-107"
                d="M65.98,152.53c-.13.75-.61,1.02-.95.55-.09-.13-.31-.52-.25-1.23.4.19.8.38,1.21.57,0,.03-.01.08-.02.12h0Z"
              />
            </g>
            <g className="cls-150">
              <path
                className="cls-107"
                d="M70.51,196.86c-.36-.13-.49.16-.35.75.41.18.82.36,1.24.53-.22-.76-.65-1.19-.88-1.29h0Z"
              />
              <path
                className="cls-107"
                d="M68.1,195.77c-.33-.13-.45.16-.31.75.38.19.78.37,1.17.55-.22-.76-.64-1.2-.86-1.3h0Z"
              />
              <path
                className="cls-107"
                d="M70.83,193.25c-.53-.18-.58.58-.23,1.31.13.27.35.62.68.78-.16-.69-.31-1.38-.45-2.08h0Z"
              />
              <path
                className="cls-107"
                d="M68.32,192.17c-.54-.2-.5.64-.19,1.3.35.74.89,1.06,1.04.62.18-.53-.34-1.69-.85-1.92h0Z"
              />
              <path
                className="cls-107"
                d="M65.95,191.05c.15.7.31,1.4.48,2.09.45.19.48-.5.2-1.19-.1-.25-.33-.7-.67-.9h0Z"
              />
            </g>
            <g className="cls-149">
              <path
                className="cls-107"
                d="M72.86,204.87c-.35-.12-.45.15-.26.71.4.17.8.35,1.2.52-.27-.72-.71-1.13-.94-1.23h0Z"
              />
              <path
                className="cls-107"
                d="M70.51,203.81c-.32-.13-.41.15-.22.71.37.18.75.36,1.14.54-.28-.73-.7-1.14-.92-1.25h0Z"
              />
              <path
                className="cls-107"
                d="M72.86,201.44c-.5-.17-.5.48-.16,1.14.12.24.38.66.76.84-.2-.66-.4-1.32-.6-1.99h0Z"
              />
              <path
                className="cls-107"
                d="M70.41,200.39c-.48-.18-.42.48-.17,1.04.35.78.96,1.24,1.11.85.18-.45-.42-1.65-.94-1.89h0Z"
              />
              <path
                className="cls-107"
                d="M71.4,198.15c-.42-.18-.83-.35-1.24-.53.3,1.02,1.04,1.62,1.24,1.18.1-.2.02-.51,0-.65h0Z"
              />
              <path
                className="cls-107"
                d="M68.96,197.07c-.4-.18-.79-.37-1.17-.55.29.98.95,1.59,1.17,1.25.12-.19.03-.57,0-.69h0Z"
              />
            </g>
            <g className="cls-156">
              <path
                className="cls-107"
                d="M75.77,212.48c-.33-.12-.4.13-.18.67.38.17.77.34,1.16.5-.32-.68-.76-1.07-.99-1.17h0Z"
              />
              <path
                className="cls-107"
                d="M73.49,211.45c-.38-.15-.29.29-.17.57.01.03.03.06.04.09.36.17.73.35,1.1.52-.33-.69-.76-1.09-.97-1.19h0Z"
              />
              <path
                className="cls-107"
                d="M75.45,209.24c-.47-.16-.39.41-.16.89.04.08.39.76.89,1-.25-.62-.49-1.25-.73-1.88h0Z"
              />
              <path
                className="cls-107"
                d="M73.07,208.21c-.45-.17-.34.39-.16.79.36.81,1.09,1.42,1.21,1.01.13-.43-.54-1.57-1.05-1.8h0Z"
              />
              <path
                className="cls-107"
                d="M70.82,207.15c.25.64.51,1.27.77,1.9.41.17.28-.37.16-.68-.13-.31-.48-.97-.93-1.22h0Z"
              />
              <path
                className="cls-107"
                d="M73.8,206.1c-.41-.17-.81-.34-1.2-.52.36.96,1.11,1.54,1.27,1.13.07-.19-.02-.48-.06-.61h0Z"
              />
              <path
                className="cls-107"
                d="M71.43,205.06c-.39-.18-.77-.36-1.14-.54.35.92,1.03,1.51,1.2,1.19.1-.18-.02-.53-.06-.65h0Z"
              />
            </g>
            <g className="cls-154">
              <path
                className="cls-107"
                d="M79.21,219.65c-.42-.16-.22.35-.17.45.02.05.06.12.08.17.37.16.74.32,1.12.48-.37-.64-.82-1.01-1.03-1.1h0Z"
              />
              <path
                className="cls-107"
                d="M78.59,216.61c-.42-.15-.32.31-.16.65.17.34.57.92,1.02,1.13-.29-.59-.58-1.18-.86-1.77h0Z"
              />
              <path
                className="cls-107"
                d="M76.29,215.62c-.39-.15-.28.28-.15.55.35.78,1.16,1.52,1.29,1.18.14-.35-.61-1.5-1.14-1.74h0Z"
              />
              <path
                className="cls-107"
                d="M76.75,213.65c-.39-.17-.78-.33-1.16-.5.43.91,1.17,1.46,1.28,1.08.06-.21-.11-.57-.11-.57h0Z"
              />
              <path
                className="cls-107"
                d="M74.46,212.63c-.37-.17-.74-.35-1.1-.52.42.87,1.09,1.43,1.22,1.14.08-.19-.12-.61-.12-.62h0Z"
              />
            </g>
            <g className="cls-153">
              <path
                className="cls-107"
                d="M83.22,225.19c-.71-.33-1.48-1.58-1.17-1.69.06-.02.12,0,.18.02.33.56.66,1.11.99,1.66h0Z"
              />
              <path
                className="cls-107"
                d="M80.28,220.84c.19.39.16.62-.08.55-.22-.06-.7-.45-1.08-1.12.37.16.74.32,1.12.48.01.03.03.06.04.09h0Z"
              />
            </g>
            <g className="cls-152">
              <path
                className="cls-107"
                d="M88.5,83.46c.42-.5.84-.75,1.08-.65.2.15.08.57-.32,1.09-.07-.04-.15-.08-.22-.12-.19-.11-.37-.21-.55-.32h0Z"
              />
              <polygon
                className="cls-107"
                points="90.29 80.66 90.28 80.66 90.29 80.66 90.29 80.66"
              />
              <polygon
                className="cls-107"
                points="90.31 80.67 90.29 80.66 90.31 80.67 90.31 80.67"
              />
              <path
                className="cls-107"
                d="M90.32,80.68s0,0-.01,0c0,0,0,0,.01,0h0Z"
              />
              <path
                className="cls-107"
                d="M90.33,80.68s0,0-.01,0c0,0,0,0,.01,0h0Z"
              />
              <path
                className="cls-107"
                d="M90.35,80.68s-.01,0-.01,0c0,0,.01,0,.01,0h0Z"
              />
              <path
                className="cls-107"
                d="M90.36,80.68s-.01,0-.02,0c0,0,.01,0,.02,0h0Z"
              />
              <path
                className="cls-107"
                d="M90.38,80.69s-.01,0-.02,0c0,0,.01,0,.02,0h0Z"
              />
              <path
                className="cls-107"
                d="M90.4,80.69s-.01,0-.02,0c0,0,.01,0,.02,0h0Z"
              />
              <path
                className="cls-107"
                d="M90.41,80.68s-.01,0-.02,0c0,0,.01,0,.02,0h0Z"
              />
              <path
                className="cls-107"
                d="M90.43,80.68s-.01,0-.02,0c0,0,.01,0,.02,0h0Z"
              />
              <path
                className="cls-107"
                d="M90.45,80.68s-.01,0-.02,0c0,0,.01,0,.02,0h0Z"
              />
              <path
                className="cls-107"
                d="M90.47,80.68s-.01,0-.02,0c0,0,.01,0,.02,0h0Z"
              />
              <path
                className="cls-107"
                d="M90.49,80.67s-.01,0-.02,0c0,0,.01,0,.02,0h0Z"
              />
              <path
                className="cls-107"
                d="M90.5,80.67s-.01,0-.02,0c0,0,.01,0,.02,0h0Z"
              />
              <path
                className="cls-107"
                d="M90.52,80.66s-.01,0-.02,0c0,0,.01,0,.02,0h0Z"
              />
              <path
                className="cls-107"
                d="M90.54,80.66s-.01,0-.02,0c0,0,.01,0,.02,0h0Z"
              />
              <path
                className="cls-107"
                d="M90.57,80.65s-.01,0-.02,0c0,0,.01,0,.02,0h0Z"
              />
              <path
                className="cls-107"
                d="M90.59,80.64s-.01,0-.02,0c0,0,.01,0,.02,0h0Z"
              />
              <path
                className="cls-107"
                d="M90.61,80.63s-.01,0-.02,0c0,0,.01,0,.02,0h0Z"
              />
              <path
                className="cls-107"
                d="M90.63,80.62s-.02,0-.02,0c0,0,.02,0,.02,0h0Z"
              />
              <path
                className="cls-107"
                d="M90.65,80.61s-.02,0-.02.01c0,0,.02,0,.02-.01h0Z"
              />
              <path
                className="cls-107"
                d="M90.67,80.6s-.02,0-.02.01c0,0,.02,0,.02-.01h0Z"
              />
              <path
                className="cls-107"
                d="M90.7,80.59s-.02,0-.02.01c0,0,.02,0,.02-.01h0Z"
              />
              <path
                className="cls-107"
                d="M90.72,80.58s-.02,0-.02.01c0,0,.02,0,.02-.01h0Z"
              />
              <path
                className="cls-107"
                d="M90.74,80.56s-.02,0-.02.01c0,0,.02,0,.02-.01h0Z"
              />
              <path
                className="cls-107"
                d="M90.77,80.55s-.02,0-.02.01c0,0,.02,0,.02-.01h0Z"
              />
              <path
                className="cls-107"
                d="M90.79,80.53s-.02.01-.02.01c0,0,.02-.01.02-.01h0Z"
              />
              <path
                className="cls-107"
                d="M90.81,80.52s-.02.01-.02.02c0,0,.02-.01.02-.02h0Z"
              />
              <path
                className="cls-107"
                d="M90.84,80.5s-.02.01-.02.02c0,0,.02-.01.02-.02h0Z"
              />
              <path
                className="cls-107"
                d="M90.86,80.49s-.02.01-.02.02c0,0,.02-.01.02-.02h0Z"
              />
              <path
                className="cls-107"
                d="M90.89,80.47s-.02.01-.02.02c.01-.01.03-.02.05-.04,0,0-.02.01-.02.02h0Z"
              />
            </g>
            <g className="cls-157">
              <path
                className="cls-107"
                d="M85.84,90.89c-.28-.11-.69.16-1.07.7.29.15.58.31.88.46.47-.74.33-1.08.19-1.16h0Z"
              />
              <path
                className="cls-107"
                d="M84.15,89.97c-.26-.11-.66.15-1.05.68.19.11.39.23.59.34.08.04.16.09.23.13.49-.74.36-1.08.23-1.16h0Z"
              />
              <path
                className="cls-107"
                d="M89.31,87.67c-.64-.23-1.63,1.24-1.4,1.72.03.06.07.08.1.11.43-.61.86-1.22,1.3-1.82h0Z"
              />
              <path
                className="cls-107"
                d="M87.62,86.79c-.57-.23-1.62,1.24-1.42,1.7.18.43,1.09-.23,1.44-1.03.14-.33.14-.59-.01-.67h0Z"
              />
              <path
                className="cls-107"
                d="M86.04,85.88c-.46.59-.91,1.19-1.36,1.79.55.25,1.6-1.2,1.44-1.68-.02-.06-.05-.08-.08-.11h0Z"
              />
              <path
                className="cls-107"
                d="M89.27,83.9c-.07-.04-.15-.08-.22-.12-.19-.11-.37-.21-.55-.32-.53.68-.52,1.16-.17,1.13.09,0,.44-.08.94-.68h0Z"
              />
            </g>
            <g className="cls-411">
              <path
                className="cls-107"
                d="M79.2,97.5c-.27-.12-.66.15-1.02.71.2.12.41.24.62.36.08.05.17.09.25.14.44-.77.29-1.13.14-1.21h0Z"
              />
              <path
                className="cls-107"
                d="M84.28,95.1c-.32-.12-.73.25-1,.62-.26.37-.45.91-.3,1.18.03.06.08.09.11.11.39-.64.78-1.28,1.18-1.91h0Z"
              />
              <path
                className="cls-107"
                d="M82.47,94.16c-.6-.25-1.55,1.3-1.32,1.78.22.45,1.1-.23,1.38-1.08.12-.35.09-.62-.07-.7h0Z"
              />
              <path
                className="cls-107"
                d="M80.79,93.2c-.42.62-.83,1.25-1.23,1.88.58.26,1.53-1.26,1.33-1.77-.02-.06-.06-.09-.09-.11h0Z"
              />
              <path
                className="cls-107"
                d="M85.66,92.05c-.3-.15-.59-.3-.88-.46-.49.75-.39,1.28.04,1.18.12-.03.45-.16.85-.72h0Z"
              />
              <path
                className="cls-107"
                d="M83.92,91.12c-.08-.04-.16-.09-.23-.13-.2-.11-.4-.23-.59-.34-.5.75-.43,1.28-.02,1.18.12-.03.44-.15.84-.71h0Z"
              />
            </g>
            <g className="cls-410">
              <path
                className="cls-107"
                d="M73.77,106.1c.32-.59.69-.87.98-.75.25.18.23.67-.06,1.28-.09-.05-.17-.1-.26-.15-.22-.13-.44-.25-.66-.38h0Z"
              />
              <path
                className="cls-107"
                d="M75.85,102.21c-.19.3-.59.78-.92.63.36-.66.73-1.32,1.11-1.97.3.23.07.92-.19,1.34h0Z"
              />
              <path
                className="cls-107"
                d="M78.99,98.81c-.44.67-1.02.87-1.09.38-.03-.18,0-.49.28-.98.2.12.41.24.62.36.08.05.17.09.25.14-.02.03-.04.07-.06.1h0Z"
              />
            </g>
            <g className="cls-394">
              <path
                className="cls-107"
                d="M72.8,114.61c-.31-.12-.68.18-.95.78.34.18.68.36,1.03.53.3-.78.12-1.21-.08-1.31h0Z"
              />
              <path
                className="cls-107"
                d="M70.83,113.53c-.29-.13-.65.16-.93.76.22.13.45.26.68.4.09.05.18.1.27.15.31-.77.15-1.21-.03-1.31h0Z"
              />
              <path
                className="cls-107"
                d="M73.67,109.94c-.63-.26-1.36,1.24-1.11,1.87.2.49.84.11,1.16-.69.21-.53.19-1.05-.06-1.18h0Z"
              />
              <path
                className="cls-107"
                d="M71.81,108.87c-.33.68-.65,1.36-.97,2.05.58.27,1.33-1.22,1.11-1.86-.04-.11-.08-.15-.14-.19h0Z"
              />
              <path
                className="cls-107"
                d="M74.69,106.63c-.09-.05-.17-.1-.26-.15-.22-.13-.44-.25-.66-.38-.42.87-.23,1.45.23,1.28.17-.06.42-.25.69-.75h0Z"
              />
            </g>
            <g className="cls-393">
              <path
                className="cls-107"
                d="M69.51,123.1c-.32-.13-.67.19-.9.8.35.19.7.37,1.06.55.25-.8.04-1.25-.16-1.35h0Z"
              />
              <path
                className="cls-107"
                d="M67.47,121.98c-.3-.14-.64.17-.87.79.23.14.47.27.71.41.09.05.19.11.28.16.25-.8.07-1.25-.12-1.36h0Z"
              />
              <path
                className="cls-107"
                d="M72.14,119.36c-.69-.26-1.31,1.3-.97,1.94.06.11.12.15.18.19.26-.71.52-1.42.8-2.13h0Z"
              />
              <path
                className="cls-107"
                d="M70.06,118.28c-.65-.28-1.28,1.27-.98,1.93.22.48.79.17,1.08-.6.22-.58.18-1.18-.1-1.33h0Z"
              />
              <path
                className="cls-107"
                d="M68.13,117.17c-.28.7-.56,1.41-.83,2.11.58.27,1.24-1.28.98-1.92-.05-.11-.09-.15-.15-.19h0Z"
              />
              <path
                className="cls-107"
                d="M72.88,115.92c-.35-.18-.69-.35-1.03-.53-.35.9-.09,1.51.37,1.33.17-.07.42-.26.66-.79h0Z"
              />
              <path
                className="cls-107"
                d="M70.86,114.85c-.09-.05-.18-.1-.27-.15-.23-.13-.46-.26-.68-.4-.39.97-.09,1.5.31,1.33.16-.07.41-.26.65-.78h0Z"
              />
            </g>
            <g className="cls-388">
              <path
                className="cls-107"
                d="M66.79,131.82c-.32-.13-.65.19-.84.82.36.19.72.38,1.09.57.19-.82-.05-1.28-.25-1.39h0Z"
              />
              <path
                className="cls-107"
                d="M64.69,130.67c-.31-.14-.62.17-.81.81.24.14.48.28.73.42.1.05.19.11.29.16.2-.82-.02-1.28-.21-1.39h0Z"
              />
              <path
                className="cls-107"
                d="M69.16,127.99c-.65-.25-1.19,1.21-.88,1.92.07.17.17.23.23.26.21-.73.43-1.46.65-2.19h0Z"
              />
              <path
                className="cls-107"
                d="M67.02,126.87c-.61-.26-1.16,1.19-.88,1.91.2.52.7.35.99-.33.27-.64.22-1.41-.11-1.59h0Z"
              />
              <path
                className="cls-107"
                d="M65.02,125.73c-.23.72-.46,1.45-.68,2.17.57.27,1.12-1.18.87-1.91-.06-.17-.14-.23-.19-.27h0Z"
              />
              <path
                className="cls-107"
                d="M69.67,124.45c-.36-.18-.71-.37-1.06-.55-.32,1.03.09,1.58.52,1.33.32-.19.48-.63.54-.78h0Z"
              />
              <path
                className="cls-107"
                d="M67.59,123.34c-.09-.05-.19-.11-.28-.16-.24-.14-.48-.27-.71-.41-.33,1.02.05,1.58.46,1.34.2-.12.38-.38.53-.77h0Z"
              />
            </g>
            <g className="cls-395">
              <path
                className="cls-107"
                d="M64.68,140.74c-.33-.13-.63.19-.77.84.36.19.74.39,1.11.58.14-.84-.13-1.31-.34-1.41h0Z"
              />
              <path
                className="cls-107"
                d="M62.53,139.57c-.31-.14-.6.17-.74.82.24.14.49.29.74.43.1.06.2.11.3.17.14-.84-.1-1.31-.3-1.42h0Z"
              />
              <path
                className="cls-107"
                d="M66.77,136.83c-.66-.26-1.1,1.23-.74,1.97.09.18.18.24.24.27.16-.75.33-1.49.5-2.24h0Z"
              />
              <path
                className="cls-107"
                d="M64.57,135.69c-.62-.27-1.06,1.22-.74,1.96.22.49.66.38.91-.23.27-.66.18-1.53-.18-1.72h0Z"
              />
              <path
                className="cls-107"
                d="M62.53,134.51c-.18.74-.36,1.48-.53,2.23.58.28,1.02-1.21.73-1.95-.07-.18-.15-.24-.2-.27h0Z"
              />
              <path
                className="cls-107"
                d="M67.04,133.2c-.37-.19-.73-.38-1.09-.57-.24,1.01.15,1.64.61,1.36.31-.19.44-.65.48-.8h0Z"
              />
              <path
                className="cls-107"
                d="M64.9,132.06c-.1-.05-.19-.11-.29-.16-.25-.14-.49-.28-.73-.42-.25,1.01.11,1.65.55,1.37.19-.12.35-.39.47-.79h0Z"
              />
            </g>
            <g className="cls-390">
              <path
                className="cls-107"
                d="M63.19,149.83c-.34-.14-.6.19-.7.85.37.2.75.39,1.13.59.08-.85-.21-1.33-.43-1.44h0Z"
              />
              <path
                className="cls-107"
                d="M61.01,148.64c-.31-.14-.57.18-.67.84.25.15.5.29.75.44.1.06.2.11.3.17.08-.85-.19-1.33-.39-1.44h0Z"
              />
              <path
                className="cls-107"
                d="M64.99,145.84c-.63-.25-.99,1.15-.64,1.93.11.24.22.31.29.36.11-.76.23-1.53.35-2.29h0Z"
              />
              <path
                className="cls-107"
                d="M62.75,144.68c-.59-.26-.94,1.13-.63,1.92.22.56.64.53.88-.06.27-.66.13-1.65-.25-1.86h0Z"
              />
              <path
                className="cls-107"
                d="M60.67,143.48c-.13.76-.25,1.52-.36,2.28.55.26.89-1.12.61-1.91-.09-.24-.18-.32-.25-.36h0Z"
              />
              <path
                className="cls-107"
                d="M65.02,142.16c-.38-.19-.75-.38-1.11-.58-.17,1.01.26,1.67.69,1.39.19-.13.34-.4.42-.81h0Z"
              />
              <path
                className="cls-107"
                d="M62.83,140.99c-.1-.06-.2-.11-.3-.17-.25-.14-.5-.29-.74-.43-.17,1.01.22,1.68.63,1.4.18-.13.32-.4.41-.8h0Z"
              />
            </g>
            <g className="cls-389">
              <path
                className="cls-107"
                d="M62.36,159.05c-.34-.14-.57.19-.62.86.37.2.75.4,1.14.59.02-.86-.3-1.34-.52-1.45h0Z"
              />
              <path
                className="cls-107"
                d="M60.15,157.84c-.09-.04-.16-.04-.24,0,.09-.02.16-.02.24,0h0Z"
              />
              <path
                className="cls-107"
                d="M63.84,155c-.61-.24-.88,1.04-.54,1.87.13.32.28.41.35.45.05-.77.12-1.55.19-2.32h0Z"
              />
              <path
                className="cls-107"
                d="M61.58,153.83c-.57-.25-.83,1.02-.52,1.86.21.57.6.66.82.19.31-.64.14-1.81-.31-2.05h0Z"
              />
              <path
                className="cls-107"
                d="M59.47,152.62c-.07.77-.14,1.54-.19,2.31.52.25.78-1.02.49-1.86-.11-.32-.24-.41-.3-.46h0Z"
              />
              <path
                className="cls-107"
                d="M63.62,151.27c-.38-.19-.76-.39-1.13-.59-.09,1.02.37,1.7.77,1.41.18-.13.3-.41.36-.82h0Z"
              />
              <path
                className="cls-107"
                d="M61.4,150.09c-.1-.06-.2-.11-.3-.17-.26-.14-.51-.29-.75-.44-.1,1.02.33,1.71.71,1.42.17-.13.29-.4.35-.82h0Z"
              />
            </g>
            <g className="cls-392">
              <path
                className="cls-107"
                d="M62.87,160.62c-.07.71-.45,1-.78.61-.09-.1-.37-.5-.35-1.32.37.2.75.4,1.14.59,0,.03,0,.08,0,.12h0Z"
              />
            </g>
            <g className="cls-391">
              <path
                className="cls-107"
                d="M61.5,185.82c-.11-.63.01-.93.31-.78.31.2.59.75.73,1.38-.1-.06-.2-.11-.3-.17-.25-.14-.5-.29-.74-.43h0Z"
              />
              <path
                className="cls-107"
                d="M62.9,182.78c.06.62-.17.9-.51.6-.58-.52-.85-2.1-.37-2.14.06,0,.11.02.16.04.42.27.67,1.04.72,1.5h0Z"
              />
              <path
                className="cls-107"
                d="M60.77,181.59c.04.34,0,.86-.35.68-.12-.73-.23-1.46-.33-2.19.39.27.63,1.04.68,1.51h0Z"
              />
            </g>
            <g className="cls-407">
              <path
                className="cls-107"
                d="M65.95,191.05c-.45-.18-.48.5-.19,1.19.1.25.33.7.67.9-.17-.69-.32-1.39-.48-2.09h0Z"
              />
              <path
                className="cls-107"
                d="M63.74,189.9c-.43-.2-.4.5-.19,1.08.3.82.83,1.32.99.91.18-.47-.32-1.74-.79-2h0Z"
              />
              <path
                className="cls-107"
                d="M61.68,188.72c.16.71.33,1.41.5,2.1.38.19.35-.44.18-.97-.04-.14-.28-.86-.68-1.13h0Z"
              />
              <path
                className="cls-107"
                d="M62.54,186.42c-.1-.06-.2-.11-.3-.17-.25-.14-.5-.29-.74-.43.22,1.02.8,1.67,1.01,1.31.12-.2.05-.59.03-.72h0Z"
              />
            </g>
            <g className="cls-406">
              <path
                className="cls-107"
                d="M68.12,203.42c-.19-.56-.12-.83.18-.7.32.19.67.68.89,1.26-.36-.18-.72-.37-1.06-.55h0Z"
              />
            </g>
            <g className="cls-409">
              <path
                className="cls-107"
                d="M71.6,209.05c-.69-.39-1.3-1.81-.95-1.93.06-.02.12,0,.18.03.25.64.51,1.27.77,1.9h0Z"
              />
              <path
                className="cls-107"
                d="M69.66,207.39c.16.43.12.68-.1.6-.53-.2-1.37-1.83-1.01-1.97.05-.02.11,0,.17.03.4.25.79.93.94,1.33h0Z"
              />
              <path
                className="cls-107"
                d="M69.22,204.07c.15.48.06.74-.21.6-.2-.1-.61-.52-.89-1.25.35.19.7.37,1.06.55.01.03.02.07.03.1h0Z"
              />
            </g>
            <g className="cls-408">
              <path
                className="cls-107"
                d="M88.14,81.94c-.22-.1-.64.15-1.06.64.23.15.46.3.69.44.55-.69.48-1.01.37-1.09h0Z"
              />
              <path
                className="cls-107"
                d="M86.83,81.05c-.2-.11-.6.14-1.04.63.2.15.41.3.62.45.56-.69.51-1.01.41-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M90.52,79.78c-.31.43-.4.75-.24.88-.16-.12-.07-.44.24-.88h0Z"
              />
              <path
                className="cls-107"
                d="M89.25,77.26c-.51.55-1.02,1.1-1.53,1.66.47.25,1.69-1.26,1.57-1.6,0-.02-.03-.04-.04-.06h0Z"
              />
            </g>
            <g className="cls-416">
              <path
                className="cls-107"
                d="M82.6,89.03c-.24-.11-.63.15-1.02.67.24.16.49.32.74.48.5-.73.4-1.07.28-1.15h0Z"
              />
              <path
                className="cls-107"
                d="M81.2,88.08c-.21-.11-.6.14-1,.66.22.16.44.32.67.48.51-.73.44-1.07.33-1.14h0Z"
              />
              <path
                className="cls-107"
                d="M86.04,85.88c-.53-.23-1.6,1.22-1.44,1.68.02.06.05.09.08.11.45-.6.9-1.2,1.36-1.79h0Z"
              />
              <path
                className="cls-107"
                d="M84.62,84.97c-.48-.24-1.58,1.2-1.45,1.67.1.39.84-.08,1.29-.82.24-.4.31-.74.16-.84h0Z"
              />
              <path
                className="cls-107"
                d="M83.33,84.05c-.47.58-.94,1.17-1.4,1.76.49.28,1.6-1.32,1.45-1.69,0-.02-.03-.05-.05-.06h0Z"
              />
              <path
                className="cls-107"
                d="M87.77,83.02c-.24-.15-.47-.3-.69-.44-.54.67-.57,1.15-.23,1.12.09,0,.42-.08.92-.67h0Z"
              />
              <path
                className="cls-107"
                d="M86.42,82.13c-.21-.15-.42-.3-.62-.45-.55.67-.6,1.14-.29,1.11.08,0,.4-.07.91-.67h0Z"
              />
            </g>
            <g className="cls-415">
              <path
                className="cls-107"
                d="M77.55,96.5c-.25-.12-.62.15-.98.71.26.17.52.34.79.5.42-.71.35-1.11.2-1.21h0Z"
              />
              <path
                className="cls-107"
                d="M76.06,95.49c-.22-.12-.59.15-.95.7.23.17.46.34.71.51.43-.71.38-1.11.25-1.2h0Z"
              />
              <path
                className="cls-107"
                d="M80.79,93.2c-.55-.25-1.52,1.28-1.33,1.77.02.06.06.09.09.11.41-.63.82-1.26,1.23-1.88h0Z"
              />
              <path
                className="cls-107"
                d="M79.27,92.22c-.51-.26-1.5,1.26-1.34,1.75.14.42.85-.08,1.24-.86.21-.42.25-.78.1-.89h0Z"
              />
              <path
                className="cls-107"
                d="M77.91,91.24c-.43.61-.86,1.23-1.28,1.86.48.27,1.47-1.23,1.35-1.74-.02-.06-.04-.09-.07-.12h0Z"
              />
              <path
                className="cls-107"
                d="M82.32,90.18c-.25-.16-.5-.32-.74-.48-.51.74-.47,1.27-.09,1.18.11-.03.42-.15.83-.7h0Z"
              />
              <path
                className="cls-107"
                d="M80.87,89.22c-.23-.16-.45-.32-.67-.48-.54.76-.52,1.26-.15,1.17.11-.02.4-.14.82-.69h0Z"
              />
            </g>
            <g className="cls-417">
              <path
                className="cls-107"
                d="M73.01,104.3c-.25-.12-.62.17-.94.74.27.18.54.35.83.53.37-.75.27-1.17.11-1.27h0Z"
              />
              <path
                className="cls-107"
                d="M71.45,103.24c-.23-.13-.58.15-.91.73.24.18.49.36.74.53.38-.75.31-1.17.17-1.27h0Z"
              />
              <path
                className="cls-107"
                d="M76.04,100.87c-.6-.27-1.45,1.32-1.21,1.85.03.07.07.1.1.12.36-.66.73-1.32,1.11-1.97h0Z"
              />
              <path
                className="cls-107"
                d="M74.43,99.84c-.55-.28-1.42,1.3-1.22,1.83.15.41.78-.03,1.14-.8.22-.48.25-.91.07-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M72.99,98.8c-.39.64-.77,1.29-1.15,1.94.5.29,1.38-1.29,1.22-1.82-.02-.07-.05-.1-.08-.12h0Z"
              />
              <path
                className="cls-107"
                d="M77.35,97.7c-.27-.17-.53-.34-.79-.5-.46.78-.38,1.33,0,1.24.11-.03.41-.15.79-.73h0Z"
              />
              <path
                className="cls-107"
                d="M75.82,96.69c-.24-.17-.48-.34-.71-.51-.48.79-.43,1.32-.06,1.23.11-.03.39-.15.77-.73h0Z"
              />
            </g>
            <g className="cls-414">
              <path
                className="cls-107"
                d="M69.02,112.43c-.26-.13-.61.17-.89.76.28.18.57.37.86.55.32-.77.19-1.21.02-1.31h0Z"
              />
              <path
                className="cls-107"
                d="M67.39,111.33c-.24-.13-.57.16-.85.75.25.19.51.37.77.56.32-.77.22-1.2.07-1.31h0Z"
              />
              <path
                className="cls-107"
                d="M71.81,108.87c-.58-.27-1.32,1.23-1.11,1.86.04.11.09.15.13.19.32-.68.64-1.37.97-2.05h0Z"
              />
              <path
                className="cls-107"
                d="M70.12,107.8c-.53-.27-1.28,1.21-1.11,1.85.12.44.61.21.96-.46.31-.58.38-1.23.14-1.39h0Z"
              />
              <path
                className="cls-107"
                d="M68.61,106.71c-.34.67-.68,1.35-1.01,2.02.48.28,1.24-1.2,1.11-1.84-.02-.11-.06-.15-.1-.19h0Z"
              />
              <path
                className="cls-107"
                d="M72.9,105.58c-.28-.18-.56-.35-.83-.53-.43.86-.28,1.44.15,1.27.13-.05.39-.22.68-.74h0Z"
              />
              <path
                className="cls-107"
                d="M71.29,104.51c-.25-.18-.5-.36-.74-.53-.42.83-.33,1.38.02,1.29.1-.03.38-.15.72-.76h0Z"
              />
            </g>
            <g className="cls-413">
              <path
                className="cls-107"
                d="M65.59,120.84c-.27-.13-.59.17-.83.78.29.19.59.38.89.57.26-.8.1-1.25-.07-1.35h0Z"
              />
              <path
                className="cls-107"
                d="M63.9,119.7c-.25-.14-.55.16-.79.78.26.19.53.38.8.58.27-.79.14-1.24-.01-1.35h0Z"
              />
              <path
                className="cls-107"
                d="M68.13,117.17c-.59-.28-1.24,1.26-.98,1.92.05.12.1.15.15.19.27-.71.55-1.41.83-2.11h0Z"
              />
              <path
                className="cls-107"
                d="M66.38,116.05c-.54-.28-1.19,1.25-.98,1.91.14.42.57.24.88-.37.31-.61.36-1.36.1-1.54h0Z"
              />
              <path
                className="cls-107"
                d="M64.8,114.92c-.29.7-.58,1.39-.86,2.09.48.28,1.15-1.26.97-1.9-.03-.11-.07-.15-.11-.19h0Z"
              />
              <path
                className="cls-107"
                d="M68.99,113.75c-.3-.18-.58-.37-.86-.55-.37.89-.18,1.51.23,1.33.15-.07.39-.25.63-.78h0Z"
              />
              <path
                className="cls-107"
                d="M67.31,112.64c-.27-.19-.52-.37-.77-.56-.41.95-.19,1.49.16,1.33.14-.06.37-.25.61-.77h0Z"
              />
            </g>
            <g className="cls-412">
              <path
                className="cls-107"
                d="M62.76,129.5c-.27-.14-.57.18-.76.8.3.2.6.39.92.59.21-.82.02-1.28-.16-1.39h0Z"
              />
              <path
                className="cls-107"
                d="M61.02,128.33c-.25-.14-.53.16-.72.8.27.2.54.4.82.59.21-.81.05-1.28-.1-1.39h0Z"
              />
              <path
                className="cls-107"
                d="M65.02,125.73c-.56-.27-1.11,1.18-.87,1.9.06.17.14.23.19.27.22-.73.45-1.45.68-2.17h0Z"
              />
              <path
                className="cls-107"
                d="M63.22,124.57c-.51-.27-1.06,1.17-.86,1.89.13.46.49.4.77-.12.35-.63.39-1.56.08-1.77h0Z"
              />
              <path
                className="cls-107"
                d="M61.59,123.4c-.24.72-.48,1.44-.7,2.16.47.28,1.01-1.16.85-1.89-.04-.17-.1-.23-.14-.27h0Z"
              />
              <path
                className="cls-107"
                d="M65.66,122.2c-.31-.19-.6-.38-.89-.57-.33.98-.04,1.53.32,1.37.15-.07.37-.26.57-.79h0Z"
              />
              <path
                className="cls-107"
                d="M63.91,121.05c-.27-.19-.54-.38-.8-.58-.33.97-.09,1.52.25,1.37.14-.06.34-.25.55-.79h0Z"
              />
            </g>
            <g className="cls-396">
              <path
                className="cls-107"
                d="M60.56,138.38c-.28-.14-.55.18-.69.82.3.2.62.4.94.6.15-.84-.07-1.31-.24-1.42h0Z"
              />
              <path
                className="cls-107"
                d="M58.78,137.17c-.25-.14-.5.17-.65.82.27.2.55.4.84.6.15-.83-.03-1.31-.19-1.42h0Z"
              />
              <path
                className="cls-107"
                d="M62.53,134.51c-.57-.27-1.01,1.21-.73,1.95.07.18.15.24.2.28.17-.74.34-1.49.53-2.23h0Z"
              />
              <path
                className="cls-107"
                d="M60.68,133.33c-.52-.28-.96,1.2-.71,1.94.14.44.46.42.71-.04.34-.63.34-1.67,0-1.9h0Z"
              />
              <path
                className="cls-107"
                d="M59.01,132.13c-.19.74-.37,1.47-.54,2.21.47.28.91-1.19.7-1.94-.05-.18-.12-.24-.16-.28h0Z"
              />
              <path
                className="cls-107"
                d="M62.92,130.89c-.31-.2-.62-.39-.92-.59-.26,1,.05,1.64.46,1.37.18-.12.34-.39.46-.78h0Z"
              />
              <path
                className="cls-107"
                d="M61.13,129.72c-.28-.2-.56-.39-.82-.59-.27,1.03.02,1.56.33,1.4.13-.07.32-.26.49-.81h0Z"
              />
            </g>
            <g className="cls-401">
              <path
                className="cls-107"
                d="M59.01,147.43c-.28-.14-.52.18-.61.84.31.2.63.41.95.61.08-.85-.15-1.33-.34-1.45h0Z"
              />
              <path
                className="cls-107"
                d="M57.21,146.21c-.25-.15-.47.17-.57.83.28.2.56.41.85.61.09-.85-.12-1.33-.28-1.45h0Z"
              />
              <path
                className="cls-107"
                d="M60.67,143.48c-.55-.26-.89,1.12-.61,1.92.09.25.18.32.25.36.11-.76.24-1.52.36-2.28h0Z"
              />
              <path
                className="cls-107"
                d="M58.78,142.27c-.49-.27-.83,1.11-.59,1.91.15.49.45.54.67.12.32-.61.27-1.78-.08-2.02h0Z"
              />
              <path
                className="cls-107"
                d="M57.09,141.05c-.13.75-.26,1.51-.38,2.27.45.27.78-1.11.57-1.9-.06-.25-.14-.32-.19-.37h0Z"
              />
              <path
                className="cls-107"
                d="M60.8,139.8c-.32-.2-.63-.4-.94-.6-.18,1,.17,1.68.54,1.4.17-.13.3-.39.39-.8h0Z"
              />
              <path
                className="cls-107"
                d="M58.98,138.59c-.29-.2-.57-.4-.84-.61-.19,1.03.11,1.68.47,1.4.16-.12.28-.39.38-.8h0Z"
              />
            </g>
            <g className="cls-398">
              <path
                className="cls-107"
                d="M58.15,156.63c-.28-.15-.49.18-.53.85.31.2.63.41.96.61.02-.86-.24-1.35-.43-1.46h0Z"
              />
              <path
                className="cls-107"
                d="M56.33,155.4c-.25-.15-.44.18-.48.85.28.21.56.41.86.62.02-.86-.21-1.35-.38-1.47h0Z"
              />
              <path
                className="cls-107"
                d="M59.47,152.62c-.52-.25-.77,1.02-.49,1.85.11.32.24.41.3.46.06-.77.12-1.54.19-2.31h0Z"
              />
              <path
                className="cls-107"
                d="M57.57,151.4c-.47-.26-.71,1.01-.46,1.85.16.54.45.66.65.28.31-.59.2-1.87-.19-2.13h0Z"
              />
              <path
                className="cls-107"
                d="M55.85,150.16c-.07.77-.14,1.54-.2,2.31.43.26.66-1,.44-1.85-.08-.32-.19-.42-.24-.46h0Z"
              />
              <path
                className="cls-107"
                d="M59.35,148.87c-.32-.2-.64-.41-.95-.61-.1,1.02.28,1.7.62,1.42.16-.13.27-.4.33-.81h0Z"
              />
              <path
                className="cls-107"
                d="M57.5,147.66c-.29-.2-.58-.41-.85-.61-.11,1.04.22,1.71.55,1.42.14-.13.25-.4.31-.81h0Z"
              />
            </g>
            <g className="cls-405">
              <path
                className="cls-107"
                d="M58.57,158.21c-.06.66-.35.96-.62.65-.04-.04-.35-.44-.33-1.38.31.2.63.41.96.61,0,.03,0,.08,0,.12h0Z"
              />
              <path
                className="cls-107"
                d="M56.7,156.98c-.06.66-.32.96-.56.65-.03-.04-.32-.44-.29-1.38.28.21.56.41.86.62,0,.03,0,.08,0,.12h0Z"
              />
            </g>
            <g className="cls-402">
              <path
                className="cls-107"
                d="M56.46,174.62c-.06-.65.05-.96.3-.81.25.21.47.77.56,1.42-.29-.2-.58-.41-.85-.61h0Z"
              />
            </g>
            <g className="cls-403">
              <path
                className="cls-107"
                d="M59.83,183.83c-.27-.14-.37.16-.26.79.3.2.62.4.94.6-.17-.81-.5-1.27-.68-1.39h0Z"
              />
              <path
                className="cls-107"
                d="M60.09,180.08c-.41-.21-.46.59-.19,1.35.1.28.27.66.52.84-.12-.73-.23-1.46-.33-2.19h0Z"
              />
              <path
                className="cls-107"
                d="M58.19,178.87c-.36-.2-.39.51-.18,1.24.22.75.6,1.2.76.89.23-.43-.16-1.85-.59-2.13h0Z"
              />
              <path
                className="cls-107"
                d="M56.49,177.64c.11.74.22,1.47.35,2.2.31.2.31-.46.19-1.01-.02-.09-.2-.89-.53-1.18h0Z"
              />
              <path
                className="cls-107"
                d="M57.32,175.24c-.29-.2-.58-.41-.85-.61.13,1.02.56,1.67.77,1.4.09-.12.12-.39.08-.79h0Z"
              />
            </g>
            <g className="cls-400">
              <path
                className="cls-107"
                d="M62.17,190.82c-.65-.46-1.02-2.11-.63-2.14.05,0,.1.02.13.04.16.71.33,1.41.5,2.1h0Z"
              />
              <path
                className="cls-107"
                d="M60.53,185.33c.08.52-.04.81-.28.66-.18-.11-.51-.57-.68-1.37.3.2.62.4.94.6,0,.03.01.08.02.11h0Z"
              />
            </g>
            <g className="cls-397">
              <path
                className="cls-107"
                d="M89.88,73.37c.47-.45.87-.67,1.03-.57.1.14-.13.53-.58.99-.15-.14-.3-.28-.44-.42h0Z"
              />
              <path
                className="cls-107"
                d="M92.42,70.81c-.1.05-.16.05-.17.06.06-.02.12-.04.18-.06,0,0,0,0,0,0h0Z"
              />
            </g>
            <g className="cls-404">
              <path
                className="cls-107"
                d="M85.66,80.16c-.18-.11-.58.14-1.01.62.18.15.36.3.55.45.57-.68.55-1,.46-1.07h0Z"
              />
              <path
                className="cls-107"
                d="M84.64,79.26c-.16-.11-.54.13-.99.61.15.15.32.3.48.45.58-.67.58-.99.5-1.06h0Z"
              />
              <path
                className="cls-107"
                d="M89.25,77.26c-.23-.13-.73.29-.96.52-.47.48-.66.91-.61,1.08,0,.02.03.04.04.06.5-.56,1.01-1.11,1.53-1.66h0Z"
              />
              <path
                className="cls-107"
                d="M88.2,76.4c-.42-.26-1.67,1.24-1.58,1.58.08.33,1-.33,1.45-1.05.17-.27.22-.47.14-.54h0Z"
              />
              <path
                className="cls-107"
                d="M87.28,75.54c-.53.54-1.05,1.08-1.57,1.63.37.26,1.64-1.22,1.59-1.57,0-.02-.02-.04-.03-.06h0Z"
              />
              <path
                className="cls-107"
                d="M90.33,73.79c-.15-.14-.3-.28-.44-.42-.66.66-.73,1.04-.48,1.03.07,0,.36-.06.92-.61h0Z"
              />
            </g>
            <g className="cls-399">
              <path
                className="cls-107"
                d="M79.95,87.12c-.19-.11-.57.14-.97.66.19.16.39.32.59.48.52-.72.48-1.06.38-1.14h0Z"
              />
              <path
                className="cls-107"
                d="M78.85,86.16c-.17-.12-.53.13-.94.65.17.16.34.32.52.49.53-.72.51-1.05.43-1.13h0Z"
              />
              <path
                className="cls-107"
                d="M83.33,84.05c-.25-.14-.72.3-.93.56-.43.5-.59.96-.52,1.14,0,.02.03.05.05.06.46-.59.93-1.18,1.4-1.76h0Z"
              />
              <path
                className="cls-107"
                d="M82.2,83.12c-.45-.28-1.58,1.31-1.46,1.68.11.36.97-.33,1.37-1.1.15-.28.18-.5.09-.58h0Z"
              />
              <path
                className="cls-107"
                d="M81.21,82.19c-.48.57-.96,1.15-1.44,1.73.39.28,1.55-1.3,1.47-1.66,0-.02-.02-.05-.03-.06h0Z"
              />
              <path
                className="cls-107"
                d="M85.21,81.23c-.19-.15-.37-.3-.55-.45-.56.66-.64,1.13-.34,1.11.08,0,.37-.07.9-.66h0Z"
              />
              <path
                className="cls-107"
                d="M84.14,80.33c-.17-.15-.33-.3-.48-.45-.61.71-.65,1.12-.4,1.1.07,0,.35-.07.88-.65h0Z"
              />
            </g>
            <g className="cls-378">
              <path
                className="cls-107"
                d="M74.73,94.47c-.2-.12-.55.14-.92.69.2.17.41.34.63.51.47-.76.4-1.12.3-1.2h0Z"
              />
              <path
                className="cls-107"
                d="M73.57,93.45c-.18-.12-.52.14-.89.68.18.17.36.34.55.52.44-.7.45-1.1.34-1.19h0Z"
              />
              <path
                className="cls-107"
                d="M77.91,91.24c-.46-.26-1.47,1.25-1.35,1.74.02.06.04.09.07.12.42-.62.85-1.24,1.28-1.86h0Z"
              />
              <path
                className="cls-107"
                d="M76.7,90.25c-.41-.26-1.43,1.24-1.35,1.73.06.34.56.06.99-.56.36-.51.52-1.03.36-1.17h0Z"
              />
              <path
                className="cls-107"
                d="M75.64,89.26c-.44.6-.88,1.21-1.31,1.83.37.27,1.4-1.2,1.35-1.71,0-.06-.03-.09-.04-.11h0Z"
              />
              <path
                className="cls-107"
                d="M79.57,88.26c-.2-.16-.4-.32-.59-.48-.51.7-.56,1.2-.26,1.18.08,0,.37-.07.85-.69h0Z"
              />
              <path
                className="cls-107"
                d="M78.43,87.29c-.18-.16-.35-.32-.52-.49-.56.75-.56,1.19-.32,1.17.07,0,.35-.07.83-.68h0Z"
              />
            </g>
            <g className="cls-384">
              <path
                className="cls-107"
                d="M70.05,102.18c-.21-.13-.55.16-.88.73.21.18.43.36.66.54.42-.8.32-1.18.22-1.26h0Z"
              />
              <path
                className="cls-107"
                d="M68.83,101.1c-.18-.13-.51.15-.84.72.18.18.38.36.58.54.39-.74.37-1.16.27-1.26h0Z"
              />
              <path
                className="cls-107"
                d="M72.99,98.8c-.49-.28-1.38,1.29-1.22,1.82.02.07.05.1.08.12.38-.65.76-1.3,1.15-1.94h0Z"
              />
              <path
                className="cls-107"
                d="M71.71,97.76c-.44-.28-1.34,1.27-1.22,1.81.07.34.5.1.89-.48.36-.55.52-1.17.34-1.32h0Z"
              />
              <path
                className="cls-107"
                d="M70.59,96.71c-.4.64-.79,1.27-1.17,1.92.38.29,1.3-1.26,1.23-1.8,0-.07-.03-.09-.05-.12h0Z"
              />
              <path
                className="cls-107"
                d="M74.44,95.67c-.22-.17-.42-.34-.63-.51-.48.76-.47,1.32-.13,1.23.12-.03.38-.16.75-.72h0Z"
              />
              <path
                className="cls-107"
                d="M73.22,94.65c-.19-.17-.37-.34-.55-.52-.5.78-.51,1.31-.19,1.23.09-.02.35-.14.74-.71h0Z"
              />
            </g>
            <g className="cls-379">
              <path
                className="cls-107"
                d="M65.93,110.21c-.21-.13-.53.16-.81.74.22.19.45.37.69.56.33-.76.26-1.2.13-1.31h0Z"
              />
              <path
                className="cls-107"
                d="M64.65,109.09c-.19-.14-.49.15-.78.74.19.19.39.38.6.56.34-.76.29-1.2.18-1.3h0Z"
              />
              <path
                className="cls-107"
                d="M68.61,106.71c-.47-.27-1.24,1.2-1.11,1.84.02.11.06.15.1.19.33-.68.66-1.35,1.01-2.02h0Z"
              />
              <path
                className="cls-107"
                d="M67.27,105.61c-.45-.3-1.24,1.33-1.09,1.88.1.35.51.11.84-.5.32-.57.43-1.22.25-1.38h0Z"
              />
              <path
                className="cls-107"
                d="M66.1,104.51c-.35.66-.69,1.33-1.03,2,.4.3,1.2-1.32,1.09-1.87-.01-.07-.04-.1-.06-.13h0Z"
              />
              <path
                className="cls-107"
                d="M69.84,103.44c-.23-.18-.45-.36-.66-.54-.43.82-.38,1.38-.04,1.29.12-.03.37-.17.7-.75h0Z"
              />
              <path
                className="cls-107"
                d="M68.56,102.36c-.2-.18-.39-.36-.58-.54-.44.82-.42,1.37-.11,1.28.09-.03.34-.15.68-.74h0Z"
              />
            </g>
            <g className="cls-387">
              <path
                className="cls-107"
                d="M62.39,118.54c-.22-.14-.51.17-.75.77.23.19.47.39.71.58.28-.79.17-1.24.04-1.35h0Z"
              />
              <path
                className="cls-107"
                d="M61.06,117.38c-.19-.14-.47.15-.71.76.2.2.41.39.62.58.28-.79.21-1.24.09-1.35h0Z"
              />
              <path
                className="cls-107"
                d="M64.8,114.92c-.48-.29-1.14,1.24-.97,1.9.03.12.07.15.11.19.28-.7.57-1.4.86-2.09h0Z"
              />
              <path
                className="cls-107"
                d="M63.41,113.78c-.43-.29-1.09,1.23-.96,1.89.07.35.33.3.61-.1.41-.59.6-1.57.35-1.79h0Z"
              />
              <path
                className="cls-107"
                d="M62.19,112.63c-.3.69-.59,1.38-.88,2.07.37.28,1.05-1.25.96-1.88-.02-.11-.04-.15-.08-.19h0Z"
              />
              <path
                className="cls-107"
                d="M65.8,111.52c-.24-.19-.47-.37-.69-.56-.39.89-.28,1.5.09,1.33.13-.06.35-.25.6-.77h0Z"
              />
              <path
                className="cls-107"
                d="M64.47,110.39c-.21-.19-.41-.38-.6-.56-.38.85-.33,1.43-.03,1.34.09-.03.32-.15.63-.78h0Z"
              />
            </g>
            <g className="cls-386">
              <path
                className="cls-107"
                d="M59.47,127.14c-.22-.14-.49.17-.68.79.24.2.48.4.73.6.22-.81.09-1.28-.05-1.39h0Z"
              />
              <path
                className="cls-107"
                d="M58.11,125.94c-.2-.14-.44.16-.64.79.21.2.42.4.64.6.22-.81.12-1.27,0-1.39h0Z"
              />
              <path
                className="cls-107"
                d="M61.59,123.4c-.45-.27-1,1.16-.84,1.89.04.17.1.24.14.27.23-.72.46-1.44.7-2.16h0Z"
              />
              <path
                className="cls-107"
                d="M60.15,122.23c-.4-.27-.95,1.15-.83,1.88.06.37.27.42.51.11.41-.53.61-1.74.32-1.98h0Z"
              />
              <path
                className="cls-107"
                d="M58.9,121.05c-.25.71-.49,1.43-.72,2.14.36.28.9-1.15.82-1.87-.02-.17-.07-.23-.1-.27h0Z"
              />
              <path
                className="cls-107"
                d="M62.35,119.89c-.24-.19-.48-.39-.71-.58-.34.97-.14,1.52.18,1.37.13-.06.32-.25.53-.79h0Z"
              />
              <path
                className="cls-107"
                d="M60.98,118.73c-.21-.19-.42-.39-.62-.58-.35.97-.18,1.52.11,1.36.12-.06.3-.25.51-.78h0Z"
              />
            </g>
            <g className="cls-385">
              <path
                className="cls-107"
                d="M57.2,135.96c-.22-.14-.46.18-.6.81.24.2.49.41.75.61.16-.83,0-1.31-.14-1.42h0Z"
              />
              <path
                className="cls-107"
                d="M55.8,134.74c-.2-.15-.41.16-.56.81.21.2.43.41.65.61.16-.83.03-1.3-.09-1.42h0Z"
              />
              <path
                className="cls-107"
                d="M59.01,132.13c-.46-.28-.9,1.19-.7,1.94.05.18.11.24.15.28.17-.74.36-1.48.54-2.21h0Z"
              />
              <path
                className="cls-107"
                d="M57.54,130.92c-.41-.28-.84,1.19-.68,1.93.08.38.29.43.5.11.36-.55.47-1.79.18-2.04h0Z"
              />
              <path
                className="cls-107"
                d="M56.25,129.71c-.19.73-.38,1.46-.56,2.2.34.27.76-1.07.68-1.85-.03-.24-.08-.31-.12-.35h0Z"
              />
              <path
                className="cls-107"
                d="M59.52,128.52c-.25-.2-.49-.4-.73-.6-.27,1-.03,1.56.26,1.4.12-.06.3-.26.47-.81h0Z"
              />
              <path
                className="cls-107"
                d="M58.11,127.33c-.22-.2-.43-.4-.64-.6-.28,1.03-.08,1.56.19,1.4.11-.06.28-.25.45-.8h0Z"
              />
            </g>
            <g className="cls-383">
              <path
                className="cls-107"
                d="M55.6,144.98c-.22-.14-.43.18-.52.83.24.21.5.41.76.62.09-.85-.09-1.33-.23-1.45h0Z"
              />
              <path
                className="cls-107"
                d="M54.19,143.74c-.2-.15-.38.17-.48.83.21.21.43.41.66.62.09-.85-.06-1.33-.18-1.45h0Z"
              />
              <path
                className="cls-107"
                d="M57.09,141.05c-.44-.27-.77,1.11-.57,1.9.06.25.14.32.19.37.12-.76.24-1.52.38-2.27h0Z"
              />
              <path
                className="cls-107"
                d="M55.59,139.83c-.39-.27-.71,1.1-.55,1.9.09.43.28.53.47.25.34-.51.39-1.88.08-2.15h0Z"
              />
              <path
                className="cls-107"
                d="M54.28,138.59c-.14.75-.26,1.51-.39,2.26.32.26.63-.98.54-1.81-.04-.31-.11-.41-.15-.45h0Z"
              />
              <path
                className="cls-107"
                d="M57.34,137.38c-.26-.2-.51-.41-.75-.61-.18.96.04,1.62.35,1.43.09-.06.26-.24.4-.82h0Z"
              />
              <path
                className="cls-107"
                d="M55.9,136.16c-.23-.2-.44-.41-.65-.61-.18.95,0,1.61.27,1.43.08-.06.24-.23.38-.82h0Z"
              />
            </g>
            <g className="cls-382">
              <path
                className="cls-107"
                d="M54.71,154.16c-.22-.15-.39.18-.43.85.25.21.5.42.76.62.03-.93-.2-1.37-.33-1.47h0Z"
              />
              <path
                className="cls-107"
                d="M53.29,152.91c-.2-.15-.35.17-.39.84.21.21.44.42.67.63.03-.86-.15-1.35-.28-1.47h0Z"
              />
              <path
                className="cls-107"
                d="M55.85,150.16c-.42-.26-.65,1.01-.43,1.85.08.32.18.42.23.46.06-.77.13-1.54.2-2.31h0Z"
              />
              <path
                className="cls-107"
                d="M54.33,148.92c-.35-.24-.57.9-.42,1.75.09.54.3.75.47.49.32-.46.29-1.95-.05-2.24h0Z"
              />
              <path
                className="cls-107"
                d="M53.01,147.68c-.08.77-.14,1.53-.2,2.3.29.24.5-.81.4-1.65-.05-.48-.16-.61-.2-.66h0Z"
              />
              <path
                className="cls-107"
                d="M55.83,146.42c-.26-.21-.51-.41-.76-.62-.11.97.15,1.65.43,1.46.08-.06.24-.24.32-.84h0Z"
              />
              <path
                className="cls-107"
                d="M54.37,145.19c-.23-.21-.45-.41-.66-.62-.11.97.11,1.65.36,1.46.08-.06.22-.24.3-.84h0Z"
              />
            </g>
            <g className="cls-381">
              <path
                className="cls-107"
                d="M53.13,162.2c-.19-.15-.31.17-.29.84.21.21.44.42.67.63-.04-.86-.25-1.35-.37-1.47h0Z"
              />
              <path
                className="cls-107"
                d="M53.8,158.17c-.31-.22-.45.72-.31,1.56.11.62.33.96.49.75.3-.38.17-2-.18-2.31h0Z"
              />
              <path
                className="cls-107"
                d="M52.47,156.92c0,.57-.02,1.14-.02,1.72,0,.2,0,.41,0,.61.25.21.37-.56.3-1.33-.03-.28-.1-.78-.28-1h0Z"
              />
              <path
                className="cls-107"
                d="M55.04,155.63c-.26-.21-.52-.41-.76-.62-.03.99.27,1.67.52,1.48.08-.06.21-.25.25-.86h0Z"
              />
              <path
                className="cls-107"
                d="M53.56,154.38c-.23-.21-.45-.42-.67-.63-.03.99.22,1.67.44,1.48.07-.06.18-.25.22-.85h0Z"
              />
            </g>
            <g className="cls-380">
              <path
                className="cls-107"
                d="M53.53,172.14c-.07-.65,0-.96.2-.81.2.21.38.77.46,1.43-.23-.21-.45-.41-.66-.62h0Z"
              />
              <path
                className="cls-107"
                d="M53.1,167.74c.02.35-.01.89-.23.71-.07-.75-.12-1.51-.17-2.27.24.28.38,1.09.4,1.57h0Z"
              />
              <path
                className="cls-107"
                d="M53.5,163.79c0,.57-.12.88-.3.72-.13-.12-.33-.6-.37-1.46.21.21.44.42.67.63,0,.03,0,.08,0,.12h0Z"
              />
            </g>
            <g className="cls-625">
              <path
                className="cls-107"
                d="M56.49,177.64c-.31-.2-.31.47-.18,1.02.02.09.2.89.53,1.18-.12-.73-.24-1.46-.35-2.2h0Z"
              />
              <path
                className="cls-107"
                d="M54.98,176.41c-.25-.19-.24.37-.18.79.13.82.5,1.61.67,1.42.24-.26-.13-1.9-.5-2.21h0Z"
              />
              <path
                className="cls-107"
                d="M53.66,175.17c.11.74.23,1.47.35,2.2.2.18.18-.32.17-.48-.04-.52-.26-1.42-.52-1.73h0Z"
              />
              <path
                className="cls-107"
                d="M54.19,172.77c-.23-.21-.45-.41-.66-.62.12.95.45,1.62.6,1.44.14-.15.06-.81.06-.82h0Z"
              />
            </g>
            <g className="cls-619">
              <path
                className="cls-107"
                d="M90.09,71.96c-.13-.1-.53.12-1,.56.12.14.25.28.38.42.63-.62.68-.92.62-.98h0Z"
              />
              <path
                className="cls-107"
                d="M89.4,71.13c-.12-.1-.5.12-.98.55.1.14.21.28.32.42.59-.57.72-.9.66-.98h0Z"
              />
              <path
                className="cls-107"
                d="M93.09,68.54c-.12-.09-.53.13-1.02.54-.37.32-.74.77-.69.92.09.3,1.4-.7,1.69-1.28.06-.12.04-.17.02-.18h0Z"
              />
              <path
                className="cls-107"
                d="M92.49,67.74c-.58.49-1.15.98-1.71,1.47.14.13.7-.29.9-.46.56-.48.84-.86.82-.99,0,0,0-.02,0-.02h0Z"
              />
            </g>
            <g className="cls-622">
              <path
                className="cls-107"
                d="M83.75,78.36c-.14-.11-.52.13-.96.6.13.15.27.3.41.46.59-.67.61-.98.55-1.06h0Z"
              />
              <path
                className="cls-107"
                d="M83,77.46c-.12-.11-.48.12-.93.59.11.15.22.3.34.46.59-.66.64-.98.59-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M87.28,75.54c-.38-.26-1.65,1.22-1.59,1.57,0,.02.02.04.03.06.52-.55,1.04-1.09,1.57-1.63h0Z"
              />
              <path
                className="cls-107"
                d="M86.49,74.67c-.32-.26-1.63,1.21-1.6,1.55.02.27.62-.1,1.15-.7.35-.39.54-.75.45-.85h0Z"
              />
              <path
                className="cls-107"
                d="M85.83,73.8c-.54.53-1.07,1.06-1.6,1.59.27.26,1.6-1.19,1.61-1.53,0-.02,0-.04-.01-.06h0Z"
              />
              <path
                className="cls-107"
                d="M89.47,72.95c-.13-.14-.26-.28-.38-.42-.62.6-.79,1.04-.53,1.02.07,0,.33-.06.91-.6h0Z"
              />
              <path
                className="cls-107"
                d="M88.74,72.11c-.11-.14-.22-.28-.32-.42-.68.65-.79,1.02-.58,1.01.06,0,.32-.06.9-.59h0Z"
              />
            </g>
            <g className="cls-623">
              <path
                className="cls-107"
                d="M77.9,85.19c-.15-.12-.51.14-.91.64.14.16.29.33.44.49.54-.71.54-1.05.47-1.13h0Z"
              />
              <path
                className="cls-107"
                d="M77.09,84.22c-.13-.12-.47.12-.88.63.12.16.24.33.37.49.5-.65.58-1.03.51-1.12h0Z"
              />
              <path
                className="cls-107"
                d="M81.21,82.19c-.4-.29-1.56,1.29-1.47,1.66,0,.02.02.05.03.07.47-.58.95-1.16,1.44-1.73h0Z"
              />
              <path
                className="cls-107"
                d="M80.36,81.25c-.34-.28-1.53,1.28-1.48,1.65.04.29.61-.1,1.09-.73.32-.42.48-.8.39-.91h0Z"
              />
              <path
                className="cls-107"
                d="M79.65,80.31c-.49.56-.98,1.13-1.47,1.69.29.28,1.49-1.26,1.48-1.63,0-.02,0-.05-.02-.06h0Z"
              />
              <path
                className="cls-107"
                d="M83.2,79.42c-.14-.15-.28-.3-.41-.46-.57.65-.71,1.11-.45,1.1.07,0,.33-.06.86-.64h0Z"
              />
              <path
                className="cls-107"
                d="M82.41,78.51c-.12-.15-.24-.3-.34-.46-.63.69-.72,1.1-.5,1.09.06,0,.31-.06.85-.63h0Z"
              />
            </g>
            <g className="cls-620">
              <path
                className="cls-107"
                d="M72.56,92.42c-.15-.12-.49.14-.86.67.15.17.31.35.47.52.48-.75.47-1.1.39-1.19h0Z"
              />
              <path
                className="cls-107"
                d="M71.7,91.39c-.13-.13-.45.13-.83.66.12.17.25.35.39.52.45-.69.51-1.09.43-1.18h0Z"
              />
              <path
                className="cls-107"
                d="M75.64,89.26c-.36-.27-1.4,1.22-1.36,1.71,0,.06.03.09.05.12.43-.61.87-1.22,1.31-1.83h0Z"
              />
              <path
                className="cls-107"
                d="M74.73,88.26c-.31-.26-1.37,1.21-1.36,1.7,0,.26.27.17.63-.2.49-.52.88-1.32.73-1.49h0Z"
              />
              <path
                className="cls-107"
                d="M73.98,87.25c-.45.59-.9,1.19-1.34,1.8.27.28,1.32-1.18,1.36-1.68,0-.06,0-.09-.02-.11h0Z"
              />
              <path
                className="cls-107"
                d="M77.43,86.32c-.15-.16-.3-.33-.44-.49-.52.69-.63,1.18-.37,1.17.07,0,.33-.07.82-.68h0Z"
              />
              <path
                className="cls-107"
                d="M76.58,85.34c-.13-.16-.25-.33-.37-.49-.57.74-.64,1.17-.43,1.16.06,0,.3-.06.8-.67h0Z"
              />
            </g>
            <g className="cls-621">
              <path
                className="cls-107"
                d="M67.76,100.02c-.16-.13-.47.15-.81.71.16.18.32.36.49.54.43-.79.39-1.17.31-1.25h0Z"
              />
              <path
                className="cls-107"
                d="M66.86,98.94c-.14-.13-.43.14-.77.7.13.18.27.36.41.55.41-.73.44-1.15.36-1.25h0Z"
              />
              <path
                className="cls-107"
                d="M70.59,96.71c-.39-.29-1.31,1.26-1.23,1.79,0,.07.03.1.05.12.39-.64.78-1.28,1.17-1.92h0Z"
              />
              <path
                className="cls-107"
                d="M69.63,95.65c-.33-.29-1.26,1.25-1.23,1.78.02.26.24.2.55-.14.47-.54.85-1.44.68-1.64h0Z"
              />
              <path
                className="cls-107"
                d="M68.83,94.59c-.4.63-.8,1.26-1.2,1.89.28.29,1.22-1.24,1.22-1.77,0-.06-.01-.09-.03-.12h0Z"
              />
              <path
                className="cls-107"
                d="M72.17,93.61c-.16-.17-.32-.34-.47-.52-.49.75-.55,1.3-.25,1.22.11-.03.34-.16.72-.7h0Z"
              />
              <path
                className="cls-107"
                d="M71.27,92.58c-.14-.17-.27-.35-.39-.52-.51.77-.59,1.29-.31,1.22.08-.02.31-.14.7-.7h0Z"
              />
            </g>
            <g className="cls-647">
              <path
                className="cls-107"
                d="M63.54,107.96c-.16-.13-.45.15-.74.73.16.19.34.38.51.57.34-.76.32-1.19.22-1.3h0Z"
              />
              <path
                className="cls-107"
                d="M62.6,106.83c-.14-.14-.41.14-.7.72.14.19.28.38.43.57.35-.75.35-1.19.27-1.29h0Z"
              />
              <path
                className="cls-107"
                d="M66.1,104.51c-.4-.3-1.2,1.31-1.09,1.87.01.07.04.1.06.13.34-.67.68-1.34,1.03-2h0Z"
              />
              <path
                className="cls-107"
                d="M65.09,103.4c-.34-.3-1.15,1.3-1.09,1.86.03.27.25.21.52-.15.43-.56.74-1.5.57-1.71h0Z"
              />
              <path
                className="cls-107"
                d="M64.26,102.29c-.36.66-.71,1.31-1.05,1.98.26.28,1.05-1.16,1.08-1.79,0-.11-.01-.15-.03-.19h0Z"
              />
              <path
                className="cls-107"
                d="M67.45,101.27c-.17-.18-.34-.36-.49-.54-.43.79-.45,1.36-.17,1.28.08-.02.31-.14.66-.74h0Z"
              />
              <path
                className="cls-107"
                d="M66.51,100.19c-.14-.18-.28-.36-.41-.55-.45.81-.5,1.36-.23,1.28.08-.02.29-.14.64-.73h0Z"
              />
            </g>
            <g className="cls-648">
              <path
                className="cls-107"
                d="M59.91,116.21c-.17-.14-.43.16-.67.76.17.2.35.39.53.59.29-.78.24-1.23.14-1.34h0Z"
              />
              <path
                className="cls-107"
                d="M58.94,115.04c-.14-.14-.38.15-.63.75.14.2.29.39.44.59.29-.78.27-1.23.19-1.34h0Z"
              />
              <path
                className="cls-107"
                d="M62.19,112.63c-.38-.29-1.05,1.22-.96,1.88.02.12.04.15.08.2.29-.69.58-1.39.88-2.07h0Z"
              />
              <path
                className="cls-107"
                d="M61.15,111.48c-.32-.29-1,1.21-.95,1.87.02.27.16.31.36.09.43-.46.8-1.71.59-1.96h0Z"
              />
              <path
                className="cls-107"
                d="M60.28,110.33c-.31.68-.6,1.37-.9,2.05.25.27.9-1.09.94-1.8,0-.16-.02-.22-.04-.26h0Z"
              />
              <path
                className="cls-107"
                d="M63.31,109.26c-.18-.19-.35-.38-.51-.57-.39.85-.37,1.43-.09,1.34.1-.03.31-.17.6-.78h0Z"
              />
              <path
                className="cls-107"
                d="M62.33,108.13c-.15-.19-.29-.38-.43-.57-.39.85-.41,1.42-.15,1.34.07-.02.28-.15.58-.77h0Z"
              />
            </g>
            <g className="cls-624">
              <path
                className="cls-107"
                d="M56.92,124.74c-.17-.14-.4.16-.59.78.17.2.36.4.55.6.23-.81.15-1.27.05-1.38h0Z"
              />
              <path
                className="cls-107"
                d="M55.92,123.54c-.14-.15-.35.15-.55.78.14.2.3.4.46.61.23-.81.18-1.27.1-1.38h0Z"
              />
              <path
                className="cls-107"
                d="M58.9,121.05c-.36-.28-.9,1.14-.82,1.87.02.17.07.24.1.27.23-.72.48-1.43.72-2.14h0Z"
              />
              <path
                className="cls-107"
                d="M57.82,119.86c-.3-.28-.84,1.14-.8,1.86.02.32.14.4.31.22.4-.42.72-1.8.49-2.08h0Z"
              />
              <path
                className="cls-107"
                d="M56.92,118.67c-.25.71-.5,1.41-.74,2.13.24.27.75-1.02.79-1.78,0-.23-.03-.3-.05-.35h0Z"
              />
              <path
                className="cls-107"
                d="M59.78,117.56c-.18-.2-.36-.39-.53-.59-.35.96-.23,1.51.04,1.36.11-.06.28-.24.49-.78h0Z"
              />
              <path
                className="cls-107"
                d="M58.76,116.38c-.16-.2-.3-.39-.44-.59-.35.94-.27,1.45-.07,1.38.08-.03.26-.17.51-.79h0Z"
              />
            </g>
            <g className="cls-646">
              <path
                className="cls-107"
                d="M54.59,133.51c-.17-.14-.37.17-.52.8.18.21.36.41.56.62.16-.83.06-1.3-.04-1.42h0Z"
              />
              <path
                className="cls-107"
                d="M53.57,132.28c-.14-.15-.32.16-.47.8.15.21.3.41.47.62.17-.83.1-1.3,0-1.42h0Z"
              />
              <path
                className="cls-107"
                d="M56.25,129.71c-.34-.27-.76,1.06-.68,1.84.03.24.08.31.12.36.18-.74.36-1.47.56-2.2h0Z"
              />
              <path
                className="cls-107"
                d="M55.14,128.49c-.28-.26-.67.94-.66,1.75,0,.42.12.59.29.43.36-.35.62-1.88.37-2.18h0Z"
              />
              <path
                className="cls-107"
                d="M54.22,127.27c-.2.73-.39,1.46-.57,2.19.22.24.59-.85.63-1.66.02-.38-.04-.49-.06-.53h0Z"
              />
              <path
                className="cls-107"
                d="M56.87,126.12c-.19-.2-.37-.4-.55-.6-.26.92-.15,1.57.12,1.4.1-.06.25-.25.43-.8h0Z"
              />
              <path
                className="cls-107"
                d="M55.83,124.92c-.16-.2-.31-.4-.46-.61-.28.97-.17,1.5.02,1.42.08-.03.24-.18.44-.81h0Z"
              />
            </g>
            <g className="cls-584">
              <path
                className="cls-107"
                d="M52.96,142.49c-.17-.15-.34.18-.43.82.18.21.37.42.57.62.1-.85-.03-1.33-.13-1.45h0Z"
              />
              <path
                className="cls-107"
                d="M51.92,141.24c-.14-.15-.29.16-.39.82.15.21.31.42.47.63.1-.85,0-1.33-.09-1.45h0Z"
              />
              <path
                className="cls-107"
                d="M54.28,138.59c-.33-.26-.64.97-.54,1.8.04.32.11.41.15.46.12-.76.25-1.51.39-2.26h0Z"
              />
              <path
                className="cls-107"
                d="M53.15,137.35c-.25-.24-.53.79-.52,1.61,0,.55.14.82.31.63.32-.37.47-1.93.21-2.24h0Z"
              />
              <path
                className="cls-107"
                d="M52.22,136.11c-.14.75-.27,1.5-.39,2.25.19.21.43-.6.48-1.39.02-.29.02-.68-.08-.86h0Z"
              />
              <path
                className="cls-107"
                d="M54.64,134.93c-.19-.2-.38-.41-.56-.62-.19.95-.04,1.61.2,1.43.07-.05.22-.23.35-.82h0Z"
              />
              <path
                className="cls-107"
                d="M53.57,133.7c-.16-.21-.32-.41-.47-.62-.19.95-.09,1.61.13,1.43.07-.05.2-.23.33-.81h0Z"
              />
            </g>
            <g className="cls-585">
              <path
                className="cls-107"
                d="M52.05,151.65c-.17-.15-.3.17-.34.84.18.21.37.42.57.63.03-.93-.14-1.37-.23-1.47h0Z"
              />
              <path
                className="cls-107"
                d="M51,150.4c-.14-.15-.25.17-.29.84.15.21.31.42.48.63.03-.86-.09-1.35-.18-1.47h0Z"
              />
              <path
                className="cls-107"
                d="M53.01,147.68c-.3-.24-.5.79-.41,1.64.05.48.17.62.2.67.06-.77.13-1.54.2-2.3h0Z"
              />
              <path
                className="cls-107"
                d="M51.87,146.42c-.22-.22-.4.62-.38,1.42.02.64.16,1.04.31.89.29-.28.34-1.99.07-2.31h0Z"
              />
              <path
                className="cls-107"
                d="M50.92,145.16c-.08.76-.15,1.53-.21,2.3.17.19.29-.44.33-.96.02-.35.03-1.07-.12-1.34h0Z"
              />
              <path
                className="cls-107"
                d="M53.09,143.94c-.2-.21-.38-.42-.57-.62-.11.97.07,1.65.29,1.46.07-.06.19-.24.28-.84h0Z"
              />
              <path
                className="cls-107"
                d="M52.01,142.69c-.17-.21-.32-.42-.47-.63-.12.97.02,1.64.22,1.46.06-.06.17-.24.26-.83h0Z"
              />
            </g>
            <g className="cls-586">
              <path
                className="cls-107"
                d="M51.89,160.95c-.17-.15-.26.17-.24.84.18.21.37.42.57.63-.04-.93-.23-1.37-.33-1.47h0Z"
              />
              <path
                className="cls-107"
                d="M50.85,159.69c-.14-.15-.18.19-.19.41,0,.16,0,.29,0,.43.15.21.31.42.48.63-.04-.86-.19-1.35-.28-1.47h0Z"
              />
              <path
                className="cls-107"
                d="M52.47,156.92c-.26-.21-.37.55-.3,1.33.03.28.1.78.28,1,0-.2,0-.41,0-.61,0-.57,0-1.15.02-1.72h0Z"
              />
              <path
                className="cls-107"
                d="M51.33,155.66c-.2-.19-.28.45-.27.97.01.84.21,1.56.38,1.37.24-.27.16-2.02-.11-2.34h0Z"
              />
              <path
                className="cls-107"
                d="M50.38,154.4c0,.57-.02,1.14-.02,1.72,0,.2,0,.41,0,.61.13.15.18-.2.2-.42.06-.61-.02-1.61-.19-1.91h0Z"
              />
              <path
                className="cls-107"
                d="M52.28,153.12c-.2-.21-.39-.42-.57-.63-.03.99.18,1.67.37,1.48.06-.06.16-.24.2-.85h0Z"
              />
              <path
                className="cls-107"
                d="M51.19,151.87c-.17-.21-.32-.42-.48-.63-.04.98.14,1.67.3,1.48.14-.16.18-.85.17-.85h0Z"
              />
            </g>
            <g className="cls-587">
              <path
                className="cls-107"
                d="M52.49,170.08c-.19-.18-.18.33-.18.49,0,.11.02.21.03.32.18.21.37.42.57.62-.12-.9-.32-1.33-.42-1.43h0Z"
              />
              <path
                className="cls-107"
                d="M51.45,168.83s-.11-.13-.13.16c-.02.22.02.51.03.65.15.21.31.42.47.63-.11-.84-.28-1.32-.37-1.44h0Z"
              />
              <path
                className="cls-107"
                d="M52.69,166.17c-.22-.19-.26.39-.22.82.03.37.15,1.16.4,1.45-.07-.75-.12-1.51-.17-2.27h0Z"
              />
              <path
                className="cls-107"
                d="M51.55,164.91c-.18-.18-.19.34-.19.5,0,.85.28,1.93.46,1.81.23-.16.02-1.97-.27-2.31h0Z"
              />
              <path
                className="cls-107"
                d="M50.6,163.65c.05.76.11,1.52.18,2.28.03.03.1.13.13-.17.05-.52-.11-1.76-.31-2.11h0Z"
              />
              <path
                className="cls-107"
                d="M52.22,162.42c-.2-.21-.39-.42-.57-.63.05.98.3,1.66.46,1.48.13-.15.12-.82.11-.85h0Z"
              />
              <path
                className="cls-107"
                d="M51.12,161.16c-.17-.21-.32-.42-.48-.63.04.95.24,1.6.37,1.5.13-.09.12-.83.11-.87h0Z"
              />
            </g>
            <g className="cls-588">
              <path
                className="cls-107"
                d="M54.02,177.37c-.42-.48-.68-2.22-.44-2.25.03,0,.06.02.08.04.11.74.23,1.47.35,2.2h0Z"
              />
              <path
                className="cls-107"
                d="M52.92,171.63c.05.52,0,.81-.13.72-.12-.08-.33-.59-.44-1.46.18.21.37.42.57.62,0,.03,0,.08.01.11h0Z"
              />
              <path
                className="cls-107"
                d="M51.84,170.38c.05.51.01.81-.09.72-.1-.08-.28-.59-.39-1.46.15.21.31.42.47.63,0,.03,0,.08.01.11h0Z"
              />
            </g>
            <g className="cls-583">
              <path
                className="cls-107"
                d="M94.35,64.25c.52-.39.9-.58.98-.49.02.13-.29.47-.8.88-.06-.13-.12-.26-.18-.39h0Z"
              />
            </g>
            <g className="cls-582">
              <path
                className="cls-107"
                d="M88.83,70.29c-.1-.1-.47.11-.95.54.08.14.17.28.26.42.6-.57.75-.89.7-.97h0Z"
              />
              <path
                className="cls-107"
                d="M88.39,69.46c-.08-.1-.44.11-.93.53.06.14.12.28.19.42.61-.56.77-.88.73-.96h0Z"
              />
              <path
                className="cls-107"
                d="M92.49,67.74c-.11-.1-.5.11-1,.53-.38.32-.76.76-.73.91,0,0,0,.02,0,.02.57-.5,1.14-.99,1.71-1.47h0Z"
              />
              <path
                className="cls-107"
                d="M92,66.94c-.09-.1-.48.12-.97.52-.37.31-.77.75-.76.91.02.26,1.04-.45,1.55-1.08.19-.24.19-.32.18-.35h0Z"
              />
              <path
                className="cls-107"
                d="M91.64,66.14c-.58.47-1.16.95-1.73,1.44.11.15.84-.44.85-.44.57-.46.88-.85.88-.97,0,0,0-.02,0-.02h0Z"
              />
              <path
                className="cls-107"
                d="M94.53,64.63c-.06-.13-.12-.26-.18-.39-.7.55-.89.88-.76.91.02,0,.22.03.94-.52h0Z"
              />
            </g>
            <g className="cls-581">
              <path
                className="cls-107"
                d="M82.39,76.55c-.1-.11-.46.12-.9.58.09.15.18.31.28.46.6-.66.67-.97.63-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M81.91,75.64c-.08-.11-.43.12-.88.57.06.15.13.31.21.46.56-.6.71-.95.67-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M85.83,73.8c-.28-.27-1.6,1.19-1.61,1.53,0,.02,0,.04.01.06.53-.54,1.06-1.07,1.6-1.59h0Z"
              />
              <path
                className="cls-107"
                d="M85.3,72.92c-.23-.26-1.58,1.17-1.61,1.51-.02.17.2.1.53-.16.57-.45,1.17-1.19,1.08-1.35h0Z"
              />
              <path
                className="cls-107"
                d="M84.91,72.05c-.54.51-1.08,1.03-1.61,1.56.18.26,1.55-1.16,1.61-1.5,0-.02,0-.04,0-.06h0Z"
              />
              <path
                className="cls-107"
                d="M88.13,71.26c-.09-.14-.18-.28-.26-.42-.63.59-.85,1.02-.62,1,.06,0,.3-.05.88-.58h0Z"
              />
              <path
                className="cls-107"
                d="M87.65,70.41c-.07-.14-.13-.28-.19-.42-.62.57-.87,1.01-.67.99.05,0,.28-.05.86-.57h0Z"
              />
            </g>
            <g className="cls-580">
              <path
                className="cls-107"
                d="M76.43,83.25c-.11-.12-.44.13-.85.62.09.16.19.33.3.49.55-.7.6-1.03.55-1.11h0Z"
              />
              <path
                className="cls-107"
                d="M75.92,82.27c-.09-.12-.41.12-.82.61.07.16.14.33.22.49.52-.64.64-1.01.6-1.1h0Z"
              />
              <path
                className="cls-107"
                d="M79.65,80.31c-.29-.29-1.5,1.26-1.48,1.63,0,.02,0,.05.02.07.48-.57.97-1.13,1.47-1.69h0Z"
              />
              <path
                className="cls-107"
                d="M79.08,79.37c-.24-.29-1.47,1.25-1.49,1.61,0,.18.19.11.51-.16.54-.48,1.08-1.27.98-1.45h0Z"
              />
              <path
                className="cls-107"
                d="M78.65,78.42c-.5.55-.99,1.1-1.48,1.66.19.28,1.43-1.23,1.49-1.6,0-.02,0-.05,0-.06h0Z"
              />
              <path
                className="cls-107"
                d="M81.76,77.59c-.1-.15-.19-.31-.28-.46-.58.63-.77,1.09-.55,1.08.06,0,.29-.06.83-.62h0Z"
              />
              <path
                className="cls-107"
                d="M81.24,76.67c-.08-.15-.14-.31-.21-.46-.58.62-.8,1.08-.6,1.07.05,0,.27-.06.81-.61h0Z"
              />
            </g>
            <g className="cls-579">
              <path
                className="cls-107"
                d="M71,90.36c-.11-.12-.42.13-.79.66.1.17.2.35.32.52.5-.74.53-1.09.48-1.18h0Z"
              />
              <path
                className="cls-107"
                d="M70.45,89.32c-.09-.12-.38.13-.76.65.07.17.15.35.24.52.47-.68.57-1.07.52-1.17h0Z"
              />
              <path
                className="cls-107"
                d="M73.98,87.25c-.27-.27-1.33,1.19-1.36,1.68,0,.06.01.09.02.12.44-.6.88-1.2,1.34-1.8h0Z"
              />
              <path
                className="cls-107"
                d="M73.37,86.25c-.22-.27-1.29,1.18-1.35,1.67-.03.19.09.2.3.04.5-.4,1.17-1.48,1.05-1.7h0Z"
              />
              <path
                className="cls-107"
                d="M72.91,85.24c-.46.58-.91,1.17-1.35,1.77.17.28,1.24-1.15,1.35-1.65.01-.06,0-.09,0-.11h0Z"
              />
              <path
                className="cls-107"
                d="M75.88,84.36c-.11-.16-.2-.33-.3-.49-.53.67-.69,1.16-.48,1.15.06,0,.28-.06.78-.66h0Z"
              />
              <path
                className="cls-107"
                d="M75.32,83.38c-.08-.16-.16-.33-.22-.49-.54.67-.72,1.16-.53,1.14.04,0,.24-.04.75-.65h0Z"
              />
            </g>
            <g className="cls-568">
              <path
                className="cls-107"
                d="M66.13,97.85c-.11-.13-.4.14-.73.7.1.18.21.37.33.55.41-.73.47-1.14.4-1.25h0Z"
              />
              <path
                className="cls-107"
                d="M65.55,96.76c-.09-.13-.36.14-.7.69.08.18.16.37.25.55.42-.72.5-1.14.45-1.24h0Z"
              />
              <path
                className="cls-107"
                d="M68.83,94.59c-.27-.28-1.22,1.26-1.22,1.77,0,.07.01.1.03.12.39-.63.79-1.26,1.2-1.89h0Z"
              />
              <path
                className="cls-107"
                d="M68.19,93.53c-.23-.29-1.18,1.23-1.22,1.75-.01.18.08.21.24.08.46-.37,1.11-1.59.98-1.83h0Z"
              />
              <path
                className="cls-107"
                d="M67.71,92.46c-.41.62-.81,1.24-1.21,1.86.16.27,1.06-1.09,1.2-1.69.02-.1.02-.14,0-.18h0Z"
              />
              <path
                className="cls-107"
                d="M70.52,91.54c-.11-.17-.22-.35-.32-.52-.51.76-.62,1.29-.37,1.21.07-.02.29-.13.68-.69h0Z"
              />
              <path
                className="cls-107"
                d="M69.93,90.49c-.09-.17-.16-.35-.24-.52-.49.71-.64,1.22-.46,1.21.03,0,.23-.05.69-.69h0Z"
              />
            </g>
            <g className="cls-569">
              <path
                className="cls-107"
                d="M61.83,105.7c-.11-.13-.37.15-.66.72.11.19.22.38.35.57.35-.75.38-1.18.32-1.29h0Z"
              />
              <path
                className="cls-107"
                d="M61.23,104.56c-.09-.14-.33.14-.62.71.08.19.17.38.26.57.36-.75.41-1.18.36-1.28h0Z"
              />
              <path
                className="cls-107"
                d="M64.26,102.29c-.27-.28-1.06,1.16-1.08,1.79,0,.11.01.15.03.19.34-.66.69-1.32,1.05-1.98h0Z"
              />
              <path
                className="cls-107"
                d="M63.59,101.18c-.22-.28-1.01,1.15-1.07,1.78-.02.22.05.28.19.18.41-.31,1.03-1.68.88-1.95h0Z"
              />
              <path
                className="cls-107"
                d="M63.08,100.06c-.36.65-.72,1.3-1.06,1.95.14.25.85-.94,1.03-1.63.06-.21.04-.28.03-.32h0Z"
              />
              <path
                className="cls-107"
                d="M65.72,99.09c-.12-.18-.23-.37-.33-.55-.46.8-.53,1.35-.29,1.27.07-.02.27-.14.62-.72h0Z"
              />
              <path
                className="cls-107"
                d="M65.1,98c-.09-.18-.17-.37-.25-.55-.45.77-.57,1.34-.35,1.27.06-.02.25-.14.6-.72h0Z"
              />
            </g>
            <g className="cls-571">
              <path
                className="cls-107"
                d="M58.14,113.87c-.11-.14-.35.15-.59.75.11.2.23.4.36.59.3-.78.3-1.23.23-1.34h0Z"
              />
              <path
                className="cls-107"
                d="M57.52,112.69c-.09-.14-.3.15-.55.74.08.2.17.39.27.59.3-.78.33-1.22.28-1.33h0Z"
              />
              <path
                className="cls-107"
                d="M60.28,110.33c-.25-.27-.9,1.09-.94,1.79,0,.17.02.23.04.26.29-.69.59-1.37.9-2.05h0Z"
              />
              <path
                className="cls-107"
                d="M59.58,109.17c-.19-.26-.8.98-.91,1.71-.05.3,0,.44.14.35.37-.24.94-1.76.77-2.06h0Z"
              />
              <path
                className="cls-107"
                d="M59.05,108.01c-.31.67-.61,1.35-.91,2.03.12.22.62-.7.83-1.45.12-.42.09-.55.08-.59h0Z"
              />
              <path
                className="cls-107"
                d="M61.51,106.99c-.12-.19-.24-.38-.35-.57-.4.84-.44,1.42-.22,1.33.07-.02.25-.14.56-.76h0Z"
              />
              <path
                className="cls-107"
                d="M60.87,105.84c-.09-.19-.18-.38-.26-.57-.4.84-.48,1.41-.28,1.33.06-.02.23-.14.54-.76h0Z"
              />
            </g>
            <g className="cls-567">
              <path
                className="cls-107"
                d="M55.1,122.33c-.12-.14-.32.16-.51.77.12.2.24.41.37.61.23-.81.21-1.27.14-1.38h0Z"
              />
              <path
                className="cls-107"
                d="M54.46,121.11c-.09-.14-.27.16-.47.77.08.2.18.4.28.61.24-.8.24-1.26.19-1.38h0Z"
              />
              <path
                className="cls-107"
                d="M56.92,118.67c-.24-.27-.75,1.02-.79,1.77-.01.23.03.3.05.35.24-.71.48-1.42.74-2.13h0Z"
              />
              <path
                className="cls-107"
                d="M56.2,117.47c-.17-.24-.62.81-.74,1.59-.07.43-.02.65.12.54.33-.25.79-1.82.62-2.13h0Z"
              />
              <path
                className="cls-107"
                d="M55.66,116.27c-.26.7-.5,1.4-.75,2.11.1.19.4-.42.59-1.09.05-.18.22-.78.15-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M57.91,115.2c-.13-.2-.25-.4-.36-.59-.33.86-.34,1.46-.13,1.38.08-.03.24-.17.49-.78h0Z"
              />
              <path
                className="cls-107"
                d="M57.24,114.02c-.1-.2-.19-.39-.27-.59-.33.86-.38,1.45-.19,1.37.05-.02.2-.15.46-.78h0Z"
              />
            </g>
            <g className="cls-570">
              <path
                className="cls-107"
                d="M52.74,131.04c-.11-.15-.28.17-.43.8.12.21.24.41.38.62.17-.83.12-1.3.05-1.42h0Z"
              />
              <path
                className="cls-107"
                d="M52.08,129.81c-.11-.18-.28.34-.36.68,0,.03-.02.08-.03.11.09.21.18.41.28.62.17-.83.16-1.3.1-1.41h0Z"
              />
              <path
                className="cls-107"
                d="M54.22,127.27c-.21-.24-.59.84-.63,1.65-.02.38.04.49.06.54.18-.73.37-1.46.57-2.19h0Z"
              />
              <path
                className="cls-107"
                d="M53.48,126.05c-.14-.21-.42.5-.55,1.23-.11.62-.08,1.06.06.99.28-.15.66-1.89.49-2.22h0Z"
              />
              <path
                className="cls-107"
                d="M52.93,124.82c-.2.72-.39,1.45-.57,2.18.11.2.32-.49.34-.57.15-.49.31-1.32.23-1.61h0Z"
              />
              <path
                className="cls-107"
                d="M54.96,123.71c-.13-.2-.25-.41-.37-.61-.26.89-.24,1.5-.05,1.42.07-.03.21-.17.41-.81h0Z"
              />
              <path
                className="cls-107"
                d="M54.27,122.49c-.1-.2-.19-.4-.28-.61-.26.89-.28,1.5-.11,1.41.16-.08.39-.77.39-.81h0Z"
              />
            </g>
            <g className="cls-566">
              <path
                className="cls-107"
                d="M51.07,139.99c-.11-.15-.25.17-.34.82.12.21.25.42.38.63.1-.85.03-1.33-.04-1.45h0Z"
              />
              <path
                className="cls-107"
                d="M50.41,138.73s-.08-.14-.19.24c-.06.21-.09.44-.11.58.09.21.18.42.29.63.11-.85.06-1.33,0-1.44h0Z"
              />
              <path
                className="cls-107"
                d="M52.22,136.11c-.2-.23-.43.68-.48,1.39-.02.29-.02.68.08.86.12-.75.25-1.5.39-2.25h0Z"
              />
              <path
                className="cls-107"
                d="M51.46,134.86c-.13-.19-.29.39-.36.82-.14.8-.12,1.57.05,1.47.25-.16.5-1.95.32-2.28h0Z"
              />
              <path
                className="cls-107"
                d="M50.89,133.61c-.14.75-.27,1.49-.4,2.24.02.03.06.12.16-.17.18-.51.33-1.73.23-2.08h0Z"
              />
              <path
                className="cls-107"
                d="M52.68,132.46c-.13-.21-.26-.41-.38-.62-.19.91-.13,1.54.04,1.45.05-.03.18-.16.34-.83h0Z"
              />
              <path
                className="cls-107"
                d="M51.98,131.22c-.1-.21-.2-.41-.28-.62-.19.91-.17,1.54-.03,1.45.14-.09.31-.79.31-.83h0Z"
              />
            </g>
            <g className="cls-565">
              <path
                className="cls-107"
                d="M50.15,149.13c-.11-.15-.18.19-.21.41-.02.16-.03.3-.04.43.12.21.25.42.38.64.03-.86-.06-1.35-.14-1.47h0Z"
              />
              <path
                className="cls-107"
                d="M49.48,147.87s-.06-.1-.1.06c-.06.21-.09.64-.1.78.09.21.18.42.29.63.04-.86-.03-1.35-.09-1.47h0Z"
              />
              <path
                className="cls-107"
                d="M50.92,145.16c-.16-.19-.28.39-.32.83-.04.44-.04,1.2.11,1.47.06-.77.13-1.54.21-2.3h0Z"
              />
              <path
                className="cls-107"
                d="M50.16,143.9c-.09-.13-.16.1-.2.32-.16.8-.12,2.15.07,2.01.21-.16.32-1.99.14-2.33h0Z"
              />
              <path
                className="cls-107"
                d="M49.59,142.64c-.08.76-.15,1.53-.21,2.3.02.03.05.1.1-.06.14-.42.23-1.85.11-2.23h0Z"
              />
              <path
                className="cls-107"
                d="M51.11,141.44c-.13-.21-.26-.42-.38-.63-.12.93-.03,1.58.12,1.48.15-.09.26-.81.26-.85h0Z"
              />
              <path
                className="cls-107"
                d="M50.4,140.18c-.1-.21-.2-.42-.29-.63-.12.93-.06,1.57.06,1.48.12-.09.23-.82.23-.85h0Z"
              />
            </g>
            <g className="cls-564">
              <path
                className="cls-107"
                d="M49.99,158.42s-.08-.11-.12.11c-.04.22-.03.58-.03.73.12.21.25.42.38.64-.04-.87-.16-1.36-.23-1.47h0Z"
              />
              <path
                className="cls-107"
                d="M50.38,154.4c-.13-.15-.18.2-.2.42-.05.54,0,1.58.19,1.91,0-.2,0-.41,0-.61,0-.57,0-1.15.02-1.72h0Z"
              />
              <path
                className="cls-107"
                d="M49.61,153.13s-.07-.11-.12.12c-.13.64,0,2.4.17,2.24.17-.16.13-2.03-.05-2.36h0Z"
              />
              <path
                className="cls-107"
                d="M50.28,150.6c-.14-.21-.26-.42-.38-.64-.04.95.09,1.6.21,1.51.13-.09.18-.83.17-.87h0Z"
              />
              <path
                className="cls-107"
                d="M49.57,149.33c-.1-.21-.2-.42-.29-.63-.04.95.05,1.6.15,1.5.1-.09.15-.83.14-.87h0Z"
              />
            </g>
            <g className="cls-563">
              <path
                className="cls-107"
                d="M50.78,165.93c-.31-.53-.41-2.39-.22-2.32.02,0,.03.03.04.04.05.76.11,1.52.18,2.28h0Z"
              />
              <path
                className="cls-107"
                d="M50.22,160.01c0,.53-.05.84-.14.74-.08-.08-.21-.6-.25-1.49.12.21.25.42.38.64,0,.03,0,.08,0,.12h0Z"
              />
            </g>
            <g className="cls-562">
              <path
                className="cls-107"
                d="M94.09,63.47c.52-.38.89-.57.95-.48,0,.13-.32.47-.83.87-.04-.13-.08-.26-.12-.39h0Z"
              />
              <path
                className="cls-107"
                d="M93.93,62.7c.52-.38.88-.56.93-.47,0,.13-.35.46-.86.86-.03-.13-.05-.26-.06-.39h0Z"
              />
              <path
                className="cls-107"
                d="M97.47,60.17c-.29.2-.8.5-.85.39.61-.43,1.22-.85,1.84-1.26-.02.17-.62.62-1,.87h0Z"
              />
            </g>
            <g className="cls-555">
              <path
                className="cls-107"
                d="M88.07,68.62c-.06-.1-.42.1-.9.52.04.14.08.28.13.43.61-.55.8-.87.77-.95h0Z"
              />
              <path
                className="cls-107"
                d="M87.87,67.78c-.05-.1-.39.1-.87.52.02.14.04.28.07.42.62-.55.82-.86.8-.94h0Z"
              />
              <path
                className="cls-107"
                d="M91.64,66.14c-.07-.1-.44.1-.95.51-.38.31-.79.74-.79.9,0,0,0,.02,0,.02.57-.48,1.15-.96,1.73-1.44h0Z"
              />
              <path
                className="cls-107"
                d="M91.39,65.34c-.14-.25-1.62,1.05-1.73,1.36-.02.05-.02.13.17.05.5-.22,1.61-1.22,1.56-1.41h0Z"
              />
              <path
                className="cls-107"
                d="M91.26,64.54c-.59.46-1.17.93-1.74,1.4.09.24,1.59-1.04,1.73-1.34,0-.02.01-.04.01-.05h0Z"
              />
              <path
                className="cls-107"
                d="M94.21,63.86c-.04-.13-.08-.26-.12-.39-.7.54-.92.87-.8.9.02,0,.2.03.92-.51h0Z"
              />
              <path
                className="cls-107"
                d="M94,63.09c-.03-.13-.05-.26-.06-.39-.71.53-.94.86-.84.89.02,0,.18.03.9-.51h0Z"
              />
            </g>
            <g className="cls-553">
              <path
                className="cls-107"
                d="M81.56,74.73c-.06-.11-.4.11-.85.56.04.15.09.31.14.46.57-.6.73-.94.7-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M81.34,73.82c-.04-.11-.36.11-.81.56.02.15.05.31.08.46.57-.59.75-.93.74-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M84.91,72.05c-.19-.27-1.55,1.15-1.62,1.5,0,.02,0,.04,0,.06.53-.52,1.07-1.04,1.61-1.56h0Z"
              />
              <path
                className="cls-107"
                d="M84.63,71.17c-.14-.27-1.52,1.14-1.61,1.48-.03.11.05.12.21.02.51-.3,1.45-1.31,1.4-1.5h0Z"
              />
              <path
                className="cls-107"
                d="M84.49,70.3c-.55.5-1.09,1.01-1.62,1.52.08.24,1.37-.99,1.59-1.42.03-.05.03-.08.03-.1h0Z"
              />
              <path
                className="cls-107"
                d="M87.3,69.57c-.05-.14-.09-.28-.13-.43-.63.57-.9,1-.71.99.05,0,.26-.05.84-.56h0Z"
              />
              <path
                className="cls-107"
                d="M87.06,68.72c-.03-.14-.05-.28-.07-.42-.63.56-.92.98-.75.98.04,0,.24-.05.82-.55h0Z"
              />
            </g>
            <g className="cls-557">
              <path
                className="cls-107"
                d="M75.54,81.3c-.07-.12-.37.12-.79.6.05.16.1.33.15.49.52-.64.66-1.01.63-1.1h0Z"
              />
              <path
                className="cls-107"
                d="M75.31,80.32c-.04-.12-.34.12-.75.6.02.16.05.33.08.49.52-.63.69-1,.67-1.09h0Z"
              />
              <path
                className="cls-107"
                d="M78.65,78.42c-.19-.29-1.44,1.23-1.49,1.6,0,.02,0,.05,0,.07.49-.56.98-1.11,1.48-1.66h0Z"
              />
              <path
                className="cls-107"
                d="M78.36,77.48c-.12-.25-1.32,1.09-1.47,1.54-.03.07-.05.19.1.12.41-.18,1.43-1.42,1.37-1.66h0Z"
              />
              <path
                className="cls-107"
                d="M78.2,76.54c-.5.54-1,1.08-1.49,1.63.07.24,1.18-.95,1.44-1.47.05-.09.05-.12.05-.16h0Z"
              />
              <path
                className="cls-107"
                d="M80.85,75.75c-.05-.15-.1-.31-.14-.46-.58.61-.83,1.08-.65,1.07.05,0,.25-.05.79-.61h0Z"
              />
              <path
                className="cls-107"
                d="M80.6,74.83c-.03-.15-.06-.31-.08-.46-.58.6-.85,1.06-.69,1.06.03,0,.21-.04.77-.6h0Z"
              />
            </g>
            <g className="cls-554">
              <path
                className="cls-107"
                d="M70.06,88.29c-.07-.13-.34.12-.72.64.05.17.1.35.16.52.47-.68.59-1.07.56-1.16h0Z"
              />
              <path
                className="cls-107"
                d="M69.81,87.25c-.04-.12-.31.12-.69.63.02.17.05.35.09.52.47-.67.62-1.06.6-1.15h0Z"
              />
              <path
                className="cls-107"
                d="M72.91,85.24c-.17-.27-1.25,1.17-1.35,1.65-.01.06,0,.09,0,.12.44-.59.9-1.18,1.35-1.77h0Z"
              />
              <path
                className="cls-107"
                d="M72.6,84.23c-.11-.25-1.13,1.04-1.33,1.58-.06.17-.03.24.08.18.38-.19,1.31-1.52,1.25-1.77h0Z"
              />
              <path
                className="cls-107"
                d="M72.43,83.23c-.46.57-.91,1.15-1.36,1.74.06.21.86-.73,1.22-1.38.14-.25.14-.32.14-.36h0Z"
              />
              <path
                className="cls-107"
                d="M74.91,82.39c-.06-.16-.11-.33-.15-.49-.53.65-.75,1.15-.58,1.14.03,0,.22-.04.73-.65h0Z"
              />
              <path
                className="cls-107"
                d="M74.64,81.41c-.03-.16-.06-.33-.08-.49-.54.66-.78,1.14-.63,1.13.03,0,.2-.04.71-.64h0Z"
              />
            </g>
            <g className="cls-558">
              <path
                className="cls-107"
                d="M65.13,95.67c-.07-.13-.33.14-.66.68.05.18.11.37.17.55.42-.72.52-1.13.49-1.23h0Z"
              />
              <path
                className="cls-107"
                d="M64.87,94.58c-.04-.13-.29.14-.62.68.02.18.05.36.09.55.42-.72.55-1.12.53-1.22h0Z"
              />
              <path
                className="cls-107"
                d="M67.71,92.46c-.16-.26-1.07,1.11-1.2,1.68-.02.11-.02.14,0,.18.4-.63.8-1.25,1.21-1.86h0Z"
              />
              <path
                className="cls-107"
                d="M67.38,91.4c-.1-.24-.89.88-1.15,1.54-.1.25-.1.38,0,.34.32-.12,1.22-1.6,1.14-1.88h0Z"
              />
              <path
                className="cls-107"
                d="M67.2,90.34c-.41.61-.82,1.22-1.22,1.84.05.18.51-.42.81-.94.09-.16.4-.68.4-.9h0Z"
              />
              <path
                className="cls-107"
                d="M69.5,89.45c-.06-.17-.11-.35-.16-.52-.53.76-.65,1.22-.51,1.21.03,0,.21-.04.67-.68h0Z"
              />
              <path
                className="cls-107"
                d="M69.21,88.41c-.04-.17-.06-.35-.09-.52-.49.7-.7,1.21-.56,1.2.03,0,.18-.04.65-.68h0Z"
              />
            </g>
            <g className="cls-556">
              <path
                className="cls-107"
                d="M60.79,103.42c-.07-.14-.3.14-.58.7.05.19.11.38.18.57.36-.74.44-1.17.41-1.28h0Z"
              />
              <path
                className="cls-107"
                d="M60.52,102.28c-.05-.17-.34.32-.49.6-.02.03-.04.07-.05.1.02.19.06.38.09.57.36-.74.47-1.17.45-1.27h0Z"
              />
              <path
                className="cls-107"
                d="M63.08,100.06c-.15-.25-.85.93-1.03,1.63-.06.22-.04.28-.03.33.35-.65.7-1.31,1.06-1.95h0Z"
              />
              <path
                className="cls-107"
                d="M62.73,98.95c-.08-.2-.59.58-.89,1.28-.2.47-.24.75-.11.7.29-.13,1.08-1.68,1-1.97h0Z"
              />
              <path
                className="cls-107"
                d="M62.55,97.84c-.36.64-.72,1.28-1.07,1.93.04.16.32-.28.4-.41.28-.45.67-1.25.67-1.52h0Z"
              />
              <path
                className="cls-107"
                d="M64.64,96.9c-.06-.18-.12-.37-.17-.55-.47.8-.57,1.28-.43,1.27.03,0,.19-.05.6-.72h0Z"
              />
              <path
                className="cls-107"
                d="M64.34,95.8c-.04-.18-.07-.36-.09-.55-.44.73-.62,1.27-.49,1.26.15-.01.58-.71.58-.71h0Z"
              />
            </g>
            <g className="cls-552">
              <path
                className="cls-107"
                d="M57.07,111.51c-.07-.14-.26.15-.51.73.05.2.12.4.18.59.3-.77.36-1.22.32-1.33h0Z"
              />
              <path
                className="cls-107"
                d="M56.79,110.33s-.04-.13-.22.21c-.1.19-.19.4-.24.52.03.2.06.39.1.59.31-.77.39-1.21.37-1.32h0Z"
              />
              <path
                className="cls-107"
                d="M59.05,108.01c-.12-.22-.61.69-.83,1.44-.12.43-.09.55-.08.6.3-.68.6-1.36.91-2.03h0Z"
              />
              <path
                className="cls-107"
                d="M58.5,105.69c-.31.67-.62,1.34-.91,2.02,0,.03.02.1.15-.09.28-.41.76-1.59.76-1.92h0Z"
              />
              <path
                className="cls-107"
                d="M60.39,104.7c-.07-.19-.13-.38-.18-.57-.4.83-.51,1.41-.34,1.33.05-.02.2-.14.51-.75h0Z"
              />
              <path
                className="cls-107"
                d="M60.07,103.56c-.04-.19-.07-.38-.09-.57-.38.77-.53,1.34-.42,1.33.13-.01.51-.75.51-.76h0Z"
              />
            </g>
            <g className="cls-551">
              <path
                className="cls-107"
                d="M54,119.9c-.07-.15-.21.17-.29.37-.06.15-.1.27-.14.39.06.2.12.41.19.61.24-.8.27-1.26.24-1.37h0Z"
              />
              <path
                className="cls-107"
                d="M53.71,118.69s-.03-.09-.11.05c-.11.19-.23.58-.27.71.03.2.06.4.1.61.24-.8.3-1.26.28-1.37h0Z"
              />
              <path
                className="cls-107"
                d="M55.66,116.27c-.11-.21-.42.49-.59,1.08-.05.18-.22.78-.15,1.03.24-.71.49-1.41.75-2.11h0Z"
              />
              <path
                className="cls-107"
                d="M55.28,115.08c-.05-.12-.16.08-.26.28-.33.7-.61,1.88-.45,1.86.21-.02.8-1.81.71-2.14h0Z"
              />
              <path
                className="cls-107"
                d="M56.75,112.84c-.07-.2-.13-.4-.18-.59-.33.85-.41,1.45-.25,1.37.16-.08.44-.77.44-.78h0Z"
              />
              <path
                className="cls-107"
                d="M56.42,111.65c-.04-.2-.07-.39-.1-.59-.34.85-.45,1.44-.32,1.36.12-.07.41-.74.41-.77h0Z"
              />
            </g>
            <g className="cls-550">
              <path
                className="cls-107"
                d="M51.61,128.57s-.05-.13-.16.16c-.08.21-.15.5-.18.63.06.21.12.42.19.62.18-.82.18-1.3.15-1.41h0Z"
              />
              <path
                className="cls-107"
                d="M51.31,127.33s0-.03-.02-.04c0,0,0,0-.01,0-.04.03-.12.2-.27.83.03.21.06.41.1.62.18-.82.21-1.29.19-1.41h0Z"
              />
              <path
                className="cls-107"
                d="M52.93,124.82c-.09-.18-.26.31-.31.47-.17.51-.35,1.41-.26,1.71.18-.73.38-1.45.57-2.18h0Z"
              />
              <path
                className="cls-107"
                d="M52.55,123.59s-.04-.11-.14.1c-.26.56-.57,2.14-.41,2.11.18-.03.63-1.87.54-2.21h0Z"
              />
              <path
                className="cls-107"
                d="M52.34,122.37c-.2.72-.39,1.44-.58,2.16,0,.01,0,.03.01.04.16-.04.58-1.82.57-2.2h0Z"
              />
              <path
                className="cls-107"
                d="M53.76,121.27c-.07-.2-.13-.41-.19-.61-.27.88-.31,1.5-.17,1.41.14-.08.36-.8.36-.8h0Z"
              />
              <path
                className="cls-107"
                d="M53.43,120.06c-.04-.2-.07-.4-.1-.61-.27.88-.35,1.49-.24,1.41.11-.08.33-.76.34-.8h0Z"
              />
            </g>
            <g className="cls-549">
              <path
                className="cls-107"
                d="M49.93,137.48s-.03-.09-.08.02c-.05.12-.11.39-.17.8.06.21.12.42.2.63.11-.85.09-1.33.05-1.44h0Z"
              />
              <path
                className="cls-107"
                d="M50.89,133.61s-.06-.13-.17.17c-.16.47-.34,1.7-.23,2.08.12-.75.26-1.5.4-2.24h0Z"
              />
              <path
                className="cls-107"
                d="M50.51,132.36s-.03-.08-.08.02c-.2.41-.44,2.29-.29,2.27.14-.03.45-1.95.37-2.28h0Z"
              />
              <path
                className="cls-107"
                d="M51.46,129.98c-.07-.21-.14-.42-.19-.62-.19.91-.21,1.54-.09,1.45.11-.09.28-.79.28-.83h0Z"
              />
              <path
                className="cls-107"
                d="M51.12,128.74c-.04-.21-.08-.41-.1-.62-.16.73-.24,1.36-.18,1.45,0,0,0,0,.01,0,.1-.07.27-.83.27-.83h0Z"
              />
            </g>
            <g className="cls-575">
              <path
                className="cls-107"
                d="M49.37,144.94c-.17-.53.04-2.41.18-2.34.01,0,.02.03.03.04-.08.76-.15,1.53-.21,2.3h0Z"
              />
              <path
                className="cls-107"
                d="M49.86,139.03c-.08.52-.17.82-.22.73-.05-.08-.07-.6.04-1.47.06.21.12.42.2.63,0,.03-.01.08-.02.11h0Z"
              />
            </g>
            <g className="cls-577">
              <path
                className="cls-107"
                d="M101.27,56.94c.55-.34.92-.5.95-.42-.03.11-.39.41-.94.76,0-.11,0-.23,0-.34h0Z"
              />
              <path
                className="cls-107"
                d="M101.32,56.25c.5-.3.86-.46.92-.42,0,0,0,0,0,.01-.04.11-.41.4-.97.75,0-.11.02-.23.04-.34h0Z"
              />
            </g>
            <g className="cls-560">
              <path
                className="cls-107"
                d="M94.78,61.47c-.03-.09-.38.09-.9.46,0,.13,0,.26,0,.38.66-.5.89-.78.89-.85h0Z"
              />
              <path
                className="cls-107"
                d="M94.82,60.71c-.01-.09-.36.09-.87.45-.02.13-.03.26-.05.38.66-.49.91-.77.92-.84h0Z"
              />
              <path
                className="cls-107"
                d="M98.47,59.29c-.04-.09-.41.09-.94.44-.4.27-.86.66-.9.8,0,0,0,.02,0,.02.61-.43,1.22-.85,1.84-1.26h0Z"
              />
              <path
                className="cls-107"
                d="M98.45,58.57c-.06-.22-1.65.91-1.82,1.19-.04.06-.02.09.05.07.36-.07,1.77-1.08,1.77-1.26h0Z"
              />
              <path
                className="cls-107"
                d="M98.53,57.86c-.62.4-1.23.81-1.84,1.22,0,0,0,.01,0,.02.13.1,1.74-.98,1.84-1.24h0Z"
              />
              <path
                className="cls-107"
                d="M101.27,57.29c0-.11,0-.23,0-.34-.75.47-1.02.76-.92.79.02,0,.18.02.93-.45h0Z"
              />
              <path
                className="cls-107"
                d="M101.28,56.6c0-.11.02-.23.04-.34-.75.46-1.03.75-.95.78.02,0,.16.02.91-.44h0Z"
              />
            </g>
            <g className="cls-561">
              <path
                className="cls-107"
                d="M87.79,66.94c-.03-.1-.36.1-.84.51,0,.14,0,.28.01.42.62-.54.84-.85.83-.93h0Z"
              />
              <path
                className="cls-107"
                d="M87.83,66.11c-.01-.1-.33.09-.81.5-.02.14-.04.28-.05.42.62-.54.86-.84.86-.92h0Z"
              />
              <path
                className="cls-107"
                d="M91.26,64.54c-.09-.25-1.59,1.03-1.73,1.34,0,.02-.01.04-.01.06.58-.47,1.16-.94,1.74-1.4h0Z"
              />
              <path
                className="cls-107"
                d="M91.24,63.74c-.05-.23-1.44.89-1.7,1.29-.06.09-.05.14.02.12.34-.08,1.68-1.2,1.68-1.4h0Z"
              />
              <path
                className="cls-107"
                d="M91.33,62.94c-.58.45-1.16.9-1.74,1.36,0,.19,1.13-.67,1.57-1.13.14-.15.16-.2.17-.23h0Z"
              />
              <path
                className="cls-107"
                d="M93.89,62.32c0-.13-.01-.26,0-.38-.71.53-.96.85-.87.88.01,0,.16.03.88-.5h0Z"
              />
              <path
                className="cls-107"
                d="M93.9,61.55c.01-.13.03-.26.05-.38-.71.52-.98.84-.9.87.02,0,.15.02.86-.49h0Z"
              />
            </g>
            <g className="cls-559">
              <path
                className="cls-107"
                d="M81.25,72.91c-.03-.11-.33.11-.78.55,0,.15,0,.3.01.46.57-.59.78-.92.77-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M81.3,72c0-.11-.3.1-.75.54-.02.15-.04.3-.05.46.62-.63.8-.93.8-1h0Z"
              />
              <path
                className="cls-107"
                d="M84.49,70.3c-.08-.24-1.39,1-1.59,1.42-.03.05-.03.08-.03.1.54-.51,1.08-1.02,1.62-1.52h0Z"
              />
              <path
                className="cls-107"
                d="M84.47,69.43c-.04-.21-1.15.79-1.52,1.31-.11.15-.13.23-.07.23.25,0,1.59-1.3,1.59-1.54h0Z"
              />
              <path
                className="cls-107"
                d="M84.57,68.56c-.55.49-1.09.99-1.62,1.49,0,.15.59-.34,1.01-.76.13-.13.55-.55.61-.73h0Z"
              />
              <path
                className="cls-107"
                d="M86.95,67.87c0-.14-.01-.28-.01-.42-.69.61-.93.97-.79.97.03,0,.2-.03.8-.55h0Z"
              />
              <path
                className="cls-107"
                d="M86.96,67.03c.01-.14.03-.28.05-.42-.63.54-.97.96-.83.96.03,0,.19-.04.78-.54h0Z"
              />
            </g>
            <g className="cls-574">
              <path
                className="cls-107"
                d="M75.22,79.35c-.02-.12-.3.11-.72.59,0,.16,0,.33.01.49.53-.63.71-.99.71-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M75.26,78.37c0-.14-.36.23-.47.35-.07.08-.14.16-.21.24-.02.16-.04.33-.06.49.57-.67.73-1,.74-1.07h0Z"
              />
              <path
                className="cls-107"
                d="M78.2,76.54c-.07-.23-1.1.85-1.41,1.42-.07.13-.08.18-.08.21.49-.55.99-1.09,1.49-1.63h0Z"
              />
              <path
                className="cls-107"
                d="M78.18,75.6c-.03-.18-.77.54-1.21,1.14-.23.31-.33.51-.25.51.23,0,1.46-1.39,1.46-1.65h0Z"
              />
              <path
                className="cls-107"
                d="M78.29,74.66c-.5.53-1,1.06-1.49,1.6,0,0,0,.02,0,.03.17.04,1.39-1.3,1.48-1.63h0Z"
              />
              <path
                className="cls-107"
                d="M80.48,73.92c0-.15-.01-.31-.01-.46-.64.66-.86,1.05-.74,1.05.03,0,.19-.03.75-.59h0Z"
              />
              <path
                className="cls-107"
                d="M80.49,73c.01-.15.03-.3.05-.46-.59.6-.9,1.04-.78,1.04.13,0,.71-.55.72-.58h0Z"
              />
            </g>
            <g className="cls-573">
              <path
                className="cls-107"
                d="M69.71,86.22c-.02-.13-.27.11-.65.63,0,.17,0,.35.01.52.48-.67.64-1.05.64-1.15h0Z"
              />
              <path
                className="cls-107"
                d="M72.43,83.23c-.06-.21-.87.74-1.22,1.38-.13.25-.14.32-.14.36.45-.58.9-1.16,1.36-1.74h0Z"
              />
              <path
                className="cls-107"
                d="M72.41,82.22c-.02-.15-.41.28-.67.61-.45.57-.79,1.16-.66,1.15.21,0,1.33-1.48,1.33-1.76h0Z"
              />
              <path
                className="cls-107"
                d="M74.51,80.43c0-.16-.01-.33-.01-.49-.59.7-.79,1.13-.67,1.12.15,0,.68-.63.68-.63h0Z"
              />
              <path
                className="cls-107"
                d="M74.52,79.44c.01-.16.03-.33.06-.49-.54.64-.83,1.12-.72,1.11.12,0,.66-.62.66-.63h0Z"
              />
            </g>
            <g className="cls-578">
              <path
                className="cls-107"
                d="M65.98,92.17c0-.45,1.07-1.94,1.2-1.87.01,0,.01.02.02.04-.41.61-.82,1.22-1.22,1.84h0Z"
              />
              <path
                className="cls-107"
                d="M69.01,87.46c-.33.44-.58.67-.59.54,0-.1.16-.49.64-1.15,0,.17,0,.35.01.52-.02.03-.05.06-.07.09h0Z"
              />
            </g>
            <g className="cls-576">
              <path
                className="cls-107"
                d="M61.48,99.77c0-.47.93-2.04,1.05-1.97.01,0,.01.03.02.04-.36.64-.72,1.28-1.07,1.93h0Z"
              />
            </g>
            <g className="cls-572">
              <path
                className="cls-107"
                d="M57.58,107.71c0-.49.79-2.13.9-2.05.01,0,.01.03.01.04-.31.67-.62,1.34-.91,2.02h0Z"
              />
            </g>
            <g className="cls-612">
              <path
                className="cls-107"
                d="M51.76,124.53c-.02-.42.41-2.11.56-2.21.01.01.02.03.02.04-.2.72-.39,1.44-.58,2.16h0Z"
              />
            </g>
            <g className="cls-616">
              <path
                className="cls-107"
                d="M94.96,59.96c0-.09-.33.08-.84.44-.04.13-.07.25-.1.38.66-.48.93-.76.94-.83h0Z"
              />
              <path
                className="cls-107"
                d="M95.21,59.2s0-.02,0-.02c-.04,0-.19.03-.81.46-.06.13-.11.25-.15.38.66-.48.94-.75.97-.82h0Z"
              />
              <path
                className="cls-107"
                d="M98.53,57.86s0-.01,0-.02c-.14-.11-1.74.96-1.84,1.24.61-.41,1.22-.82,1.84-1.22h0Z"
              />
              <path
                className="cls-107"
                d="M98.72,57.14s0-.01,0-.02c-.1-.12-1.82,1.03-1.84,1.23.1.1,1.78-1.01,1.84-1.22h0Z"
              />
              <path
                className="cls-107"
                d="M99.01,56.43c-.61.39-1.22.78-1.83,1.18,0,0,0,.01,0,.02,0,0,0,0,0,0,.17.03,1.67-.96,1.83-1.21h0Z"
              />
            </g>
            <g className="cls-618">
              <path
                className="cls-107"
                d="M87.98,65.28c0-.1-.3.09-.78.49-.04.14-.08.28-.11.42.62-.53.87-.84.89-.91h0Z"
              />
              <path
                className="cls-107"
                d="M88.26,64.45s0-.02,0-.03c-.03,0-.17.03-.75.51-.06.14-.12.28-.17.42.62-.53.89-.83.92-.9h0Z"
              />
              <path
                className="cls-107"
                d="M91.33,62.94c0-.18-1.11.64-1.57,1.13-.14.15-.16.2-.17.23.58-.46,1.15-.91,1.74-1.36h0Z"
              />
              <path
                className="cls-107"
                d="M91.54,62.15s0-.02,0-.03c-.2-.04-1.81,1.27-1.73,1.39.21.04,1.68-1.2,1.73-1.37h0Z"
              />
              <path
                className="cls-107"
                d="M91.85,61.36c-.58.44-1.16.88-1.73,1.32,0,0,0,.02,0,.03.15.03,1.57-1.08,1.73-1.35h0Z"
              />
              <path
                className="cls-107"
                d="M94.02,60.78c.03-.13.06-.25.1-.38-.71.51-1,.83-.93.86.1.05.83-.47.83-.48h0Z"
              />
              <path
                className="cls-107"
                d="M94.25,60.02c.05-.13.1-.25.15-.38-.58.41-1,.79-.96.85.12.02.81-.47.81-.47h0Z"
              />
            </g>
            <g className="cls-617">
              <path
                className="cls-107"
                d="M81.47,71.1s0-.02,0-.03c-.04,0-.18.05-.71.57-.04.15-.08.3-.12.45.58-.58.82-.91.83-.99h0Z"
              />
              <path
                className="cls-107"
                d="M81.76,70.2s0-.02,0-.03c-.03,0-.16.05-.68.56-.07.15-.13.3-.18.45.62-.62.84-.91.86-.98h0Z"
              />
              <path
                className="cls-107"
                d="M84.57,68.56c0-.15-.6.33-1.09.82-.14.15-.48.5-.54.66.54-.5,1.08-1,1.62-1.49h0Z"
              />
              <path
                className="cls-107"
                d="M84.8,67.69s0-.02,0-.03c-.17-.04-1.68,1.39-1.61,1.53.18.04,1.56-1.31,1.61-1.5h0Z"
              />
              <path
                className="cls-107"
                d="M85.14,66.83c-.54.48-1.08.96-1.61,1.45,0,0,0,.02,0,.03.12.03,1.45-1.18,1.61-1.48h0Z"
              />
              <path
                className="cls-107"
                d="M87.09,66.19c.03-.14.07-.28.11-.42-.63.54-.98.95-.87.95.13,0,.76-.52.76-.53h0Z"
              />
              <path
                className="cls-107"
                d="M87.34,65.35c.05-.14.11-.28.17-.42-.54.46-.94.87-.92.94.1.02.75-.51.75-.52h0Z"
              />
            </g>
            <g className="cls-614">
              <path
                className="cls-107"
                d="M75.45,77.41s0-.02,0-.03c-.03-.01-.16.06-.65.61-.05.16-.09.32-.13.49.53-.62.75-.97.77-1.06h0Z"
              />
              <path
                className="cls-107"
                d="M75.77,76.44s0-.02,0-.03c-.02,0-.14.06-.62.6-.07.16-.14.32-.19.48.57-.66.78-.98.81-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M78.29,74.66s0-.02,0-.03c-.18-.03-1.38,1.29-1.48,1.63.49-.54.99-1.07,1.49-1.6h0Z"
              />
              <path
                className="cls-107"
                d="M78.53,73.73s0-.02,0-.03c-.14-.04-1.53,1.5-1.49,1.64.15.05,1.42-1.41,1.49-1.61h0Z"
              />
              <path
                className="cls-107"
                d="M78.91,72.8c-.5.52-.99,1.04-1.48,1.56,0,0,0,.02,0,.03.09.04,1.31-1.27,1.49-1.6h0Z"
              />
              <path
                className="cls-107"
                d="M80.63,72.09c.03-.15.07-.3.12-.45-.51.51-.87.95-.83,1.03.12.02.71-.57.71-.57h0Z"
              />
              <path
                className="cls-107"
                d="M80.9,71.18c.06-.15.12-.3.18-.45-.5.5-.88.94-.87,1.02.09.03.68-.56.68-.57h0Z"
              />
            </g>
            <g className="cls-610">
              <path
                className="cls-107"
                d="M74.6,78.55c-.11.13-.49.55-.57.53-.03-.08.3-.55.77-1.1-.05.16-.09.32-.13.49-.02.02-.05.06-.07.08h0Z"
              />
              <path
                className="cls-107"
                d="M74.89,77.58c-.11.13-.49.55-.55.53,0-.08.35-.56.81-1.09-.07.16-.14.32-.19.48-.02.02-.05.06-.07.08h0Z"
              />
            </g>
            <g className="cls-609">
              <path
                className="cls-107"
                d="M94.78,58.89c.44-.3.72-.47.78-.45,0,0,0,.02,0,.03-.08.12-.46.43-.99.8.06-.13.13-.25.21-.38h0Z"
              />
              <path
                className="cls-107"
                d="M97.18,57.61c.16-.26,1.65-1.24,1.83-1.21,0,0,0,0,0,0,0,0,0,.01,0,.01-.61.39-1.22.78-1.83,1.18h0Z"
              />
            </g>
            <g className="cls-611">
              <path
                className="cls-107"
                d="M88.65,63.63s0-.02,0-.03c-.05-.02-.31.17-.72.5-.08.14-.16.28-.23.41.62-.52.9-.82.94-.89h0Z"
              />
              <path
                className="cls-107"
                d="M89.15,62.81s.01-.02.01-.03c-.02,0-.12.03-.69.5-.1.14-.19.27-.28.41.62-.51.92-.81.97-.88h0Z"
              />
              <path
                className="cls-107"
                d="M91.85,61.36s0-.02,0-.03c-.15-.03-1.56,1.06-1.73,1.35.57-.45,1.15-.89,1.73-1.32h0Z"
              />
              <path
                className="cls-107"
                d="M92.28,60.58s0-.02,0-.03c-.12-.04-1.74,1.23-1.73,1.36.14.04,1.62-1.16,1.72-1.33h0Z"
              />
              <path
                className="cls-107"
                d="M92.82,59.81c-.57.42-1.14.85-1.7,1.29,0,0-.01.02-.01.03.15,0,1.53-1.09,1.72-1.31h0Z"
              />
              <path
                className="cls-107"
                d="M94.58,59.26c.06-.13.13-.25.21-.38-.58.41-1.01.78-.99.84.1.02.78-.46.78-.46h0Z"
              />
            </g>
            <g className="cls-613">
              <path
                className="cls-107"
                d="M82.19,69.31s0-.02,0-.03c-.02-.01-.13.05-.66.55-.09.15-.17.3-.24.45.62-.61.85-.9.89-.97h0Z"
              />
              <path
                className="cls-107"
                d="M82.73,68.43s.01-.02.02-.03c0,0,0,0,0,0-.04.01-.18.12-.62.55-.11.15-.21.3-.31.45.62-.61.87-.89.92-.96h0Z"
              />
              <path
                className="cls-107"
                d="M85.14,66.83s0-.02,0-.03c-.13-.03-1.44,1.17-1.61,1.48.53-.49,1.07-.97,1.61-1.45h0Z"
              />
              <path
                className="cls-107"
                d="M85.61,65.98s0-.02.01-.03c-.2.01-1.61,1.4-1.62,1.49.17-.01,1.52-1.31,1.61-1.46h0Z"
              />
              <path
                className="cls-107"
                d="M86.19,65.13c-.53.47-1.06.94-1.59,1.42,0,0-.01.02-.02.03.11,0,1.4-1.2,1.61-1.45h0Z"
              />
              <path
                className="cls-107"
                d="M87.7,64.52c.07-.14.15-.28.23-.41-.54.45-.96.86-.95.92.08.02.72-.51.72-.51h0Z"
              />
              <path
                className="cls-107"
                d="M88.18,63.69c.09-.14.18-.27.28-.41-.54.44-.96.85-.98.91.06.03.69-.5.69-.5h0Z"
              />
            </g>
            <g className="cls-615">
              <path
                className="cls-107"
                d="M76.22,75.49s.01-.02.01-.03c0,0,0,0,0,0-.04.02-.17.13-.58.6-.09.16-.18.32-.26.48.57-.66.8-.97.84-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M76.81,74.54s.01-.02.02-.03c-.01,0-.04,0-.55.59-.12.16-.23.32-.33.48.57-.66.82-.97.87-1.04h0Z"
              />
              <path
                className="cls-107"
                d="M78.91,72.8s0-.02,0-.03c-.1-.04-1.31,1.26-1.49,1.6.49-.53.98-1.05,1.48-1.56h0Z"
              />
              <path
                className="cls-107"
                d="M79.41,71.88s.01-.02.01-.03c-.14.01-1.47,1.51-1.5,1.61.12-.01,1.39-1.42,1.48-1.58h0Z"
              />
              <path
                className="cls-107"
                d="M80.04,70.96c-.49.51-.98,1.02-1.46,1.53,0,0-.02.02-.02.03.06,0,1.28-1.31,1.48-1.56h0Z"
              />
              <path
                className="cls-107"
                d="M81.3,70.28c.08-.15.16-.3.24-.45-.5.49-.9.93-.9,1.01.06.02.65-.55.66-.56h0Z"
              />
              <path
                className="cls-107"
                d="M81.82,69.39c.1-.15.2-.3.31-.45-.5.48-.91.92-.93,1,0,0,0,0,0,0,.09-.04.62-.55.62-.55h0Z"
              />
            </g>
            <g className="cls-598">
              <path
                className="cls-107"
                d="M72.83,79.42c-.19.23-.42.51-.46.54.03-.14,1.29-1.69,1.37-1.74,0,.01,0,.03-.02.04-.14.22-.62.83-.89,1.16h0Z"
              />
              <path
                className="cls-107"
                d="M73.47,78.43c-.14.18-.28.36-.43.53,0-.01.01-.02.02-.03.44-.55.88-1.1,1.33-1.65-.18.23-.84,1.06-.92,1.15h0Z"
              />
              <path
                className="cls-107"
                d="M75.31,76.61c-.16.18-.44.49-.51.52,0,0,0,0,0,0,.02-.08.39-.55.85-1.08-.09.16-.18.32-.26.48-.02.02-.05.06-.07.08h0Z"
              />
              <path
                className="cls-107"
                d="M75.87,75.65c-.19.22-.44.49-.48.52.02-.06.46-.6.88-1.08-.12.16-.23.32-.33.48-.02.02-.05.06-.07.08h0Z"
              />
            </g>
            <g className="cls-592">
              <path
                className="cls-107"
                d="M89.12,62.46c.47-.38.62-.48.66-.49,0,0,0,0,0,0,0,0-.01.02-.02.03-.14.16-.6.55-.99.87.11-.14.22-.27.34-.41h0Z"
              />
              <path
                className="cls-107"
                d="M91.11,61.09c.23-.27,1.52-1.27,1.71-1.31,0,0,0,0,0,.01,0,0,0,.01-.01.02-.57.42-1.14.85-1.7,1.29h0Z"
              />
            </g>
            <g className="cls-597">
              <path
                className="cls-107"
                d="M82.83,68.06c.46-.44.57-.53.59-.54,0,.01-.01.02-.02.03-.18.21-.77.78-.94.95.12-.15.24-.29.37-.44h0Z"
              />
              <path
                className="cls-107"
                d="M83.66,67.18c.47-.45.55-.52.56-.53,0,.01-.02.02-.03.03-.32.32-.64.63-.96.94.14-.15.28-.29.43-.44h0Z"
              />
              <path
                className="cls-107"
                d="M84.6,66.55c.24-.3,1.46-1.4,1.6-1.45,0,0,0,.02-.01.03-.53.47-1.06.94-1.59,1.42h0Z"
              />
              <path
                className="cls-107"
                d="M88.7,62.94c-.19.15-.51.41-.58.43,0-.05.51-.5,1-.91-.12.14-.23.27-.34.41-.02.02-.06.05-.08.07h0Z"
              />
            </g>
            <g className="cls-593">
              <path
                className="cls-107"
                d="M77.03,74.15c.43-.5.51-.58.52-.59,0,.01-.02.02-.03.03-.29.35-.59.68-.89,1.02.13-.16.26-.31.39-.47h0Z"
              />
              <path
                className="cls-107"
                d="M78.58,72.5c.26-.34,1.37-1.51,1.48-1.57,0,.01-.01.02-.02.03-.49.51-.98,1.02-1.46,1.53h0Z"
              />
              <path
                className="cls-107"
                d="M79.79,71.12c-.16.16-.31.33-.47.49.05-.07,1.32-1.41,1.49-1.58,0,0-.02.02-.02.03-.33.36-.67.71-1,1.06h0Z"
              />
              <path
                className="cls-107"
                d="M82.38,68.57c-.21.2-.47.45-.52.47.02-.06.52-.56.96-.99-.13.15-.25.29-.37.44-.02.02-.05.05-.08.07h0Z"
              />
              <path
                className="cls-107"
                d="M83.15,67.69c-.16.16-.32.32-.49.47.04-.05.46-.46,1-.98-.15.15-.29.29-.43.44-.02.02-.05.05-.08.07h0Z"
              />
            </g>
            <g className="cls-590">
              <path
                className="cls-107"
                d="M73.06,78.93c.27-.36,1.19-1.51,1.35-1.68,0,0-.01.02-.02.03-.45.55-.89,1.09-1.33,1.65h0Z"
              />
              <path
                className="cls-107"
                d="M76.56,74.7c-.15.17-.29.35-.46.51.04-.05.42-.49.92-1.07-.14.16-.27.31-.39.47-.02.02-.05.06-.07.08h0Z"
              />
            </g>
          </g>
          <g className="cls-594">
            <g className="cls-596">
              <path
                className="cls-107"
                d="M151.17,63.59c-.18.5-.36,1-.54,1.51.61,0,1.03-1.12.7-1.44-.06-.06-.11-.06-.16-.07h0Z"
              />
            </g>
            <g className="cls-591">
              <path
                className="cls-107"
                d="M149.21,73.21c-.35,0-.67.31-.83.8.4.03.79.06,1.19.09.15-.67-.17-.87-.36-.88h0Z"
              />
              <path
                className="cls-107"
                d="M151.26,69.98c-.66,0-1.05,1.12-.69,1.52.36.38,1.03-.2,1.07-.92.02-.35-.14-.59-.38-.6h0Z"
              />
              <path
                className="cls-107"
                d="M149.06,69.83c-.17.54-.34,1.08-.51,1.63.7,0,1.11-1.2.7-1.55-.07-.06-.13-.07-.19-.08h0Z"
              />
            </g>
            <g className="cls-595">
              <path
                className="cls-107"
                d="M147.05,76.54c-.16.58-.32,1.16-.48,1.74.73,0,1.16-1.19.75-1.62-.1-.1-.2-.12-.27-.13h0Z"
              />
              <path
                className="cls-107"
                d="M149.58,74.09c-.4-.03-.79-.06-1.19-.09-.19.77.27,1.04.68.81.16-.09.38-.29.51-.73h0Z"
              />
            </g>
            <g className="cls-589">
              <path
                className="cls-107"
                d="M145.16,83.67c-.15.61-.31,1.23-.46,1.85.8,0,1.22-1.26.76-1.72-.11-.11-.23-.13-.3-.14h0Z"
              />
            </g>
            <g className="cls-644">
              <path
                className="cls-107"
                d="M149.69,60.43c-.26,0-.56.26-.77.67.29.03.58.06.87.08.2-.49.09-.74-.11-.76h0Z"
              />
            </g>
            <g className="cls-645">
              <path
                className="cls-107"
                d="M149.09,66.56c-.31,0-.61.28-.8.74.34.03.69.06,1.03.09.18-.57-.04-.81-.23-.82h0Z"
              />
              <path
                className="cls-107"
                d="M147.08,66.38c-.3,0-.62.28-.83.73.34.03.68.07,1.02.1.22-.62-.03-.81-.2-.83h0Z"
              />
              <path
                className="cls-107"
                d="M151.17,63.59c-.61,0-1.04,1.12-.7,1.44.06.06.11.07.17.08.18-.51.36-1.01.54-1.51h0Z"
              />
              <path
                className="cls-107"
                d="M149.3,63.43c-.58,0-1.08,1.11-.78,1.43.3.31,1-.36,1.03-1,.01-.25-.08-.41-.25-.43h0Z"
              />
              <path
                className="cls-107"
                d="M147.45,63.25c-.23.49-.46.99-.69,1.5.6.01,1.14-1.09.84-1.42-.05-.06-.1-.07-.15-.08h0Z"
              />
              <path
                className="cls-107"
                d="M149.8,61.18c-.29-.03-.58-.05-.87-.08-.27.61-.04.85.25.75.08-.03.38-.16.62-.67h0Z"
              />
            </g>
            <g className="cls-641">
              <path
                className="cls-107"
                d="M146.89,73.03c-.35,0-.68.3-.85.79.39.03.78.07,1.18.1.17-.62-.1-.87-.32-.89h0Z"
              />
              <path
                className="cls-107"
                d="M144.58,72.82c-.34,0-.69.3-.88.78.39.04.78.07,1.17.11.19-.62-.06-.87-.28-.89h0Z"
              />
              <path
                className="cls-107"
                d="M149.06,69.83c-.7,0-1.11,1.2-.71,1.55.07.06.13.07.2.08.17-.55.34-1.09.51-1.63h0Z"
              />
              <path
                className="cls-107"
                d="M146.89,69.65c-.67-.01-1.15,1.2-.78,1.54.37.34,1.12-.38,1.11-1.08,0-.27-.13-.44-.33-.46h0Z"
              />
              <path
                className="cls-107"
                d="M144.74,69.44c-.22.54-.44,1.08-.66,1.62.69.02,1.21-1.18.84-1.54-.06-.06-.12-.07-.18-.08h0Z"
              />
              <path
                className="cls-107"
                d="M149.33,67.38c-.34-.03-.69-.06-1.03-.09-.24.7.12.94.46.79.14-.06.39-.24.57-.7h0Z"
              />
              <path
                className="cls-107"
                d="M147.27,67.21c-.34-.03-.68-.06-1.02-.1-.25.65.03.96.42.79.14-.06.4-.23.6-.7h0Z"
              />
            </g>
            <g className="cls-636">
              <path
                className="cls-107"
                d="M144.79,79.95c-.39,0-.74.32-.91.84.44.04.87.07,1.31.11.15-.66-.16-.93-.4-.95h0Z"
              />
              <path
                className="cls-107"
                d="M142.21,79.72c-.38,0-.75.32-.93.83.43.04.87.08,1.3.12.18-.66-.12-.93-.37-.95h0Z"
              />
              <path
                className="cls-107"
                d="M147.05,76.54c-.72,0-1.16,1.18-.76,1.61.1.1.21.12.27.13.16-.59.32-1.17.48-1.74h0Z"
              />
              <path
                className="cls-107"
                d="M144.6,76.33c-.72-.01-1.21,1.17-.82,1.61.38.42,1.15-.18,1.22-.95.03-.37-.13-.63-.39-.66h0Z"
              />
              <path
                className="cls-107"
                d="M142.17,76.1c-.21.57-.42,1.15-.62,1.73.72.02,1.24-1.16.87-1.6-.09-.1-.19-.12-.25-.13h0Z"
              />
              <path
                className="cls-107"
                d="M147.21,73.92c-.39-.03-.78-.06-1.18-.1-.22.77.22,1.05.64.82.17-.09.39-.29.54-.72h0Z"
              />
              <path
                className="cls-107"
                d="M144.86,73.71c-.39-.04-.78-.07-1.17-.11-.26.77.18,1.05.6.83.17-.09.4-.29.57-.71h0Z"
              />
            </g>
            <g className="cls-640">
              <path
                className="cls-107"
                d="M142.82,87.27c-.43,0-.79.33-.96.88.48.04.96.08,1.44.12.14-.69-.21-.98-.48-1h0Z"
              />
              <path
                className="cls-107"
                d="M139.98,87.02c-.42-.01-.8.33-.98.87.48.05.95.09,1.43.14.16-.69-.18-.98-.45-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M145.16,83.67c-.8,0-1.23,1.26-.76,1.71.11.11.23.13.31.14.15-.62.3-1.24.46-1.85h0Z"
              />
              <path
                className="cls-107"
                d="M142.43,83.44c-.8-.02-1.27,1.24-.82,1.71.43.45,1.26-.19,1.29-1,.02-.39-.18-.68-.47-.71h0Z"
              />
              <path
                className="cls-107"
                d="M139.73,83.18c-.2.61-.39,1.22-.59,1.84.78.03,1.3-1.23.87-1.7-.1-.11-.22-.13-.29-.14h0Z"
              />
              <path
                className="cls-107"
                d="M145.2,80.89c-.44-.04-.88-.07-1.31-.11-.21.82.31,1.11.75.87.18-.1.42-.31.56-.76h0Z"
              />
              <path
                className="cls-107"
                d="M142.58,80.67c-.44-.04-.87-.08-1.3-.12-.22.76.21,1.14.71.88.18-.1.43-.3.59-.76h0Z"
              />
            </g>
            <g className="cls-638">
              <path
                className="cls-107"
                d="M140.98,94.97c-.46,0-.85.34-1,.92.52.04,1.04.09,1.56.13.14-.78-.31-1.03-.56-1.05h0Z"
              />
              <path
                className="cls-107"
                d="M137.89,94.7c-.46-.01-.85.33-1.02.91.52.05,1.03.1,1.55.15.16-.78-.28-1.03-.53-1.06h0Z"
              />
              <path
                className="cls-107"
                d="M140.4,90.95c-.86-.02-1.33,1.3-.82,1.79.49.48,1.36-.19,1.36-1.05,0-.41-.22-.71-.54-.74h0Z"
              />
              <path
                className="cls-107"
                d="M137.45,90.67c-.18.64-.37,1.29-.55,1.93.85.03,1.35-1.29.87-1.78-.12-.12-.24-.14-.32-.15h0Z"
              />
              <path
                className="cls-107"
                d="M143.3,88.27c-.48-.04-.96-.08-1.44-.12-.2.9.44,1.2.93.88.24-.16.41-.42.51-.76h0Z"
              />
              <path
                className="cls-107"
                d="M140.43,88.03c-.48-.04-.96-.09-1.43-.14-.21.84.35,1.24.9.89.25-.16.43-.41.53-.75h0Z"
              />
            </g>
            <g className="cls-637">
              <path
                className="cls-107"
                d="M135.33,98.51c-.17.67-.34,1.34-.5,2.01.92.03,1.39-1.33.85-1.85-.13-.12-.27-.15-.35-.16h0Z"
              />
              <path
                className="cls-107"
                d="M141.54,96.02c-.52-.04-1.04-.09-1.56-.13-.18.94.52,1.26,1.04.92.26-.17.43-.43.52-.79h0Z"
              />
              <path
                className="cls-107"
                d="M138.42,95.76c-.52-.05-1.04-.1-1.55-.15-.19.88.43,1.3,1.01.93.26-.16.44-.43.55-.79h0Z"
              />
            </g>
            <g className="cls-643">
              <path
                className="cls-107"
                d="M148.01,60.26c-.25,0-.57.26-.8.67.28.03.57.06.86.09.25-.52.1-.74-.06-.76h0Z"
              />
            </g>
            <g className="cls-642">
              <path
                className="cls-107"
                d="M145.09,66.18c-.3,0-.63.27-.86.72.33.04.67.07,1,.11.23-.57.04-.81-.15-.83h0Z"
              />
              <path
                className="cls-107"
                d="M143.13,65.96c-.3-.01-.65.27-.89.71.33.04.66.08.99.12.26-.57.08-.81-.1-.83h0Z"
              />
              <path
                className="cls-107"
                d="M147.45,63.25c-.6-.01-1.14,1.09-.85,1.42.05.06.1.07.16.08.23-.51.46-1,.69-1.5h0Z"
              />
              <path
                className="cls-107"
                d="M145.62,63.06c-.57-.02-1.18,1.09-.92,1.41.28.34,1.07-.39,1.13-1.04.02-.21-.06-.35-.21-.37h0Z"
              />
              <path
                className="cls-107"
                d="M143.82,62.84c-.28.49-.56.98-.83,1.48.59.02,1.23-1.07.98-1.4-.04-.06-.09-.07-.14-.08h0Z"
              />
              <path
                className="cls-107"
                d="M148.06,61.01c-.29-.03-.57-.06-.86-.09-.3.61-.09.85.2.75.09-.03.39-.16.65-.66h0Z"
              />
            </g>
            <g className="cls-639">
              <path
                className="cls-107"
                d="M142.31,72.59c-.34-.01-.69.29-.91.77.38.04.76.08,1.15.12.22-.61-.02-.87-.24-.89h0Z"
              />
              <path
                className="cls-107"
                d="M140.07,72.34c-.34-.01-.71.28-.94.76.38.05.75.09,1.13.14.24-.61.02-.87-.19-.9h0Z"
              />
              <path
                className="cls-107"
                d="M144.74,69.44c-.69-.02-1.21,1.18-.84,1.53.06.06.12.07.19.09.22-.54.44-1.08.66-1.62h0Z"
              />
              <path
                className="cls-107"
                d="M142.62,69.22c-.66-.02-1.24,1.17-.91,1.52.36.38,1.19-.41,1.19-1.12,0-.23-.11-.38-.28-.4h0Z"
              />
              <path
                className="cls-107"
                d="M140.54,68.97c-.27.53-.53,1.06-.8,1.6.67.03,1.3-1.15.97-1.52-.06-.06-.11-.07-.17-.09h0Z"
              />
              <path
                className="cls-107"
                d="M145.24,67.01c-.34-.03-.67-.07-1-.11-.29.67.02.94.37.8.14-.06.41-.23.63-.69h0Z"
              />
              <path
                className="cls-107"
                d="M143.24,66.79c-.33-.04-.66-.08-.99-.12-.32.67-.02.95.33.8.14-.06.42-.22.66-.68h0Z"
              />
            </g>
            <g className="cls-608">
              <path
                className="cls-107"
                d="M139.66,79.46c-.38-.01-.75.31-.96.82.43.05.85.09,1.28.14.2-.65-.08-.93-.32-.95h0Z"
              />
              <path
                className="cls-107"
                d="M137.16,79.18c-.37-.02-.76.3-.99.81.42.05.84.1,1.27.15.23-.65-.04-.93-.28-.96h0Z"
              />
              <path
                className="cls-107"
                d="M142.17,76.1c-.71-.02-1.24,1.16-.88,1.6.09.11.19.12.26.14.21-.58.41-1.16.62-1.73h0Z"
              />
              <path
                className="cls-107"
                d="M139.77,75.84c-.76-.03-1.32,1.24-.9,1.63.4.38,1.24-.38,1.25-1.12,0-.29-.13-.48-.35-.51h0Z"
              />
              <path
                className="cls-107"
                d="M137.41,75.56c-.25.57-.5,1.14-.75,1.72.76.04,1.35-1.23.95-1.62-.07-.07-.13-.08-.2-.09h0Z"
              />
              <path
                className="cls-107"
                d="M142.54,73.49c-.38-.04-.77-.08-1.15-.12-.26.69.05,1.04.49.86.15-.06.45-.24.66-.74h0Z"
              />
              <path
                className="cls-107"
                d="M140.26,73.24c-.38-.04-.76-.09-1.13-.14-.3.72.06,1.02.45.87.16-.06.45-.24.68-.73h0Z"
              />
            </g>
            <g className="cls-601">
              <path
                className="cls-107"
                d="M137.18,86.74c-.41-.02-.8.32-1,.86.47.05.94.1,1.41.15.19-.69-.14-.98-.4-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M134.42,86.43c-.41-.02-.81.31-1.03.85.46.06.93.11,1.39.17.21-.69-.1-.98-.36-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M139.73,83.18c-.79-.02-1.3,1.23-.88,1.7.1.11.22.13.29.14.19-.62.39-1.23.59-1.84h0Z"
              />
              <path
                className="cls-107"
                d="M137.08,82.9c-.78-.03-1.34,1.21-.93,1.69.41.48,1.31-.24,1.35-1.06.01-.35-.15-.6-.41-.63h0Z"
              />
              <path
                className="cls-107"
                d="M134.46,82.59c-.24.61-.48,1.21-.71,1.83.76.04,1.36-1.2.98-1.68-.09-.11-.2-.14-.27-.15h0Z"
              />
              <path
                className="cls-107"
                d="M139.99,80.41c-.43-.04-.85-.09-1.28-.14-.25.75.17,1.14.67.89.18-.09.44-.3.61-.75h0Z"
              />
              <path
                className="cls-107"
                d="M137.44,80.13c-.42-.05-.85-.1-1.27-.15-.27.75.13,1.14.63.89.18-.09.45-.3.63-.74h0Z"
              />
            </g>
            <g className="cls-603">
              <path
                className="cls-107"
                d="M134.85,94.39c-.45-.02-.85.33-1.04.9.51.06,1.01.11,1.52.16.17-.72-.2-1.03-.48-1.06h0Z"
              />
              <path
                className="cls-107"
                d="M131.86,94.05c-.45-.02-.86.32-1.06.89.5.06,1,.12,1.51.18.2-.78-.2-1.04-.45-1.07h0Z"
              />
              <path
                className="cls-107"
                d="M137.45,90.67c-.85-.03-1.35,1.29-.87,1.78.12.12.24.14.32.15.18-.65.36-1.29.55-1.93h0Z"
              />
              <path
                className="cls-107"
                d="M134.55,90.36c-.84-.04-1.39,1.27-.92,1.77.45.49,1.34-.16,1.4-1.02.03-.41-.17-.71-.48-.75h0Z"
              />
              <path
                className="cls-107"
                d="M131.69,90.02c-.22.64-.45,1.28-.66,1.92.83.05,1.41-1.26.96-1.76-.1-.12-.23-.14-.3-.16h0Z"
              />
              <path
                className="cls-107"
                d="M137.58,87.75c-.47-.05-.94-.1-1.41-.15-.23.8.24,1.21.78.94.2-.1.46-.32.63-.79h0Z"
              />
              <path
                className="cls-107"
                d="M134.78,87.44c-.47-.05-.93-.11-1.39-.17-.25.79.21,1.21.74.95.2-.1.47-.31.65-.78h0Z"
              />
            </g>
            <g className="cls-604">
              <path
                className="cls-107"
                d="M129.49,102.02c-.48-.03-.9.33-1.09.92.54.07,1.07.13,1.61.19.18-.81-.26-1.08-.52-1.11h0Z"
              />
              <path
                className="cls-107"
                d="M135.33,98.51c-.87-.03-1.37,1.23-.91,1.79.14.17.3.2.4.22.17-.67.33-1.34.5-2.01h0Z"
              />
              <path
                className="cls-107"
                d="M132.2,98.17c-.91-.04-1.43,1.32-.9,1.84.51.5,1.43-.17,1.45-1.05.01-.42-.21-.75-.55-.79h0Z"
              />
              <path
                className="cls-107"
                d="M129.11,97.81c-.21.66-.41,1.33-.61,2,.89.05,1.44-1.3.94-1.83-.12-.12-.25-.15-.33-.17h0Z"
              />
              <path
                className="cls-107"
                d="M135.34,95.45c-.51-.05-1.02-.11-1.52-.16-.22.88.38,1.3.96.94.26-.16.45-.42.56-.78h0Z"
              />
              <path
                className="cls-107"
                d="M132.3,95.12c-.5-.06-1.01-.12-1.51-.18-.24.88.34,1.31.93.96.26-.16.46-.42.58-.78h0Z"
              />
            </g>
            <g className="cls-602">
              <path
                className="cls-107"
                d="M126.74,105.92c-.19.69-.37,1.38-.56,2.07.9.06,1.44-1.24.97-1.84-.14-.18-.3-.21-.41-.23h0Z"
              />
              <path
                className="cls-107"
                d="M130.02,103.14c-.54-.06-1.08-.13-1.61-.19-.22.91.42,1.36,1.03,1,.27-.16.47-.43.58-.8h0Z"
              />
            </g>
            <g className="cls-605">
              <path
                className="cls-107"
                d="M141.2,65.72c-.29-.01-.65.26-.91.7.32.04.65.09.97.13.29-.56.12-.81-.06-.83h0Z"
              />
              <path
                className="cls-107"
                d="M139.31,65.45c-.29-.02-.65.25-.94.69.32.05.64.09.96.14.31-.56.16-.8-.02-.83h0Z"
              />
              <path
                className="cls-107"
                d="M143.82,62.84c-.59-.02-1.23,1.07-.98,1.4.05.06.09.07.15.08.28-.5.55-.99.83-1.48h0Z"
              />
              <path
                className="cls-107"
                d="M140.31,62.36c-.33.48-.65.97-.98,1.46.62.04,1.36-1.13,1.08-1.41-.03-.03-.07-.04-.11-.05h0Z"
              />
            </g>
            <g className="cls-599">
              <path
                className="cls-107"
                d="M137.86,72.06c-.33-.02-.71.28-.96.75.37.05.74.1,1.11.15.27-.61.06-.87-.15-.9h0Z"
              />
              <path
                className="cls-107"
                d="M135.69,71.76c-.32-.02-.71.27-.98.74.36.05.72.11,1.09.16.29-.6.1-.87-.11-.9h0Z"
              />
              <path
                className="cls-107"
                d="M140.54,68.97c-.67-.03-1.3,1.15-.97,1.51.06.07.11.08.18.09.26-.54.53-1.07.8-1.6h0Z"
              />
              <path
                className="cls-107"
                d="M138.49,68.69c-.64-.04-1.33,1.15-1.04,1.5.31.38,1.21-.39,1.27-1.1.02-.23-.07-.38-.23-.41h0Z"
              />
              <path
                className="cls-107"
                d="M136.47,68.4c-.31.52-.62,1.05-.93,1.59.66.05,1.38-1.12,1.09-1.49-.05-.06-.1-.08-.16-.09h0Z"
              />
              <path
                className="cls-107"
                d="M141.26,66.55c-.33-.04-.65-.08-.97-.13-.34.64-.1.91.23.82.1-.03.44-.16.75-.69h0Z"
              />
              <path
                className="cls-107"
                d="M139.33,66.28c-.32-.05-.64-.09-.96-.14-.37.64-.14.91.18.83.1-.03.44-.15.77-.69h0Z"
              />
            </g>
            <g className="cls-607">
              <path
                className="cls-107"
                d="M134.68,78.86c-.37-.02-.76.29-1,.8.41.06.82.11,1.24.16.25-.65,0-.93-.24-.96h0Z"
              />
              <path
                className="cls-107"
                d="M132.26,78.53c-.36-.03-.76.28-1.02.79.4.06.81.12,1.22.18.27-.64.03-.93-.2-.96h0Z"
              />
              <path
                className="cls-107"
                d="M137.41,75.56c-.75-.04-1.35,1.22-.96,1.62.07.07.13.08.2.1.25-.58.5-1.15.75-1.72h0Z"
              />
              <path
                className="cls-107"
                d="M135.09,75.26c-.74-.05-1.39,1.21-1.02,1.61.39.41,1.31-.41,1.32-1.17,0-.25-.11-.41-.3-.44h0Z"
              />
              <path
                className="cls-107"
                d="M132.81,74.92c-.3.56-.59,1.13-.88,1.7.74.06,1.43-1.19,1.07-1.6-.06-.07-.12-.08-.19-.1h0Z"
              />
              <path
                className="cls-107"
                d="M138.01,72.96c-.37-.05-.74-.1-1.11-.15-.32.69-.04,1.04.4.87.16-.06.46-.23.71-.72h0Z"
              />
              <path
                className="cls-107"
                d="M135.8,72.66c-.36-.05-.73-.1-1.09-.16-.37.74-.03,1.02.36.87.16-.06.46-.23.73-.72h0Z"
              />
            </g>
            <g className="cls-606">
              <path
                className="cls-107"
                d="M131.69,86.08c-.4-.02-.81.3-1.04.84.45.06.91.12,1.36.18.23-.68-.07-.98-.32-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M129.03,85.71c-.4-.03-.81.29-1.06.83.44.07.89.13,1.34.19.25-.68-.03-.98-.28-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M134.46,82.59c-.77-.04-1.37,1.2-.99,1.68.09.11.2.14.27.15.24-.61.47-1.22.71-1.83h0Z"
              />
              <path
                className="cls-107"
                d="M131.89,82.25c-.79-.05-1.42,1.3-1,1.71.45.44,1.4-.43,1.36-1.24-.01-.27-.15-.44-.36-.47h0Z"
              />
              <path
                className="cls-107"
                d="M129.35,81.88c-.28.6-.56,1.2-.83,1.81.81.06,1.46-1.27,1.05-1.7-.07-.08-.14-.09-.21-.11h0Z"
              />
              <path
                className="cls-107"
                d="M134.92,79.82c-.41-.05-.83-.11-1.24-.16-.29.71.04,1.11.51.93.17-.06.49-.25.73-.77h0Z"
              />
              <path
                className="cls-107"
                d="M132.45,79.49c-.41-.06-.81-.12-1.22-.18-.34.76.04,1.09.47.94.17-.06.49-.24.75-.76h0Z"
              />
            </g>
            <g className="cls-600">
              <path
                className="cls-107"
                d="M128.9,93.68c-.44-.03-.85.31-1.07.88.49.07.98.13,1.47.2.23-.77-.17-1.04-.4-1.07h0Z"
              />
              <path
                className="cls-107"
                d="M126.01,93.28c-.43-.03-.85.3-1.08.86.48.07.96.14,1.45.21.25-.77-.13-1.04-.36-1.07h0Z"
              />
              <path
                className="cls-107"
                d="M131.69,90.02c-.83-.05-1.41,1.26-.97,1.76.11.12.23.15.3.16.22-.64.44-1.28.66-1.92h0Z"
              />
              <path
                className="cls-107"
                d="M128.88,89.64c-.82-.06-1.44,1.24-1.02,1.75.41.5,1.32-.13,1.44-.99.05-.41-.12-.72-.42-.76h0Z"
              />
              <path
                className="cls-107"
                d="M126.11,89.24c-.26.63-.52,1.27-.78,1.91.81.07,1.46-1.23,1.06-1.74-.09-.12-.21-.15-.28-.16h0Z"
              />
              <path
                className="cls-107"
                d="M132.02,87.1c-.46-.06-.91-.12-1.36-.18-.28.8.15,1.21.69.96.2-.09.47-.31.67-.77h0Z"
              />
              <path
                className="cls-107"
                d="M129.31,86.73c-.45-.06-.89-.13-1.34-.19-.33.85.16,1.19.65.96.2-.09.48-.3.69-.77h0Z"
              />
            </g>
            <g className="cls-635">
              <path
                className="cls-107"
                d="M126.32,101.63c-.47-.03-.89.32-1.09.91.52.07,1.05.14,1.58.21.2-.81-.23-1.08-.48-1.12h0Z"
              />
              <path
                className="cls-107"
                d="M123.22,101.19c-.46-.04-.89.31-1.11.9.51.08,1.03.15,1.55.23.22-.8-.19-1.09-.45-1.12h0Z"
              />
              <path
                className="cls-107"
                d="M129.11,97.81c-.9-.05-1.45,1.3-.94,1.83.12.13.25.15.33.17.2-.67.41-1.33.61-2h0Z"
              />
              <path
                className="cls-107"
                d="M126.08,97.4c-.89-.06-1.47,1.29-.99,1.82.46.51,1.4-.14,1.48-1.02.04-.42-.16-.75-.49-.8h0Z"
              />
              <path
                className="cls-107"
                d="M123.1,96.97c-.24.66-.48,1.32-.72,1.98.87.07,1.48-1.27,1.03-1.81-.11-.13-.24-.16-.31-.17h0Z"
              />
              <path
                className="cls-107"
                d="M129.31,94.75c-.49-.06-.99-.13-1.47-.2-.26.83.23,1.27.8,1.01.21-.1.49-.32.68-.81h0Z"
              />
              <path
                className="cls-107"
                d="M126.37,94.36c-.49-.07-.97-.14-1.45-.21-.3.89.24,1.25.76,1.01.21-.1.5-.31.69-.8h0Z"
              />
            </g>
            <g className="cls-634">
              <path
                className="cls-107"
                d="M126.74,105.92c-.91-.05-1.44,1.24-.97,1.84.15.18.31.21.41.23.18-.69.37-1.38.56-2.07h0Z"
              />
              <path
                className="cls-107"
                d="M123.51,105.49c-.94-.07-1.49,1.33-.96,1.89.51.53,1.48-.14,1.51-1.06.02-.44-.21-.78-.56-.83h0Z"
              />
              <path
                className="cls-107"
                d="M120.33,105.03c-.22.68-.44,1.37-.65,2.06.92.08,1.5-1.32.99-1.88-.12-.13-.26-.16-.34-.18h0Z"
              />
              <path
                className="cls-107"
                d="M126.81,102.74c-.53-.07-1.06-.14-1.58-.21-.24.91.37,1.37.98,1.01.27-.16.48-.43.6-.8h0Z"
              />
              <path
                className="cls-107"
                d="M123.66,102.32c-.52-.07-1.04-.15-1.55-.23-.28.96.38,1.34.94,1.02.27-.16.48-.42.61-.79h0Z"
              />
            </g>
            <g className="cls-633">
              <path
                className="cls-107"
                d="M137.45,65.17c-.28-.02-.66.25-.96.68.31.05.62.1.94.15.36-.6.18-.81.03-.83h0Z"
              />
              <path
                className="cls-107"
                d="M135.63,64.86c-.28-.02-.66.24-.99.67.3.05.61.11.92.16.34-.52.27-.79.07-.83h0Z"
              />
              <path
                className="cls-107"
                d="M140.31,62.36c-.61-.04-1.36,1.13-1.09,1.41.03.03.08.05.11.05.32-.49.65-.98.98-1.46h0Z"
              />
              <path
                className="cls-107"
                d="M138.61,62.08c-.61-.05-1.41,1.12-1.15,1.4.28.31,1.3-.62,1.3-1.19,0-.07-.02-.18-.15-.21h0Z"
              />
            </g>
            <g className="cls-628">
              <path
                className="cls-107"
                d="M133.56,71.44c-.32-.02-.71.26-1,.73.35.06.71.11,1.07.17.34-.65.11-.87-.06-.9h0Z"
              />
              <path
                className="cls-107"
                d="M131.48,71.09c-.31-.03-.72.25-1.02.72.35.06.69.12,1.05.18.34-.6.17-.87-.02-.9h0Z"
              />
              <path
                className="cls-107"
                d="M136.47,68.4c-.65-.05-1.38,1.12-1.09,1.49.05.07.1.08.16.09.31-.53.62-1.06.93-1.59h0Z"
              />
              <path
                className="cls-107"
                d="M134.5,68.09c-.64-.05-1.41,1.1-1.15,1.48.27.39,1.21-.36,1.34-1.07.04-.23-.03-.38-.19-.41h0Z"
              />
              <path
                className="cls-107"
                d="M132.57,67.75c-.36.52-.71,1.04-1.06,1.56.68.06,1.48-1.19,1.18-1.5-.04-.04-.08-.05-.12-.06h0Z"
              />
              <path
                className="cls-107"
                d="M137.42,66c-.31-.05-.63-.1-.94-.15-.4.64-.19.91.14.83.1-.02.44-.15.8-.68h0Z"
              />
              <path
                className="cls-107"
                d="M135.56,65.69c-.31-.05-.61-.11-.92-.16-.43.63-.23.91.09.83.1-.02.44-.14.82-.67h0Z"
              />
            </g>
            <g className="cls-627">
              <path
                className="cls-107"
                d="M129.87,78.16c-.35-.03-.76.27-1.04.77.4.06.79.13,1.19.19.32-.69.04-.93-.15-.96h0Z"
              />
              <path
                className="cls-107"
                d="M127.54,77.77c-.35-.03-.76.27-1.06.76.39.07.78.14,1.17.2.32-.64.11-.93-.11-.97h0Z"
              />
              <path
                className="cls-107"
                d="M132.81,74.92c-.73-.05-1.42,1.19-1.07,1.6.06.07.12.09.19.1.29-.57.59-1.14.88-1.7h0Z"
              />
              <path
                className="cls-107"
                d="M130.58,74.57c-.72-.06-1.45,1.18-1.13,1.58.33.41,1.31-.4,1.38-1.14.02-.25-.07-.41-.25-.44h0Z"
              />
              <path
                className="cls-107"
                d="M128.39,74.19c-.34.55-.67,1.11-1.01,1.68.71.07,1.48-1.16,1.18-1.58-.05-.07-.11-.09-.17-.1h0Z"
              />
              <path
                className="cls-107"
                d="M133.62,72.34c-.36-.06-.71-.11-1.07-.17-.38.68-.11.98.25.9.11-.03.48-.15.82-.73h0Z"
              />
              <path
                className="cls-107"
                d="M131.5,71.99c-.35-.06-.7-.12-1.05-.18-.4.68-.15.98.2.9.11-.02.48-.15.84-.72h0Z"
              />
            </g>
            <g className="cls-626">
              <path
                className="cls-107"
                d="M126.4,85.31c-.39-.03-.81.29-1.07.81.43.07.87.14,1.31.21.3-.73-.03-.99-.24-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M123.84,84.88c-.38-.04-.81.28-1.09.8.43.08.85.15,1.28.22.3-.68.04-.98-.2-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M129.35,81.88c-.8-.06-1.46,1.27-1.05,1.7.07.08.14.09.22.11.28-.61.55-1.21.83-1.81h0Z"
              />
              <path
                className="cls-107"
                d="M126.88,81.48c-.79-.07-1.49,1.25-1.1,1.69.4.45,1.39-.4,1.41-1.21,0-.27-.11-.45-.31-.48h0Z"
              />
              <path
                className="cls-107"
                d="M124.46,81.06c-.32.59-.64,1.19-.95,1.79.77.08,1.51-1.24,1.15-1.68-.06-.08-.13-.09-.2-.11h0Z"
              />
              <path
                className="cls-107"
                d="M130.02,79.13c-.4-.06-.8-.13-1.19-.19-.34.7-.05,1.11.42.94.17-.06.49-.23.77-.75h0Z"
              />
              <path
                className="cls-107"
                d="M127.65,78.74c-.39-.07-.78-.13-1.17-.2-.39.76-.05,1.09.38.95.17-.06.5-.23.79-.74h0Z"
              />
            </g>
            <g className="cls-629">
              <path
                className="cls-107"
                d="M123.16,92.85c-.42-.04-.85.3-1.1.85.47.08.94.15,1.42.23.27-.77-.09-1.04-.32-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M120.38,92.38c-.42-.04-.84.28-1.11.84.46.08.92.16,1.39.24.29-.76-.06-1.04-.28-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M126.11,89.24c-.8-.06-1.46,1.23-1.06,1.74.09.12.21.15.28.17.26-.64.52-1.27.78-1.91h0Z"
              />
              <path
                className="cls-107"
                d="M123.41,88.81c-.79-.07-1.48,1.21-1.11,1.73.36.5,1.29-.11,1.46-.96.08-.4-.06-.72-.35-.77h0Z"
              />
              <path
                className="cls-107"
                d="M120.76,88.35c-.3.63-.59,1.25-.89,1.89.84.09,1.53-1.3,1.11-1.77-.07-.08-.14-.1-.22-.12h0Z"
              />
              <path
                className="cls-107"
                d="M126.64,86.34c-.44-.07-.88-.14-1.31-.21-.33.79.06,1.22.61.97.2-.09.48-.29.7-.76h0Z"
              />
              <path
                className="cls-107"
                d="M124.03,85.91c-.43-.07-.86-.15-1.28-.22-.36.8.04,1.15.48,1.01.18-.06.52-.24.8-.78h0Z"
              />
            </g>
            <g className="cls-630">
              <path
                className="cls-107"
                d="M120.16,100.73c-.45-.04-.88.3-1.11.88.5.08,1.01.16,1.52.24.24-.8-.16-1.09-.41-1.13h0Z"
              />
              <path
                className="cls-107"
                d="M117.18,100.23c-.45-.05-.88.29-1.12.87.49.09.99.17,1.49.26.26-.8-.12-1.09-.37-1.13h0Z"
              />
              <path
                className="cls-107"
                d="M123.1,96.97c-.87-.07-1.49,1.27-1.03,1.81.11.13.24.16.31.17.24-.66.47-1.33.72-1.98h0Z"
              />
              <path
                className="cls-107"
                d="M120.18,96.5c-.85-.08-1.5,1.26-1.07,1.8.42.52,1.36-.11,1.49-.99.06-.42-.11-.75-.42-.81h0Z"
              />
              <path
                className="cls-107"
                d="M117.33,96.01c-.27.65-.55,1.31-.81,1.97.83.09,1.5-1.24,1.1-1.79-.1-.13-.22-.16-.29-.18h0Z"
              />
              <path
                className="cls-107"
                d="M123.48,93.92c-.48-.07-.95-.15-1.42-.23-.3.83.15,1.28.71,1.02.21-.09.5-.31.71-.8h0Z"
              />
              <path
                className="cls-107"
                d="M120.66,93.46c-.47-.08-.93-.16-1.39-.24-.35.88.15,1.26.67,1.03.21-.09.5-.3.72-.79h0Z"
              />
            </g>
            <g className="cls-631">
              <path
                className="cls-107"
                d="M117.43,108.92c-.48-.04-.91.31-1.13.91.53.09,1.07.17,1.61.26.22-.83-.22-1.13-.49-1.17h0Z"
              />
              <path
                className="cls-107"
                d="M114.26,108.39c-.47-.05-.9.29-1.13.9.52.09,1.05.18,1.58.28.23-.83-.19-1.13-.45-1.18h0Z"
              />
              <path
                className="cls-107"
                d="M120.33,105.03c-.92-.08-1.5,1.32-.99,1.88.12.13.26.16.34.18.21-.69.43-1.38.65-2.06h0Z"
              />
              <path
                className="cls-107"
                d="M117.22,104.53c-.91-.09-1.52,1.3-1.03,1.87.47.54,1.43-.11,1.52-1.02.04-.44-.16-.79-.49-.84h0Z"
              />
              <path
                className="cls-107"
                d="M114.17,104c-.25.68-.5,1.36-.74,2.04.88.1,1.51-1.28,1.06-1.86-.11-.14-.24-.17-.31-.19h0Z"
              />
              <path
                className="cls-107"
                d="M120.57,101.85c-.51-.08-1.02-.16-1.52-.24-.29.9.28,1.37.9,1.03.27-.15.48-.42.62-.79h0Z"
              />
              <path
                className="cls-107"
                d="M117.54,101.36c-.5-.09-.99-.17-1.49-.26-.32.92.24,1.31.77,1.08.21-.09.51-.31.72-.82h0Z"
              />
            </g>
            <g className="cls-632">
              <path
                className="cls-107"
                d="M114.53,112.85c-.94-.09-1.51,1.34-.98,1.92.52.57,1.49-.1,1.54-1.05.02-.45-.21-.81-.56-.87h0Z"
              />
              <path
                className="cls-107"
                d="M111.31,112.29c-.23.7-.45,1.41-.67,2.11.92.1,1.51-1.32,1-1.92-.12-.14-.26-.18-.34-.2h0Z"
              />
              <path
                className="cls-107"
                d="M117.92,110.09c-.54-.08-1.08-.17-1.61-.26-.25.93.37,1.43,1,1.07.28-.16.49-.43.62-.81h0Z"
              />
              <path
                className="cls-107"
                d="M114.71,109.57c-.53-.09-1.06-.18-1.58-.28-.29.99.38,1.4.95,1.08.28-.16.49-.43.63-.8h0Z"
              />
            </g>
            <g className="cls-540">
              <path
                className="cls-107"
                d="M133.84,64.54c-.27-.03-.67.23-1.01.66.3.06.59.11.9.17.42-.59.26-.8.11-.83h0Z"
              />
            </g>
            <g className="cls-541">
              <path
                className="cls-107"
                d="M129.44,70.72c-.31-.03-.72.25-1.04.71.34.07.68.13,1.02.19.39-.64.19-.87.02-.9h0Z"
              />
              <path
                className="cls-107"
                d="M127.45,70.32c-.3-.04-.72.24-1.06.7.33.07.66.14,1,.21.39-.59.25-.86.07-.9h0Z"
              />
              <path
                className="cls-107"
                d="M132.57,67.75c-.69-.07-1.5,1.19-1.19,1.5.04.04.09.05.12.06.35-.53.71-1.05,1.06-1.56h0Z"
              />
              <path
                className="cls-107"
                d="M133.73,65.37c-.3-.06-.6-.11-.9-.17-.41.56-.32.88,0,.84.07,0,.45-.08.9-.67h0Z"
              />
            </g>
            <g className="cls-542">
              <path
                className="cls-107"
                d="M125.26,77.36c-.34-.04-.76.26-1.07.75.38.07.76.15,1.14.22.37-.68.12-.93-.07-.97h0Z"
              />
              <path
                className="cls-107"
                d="M123.03,76.92c-.33-.04-.76.25-1.09.74.37.08.74.15,1.11.23.36-.63.18-.92-.02-.97h0Z"
              />
              <path
                className="cls-107"
                d="M128.39,74.19c-.71-.07-1.49,1.16-1.18,1.57.05.07.11.09.18.11.33-.56.67-1.12,1.01-1.68h0Z"
              />
              <path
                className="cls-107"
                d="M126.26,73.78c-.69-.08-1.51,1.14-1.23,1.56.29.43,1.3-.35,1.44-1.11.05-.25-.03-.41-.21-.45h0Z"
              />
              <path
                className="cls-107"
                d="M124.18,73.35c-.38.55-.75,1.1-1.12,1.65.73.09,1.58-1.24,1.25-1.59-.04-.04-.09-.06-.13-.07h0Z"
              />
              <path
                className="cls-107"
                d="M129.42,71.62c-.34-.06-.68-.13-1.02-.19-.43.68-.2.98.16.9.1-.02.48-.14.86-.71h0Z"
              />
              <path
                className="cls-107"
                d="M127.39,71.22c-.33-.07-.67-.14-1-.21-.45.67-.24.98.11.9.11-.02.48-.14.89-.7h0Z"
              />
            </g>
            <g className="cls-544">
              <path
                className="cls-107"
                d="M121.32,84.43c-.37-.04-.8.27-1.1.79.41.08.83.16,1.25.24.34-.73.05-.99-.15-1.03h0Z"
              />
              <path
                className="cls-107"
                d="M124.46,81.06c-.78-.08-1.53,1.23-1.15,1.68.07.08.13.1.2.11.31-.6.63-1.2.95-1.79h0Z"
              />
              <path
                className="cls-107"
                d="M122.09,80.61c-.76-.09-1.54,1.22-1.2,1.66.35.46,1.38-.37,1.46-1.18.03-.27-.07-.45-.26-.49h0Z"
              />
              <path
                className="cls-107"
                d="M125.32,78.32c-.38-.07-.76-.14-1.14-.22-.39.7-.14,1.1.33.95.17-.06.5-.22.81-.73h0Z"
              />
              <path
                className="cls-107"
                d="M123.06,77.89c-.37-.08-.74-.15-1.11-.23-.43.72-.16,1.05.21.97.11-.02.51-.15.9-.74h0Z"
              />
            </g>
            <g className="cls-543">
              <path
                className="cls-107"
                d="M117.65,91.88c-.4-.05-.84.28-1.12.83.45.09.9.17,1.36.26.31-.76-.02-1.04-.24-1.08h0Z"
              />
              <path
                className="cls-107"
                d="M120.76,88.35c-.85-.09-1.55,1.29-1.11,1.76.08.08.15.1.23.12.29-.63.59-1.26.89-1.89h0Z"
              />
              <path
                className="cls-107"
                d="M121.48,85.45c-.42-.08-.84-.16-1.25-.24-.36.74-.06,1.17.44,1.01.18-.06.52-.23.81-.77h0Z"
              />
            </g>
            <g className="cls-546">
              <path
                className="cls-107"
                d="M114.25,99.7c-.43-.05-.87.29-1.13.86.48.09.97.19,1.45.28.28-.8-.09-1.09-.33-1.14h0Z"
              />
              <path
                className="cls-107"
                d="M117.33,96.01c-.85-.09-1.53,1.24-1.11,1.78.1.13.22.16.3.18.27-.66.54-1.31.81-1.97h0Z"
              />
              <path
                className="cls-107"
                d="M117.89,92.97c-.46-.08-.91-.17-1.36-.26-.35.82.06,1.28.62,1.04.2-.09.5-.29.73-.78h0Z"
              />
            </g>
            <g className="cls-545">
              <path
                className="cls-107"
                d="M111.15,107.82c-.46-.06-.9.29-1.13.89.51.1,1.02.2,1.54.29.25-.82-.16-1.13-.41-1.18h0Z"
              />
              <path
                className="cls-107"
                d="M114.17,104c-.9-.1-1.54,1.28-1.07,1.85.11.14.24.17.32.19.24-.68.49-1.37.74-2.04h0Z"
              />
              <path
                className="cls-107"
                d="M111.19,103.43c-.87-.11-1.53,1.27-1.09,1.84.42.55,1.39-.08,1.52-.99.06-.44-.11-.79-.43-.85h0Z"
              />
              <path
                className="cls-107"
                d="M114.58,100.83c-.49-.09-.97-.18-1.45-.28-.31.86.14,1.34.73,1.09.21-.09.51-.31.73-.81h0Z"
              />
            </g>
            <g className="cls-548">
              <path
                className="cls-107"
                d="M111.31,112.29c-.93-.11-1.53,1.32-1.01,1.91.12.14.26.18.35.2.22-.71.44-1.41.67-2.11h0Z"
              />
              <path
                className="cls-107"
                d="M108.16,111.69c-.9-.11-1.52,1.31-1.04,1.9.47.58,1.44-.07,1.53-1.02.04-.45-.16-.82-.5-.88h0Z"
              />
              <path
                className="cls-107"
                d="M111.56,109c-.52-.1-1.03-.19-1.54-.29-.29.93.28,1.43.91,1.09.28-.15.49-.42.64-.8h0Z"
              />
            </g>
            <g className="cls-547">
              <path
                className="cls-107"
                d="M124.18,73.35c-.73-.09-1.59,1.23-1.26,1.58.04.04.09.06.13.07.37-.56.75-1.11,1.12-1.65h0Z"
              />
              <path
                className="cls-107"
                d="M122.15,72.9c-.71-.1-1.61,1.22-1.31,1.57.33.38,1.43-.55,1.49-1.25.02-.24-.11-.3-.18-.32h0Z"
              />
            </g>
          </g>
          <g className="cls-539">
            <g className="cls-538">
              <path
                className="cls-107"
                d="M139.97,59.14c-.24-.02-.61.22-.94.62.26.05.52.09.78.14.36-.47.33-.72.16-.75h0Z"
              />
            </g>
            <g className="cls-537">
              <path
                className="cls-107"
                d="M139.81,59.89c-.26-.04-.52-.09-.78-.14-.43.56-.32.8-.07.77.06,0,.41-.08.86-.63h0Z"
              />
            </g>
            <g className="cls-532">
              <path
                className="cls-107"
                d="M138.46,58.86c-.24-.02-.61.22-.97.61.25.05.51.1.76.14.38-.47.37-.72.2-.75h0Z"
              />
              <path
                className="cls-107"
                d="M136.99,58.57c-.23-.02-.62.21-.99.6.25.05.49.1.74.15.4-.47.41-.71.25-.75h0Z"
              />
              <path
                className="cls-107"
                d="M140.17,56.1c-.28-.03-.74.36-.89.51-.39.38-.49.67-.39.76.25.23,1.38-.72,1.37-1.16,0-.08-.05-.1-.08-.11h0Z"
              />
              <path
                className="cls-107"
                d="M138.84,55.83c-.43.42-.87.85-1.3,1.28.52.06,1.55-1.05,1.35-1.25-.01-.01-.04-.02-.05-.03h0Z"
              />
            </g>
            <g className="cls-533">
              <path
                className="cls-107"
                d="M132.11,64.2c-.27-.03-.67.22-1.03.65.29.06.58.12.87.18.38-.51.35-.79.16-.83h0Z"
              />
              <path
                className="cls-107"
                d="M135.32,61.48c-.58-.06-1.49,1.08-1.28,1.37.24.31,1.34-.6,1.4-1.16,0-.07,0-.19-.12-.21h0Z"
              />
              <path
                className="cls-107"
                d="M133.73,61.16c-.42.47-.83.94-1.24,1.41.57.07,1.53-1.07,1.33-1.36-.02-.03-.06-.05-.09-.06h0Z"
              />
              <path
                className="cls-107"
                d="M138.26,59.62c-.26-.05-.51-.1-.76-.14-.42.51-.4.81-.12.77.06,0,.4-.08.88-.62h0Z"
              />
              <path
                className="cls-107"
                d="M136.74,59.32c-.25-.05-.5-.1-.74-.15-.44.49-.44.76-.21.77.02,0,.38,0,.95-.62h0Z"
              />
            </g>
            <g className="cls-530">
              <path
                className="cls-107"
                d="M131.95,65.02c-.29-.06-.58-.12-.87-.18-.48.62-.32.87-.05.84.07,0,.45-.07.93-.66h0Z"
              />
            </g>
            <g className="cls-531">
              <path
                className="cls-107"
                d="M135.55,58.26c-.23-.03-.62.2-1.01.59.24.05.48.11.73.16.43-.46.45-.71.29-.75h0Z"
              />
              <path
                className="cls-107"
                d="M134.15,57.94c-.22-.03-.63.2-1.03.57.23.06.47.11.7.17.45-.46.49-.7.33-.74h0Z"
              />
              <path
                className="cls-107"
                d="M138.84,55.83c-.28-.03-.75.35-.91.5-.41.38-.53.66-.44.75.01.01.04.02.06.03.43-.43.86-.86,1.3-1.28h0Z"
              />
            </g>
            <g className="cls-536">
              <path
                className="cls-107"
                d="M130.41,63.83c-.26-.03-.67.22-1.05.64.28.06.57.13.85.19.41-.51.39-.78.2-.83h0Z"
              />
              <path
                className="cls-107"
                d="M128.77,63.45c-.26-.04-.67.21-1.07.62.27.07.55.13.82.2.43-.5.42-.78.24-.82h0Z"
              />
              <path
                className="cls-107"
                d="M133.73,61.16c-.58-.07-1.54,1.07-1.34,1.36.02.04.06.05.09.06.41-.48.83-.95,1.24-1.41h0Z"
              />
              <path
                className="cls-107"
                d="M132.19,60.81c-.56-.07-1.57,1.05-1.39,1.34.19.32,1.36-.57,1.49-1.13.02-.07.02-.18-.1-.21h0Z"
              />
              <path
                className="cls-107"
                d="M135.26,59.01c-.24-.05-.49-.11-.73-.16-.45.47-.48.76-.25.77.02,0,.38,0,.98-.6h0Z"
              />
              <path
                className="cls-107"
                d="M133.82,58.68c-.24-.06-.47-.11-.7-.17-.52.51-.49.76-.3.76.01,0,.37.01,1-.59h0Z"
              />
            </g>
            <g className="cls-535">
              <path
                className="cls-107"
                d="M125.31,66.19c-.44.5-.87,1-1.3,1.51.62.09,1.62-1.12,1.4-1.45-.03-.04-.07-.05-.1-.07h0Z"
              />
              <path
                className="cls-107"
                d="M130.22,64.66c-.29-.06-.57-.13-.85-.19-.46.55-.41.87-.1.84.07,0,.45-.07.95-.65h0Z"
              />
              <path
                className="cls-107"
                d="M128.53,64.27c-.28-.07-.55-.13-.82-.2-.51.58-.41.86-.14.84.07,0,.44-.06.97-.64h0Z"
              />
            </g>
            <g className="cls-534">
              <path
                className="cls-107"
                d="M132.8,57.6c-.22-.03-.63.19-1.06.56.23.06.45.12.68.18.47-.45.52-.7.37-.74h0Z"
              />
            </g>
            <g className="cls-529">
              <path
                className="cls-107"
                d="M127.18,63.05c-.25-.04-.68.2-1.09.61.26.07.53.14.8.21.45-.5.46-.77.28-.82h0Z"
              />
              <path
                className="cls-107"
                d="M132.43,58.34c-.23-.06-.46-.12-.68-.18-.54.51-.52.75-.34.76.01,0,.36.01,1.02-.58h0Z"
              />
            </g>
            <g className="cls-525">
              <path
                className="cls-107"
                d="M120.05,68.53c-.27-.05-.71.2-1.12.65.29.08.58.17.88.25.44-.53.43-.84.24-.9h0Z"
              />
              <path
                className="cls-107"
                d="M125.31,66.19c-.62-.1-1.63,1.12-1.41,1.44.03.04.07.06.1.07.43-.51.87-1.01,1.3-1.51h0Z"
              />
              <path
                className="cls-107"
                d="M123.62,65.75c-.6-.1-1.66,1.1-1.46,1.43.22.36,1.45-.57,1.57-1.19.01-.07.02-.2-.11-.24h0Z"
              />
              <path
                className="cls-107"
                d="M126.9,63.87c-.27-.07-.54-.14-.8-.21-.53.58-.45.86-.18.84.07,0,.43-.06.99-.63h0Z"
              />
            </g>
            <g className="cls-524">
              <path
                className="cls-107"
                d="M118.28,71.92c-.67-.12-1.66,1.18-1.4,1.54.28.38,1.42-.51,1.55-1.22.04-.23-.07-.3-.15-.32h0Z"
              />
              <path
                className="cls-107"
                d="M116.45,71.4c-.45.53-.9,1.06-1.34,1.6.65.13,1.68-1.16,1.44-1.53-.03-.04-.07-.06-.1-.07h0Z"
              />
              <path
                className="cls-107"
                d="M119.81,69.42c-.3-.08-.59-.17-.88-.25-.52.62-.41.93-.13.91.07,0,.46-.05,1.01-.66h0Z"
              />
            </g>
            <g className="cls-528">
              <path
                className="cls-107"
                d="M116.45,71.4c-.66-.13-1.69,1.16-1.45,1.52.03.05.07.06.11.08.44-.54.89-1.07,1.34-1.6h0Z"
              />
            </g>
          </g>
          <g className="cls-527">
            <g className="cls-523">
              <path
                className="cls-107"
                d="M103.08,70.48c-.22-.08-.67.15-1.13.59.23.12.46.24.69.36.56-.57.57-.88.44-.95h0Z"
              />
            </g>
            <g className="cls-522">
              <path
                className="cls-107"
                d="M96.91,76.86c-.24-.09-.68.16-1.12.63.25.13.5.26.76.39.52-.62.5-.95.36-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M95.46,76.07c-.23-.09-.66.15-1.11.61.17.1.34.2.51.29.07.04.13.08.2.11.53-.61.53-.94.4-1.02h0Z"
              />
              <path
                className="cls-107"
                d="M99.25,73.24c-.28-.11-.81.3-1.05.53-.48.46-.64.87-.56,1.02.21.38,1.51-.63,1.67-1.31.03-.12,0-.2-.06-.24h0Z"
              />
              <path
                className="cls-107"
                d="M97.91,72.47c-.53.52-1.06,1.05-1.58,1.59.52.23,1.78-1.21,1.63-1.53,0-.02-.03-.04-.05-.06h0Z"
              />
              <path
                className="cls-107"
                d="M102.64,71.43c-.23-.12-.47-.24-.69-.36-.62.62-.6.97-.36.98.04,0,.4,0,1.05-.62h0Z"
              />
            </g>
            <g className="cls-520">
              <path
                className="cls-107"
                d="M93.22,79.8c-.56-.22-1.68,1.16-1.53,1.61.15.43,1.16-.27,1.53-1.07.13-.27.13-.48,0-.55h0Z"
              />
              <path
                className="cls-107"
                d="M91.76,78.96c-.5.56-.99,1.13-1.48,1.7.48.24,1.66-1.16,1.55-1.6-.01-.05-.04-.08-.07-.1h0Z"
              />
              <path
                className="cls-107"
                d="M96.56,77.88c-.26-.13-.51-.26-.76-.39-.55.64-.56,1.09-.21,1.05.1,0,.45-.08.97-.66h0Z"
              />
              <path
                className="cls-107"
                d="M95.06,77.09c-.07-.04-.14-.08-.2-.11-.17-.1-.34-.2-.51-.29-.57.64-.61,1.08-.26,1.05.09,0,.43-.08.97-.65h0Z"
              />
            </g>
            <g className="cls-526">
              <path
                className="cls-107"
                d="M100.55,69.03c-.19-.09-.63.14-1.11.57.19.12.38.25.58.37.59-.56.64-.87.53-.94h0Z"
              />
              <path
                className="cls-107"
                d="M99.49,68.38q-1.09.42-1.13.46c.17.13.34.25.52.38.5-.46.6-.72.61-.84h0Z"
              />
            </g>
            <g className="cls-521">
              <path
                className="cls-107"
                d="M94.13,75.26c-.21-.09-.63.14-1.09.6.21.14.42.27.64.41.55-.6.57-.94.45-1.01h0Z"
              />
              <path
                className="cls-107"
                d="M97.91,72.47c-.26-.11-.79.29-1.03.52-.48.45-.67.86-.6,1.01,0,.02.03.04.05.06.52-.53,1.05-1.06,1.58-1.59h0Z"
              />
              <path
                className="cls-107"
                d="M96.7,71.69c-.24-.11-.77.28-1.01.51-.49.45-.7.85-.64,1,.13.36,1.35-.53,1.65-1.21.04-.09.09-.24,0-.3h0Z"
              />
              <path
                className="cls-107"
                d="M95.61,70.91c-.55.51-1.1,1.03-1.64,1.55.44.23,1.76-1.17,1.67-1.49,0-.02-.02-.04-.04-.06h0Z"
              />
              <path
                className="cls-107"
                d="M100.02,69.97c-.2-.12-.39-.25-.58-.37-.59.56-.71.95-.45.97.04,0,.37,0,1.04-.6h0Z"
              />
              <path
                className="cls-107"
                d="M98.88,69.22c-.18-.13-.35-.25-.52-.38-.6.55-.75.94-.5.96.03,0,.35.01,1.03-.59h0Z"
              />
            </g>
            <g className="cls-518">
              <path
                className="cls-107"
                d="M91.76,78.96c-.53-.23-1.7,1.18-1.54,1.61.02.04.04.07.07.08.49-.57.98-1.14,1.48-1.7h0Z"
              />
              <path
                className="cls-107"
                d="M93.68,76.27c-.22-.14-.43-.27-.64-.41-.58.63-.65,1.07-.32,1.05.09,0,.41-.07.96-.64h0Z"
              />
            </g>
            <g className="cls-519">
              <path
                className="cls-107"
                d="M95.61,70.91c-.22-.11-.75.28-.99.5-.5.44-.72.84-.68,1,0,.02.02.04.04.06.54-.52,1.09-1.04,1.64-1.55h0Z"
              />
            </g>
          </g>
          <path
            className="cls-10"
            d="M275.73,185.52c1.72,10.03,2.62,19.94,2.59,29.56-.2,71.26-50.81,100.11-112.83,64.3-62.01-35.8-112.3-122.91-112.1-194.16.2-71.26,50.82-100.09,112.83-64.29,6.51,3.76,12.88,8.08,19.09,12.89.52.09,1.03.19,1.54.29-6.69-5.29-13.58-10.02-20.63-14.08C103.78-16.03,52.82,13.02,52.61,84.77c-.2,71.75,50.43,159.45,112.88,195.51,62.44,36.05,113.4,7,113.61-64.75.03-10.22-.98-20.77-2.9-31.45-.15.48-.31.96-.47,1.44Z"
          />
          <path
            className="cls-8"
            d="M278.37,84.77c-7.63-4.41-15.85-8.27-24.49-11.6.33.38.66.77.98,1.16,8.01,3.16,15.63,6.79,22.74,10.9,62.01,35.8,62.34,94.05.73,129.86-61.61,35.8-162.18,35.81-224.19,0-62.01-35.8-62.34-94.06-.73-129.87,6.66-3.87,13.78-7.32,21.25-10.36.32-.39.64-.77.96-1.15-8.11,3.21-15.82,6.89-23,11.06-62.03,36.05-61.71,94.71.74,130.76,62.44,36.05,163.71,36.05,225.75,0,62.03-36.05,61.71-94.71-.73-130.76Z"
          />
          <path
            className="cls-7"
            d="M165.49,20.02c-6.87,3.96-13.59,8.55-20.12,13.68.51-.09,1.01-.17,1.52-.25,6.05-4.66,12.26-8.86,18.6-12.52,62.01-35.8,112.62-6.96,112.83,64.3.2,71.26-50.08,158.36-112.09,194.16-62.01,35.8-112.63,6.96-112.83-64.3-.02-8.51.68-17.24,2.03-26.08-.17-.47-.34-.95-.5-1.42-1.53,9.48-2.33,18.85-2.3,27.95.2,71.75,51.17,100.8,113.61,64.74,62.44-36.05,113.07-123.76,112.87-195.5-.2-71.75-51.17-100.8-113.61-64.75Z"
          />
          <g className="cls-117">
            <ellipse
              fill={mainColor + '06'}
              cx={85.98}
              cy={11.87}
              rx={11.72}
              ry={11.66}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={85.98}
              cy={11.9}
              rx={11.06}
              ry={11}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={85.98}
              cy={11.92}
              rx={10.39}
              ry={10.34}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={85.98}
              cy={11.95}
              rx={9.73}
              ry={9.69}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={85.98}
              cy={11.98}
              rx={9.07}
              ry={9.03}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={85.98}
              cy={12}
              rx={8.41}
              ry={8.37}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={85.98}
              cy={12.03}
              rx={7.75}
              ry={7.71}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={85.98}
              cy={12.06}
              rx={7.09}
              ry={7.05}
            />
            <path
              fill={mainColor + '06'}
              d="M92.4,12.08c0,3.53-2.88,6.4-6.43,6.4s-6.43-2.86-6.43-6.4,2.88-6.4,6.43-6.4,6.43,2.86,6.43,6.4Z"
            />
            <path
              fill={mainColor + '06'}
              d="M91.74,12.11c0,3.17-2.58,5.74-5.76,5.74s-5.76-2.57-5.76-5.74,2.58-5.74,5.76-5.74,5.76,2.57,5.76,5.74Z"
            />
            <path
              fill={mainColor + '06'}
              d="M91.08,12.14c0,2.8-2.28,5.08-5.1,5.08s-5.1-2.27-5.1-5.08,2.28-5.08,5.1-5.08,5.1,2.27,5.1,5.08Z"
            />
            <path
              fill={mainColor + '06'}
              d="M90.42,12.16c0,2.44-1.99,4.42-4.44,4.42s-4.44-1.98-4.44-4.42,1.99-4.42,4.44-4.42,4.44,1.98,4.44,4.42Z"
            />
            <path
              fill={mainColor + '06'}
              d="M89.76,12.19c0,2.08-1.69,3.76-3.78,3.76s-3.78-1.68-3.78-3.76,1.69-3.76,3.78-3.76,3.78,1.68,3.78,3.76Z"
            />
            <path
              fill={mainColor + '06'}
              d="M89.1,12.22c0,1.71-1.4,3.1-3.12,3.1s-3.12-1.39-3.12-3.1,1.4-3.1,3.12-3.1,3.12,1.39,3.12,3.1Z"
            />
            <path
              fill={mainColor + '06'}
              d="M88.44,12.24c0,1.35-1.1,2.45-2.46,2.45s-2.46-1.1-2.46-2.45,1.1-2.45,2.46-2.45,2.46,1.1,2.46,2.45Z"
            />
            <path
              fill={mainColor + '06'}
              d="M87.77,12.27c0,.99-.8,1.79-1.8,1.79s-1.8-.8-1.8-1.79.8-1.79,1.8-1.79,1.8.8,1.8,1.79Z"
            />
            <path
              fill={mainColor + '06'}
              d="M87.11,12.3c0,.62-.51,1.13-1.14,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.14.51,1.14,1.13Z"
            />
          </g>
          <path
            className="cls-649"
            d="M87.11,12.3c0,.62-.51,1.13-1.14,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.14.51,1.14,1.13Z"
          />
          <g className="cls-117">
            <ellipse
              fill={mainColor + '06'}
              cx={55.42}
              cy={59.12}
              rx={11.72}
              ry={11.66}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={55.42}
              cy={59.15}
              rx={11.06}
              ry={11}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={55.42}
              cy={59.17}
              rx={10.39}
              ry={10.34}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={55.42}
              cy={59.2}
              rx={9.73}
              ry={9.69}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={55.42}
              cy={59.23}
              rx={9.07}
              ry={9.03}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={55.42}
              cy={59.26}
              rx={8.41}
              ry={8.37}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={55.42}
              cy={59.28}
              rx={7.75}
              ry={7.71}
            />
            <path
              fill={mainColor + '06'}
              d="M62.51,59.31c0,3.9-3.17,7.05-7.09,7.05s-7.09-3.16-7.09-7.05,3.17-7.05,7.09-7.05,7.09,3.16,7.09,7.05Z"
            />
            <path
              fill={mainColor + '06'}
              d="M61.85,59.34c0,3.53-2.88,6.4-6.43,6.4s-6.43-2.86-6.43-6.4,2.88-6.4,6.43-6.4,6.43,2.86,6.43,6.4Z"
            />
            <path
              fill={mainColor + '06'}
              d="M61.19,59.36c0,3.17-2.58,5.74-5.76,5.74s-5.76-2.57-5.76-5.74,2.58-5.74,5.76-5.74,5.76,2.57,5.76,5.74Z"
            />
            <path
              fill={mainColor + '06'}
              d="M60.52,59.39c0,2.8-2.28,5.08-5.1,5.08s-5.1-2.27-5.1-5.08,2.28-5.08,5.1-5.08,5.1,2.27,5.1,5.08Z"
            />
            <path
              fill={mainColor + '06'}
              d="M59.86,59.42c0,2.44-1.99,4.42-4.44,4.42s-4.44-1.98-4.44-4.42,1.99-4.42,4.44-4.42,4.44,1.98,4.44,4.42Z"
            />
            <path
              fill={mainColor + '06'}
              d="M59.2,59.44c0,2.08-1.69,3.76-3.78,3.76s-3.78-1.68-3.78-3.76,1.69-3.76,3.78-3.76,3.78,1.68,3.78,3.76Z"
            />
            <path
              fill={mainColor + '06'}
              d="M58.54,59.47c0,1.71-1.4,3.1-3.12,3.1s-3.12-1.39-3.12-3.1,1.4-3.1,3.12-3.1,3.12,1.39,3.12,3.1Z"
            />
            <path
              fill={mainColor + '06'}
              d="M57.88,59.5c0,1.35-1.1,2.45-2.46,2.45s-2.46-1.1-2.46-2.45,1.1-2.45,2.46-2.45,2.46,1.1,2.46,2.45Z"
            />
            <path
              fill={mainColor + '06'}
              d="M57.22,59.52c0,.99-.8,1.79-1.8,1.79s-1.8-.8-1.8-1.79.8-1.79,1.8-1.79,1.8.8,1.8,1.79Z"
            />
            <path
              fill={mainColor + '06'}
              d="M56.56,59.55c0,.62-.51,1.13-1.14,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.14.51,1.14,1.13Z"
            />
          </g>
          <path
            className="cls-649"
            d="M56.56,59.55c0,.62-.51,1.13-1.14,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.14.51,1.14,1.13Z"
          />
          <g className="cls-117">
            <ellipse
              fill={mainColor + '06'}
              cx={60.39}
              cy={135.17}
              rx={11.72}
              ry={11.66}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={60.39}
              cy={135.2}
              rx={11.06}
              ry={11}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={60.39}
              cy={135.23}
              rx={10.39}
              ry={10.34}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={60.39}
              cy={135.25}
              rx={9.73}
              ry={9.69}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={60.39}
              cy={135.28}
              rx={9.07}
              ry={9.03}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={60.39}
              cy={135.31}
              rx={8.41}
              ry={8.37}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={60.39}
              cy={135.33}
              rx={7.75}
              ry={7.71}
            />
            <path
              fill={mainColor + '06'}
              d="M67.48,135.36c0,3.9-3.17,7.05-7.09,7.05s-7.09-3.16-7.09-7.05,3.17-7.05,7.09-7.05,7.09,3.16,7.09,7.05Z"
            />
            <path
              fill={mainColor + '06'}
              d="M66.82,135.39c0,3.53-2.88,6.4-6.43,6.4s-6.43-2.86-6.43-6.4,2.88-6.4,6.43-6.4,6.43,2.86,6.43,6.4Z"
            />
            <path
              fill={mainColor + '06'}
              d="M66.16,135.41c0,3.17-2.58,5.74-5.76,5.74s-5.76-2.57-5.76-5.74,2.58-5.74,5.76-5.74,5.76,2.57,5.76,5.74Z"
            />
            <path
              fill={mainColor + '06'}
              d="M65.5,135.44c0,2.8-2.28,5.08-5.1,5.08s-5.1-2.27-5.1-5.08,2.28-5.08,5.1-5.08,5.1,2.27,5.1,5.08Z"
            />
            <path
              fill={mainColor + '06'}
              d="M64.84,135.47c0,2.44-1.99,4.42-4.44,4.42s-4.44-1.98-4.44-4.42,1.99-4.42,4.44-4.42,4.44,1.98,4.44,4.42Z"
            />
            <path
              fill={mainColor + '06'}
              d="M64.17,135.49c0,2.08-1.69,3.76-3.78,3.76s-3.78-1.68-3.78-3.76,1.69-3.76,3.78-3.76,3.78,1.68,3.78,3.76Z"
            />
            <path
              fill={mainColor + '06'}
              d="M63.51,135.52c0,1.71-1.4,3.1-3.12,3.1s-3.12-1.39-3.12-3.1,1.4-3.1,3.12-3.1,3.12,1.39,3.12,3.1Z"
            />
            <path
              fill={mainColor + '06'}
              d="M62.85,135.55c0,1.35-1.1,2.45-2.46,2.45s-2.46-1.1-2.46-2.45,1.1-2.45,2.46-2.45,2.46,1.1,2.46,2.45Z"
            />
            <path
              fill={mainColor + '06'}
              d="M62.19,135.57c0,.99-.8,1.79-1.8,1.79s-1.8-.8-1.8-1.79.8-1.79,1.8-1.79,1.8.8,1.8,1.79Z"
            />
            <path
              fill={mainColor + '06'}
              d="M61.53,135.6c0,.62-.51,1.13-1.13,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.13.51,1.13,1.13Z"
            />
          </g>
          <path
            className="cls-649"
            d="M61.53,135.6c0,.62-.51,1.13-1.13,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.13.51,1.13,1.13Z"
          />
          <g className="cls-117">
            <ellipse
              fill={mainColor + '06'}
              cx={93.49}
              cy={207.55}
              rx={11.72}
              ry={11.66}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={93.49}
              cy={207.58}
              rx={11.06}
              ry={11}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={93.49}
              cy={207.6}
              rx={10.39}
              ry={10.34}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={93.49}
              cy={207.63}
              rx={9.73}
              ry={9.69}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={93.49}
              cy={207.66}
              rx={9.07}
              ry={9.03}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={93.49}
              cy={207.68}
              rx={8.41}
              ry={8.37}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={93.49}
              cy={207.71}
              rx={7.75}
              ry={7.71}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={93.49}
              cy={207.74}
              rx={7.09}
              ry={7.05}
            />
            <path
              fill={mainColor + '06'}
              d="M99.91,207.76c0,3.53-2.88,6.4-6.43,6.4s-6.43-2.86-6.43-6.4,2.88-6.4,6.43-6.4,6.43,2.86,6.43,6.4Z"
            />
            <path
              fill={mainColor + '06'}
              d="M99.25,207.79c0,3.17-2.58,5.74-5.76,5.74s-5.76-2.57-5.76-5.74,2.58-5.74,5.76-5.74,5.76,2.57,5.76,5.74Z"
            />
            <path
              fill={mainColor + '06'}
              d="M98.59,207.82c0,2.8-2.28,5.08-5.1,5.08s-5.1-2.27-5.1-5.08,2.28-5.08,5.1-5.08,5.1,2.27,5.1,5.08Z"
            />
            <path
              fill={mainColor + '06'}
              d="M97.93,207.84c0,2.44-1.99,4.42-4.44,4.42s-4.44-1.98-4.44-4.42,1.99-4.42,4.44-4.42,4.44,1.98,4.44,4.42Z"
            />
            <path
              fill={mainColor + '06'}
              d="M97.27,207.87c0,2.08-1.69,3.76-3.78,3.76s-3.78-1.68-3.78-3.76,1.69-3.76,3.78-3.76,3.78,1.68,3.78,3.76Z"
            />
            <path
              fill={mainColor + '06'}
              d="M96.61,207.9c0,1.71-1.4,3.1-3.12,3.1s-3.12-1.39-3.12-3.1,1.4-3.1,3.12-3.1,3.12,1.39,3.12,3.1Z"
            />
            <path
              fill={mainColor + '06'}
              d="M95.94,207.92c0,1.35-1.1,2.45-2.46,2.45s-2.46-1.1-2.46-2.45,1.1-2.45,2.46-2.45,2.46,1.1,2.46,2.45Z"
            />
            <path
              fill={mainColor + '06'}
              d="M95.28,207.95c0,.99-.8,1.79-1.8,1.79s-1.8-.8-1.8-1.79.8-1.79,1.8-1.79,1.8.8,1.8,1.79Z"
            />
            <path
              fill={mainColor + '06'}
              d="M94.62,207.98c0,.62-.51,1.13-1.14,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.14.51,1.14,1.13Z"
            />
          </g>
          <path
            className="cls-649"
            d="M94.62,207.98c0,.62-.51,1.13-1.14,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.14.51,1.14,1.13Z"
          />
          <g className="cls-117">
            <ellipse
              fill={mainColor + '06'}
              cx={144.92}
              cy={264.97}
              rx={11.72}
              ry={11.66}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={144.92}
              cy={265}
              rx={11.06}
              ry={11}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={144.92}
              cy={265.02}
              rx={10.39}
              ry={10.34}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={144.92}
              cy={265.05}
              rx={9.73}
              ry={9.69}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={144.92}
              cy={265.08}
              rx={9.07}
              ry={9.03}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={144.92}
              cy={265.1}
              rx={8.41}
              ry={8.37}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={144.92}
              cy={265.13}
              rx={7.75}
              ry={7.71}
            />
            <path
              fill={mainColor + '06'}
              d="M152.01,265.16c0,3.9-3.17,7.05-7.09,7.05s-7.09-3.16-7.09-7.05,3.17-7.05,7.09-7.05,7.09,3.16,7.09,7.05Z"
            />
            <path
              fill={mainColor + '06'}
              d="M151.35,265.18c0,3.53-2.88,6.4-6.43,6.4s-6.43-2.86-6.43-6.4,2.88-6.4,6.43-6.4,6.43,2.86,6.43,6.4Z"
            />
            <path
              fill={mainColor + '06'}
              d="M150.68,265.21c0,3.17-2.58,5.74-5.76,5.74s-5.76-2.57-5.76-5.74,2.58-5.74,5.76-5.74,5.76,2.57,5.76,5.74Z"
            />
            <path
              fill={mainColor + '06'}
              d="M150.02,265.24c0,2.8-2.28,5.08-5.1,5.08s-5.1-2.27-5.1-5.08,2.28-5.08,5.1-5.08,5.1,2.27,5.1,5.08Z"
            />
            <path
              fill={mainColor + '06'}
              d="M149.36,265.26c0,2.44-1.99,4.42-4.44,4.42s-4.44-1.98-4.44-4.42,1.99-4.42,4.44-4.42,4.44,1.98,4.44,4.42Z"
            />
            <path
              fill={mainColor + '06'}
              d="M148.7,265.29c0,2.08-1.69,3.76-3.78,3.76s-3.78-1.68-3.78-3.76,1.69-3.76,3.78-3.76,3.78,1.68,3.78,3.76Z"
            />
            <path
              fill={mainColor + '06'}
              d="M148.04,265.32c0,1.71-1.4,3.1-3.12,3.1s-3.12-1.39-3.12-3.1,1.4-3.1,3.12-3.1,3.12,1.39,3.12,3.1Z"
            />
            <path
              fill={mainColor + '06'}
              d="M147.38,265.34c0,1.35-1.1,2.45-2.46,2.45s-2.46-1.1-2.46-2.45,1.1-2.45,2.46-2.45,2.46,1.1,2.46,2.45Z"
            />
            <path
              fill={mainColor + '06'}
              d="M146.72,265.37c0,.99-.8,1.79-1.8,1.79s-1.8-.8-1.8-1.79.8-1.79,1.8-1.79,1.8.8,1.8,1.79Z"
            />
            <path
              fill={mainColor + '06'}
              d="M146.05,265.4c0,.62-.51,1.13-1.14,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.14.51,1.14,1.13Z"
            />
          </g>
          <path
            className="cls-649"
            d="M146.05,265.4c0,.62-.51,1.13-1.14,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.14.51,1.14,1.13Z"
          />
          <g className="cls-117">
            <ellipse
              fill={mainColor + '06'}
              cx={223.18}
              cy={294.23}
              rx={11.72}
              ry={11.66}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={223.18}
              cy={294.26}
              rx={11.06}
              ry={11}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={223.18}
              cy={294.29}
              rx={10.39}
              ry={10.34}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={223.18}
              cy={294.31}
              rx={9.73}
              ry={9.69}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={223.18}
              cy={294.34}
              rx={9.07}
              ry={9.03}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={223.18}
              cy={294.37}
              rx={8.41}
              ry={8.37}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={223.18}
              cy={294.39}
              rx={7.75}
              ry={7.71}
            />
            <path
              fill={mainColor + '06'}
              d="M230.26,294.42c0,3.9-3.17,7.05-7.09,7.05s-7.09-3.16-7.09-7.05,3.17-7.05,7.09-7.05,7.09,3.16,7.09,7.05Z"
            />
            <path
              fill={mainColor + '06'}
              d="M229.6,294.45c0,3.53-2.88,6.4-6.43,6.4s-6.43-2.86-6.43-6.4,2.88-6.4,6.43-6.4,6.43,2.86,6.43,6.4Z"
            />
            <path
              fill={mainColor + '06'}
              d="M228.94,294.47c0,3.17-2.58,5.74-5.76,5.74s-5.76-2.57-5.76-5.74,2.58-5.74,5.76-5.74,5.76,2.57,5.76,5.74Z"
            />
            <path
              fill={mainColor + '06'}
              d="M228.28,294.5c0,2.8-2.28,5.08-5.1,5.08s-5.1-2.27-5.1-5.08,2.28-5.08,5.1-5.08,5.1,2.27,5.1,5.08Z"
            />
            <path
              fill={mainColor + '06'}
              d="M227.62,294.53c0,2.44-1.99,4.42-4.44,4.42s-4.44-1.98-4.44-4.42,1.99-4.42,4.44-4.42,4.44,1.98,4.44,4.42Z"
            />
            <path
              fill={mainColor + '06'}
              d="M226.96,294.55c0,2.08-1.69,3.76-3.78,3.76s-3.78-1.68-3.78-3.76,1.69-3.76,3.78-3.76,3.78,1.68,3.78,3.76Z"
            />
            <path
              fill={mainColor + '06'}
              d="M226.3,294.58c0,1.71-1.4,3.1-3.12,3.1s-3.12-1.39-3.12-3.1,1.4-3.1,3.12-3.1,3.12,1.39,3.12,3.1Z"
            />
            <path
              fill={mainColor + '06'}
              d="M225.63,294.61c0,1.35-1.1,2.45-2.46,2.45s-2.46-1.1-2.46-2.45,1.1-2.45,2.46-2.45,2.46,1.1,2.46,2.45Z"
            />
            <path
              fill={mainColor + '06'}
              d="M224.97,294.63c0,.99-.8,1.79-1.8,1.79s-1.8-.8-1.8-1.79.8-1.79,1.8-1.79,1.8.8,1.8,1.79Z"
            />
            <path
              fill={mainColor + '06'}
              d="M224.31,294.66c0,.62-.51,1.13-1.14,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.14.51,1.14,1.13Z"
            />
          </g>
          <path
            className="cls-649"
            d="M224.31,294.66c0,.62-.51,1.13-1.14,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.14.51,1.14,1.13Z"
          />
          <g className="cls-117">
            <ellipse
              fill={mainColor + '06'}
              cx={277.2}
              cy={235.48}
              rx={11.72}
              ry={11.66}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={277.2}
              cy={235.51}
              rx={11.06}
              ry={11}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={277.2}
              cy={235.54}
              rx={10.39}
              ry={10.34}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={277.2}
              cy={235.56}
              rx={9.73}
              ry={9.69}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={277.2}
              cy={235.59}
              rx={9.07}
              ry={9.03}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={277.2}
              cy={235.62}
              rx={8.41}
              ry={8.37}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={277.2}
              cy={235.64}
              rx={7.75}
              ry={7.71}
            />
            <path
              fill={mainColor + '06'}
              d="M284.29,235.67c0,3.9-3.17,7.05-7.09,7.05s-7.09-3.16-7.09-7.05,3.17-7.05,7.09-7.05,7.09,3.16,7.09,7.05Z"
            />
            <path
              fill={mainColor + '06'}
              d="M283.63,235.7c0,3.53-2.88,6.4-6.43,6.4s-6.43-2.86-6.43-6.4,2.88-6.4,6.43-6.4,6.43,2.86,6.43,6.4Z"
            />
            <path
              fill={mainColor + '06'}
              d="M282.97,235.72c0,3.17-2.58,5.74-5.76,5.74s-5.76-2.57-5.76-5.74,2.58-5.74,5.76-5.74,5.76,2.57,5.76,5.74Z"
            />
            <path
              fill={mainColor + '06'}
              d="M282.3,235.75c0,2.8-2.28,5.08-5.1,5.08s-5.1-2.27-5.1-5.08,2.28-5.08,5.1-5.08,5.1,2.27,5.1,5.08Z"
            />
            <path
              fill={mainColor + '06'}
              d="M281.64,235.78c0,2.44-1.99,4.42-4.44,4.42s-4.44-1.98-4.44-4.42,1.99-4.42,4.44-4.42,4.44,1.98,4.44,4.42Z"
            />
            <path
              fill={mainColor + '06'}
              d="M280.98,235.8c0,2.08-1.69,3.76-3.78,3.76s-3.78-1.68-3.78-3.76,1.69-3.76,3.78-3.76,3.78,1.68,3.78,3.76Z"
            />
            <path
              fill={mainColor + '06'}
              d="M280.32,235.83c0,1.71-1.4,3.1-3.12,3.1s-3.12-1.39-3.12-3.1,1.4-3.1,3.12-3.1,3.12,1.39,3.12,3.1Z"
            />
            <path
              fill={mainColor + '06'}
              d="M279.66,235.86c0,1.35-1.1,2.45-2.46,2.45s-2.46-1.1-2.46-2.45,1.1-2.45,2.46-2.45,2.46,1.1,2.46,2.45Z"
            />
            <path
              fill={mainColor + '06'}
              d="M279,235.88c0,.99-.8,1.79-1.8,1.79s-1.8-.8-1.8-1.79.8-1.79,1.8-1.79,1.8.8,1.8,1.79Z"
            />
            <path
              fill={mainColor + '06'}
              d="M278.34,235.91c0,.62-.51,1.13-1.14,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.14.51,1.14,1.13Z"
            />
          </g>
          <path
            className="cls-649"
            d="M278.34,235.91c0,.62-.51,1.13-1.14,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.14.51,1.14,1.13Z"
          />
          <g className="cls-117">
            <ellipse
              fill={mainColor + '06'}
              cx={148.98}
              cy={11.87}
              rx={11.72}
              ry={11.66}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={148.98}
              cy={11.9}
              rx={11.06}
              ry={11}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={148.98}
              cy={11.92}
              rx={10.39}
              ry={10.34}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={148.98}
              cy={11.95}
              rx={9.73}
              ry={9.69}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={148.98}
              cy={11.98}
              rx={9.07}
              ry={9.03}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={148.98}
              cy={12}
              rx={8.41}
              ry={8.37}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={148.98}
              cy={12.03}
              rx={7.75}
              ry={7.71}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={148.98}
              cy={12.06}
              rx={7.09}
              ry={7.05}
            />
            <path
              fill={mainColor + '06'}
              d="M155.4,12.08c0,3.53-2.88,6.4-6.43,6.4s-6.43-2.86-6.43-6.4,2.88-6.4,6.43-6.4,6.43,2.86,6.43,6.4Z"
            />
            <path
              fill={mainColor + '06'}
              d="M154.74,12.11c0,3.17-2.58,5.74-5.76,5.74s-5.76-2.57-5.76-5.74,2.58-5.74,5.76-5.74,5.76,2.57,5.76,5.74Z"
            />
            <path
              fill={mainColor + '06'}
              d="M154.08,12.14c0,2.8-2.28,5.08-5.1,5.08s-5.1-2.27-5.1-5.08,2.28-5.08,5.1-5.08,5.1,2.27,5.1,5.08Z"
            />
            <path
              fill={mainColor + '06'}
              d="M153.42,12.16c0,2.44-1.99,4.42-4.44,4.42s-4.44-1.98-4.44-4.42,1.99-4.42,4.44-4.42,4.44,1.98,4.44,4.42Z"
            />
            <path
              fill={mainColor + '06'}
              d="M152.76,12.19c0,2.08-1.69,3.76-3.78,3.76s-3.78-1.68-3.78-3.76,1.69-3.76,3.78-3.76,3.78,1.68,3.78,3.76Z"
            />
            <path
              fill={mainColor + '06'}
              d="M152.09,12.22c0,1.71-1.4,3.1-3.12,3.1s-3.12-1.39-3.12-3.1,1.4-3.1,3.12-3.1,3.12,1.39,3.12,3.1Z"
            />
            <path
              fill={mainColor + '06'}
              d="M151.43,12.24c0,1.35-1.1,2.45-2.46,2.45s-2.46-1.1-2.46-2.45,1.1-2.45,2.46-2.45,2.46,1.1,2.46,2.45Z"
            />
            <path
              fill={mainColor + '06'}
              d="M150.77,12.27c0,.99-.8,1.79-1.8,1.79s-1.8-.8-1.8-1.79.8-1.79,1.8-1.79,1.8.8,1.8,1.79Z"
            />
            <path
              fill={mainColor + '06'}
              d="M150.11,12.3c0,.62-.51,1.13-1.13,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.13.51,1.13,1.13Z"
            />
          </g>
          <path
            className="cls-649"
            d="M150.11,12.3c0,.62-.51,1.13-1.13,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.13.51,1.13,1.13Z"
          />
          <g className="cls-117">
            <ellipse
              fill={mainColor + '06'}
              cx={244.52}
              cy={11.66}
              rx={11.72}
              ry={11.66}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={244.52}
              cy={11.69}
              rx={11.06}
              ry={11}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={244.52}
              cy={11.71}
              rx={10.39}
              ry={10.34}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={244.52}
              cy={11.74}
              rx={9.73}
              ry={9.69}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={244.52}
              cy={11.77}
              rx={9.07}
              ry={9.03}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={244.52}
              cy={11.79}
              rx={8.41}
              ry={8.37}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={244.52}
              cy={11.82}
              rx={7.75}
              ry={7.71}
            />
            <path
              fill={mainColor + '06'}
              d="M237.43,11.85c0,3.9,3.17,7.05,7.09,7.05s7.09-3.16,7.09-7.05-3.17-7.05-7.09-7.05-7.09,3.16-7.09,7.05Z"
            />
            <path
              fill={mainColor + '06'}
              d="M238.1,11.87c0,3.53,2.88,6.4,6.43,6.4s6.43-2.86,6.43-6.4-2.88-6.4-6.43-6.4-6.43,2.86-6.43,6.4Z"
            />
            <path
              fill={mainColor + '06'}
              d="M238.76,11.9c0,3.17,2.58,5.74,5.76,5.74s5.76-2.57,5.76-5.74-2.58-5.74-5.76-5.74-5.76,2.57-5.76,5.74Z"
            />
            <path
              fill={mainColor + '06'}
              d="M239.42,11.93c0,2.8,2.28,5.08,5.1,5.08s5.1-2.27,5.1-5.08-2.28-5.08-5.1-5.08-5.1,2.27-5.1,5.08Z"
            />
            <path
              fill={mainColor + '06'}
              d="M240.08,11.95c0,2.44,1.99,4.42,4.44,4.42s4.44-1.98,4.44-4.42-1.99-4.42-4.44-4.42-4.44,1.98-4.44,4.42Z"
            />
            <path
              fill={mainColor + '06'}
              d="M240.74,11.98c0,2.08,1.69,3.76,3.78,3.76s3.78-1.68,3.78-3.76-1.69-3.76-3.78-3.76-3.78,1.68-3.78,3.76Z"
            />
            <path
              fill={mainColor + '06'}
              d="M241.4,12.01c0,1.71,1.4,3.1,3.12,3.1s3.12-1.39,3.12-3.1-1.4-3.1-3.12-3.1-3.12,1.39-3.12,3.1Z"
            />
            <path
              fill={mainColor + '06'}
              d="M242.06,12.04c0,1.35,1.1,2.45,2.46,2.45s2.46-1.1,2.46-2.45-1.1-2.45-2.46-2.45-2.46,1.1-2.46,2.45Z"
            />
            <path
              fill={mainColor + '06'}
              d="M242.73,12.06c0,.99.8,1.79,1.8,1.79s1.8-.8,1.8-1.79-.8-1.79-1.8-1.79-1.8.8-1.8,1.79Z"
            />
            <path
              fill={mainColor + '06'}
              d="M243.39,12.09c0,.62.51,1.13,1.14,1.13s1.13-.51,1.13-1.13-.51-1.13-1.13-1.13-1.14.51-1.14,1.13Z"
            />
          </g>
          <path
            className="cls-649"
            d="M243.39,12.09c0,.62.51,1.13,1.14,1.13s1.13-.51,1.13-1.13-.51-1.13-1.13-1.13-1.14.51-1.14,1.13Z"
          />
          <g className="cls-117">
            <ellipse
              fill={mainColor + '06'}
              cx={276.21}
              cy={59.12}
              rx={11.72}
              ry={11.66}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={276.21}
              cy={59.15}
              rx={11.06}
              ry={11}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={276.21}
              cy={59.17}
              rx={10.39}
              ry={10.34}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={276.21}
              cy={59.2}
              rx={9.73}
              ry={9.69}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={276.21}
              cy={59.23}
              rx={9.07}
              ry={9.03}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={276.21}
              cy={59.26}
              rx={8.41}
              ry={8.37}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={276.21}
              cy={59.28}
              rx={7.75}
              ry={7.71}
            />
            <path
              fill={mainColor + '06'}
              d="M269.13,59.31c0,3.9,3.17,7.05,7.09,7.05s7.09-3.16,7.09-7.05-3.17-7.05-7.09-7.05-7.09,3.16-7.09,7.05Z"
            />
            <path
              fill={mainColor + '06'}
              d="M269.79,59.34c0,3.53,2.88,6.4,6.43,6.4s6.43-2.86,6.43-6.4-2.88-6.4-6.43-6.4-6.43,2.86-6.43,6.4Z"
            />
            <path
              fill={mainColor + '06'}
              d="M270.45,59.36c0,3.17,2.58,5.74,5.76,5.74s5.76-2.57,5.76-5.74-2.58-5.74-5.76-5.74-5.76,2.57-5.76,5.74Z"
            />
            <path
              fill={mainColor + '06'}
              d="M271.11,59.39c0,2.8,2.28,5.08,5.1,5.08s5.1-2.27,5.1-5.08-2.28-5.08-5.1-5.08-5.1,2.27-5.1,5.08Z"
            />
            <path
              fill={mainColor + '06'}
              d="M271.77,59.42c0,2.44,1.99,4.42,4.44,4.42s4.44-1.98,4.44-4.42-1.99-4.42-4.44-4.42-4.44,1.98-4.44,4.42Z"
            />
            <path
              fill={mainColor + '06'}
              d="M272.43,59.44c0,2.08,1.69,3.76,3.78,3.76s3.78-1.68,3.78-3.76-1.69-3.76-3.78-3.76-3.78,1.68-3.78,3.76Z"
            />
            <path
              fill={mainColor + '06'}
              d="M273.09,59.47c0,1.71,1.4,3.1,3.12,3.1s3.12-1.39,3.12-3.1-1.4-3.1-3.12-3.1-3.12,1.39-3.12,3.1Z"
            />
            <path
              fill={mainColor + '06'}
              d="M273.76,59.5c0,1.35,1.1,2.45,2.46,2.45s2.46-1.1,2.46-2.45-1.1-2.45-2.46-2.45-2.46,1.1-2.46,2.45Z"
            />
            <path
              fill={mainColor + '06'}
              d="M274.42,59.52c0,.99.8,1.79,1.8,1.79s1.8-.8,1.8-1.79-.8-1.79-1.8-1.79-1.8.8-1.8,1.79Z"
            />
            <path
              fill={mainColor + '06'}
              d="M275.08,59.55c0,.62.51,1.13,1.13,1.13s1.13-.51,1.13-1.13-.51-1.13-1.13-1.13-1.13.51-1.13,1.13Z"
            />
          </g>
          <path
            className="cls-649"
            d="M275.08,59.55c0,.62.51,1.13,1.13,1.13s1.13-.51,1.13-1.13-.51-1.13-1.13-1.13-1.13.51-1.13,1.13Z"
          />
          <g className="cls-117">
            <ellipse
              fill={mainColor + '06'}
              cx={271.24}
              cy={135.17}
              rx={11.72}
              ry={11.66}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={271.24}
              cy={135.2}
              rx={11.06}
              ry={11}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={271.24}
              cy={135.23}
              rx={10.39}
              ry={10.34}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={271.24}
              cy={135.25}
              rx={9.73}
              ry={9.69}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={271.24}
              cy={135.28}
              rx={9.07}
              ry={9.03}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={271.24}
              cy={135.31}
              rx={8.41}
              ry={8.37}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={271.24}
              cy={135.33}
              rx={7.75}
              ry={7.71}
            />
            <path
              fill={mainColor + '06'}
              d="M264.15,135.36c0,3.9,3.17,7.05,7.09,7.05s7.09-3.16,7.09-7.05-3.17-7.05-7.09-7.05-7.09,3.16-7.09,7.05Z"
            />
            <path
              fill={mainColor + '06'}
              d="M264.81,135.39c0,3.53,2.88,6.4,6.43,6.4s6.43-2.86,6.43-6.4-2.88-6.4-6.43-6.4-6.43,2.86-6.43,6.4Z"
            />
            <path
              fill={mainColor + '06'}
              d="M265.47,135.41c0,3.17,2.58,5.74,5.76,5.74s5.76-2.57,5.76-5.74-2.58-5.74-5.76-5.74-5.76,2.57-5.76,5.74Z"
            />
            <path
              fill={mainColor + '06'}
              d="M266.14,135.44c0,2.8,2.28,5.08,5.1,5.08s5.1-2.27,5.1-5.08-2.28-5.08-5.1-5.08-5.1,2.27-5.1,5.08Z"
            />
            <path
              fill={mainColor + '06'}
              d="M266.8,135.47c0,2.44,1.99,4.42,4.44,4.42s4.44-1.98,4.44-4.42-1.99-4.42-4.44-4.42-4.44,1.98-4.44,4.42Z"
            />
            <path
              fill={mainColor + '06'}
              d="M267.46,135.49c0,2.08,1.69,3.76,3.78,3.76s3.78-1.68,3.78-3.76-1.69-3.76-3.78-3.76-3.78,1.68-3.78,3.76Z"
            />
            <path
              fill={mainColor + '06'}
              d="M268.12,135.52c0,1.71,1.4,3.1,3.12,3.1s3.12-1.39,3.12-3.1-1.4-3.1-3.12-3.1-3.12,1.39-3.12,3.1Z"
            />
            <path
              fill={mainColor + '06'}
              d="M268.78,135.55c0,1.35,1.1,2.45,2.46,2.45s2.46-1.1,2.46-2.45-1.1-2.45-2.46-2.45-2.46,1.1-2.46,2.45Z"
            />
            <path
              fill={mainColor + '06'}
              d="M269.44,135.57c0,.99.8,1.79,1.8,1.79s1.8-.8,1.8-1.79-.8-1.79-1.8-1.79-1.8.8-1.8,1.79Z"
            />
            <path
              fill={mainColor + '06'}
              d="M270.1,135.6c0,.62.51,1.13,1.14,1.13s1.13-.51,1.13-1.13-.51-1.13-1.13-1.13-1.14.51-1.14,1.13Z"
            />
          </g>
          <path
            className="cls-649"
            d="M270.1,135.6c0,.62.51,1.13,1.14,1.13s1.13-.51,1.13-1.13-.51-1.13-1.13-1.13-1.14.51-1.14,1.13Z"
          />
          <g className="cls-117">
            <ellipse
              fill={mainColor + '06'}
              cx={238.15}
              cy={207.55}
              rx={11.72}
              ry={11.66}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={238.15}
              cy={207.58}
              rx={11.06}
              ry={11}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={238.15}
              cy={207.6}
              rx={10.39}
              ry={10.34}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={238.15}
              cy={207.63}
              rx={9.73}
              ry={9.69}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={238.15}
              cy={207.66}
              rx={9.07}
              ry={9.03}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={238.15}
              cy={207.68}
              rx={8.41}
              ry={8.37}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={238.15}
              cy={207.71}
              rx={7.75}
              ry={7.71}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={238.15}
              cy={207.74}
              rx={7.09}
              ry={7.05}
            />
            <path
              fill={mainColor + '06'}
              d="M231.72,207.76c0,3.53,2.88,6.4,6.43,6.4s6.43-2.86,6.43-6.4-2.88-6.4-6.43-6.4-6.43,2.86-6.43,6.4Z"
            />
            <path
              fill={mainColor + '06'}
              d="M232.38,207.79c0,3.17,2.58,5.74,5.76,5.74s5.76-2.57,5.76-5.74-2.58-5.74-5.76-5.74-5.76,2.57-5.76,5.74Z"
            />
            <path
              fill={mainColor + '06'}
              d="M233.04,207.82c0,2.8,2.28,5.08,5.1,5.08s5.1-2.27,5.1-5.08-2.28-5.08-5.1-5.08-5.1,2.27-5.1,5.08Z"
            />
            <path
              fill={mainColor + '06'}
              d="M233.71,207.84c0,2.44,1.99,4.42,4.44,4.42s4.44-1.98,4.44-4.42-1.99-4.42-4.44-4.42-4.44,1.98-4.44,4.42Z"
            />
            <path
              fill={mainColor + '06'}
              d="M234.37,207.87c0,2.08,1.69,3.76,3.78,3.76s3.78-1.68,3.78-3.76-1.69-3.76-3.78-3.76-3.78,1.68-3.78,3.76Z"
            />
            <path
              fill={mainColor + '06'}
              d="M235.03,207.9c0,1.71,1.4,3.1,3.12,3.1s3.12-1.39,3.12-3.1-1.4-3.1-3.12-3.1-3.12,1.39-3.12,3.1Z"
            />
            <path
              fill={mainColor + '06'}
              d="M235.69,207.92c0,1.35,1.1,2.45,2.46,2.45s2.46-1.1,2.46-2.45-1.1-2.45-2.46-2.45-2.46,1.1-2.46,2.45Z"
            />
            <path
              fill={mainColor + '06'}
              d="M236.35,207.95c0,.99.8,1.79,1.8,1.79s1.8-.8,1.8-1.79-.8-1.79-1.8-1.79-1.8.8-1.8,1.79Z"
            />
            <path
              fill={mainColor + '06'}
              d="M237.01,207.98c0,.62.51,1.13,1.14,1.13s1.13-.51,1.13-1.13-.51-1.13-1.13-1.13-1.14.51-1.14,1.13Z"
            />
          </g>
          <path
            className="cls-649"
            d="M237.01,207.98c0,.62.51,1.13,1.14,1.13s1.13-.51,1.13-1.13-.51-1.13-1.13-1.13-1.14.51-1.14,1.13Z"
          />
          <g className="cls-117">
            <ellipse
              fill={mainColor + '06'}
              cx={186.13}
              cy={265.69}
              rx={11.72}
              ry={11.66}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={186.13}
              cy={265.72}
              rx={11.06}
              ry={11}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={186.13}
              cy={265.74}
              rx={10.39}
              ry={10.34}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={186.13}
              cy={265.77}
              rx={9.73}
              ry={9.69}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={186.13}
              cy={265.8}
              rx={9.07}
              ry={9.03}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={186.13}
              cy={265.82}
              rx={8.41}
              ry={8.37}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={186.13}
              cy={265.85}
              rx={7.75}
              ry={7.71}
            />
            <path
              fill={mainColor + '06'}
              d="M179.05,265.88c0,3.9,3.17,7.05,7.09,7.05s7.09-3.16,7.09-7.05-3.17-7.05-7.09-7.05-7.09,3.16-7.09,7.05Z"
            />
            <path
              fill={mainColor + '06'}
              d="M179.71,265.9c0,3.53,2.88,6.4,6.43,6.4s6.43-2.86,6.43-6.4-2.88-6.4-6.43-6.4-6.43,2.86-6.43,6.4Z"
            />
            <path
              fill={mainColor + '06'}
              d="M180.37,265.93c0,3.17,2.58,5.74,5.76,5.74s5.76-2.57,5.76-5.74-2.58-5.74-5.76-5.74-5.76,2.57-5.76,5.74Z"
            />
            <path
              fill={mainColor + '06'}
              d="M181.03,265.96c0,2.8,2.28,5.08,5.1,5.08s5.1-2.27,5.1-5.08-2.28-5.08-5.1-5.08-5.1,2.27-5.1,5.08Z"
            />
            <path
              fill={mainColor + '06'}
              d="M181.69,265.98c0,2.44,1.99,4.42,4.44,4.42s4.44-1.98,4.44-4.42-1.99-4.42-4.44-4.42-4.44,1.98-4.44,4.42Z"
            />
            <path
              fill={mainColor + '06'}
              d="M182.35,266.01c0,2.08,1.69,3.76,3.78,3.76s3.78-1.68,3.78-3.76-1.69-3.76-3.78-3.76-3.78,1.68-3.78,3.76Z"
            />
            <path
              fill={mainColor + '06'}
              d="M183.01,266.04c0,1.71,1.4,3.1,3.12,3.1s3.12-1.39,3.12-3.1-1.4-3.1-3.12-3.1-3.12,1.39-3.12,3.1Z"
            />
            <path
              fill={mainColor + '06'}
              d="M183.68,266.06c0,1.35,1.1,2.45,2.46,2.45s2.46-1.1,2.46-2.45-1.1-2.45-2.46-2.45-2.46,1.1-2.46,2.45Z"
            />
            <path
              fill={mainColor + '06'}
              d="M184.34,266.09c0,.99.8,1.79,1.8,1.79s1.8-.8,1.8-1.79-.8-1.79-1.8-1.79-1.8.8-1.8,1.79Z"
            />
            <path
              fill={mainColor + '06'}
              d="M185,266.12c0,.62.51,1.13,1.14,1.13s1.13-.51,1.13-1.13-.51-1.13-1.13-1.13-1.14.51-1.14,1.13Z"
            />
          </g>
          <path
            className="cls-649"
            d="M185,266.12c0,.62.51,1.13,1.14,1.13s1.13-.51,1.13-1.13-.51-1.13-1.13-1.13-1.14.51-1.14,1.13Z"
          />
          <g className="cls-117">
            <ellipse
              fill={mainColor + '06'}
              cx={107.32}
              cy={294.23}
              rx={11.72}
              ry={11.66}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={107.32}
              cy={294.26}
              rx={11.06}
              ry={11}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={107.32}
              cy={294.29}
              rx={10.39}
              ry={10.34}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={107.32}
              cy={294.31}
              rx={9.73}
              ry={9.69}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={107.32}
              cy={294.34}
              rx={9.07}
              ry={9.03}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={107.32}
              cy={294.37}
              rx={8.41}
              ry={8.37}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={107.32}
              cy={294.39}
              rx={7.75}
              ry={7.71}
            />
            <path
              fill={mainColor + '06'}
              d="M100.23,294.42c0,3.9,3.17,7.05,7.09,7.05s7.09-3.16,7.09-7.05-3.17-7.05-7.09-7.05-7.09,3.16-7.09,7.05Z"
            />
            <path
              fill={mainColor + '06'}
              d="M100.9,294.45c0,3.53,2.88,6.4,6.43,6.4s6.43-2.86,6.43-6.4-2.88-6.4-6.43-6.4-6.43,2.86-6.43,6.4Z"
            />
            <path
              fill={mainColor + '06'}
              d="M101.56,294.47c0,3.17,2.58,5.74,5.76,5.74s5.76-2.57,5.76-5.74-2.58-5.74-5.76-5.74-5.76,2.57-5.76,5.74Z"
            />
            <path
              fill={mainColor + '06'}
              d="M102.22,294.5c0,2.8,2.28,5.08,5.1,5.08s5.1-2.27,5.1-5.08-2.28-5.08-5.1-5.08-5.1,2.27-5.1,5.08Z"
            />
            <path
              fill={mainColor + '06'}
              d="M102.88,294.53c0,2.44,1.99,4.42,4.44,4.42s4.44-1.98,4.44-4.42-1.99-4.42-4.44-4.42-4.44,1.98-4.44,4.42Z"
            />
            <path
              fill={mainColor + '06'}
              d="M103.54,294.55c0,2.08,1.69,3.76,3.78,3.76s3.78-1.68,3.78-3.76-1.69-3.76-3.78-3.76-3.78,1.68-3.78,3.76Z"
            />
            <path
              fill={mainColor + '06'}
              d="M104.2,294.58c0,1.71,1.4,3.1,3.12,3.1s3.12-1.39,3.12-3.1-1.4-3.1-3.12-3.1-3.12,1.39-3.12,3.1Z"
            />
            <path
              fill={mainColor + '06'}
              d="M104.86,294.61c0,1.35,1.1,2.45,2.46,2.45s2.46-1.1,2.46-2.45-1.1-2.45-2.46-2.45-2.46,1.1-2.46,2.45Z"
            />
            <path
              fill={mainColor + '06'}
              d="M105.53,294.63c0,.99.8,1.79,1.8,1.79s1.8-.8,1.8-1.79-.8-1.79-1.8-1.79-1.8.8-1.8,1.79Z"
            />
            <path
              fill={mainColor + '06'}
              d="M106.19,294.66c0,.62.51,1.13,1.13,1.13s1.13-.51,1.13-1.13-.51-1.13-1.13-1.13-1.13.51-1.13,1.13Z"
            />
          </g>
          <path
            className="cls-649"
            d="M106.19,294.66c0,.62.51,1.13,1.13,1.13s1.13-.51,1.13-1.13-.51-1.13-1.13-1.13-1.13.51-1.13,1.13Z"
          />
          <g className="cls-117">
            <ellipse
              fill={mainColor + '06'}
              cx={54.43}
              cy={235.48}
              rx={11.72}
              ry={11.66}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={54.43}
              cy={235.51}
              rx={11.06}
              ry={11}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={54.43}
              cy={235.54}
              rx={10.39}
              ry={10.34}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={54.43}
              cy={235.56}
              rx={9.73}
              ry={9.69}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={54.43}
              cy={235.59}
              rx={9.07}
              ry={9.03}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={54.43}
              cy={235.62}
              rx={8.41}
              ry={8.37}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={54.43}
              cy={235.64}
              rx={7.75}
              ry={7.71}
            />
            <path
              fill={mainColor + '06'}
              d="M47.34,235.67c0,3.9,3.17,7.05,7.09,7.05s7.09-3.16,7.09-7.05-3.17-7.05-7.09-7.05-7.09,3.16-7.09,7.05Z"
            />
            <path
              fill={mainColor + '06'}
              d="M48.01,235.7c0,3.53,2.88,6.4,6.43,6.4s6.43-2.86,6.43-6.4-2.88-6.4-6.43-6.4-6.43,2.86-6.43,6.4Z"
            />
            <path
              fill={mainColor + '06'}
              d="M48.67,235.72c0,3.17,2.58,5.74,5.76,5.74s5.76-2.57,5.76-5.74-2.58-5.74-5.76-5.74-5.76,2.57-5.76,5.74Z"
            />
            <path
              fill={mainColor + '06'}
              d="M49.33,235.75c0,2.8,2.28,5.08,5.1,5.08s5.1-2.27,5.1-5.08-2.28-5.08-5.1-5.08-5.1,2.27-5.1,5.08Z"
            />
            <path
              fill={mainColor + '06'}
              d="M49.99,235.78c0,2.44,1.99,4.42,4.44,4.42s4.44-1.98,4.44-4.42-1.99-4.42-4.44-4.42-4.44,1.98-4.44,4.42Z"
            />
            <path
              fill={mainColor + '06'}
              d="M50.65,235.8c0,2.08,1.69,3.76,3.78,3.76s3.78-1.68,3.78-3.76-1.69-3.76-3.78-3.76-3.78,1.68-3.78,3.76Z"
            />
            <path
              fill={mainColor + '06'}
              d="M51.31,235.83c0,1.71,1.4,3.1,3.12,3.1s3.12-1.39,3.12-3.1-1.4-3.1-3.12-3.1-3.12,1.39-3.12,3.1Z"
            />
            <path
              fill={mainColor + '06'}
              d="M51.97,235.86c0,1.35,1.1,2.45,2.46,2.45s2.46-1.1,2.46-2.45-1.1-2.45-2.46-2.45-2.46,1.1-2.46,2.45Z"
            />
            <path
              fill={mainColor + '06'}
              d="M52.64,235.88c0,.99.8,1.79,1.8,1.79s1.8-.8,1.8-1.79-.8-1.79-1.8-1.79-1.8.8-1.8,1.79Z"
            />
            <path
              fill={mainColor + '06'}
              d="M53.3,235.91c0,.62.51,1.13,1.14,1.13s1.13-.51,1.13-1.13-.51-1.13-1.13-1.13-1.14.51-1.14,1.13Z"
            />
          </g>
          <path
            className="cls-649"
            d="M53.3,235.91c0,.62.51,1.13,1.14,1.13s1.13-.51,1.13-1.13-.51-1.13-1.13-1.13-1.14.51-1.14,1.13Z"
          />
          <g className="cls-117">
            <ellipse
              fill={mainColor + '06'}
              cx={181.52}
              cy={11.87}
              rx={11.72}
              ry={11.66}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={181.52}
              cy={11.9}
              rx={11.06}
              ry={11}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={181.52}
              cy={11.92}
              rx={10.39}
              ry={10.34}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={181.52}
              cy={11.95}
              rx={9.73}
              ry={9.69}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={181.52}
              cy={11.98}
              rx={9.07}
              ry={9.03}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={181.52}
              cy={12}
              rx={8.41}
              ry={8.37}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={181.52}
              cy={12.03}
              rx={7.75}
              ry={7.71}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={181.52}
              cy={12.06}
              rx={7.09}
              ry={7.05}
            />
            <path
              fill={mainColor + '06'}
              d="M175.1,12.08c0,3.53,2.88,6.4,6.43,6.4s6.43-2.86,6.43-6.4-2.88-6.4-6.43-6.4-6.43,2.86-6.43,6.4Z"
            />
            <path
              fill={mainColor + '06'}
              d="M175.76,12.11c0,3.17,2.58,5.74,5.76,5.74s5.76-2.57,5.76-5.74-2.58-5.74-5.76-5.74-5.76,2.57-5.76,5.74Z"
            />
            <path
              fill={mainColor + '06'}
              d="M176.42,12.14c0,2.8,2.28,5.08,5.1,5.08s5.1-2.27,5.1-5.08-2.28-5.08-5.1-5.08-5.1,2.27-5.1,5.08Z"
            />
            <path
              fill={mainColor + '06'}
              d="M177.08,12.16c0,2.44,1.99,4.42,4.44,4.42s4.44-1.98,4.44-4.42-1.99-4.42-4.44-4.42-4.44,1.98-4.44,4.42Z"
            />
            <path
              fill={mainColor + '06'}
              d="M177.74,12.19c0,2.08,1.69,3.76,3.78,3.76s3.78-1.68,3.78-3.76-1.69-3.76-3.78-3.76-3.78,1.68-3.78,3.76Z"
            />
            <path
              fill={mainColor + '06'}
              d="M178.4,12.22c0,1.71,1.4,3.1,3.12,3.1s3.12-1.39,3.12-3.1-1.4-3.1-3.12-3.1-3.12,1.39-3.12,3.1Z"
            />
            <path
              fill={mainColor + '06'}
              d="M179.07,12.24c0,1.35,1.1,2.45,2.46,2.45s2.46-1.1,2.46-2.45-1.1-2.45-2.46-2.45-2.46,1.1-2.46,2.45Z"
            />
            <path
              fill={mainColor + '06'}
              d="M179.73,12.27c0,.99.8,1.79,1.8,1.79s1.8-.8,1.8-1.79-.8-1.79-1.8-1.79-1.8.8-1.8,1.79Z"
            />
            <path
              fill={mainColor + '06'}
              d="M180.39,12.3c0,.62.51,1.13,1.13,1.13s1.13-.51,1.13-1.13-.51-1.13-1.13-1.13-1.13.51-1.13,1.13Z"
            />
          </g>
          <path
            className="cls-649"
            d="M180.39,12.3c0,.62.51,1.13,1.13,1.13s1.13-.51,1.13-1.13-.51-1.13-1.13-1.13-1.13.51-1.13,1.13Z"
          />
          <g className="cls-117">
            <ellipse
              fill={mainColor + '06'}
              cx={166.24}
              cy={242.07}
              rx={11.72}
              ry={11.66}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={166.24}
              cy={242.1}
              rx={11.06}
              ry={11}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={166.24}
              cy={242.12}
              rx={10.39}
              ry={10.34}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={166.24}
              cy={242.15}
              rx={9.73}
              ry={9.69}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={166.24}
              cy={242.18}
              rx={9.07}
              ry={9.03}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={166.24}
              cy={242.2}
              rx={8.41}
              ry={8.37}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={166.24}
              cy={242.23}
              rx={7.75}
              ry={7.71}
            />
            <path
              fill={mainColor + '06'}
              d="M173.33,242.26c0,3.9-3.17,7.05-7.09,7.05s-7.09-3.16-7.09-7.05,3.17-7.05,7.09-7.05,7.09,3.16,7.09,7.05Z"
            />
            <path
              fill={mainColor + '06'}
              d="M172.67,242.28c0,3.53-2.88,6.4-6.43,6.4s-6.43-2.86-6.43-6.4,2.88-6.4,6.43-6.4,6.43,2.86,6.43,6.4Z"
            />
            <path
              fill={mainColor + '06'}
              d="M172.01,242.31c0,3.17-2.58,5.74-5.76,5.74s-5.76-2.57-5.76-5.74,2.58-5.74,5.76-5.74,5.76,2.57,5.76,5.74Z"
            />
            <path
              fill={mainColor + '06'}
              d="M171.35,242.34c0,2.8-2.28,5.08-5.1,5.08s-5.1-2.27-5.1-5.08,2.28-5.08,5.1-5.08,5.1,2.27,5.1,5.08Z"
            />
            <path
              fill={mainColor + '06'}
              d="M170.68,242.37c0,2.44-1.99,4.42-4.44,4.42s-4.44-1.98-4.44-4.42,1.99-4.42,4.44-4.42,4.44,1.98,4.44,4.42Z"
            />
            <path
              fill={mainColor + '06'}
              d="M170.02,242.39c0,2.08-1.69,3.76-3.78,3.76s-3.78-1.68-3.78-3.76,1.69-3.76,3.78-3.76,3.78,1.68,3.78,3.76Z"
            />
            <path
              fill={mainColor + '06'}
              d="M169.36,242.42c0,1.71-1.4,3.1-3.12,3.1s-3.12-1.39-3.12-3.1,1.4-3.1,3.12-3.1,3.12,1.39,3.12,3.1Z"
            />
            <path
              fill={mainColor + '06'}
              d="M168.7,242.45c0,1.35-1.1,2.45-2.46,2.45s-2.46-1.1-2.46-2.45,1.1-2.45,2.46-2.45,2.46,1.1,2.46,2.45Z"
            />
            <path
              fill={mainColor + '06'}
              d="M168.04,242.47c0,.99-.8,1.79-1.8,1.79s-1.8-.8-1.8-1.79.8-1.79,1.8-1.79,1.8.8,1.8,1.79Z"
            />
            <path
              fill={mainColor + '06'}
              d="M167.38,242.5c0,.62-.51,1.13-1.14,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.14.51,1.14,1.13Z"
            />
          </g>
          <path
            className="cls-649"
            d="M167.38,242.5c0,.62-.51,1.13-1.14,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.14.51,1.14,1.13Z"
          />
          <g className="cls-117">
            <ellipse
              fill={mainColor + '06'}
              cx={256.25}
              cy={225.38}
              rx={11.72}
              ry={11.66}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={256.25}
              cy={225.41}
              rx={11.06}
              ry={11}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={256.25}
              cy={225.43}
              rx={10.39}
              ry={10.34}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={256.25}
              cy={225.46}
              rx={9.73}
              ry={9.69}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={256.25}
              cy={225.49}
              rx={9.07}
              ry={9.03}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={256.25}
              cy={225.51}
              rx={8.41}
              ry={8.37}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={256.25}
              cy={225.54}
              rx={7.75}
              ry={7.71}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={256.25}
              cy={225.57}
              rx={7.09}
              ry={7.05}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={256.25}
              cy={225.59}
              rx={6.43}
              ry={6.4}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={256.25}
              cy={225.62}
              rx={5.76}
              ry={5.74}
            />
            <path
              fill={mainColor + '06'}
              d="M261.35,225.65c0,2.8-2.28,5.08-5.1,5.08s-5.1-2.27-5.1-5.08,2.28-5.08,5.1-5.08,5.1,2.27,5.1,5.08Z"
            />
            <path
              fill={mainColor + '06'}
              d="M260.69,225.67c0,2.44-1.99,4.42-4.44,4.42s-4.44-1.98-4.44-4.42,1.99-4.42,4.44-4.42,4.44,1.98,4.44,4.42Z"
            />
            <path
              fill={mainColor + '06'}
              d="M260.03,225.7c0,2.08-1.69,3.76-3.78,3.76s-3.78-1.68-3.78-3.76,1.69-3.76,3.78-3.76,3.78,1.68,3.78,3.76Z"
            />
            <path
              fill={mainColor + '06'}
              d="M259.37,225.73c0,1.71-1.4,3.1-3.12,3.1s-3.12-1.39-3.12-3.1,1.4-3.1,3.12-3.1,3.12,1.39,3.12,3.1Z"
            />
            <path
              fill={mainColor + '06'}
              d="M258.71,225.75c0,1.35-1.1,2.45-2.46,2.45s-2.46-1.1-2.46-2.45,1.1-2.45,2.46-2.45,2.46,1.1,2.46,2.45Z"
            />
            <path
              fill={mainColor + '06'}
              d="M258.05,225.78c0,.99-.8,1.79-1.8,1.79s-1.8-.8-1.8-1.79.8-1.79,1.8-1.79,1.8.8,1.8,1.79Z"
            />
            <path
              fill={mainColor + '06'}
              d="M257.38,225.81c0,.62-.51,1.13-1.14,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.14.51,1.14,1.13Z"
            />
          </g>
          <path
            className="cls-649"
            d="M257.38,225.81c0,.62-.51,1.13-1.14,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.14.51,1.14,1.13Z"
          />
          <g className="cls-117">
            <ellipse
              fill={mainColor + '06'}
              cx={76.06}
              cy={225.38}
              rx={11.72}
              ry={11.66}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={76.06}
              cy={225.41}
              rx={11.06}
              ry={11}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={76.06}
              cy={225.43}
              rx={10.39}
              ry={10.34}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={76.06}
              cy={225.46}
              rx={9.73}
              ry={9.69}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={76.06}
              cy={225.49}
              rx={9.07}
              ry={9.03}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={76.06}
              cy={225.51}
              rx={8.41}
              ry={8.37}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={76.06}
              cy={225.54}
              rx={7.75}
              ry={7.71}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={76.06}
              cy={225.57}
              rx={7.09}
              ry={7.05}
            />
            <path
              fill={mainColor + '06'}
              d="M82.49,225.59c0,3.53-2.88,6.4-6.43,6.4s-6.43-2.86-6.43-6.4,2.88-6.4,6.43-6.4,6.43,2.86,6.43,6.4Z"
            />
            <path
              fill={mainColor + '06'}
              d="M81.83,225.62c0,3.17-2.58,5.74-5.76,5.74s-5.76-2.57-5.76-5.74,2.58-5.74,5.76-5.74,5.76,2.57,5.76,5.74Z"
            />
            <path
              fill={mainColor + '06'}
              d="M81.16,225.65c0,2.8-2.28,5.08-5.1,5.08s-5.1-2.27-5.1-5.08,2.28-5.08,5.1-5.08,5.1,2.27,5.1,5.08Z"
            />
            <path
              fill={mainColor + '06'}
              d="M80.5,225.67c0,2.44-1.99,4.42-4.44,4.42s-4.44-1.98-4.44-4.42,1.99-4.42,4.44-4.42,4.44,1.98,4.44,4.42Z"
            />
            <path
              fill={mainColor + '06'}
              d="M79.84,225.7c0,2.08-1.69,3.76-3.78,3.76s-3.78-1.68-3.78-3.76,1.69-3.76,3.78-3.76,3.78,1.68,3.78,3.76Z"
            />
            <path
              fill={mainColor + '06'}
              d="M79.18,225.73c0,1.71-1.4,3.1-3.12,3.1s-3.12-1.39-3.12-3.1,1.4-3.1,3.12-3.1,3.12,1.39,3.12,3.1Z"
            />
            <path
              fill={mainColor + '06'}
              d="M78.52,225.75c0,1.35-1.1,2.45-2.46,2.45s-2.46-1.1-2.46-2.45,1.1-2.45,2.46-2.45,2.46,1.1,2.46,2.45Z"
            />
            <path
              fill={mainColor + '06'}
              d="M77.86,225.78c0,.99-.8,1.79-1.8,1.79s-1.8-.8-1.8-1.79.8-1.79,1.8-1.79,1.8.8,1.8,1.79Z"
            />
            <path
              fill={mainColor + '06'}
              d="M77.2,225.81c0,.62-.51,1.13-1.14,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.14.51,1.14,1.13Z"
            />
          </g>
          <path
            className="cls-649"
            d="M77.2,225.81c0,.62-.51,1.13-1.14,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.14.51,1.14,1.13Z"
          />
          <g className="cls-117">
            <ellipse
              fill={mainColor + '06'}
              cx={320.76}
              cy={171.51}
              rx={11.72}
              ry={11.66}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={320.76}
              cy={171.53}
              rx={11.06}
              ry={11}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={320.76}
              cy={171.56}
              rx={10.39}
              ry={10.34}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={320.76}
              cy={171.59}
              rx={9.73}
              ry={9.69}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={320.76}
              cy={171.61}
              rx={9.07}
              ry={9.03}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={320.76}
              cy={171.64}
              rx={8.41}
              ry={8.37}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={320.76}
              cy={171.67}
              rx={7.75}
              ry={7.71}
            />
            <path
              fill={mainColor + '06'}
              d="M327.85,171.69c0,3.9-3.17,7.05-7.09,7.05s-7.09-3.16-7.09-7.05,3.17-7.05,7.09-7.05,7.09,3.16,7.09,7.05Z"
            />
            <path
              fill={mainColor + '06'}
              d="M327.19,171.72c0,3.53-2.88,6.4-6.43,6.4s-6.43-2.86-6.43-6.4,2.88-6.4,6.43-6.4,6.43,2.86,6.43,6.4Z"
            />
            <path
              fill={mainColor + '06'}
              d="M326.53,171.75c0,3.17-2.58,5.74-5.76,5.74s-5.76-2.57-5.76-5.74,2.58-5.74,5.76-5.74,5.76,2.57,5.76,5.74Z"
            />
            <path
              fill={mainColor + '06'}
              d="M325.87,171.78c0,2.8-2.28,5.08-5.1,5.08s-5.1-2.27-5.1-5.08,2.28-5.08,5.1-5.08,5.1,2.27,5.1,5.08Z"
            />
            <path
              fill={mainColor + '06'}
              d="M325.2,171.8c0,2.44-1.99,4.42-4.44,4.42s-4.44-1.98-4.44-4.42,1.99-4.42,4.44-4.42,4.44,1.98,4.44,4.42Z"
            />
            <path
              fill={mainColor + '06'}
              d="M324.54,171.83c0,2.08-1.69,3.76-3.78,3.76s-3.78-1.68-3.78-3.76,1.69-3.76,3.78-3.76,3.78,1.68,3.78,3.76Z"
            />
            <path
              fill={mainColor + '06'}
              d="M323.88,171.86c0,1.71-1.4,3.1-3.12,3.1s-3.12-1.39-3.12-3.1,1.4-3.1,3.12-3.1,3.12,1.39,3.12,3.1Z"
            />
            <path
              fill={mainColor + '06'}
              d="M323.22,171.88c0,1.35-1.1,2.45-2.46,2.45s-2.46-1.1-2.46-2.45,1.1-2.45,2.46-2.45,2.46,1.1,2.46,2.45Z"
            />
            <path
              fill={mainColor + '06'}
              d="M322.56,171.91c0,.99-.8,1.79-1.8,1.79s-1.8-.8-1.8-1.79.8-1.79,1.8-1.79,1.8.8,1.8,1.79Z"
            />
            <path
              fill={mainColor + '06'}
              d="M321.9,171.94c0,.62-.51,1.13-1.14,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.14.51,1.14,1.13Z"
            />
          </g>
          <path
            className="cls-649"
            d="M321.9,171.94c0,.62-.51,1.13-1.14,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.14.51,1.14,1.13Z"
          />
          <g className="cls-117">
            <ellipse
              fill={mainColor + '06'}
              cx={11.72}
              cy={171.51}
              rx={11.72}
              ry={11.66}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={11.72}
              cy={171.53}
              rx={11.06}
              ry={11}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={11.72}
              cy={171.56}
              rx={10.39}
              ry={10.34}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={11.72}
              cy={171.59}
              rx={9.73}
              ry={9.69}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={11.72}
              cy={171.61}
              rx={9.07}
              ry={9.03}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={11.72}
              cy={171.64}
              rx={8.41}
              ry={8.37}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={11.72}
              cy={171.67}
              rx={7.75}
              ry={7.71}
            />
            <path
              fill={mainColor + '06'}
              d="M18.81,171.69c0,3.9-3.17,7.05-7.09,7.05s-7.09-3.16-7.09-7.05,3.17-7.05,7.09-7.05,7.09,3.16,7.09,7.05Z"
            />
            <path
              fill={mainColor + '06'}
              d="M18.14,171.72c0,3.53-2.88,6.4-6.43,6.4s-6.43-2.86-6.43-6.4,2.88-6.4,6.43-6.4,6.43,2.86,6.43,6.4Z"
            />
            <path
              fill={mainColor + '06'}
              d="M17.48,171.75c0,3.17-2.58,5.74-5.76,5.74s-5.76-2.57-5.76-5.74,2.58-5.74,5.76-5.74,5.76,2.57,5.76,5.74Z"
            />
            <path
              fill={mainColor + '06'}
              d="M16.82,171.78c0,2.8-2.28,5.08-5.1,5.08s-5.1-2.27-5.1-5.08,2.28-5.08,5.1-5.08,5.1,2.27,5.1,5.08Z"
            />
            <path
              fill={mainColor + '06'}
              d="M16.16,171.8c0,2.44-1.99,4.42-4.44,4.42s-4.44-1.98-4.44-4.42,1.99-4.42,4.44-4.42,4.44,1.98,4.44,4.42Z"
            />
            <path
              fill={mainColor + '06'}
              d="M15.5,171.83c0,2.08-1.69,3.76-3.78,3.76s-3.78-1.68-3.78-3.76,1.69-3.76,3.78-3.76,3.78,1.68,3.78,3.76Z"
            />
            <path
              fill={mainColor + '06'}
              d="M14.84,171.86c0,1.71-1.4,3.1-3.12,3.1s-3.12-1.39-3.12-3.1,1.4-3.1,3.12-3.1,3.12,1.39,3.12,3.1Z"
            />
            <path
              fill={mainColor + '06'}
              d="M14.18,171.88c0,1.35-1.1,2.45-2.46,2.45s-2.46-1.1-2.46-2.45,1.1-2.45,2.46-2.45,2.46,1.1,2.46,2.45Z"
            />
            <path
              fill={mainColor + '06'}
              d="M13.51,171.91c0,.99-.8,1.79-1.8,1.79s-1.8-.8-1.8-1.79.8-1.79,1.8-1.79,1.8.8,1.8,1.79Z"
            />
            <path
              fill={mainColor + '06'}
              d="M12.85,171.94c0,.62-.51,1.13-1.14,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.14.51,1.14,1.13Z"
            />
          </g>
          <path
            className="cls-649"
            d="M12.85,171.94c0,.62-.51,1.13-1.14,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.14.51,1.14,1.13Z"
          />
          <g className="cls-117">
            <ellipse
              fill={mainColor + '06'}
              cx={306.84}
              cy={106.9}
              rx={11.72}
              ry={11.66}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={306.84}
              cy={106.93}
              rx={11.06}
              ry={11}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={306.84}
              cy={106.95}
              rx={10.39}
              ry={10.34}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={306.84}
              cy={106.98}
              rx={9.73}
              ry={9.69}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={306.84}
              cy={107.01}
              rx={9.07}
              ry={9.03}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={306.84}
              cy={107.03}
              rx={8.41}
              ry={8.37}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={306.84}
              cy={107.06}
              rx={7.75}
              ry={7.71}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={306.84}
              cy={107.09}
              rx={7.09}
              ry={7.05}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={306.84}
              cy={107.11}
              rx={6.43}
              ry={6.4}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={306.84}
              cy={107.14}
              rx={5.76}
              ry={5.74}
            />
            <path
              fill={mainColor + '06'}
              d="M311.94,107.17c0,2.8-2.28,5.08-5.1,5.08s-5.1-2.27-5.1-5.08,2.28-5.08,5.1-5.08,5.1,2.27,5.1,5.08Z"
            />
            <path
              fill={mainColor + '06'}
              d="M311.28,107.19c0,2.44-1.99,4.42-4.44,4.42s-4.44-1.98-4.44-4.42,1.99-4.42,4.44-4.42,4.44,1.98,4.44,4.42Z"
            />
            <path
              fill={mainColor + '06'}
              d="M310.62,107.22c0,2.08-1.69,3.76-3.78,3.76s-3.78-1.68-3.78-3.76,1.69-3.76,3.78-3.76,3.78,1.68,3.78,3.76Z"
            />
            <path
              fill={mainColor + '06'}
              d="M309.96,107.25c0,1.71-1.4,3.1-3.12,3.1s-3.12-1.39-3.12-3.1,1.4-3.1,3.12-3.1,3.12,1.39,3.12,3.1Z"
            />
            <path
              fill={mainColor + '06'}
              d="M309.3,107.27c0,1.35-1.1,2.45-2.46,2.45s-2.46-1.1-2.46-2.45,1.1-2.45,2.46-2.45,2.46,1.1,2.46,2.45Z"
            />
            <path
              fill={mainColor + '06'}
              d="M308.64,107.3c0,.99-.8,1.79-1.8,1.79s-1.8-.8-1.8-1.79.8-1.79,1.8-1.79,1.8.8,1.8,1.79Z"
            />
            <path
              fill={mainColor + '06'}
              d="M307.97,107.33c0,.62-.51,1.13-1.14,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.14.51,1.14,1.13Z"
            />
          </g>
          <path
            className="cls-649"
            d="M307.97,107.33c0,.62-.51,1.13-1.14,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.14.51,1.14,1.13Z"
          />
          <g className="cls-117">
            <ellipse
              fill={mainColor + '06'}
              cx={25.3}
              cy={106.9}
              rx={11.72}
              ry={11.66}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={25.3}
              cy={106.93}
              rx={11.06}
              ry={11}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={25.3}
              cy={106.95}
              rx={10.39}
              ry={10.34}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={25.3}
              cy={106.98}
              rx={9.73}
              ry={9.69}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={25.3}
              cy={107.01}
              rx={9.07}
              ry={9.03}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={25.3}
              cy={107.03}
              rx={8.41}
              ry={8.37}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={25.3}
              cy={107.06}
              rx={7.75}
              ry={7.71}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={25.3}
              cy={107.09}
              rx={7.09}
              ry={7.05}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={25.3}
              cy={107.11}
              rx={6.43}
              ry={6.4}
            />
            <ellipse
              fill={mainColor + '06'}
              cx={25.3}
              cy={107.14}
              rx={5.76}
              ry={5.74}
            />
            <path
              fill={mainColor + '06'}
              d="M30.4,107.17c0,2.8-2.28,5.08-5.1,5.08s-5.1-2.27-5.1-5.08,2.28-5.08,5.1-5.08,5.1,2.27,5.1,5.08Z"
            />
            <path
              fill={mainColor + '06'}
              d="M29.74,107.19c0,2.44-1.99,4.42-4.44,4.42s-4.44-1.98-4.44-4.42,1.99-4.42,4.44-4.42,4.44,1.98,4.44,4.42Z"
            />
            <path
              fill={mainColor + '06'}
              d="M29.08,107.22c0,2.08-1.69,3.76-3.78,3.76s-3.78-1.68-3.78-3.76,1.69-3.76,3.78-3.76,3.78,1.68,3.78,3.76Z"
            />
            <path
              fill={mainColor + '06'}
              d="M28.42,107.25c0,1.71-1.4,3.1-3.12,3.1s-3.12-1.39-3.12-3.1,1.4-3.1,3.12-3.1,3.12,1.39,3.12,3.1Z"
            />
            <path
              fill={mainColor + '06'}
              d="M27.76,107.27c0,1.35-1.1,2.45-2.46,2.45s-2.46-1.1-2.46-2.45,1.1-2.45,2.46-2.45,2.46,1.1,2.46,2.45Z"
            />
            <path
              fill={mainColor + '06'}
              d="M27.1,107.3c0,.99-.8,1.79-1.8,1.79s-1.8-.8-1.8-1.79.8-1.79,1.8-1.79,1.8.8,1.8,1.79Z"
            />
            <path
              fill={mainColor + '06'}
              d="M26.44,107.33c0,.62-.51,1.13-1.13,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.13.51,1.13,1.13Z"
            />
          </g>
          <path
            className="cls-649"
            d="M26.44,107.33c0,.62-.51,1.13-1.13,1.13s-1.13-.51-1.13-1.13.51-1.13,1.13-1.13,1.13.51,1.13,1.13Z"
          />
        </g>
      </g>
    </g>
  </svg>
);
export default BlueLink;
